// tslint:disable
import { Injectable } from '@angular/core';

import { DwQuery, DwQueryBuilderGen, DwItem2, DwItemAttributeCollection, DwItemAttribute, DwItemRelationshipCollection, DwItemRelationship, DwItemDetail2, DwOrmData } from '@devwareapps/devware-cap';
import * as EnterpriseMetaData from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/************************************************
   Generated with the Devware CAP CLI 4.4.49
   Code Gen Name   App
   API Url         https://pilexos-feature-api.azurewebsites.net

   Generated By    DEVWARE/Anthony.Monsees
   Generate On     9/18/2026 1:37:27 PM
************************************************/

export enum AppMetaDataItemNames {
    AcsAreaOfOperation = 'AcsAreaOfOperation',
    AcsAreaOfOperationTask = 'AcsAreaOfOperationTask',
    AcsCode = 'AcsCode',
    AcsCodeLookupRequest = 'AcsCodeLookupRequest',
    AcsCodeSelectionMode = 'AcsCodeSelectionMode',
    AcsCodeType = 'AcsCodeType',
    AcsTest = 'AcsTest',
    AcsTestCheckRideType = 'AcsTestCheckRideType',
    AcsTestPortion = 'AcsTestPortion',
    AcsTestStatus = 'AcsTestStatus',
    Address = 'Address',
    Airport = 'Airport',
    ApplicantAcsWrittenResult = 'ApplicantAcsWrittenResult',
    ApplicantAcsWrittenResultMissedCode = 'ApplicantAcsWrittenResultMissedCode',
    ApplicantAcsWrittenResultType = 'ApplicantAcsWrittenResultType',
    ApplicantPlaceholder = 'ApplicantPlaceholder',
    ApplicantPlaceholderStatus = 'ApplicantPlaceholderStatus',
    AviationAuthority = 'AviationAuthority',
    AviationAuthorityDistrictOffice = 'AviationAuthorityDistrictOffice',
    AviationTrainingProgram = 'AviationTrainingProgram',
    AvionicType = 'AvionicType',
    CalendarEventReference = 'CalendarEventReference',
    CalendarOwnerType = 'CalendarOwnerType',
    CalendarReference = 'CalendarReference',
    CalendarReferenceLog = 'CalendarReferenceLog',
    CalendarReferenceType = 'CalendarReferenceType',
    CalendarSyncRequest = 'CalendarSyncRequest',
    CalendarSyncRequestActionType = 'CalendarSyncRequestActionType',
    CalendarSyncRequestErrorType = 'CalendarSyncRequestErrorType',
    CalendarSyncRequestSourceSubType = 'CalendarSyncRequestSourceSubType',
    CalendarSyncRequestSourceType = 'CalendarSyncRequestSourceType',
    CalendarSyncRequestStatus = 'CalendarSyncRequestStatus',
    CheckRideAISummary = 'CheckRideAISummary',
    CheckRideAISummaryStatus = 'CheckRideAISummaryStatus',
    CheckRideApplicantType = 'CheckRideApplicantType',
    CheckRideAvionicType = 'CheckRideAvionicType',
    CheckRideCancellationType = 'CheckRideCancellationType',
    CheckRideExaminerType = 'CheckRideExaminerType',
    CheckRideGroup = 'CheckRideGroup',
    CheckRideInstructorType = 'CheckRideInstructorType',
    CheckRideOutcome = 'CheckRideOutcome',
    CheckRideOwnershipType = 'CheckRideOwnershipType',
    CheckRidePayment = 'CheckRidePayment',
    CheckRideRequest = 'CheckRideRequest',
    CheckRideRequestNote = 'CheckRideRequestNote',
    CheckRideRequestPaymentParty = 'CheckRideRequestPaymentParty',
    CheckRideRequestPilotCertificate = 'CheckRideRequestPilotCertificate',
    CheckRideRequestStatus = 'CheckRideRequestStatus',
    CheckRideRequestSubStatus = 'CheckRideRequestSubStatus',
    CheckRideResult = 'CheckRideResult',
    CheckRideScenario = 'CheckRideScenario',
    CheckRideScenarioTypeMap = 'CheckRideScenarioTypeMap',
    CheckRideScheduleHold = 'CheckRideScheduleHold',
    CheckRideStatusLevel = 'CheckRideStatusLevel',
    CheckRideTestAttemptClassification = 'CheckRideTestAttemptClassification',
    CheckRideTestType = 'CheckRideTestType',
    CheckRideType = 'CheckRideType',
    CheckRideWorkflow = 'CheckRideWorkflow',
    Country = 'Country',
    Duration = 'Duration',
    DwAiFunction = 'dw_AiFunction',
    DwAiPromptRequest = 'dw_AiPromptRequest',
    DwMediaGroup = 'dw_MediaGroup',
    DwProcessDefinition = 'dw_ProcessDefinition',
    DwRole = 'dw_Role',
    DwRoMedia = 'dw_roMedia',
    DwUser = 'dw_User',
    DwUserInviteRequest = 'dw_UserInviteRequest',
    DwUserInviteRequestEmail = 'dw_UserInviteRequestEmail',
    DwUserInviteRequestStatus = 'dw_UserInviteRequestStatus',
    DwUserInviteRequestType = 'dw_UserInviteRequestType',
    DwUserType = 'dw_UserType',
    ElectronicFlightBagType = 'ElectronicFlightBagType',
    FlightSchool = 'FlightSchool',
    FlightSchoolApplicant = 'FlightSchoolApplicant',
    FlightSchoolApplicantBranch = 'FlightSchoolApplicantBranch',
    FlightSchoolApplicantStatus = 'FlightSchoolApplicantStatus',
    FlightSchoolBranch = 'FlightSchoolBranch',
    FlightSchoolExaminer = 'FlightSchoolExaminer',
    FlightSchoolExaminerStatus = 'FlightSchoolExaminerStatus',
    FlightSchoolExaminerType = 'FlightSchoolExaminerType',
    FlightSchoolInstructor = 'FlightSchoolInstructor',
    FlightSchoolInstructorApplicant = 'FlightSchoolInstructorApplicant',
    FlightSchoolInstructorStatus = 'FlightSchoolInstructorStatus',
    FlightSchoolInstructorType = 'FlightSchoolInstructorType',
    FlightSchoolOrganization = 'FlightSchoolOrganization',
    FlightSchoolOrganizationFeature = 'FlightSchoolOrganizationFeature',
    FlightSchoolReferenceStatus = 'FlightSchoolReferenceStatus',
    FlightSchoolSetupRequest = 'FlightSchoolSetupRequest',
    FlightSchoolSetupRequestStatus = 'FlightSchoolSetupRequestStatus',
    FlightSchoolStatus = 'FlightSchoolStatus',
    FlightSchoolTrainingProgram = 'FlightSchoolTrainingProgram',
    FlightSchoolType = 'FlightSchoolType',
    FlightSchoolUser = 'FlightSchoolUser',
    FlightSchoolUserBranch = 'FlightSchoolUserBranch',
    PaymentAttempt = 'PaymentAttempt',
    PaymentCard = 'PaymentCard',
    PaymentCardStatus = 'PaymentCardStatus',
    PaymentCustomerReference = 'PaymentCustomerReference',
    PaymentDiscountCode = 'PaymentDiscountCode',
    PaymentMethod = 'PaymentMethod',
    PaymentProvider = 'PaymentProvider',
    PaymentReference = 'PaymentReference',
    PaymentReferenceCardType = 'PaymentReferenceCardType',
    PaymentReferenceStatus = 'PaymentReferenceStatus',
    PaymentType = 'PaymentType',
    PilotCertificateType = 'PilotCertificateType',
    PilotExaminer = 'PilotExaminer',
    PilotExaminerFlightSchoolSetup = 'PilotExaminerFlightSchoolSetup',
    PilotExaminerLocation = 'PilotExaminerLocation',
    PilotExaminerLocationAirport = 'PilotExaminerLocationAirport',
    PilotExaminerLocationState = 'PilotExaminerLocationState',
    PilotExaminerLocationType = 'PilotExaminerLocationType',
    PilotExaminerStatus = 'PilotExaminerStatus',
    PilotExaminerType = 'PilotExaminerType',
    PlanOfAction = 'PlanOfAction',
    PlanOfActionQuestionResult = 'PlanOfActionQuestionResult',
    PlanOfActionRequiredAcsCode = 'PlanOfActionRequiredAcsCode',
    PlanOfActionResult = 'PlanOfActionResult',
    PlanOfActionSection = 'PlanOfActionSection',
    PlanOfActionSectionQuestion = 'PlanOfActionSectionQuestion',
    PlanOfActionSectionType = 'PlanOfActionSectionType',
    PlanOfActionStatus = 'PlanOfActionStatus',
    PlanOfActionStatusType = 'PlanOfActionStatusType',
    PostalCode = 'PostalCode',
    QuestionBank = 'QuestionBank',
    QuestionBankStatus = 'QuestionBankStatus',
    QuestionOutcome = 'QuestionOutcome',
    ReferenceStatus = 'ReferenceStatus',
    ReportDashboard = 'ReportDashboard',
    ReportDashboardGroup = 'ReportDashboardGroup',
    ReportDashboardWidget = 'ReportDashboardWidget',
    ReportDataSource = 'ReportDataSource',
    ReportDataSourceColumn = 'ReportDataSourceColumn',
    ReportFilterPreference = 'ReportFilterPreference',
    ReportFilterPreset = 'ReportFilterPreset',
    ReportFilterPresetOwnershipType = 'ReportFilterPresetOwnershipType',
    RoAcsCodeDimension = 'roAcsCodeDimension',
    RoAcsWrittenSource = 'roAcsWrittenSource',
    RoAirportDistances = 'roAirportDistances',
    RoAssessmentAcsFactBase = 'roAssessmentAcsFactBase',
    RoAssessmentAcsMissedCodeFact = 'roAssessmentAcsMissedCodeFact',
    RoAssessmentFactBase = 'roAssessmentFactBase',
    RoCalendarSyncRequestDisplay = 'roCalendarSyncRequestDisplay',
    RoCheckrideAcsFactBase = 'roCheckrideAcsFactBase',
    RoCheckrideAggregateUtil = 'roCheckrideAggregateUtil',
    RoCheckrideApplicantFinalName = 'roCheckrideApplicantFinalName',
    RoCheckrideFactBase = 'roCheckrideFactBase',
    RoCheckRidePaymentAggregate = 'roCheckRidePaymentAggregate',
    RoCheckRideRequestApplicant = 'roCheckRideRequestApplicant',
    RoCheckrideRequestScheduleDateInfo = 'roCheckrideRequestScheduleDateInfo',
    RoFlightSchoolExaminer = 'roFlightSchoolExaminer',
    RoFlightSchoolExaminerSearch = 'roFlightSchoolExaminerSearch',
    RoPilotExaminerLocationCurrent = 'roPilotExaminerLocationCurrent',
    RoPilotExaminerLocationDistances = 'roPilotExaminerLocationDistances',
    RoPilotExaminerScenario = 'roPilotExaminerScenario',
    RoPlanOfActionAcsFactBase = 'roPlanOfActionAcsFactBase',
    RoPlanOfActionDetails = 'roPlanOfActionDetails',
    RoPlanOfActionFactBase = 'roPlanOfActionFactBase',
    RoScheduleBlockSchoolExaminerFinal = 'roScheduleBlockSchoolExaminerFinal',
    RoSchoolExaminers = 'roSchoolExaminers',
    RoUnitMemberDpeSupplementSummary = 'roUnitMemberDpeSupplementSummary',
    Schedule = 'Schedule',
    ScheduleBlock = 'ScheduleBlock',
    ScheduleBlockAirport = 'ScheduleBlockAirport',
    ScheduleBlockCheckRideType = 'ScheduleBlockCheckRideType',
    ScheduleBlockItem = 'ScheduleBlockItem',
    ScheduleBlockItemCalendarItem = 'ScheduleBlockItemCalendarItem',
    ScheduleBlockItemStatus = 'ScheduleBlockItemStatus',
    ScheduleBlockItemType = 'ScheduleBlockItemType',
    ScheduleBlockLocation = 'ScheduleBlockLocation',
    ScheduleBlockSchoolBookingOption = 'ScheduleBlockSchoolBookingOption',
    ScheduleBlockStatus = 'ScheduleBlockStatus',
    ScheduleDayOfWeek = 'ScheduleDayOfWeek',
    ScheduleDetail = 'ScheduleDetail',
    SchoolFeature = 'SchoolFeature',
    StateProvince = 'StateProvince',
    StudentApplicant = 'StudentApplicant',
    Subscription = 'Subscription',
    SubscriptionFeature = 'SubscriptionFeature',
    SubscriptionParty = 'SubscriptionParty',
    SubscriptionStatus = 'SubscriptionStatus',
    SubscriptionTier = 'SubscriptionTier',
    SubscriptionTierFeature = 'SubscriptionTierFeature',
    SubscriptionTierStatus = 'SubscriptionTierStatus',
    TimeZone = 'TimeZone',
    TrainingRecord = 'TrainingRecord',
    TrainingRecordStatus = 'TrainingRecordStatus',
    TrainingType = 'TrainingType',
    UnitMemberAircraftCategoryClass = 'UnitMemberAircraftCategoryClass',
    UnitMemberAircraftExperience = 'UnitMemberAircraftExperience',
    UnitMemberAircraftExperienceType = 'UnitMemberAircraftExperienceType',
    UnitMemberCertificate = 'UnitMemberCertificate',
    UnitMemberEmployment = 'UnitMemberEmployment',
    UnitMemberFlightExperience = 'UnitMemberFlightExperience',
    UnitMemberProfile = 'UnitMemberProfile',
    UnitMemberQualificationOption = 'UnitMemberQualificationOption',
    UnitMemberQualificationResponse = 'UnitMemberQualificationResponse',
    UnitMemberQualificationResponseType = 'UnitMemberQualificationResponseType',
    UnitMemberQualificationType = 'UnitMemberQualificationType',
    UserInviteRequestDetail = 'UserInviteRequestDetail',
    UserInviteRequestSchoolBranch = 'UserInviteRequestSchoolBranch',
}

export enum AppMetaDataLookups {
    AcsAreaOfOperationByAcsTest = 371,
    AcsAreaOfOperationAllItems = 353,
    AcsAreaOfOperationTaskAllItems = 354,
    AcsAreaOfOperationTaskByAreaOfOperation = 372,
    AcsCodeAllItems = 352,
    AcsCodeLookupRequestAllItems = 396,
    AcsCodesByAcsTest = 378,
    AcsCodeSelectionModeAllItems = 370,
    AcsCodeTypeAllItems = 351,
    ACSTestActiveOnly = 395,
    ACSTestByGrade = 394,
    AcsTestAllItems = 348,
    AcsTestCheckRideTypeAllItems = 409,
    AcsTestPortionAllItems = 377,
    AcsTestStatusAllItems = 369,
    AddressAllItems = 273,
    AiFunctionAllItems = 1479,
    AiPromptRequestAllItems = 1486,
    AirportByExaminer = 1524,
    AirportByFlightSchool = 1525,
    AirportAllItems = 297,
    AirportWithDetail = 300,
    ApplicantAcsWrittenResultAllItems = 386,
    ApplicantAcsWrittenResultMissedCodeAllItems = 387,
    ApplicantAcsWrittenResultTypeAllItems = 1535,
    ApplicantPlaceholderAllItems = 344,
    ApplicantPlaceholderStatusAllItems = 343,
    AviationAuthorityAllItems = 275,
    AviationAuthorityDistrictOfficeAllItems = 341,
    AviationTrainingProgramAllItems = 327,
    AvionicTypeAllItems = 1449,
    CalendarEventReferenceAllItems = 314,
    CalendarOwnerTypeAllItems = 1558,
    CalendarReferenceAllItems = 312,
    CalendarReferenceLogAllItems = 315,
    CalendarReferenceTypeAllItems = 313,
    CalendarSyncRequestAllItems = 1557,
    CalendarSyncRequestActionTypeAllItems = 1554,
    CalendarSyncRequestErrorTypeAllItems = 1556,
    CalendarSyncRequestSourceSubTypeAllItems = 1553,
    CalendarSyncRequestSourceTypeAllItems = 1552,
    CalendarSyncRequestStatusAllItems = 1555,
    CheckrideYearByFlightSchool = 1569,
    CheckRideAISummaryAllItems = 1516,
    CheckRideAISummaryStatusAllItems = 1517,
    CheckRideApplicantTypeAllItems = 329,
    CheckRideAvionicTypeAllItems = 1450,
    CheckRideExaminerTypeAllItems = 432,
    CheckRideGroupAllItems = 276,
    CheckRideInstructorTypeAllItems = 1548,
    CheckrideOutcomeStage = 1515,
    CheckrideOutcomeStandard = 1514,
    CheckRideOutcomeAllItems = 279,
    CheckRideOwnershipTypeAllItems = 433,
    CheckRidePaymentAllItems = 280,
    CheckRideRequestByExaminer = 385,
    CheckRideRequestBySchool = 1476,
    CheckRideRequestAllItems = 281,
    CheckRideRequestCancelTypeAllItems = 338,
    CheckRideRequestNoteAllItems = 400,
    CheckRideRequestPaymentPartyForExaminers = 1460,
    CheckRideRequestPaymentPartyForSchools = 1437,
    CheckRideRequestPaymentPartyAllItems = 340,
    CheckRideRequestPilotCertificateAllItems = 1447,
    CheckRideRequestStatusAllItems = 293,
    CheckRideRequestSubStatusAllItems = 1465,
    CheckRideRequestSubStatusExaminerManualWF = 332,
    CheckRideRequestSubStatusExaminerWF = 294,
    CheckRideRequestSubStatusSchoolManualWF = 1461,
    CheckRideRequestSubStatusSchoolWF = 438,
    CheckRideRequestSubStatusStudentWF = 311,
    CheckRideRequestSubStatusFullStatusDesc = 309,
    CheckRideResultAllItems = 292,
    CheckRideScenarioByExaminer = 342,
    CheckRideScenarioAllItems = 288,
    CheckRideScenarioTypeMapAllItems = 289,
    CheckRideScheduleHoldAllItems = 418,
    CheckRideStatusLevelAllItems = 328,
    CheckRideTestAttemptClassificationAllItems = 1565,
    CheckRideTestTypeAllItems = 295,
    CheckRideTypeWithGrade = 316,
    CheckRideTypeAllItems = 277,
    CheckRideTypeByGroup = 304,
    CheckRideWorkflowAllItems = 1462,
    CountryAllItems = 272,
    DurationAllItems = 333,
    ElectronicFlightBagTypeAllItems = 1448,
    FlightSchoolNoneRemoved = 426,
    FlightSchoolNoneOtherRemoved = 1551,
    FlightSchoolApplicantByFlightSchool = 435,
    FlightSchoolBranchBySchool = 1458,
    FlightSchoolExaminerBySchool = 436,
    FlightSchoolExaminerBySchoolWithGrouping = 1469,
    FlightSchoolExaminerCheckInstructor = 1533,
    FlightSchoolExaminerNonPilexosBySchool = 1473,
    FlightSchoolByExaminerSchoolSetup = 1513,
    FlightSchoolAllItems = 345,
    FlightSchoolApplicantAllItems = 424,
    FlightSchoolApplicantBranchAllItems = 428,
    FlightSchoolApplicantStatusAllItems = 425,
    FlightSchoolBranchBySchoolODA = 1550,
    FlightSchoolBranchAllItems = 422,
    FlightSchoolExaminerAllItems = 430,
    FlightSchoolExaminerStatusActiveInactive = 1468,
    FlightSchoolExaminerStatusAllItems = 431,
    FlightSchoolExaminerTypeAllItems = 1451,
    FlightSchoolInstrcutorStatusActiveInactive = 1547,
    FlightSchoolInstructorBySchool = 1470,
    FlightSchoolInstructorSchoolNonCheck = 1530,
    FlightSchoolInstructorAllItems = 1453,
    FlightSchoolInstructorApplicantAllItems = 1457,
    FlightSchoolInstructorStatusAllItems = 1454,
    FlightSchoolInstructorTypeAllItems = 1529,
    FlightSchoolOrganizationAllItems = 427,
    FlightSchoolOrganizationFeatureAllItems = 1474,
    FlightSchoolReferenceStatusAllItems = 421,
    FlightSchoolSetupRequestAllItems = 1503,
    FlightSchoolSetupRequestStatusAllItems = 1504,
    FlightSchoolStatusAllItems = 420,
    FlightSchoolTrainingProgramAllItems = 419,
    FlightSchoolTypeAllItems = 1549,
    FlightSchoolUserAllItems = 423,
    FlightSchoolUserBranchAllItems = 429,
    MediaGroupAllItems = 201,
    PaymentAttemptAllItems = 1564,
    PaymentCardAllItems = 1446,
    PaymentCardStatusAllItems = 1445,
    PaymentCustomerReferenceAllItems = 319,
    PaymentDiscountCodeAllItems = 326,
    PaymentMethodAllItems = 290,
    PaymentProviderAllItems = 323,
    PaymentReferenceAllItems = 320,
    PaymentReferenceCardTypeAllItems = 321,
    PaymentReferenceStatusAllItems = 322,
    PaymentTypeAllItems = 291,
    PilotCertificateTypeAllItems = 346,
    PIlotExaminerActive = 339,
    PilotExaminerAllItems = 286,
    PilotExaminerFlightSchoolSetupAllItems = 1459,
    PilotExaminerLocationByExaminer = 1508,
    PilotExaminerLocationAllItems = 287,
    PilotExaminerLocationAirportAllItems = 298,
    PilotExaminerLocationStateAllItems = 308,
    PilotExaminerLocationTypeAllItems = 381,
    PilotExaminerStatusAllItems = 285,
    PilotExaminerTypeAllItems = 437,
    PlanOfActionTemplates = 397,
    PlanOfActionTemplatesByAcsTest = 376,
    PlanOfActionAllItems = 368,
    PlanOfActionQuestionResultAllItems = 383,
    PlanOfActionRequiredAcsCodeAllItems = 379,
    PlanOfActionResultAllItems = 382,
    PlanOfActionSectionAllItems = 365,
    PlanOfActionSectionQuestionAllItems = 366,
    PlanOfActionSectionTypeAllItems = 364,
    PlanOfActionStatusTemplate = 375,
    PlanOfActionStatusPlan = 373,
    PlanOfActionStatusAllItems = 363,
    PlanOfActionStatusTypeAllItems = 374,
    PostalCodeAllItems = 271,
    ProcessDefinitionByMeaning = 1518,
    ProcessDefinitionAllItems = 252,
    QuestionBankAllItems = 367,
    QuestionBankStatusAllItems = 1528,
    QuestionOutcomeAllItems = 384,
    ReferenceStatusActiveInactive = 1545,
    ReferenceStatusAllItems = 1544,
    ReportDashboardAllItems = 1567,
    ReportDashboardGroupAllItems = 1566,
    ReportDashboardWidgetAllItems = 1568,
    ReportDataSourceAllItems = 1585,
    ReportDataSourceColumnAllItems = 1586,
    ReportFilterPreferenceAllItems = 1572,
    ReportFilterPresetAllItems = 1571,
    ReportFilterPresetOwnershipTypeAllItems = 1570,
    RoAcsCodeDimensionAllItems = 1538,
    RoAcsWrittenSourceAllItems = 1534,
    RoAirportDistancesAllItems = 347,
    RoAssessmentAcsFactBaseAllItems = 1537,
    RoAssessmentAcsMissedCodeFactAllItems = 1539,
    RoAssessmentFactBaseAllItems = 1536,
    RoCalendarSyncRequestDisplayAllItems = 1559,
    RoCheckrideAcsFactBaseAllItems = 1540,
    RoCheckrideAggregateUtilAllItems = 336,
    RoCheckrideApplicantFinalNameAllItems = 334,
    RoCheckrideFactBaseAllItems = 1543,
    RoCheckRidePaymentAggregateAllItems = 337,
    RoCheckRideRequestApplicantAllItems = 1471,
    RoCheckrideRequestScheduleDateInfoAllItems = 335,
    RoFlightSchoolExaminerAllItems = 1452,
    RoFlightSchoolExaminerSearchAllItems = 1527,
    RoleAllItems = 182,
    RoMediaAllItems = 214,
    RoPilotExaminerLocationCurrentAllItems = 307,
    RoPilotExaminerLocationDistancesAllItems = 305,
    RoPilotExaminerScenarioAllItems = 306,
    RoPlanOfActionAcsFactBaseAllItems = 1541,
    RoPlanOfActionDetailsAllItems = 388,
    RoPlanOfActionFactBaseAllItems = 1542,
    RoScheduleBlockSchoolExaminerFinalAllItems = 1526,
    RoSchoolExaminersAllItems = 1466,
    RoUnitMemberDpeSupplementSummaryAllItems = 1584,
    ScheduleAllItems = 283,
    ScheduleBlockAllItems = 1507,
    ScheduleBlockAirportAllItems = 1522,
    ScheduleBlockCheckRideTypeAllItems = 1519,
    ScheduleBlockItemAllItems = 1512,
    ScheduleBlockItemCalendarItemAllItems = 1510,
    ScheduleBlockItemStatusAllItems = 1511,
    ScheduleBlockItemTypeAllItems = 1509,
    ScheduleBlockLocationAllItems = 1505,
    ScheduleBlockSchoolBookingOptionAllItems = 1523,
    ScheduleBlockStatusAllItems = 1506,
    ScheduleDayOfWeekAllItems = 282,
    ScheduleDetailAllItems = 284,
    SchedulesActive = 1546,
    SchedulesByUser = 325,
    SchoolApplicantAll = 1472,
    SchoolApplicantAwaitingScheduled = 1521,
    SchoolApplicantBySchoolAwaitingCheckride = 1456,
    SchoolExaminersPilexosExaminersBySchool = 1467,
    SchoolFeatureAllItems = 1475,
    StateProvinceAllItems = 274,
    StateProvinceByCountry = 299,
    StateProvinceShortName = 303,
    StudentApplicantAllItems = 278,
    SubscriptionAllItems = 1438,
    SubscriptionFeatureAllItems = 1443,
    SubscriptionPartyAllItems = 1439,
    SubscriptionStatusAllItems = 1440,
    SubscriptionTierAllItems = 1441,
    SubscriptionTierFeatureAllItems = 1444,
    SubscriptionTierStatusAllItems = 1442,
    TimeZoneUSOnlyLongDescription = 317,
    TimeZoneAllItems = 296,
    TrainingRecordAllItems = 1563,
    TrainingRecordStatusAllItems = 1560,
    TrainingTypeAllItems = 1561,
    UnitMemberAircraftCategoryClassAllItems = 1573,
    UnitMemberAircraftExperienceAllItems = 1582,
    UnitMemberAircraftExperienceTypeAllItems = 1574,
    UnitMemberCertificateAllItems = 1580,
    UnitMemberEmploymentAllItems = 1579,
    UnitMemberFlightExperienceAllItems = 1581,
    UnitMemberProfileAllItems = 1578,
    UnitMemberQualificationOptionAllItems = 1577,
    UnitMemberQualificationResponseAllItems = 1583,
    UnitMemberQualificationResponseTypeAllItems = 1575,
    UnitMemberQualificationTypeAllItems = 1576,
    UserAllItems = 189,
    UserInviteRequestTypeLimited = 1531,
    UserInviteRequestAllItems = 1478,
    UserInviteRequestDetailAllItems = 1501,
    UserInviteRequestEmailAllItems = 1483,
    UserInviteRequestSchoolBranchAllItems = 1502,
    UserInviteRequestStatusAllItems = 1477,
    UserInviteRequestTypeAllItems = 1481,
    UserTypeAllItems = 302,
}


// Generated Classes for MetaData service
export class AcsAreaOfOperationMetaData implements DwItem2<AcsAreaOfOperationEntity, AcsAreaOfOperationMetaDataAttributes,AcsAreaOfOperationMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1202;
        this.ItemDetail.itemName='AcsAreaOfOperation';
        this.ItemDetail.keyName='AcsAreaOfOperationId';
    }

    CreateEntity(): AcsAreaOfOperationEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsAreaOfOperationQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsAreaOfOperationEntity, AcsAreaOfOperationMetaDataAttributes,AcsAreaOfOperationMetaDataRelations>(query, this);
    }
     Attributes = new AcsAreaOfOperationMetaDataAttributes();
     Relations = new AcsAreaOfOperationMetaDataRelations();

}


export type AcsAreaOfOperationQueryBuilder = DwQueryBuilderGen<AcsAreaOfOperationEntity, AcsAreaOfOperationMetaDataAttributes,AcsAreaOfOperationMetaDataRelations>


export class AcsAreaOfOperationMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsAreaOfOperation';
    // Attributes
    AcsAreaOfOperationId = new DwItemAttribute(this.i, 'AcsAreaOfOperationId');
    AcsTestId = new DwItemAttribute(this.i, 'AcsTestId');
    AreaOfOperationName = new DwItemAttribute(this.i, 'AreaOfOperationName');
    AreaOfOperationOrder = new DwItemAttribute(this.i, 'AreaOfOperationOrder');
    AreaOfOperationCode = new DwItemAttribute(this.i, 'AreaOfOperationCode');
    AcsTestPortionId = new DwItemAttribute(this.i, 'AcsTestPortionId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class AcsAreaOfOperationMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: ACS Test */
            AcsTest = new DwItemRelationship('AcsTest|AreaOfOperation|AcsTestId', 'AcsTest', 'AcsTest');
            /** Relation: Acs Test Portion */
            AcsTestPortion = new DwItemRelationship('AcsTestPortion|AcsAreaOfOperation|AcsTestPortionId', 'AcsTestPortion', 'AcsTestPortion');
            /** Relation: Acs Area Of Operation Task */
            AcsAreaOfOperationTask = new DwItemRelationship('AcsAreaOfOperation|AcsAreaOfOperationTask|AcsAreaOfOperationId', 'AcsAreaOfOperationTask', 'AcsAreaOfOperationTask');
            /** Relation: Plan Of Action Section */
            PlanOfActionSection = new DwItemRelationship('AcsAreaOfOperation|PlanOfActionSection|AcsAreaOfOperationId', 'PlanOfActionSection', 'PlanOfActionSection');
    };
export class AcsAreaOfOperationTaskMetaData implements DwItem2<AcsAreaOfOperationTaskEntity, AcsAreaOfOperationTaskMetaDataAttributes,AcsAreaOfOperationTaskMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1203;
        this.ItemDetail.itemName='AcsAreaOfOperationTask';
        this.ItemDetail.keyName='AcsAreaOfOperationTaskId';
    }

    CreateEntity(): AcsAreaOfOperationTaskEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsAreaOfOperationTaskQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsAreaOfOperationTaskEntity, AcsAreaOfOperationTaskMetaDataAttributes,AcsAreaOfOperationTaskMetaDataRelations>(query, this);
    }
     Attributes = new AcsAreaOfOperationTaskMetaDataAttributes();
     Relations = new AcsAreaOfOperationTaskMetaDataRelations();

}


export type AcsAreaOfOperationTaskQueryBuilder = DwQueryBuilderGen<AcsAreaOfOperationTaskEntity, AcsAreaOfOperationTaskMetaDataAttributes,AcsAreaOfOperationTaskMetaDataRelations>


export class AcsAreaOfOperationTaskMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsAreaOfOperationTask';
    // Attributes
    AcsAreaOfOperationTaskId = new DwItemAttribute(this.i, 'AcsAreaOfOperationTaskId');
    AcsAreaOfOperationId = new DwItemAttribute(this.i, 'AcsAreaOfOperationId');
    TaskName = new DwItemAttribute(this.i, 'TaskName');
    TaskOrder = new DwItemAttribute(this.i, 'TaskOrder');
    TaskCode = new DwItemAttribute(this.i, 'TaskCode');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class AcsAreaOfOperationTaskMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Area Of Operation */
            AcsAreaOfOperation = new DwItemRelationship('AcsAreaOfOperation|AcsAreaOfOperationTask|AcsAreaOfOperationId', 'AcsAreaOfOperation', 'AcsAreaOfOperation');
            /** Relation: ACS Code */
            AcsCode = new DwItemRelationship('AcsAreaOfOperationTask|AcsCode|AcsAreaOfOperationTaskId', 'AcsCode', 'AcsCode');
            /** Relation: Plan Of Action Section */
            PlanOfActionSection = new DwItemRelationship('AcsAreaOfOperationTask|PlanOfActionSection|AcsAreaOfOperationTaskId', 'PlanOfActionSection', 'PlanOfActionSection');
    };
export class AcsCodeMetaData implements DwItem2<AcsCodeEntity, AcsCodeMetaDataAttributes,AcsCodeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1201;
        this.ItemDetail.itemName='AcsCode';
        this.ItemDetail.keyName='AcsCodeId';
    }

    CreateEntity(): AcsCodeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsCodeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsCodeEntity, AcsCodeMetaDataAttributes,AcsCodeMetaDataRelations>(query, this);
    }
     Attributes = new AcsCodeMetaDataAttributes();
     Relations = new AcsCodeMetaDataRelations();

}


export type AcsCodeQueryBuilder = DwQueryBuilderGen<AcsCodeEntity, AcsCodeMetaDataAttributes,AcsCodeMetaDataRelations>


export class AcsCodeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsCode';
    // Attributes
    AcsCodeId = new DwItemAttribute(this.i, 'AcsCodeId');
    AscCodeTypeId = new DwItemAttribute(this.i, 'AscCodeTypeId');
    AcsCode = new DwItemAttribute(this.i, 'AcsCode');
    AcsCodeOrder = new DwItemAttribute(this.i, 'AcsCodeOrder');
    AcsAreaOfOperationTaskId = new DwItemAttribute(this.i, 'AcsAreaOfOperationTaskId');
    AscCodeDescription = new DwItemAttribute(this.i, 'AscCodeDescription');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class AcsCodeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Area Of Operation Task */
            AcsAreaOfOperationTask = new DwItemRelationship('AcsAreaOfOperationTask|AcsCode|AcsAreaOfOperationTaskId', 'AcsAreaOfOperationTask', 'AcsAreaOfOperationTask');
            /** Relation: Acs Code Type - Code Type */
            AcsCodeTypeByAscCodeTypeId = new DwItemRelationship('AcsCodeType|AcsCode|AscCodeTypeId', 'AscCodeTypeIdAcsCodeType', 'AscCodeTypeIdAcsCodeType');
            /** Relation: Ro Assessment Acs Missed Code Fact */
            RoAssessmentAcsMissedCodeFact = new DwItemRelationship('ACSCode|RoAssessmentAcsMissedCodeFact|AcsCodeID', 'AcsCode2', 'AcsCode2');
            /** Relation: Applicant Acs Written Result Missed Code */
            ApplicantAcsWrittenResultMissedCode = new DwItemRelationship('AcsCode|ApplicantAcsWrittenResultMissedCode|AcsCodeId', 'ApplicantAcsWrittenResultMissedCode', 'ApplicantAcsWrittenResultMissedCode');
            /** Relation: Plan Of Action Required Acs Code */
            PlanOfActionRequiredAcsCode = new DwItemRelationship('AcsCode|PlanOfActionRequiredAcsCode|AscCodeId', 'PlanOfActionRequiredAcsCode', 'PlanOfActionRequiredAcsCode');
            /** Relation: Plan Of Action Section Question */
            PlanOfActionSectionQuestion = new DwItemRelationship('AcsCode|PlanOfActionSectionQuestion|AcsCodeId', 'PlanOfActionSectionQuestion', 'PlanOfActionSectionQuestion');
            /** Relation: Question Bank */
            QuestionBank = new DwItemRelationship('AcsCode|QuestionBank|AcsCodeId', 'QuestionBank', 'QuestionBank');
    };
export class AcsCodeLookupRequestMetaData implements DwItem2<AcsCodeLookupRequestEntity, AcsCodeLookupRequestMetaDataAttributes,AcsCodeLookupRequestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1236;
        this.ItemDetail.itemName='AcsCodeLookupRequest';
        this.ItemDetail.keyName='AcsCodeLookupRequestId';
    }

    CreateEntity(): AcsCodeLookupRequestEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsCodeLookupRequestQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsCodeLookupRequestEntity, AcsCodeLookupRequestMetaDataAttributes,AcsCodeLookupRequestMetaDataRelations>(query, this);
    }
     Attributes = new AcsCodeLookupRequestMetaDataAttributes();
     Relations = new AcsCodeLookupRequestMetaDataRelations();

}


export type AcsCodeLookupRequestQueryBuilder = DwQueryBuilderGen<AcsCodeLookupRequestEntity, AcsCodeLookupRequestMetaDataAttributes,AcsCodeLookupRequestMetaDataRelations>


export class AcsCodeLookupRequestMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsCodeLookupRequest';
    // Attributes
    AcsCodeLookupRequestId = new DwItemAttribute(this.i, 'AcsCodeLookupRequestId');
    EmailAddress = new DwItemAttribute(this.i, 'EmailAddress');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ApplicantAcsWrittenResultId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultId');
    EmailNotes = new DwItemAttribute(this.i, 'EmailNotes');
}

class AcsCodeLookupRequestMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Applicant Acs Written Result */
            ApplicantAcsWrittenResult = new DwItemRelationship('ApplicantAcsWrittenResult|AcsCodeLookupRequest|ApplicantAcsWrittenResultId', 'ApplicantAcsWrittenResult', 'ApplicantAcsWrittenResult');
    };
export class AcsCodeSelectionModeMetaData implements DwItem2<AcsCodeSelectionModeEntity, AcsCodeSelectionModeMetaDataAttributes,AcsCodeSelectionModeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1219;
        this.ItemDetail.itemName='AcsCodeSelectionMode';
        this.ItemDetail.keyName='AcsCodeSelectionModeId';
    }

    CreateEntity(): AcsCodeSelectionModeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsCodeSelectionModeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsCodeSelectionModeEntity, AcsCodeSelectionModeMetaDataAttributes,AcsCodeSelectionModeMetaDataRelations>(query, this);
    }
     Attributes = new AcsCodeSelectionModeMetaDataAttributes();
     Relations = new AcsCodeSelectionModeMetaDataRelations();

}


export type AcsCodeSelectionModeQueryBuilder = DwQueryBuilderGen<AcsCodeSelectionModeEntity, AcsCodeSelectionModeMetaDataAttributes,AcsCodeSelectionModeMetaDataRelations>


export class AcsCodeSelectionModeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsCodeSelectionMode';
    // Attributes
    AcsCodeSelectionModeId = new DwItemAttribute(this.i, 'AcsCodeSelectionModeId');
    AcsCodeSelectionMode = new DwItemAttribute(this.i, 'AcsCodeSelectionMode');
}

class AcsCodeSelectionModeMetaDataRelations implements DwItemRelationshipCollection {
    };
export class AcsCodeTypeMetaData implements DwItem2<AcsCodeTypeEntity, AcsCodeTypeMetaDataAttributes,AcsCodeTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1200;
        this.ItemDetail.itemName='AcsCodeType';
        this.ItemDetail.keyName='AcsCodeTypeId';
    }

    CreateEntity(): AcsCodeTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsCodeTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsCodeTypeEntity, AcsCodeTypeMetaDataAttributes,AcsCodeTypeMetaDataRelations>(query, this);
    }
     Attributes = new AcsCodeTypeMetaDataAttributes();
     Relations = new AcsCodeTypeMetaDataRelations();

}


export type AcsCodeTypeQueryBuilder = DwQueryBuilderGen<AcsCodeTypeEntity, AcsCodeTypeMetaDataAttributes,AcsCodeTypeMetaDataRelations>


export class AcsCodeTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsCodeType';
    // Attributes
    AcsCodeTypeId = new DwItemAttribute(this.i, 'AcsCodeTypeId');
    AcsCodeTypeName = new DwItemAttribute(this.i, 'AcsCodeTypeName');
    AcsCodeTypeShortName = new DwItemAttribute(this.i, 'AcsCodeTypeShortName');
}

class AcsCodeTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: ACS Code - Asc Code Type - Many */
            AcsCodeByAscCodeTypeId = new DwItemRelationship('AcsCodeType|AcsCode|AscCodeTypeId', 'AscCodeTypeIdAcsCode', 'AscCodeTypeIdAcsCode');
    };
export class AcsTestMetaData implements DwItem2<AcsTestEntity, AcsTestMetaDataAttributes,AcsTestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1197;
        this.ItemDetail.itemName='AcsTest';
        this.ItemDetail.keyName='AcsTestId';
    }

    CreateEntity(): AcsTestEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsTestQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsTestEntity, AcsTestMetaDataAttributes,AcsTestMetaDataRelations>(query, this);
    }
     Attributes = new AcsTestMetaDataAttributes();
     Relations = new AcsTestMetaDataRelations();

}


export type AcsTestQueryBuilder = DwQueryBuilderGen<AcsTestEntity, AcsTestMetaDataAttributes,AcsTestMetaDataRelations>


export class AcsTestMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsTest';
    // Attributes
    AcsTestId = new DwItemAttribute(this.i, 'AcsTestId');
    TestName = new DwItemAttribute(this.i, 'TestName');
    TestDescription = new DwItemAttribute(this.i, 'TestDescription');
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    TestCode = new DwItemAttribute(this.i, 'TestCode');
    TestExpirationDate = new DwItemAttribute(this.i, 'TestExpirationDate');
    AcsTestStatusId = new DwItemAttribute(this.i, 'AcsTestStatusId');
    AcsTestPdfMediaId = new DwItemAttribute(this.i, 'AcsTestPdfMediaId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    HasACSCodes = new DwItemAttribute(this.i, 'HasACSCodes');
    ShowAdditionalTestResult = new DwItemAttribute(this.i, 'ShowAdditionalTestResult');
}

class AcsTestMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Test Status */
            AcsTestStatus = new DwItemRelationship('AcsTestStatus|AcsTest|AcsTestStatusId', 'AcsTestStatus', 'AcsTestStatus');
            /** Relation: Checkride Group */
            CheckRideGroup = new DwItemRelationship('CheckRideGroup|AcsTest|CheckRideGroupId', 'CheckRideGroup', 'CheckRideGroup');
            /** Relation: Acs Area Of Operation */
            AcsAreaOfOperation = new DwItemRelationship('AcsTest|AreaOfOperation|AcsTestId', 'AcsAreaOfOperation', 'AcsAreaOfOperation');
            /** Relation: Acs Test Check Ride Type */
            AcsTestCheckRideType = new DwItemRelationship('AcsTest|AcsTestCheckRideType|AcsTestId', 'AcsTestCheckRideType', 'AcsTestCheckRideType');
            /** Relation: Applicant Acs Written Result */
            ApplicantAcsWrittenResult = new DwItemRelationship('AcsTest|ApplicantAcsWrittenResult|AcsTestId', 'ApplicantAcsWrittenResult', 'ApplicantAcsWrittenResult');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('AcsTest|PlanOfAction|AcsTestId', 'PlanOfAction', 'PlanOfAction');
            /** Relation: Question Bank */
            QuestionBank = new DwItemRelationship('AcsTest|QuestionBank|AcsTestId', 'QuestionBank', 'QuestionBank');
    };
export class AcsTestCheckRideTypeMetaData implements DwItem2<AcsTestCheckRideTypeEntity, AcsTestCheckRideTypeMetaDataAttributes,AcsTestCheckRideTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1243;
        this.ItemDetail.itemName='AcsTestCheckRideType';
        this.ItemDetail.keyName='AcsTestCheckRideTypeId';
    }

    CreateEntity(): AcsTestCheckRideTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsTestCheckRideTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsTestCheckRideTypeEntity, AcsTestCheckRideTypeMetaDataAttributes,AcsTestCheckRideTypeMetaDataRelations>(query, this);
    }
     Attributes = new AcsTestCheckRideTypeMetaDataAttributes();
     Relations = new AcsTestCheckRideTypeMetaDataRelations();

}


export type AcsTestCheckRideTypeQueryBuilder = DwQueryBuilderGen<AcsTestCheckRideTypeEntity, AcsTestCheckRideTypeMetaDataAttributes,AcsTestCheckRideTypeMetaDataRelations>


export class AcsTestCheckRideTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsTestCheckRideType';
    // Attributes
    AcsTestCheckRideTypeId = new DwItemAttribute(this.i, 'AcsTestCheckRideTypeId');
    AcsTestId = new DwItemAttribute(this.i, 'AcsTestId');
    CheckRideTypeId = new DwItemAttribute(this.i, 'CheckRideTypeId');
}

class AcsTestCheckRideTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: ACS Test */
            AcsTest = new DwItemRelationship('AcsTest|AcsTestCheckRideType|AcsTestId', 'AcsTest', 'AcsTest');
            /** Relation: Checkride Type */
            CheckRideType = new DwItemRelationship('CheckRideType|AcsTestCheckRideType|CheckRideTypeId', 'CheckRideType', 'CheckRideType');
    };
export class AcsTestPortionMetaData implements DwItem2<AcsTestPortionEntity, AcsTestPortionMetaDataAttributes,AcsTestPortionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1221;
        this.ItemDetail.itemName='AcsTestPortion';
        this.ItemDetail.keyName='AcsTestPortionId';
    }

    CreateEntity(): AcsTestPortionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsTestPortionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsTestPortionEntity, AcsTestPortionMetaDataAttributes,AcsTestPortionMetaDataRelations>(query, this);
    }
     Attributes = new AcsTestPortionMetaDataAttributes();
     Relations = new AcsTestPortionMetaDataRelations();

}


export type AcsTestPortionQueryBuilder = DwQueryBuilderGen<AcsTestPortionEntity, AcsTestPortionMetaDataAttributes,AcsTestPortionMetaDataRelations>


export class AcsTestPortionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsTestPortion';
    // Attributes
    AcsTestPortionId = new DwItemAttribute(this.i, 'AcsTestPortionId');
    AcsTestPortion = new DwItemAttribute(this.i, 'AcsTestPortion');
    HeaderClass = new DwItemAttribute(this.i, 'HeaderClass');
    IconClass = new DwItemAttribute(this.i, 'IconClass');
    AcsTestPortionOrder = new DwItemAttribute(this.i, 'AcsTestPortionOrder');
    AllowAcsSections = new DwItemAttribute(this.i, 'AllowAcsSections');
}

class AcsTestPortionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Area Of Operation */
            AcsAreaOfOperation = new DwItemRelationship('AcsTestPortion|AcsAreaOfOperation|AcsTestPortionId', 'AcsAreaOfOperation', 'AcsAreaOfOperation');
            /** Relation: Plan Of Action Section */
            PlanOfActionSection = new DwItemRelationship('AcsTestPortion|PlanOfActionSection|AcsTestPortionId', 'PlanOfActionSection', 'PlanOfActionSection');
            /** Relation: Plan Of Action Section Type */
            PlanOfActionSectionType = new DwItemRelationship('AcsTestPortion|PlanOfActionSectionType|AcsTestPortionId', 'PlanOfActionSectionType', 'PlanOfActionSectionType');
    };
export class AcsTestStatusMetaData implements DwItem2<AcsTestStatusEntity, AcsTestStatusMetaDataAttributes,AcsTestStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1218;
        this.ItemDetail.itemName='AcsTestStatus';
        this.ItemDetail.keyName='AcsTestStatusId';
    }

    CreateEntity(): AcsTestStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsTestStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsTestStatusEntity, AcsTestStatusMetaDataAttributes,AcsTestStatusMetaDataRelations>(query, this);
    }
     Attributes = new AcsTestStatusMetaDataAttributes();
     Relations = new AcsTestStatusMetaDataRelations();

}


export type AcsTestStatusQueryBuilder = DwQueryBuilderGen<AcsTestStatusEntity, AcsTestStatusMetaDataAttributes,AcsTestStatusMetaDataRelations>


export class AcsTestStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsTestStatus';
    // Attributes
    AcsTestStatusId = new DwItemAttribute(this.i, 'AcsTestStatusId');
    AcsTestStatus = new DwItemAttribute(this.i, 'AcsTestStatus');
}

class AcsTestStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: ACS Test */
            AcsTest = new DwItemRelationship('AcsTestStatus|AcsTest|AcsTestStatusId', 'AcsTest', 'AcsTest');
    };
export class AddressMetaData implements DwItem2<AddressEntity, AddressMetaDataAttributes,AddressMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1157;
        this.ItemDetail.itemName='Address';
        this.ItemDetail.keyName='AddressId';
    }

    CreateEntity(): AddressEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AddressQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AddressEntity, AddressMetaDataAttributes,AddressMetaDataRelations>(query, this);
    }
     Attributes = new AddressMetaDataAttributes();
     Relations = new AddressMetaDataRelations();

}


export type AddressQueryBuilder = DwQueryBuilderGen<AddressEntity, AddressMetaDataAttributes,AddressMetaDataRelations>


export class AddressMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Address';
    // Attributes
    AddressId = new DwItemAttribute(this.i, 'AddressId');
    StreetAddress1 = new DwItemAttribute(this.i, 'StreetAddress1');
    StreetAddress2 = new DwItemAttribute(this.i, 'StreetAddress2');
    City = new DwItemAttribute(this.i, 'City');
    StateProvinceId = new DwItemAttribute(this.i, 'StateProvinceId');
    CountryId = new DwItemAttribute(this.i, 'CountryId');
    CountyName = new DwItemAttribute(this.i, 'CountyName');
    PostalCode = new DwItemAttribute(this.i, 'PostalCode');
    PostalCodePlus4 = new DwItemAttribute(this.i, 'PostalCodePlus4');
    Phone = new DwItemAttribute(this.i, 'Phone');
    Fax = new DwItemAttribute(this.i, 'Fax');
    Latitude = new DwItemAttribute(this.i, 'Latitude');
    Longitude = new DwItemAttribute(this.i, 'Longitude');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    TimezoneId = new DwItemAttribute(this.i, 'TimezoneId');
    ObservesDst = new DwItemAttribute(this.i, 'ObservesDst');
}

class AddressMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Country */
            Country = new DwItemRelationship('Country|Address|CountryId', 'Country', 'Country');
            /** Relation: State Province */
            StateProvince = new DwItemRelationship('StateProvince|Address|StateProvinceId', 'StateProvince', 'StateProvince');
            /** Relation: Time Zone */
            TimeZone = new DwItemRelationship('TimeZone|Address|TimezoneId', 'TimeZone', 'TimeZone');
            /** Relation: Airport - Airport - Many */
            AirportByAirportAddressId = new DwItemRelationship('Address|Airport|AirportAddressId', 'AirportAirport', 'AirportAirport');
            /** Relation: Flight School Branch - Branch - Many */
            FlightSchoolBranchByBranchAddressId = new DwItemRelationship('Address|FlightSchoolBranch|BranchAddressId', 'BranchFlightSchoolBranch', 'BranchFlightSchoolBranch');
            /** Relation: Flight School Organization - Billing - Many */
            FlightSchoolOrganizationByBillingAddressId = new DwItemRelationship('Address|FlightSchoolOrganization|BillingAddressId', 'BillingFlightSchoolOrganization', 'BillingFlightSchoolOrganization');
            /** Relation: Flight School Organization - Headquaters - Many */
            FlightSchoolOrganizationByHeadquatersAddressId = new DwItemRelationship('Address|FlightSchoolOrganization|HeadquatersAddressId', 'HeadquatersFlightSchoolOrganization', 'HeadquatersFlightSchoolOrganization');
            /** Relation: Student Applicant - Applicant - Many */
            StudentApplicantByApplicantAddressId = new DwItemRelationship('Address|StudentApplicant|ApplicantAddressId', 'ApplicantStudentApplicant', 'ApplicantStudentApplicant');
    };
export class DwAiFunctionMetaData implements DwItem2<DwAiFunctionEntity, DwAiFunctionMetaDataAttributes,DwAiFunctionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2294;
        this.ItemDetail.itemName='dw_AiFunction';
        this.ItemDetail.keyName='AiFunctionId';
    }

    CreateEntity(): DwAiFunctionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwAiFunctionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwAiFunctionEntity, DwAiFunctionMetaDataAttributes,DwAiFunctionMetaDataRelations>(query, this);
    }
     Attributes = new DwAiFunctionMetaDataAttributes();
     Relations = new DwAiFunctionMetaDataRelations();

}


export type DwAiFunctionQueryBuilder = DwQueryBuilderGen<DwAiFunctionEntity, DwAiFunctionMetaDataAttributes,DwAiFunctionMetaDataRelations>


export class DwAiFunctionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_AiFunction';
    // Attributes
    AiFunctionId = new DwItemAttribute(this.i, 'AiFunctionId');
    AiFunctionName = new DwItemAttribute(this.i, 'AiFunctionName');
}

class DwAiFunctionMetaDataRelations implements DwItemRelationshipCollection {
    };
export class DwAiPromptRequestMetaData implements DwItem2<DwAiPromptRequestEntity, DwAiPromptRequestMetaDataAttributes,DwAiPromptRequestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2301;
        this.ItemDetail.itemName='dw_AiPromptRequest';
        this.ItemDetail.keyName='AiPromptRequestId';
    }

    CreateEntity(): DwAiPromptRequestEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwAiPromptRequestQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwAiPromptRequestEntity, DwAiPromptRequestMetaDataAttributes,DwAiPromptRequestMetaDataRelations>(query, this);
    }
     Attributes = new DwAiPromptRequestMetaDataAttributes();
     Relations = new DwAiPromptRequestMetaDataRelations();

}


export type DwAiPromptRequestQueryBuilder = DwQueryBuilderGen<DwAiPromptRequestEntity, DwAiPromptRequestMetaDataAttributes,DwAiPromptRequestMetaDataRelations>


export class DwAiPromptRequestMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_AiPromptRequest';
    // Attributes
    AiPromptRequestId = new DwItemAttribute(this.i, 'AiPromptRequestId');
    AiPromptSetupId = new DwItemAttribute(this.i, 'AiPromptSetupId');
    AiPromptRequestStatusId = new DwItemAttribute(this.i, 'AiPromptRequestStatusId');
    Result = new DwItemAttribute(this.i, 'Result');
    SystemPromptAcutal = new DwItemAttribute(this.i, 'SystemPromptAcutal');
    UserPromptActual = new DwItemAttribute(this.i, 'UserPromptActual');
    InputTokens = new DwItemAttribute(this.i, 'InputTokens');
    InputCachedTokens = new DwItemAttribute(this.i, 'InputCachedTokens');
    OutputTokens = new DwItemAttribute(this.i, 'OutputTokens');
    TotalCost = new DwItemAttribute(this.i, 'TotalCost');
    UsePromptTokens = new DwItemAttribute(this.i, 'UsePromptTokens');
    ProcessingTimeSeconds = new DwItemAttribute(this.i, 'ProcessingTimeSeconds');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    LastLogId = new DwItemAttribute(this.i, 'LastLogId');
}

class DwAiPromptRequestMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Post Exam AI Summary - A I Prompt Request - Many */
            CheckRideAISummaryByAIPromptRequestId = new DwItemRelationship('dw_AiPromptRequest|CheckRideAISummary|AIPromptRequestId', 'AIPromptRequestIdCheckRideAISummary', 'AIPromptRequestIdCheckRideAISummary');
    };
export class AirportMetaData implements DwItem2<AirportEntity, AirportMetaDataAttributes,AirportMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1159;
        this.ItemDetail.itemName='Airport';
        this.ItemDetail.keyName='AirportId';
    }

    CreateEntity(): AirportEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AirportQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AirportEntity, AirportMetaDataAttributes,AirportMetaDataRelations>(query, this);
    }
     Attributes = new AirportMetaDataAttributes();
     Relations = new AirportMetaDataRelations();

}


export type AirportQueryBuilder = DwQueryBuilderGen<AirportEntity, AirportMetaDataAttributes,AirportMetaDataRelations>


export class AirportMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Airport';
    // Attributes
    AirportId = new DwItemAttribute(this.i, 'AirportId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    AirportName = new DwItemAttribute(this.i, 'AirportName');
    AirportCode = new DwItemAttribute(this.i, 'AirportCode');
    AirportAddressId = new DwItemAttribute(this.i, 'AirportAddressId');
    Elevation = new DwItemAttribute(this.i, 'Elevation');
    OwnershipCode = new DwItemAttribute(this.i, 'OwnershipCode');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class AirportMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Address - Airport Address */
            AddressByAirportAddressId = new DwItemRelationship('Address|Airport|AirportAddressId', 'AirportAddress', 'AirportAddress');
            /** Relation: Aviation Authority */
            AviationAuthority = new DwItemRelationship('AviationAuthority|Airport|AviationAuthorityId', 'AviationAuthority', 'AviationAuthority');
            /** Relation: Applicant Wait List - Preferred - Many */
            ApplicantPlaceholderByPreferredAirportId = new DwItemRelationship('Airport|ApplicantPlaceholder|PreferredAirportId', 'PreferredApplicantPlaceholder', 'PreferredApplicantPlaceholder');
            /** Relation: Checkride Request - Scheduled - Many */
            CheckRideRequestByScheduledAirportId = new DwItemRelationship('Airport|CheckRideRequest|ScheduledAirportId', 'ScheduledCheckRideRequest', 'ScheduledCheckRideRequest');
            /** Relation: Checkride Request - Preferred - Many */
            CheckRideRequestByPreferredAirportId = new DwItemRelationship('Airport|CheckRideRequest|PreferredAirportId', 'PreferredCheckRideRequest', 'PreferredCheckRideRequest');
            /** Relation: Checkride Request - Proposed - Many */
            CheckRideRequestByProposedAirportId = new DwItemRelationship('Airport|CheckRideRequest|ProposedAirportId', 'ProposedCheckRideRequest', 'ProposedCheckRideRequest');
            /** Relation: Checkride Request - Primary Training - Many */
            CheckRideRequestByPrimaryTrainingAirportId = new DwItemRelationship('Airport|CheckRideRequest|PrimaryTrainingAirportId', 'PrimaryTrainingCheckRideRequest', 'PrimaryTrainingCheckRideRequest');
            /** Relation: Check Ride Schedule Hold */
            CheckRideScheduleHold = new DwItemRelationship('Airport|CheckRideScheduleHold|AirportId', 'CheckRideScheduleHold', 'CheckRideScheduleHold');
            /** Relation: Flight School Branch - Main - Many */
            FlightSchoolBranchByMainAirportId = new DwItemRelationship('Airport|FlightSchoolBranch|MainAirportId', 'MainFlightSchoolBranch', 'MainFlightSchoolBranch');
            /** Relation: Pilot Examiner Location Airport */
            PilotExaminerLocationAirport = new DwItemRelationship('Airport|PilotExaminerLocationAirport|AirportId', 'PilotExaminerLocationAirport', 'PilotExaminerLocationAirport');
            /** Relation: Plan Of Action - Check Ride - Many */
            PlanOfActionByCheckRideAirportId = new DwItemRelationship('Airport|PlanOfAction|CheckRideAirportId', 'CheckRidePlanOfAction', 'CheckRidePlanOfAction');
            /** Relation: Plan Of Action - Primary Traning - Many */
            PlanOfActionByPrimaryTraningAirportId = new DwItemRelationship('Airport|PlanOfAction|PrimaryTraningAirportId', 'PrimaryTraningPlanOfAction', 'PrimaryTraningPlanOfAction');
            /** Relation: Ro Pilot Examiner Location Distances */
            RoPilotExaminerLocationDistances = new DwItemRelationship('RoPilotExaminerLocationDistances|Airport|AirportId', 'RoPilotExaminerLocationDistances', 'RoPilotExaminerLocationDistances');
            /** Relation: Schedule Block Airport */
            ScheduleBlockAirport = new DwItemRelationship('Airport|ScheduleBlockAirport|AirportId', 'ScheduleBlockAirport', 'ScheduleBlockAirport');
            /** Relation: Student Applicant - Main - Many */
            StudentApplicantByMainAirportId = new DwItemRelationship('Airport|StudentApplicant|MainAirportId', 'MainStudentApplicant', 'MainStudentApplicant');
    };
export class ApplicantAcsWrittenResultMetaData implements DwItem2<ApplicantAcsWrittenResultEntity, ApplicantAcsWrittenResultMetaDataAttributes,ApplicantAcsWrittenResultMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1228;
        this.ItemDetail.itemName='ApplicantAcsWrittenResult';
        this.ItemDetail.keyName='ApplicantAcsWrittenResultId';
    }

    CreateEntity(): ApplicantAcsWrittenResultEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ApplicantAcsWrittenResultQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ApplicantAcsWrittenResultEntity, ApplicantAcsWrittenResultMetaDataAttributes,ApplicantAcsWrittenResultMetaDataRelations>(query, this);
    }
     Attributes = new ApplicantAcsWrittenResultMetaDataAttributes();
     Relations = new ApplicantAcsWrittenResultMetaDataRelations();

}


export type ApplicantAcsWrittenResultQueryBuilder = DwQueryBuilderGen<ApplicantAcsWrittenResultEntity, ApplicantAcsWrittenResultMetaDataAttributes,ApplicantAcsWrittenResultMetaDataRelations>


export class ApplicantAcsWrittenResultMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ApplicantAcsWrittenResult';
    // Attributes
    ApplicantAcsWrittenResultId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    AcsTestId = new DwItemAttribute(this.i, 'AcsTestId');
    AcsMissedCodesRaw = new DwItemAttribute(this.i, 'AcsMissedCodesRaw');
    ApplicantAcsWrittenResultTypeId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultTypeId');
}

class ApplicantAcsWrittenResultMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: ACS Test */
            AcsTest = new DwItemRelationship('AcsTest|ApplicantAcsWrittenResult|AcsTestId', 'AcsTest', 'AcsTest');
            /** Relation: Applicant Acs Written Result Type */
            ApplicantAcsWrittenResultType = new DwItemRelationship('ApplicantAcsWrittenResultType|ApplicantAcsWrittenResult|ApplicantAcsWrittenResultTypeId', 'ApplicantAcsWrittenResultType', 'ApplicantAcsWrittenResultType');
            /** Relation: Acs Code Lookup Request */
            AcsCodeLookupRequest = new DwItemRelationship('ApplicantAcsWrittenResult|AcsCodeLookupRequest|ApplicantAcsWrittenResultId', 'AcsCodeLookupRequest', 'AcsCodeLookupRequest');
            /** Relation: Applicant Acs Written Result Missed Code */
            ApplicantAcsWrittenResultMissedCode = new DwItemRelationship('ApplicantAcsWrittenResult|ApplicantAcsWrittenResultMissedCode|ApplicantAcsWrittenResultId', 'ApplicantAcsWrittenResultMissedCode', 'ApplicantAcsWrittenResultMissedCode');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('ApplicantAcsWrittenResult|CheckRideRequest|ApplicantAcsWrittenResultId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Checkride Result - Post - Many */
            CheckRideResultByPostApplicantAcsWrittenResultId = new DwItemRelationship('ApplicantAcsWrittenResult|CheckRideResult|PostApplicantAcsWrittenResultId', 'PostCheckRideResult', 'PostCheckRideResult');
            /** Relation: Flight School Applicant */
            FlightSchoolApplicant = new DwItemRelationship('ApplicantAcsWrittenResult|FlightSchoolApplicant|ApplicantAcsWrittenResultId', 'FlightSchoolApplicant', 'FlightSchoolApplicant');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('ApplicantAcsWrittenResult|PlanOfAction|ApplicantAcsWrittenResultId', 'PlanOfAction', 'PlanOfAction');
            /** Relation: Plan Of Action Result - Post - Many */
            PlanOfActionResultByPostApplicantAcsWrittenResultId = new DwItemRelationship('ApplicantAcsWrittenResult|PlanOfActionResult|PostApplicantAcsWrittenResultId', 'PostPlanOfActionResult', 'PostPlanOfActionResult');
    };
export class ApplicantAcsWrittenResultMissedCodeMetaData implements DwItem2<ApplicantAcsWrittenResultMissedCodeEntity, ApplicantAcsWrittenResultMissedCodeMetaDataAttributes,ApplicantAcsWrittenResultMissedCodeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1229;
        this.ItemDetail.itemName='ApplicantAcsWrittenResultMissedCode';
        this.ItemDetail.keyName='ApplicantAcsWrittenResultMissedCodeId';
    }

    CreateEntity(): ApplicantAcsWrittenResultMissedCodeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ApplicantAcsWrittenResultMissedCodeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ApplicantAcsWrittenResultMissedCodeEntity, ApplicantAcsWrittenResultMissedCodeMetaDataAttributes,ApplicantAcsWrittenResultMissedCodeMetaDataRelations>(query, this);
    }
     Attributes = new ApplicantAcsWrittenResultMissedCodeMetaDataAttributes();
     Relations = new ApplicantAcsWrittenResultMissedCodeMetaDataRelations();

}


export type ApplicantAcsWrittenResultMissedCodeQueryBuilder = DwQueryBuilderGen<ApplicantAcsWrittenResultMissedCodeEntity, ApplicantAcsWrittenResultMissedCodeMetaDataAttributes,ApplicantAcsWrittenResultMissedCodeMetaDataRelations>


export class ApplicantAcsWrittenResultMissedCodeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ApplicantAcsWrittenResultMissedCode';
    // Attributes
    ApplicantAcsWrittenResultMissedCodeId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultMissedCodeId');
    ApplicantAcsWrittenResultId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultId');
    AcsCodeId = new DwItemAttribute(this.i, 'AcsCodeId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ApplicantAcsWrittenResultMissedCodeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: ACS Code */
            AcsCode = new DwItemRelationship('AcsCode|ApplicantAcsWrittenResultMissedCode|AcsCodeId', 'AcsCode', 'AcsCode');
            /** Relation: Applicant Acs Written Result */
            ApplicantAcsWrittenResult = new DwItemRelationship('ApplicantAcsWrittenResult|ApplicantAcsWrittenResultMissedCode|ApplicantAcsWrittenResultId', 'ApplicantAcsWrittenResult', 'ApplicantAcsWrittenResult');
    };
export class ApplicantAcsWrittenResultTypeMetaData implements DwItem2<ApplicantAcsWrittenResultTypeEntity, ApplicantAcsWrittenResultTypeMetaDataAttributes,ApplicantAcsWrittenResultTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2337;
        this.ItemDetail.itemName='ApplicantAcsWrittenResultType';
        this.ItemDetail.keyName='ApplicantAcsWrittenResultTypeId';
    }

    CreateEntity(): ApplicantAcsWrittenResultTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ApplicantAcsWrittenResultTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ApplicantAcsWrittenResultTypeEntity, ApplicantAcsWrittenResultTypeMetaDataAttributes,ApplicantAcsWrittenResultTypeMetaDataRelations>(query, this);
    }
     Attributes = new ApplicantAcsWrittenResultTypeMetaDataAttributes();
     Relations = new ApplicantAcsWrittenResultTypeMetaDataRelations();

}


export type ApplicantAcsWrittenResultTypeQueryBuilder = DwQueryBuilderGen<ApplicantAcsWrittenResultTypeEntity, ApplicantAcsWrittenResultTypeMetaDataAttributes,ApplicantAcsWrittenResultTypeMetaDataRelations>


export class ApplicantAcsWrittenResultTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ApplicantAcsWrittenResultType';
    // Attributes
    ApplicantAcsWrittenResultTypeId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultTypeId');
    ApplicantAcsWrittenResultType = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultType');
}

class ApplicantAcsWrittenResultTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Applicant Acs Written Result */
            ApplicantAcsWrittenResult = new DwItemRelationship('ApplicantAcsWrittenResultType|ApplicantAcsWrittenResult|ApplicantAcsWrittenResultTypeId', 'ApplicantAcsWrittenResult', 'ApplicantAcsWrittenResult');
    };
export class ApplicantPlaceholderMetaData implements DwItem2<ApplicantPlaceholderEntity, ApplicantPlaceholderMetaDataAttributes,ApplicantPlaceholderMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1193;
        this.ItemDetail.itemName='ApplicantPlaceholder';
        this.ItemDetail.keyName='ApplicantPlaceholderId';
    }

    CreateEntity(): ApplicantPlaceholderEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ApplicantPlaceholderQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ApplicantPlaceholderEntity, ApplicantPlaceholderMetaDataAttributes,ApplicantPlaceholderMetaDataRelations>(query, this);
    }
     Attributes = new ApplicantPlaceholderMetaDataAttributes();
     Relations = new ApplicantPlaceholderMetaDataRelations();

}


export type ApplicantPlaceholderQueryBuilder = DwQueryBuilderGen<ApplicantPlaceholderEntity, ApplicantPlaceholderMetaDataAttributes,ApplicantPlaceholderMetaDataRelations>


export class ApplicantPlaceholderMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ApplicantPlaceholder';
    // Attributes
    ApplicantPlaceholderId = new DwItemAttribute(this.i, 'ApplicantPlaceholderId');
    ApplicantPlaceholderStatusId = new DwItemAttribute(this.i, 'ApplicantPlaceholderStatusId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    StudentApplicantId = new DwItemAttribute(this.i, 'StudentApplicantId');
    CheckRideApplicantTypeId = new DwItemAttribute(this.i, 'CheckRideApplicantTypeId');
    StudentApplicantNameManual = new DwItemAttribute(this.i, 'StudentApplicantNameManual');
    StudentApplicantEmailManual = new DwItemAttribute(this.i, 'StudentApplicantEmailManual');
    StudentApplicantPhoneManual = new DwItemAttribute(this.i, 'StudentApplicantPhoneManual');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    CheckRideTypeId = new DwItemAttribute(this.i, 'CheckRideTypeId');
    PreferredAirportId = new DwItemAttribute(this.i, 'PreferredAirportId');
    PreferredDateTime = new DwItemAttribute(this.i, 'PreferredDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    PilotCertificateNumber = new DwItemAttribute(this.i, 'PilotCertificateNumber');
    FlightSchoolName = new DwItemAttribute(this.i, 'FlightSchoolName');
    FlightInstructorName = new DwItemAttribute(this.i, 'FlightInstructorName');
    PrivateNotes = new DwItemAttribute(this.i, 'PrivateNotes');
    CheckRideTestTypeId = new DwItemAttribute(this.i, 'CheckRideTestTypeId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolNameOther = new DwItemAttribute(this.i, 'FlightSchoolNameOther');
    AuthorityPreCheckRideNumber = new DwItemAttribute(this.i, 'AuthorityPreCheckRideNumber');
    StudentApplicantCitizenshipCountyId = new DwItemAttribute(this.i, 'StudentApplicantCitizenshipCountyId');
    AviationTrainingProgramId = new DwItemAttribute(this.i, 'AviationTrainingProgramId');
    OriginalCheckRideRequestId = new DwItemAttribute(this.i, 'OriginalCheckRideRequestId');
    FlightInstructorEmail = new DwItemAttribute(this.i, 'FlightInstructorEmail');
    FlightInstructorPhone = new DwItemAttribute(this.i, 'FlightInstructorPhone');
    LastContactDateTime = new DwItemAttribute(this.i, 'LastContactDateTime');
    RankingDateTime = new DwItemAttribute(this.i, 'RankingDateTime');
    DocumentsMediaGroupId = new DwItemAttribute(this.i, 'DocumentsMediaGroupId');
}

class ApplicantPlaceholderMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Airport - Preferred Airport */
            AirportByPreferredAirportId = new DwItemRelationship('Airport|ApplicantPlaceholder|PreferredAirportId', 'PreferredAirport', 'PreferredAirport');
            /** Relation: Applicant Placeholder Status */
            ApplicantPlaceholderStatus = new DwItemRelationship('ApplicantPlaceholderStatus|ApplicantPlaceholder|ApplicantPlaceholderStatusId', 'ApplicantPlaceholderStatus', 'ApplicantPlaceholderStatus');
            /** Relation: Aviation Authority */
            AviationAuthority = new DwItemRelationship('AviationAuthority|ApplicantPlaceholder|AviationAuthorityId', 'AviationAuthority', 'AviationAuthority');
            /** Relation: Aviation Training Program */
            AviationTrainingProgram = new DwItemRelationship('AviationTrainingProgram|ApplicantPlaceholder|AviationTrainingProgramId', 'AviationTrainingProgram', 'AviationTrainingProgram');
            /** Relation: Check Ride Applicant Type */
            CheckRideApplicantType = new DwItemRelationship('CheckRideApplicantType|ApplicantPlaceholder|CheckRideApplicantTypeId', 'CheckRideApplicantType', 'CheckRideApplicantType');
            /** Relation: Checkride Group */
            CheckRideGroup = new DwItemRelationship('CheckRideGroup|ApplicantPlaceholder|CheckRideGroupId', 'CheckRideGroup', 'CheckRideGroup');
            /** Relation: Checkride Test Type */
            CheckRideTestType = new DwItemRelationship('CheckRideTestType|ApplicantPlaceholder|CheckRideTtestTypeId', 'CheckRideTestType', 'CheckRideTestType');
            /** Relation: Checkride Type */
            CheckRideType = new DwItemRelationship('CheckRideType|ApplicantPlaceholder|CheckRideTypeId', 'CheckRideType', 'CheckRideType');
            /** Relation: Country - Applicant Citizenship */
            CountryByStudentApplicantCitizenshipCountyId = new DwItemRelationship('Country|ApplicantPlaceholder|StudentApplicantCitizenshipCountyId', 'StudentApplicantCitizenshipCountyIdCountry', 'StudentApplicantCitizenshipCountyIdCountry');
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|ApplicantPlaceholder|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('PilotExaminer|ApplicantPlaceholder|PilotExaminerId', 'PilotExaminer', 'PilotExaminer');
            /** Relation: Student Applicant */
            StudentApplicant = new DwItemRelationship('StudentApplicant|ApplicantPlaceholder|StudentApplicantId', 'StudentApplicant', 'StudentApplicant');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('ApplicantPlaceholder|CheckRideRequest|ApplicantPlaceholderId', 'CheckRideRequest', 'CheckRideRequest');
    };
export class ApplicantPlaceholderStatusMetaData implements DwItem2<ApplicantPlaceholderStatusEntity, ApplicantPlaceholderStatusMetaDataAttributes,ApplicantPlaceholderStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1192;
        this.ItemDetail.itemName='ApplicantPlaceholderStatus';
        this.ItemDetail.keyName='ApplicantPlaceholderStatusId';
    }

    CreateEntity(): ApplicantPlaceholderStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ApplicantPlaceholderStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ApplicantPlaceholderStatusEntity, ApplicantPlaceholderStatusMetaDataAttributes,ApplicantPlaceholderStatusMetaDataRelations>(query, this);
    }
     Attributes = new ApplicantPlaceholderStatusMetaDataAttributes();
     Relations = new ApplicantPlaceholderStatusMetaDataRelations();

}


export type ApplicantPlaceholderStatusQueryBuilder = DwQueryBuilderGen<ApplicantPlaceholderStatusEntity, ApplicantPlaceholderStatusMetaDataAttributes,ApplicantPlaceholderStatusMetaDataRelations>


export class ApplicantPlaceholderStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ApplicantPlaceholderStatus';
    // Attributes
    ApplicantPlaceholderStatusId = new DwItemAttribute(this.i, 'ApplicantPlaceholderStatusId');
    ApplicantPlaceholderStatus = new DwItemAttribute(this.i, 'ApplicantPlaceholderStatus');
}

class ApplicantPlaceholderStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Applicant Wait List */
            ApplicantPlaceholder = new DwItemRelationship('ApplicantPlaceholderStatus|ApplicantPlaceholder|ApplicantPlaceholderStatusId', 'ApplicantPlaceholder', 'ApplicantPlaceholder');
    };
export class AviationAuthorityMetaData implements DwItem2<AviationAuthorityEntity, AviationAuthorityMetaDataAttributes,AviationAuthorityMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1133;
        this.ItemDetail.itemName='AviationAuthority';
        this.ItemDetail.keyName='AviationAuthorityId';
    }

    CreateEntity(): AviationAuthorityEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AviationAuthorityQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AviationAuthorityEntity, AviationAuthorityMetaDataAttributes,AviationAuthorityMetaDataRelations>(query, this);
    }
     Attributes = new AviationAuthorityMetaDataAttributes();
     Relations = new AviationAuthorityMetaDataRelations();

}


export type AviationAuthorityQueryBuilder = DwQueryBuilderGen<AviationAuthorityEntity, AviationAuthorityMetaDataAttributes,AviationAuthorityMetaDataRelations>


export class AviationAuthorityMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AviationAuthority';
    // Attributes
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    AuthorityName = new DwItemAttribute(this.i, 'AuthorityName');
}

class AviationAuthorityMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Airport */
            Airport = new DwItemRelationship('AviationAuthority|Airport|AviationAuthorityId', 'Airport', 'Airport');
            /** Relation: Applicant Wait List */
            ApplicantPlaceholder = new DwItemRelationship('AviationAuthority|ApplicantPlaceholder|AviationAuthorityId', 'ApplicantPlaceholder', 'ApplicantPlaceholder');
            /** Relation: FSDO */
            AviationAuthorityDistrictOffice = new DwItemRelationship('AviationAuthority|AviationAuthorityDistrictOffice|AviationAuthorityId', 'AviationAuthorityDistrictOffice', 'AviationAuthorityDistrictOffice');
            /** Relation: Aviation Training Program */
            AviationTrainingProgram = new DwItemRelationship('AviationAuthority|AviationTrainingProgram|AviationAuthorityId', 'AviationTrainingProgram', 'AviationTrainingProgram');
            /** Relation: Checkride Group */
            CheckRideGroup = new DwItemRelationship('AviationAuthority|CheckRideGroup|AviationAuthorityId', 'CheckRideGroup', 'CheckRideGroup');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('AviationAuthority|CheckRideRequest|AviationAuthorityId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('AviationAuthority|PilotExaminer|AviationAuthorityId', 'PilotExaminer', 'PilotExaminer');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('AviationAuthority|PlanOfAction|AviationAuthorityId', 'PlanOfAction', 'PlanOfAction');
            /** Relation: Student Applicant */
            StudentApplicant = new DwItemRelationship('AviationAuthority|StudentApplicant|AviationAuthorityId', 'StudentApplicant', 'StudentApplicant');
    };
export class AviationAuthorityDistrictOfficeMetaData implements DwItem2<AviationAuthorityDistrictOfficeEntity, AviationAuthorityDistrictOfficeMetaDataAttributes,AviationAuthorityDistrictOfficeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1191;
        this.ItemDetail.itemName='AviationAuthorityDistrictOffice';
        this.ItemDetail.keyName='AviationAuthorityDistrictOfficeId';
    }

    CreateEntity(): AviationAuthorityDistrictOfficeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AviationAuthorityDistrictOfficeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AviationAuthorityDistrictOfficeEntity, AviationAuthorityDistrictOfficeMetaDataAttributes,AviationAuthorityDistrictOfficeMetaDataRelations>(query, this);
    }
     Attributes = new AviationAuthorityDistrictOfficeMetaDataAttributes();
     Relations = new AviationAuthorityDistrictOfficeMetaDataRelations();

}


export type AviationAuthorityDistrictOfficeQueryBuilder = DwQueryBuilderGen<AviationAuthorityDistrictOfficeEntity, AviationAuthorityDistrictOfficeMetaDataAttributes,AviationAuthorityDistrictOfficeMetaDataRelations>


export class AviationAuthorityDistrictOfficeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AviationAuthorityDistrictOffice';
    // Attributes
    AviationAuthorityDistrictOfficeId = new DwItemAttribute(this.i, 'AviationAuthorityDistrictOfficeId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    DistictOfficeName = new DwItemAttribute(this.i, 'DistictOfficeName');
    PhoneNumber = new DwItemAttribute(this.i, 'PhoneNumber');
}

class AviationAuthorityDistrictOfficeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Aviation Authority */
            AviationAuthority = new DwItemRelationship('AviationAuthority|AviationAuthorityDistrictOffice|AviationAuthorityId', 'AviationAuthority', 'AviationAuthority');
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('AviationAuthorityDistrictOffice|PilotExaminer|AviationAuthorityDistrictOfficeId', 'PilotExaminer', 'PilotExaminer');
    };
export class AviationTrainingProgramMetaData implements DwItem2<AviationTrainingProgramEntity, AviationTrainingProgramMetaDataAttributes,AviationTrainingProgramMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1181;
        this.ItemDetail.itemName='AviationTrainingProgram';
        this.ItemDetail.keyName='AviationTrainingProgramId';
    }

    CreateEntity(): AviationTrainingProgramEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AviationTrainingProgramQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AviationTrainingProgramEntity, AviationTrainingProgramMetaDataAttributes,AviationTrainingProgramMetaDataRelations>(query, this);
    }
     Attributes = new AviationTrainingProgramMetaDataAttributes();
     Relations = new AviationTrainingProgramMetaDataRelations();

}


export type AviationTrainingProgramQueryBuilder = DwQueryBuilderGen<AviationTrainingProgramEntity, AviationTrainingProgramMetaDataAttributes,AviationTrainingProgramMetaDataRelations>


export class AviationTrainingProgramMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AviationTrainingProgram';
    // Attributes
    AviationTrainingProgramId = new DwItemAttribute(this.i, 'AviationTrainingProgramId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    TrainingProgramName = new DwItemAttribute(this.i, 'TrainingProgramName');
    TrainingProgramShortName = new DwItemAttribute(this.i, 'TrainingProgramShortName');
}

class AviationTrainingProgramMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Aviation Authority */
            AviationAuthority = new DwItemRelationship('AviationAuthority|AviationTrainingProgram|AviationAuthorityId', 'AviationAuthority', 'AviationAuthority');
            /** Relation: Applicant Wait List */
            ApplicantPlaceholder = new DwItemRelationship('AviationTrainingProgram|ApplicantPlaceholder|AviationTrainingProgramId', 'ApplicantPlaceholder', 'ApplicantPlaceholder');
            /** Relation: Checkride Request - Avaiation Training Program - Many */
            CheckRideRequestByAvaiationTrainingProgramId = new DwItemRelationship('AviationTrainingProgram|CheckRideRequest|AvaiationTrainingProgramId', 'AvaiationTrainingProgramIdCheckRideRequest', 'AvaiationTrainingProgramIdCheckRideRequest');
            /** Relation: Flight School Training Program */
            FlightSchoolTrainingProgram = new DwItemRelationship('AviationTrainingProgram|FlightSchoolTrainingProgram|AviationTrainingProgramId', 'FlightSchoolTrainingProgram', 'FlightSchoolTrainingProgram');
            /** Relation: Student Applicant */
            StudentApplicant = new DwItemRelationship('AviationTrainingProgram|StudentApplicant|AviationTrainingProgramId', 'StudentApplicant', 'StudentApplicant');
    };
export class AvionicTypeMetaData implements DwItem2<AvionicTypeEntity, AvionicTypeMetaDataAttributes,AvionicTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2279;
        this.ItemDetail.itemName='AvionicType';
        this.ItemDetail.keyName='AvionicTypeId';
    }

    CreateEntity(): AvionicTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AvionicTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AvionicTypeEntity, AvionicTypeMetaDataAttributes,AvionicTypeMetaDataRelations>(query, this);
    }
     Attributes = new AvionicTypeMetaDataAttributes();
     Relations = new AvionicTypeMetaDataRelations();

}


export type AvionicTypeQueryBuilder = DwQueryBuilderGen<AvionicTypeEntity, AvionicTypeMetaDataAttributes,AvionicTypeMetaDataRelations>


export class AvionicTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AvionicType';
    // Attributes
    AvionicTypeId = new DwItemAttribute(this.i, 'AvionicTypeId');
    AvionicType = new DwItemAttribute(this.i, 'AvionicType');
}

class AvionicTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Check Ride Avionic Type */
            CheckRideAvionicType = new DwItemRelationship('AvionicType|CheckRideAvionicType|AvionicTypeId', 'CheckRideAvionicType', 'CheckRideAvionicType');
    };
export class CalendarEventReferenceMetaData implements DwItem2<CalendarEventReferenceEntity, CalendarEventReferenceMetaDataAttributes,CalendarEventReferenceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1171;
        this.ItemDetail.itemName='CalendarEventReference';
        this.ItemDetail.keyName='CalendarEventReferenceId';
    }

    CreateEntity(): CalendarEventReferenceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CalendarEventReferenceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CalendarEventReferenceEntity, CalendarEventReferenceMetaDataAttributes,CalendarEventReferenceMetaDataRelations>(query, this);
    }
     Attributes = new CalendarEventReferenceMetaDataAttributes();
     Relations = new CalendarEventReferenceMetaDataRelations();

}


export type CalendarEventReferenceQueryBuilder = DwQueryBuilderGen<CalendarEventReferenceEntity, CalendarEventReferenceMetaDataAttributes,CalendarEventReferenceMetaDataRelations>


export class CalendarEventReferenceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CalendarEventReference';
    // Attributes
    CalendarEventReferenceId = new DwItemAttribute(this.i, 'CalendarEventReferenceId');
    CalendarReferenceId = new DwItemAttribute(this.i, 'CalendarReferenceId');
    EventReferenceKey = new DwItemAttribute(this.i, 'EventReferenceKey');
    CalendarKey = new DwItemAttribute(this.i, 'CalendarKey');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    IsCancelled = new DwItemAttribute(this.i, 'IsCancelled');
}

class CalendarEventReferenceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Calendar Reference */
            CalendarReference = new DwItemRelationship('CalendarReference|CalendarEventReference|CalendarReferenceId', 'CalendarReference', 'CalendarReference');
            /** Relation: Calendar Reference Log - Calendar Reference Event - Many */
            CalendarReferenceLogByCalendarReferenceEventId = new DwItemRelationship('CalendarEventReference|CalendarReferenceLog|CalendarReferenceEventId', 'CalendarReferenceEventIdCalendarReferenceLog', 'CalendarReferenceEventIdCalendarReferenceLog');
            /** Relation: Checkride Request - Scheduled - Many */
            CheckRideRequestByScheduledCalendarEventReferenceId = new DwItemRelationship('CalendarEventReference|CheckRideRequest|ScheduledCalendarEventReferenceId', 'ScheduledCheckRideRequest', 'ScheduledCheckRideRequest');
            /** Relation: Schedule Block Item Calendar Item */
            ScheduleBlockItemCalendarItem = new DwItemRelationship('CalendarEventReference|ScheduleBlockItemCalendarItem|CalendarEventReferenceId', 'ScheduleBlockItemCalendarItem', 'ScheduleBlockItemCalendarItem');
    };
export class CalendarOwnerTypeMetaData implements DwItem2<CalendarOwnerTypeEntity, CalendarOwnerTypeMetaDataAttributes,CalendarOwnerTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2355;
        this.ItemDetail.itemName='CalendarOwnerType';
        this.ItemDetail.keyName='CalendarOwnerTypeId';
    }

    CreateEntity(): CalendarOwnerTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CalendarOwnerTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CalendarOwnerTypeEntity, CalendarOwnerTypeMetaDataAttributes,CalendarOwnerTypeMetaDataRelations>(query, this);
    }
     Attributes = new CalendarOwnerTypeMetaDataAttributes();
     Relations = new CalendarOwnerTypeMetaDataRelations();

}


export type CalendarOwnerTypeQueryBuilder = DwQueryBuilderGen<CalendarOwnerTypeEntity, CalendarOwnerTypeMetaDataAttributes,CalendarOwnerTypeMetaDataRelations>


export class CalendarOwnerTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CalendarOwnerType';
    // Attributes
    CalendarOwnerTypeId = new DwItemAttribute(this.i, 'CalendarOwnerTypeId');
    CalendarOwnerType = new DwItemAttribute(this.i, 'CalendarOwnerType');
    CalendarOwnerTypeMeaning = new DwItemAttribute(this.i, 'CalendarOwnerTypeMeaning');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CalendarOwnerTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Calendar Sync Request */
            CalendarSyncRequest = new DwItemRelationship('CalendarOwnerType|CalendarSyncRequest|CalendarOwnerTypeId', 'CalendarSyncRequest', 'CalendarSyncRequest');
    };
export class CalendarReferenceMetaData implements DwItem2<CalendarReferenceEntity, CalendarReferenceMetaDataAttributes,CalendarReferenceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1169;
        this.ItemDetail.itemName='CalendarReference';
        this.ItemDetail.keyName='CalendarReferenceId';
    }

    CreateEntity(): CalendarReferenceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CalendarReferenceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CalendarReferenceEntity, CalendarReferenceMetaDataAttributes,CalendarReferenceMetaDataRelations>(query, this);
    }
     Attributes = new CalendarReferenceMetaDataAttributes();
     Relations = new CalendarReferenceMetaDataRelations();

}


export type CalendarReferenceQueryBuilder = DwQueryBuilderGen<CalendarReferenceEntity, CalendarReferenceMetaDataAttributes,CalendarReferenceMetaDataRelations>


export class CalendarReferenceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CalendarReference';
    // Attributes
    CalendarReferenceId = new DwItemAttribute(this.i, 'CalendarReferenceId');
    CalendarReferenceTypeId = new DwItemAttribute(this.i, 'CalendarReferenceTypeId');
    MainCalendarKey = new DwItemAttribute(this.i, 'MainCalendarKey');
    RefreshSecretKey = new DwItemAttribute(this.i, 'RefreshSecretKey');
    InitialSecretKey = new DwItemAttribute(this.i, 'InitialSecretKey');
    CalendarConfigJSON = new DwItemAttribute(this.i, 'CalendarConfigJSON');
    CalendarIsSetup = new DwItemAttribute(this.i, 'CalendarIsSetup');
    RefreshCount = new DwItemAttribute(this.i, 'RefreshCount');
    LastRefreshDateTime = new DwItemAttribute(this.i, 'LastRefreshDateTime');
    CalendarHasErrors = new DwItemAttribute(this.i, 'CalendarHasErrors');
    LastCalendarErrorDateTime = new DwItemAttribute(this.i, 'LastCalendarErrorDateTime');
    MainCalendarTimezone = new DwItemAttribute(this.i, 'MainCalendarTimezone');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CalendarReferenceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Calendar Reference Type */
            CalendarReferenceType = new DwItemRelationship('CalendarReferenceType|CalendarReference|CalendarReferenceTypeId', 'CalendarReferenceType', 'CalendarReferenceType');
            /** Relation: Calendar Event Reference */
            CalendarEventReference = new DwItemRelationship('CalendarReference|CalendarEventReference|CalendarReferenceId', 'CalendarEventReference', 'CalendarEventReference');
            /** Relation: Calendar Reference Log */
            CalendarReferenceLog = new DwItemRelationship('CalendarReference|CalendarReferenceLog|CalendarReferenceId', 'CalendarReferenceLog', 'CalendarReferenceLog');
            /** Relation: Calendar Sync Request */
            CalendarSyncRequest = new DwItemRelationship('CalendarReference|CalendarSyncRequest|CalendarReferenceId', 'CalendarSyncRequest', 'CalendarSyncRequest');
            /** Relation: Flight School Organization */
            FlightSchoolOrganization = new DwItemRelationship('CalendarReference|FlightSchoolOrganization|CalendarReferenceId', 'FlightSchoolOrganization', 'FlightSchoolOrganization');
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('CalendarReference|PilotExaminer|CalendarReferenceId', 'PilotExaminer', 'PilotExaminer');
    };
export class CalendarReferenceLogMetaData implements DwItem2<CalendarReferenceLogEntity, CalendarReferenceLogMetaDataAttributes,CalendarReferenceLogMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1172;
        this.ItemDetail.itemName='CalendarReferenceLog';
        this.ItemDetail.keyName='CalendarReferenceLogId';
    }

    CreateEntity(): CalendarReferenceLogEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CalendarReferenceLogQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CalendarReferenceLogEntity, CalendarReferenceLogMetaDataAttributes,CalendarReferenceLogMetaDataRelations>(query, this);
    }
     Attributes = new CalendarReferenceLogMetaDataAttributes();
     Relations = new CalendarReferenceLogMetaDataRelations();

}


export type CalendarReferenceLogQueryBuilder = DwQueryBuilderGen<CalendarReferenceLogEntity, CalendarReferenceLogMetaDataAttributes,CalendarReferenceLogMetaDataRelations>


export class CalendarReferenceLogMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CalendarReferenceLog';
    // Attributes
    CalendarReferenceLogId = new DwItemAttribute(this.i, 'CalendarReferenceLogId');
    CalendarReferenceId = new DwItemAttribute(this.i, 'CalendarReferenceId');
    LogId = new DwItemAttribute(this.i, 'LogId');
    CalendarReferenceEventId = new DwItemAttribute(this.i, 'CalendarReferenceEventId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CalendarReferenceLogMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Calendar Event Reference - Calendar Reference Event */
            CalendarEventReferenceByCalendarReferenceEventId = new DwItemRelationship('CalendarEventReference|CalendarReferenceLog|CalendarReferenceEventId', 'CalendarReferenceEventIdCalendarEventReference', 'CalendarReferenceEventIdCalendarEventReference');
            /** Relation: Calendar Reference */
            CalendarReference = new DwItemRelationship('CalendarReference|CalendarReferenceLog|CalendarReferenceId', 'CalendarReference', 'CalendarReference');
    };
export class CalendarReferenceTypeMetaData implements DwItem2<CalendarReferenceTypeEntity, CalendarReferenceTypeMetaDataAttributes,CalendarReferenceTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1170;
        this.ItemDetail.itemName='CalendarReferenceType';
        this.ItemDetail.keyName='CalendarReferenceTypeId';
    }

    CreateEntity(): CalendarReferenceTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CalendarReferenceTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CalendarReferenceTypeEntity, CalendarReferenceTypeMetaDataAttributes,CalendarReferenceTypeMetaDataRelations>(query, this);
    }
     Attributes = new CalendarReferenceTypeMetaDataAttributes();
     Relations = new CalendarReferenceTypeMetaDataRelations();

}


export type CalendarReferenceTypeQueryBuilder = DwQueryBuilderGen<CalendarReferenceTypeEntity, CalendarReferenceTypeMetaDataAttributes,CalendarReferenceTypeMetaDataRelations>


export class CalendarReferenceTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CalendarReferenceType';
    // Attributes
    CalendarReferenceTypeId = new DwItemAttribute(this.i, 'CalendarReferenceTypeId');
    CalendarReferenceTypeDisplay = new DwItemAttribute(this.i, 'CalendarReferenceTypeDisplay');
    CalendarReferenceTypeMeaning = new DwItemAttribute(this.i, 'CalendarReferenceTypeMeaning');
}

class CalendarReferenceTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Calendar Reference */
            CalendarReference = new DwItemRelationship('CalendarReferenceType|CalendarReference|CalendarReferenceTypeId', 'CalendarReference', 'CalendarReference');
    };
export class CalendarSyncRequestMetaData implements DwItem2<CalendarSyncRequestEntity, CalendarSyncRequestMetaDataAttributes,CalendarSyncRequestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2354;
        this.ItemDetail.itemName='CalendarSyncRequest';
        this.ItemDetail.keyName='CalendarSyncRequestId';
    }

    CreateEntity(): CalendarSyncRequestEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CalendarSyncRequestQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CalendarSyncRequestEntity, CalendarSyncRequestMetaDataAttributes,CalendarSyncRequestMetaDataRelations>(query, this);
    }
     Attributes = new CalendarSyncRequestMetaDataAttributes();
     Relations = new CalendarSyncRequestMetaDataRelations();

}


export type CalendarSyncRequestQueryBuilder = DwQueryBuilderGen<CalendarSyncRequestEntity, CalendarSyncRequestMetaDataAttributes,CalendarSyncRequestMetaDataRelations>


export class CalendarSyncRequestMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CalendarSyncRequest';
    // Attributes
    CalendarSyncRequestId = new DwItemAttribute(this.i, 'CalendarSyncRequestId');
    CalendarSyncRequestSourceTypeId = new DwItemAttribute(this.i, 'CalendarSyncRequestSourceTypeId');
    SourceRecordId = new DwItemAttribute(this.i, 'SourceRecordId');
    CalendarSyncRequestSourceSubTypeId = new DwItemAttribute(this.i, 'CalendarSyncRequestSourceSubTypeId');
    CalendarOwnerTypeId = new DwItemAttribute(this.i, 'CalendarOwnerTypeId');
    CalendarOwnerRecordId = new DwItemAttribute(this.i, 'CalendarOwnerRecordId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    CalendarReferenceId = new DwItemAttribute(this.i, 'CalendarReferenceId');
    CalendarSyncRequestActionTypeId = new DwItemAttribute(this.i, 'CalendarSyncRequestActionTypeId');
    CalendarSyncRequestStatusId = new DwItemAttribute(this.i, 'CalendarSyncRequestStatusId');
    RequestKey = new DwItemAttribute(this.i, 'RequestKey');
    SourceModifiedDateTime = new DwItemAttribute(this.i, 'SourceModifiedDateTime');
    SourceFingerprint = new DwItemAttribute(this.i, 'SourceFingerprint');
    PayloadJson = new DwItemAttribute(this.i, 'PayloadJson');
    AttemptCount = new DwItemAttribute(this.i, 'AttemptCount');
    MaxAttemptCount = new DwItemAttribute(this.i, 'MaxAttemptCount');
    NextAttemptDateTime = new DwItemAttribute(this.i, 'NextAttemptDateTime');
    LastAttemptDateTime = new DwItemAttribute(this.i, 'LastAttemptDateTime');
    ClaimedDateTime = new DwItemAttribute(this.i, 'ClaimedDateTime');
    LastCompletedDateTime = new DwItemAttribute(this.i, 'LastCompletedDateTime');
    CalendarSyncRequestErrorTypeId = new DwItemAttribute(this.i, 'CalendarSyncRequestErrorTypeId');
    LastErrorMessage = new DwItemAttribute(this.i, 'LastErrorMessage');
    LastProviderStatusCode = new DwItemAttribute(this.i, 'LastProviderStatusCode');
    LastProviderRetryAfterDateTime = new DwItemAttribute(this.i, 'LastProviderRetryAfterDateTime');
    LastResultJson = new DwItemAttribute(this.i, 'LastResultJson');
    SupersededByCalendarSyncRequestId = new DwItemAttribute(this.i, 'SupersededByCalendarSyncRequestId');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CalendarSyncRequestMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Calendar Owner Type */
            CalendarOwnerType = new DwItemRelationship('CalendarOwnerType|CalendarSyncRequest|CalendarOwnerTypeId', 'CalendarOwnerType', 'CalendarOwnerType');
            /** Relation: Calendar Reference */
            CalendarReference = new DwItemRelationship('CalendarReference|CalendarSyncRequest|CalendarReferenceId', 'CalendarReference', 'CalendarReference');
            /** Relation: Calendar Sync Request Action Type */
            CalendarSyncRequestActionType = new DwItemRelationship('CalendarSyncRequestActionType|CalendarSyncRequest|CalendarSyncRequestActionTypeId', 'CalendarSyncRequestActionType', 'CalendarSyncRequestActionType');
            /** Relation: Calendar Sync Request Error Type */
            CalendarSyncRequestErrorType = new DwItemRelationship('CalendarSyncRequestErrorType|CalendarSyncRequest|CalendarSyncRequestErrorTypeId', 'CalendarSyncRequestErrorType', 'CalendarSyncRequestErrorType');
            /** Relation: Calendar Sync Request Source Sub Type */
            CalendarSyncRequestSourceSubType = new DwItemRelationship('CalendarSyncRequestSourceSubType|CalendarSyncRequest|CalendarSyncRequestSourceSubTypeId', 'CalendarSyncRequestSourceSubType', 'CalendarSyncRequestSourceSubType');
            /** Relation: Calendar Sync Request Source Type */
            CalendarSyncRequestSourceType = new DwItemRelationship('CalendarSyncRequestSourceType|CalendarSyncRequest|CalendarSyncRequestSourceTypeId', 'CalendarSyncRequestSourceType', 'CalendarSyncRequestSourceType');
            /** Relation: Calendar Sync Request Status */
            CalendarSyncRequestStatus = new DwItemRelationship('CalendarSyncRequestStatus|CalendarSyncRequest|CalendarSyncRequestStatusId', 'CalendarSyncRequestStatus', 'CalendarSyncRequestStatus');
            /** Relation: Flight School Organization */
            FlightSchoolOrganization = new DwItemRelationship('FlightSchoolOrganization|CalendarSyncRequest|FlightSchoolOrganizationId', 'FlightSchoolOrganization', 'FlightSchoolOrganization');
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('PilotExaminer|CalendarSyncRequest|PilotExaminerId', 'PilotExaminer', 'PilotExaminer');
            /** Relation: Calendar Sync Request - Superseded By Calendar Sync Request - One */
            CalendarSyncRequestBySupersededByCalendarSyncRequestId = new DwItemRelationship('CalendarSyncRequest|CalendarSyncRequest|SupersededByCalendarSyncRequestId', 'SupersededByCalendarSyncRequest', 'SupersededByCalendarSyncRequest');
            /** Relation: Ro Calendar Sync Request Display */
            RoCalendarSyncRequestDisplay = new DwItemRelationship('CalendarSyncRequest|RoCalendarSyncRequestDisplay', 'RoCalendarSyncRequestDisplay', 'RoCalendarSyncRequestDisplay');
    };
export class CalendarSyncRequestActionTypeMetaData implements DwItem2<CalendarSyncRequestActionTypeEntity, CalendarSyncRequestActionTypeMetaDataAttributes,CalendarSyncRequestActionTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2351;
        this.ItemDetail.itemName='CalendarSyncRequestActionType';
        this.ItemDetail.keyName='CalendarSyncRequestActionTypeId';
    }

    CreateEntity(): CalendarSyncRequestActionTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CalendarSyncRequestActionTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CalendarSyncRequestActionTypeEntity, CalendarSyncRequestActionTypeMetaDataAttributes,CalendarSyncRequestActionTypeMetaDataRelations>(query, this);
    }
     Attributes = new CalendarSyncRequestActionTypeMetaDataAttributes();
     Relations = new CalendarSyncRequestActionTypeMetaDataRelations();

}


export type CalendarSyncRequestActionTypeQueryBuilder = DwQueryBuilderGen<CalendarSyncRequestActionTypeEntity, CalendarSyncRequestActionTypeMetaDataAttributes,CalendarSyncRequestActionTypeMetaDataRelations>


export class CalendarSyncRequestActionTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CalendarSyncRequestActionType';
    // Attributes
    CalendarSyncRequestActionTypeId = new DwItemAttribute(this.i, 'CalendarSyncRequestActionTypeId');
    CalendarSyncRequestActionType = new DwItemAttribute(this.i, 'CalendarSyncRequestActionType');
    CalendarSyncRequestActionTypeMeaning = new DwItemAttribute(this.i, 'CalendarSyncRequestActionTypeMeaning');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CalendarSyncRequestActionTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Calendar Sync Request */
            CalendarSyncRequest = new DwItemRelationship('CalendarSyncRequestActionType|CalendarSyncRequest|CalendarSyncRequestActionTypeId', 'CalendarSyncRequest', 'CalendarSyncRequest');
    };
export class CalendarSyncRequestErrorTypeMetaData implements DwItem2<CalendarSyncRequestErrorTypeEntity, CalendarSyncRequestErrorTypeMetaDataAttributes,CalendarSyncRequestErrorTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2353;
        this.ItemDetail.itemName='CalendarSyncRequestErrorType';
        this.ItemDetail.keyName='CalendarSyncRequestErrorTypeId';
    }

    CreateEntity(): CalendarSyncRequestErrorTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CalendarSyncRequestErrorTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CalendarSyncRequestErrorTypeEntity, CalendarSyncRequestErrorTypeMetaDataAttributes,CalendarSyncRequestErrorTypeMetaDataRelations>(query, this);
    }
     Attributes = new CalendarSyncRequestErrorTypeMetaDataAttributes();
     Relations = new CalendarSyncRequestErrorTypeMetaDataRelations();

}


export type CalendarSyncRequestErrorTypeQueryBuilder = DwQueryBuilderGen<CalendarSyncRequestErrorTypeEntity, CalendarSyncRequestErrorTypeMetaDataAttributes,CalendarSyncRequestErrorTypeMetaDataRelations>


export class CalendarSyncRequestErrorTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CalendarSyncRequestErrorType';
    // Attributes
    CalendarSyncRequestErrorTypeId = new DwItemAttribute(this.i, 'CalendarSyncRequestErrorTypeId');
    CalendarSyncRequestErrorType = new DwItemAttribute(this.i, 'CalendarSyncRequestErrorType');
    CalendarSyncRequestErrorTypeMeaning = new DwItemAttribute(this.i, 'CalendarSyncRequestErrorTypeMeaning');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CalendarSyncRequestErrorTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Calendar Sync Request */
            CalendarSyncRequest = new DwItemRelationship('CalendarSyncRequestErrorType|CalendarSyncRequest|CalendarSyncRequestErrorTypeId', 'CalendarSyncRequest', 'CalendarSyncRequest');
    };
export class CalendarSyncRequestSourceSubTypeMetaData implements DwItem2<CalendarSyncRequestSourceSubTypeEntity, CalendarSyncRequestSourceSubTypeMetaDataAttributes,CalendarSyncRequestSourceSubTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2350;
        this.ItemDetail.itemName='CalendarSyncRequestSourceSubType';
        this.ItemDetail.keyName='CalendarSyncRequestSourceSubTypeId';
    }

    CreateEntity(): CalendarSyncRequestSourceSubTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CalendarSyncRequestSourceSubTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CalendarSyncRequestSourceSubTypeEntity, CalendarSyncRequestSourceSubTypeMetaDataAttributes,CalendarSyncRequestSourceSubTypeMetaDataRelations>(query, this);
    }
     Attributes = new CalendarSyncRequestSourceSubTypeMetaDataAttributes();
     Relations = new CalendarSyncRequestSourceSubTypeMetaDataRelations();

}


export type CalendarSyncRequestSourceSubTypeQueryBuilder = DwQueryBuilderGen<CalendarSyncRequestSourceSubTypeEntity, CalendarSyncRequestSourceSubTypeMetaDataAttributes,CalendarSyncRequestSourceSubTypeMetaDataRelations>


export class CalendarSyncRequestSourceSubTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CalendarSyncRequestSourceSubType';
    // Attributes
    CalendarSyncRequestSourceSubTypeId = new DwItemAttribute(this.i, 'CalendarSyncRequestSourceSubTypeId');
    CalendarSyncRequestSourceSubType = new DwItemAttribute(this.i, 'CalendarSyncRequestSourceSubType');
    CalendarSyncRequestSourceSubTypeMeaning = new DwItemAttribute(this.i, 'CalendarSyncRequestSourceSubTypeMeaning');
    CalendarSyncRequestSourceTypeId = new DwItemAttribute(this.i, 'CalendarSyncRequestSourceTypeId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CalendarSyncRequestSourceSubTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Calendar Sync Request Source Type */
            CalendarSyncRequestSourceType = new DwItemRelationship('CalendarSyncRequestSourceType|CalendarSyncRequestSourceSubType|CalendarSyncRequestSourceTypeId', 'CalendarSyncRequestSourceType', 'CalendarSyncRequestSourceType');
            /** Relation: Calendar Sync Request */
            CalendarSyncRequest = new DwItemRelationship('CalendarSyncRequestSourceSubType|CalendarSyncRequest|CalendarSyncRequestSourceSubTypeId', 'CalendarSyncRequest', 'CalendarSyncRequest');
    };
export class CalendarSyncRequestSourceTypeMetaData implements DwItem2<CalendarSyncRequestSourceTypeEntity, CalendarSyncRequestSourceTypeMetaDataAttributes,CalendarSyncRequestSourceTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2349;
        this.ItemDetail.itemName='CalendarSyncRequestSourceType';
        this.ItemDetail.keyName='CalendarSyncRequestSourceTypeId';
    }

    CreateEntity(): CalendarSyncRequestSourceTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CalendarSyncRequestSourceTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CalendarSyncRequestSourceTypeEntity, CalendarSyncRequestSourceTypeMetaDataAttributes,CalendarSyncRequestSourceTypeMetaDataRelations>(query, this);
    }
     Attributes = new CalendarSyncRequestSourceTypeMetaDataAttributes();
     Relations = new CalendarSyncRequestSourceTypeMetaDataRelations();

}


export type CalendarSyncRequestSourceTypeQueryBuilder = DwQueryBuilderGen<CalendarSyncRequestSourceTypeEntity, CalendarSyncRequestSourceTypeMetaDataAttributes,CalendarSyncRequestSourceTypeMetaDataRelations>


export class CalendarSyncRequestSourceTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CalendarSyncRequestSourceType';
    // Attributes
    CalendarSyncRequestSourceTypeId = new DwItemAttribute(this.i, 'CalendarSyncRequestSourceTypeId');
    CalendarSyncRequestSourceType = new DwItemAttribute(this.i, 'CalendarSyncRequestSourceType');
    CalendarSyncRequestSourceTypeMeaning = new DwItemAttribute(this.i, 'CalendarSyncRequestSourceTypeMeaning');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CalendarSyncRequestSourceTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Calendar Sync Request */
            CalendarSyncRequest = new DwItemRelationship('CalendarSyncRequestSourceType|CalendarSyncRequest|CalendarSyncRequestSourceTypeId', 'CalendarSyncRequest', 'CalendarSyncRequest');
            /** Relation: Calendar Sync Request Source Sub Type */
            CalendarSyncRequestSourceSubType = new DwItemRelationship('CalendarSyncRequestSourceType|CalendarSyncRequestSourceSubType|CalendarSyncRequestSourceTypeId', 'CalendarSyncRequestSourceSubType', 'CalendarSyncRequestSourceSubType');
    };
export class CalendarSyncRequestStatusMetaData implements DwItem2<CalendarSyncRequestStatusEntity, CalendarSyncRequestStatusMetaDataAttributes,CalendarSyncRequestStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2352;
        this.ItemDetail.itemName='CalendarSyncRequestStatus';
        this.ItemDetail.keyName='CalendarSyncRequestStatusId';
    }

    CreateEntity(): CalendarSyncRequestStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CalendarSyncRequestStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CalendarSyncRequestStatusEntity, CalendarSyncRequestStatusMetaDataAttributes,CalendarSyncRequestStatusMetaDataRelations>(query, this);
    }
     Attributes = new CalendarSyncRequestStatusMetaDataAttributes();
     Relations = new CalendarSyncRequestStatusMetaDataRelations();

}


export type CalendarSyncRequestStatusQueryBuilder = DwQueryBuilderGen<CalendarSyncRequestStatusEntity, CalendarSyncRequestStatusMetaDataAttributes,CalendarSyncRequestStatusMetaDataRelations>


export class CalendarSyncRequestStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CalendarSyncRequestStatus';
    // Attributes
    CalendarSyncRequestStatusId = new DwItemAttribute(this.i, 'CalendarSyncRequestStatusId');
    CalendarSyncRequestStatus = new DwItemAttribute(this.i, 'CalendarSyncRequestStatus');
    CalendarSyncRequestStatusMeaning = new DwItemAttribute(this.i, 'CalendarSyncRequestStatusMeaning');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CalendarSyncRequestStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Calendar Sync Request */
            CalendarSyncRequest = new DwItemRelationship('CalendarSyncRequestStatus|CalendarSyncRequest|CalendarSyncRequestStatusId', 'CalendarSyncRequest', 'CalendarSyncRequest');
    };
export class CheckRideAISummaryMetaData implements DwItem2<CheckRideAISummaryEntity, CheckRideAISummaryMetaDataAttributes,CheckRideAISummaryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2327;
        this.ItemDetail.itemName='CheckRideAISummary';
        this.ItemDetail.keyName='CheckRideAISummaryId';
    }

    CreateEntity(): CheckRideAISummaryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideAISummaryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideAISummaryEntity, CheckRideAISummaryMetaDataAttributes,CheckRideAISummaryMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideAISummaryMetaDataAttributes();
     Relations = new CheckRideAISummaryMetaDataRelations();

}


export type CheckRideAISummaryQueryBuilder = DwQueryBuilderGen<CheckRideAISummaryEntity, CheckRideAISummaryMetaDataAttributes,CheckRideAISummaryMetaDataRelations>


export class CheckRideAISummaryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideAISummary';
    // Attributes
    CheckRideAISummaryId = new DwItemAttribute(this.i, 'CheckRideAISummaryId');
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    PlanOfActionId = new DwItemAttribute(this.i, 'PlanOfActionId');
    CheckRideAISummaryStatusId = new DwItemAttribute(this.i, 'CheckRideAISummaryStatusId');
    AIPromptRequestId = new DwItemAttribute(this.i, 'AIPromptRequestId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    SummaryHeading = new DwItemAttribute(this.i, 'SummaryHeading');
    SummaryFull = new DwItemAttribute(this.i, 'SummaryFull');
    SummaryIssues = new DwItemAttribute(this.i, 'SummaryIssues');
}

class CheckRideAISummaryMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Ai Prompt Request - Ai Prompt Request */
            DwAiPromptRequestByAIPromptRequestId = new DwItemRelationship('dw_AiPromptRequest|CheckRideAISummary|AIPromptRequestId', 'AIPromptRequestIdDwAiPromptRequest', 'AIPromptRequestIdDwAiPromptRequest');
            /** Relation: Check Ride A I Summary Status */
            CheckRideAISummaryStatus = new DwItemRelationship('CheckRideAISummaryStatus|CheckRideAISummary|CheckRideAISummaryStatusId', 'CheckRideAISummaryStatus', 'CheckRideAISummaryStatus');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('CheckRideRequest|CheckRideAISummary|CheckRideRequestId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('PlanOfAction|CheckRideAISummary|PlanOfActionId', 'PlanOfAction', 'PlanOfAction');
    };
export class CheckRideAISummaryStatusMetaData implements DwItem2<CheckRideAISummaryStatusEntity, CheckRideAISummaryStatusMetaDataAttributes,CheckRideAISummaryStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2328;
        this.ItemDetail.itemName='CheckRideAISummaryStatus';
        this.ItemDetail.keyName='CheckRideAISummaryStatusId';
    }

    CreateEntity(): CheckRideAISummaryStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideAISummaryStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideAISummaryStatusEntity, CheckRideAISummaryStatusMetaDataAttributes,CheckRideAISummaryStatusMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideAISummaryStatusMetaDataAttributes();
     Relations = new CheckRideAISummaryStatusMetaDataRelations();

}


export type CheckRideAISummaryStatusQueryBuilder = DwQueryBuilderGen<CheckRideAISummaryStatusEntity, CheckRideAISummaryStatusMetaDataAttributes,CheckRideAISummaryStatusMetaDataRelations>


export class CheckRideAISummaryStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideAISummaryStatus';
    // Attributes
    CheckRideAISummaryStatusId = new DwItemAttribute(this.i, 'CheckRideAISummaryStatusId');
    CheckRideAISummaryStatus = new DwItemAttribute(this.i, 'CheckRideAISummaryStatus');
}

class CheckRideAISummaryStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Post Exam AI Summary */
            CheckRideAISummary = new DwItemRelationship('CheckRideAISummaryStatus|CheckRideAISummary|CheckRideAISummaryStatusId', 'CheckRideAISummary', 'CheckRideAISummary');
    };
export class CheckRideApplicantTypeMetaData implements DwItem2<CheckRideApplicantTypeEntity, CheckRideApplicantTypeMetaDataAttributes,CheckRideApplicantTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1183;
        this.ItemDetail.itemName='CheckRideApplicantType';
        this.ItemDetail.keyName='CheckRideApplicantTypeId';
    }

    CreateEntity(): CheckRideApplicantTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideApplicantTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideApplicantTypeEntity, CheckRideApplicantTypeMetaDataAttributes,CheckRideApplicantTypeMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideApplicantTypeMetaDataAttributes();
     Relations = new CheckRideApplicantTypeMetaDataRelations();

}


export type CheckRideApplicantTypeQueryBuilder = DwQueryBuilderGen<CheckRideApplicantTypeEntity, CheckRideApplicantTypeMetaDataAttributes,CheckRideApplicantTypeMetaDataRelations>


export class CheckRideApplicantTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideApplicantType';
    // Attributes
    CheckRideApplicantTypeId = new DwItemAttribute(this.i, 'CheckRideApplicantTypeId');
    ApplicantType = new DwItemAttribute(this.i, 'ApplicantType');
}

class CheckRideApplicantTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Applicant Wait List */
            ApplicantPlaceholder = new DwItemRelationship('CheckRideApplicantType|ApplicantPlaceholder|CheckRideApplicantTypeId', 'ApplicantPlaceholder', 'ApplicantPlaceholder');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('CheckRideApplicantType|CheckRideRequest|CheckRideApplicantTypeId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('CheckRideApplicantType|PlanOfAction|CheckRideApplicantTypeId', 'PlanOfAction', 'PlanOfAction');
    };
export class CheckRideAvionicTypeMetaData implements DwItem2<CheckRideAvionicTypeEntity, CheckRideAvionicTypeMetaDataAttributes,CheckRideAvionicTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2280;
        this.ItemDetail.itemName='CheckRideAvionicType';
        this.ItemDetail.keyName='CheckRideAvionicTypeId';
    }

    CreateEntity(): CheckRideAvionicTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideAvionicTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideAvionicTypeEntity, CheckRideAvionicTypeMetaDataAttributes,CheckRideAvionicTypeMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideAvionicTypeMetaDataAttributes();
     Relations = new CheckRideAvionicTypeMetaDataRelations();

}


export type CheckRideAvionicTypeQueryBuilder = DwQueryBuilderGen<CheckRideAvionicTypeEntity, CheckRideAvionicTypeMetaDataAttributes,CheckRideAvionicTypeMetaDataRelations>


export class CheckRideAvionicTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideAvionicType';
    // Attributes
    CheckRideAvionicTypeId = new DwItemAttribute(this.i, 'CheckRideAvionicTypeId');
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    AvionicTypeId = new DwItemAttribute(this.i, 'AvionicTypeId');
}

class CheckRideAvionicTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Avionic Type */
            AvionicType = new DwItemRelationship('AvionicType|CheckRideAvionicType|AvionicTypeId', 'AvionicType', 'AvionicType');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('CheckRideRequest|CheckRideAvionicType|CheckRideRequestId', 'CheckRideRequest', 'CheckRideRequest');
    };
export class CheckRideCancellationTypeMetaData implements DwItem2<CheckRideCancellationTypeEntity, CheckRideCancellationTypeMetaDataAttributes,CheckRideCancellationTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1189;
        this.ItemDetail.itemName='CheckRideCancellationType';
        this.ItemDetail.keyName='CheckRideCancellationTypeId';
    }

    CreateEntity(): CheckRideCancellationTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideCancellationTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideCancellationTypeEntity, CheckRideCancellationTypeMetaDataAttributes,CheckRideCancellationTypeMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideCancellationTypeMetaDataAttributes();
     Relations = new CheckRideCancellationTypeMetaDataRelations();

}


export type CheckRideCancellationTypeQueryBuilder = DwQueryBuilderGen<CheckRideCancellationTypeEntity, CheckRideCancellationTypeMetaDataAttributes,CheckRideCancellationTypeMetaDataRelations>


export class CheckRideCancellationTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideCancellationType';
    // Attributes
    CheckRideCancellationTypeId = new DwItemAttribute(this.i, 'CheckRideCancellationTypeId');
    CancellationTypeDisplay = new DwItemAttribute(this.i, 'CancellationTypeDisplay');
    CancelOrder = new DwItemAttribute(this.i, 'CancelOrder');
}

class CheckRideCancellationTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('CheckRideRequestCancelType|CheckRideRequest|CheckRideCancellationTypeId', 'CheckRideRequest', 'CheckRideRequest');
    };
export class CheckRideExaminerTypeMetaData implements DwItem2<CheckRideExaminerTypeEntity, CheckRideExaminerTypeMetaDataAttributes,CheckRideExaminerTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1265;
        this.ItemDetail.itemName='CheckRideExaminerType';
        this.ItemDetail.keyName='CheckRideExaminerTypeId';
    }

    CreateEntity(): CheckRideExaminerTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideExaminerTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideExaminerTypeEntity, CheckRideExaminerTypeMetaDataAttributes,CheckRideExaminerTypeMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideExaminerTypeMetaDataAttributes();
     Relations = new CheckRideExaminerTypeMetaDataRelations();

}


export type CheckRideExaminerTypeQueryBuilder = DwQueryBuilderGen<CheckRideExaminerTypeEntity, CheckRideExaminerTypeMetaDataAttributes,CheckRideExaminerTypeMetaDataRelations>


export class CheckRideExaminerTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideExaminerType';
    // Attributes
    CheckRideExaminerTypeId = new DwItemAttribute(this.i, 'CheckRideExaminerTypeId');
    CheckRideExaminerType = new DwItemAttribute(this.i, 'CheckRideExaminerType');
}

class CheckRideExaminerTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('CheckRideExaminerType|CheckRideRequest|CheckRideExaminerTypeId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('CheckRideExaminerType|PlanOfAction|CheckRideExaminerTypeId', 'PlanOfAction', 'PlanOfAction');
    };
export class CheckRideGroupMetaData implements DwItem2<CheckRideGroupEntity, CheckRideGroupMetaDataAttributes,CheckRideGroupMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1134;
        this.ItemDetail.itemName='CheckRideGroup';
        this.ItemDetail.keyName='CheckRideGroupId';
    }

    CreateEntity(): CheckRideGroupEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideGroupQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideGroupEntity, CheckRideGroupMetaDataAttributes,CheckRideGroupMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideGroupMetaDataAttributes();
     Relations = new CheckRideGroupMetaDataRelations();

}


export type CheckRideGroupQueryBuilder = DwQueryBuilderGen<CheckRideGroupEntity, CheckRideGroupMetaDataAttributes,CheckRideGroupMetaDataRelations>


export class CheckRideGroupMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideGroup';
    // Attributes
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    CheckRideGroup = new DwItemAttribute(this.i, 'CheckRideGroup');
    GroupOrder = new DwItemAttribute(this.i, 'GroupOrder');
}

class CheckRideGroupMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Aviation Authority */
            AviationAuthority = new DwItemRelationship('AviationAuthority|CheckRideGroup|AviationAuthorityId', 'AviationAuthority', 'AviationAuthority');
            /** Relation: ACS Test */
            AcsTest = new DwItemRelationship('CheckRideGroup|AcsTest|CheckRideGroupId', 'AcsTest', 'AcsTest');
            /** Relation: Applicant Wait List */
            ApplicantPlaceholder = new DwItemRelationship('CheckRideGroup|ApplicantPlaceholder|CheckRideGroupId', 'ApplicantPlaceholder', 'ApplicantPlaceholder');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('CheckRideGroup|CheckRideRequest|CheckRideGroupId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Check Ride Request Pilot Certificate */
            CheckRideRequestPilotCertificate = new DwItemRelationship('CheckRideGroup|CheckRideRequestPilotCertificate|CheckRideGroupId', 'CheckRideRequestPilotCertificate', 'CheckRideRequestPilotCertificate');
            /** Relation: Exam Type */
            CheckRideScenario = new DwItemRelationship('CheckRideGroup|CheckRideScenario|CheckRideGroupId', 'CheckRideScenario', 'CheckRideScenario');
            /** Relation: Checkride Type */
            CheckRideType = new DwItemRelationship('CheckRideGroup|CheckRideType|CheckRideGroupId', 'CheckRideType', 'CheckRideType');
            /** Relation: Flight School Applicant */
            FlightSchoolApplicant = new DwItemRelationship('CheckRideGroup|FlightSchoolApplicant|CheckRideGroupId', 'FlightSchoolApplicant', 'FlightSchoolApplicant');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('CheckRideGroup|PlanOfAction|CheckRideGroupId', 'PlanOfAction', 'PlanOfAction');
    };
export class CheckRideInstructorTypeMetaData implements DwItem2<CheckRideInstructorTypeEntity, CheckRideInstructorTypeMetaDataAttributes,CheckRideInstructorTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2347;
        this.ItemDetail.itemName='CheckRideInstructorType';
        this.ItemDetail.keyName='CheckRideInstructorTypeId';
    }

    CreateEntity(): CheckRideInstructorTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideInstructorTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideInstructorTypeEntity, CheckRideInstructorTypeMetaDataAttributes,CheckRideInstructorTypeMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideInstructorTypeMetaDataAttributes();
     Relations = new CheckRideInstructorTypeMetaDataRelations();

}


export type CheckRideInstructorTypeQueryBuilder = DwQueryBuilderGen<CheckRideInstructorTypeEntity, CheckRideInstructorTypeMetaDataAttributes,CheckRideInstructorTypeMetaDataRelations>


export class CheckRideInstructorTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideInstructorType';
    // Attributes
    CheckRideInstructorTypeId = new DwItemAttribute(this.i, 'CheckRideInstructorTypeId');
    CheckRideInstructorType = new DwItemAttribute(this.i, 'CheckRideInstructorType');
}

class CheckRideInstructorTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('ApplicantAcsWrittenResult|CheckRideRequest|PrecheckApplicantAcsWrittenResultId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Flight School Applicant */
            FlightSchoolApplicant = new DwItemRelationship('CheckRideInstructorType|FlightSchoolApplicant|CheckRideInstructorTypeId', 'FlightSchoolApplicant', 'FlightSchoolApplicant');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('CheckRideInstructorType|PlanOfAction|CheckRideInstructorTypeId', 'PlanOfAction', 'PlanOfAction');
    };
export class CheckRideOutcomeMetaData implements DwItem2<CheckRideOutcomeEntity, CheckRideOutcomeMetaDataAttributes,CheckRideOutcomeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1148;
        this.ItemDetail.itemName='CheckRideOutcome';
        this.ItemDetail.keyName='CheckRideOutcomeId';
    }

    CreateEntity(): CheckRideOutcomeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideOutcomeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideOutcomeEntity, CheckRideOutcomeMetaDataAttributes,CheckRideOutcomeMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideOutcomeMetaDataAttributes();
     Relations = new CheckRideOutcomeMetaDataRelations();

}


export type CheckRideOutcomeQueryBuilder = DwQueryBuilderGen<CheckRideOutcomeEntity, CheckRideOutcomeMetaDataAttributes,CheckRideOutcomeMetaDataRelations>


export class CheckRideOutcomeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideOutcome';
    // Attributes
    CheckRideOutcomeId = new DwItemAttribute(this.i, 'CheckRideOutcomeId');
    CheckRideOutcome = new DwItemAttribute(this.i, 'CheckRideOutcome');
    AllowRetest = new DwItemAttribute(this.i, 'AllowRetest');
    IsStageCheckOutcome = new DwItemAttribute(this.i, 'IsStageCheckOutcome');
    AllowFlagStudent = new DwItemAttribute(this.i, 'AllowFlagStudent');
    IsIncomplete = new DwItemAttribute(this.i, 'IsIncomplete');
}

class CheckRideOutcomeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Result */
            CheckRideResult = new DwItemRelationship('CheckRideOutcome|CheckRideResult|CheckRideOutcomeId', 'CheckRideResult', 'CheckRideResult');
            /** Relation: Plan Of Action Result */
            PlanOfActionResult = new DwItemRelationship('CheckRideOutcome|PlanOfActionResult|CheckRideOutcomeId', 'PlanOfActionResult', 'PlanOfActionResult');
    };
export class CheckRideOwnershipTypeMetaData implements DwItem2<CheckRideOwnershipTypeEntity, CheckRideOwnershipTypeMetaDataAttributes,CheckRideOwnershipTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1266;
        this.ItemDetail.itemName='CheckRideOwnershipType';
        this.ItemDetail.keyName='CheckRideOwnershipTypeId';
    }

    CreateEntity(): CheckRideOwnershipTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideOwnershipTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideOwnershipTypeEntity, CheckRideOwnershipTypeMetaDataAttributes,CheckRideOwnershipTypeMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideOwnershipTypeMetaDataAttributes();
     Relations = new CheckRideOwnershipTypeMetaDataRelations();

}


export type CheckRideOwnershipTypeQueryBuilder = DwQueryBuilderGen<CheckRideOwnershipTypeEntity, CheckRideOwnershipTypeMetaDataAttributes,CheckRideOwnershipTypeMetaDataRelations>


export class CheckRideOwnershipTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideOwnershipType';
    // Attributes
    CheckRideOwnershipTypeId = new DwItemAttribute(this.i, 'CheckRideOwnershipTypeId');
    CheckRideOwnershipType = new DwItemAttribute(this.i, 'CheckRideOwnershipType');
}

class CheckRideOwnershipTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('CheckRideOwnershipType|CheckRideRequest|CheckRideOwnershipTypeId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('CheckRideOwnershipType|PlanOfAction|CheckRideOwnershipTypeId', 'PlanOfAction', 'PlanOfAction');
            /** Relation: Question Bank */
            QuestionBank = new DwItemRelationship('CheckRideOwnershipType|QuestionBank|CheckRideOwnershipTypeId', 'QuestionBank', 'QuestionBank');
            /** Relation: Schedule Block - Ownership Type - Many */
            ScheduleBlockByOwnershipTypeId = new DwItemRelationship('CheckRideOwnershipType|ScheduleBlock|OwnershipTypeId', 'OwnershipTypeIdScheduleBlock', 'OwnershipTypeIdScheduleBlock');
            /** Relation: Training Record - Ownership Type - Many */
            TrainingRecordByOwnershipTypeId = new DwItemRelationship('CheckRideOwnershipType|TrainingRecord|OwnershipTypeId', 'OwnershipTypeIdTrainingRecord', 'OwnershipTypeIdTrainingRecord');
    };
export class CheckRidePaymentMetaData implements DwItem2<CheckRidePaymentEntity, CheckRidePaymentMetaDataAttributes,CheckRidePaymentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1152;
        this.ItemDetail.itemName='CheckRidePayment';
        this.ItemDetail.keyName='CheckRidePaymentId';
    }

    CreateEntity(): CheckRidePaymentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRidePaymentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRidePaymentEntity, CheckRidePaymentMetaDataAttributes,CheckRidePaymentMetaDataRelations>(query, this);
    }
     Attributes = new CheckRidePaymentMetaDataAttributes();
     Relations = new CheckRidePaymentMetaDataRelations();

}


export type CheckRidePaymentQueryBuilder = DwQueryBuilderGen<CheckRidePaymentEntity, CheckRidePaymentMetaDataAttributes,CheckRidePaymentMetaDataRelations>


export class CheckRidePaymentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRidePayment';
    // Attributes
    CheckRidePaymentId = new DwItemAttribute(this.i, 'CheckRidePaymentId');
    PaymentTypeId = new DwItemAttribute(this.i, 'PaymentTypeId');
    PaymentMethodId = new DwItemAttribute(this.i, 'PaymentMethodId');
    PaymentDateTime = new DwItemAttribute(this.i, 'PaymentDateTime');
    PaymentAmount = new DwItemAttribute(this.i, 'PaymentAmount');
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    PaymentReferenceId = new DwItemAttribute(this.i, 'PaymentReferenceId');
    PaymentReferenceText = new DwItemAttribute(this.i, 'PaymentReferenceText');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    PaymentDiscountid = new DwItemAttribute(this.i, 'PaymentDiscountid');
    PaymentPartyId = new DwItemAttribute(this.i, 'PaymentPartyId');
    EmailCCReceipt = new DwItemAttribute(this.i, 'EmailCCReceipt');
}

class CheckRidePaymentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('CheckRideRequest|CheckRidePayment|CheckRideRequestId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Check Ride Request Payment Party - Payment Party */
            CheckRideRequestPaymentPartyByPaymentPartyId = new DwItemRelationship('CheckRideRequestPaymentParty|CheckRidePayment|PaymentPartyId', 'PaymentPartyIdCheckRideRequestPaymentParty', 'PaymentPartyIdCheckRideRequestPaymentParty');
            /** Relation: Payment Discount Code - Payment Discount */
            PaymentDiscountCodeByPaymentDiscountid = new DwItemRelationship('PaymentDiscountCode|CheckRidePayment|PaymentDiscountid', 'PaymentDiscountidPaymentDiscountCode', 'PaymentDiscountidPaymentDiscountCode');
            /** Relation: Payment Method */
            PaymentMethod = new DwItemRelationship('PaymentMethod|CheckRidePayment|PaymentMethodId', 'PaymentMethod', 'PaymentMethod');
            /** Relation: Payment Reference */
            PaymentReference = new DwItemRelationship('PaymentReference|CheckRidePayment|PaymentReferenceId', 'PaymentReference', 'PaymentReference');
            /** Relation: Payment Type */
            PaymentType = new DwItemRelationship('PaymentType|CheckRidePayment|PaymentTypeId', 'PaymentType', 'PaymentType');
            /** Relation: Checkride Request - Checkride Payment Id - Many */
            CheckRideRequestByPilexosBookingCheckRidePaymentId = new DwItemRelationship('CheckRidePayment|CheckRideRequest|PilexosBookingCheckRidePaymentId', 'PilexosBookingCheckRideRequest', 'PilexosBookingCheckRideRequest');
            /** Relation: Payment Attempt */
            PaymentAttempt = new DwItemRelationship('CheckRidePayment|PaymentAttempt|CheckRidePaymentId', 'PaymentAttempt', 'PaymentAttempt');
    };
export class CheckRideRequestMetaData implements DwItem2<CheckRideRequestEntity, CheckRideRequestMetaDataAttributes,CheckRideRequestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1153;
        this.ItemDetail.itemName='CheckRideRequest';
        this.ItemDetail.keyName='CheckRideRequestId';
    }

    CreateEntity(): CheckRideRequestEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideRequestQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideRequestEntity, CheckRideRequestMetaDataAttributes,CheckRideRequestMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideRequestMetaDataAttributes();
     Relations = new CheckRideRequestMetaDataRelations();

}


export type CheckRideRequestQueryBuilder = DwQueryBuilderGen<CheckRideRequestEntity, CheckRideRequestMetaDataAttributes,CheckRideRequestMetaDataRelations>


export class CheckRideRequestMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideRequest';
    // Attributes
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    StudentApplicantId = new DwItemAttribute(this.i, 'StudentApplicantId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    CheckRideTypeId = new DwItemAttribute(this.i, 'CheckRideTypeId');
    CheckRideTestTypeId = new DwItemAttribute(this.i, 'CheckRideTestTypeId');
    PilotCertificateNumber = new DwItemAttribute(this.i, 'PilotCertificateNumber');
    CheckRideRequestSubStatusId = new DwItemAttribute(this.i, 'CheckRideRequestSubStatusId');
    PreferredDateTime = new DwItemAttribute(this.i, 'PreferredDateTime');
    ScheduledTimeMinutes = new DwItemAttribute(this.i, 'ScheduledTimeMinutes');
    ScheduledPilotExaminerId = new DwItemAttribute(this.i, 'ScheduledPilotExaminerId');
    ScheduledPreTimeMinutes = new DwItemAttribute(this.i, 'ScheduledPreTimeMinutes');
    ScheduledPostTimeMinutes = new DwItemAttribute(this.i, 'ScheduledPostTimeMinutes');
    AuthorityPreCheckRideNumber = new DwItemAttribute(this.i, 'AuthorityPreCheckRideNumber');
    AirplaneMakeModel = new DwItemAttribute(this.i, 'AirplaneMakeModel');
    AirplaneNNumber = new DwItemAttribute(this.i, 'AirplaneNNumber');
    DocumentsMediaGroupId = new DwItemAttribute(this.i, 'DocumentsMediaGroupId');
    AuthorityPreapprovalCode = new DwItemAttribute(this.i, 'AuthorityPreapprovalCode');
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    CancellationNotes = new DwItemAttribute(this.i, 'CancellationNotes');
    PreferredAirportId = new DwItemAttribute(this.i, 'PreferredAirportId');
    ScheduledAirportId = new DwItemAttribute(this.i, 'ScheduledAirportId');
    ScheduledDateTime = new DwItemAttribute(this.i, 'ScheduledDateTime');
    ScheduledCheckRideScenarioId = new DwItemAttribute(this.i, 'ScheduledCheckRideScenarioId');
    MedicalCertificateMediaId = new DwItemAttribute(this.i, 'MedicalCertificateMediaId');
    LogBookMediaId = new DwItemAttribute(this.i, 'LogBookMediaId');
    AdditionalDocumentationNotes = new DwItemAttribute(this.i, 'AdditionalDocumentationNotes');
    TrainingMediaId = new DwItemAttribute(this.i, 'TrainingMediaId');
    ScheduledCalendarEventReferenceId = new DwItemAttribute(this.i, 'ScheduledCalendarEventReferenceId');
    EndorsedAndCheckRideReady = new DwItemAttribute(this.i, 'EndorsedAndCheckRideReady');
    ScheduledPilotExaminerLocationId = new DwItemAttribute(this.i, 'ScheduledPilotExaminerLocationId');
    ProposedDateTime = new DwItemAttribute(this.i, 'ProposedDateTime');
    ProposedAirportId = new DwItemAttribute(this.i, 'ProposedAirportId');
    ProposedTimeMinutes = new DwItemAttribute(this.i, 'ProposedTimeMinutes');
    ProposedCalendarEventReferenceId = new DwItemAttribute(this.i, 'ProposedCalendarEventReferenceId');
    ScheduledCheckRideCost = new DwItemAttribute(this.i, 'ScheduledCheckRideCost');
    AdditionalTravelCost = new DwItemAttribute(this.i, 'AdditionalTravelCost');
    PilexosBookingCost = new DwItemAttribute(this.i, 'PilexosBookingCost');
    ExaminerBookingCost = new DwItemAttribute(this.i, 'ExaminerBookingCost');
    RejectedNotes = new DwItemAttribute(this.i, 'RejectedNotes');
    MoreInfoRequestedNotes = new DwItemAttribute(this.i, 'MoreInfoRequestedNotes');
    PilexosBookingPaymentAdded = new DwItemAttribute(this.i, 'PilexosBookingPaymentAdded');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    AvaiationTrainingProgramId = new DwItemAttribute(this.i, 'AvaiationTrainingProgramId');
    CheckRideApplicantTypeId = new DwItemAttribute(this.i, 'CheckRideApplicantTypeId');
    StudentApplicantNameManual = new DwItemAttribute(this.i, 'StudentApplicantNameManual');
    StudentApplicantEmailManual = new DwItemAttribute(this.i, 'StudentApplicantEmailManual');
    StudentApplicantPhoneManual = new DwItemAttribute(this.i, 'StudentApplicantPhoneManual');
    ExaminerPrivateNotes = new DwItemAttribute(this.i, 'ExaminerPrivateNotes');
    ExaminerToApplicantNotes = new DwItemAttribute(this.i, 'ExaminerToApplicantNotes');
    ExaminerToApplicantMediaGroupId = new DwItemAttribute(this.i, 'ExaminerToApplicantMediaGroupId');
    IsAirplaneAirworthy = new DwItemAttribute(this.i, 'IsAirplaneAirworthy');
    EmailApplicantReceipt = new DwItemAttribute(this.i, 'EmailApplicantReceipt');
    CheckRideCancellationTypeId = new DwItemAttribute(this.i, 'CheckRideCancellationTypeId');
    CheckRideCancellationTypeOther = new DwItemAttribute(this.i, 'CheckRideCancellationTypeOther');
    PilexosBookingCostPaymentPartyId = new DwItemAttribute(this.i, 'PilexosBookingCostPaymentPartyId');
    FlightSchoolName = new DwItemAttribute(this.i, 'FlightSchoolName');
    EmailCCReceipt = new DwItemAttribute(this.i, 'EmailCCReceipt');
    CancelledRequestBookingFeeRefund = new DwItemAttribute(this.i, 'CancelledRequestBookingFeeRefund');
    PilexosBookingCheckRidePaymentId = new DwItemAttribute(this.i, 'PilexosBookingCheckRidePaymentId');
    ScheduleAirportLocationNotes = new DwItemAttribute(this.i, 'ScheduleAirportLocationNotes');
    AuthorityApprovalCode = new DwItemAttribute(this.i, 'AuthorityApprovalCode');
    FlightInstructorName = new DwItemAttribute(this.i, 'FlightInstructorName');
    ApplicantPlaceholderId = new DwItemAttribute(this.i, 'ApplicantPlaceholderId');
    AddToWaitlist = new DwItemAttribute(this.i, 'AddToWaitlist');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolNameOther = new DwItemAttribute(this.i, 'FlightSchoolNameOther');
    StudentApplicantCitizenshipCountyId = new DwItemAttribute(this.i, 'StudentApplicantCitizenshipCountyId');
    AirmanKnowledgeTestScore = new DwItemAttribute(this.i, 'AirmanKnowledgeTestScore');
    FlightInstructorCertificateNumber = new DwItemAttribute(this.i, 'FlightInstructorCertificateNumber');
    CurrentPilotCertifiateTypeId = new DwItemAttribute(this.i, 'CurrentPilotCertifiateTypeId');
    FlightInstructorEmail = new DwItemAttribute(this.i, 'FlightInstructorEmail');
    FlightInstructorPhone = new DwItemAttribute(this.i, 'FlightInstructorPhone');
    ApplicantAcsWrittenResultId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultId');
    AirmanKnowledgeTestDate = new DwItemAttribute(this.i, 'AirmanKnowledgeTestDate');
    AirmanKnowledgeTestPDFMediaId = new DwItemAttribute(this.i, 'AirmanKnowledgeTestPDFMediaId');
    ExamScenarioNotes = new DwItemAttribute(this.i, 'ExamScenarioNotes');
    FlightSchoolCertificateNumber = new DwItemAttribute(this.i, 'FlightSchoolCertificateNumber');
    CheckRideExaminerTypeId = new DwItemAttribute(this.i, 'CheckRideExaminerTypeId');
    CheckRideOwnershipTypeId = new DwItemAttribute(this.i, 'CheckRideOwnershipTypeId');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    FlightSchoolApplicantId = new DwItemAttribute(this.i, 'FlightSchoolApplicantId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    FlightSchoolBranchId = new DwItemAttribute(this.i, 'FlightSchoolBranchId');
    ForeignPilotMeetsQualifications = new DwItemAttribute(this.i, 'ForeignPilotMeetsQualifications');
    IsGPSWAASEquiped = new DwItemAttribute(this.i, 'IsGPSWAASEquiped');
    AuthorityApplicationNumber = new DwItemAttribute(this.i, 'AuthorityApplicationNumber');
    ElectronicFlightBagTypeId = new DwItemAttribute(this.i, 'ElectronicFlightBagTypeId');
    FlightSchoolInstructorId = new DwItemAttribute(this.i, 'FlightSchoolInstructorId');
    CheckRideAcceptedDateTime = new DwItemAttribute(this.i, 'CheckRideAcceptedDateTime');
    FlightSchoolPrivateNotes = new DwItemAttribute(this.i, 'FlightSchoolPrivateNotes');
    CheckRideWorkflowId = new DwItemAttribute(this.i, 'CheckRideWorkflowId');
    PrimaryTrainingAirportId = new DwItemAttribute(this.i, 'PrimaryTrainingAirportId');
    StudentApplicantStateProvinceId = new DwItemAttribute(this.i, 'StudentApplicantStateProvinceId');
    StudentEndOfCourseDate = new DwItemAttribute(this.i, 'StudentEndOfCourseDate');
    CheckRideExpirationDate = new DwItemAttribute(this.i, 'CheckRideExpirationDate');
    EndorsedDate = new DwItemAttribute(this.i, 'EndorsedDate');
    ExaminerLastSendDateTime = new DwItemAttribute(this.i, 'ExaminerLastSendDateTime');
    SendExaminerCheckrideEmails = new DwItemAttribute(this.i, 'SendExaminerCheckrideEmails');
    AdditionalAirmanKnowledgeTestScore = new DwItemAttribute(this.i, 'AdditionalAirmanKnowledgeTestScore');
    AdditionalAirmanKnowledgeTestDate = new DwItemAttribute(this.i, 'AdditionalAirmanKnowledgeTestDate');
    AdditionalAirmanKnowledgeTestPDFMediaId = new DwItemAttribute(this.i, 'AdditionalAirmanKnowledgeTestPDFMediaId');
    CheckRideInstructorTypeId = new DwItemAttribute(this.i, 'CheckRideInstructorTypeId');
    FlightSchoolTypeId = new DwItemAttribute(this.i, 'FlightSchoolTypeId');
    OdaFlightSchoolId = new DwItemAttribute(this.i, 'OdaFlightSchoolId');
    SendApplicantCheckrideEmails = new DwItemAttribute(this.i, 'SendApplicantCheckrideEmails');
}

class CheckRideRequestMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Airport - Checkride Airport */
            AirportByScheduledAirportId = new DwItemRelationship('Airport|CheckRideRequest|ScheduledAirportId', 'ScheduledAirport', 'ScheduledAirport');
            /** Relation: Airport - Preferred Airport */
            AirportByPreferredAirportId = new DwItemRelationship('Airport|CheckRideRequest|PreferredAirportId', 'PreferredAirport', 'PreferredAirport');
            /** Relation: Airport - Proposed Airport */
            AirportByProposedAirportId = new DwItemRelationship('Airport|CheckRideRequest|ProposedAirportId', 'ProposedAirport', 'ProposedAirport');
            /** Relation: Airport - Primary Training Airport */
            AirportByPrimaryTrainingAirportId = new DwItemRelationship('Airport|CheckRideRequest|PrimaryTrainingAirportId', 'PrimaryTrainingAirport', 'PrimaryTrainingAirport');
            /** Relation: Applicant Acs Written Result */
            ApplicantAcsWrittenResult = new DwItemRelationship('ApplicantAcsWrittenResult|CheckRideRequest|ApplicantAcsWrittenResultId', 'ApplicantAcsWrittenResult', 'ApplicantAcsWrittenResult');
            /** Relation: Applicant Wait List */
            ApplicantPlaceholder = new DwItemRelationship('ApplicantPlaceholder|CheckRideRequest|ApplicantPlaceholderId', 'ApplicantPlaceholder', 'ApplicantPlaceholder');
            /** Relation: Aviation Authority */
            AviationAuthority = new DwItemRelationship('AviationAuthority|CheckRideRequest|AviationAuthorityId', 'AviationAuthority', 'AviationAuthority');
            /** Relation: Aviation Training Program - Program Type */
            AviationTrainingProgramByAvaiationTrainingProgramId = new DwItemRelationship('AviationTrainingProgram|CheckRideRequest|AvaiationTrainingProgramId', 'AvaiationTrainingProgramIdAviationTrainingProgram', 'AvaiationTrainingProgramIdAviationTrainingProgram');
            /** Relation: Calendar Event Reference - Calendar Event Reference */
            CalendarEventReferenceByScheduledCalendarEventReferenceId = new DwItemRelationship('CalendarEventReference|CheckRideRequest|ScheduledCalendarEventReferenceId', 'ScheduledCalendarEventReference', 'ScheduledCalendarEventReference');
            /** Relation: Check Ride Applicant Type */
            CheckRideApplicantType = new DwItemRelationship('CheckRideApplicantType|CheckRideRequest|CheckRideApplicantTypeId', 'CheckRideApplicantType', 'CheckRideApplicantType');
            /** Relation: Check Ride Cancellation Type */
            CheckRideCancellationType = new DwItemRelationship('CheckRideRequestCancelType|CheckRideRequest|CheckRideCancellationTypeId', 'CheckRideCancellationType', 'CheckRideCancellationType');
            /** Relation: Check Ride Examiner Type */
            CheckRideExaminerType = new DwItemRelationship('CheckRideExaminerType|CheckRideRequest|CheckRideExaminerTypeId', 'CheckRideExaminerType', 'CheckRideExaminerType');
            /** Relation: Checkride Group */
            CheckRideGroup = new DwItemRelationship('CheckRideGroup|CheckRideRequest|CheckRideGroupId', 'CheckRideGroup', 'CheckRideGroup');
            /** Relation: Check Ride Instructor Type */
            CheckRideInstructorType = new DwItemRelationship('ApplicantAcsWrittenResult|CheckRideRequest|PrecheckApplicantAcsWrittenResultId', 'CheckRideInstructorType', 'CheckRideInstructorType');
            /** Relation: Check Ride Ownership Type */
            CheckRideOwnershipType = new DwItemRelationship('CheckRideOwnershipType|CheckRideRequest|CheckRideOwnershipTypeId', 'CheckRideOwnershipType', 'CheckRideOwnershipType');
            /** Relation: Checkride Payment - Pilexos Booking Check Ride Payment */
            CheckRidePaymentByPilexosBookingCheckRidePaymentId = new DwItemRelationship('CheckRidePayment|CheckRideRequest|PilexosBookingCheckRidePaymentId', 'PilexosBookingCheckRidePayment', 'PilexosBookingCheckRidePayment');
            /** Relation: Check Ride Request Payment Party - Pilexos Booking Cost Responsible Party */
            CheckRideRequestPaymentPartyByPilexosBookingCostPaymentPartyId = new DwItemRelationship('CheckRideRequestPaymentParty|CheckRideRequest|PilexosBookingCostPaymentPartyId', 'PilexosBookingCostPaymentPartyIdCheckRideRequestPaymentParty', 'PilexosBookingCostPaymentPartyIdCheckRideRequestPaymentParty');
            /** Relation: Checkride Request Sub Status */
            CheckRideRequestSubStatus = new DwItemRelationship('CheckRideRequestSubStatus|CheckRideRequest|CheckRideRequestSubStatusId', 'CheckRideRequestSubStatus', 'CheckRideRequestSubStatus');
            /** Relation: Exam Type - Checkride Exam Type */
            CheckRideScenarioByScheduledCheckRideScenarioId = new DwItemRelationship('CheckRideScenario|CheckRideRequest|ScheduledCheckRideScenarioId', 'ScheduledCheckRideScenario', 'ScheduledCheckRideScenario');
            /** Relation: Checkride Test Type */
            CheckRideTestType = new DwItemRelationship('CheckRideTestType|CheckRideRequest|CheckRideTestTypeId', 'CheckRideTestType', 'CheckRideTestType');
            /** Relation: Checkride Type */
            CheckRideType = new DwItemRelationship('CheckRideType|CheckRideRequest|CheckRideTypeId', 'CheckRideType', 'CheckRideType');
            /** Relation: Check Ride Workflow */
            CheckRideWorkflow = new DwItemRelationship('CheckRideWorkflow|CheckRideRequest|CheckRideWorkflowId', 'CheckRideWorkflow', 'CheckRideWorkflow');
            /** Relation: Country - Applicant Citizenship */
            CountryByStudentApplicantCitizenshipCountyId = new DwItemRelationship('Country|CheckRideRequest|StudentApplicantCitizenshipCountyId', 'StudentApplicantCitizenshipCountyIdCountry', 'StudentApplicantCitizenshipCountyIdCountry');
            /** Relation: Electronic Flight Bag Type */
            ElectronicFlightBagType = new DwItemRelationship('ElectronicFlightBagType|CheckRideRequest|ElectronicFlightBagTypeId', 'ElectronicFlightBagType', 'ElectronicFlightBagType');
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|CheckRideRequest|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Flight School - Oda Flight School */
            FlightSchoolByOdaFlightSchoolId = new DwItemRelationship('FlightSchool|CheckRideRequest|OdaFlightSchoolId', 'OdaFlightSchool', 'OdaFlightSchool');
            /** Relation: Flight School Applicant */
            FlightSchoolApplicant = new DwItemRelationship('FlightSchoolApplicant|CheckRideRequest|FlightSchoolApplicantId', 'FlightSchoolApplicant', 'FlightSchoolApplicant');
            /** Relation: Flight School Branch */
            FlightSchoolBranch = new DwItemRelationship('FlightSchoolBranch|CheckRideRequest|FlightSchoolBranchId', 'FlightSchoolBranch', 'FlightSchoolBranch');
            /** Relation: Flight School Examiner */
            FlightSchoolExaminer = new DwItemRelationship('FlightSchoolExaminer|CheckRideRequest|FlightSchoolExaminerId', 'FlightSchoolExaminer', 'FlightSchoolExaminer');
            /** Relation: Flight School Instructor */
            FlightSchoolInstructor = new DwItemRelationship('FlightSchoolInstructor|CheckRideRequest|FlightSchoolInstructorId', 'FlightSchoolInstructor', 'FlightSchoolInstructor');
            /** Relation: Flight School Organization */
            FlightSchoolOrganization = new DwItemRelationship('FlightSchoolOrganization|CheckRideRequest|FlightSchoolOrganizationId', 'FlightSchoolOrganization', 'FlightSchoolOrganization');
            /** Relation: Flight School Type */
            FlightSchoolType = new DwItemRelationship('FlightSchoolType|CheckRideRequest|FlightSchoolTypeId', 'FlightSchoolType', 'FlightSchoolType');
            /** Relation: Media Group - Documents Media Group */
            DwMediaGroupByDocumentsMediaGroupId = new DwItemRelationship('dw_MediaGroup|CheckRideRequest|DocumentsMediaGroupId', 'DocumentsDwMediaGroup', 'DocumentsDwMediaGroup');
            /** Relation: Pilot Certificate Type - Current Pilot Certifiate Type */
            PilotCertificateTypeByCurrentPilotCertifiateTypeId = new DwItemRelationship('PilotCertificateType|CheckRideRequest|CurrentPilotCertifiateTypeId', 'CurrentPilotCertifiateTypeIdPilotCertificateType', 'CurrentPilotCertifiateTypeIdPilotCertificateType');
            /** Relation: Pilot Examiner - Assigned Pilot Examiner */
            PilotExaminerByScheduledPilotExaminerId = new DwItemRelationship('PilotExaminer|CheckRideRequest|ScheduledPilotExaminerId', 'ScheduledPilotExaminer', 'ScheduledPilotExaminer');
            /** Relation: Pilot Examiner Location - Assigned Pilot Examiner Location */
            PilotExaminerLocationByScheduledPilotExaminerLocationId = new DwItemRelationship('PilotExaminerLocation|CheckRideRequest|ScheduledPilotExaminerLocationId', 'ScheduledPilotExaminerLocation', 'ScheduledPilotExaminerLocation');
            /** Relation: State Province - Student Applicant State Province */
            StateProvinceByStudentApplicantStateProvinceId = new DwItemRelationship('StateProvince|CheckRideRequest|StudentApplicantStateProvinceId', 'StudentApplicantStateProvince', 'StudentApplicantStateProvince');
            /** Relation: Student Applicant */
            StudentApplicant = new DwItemRelationship('StudentApplicant|CheckRideRequest|StudentApplicantId', 'StudentApplicant', 'StudentApplicant');
            /** Relation: Post Exam AI Summary */
            CheckRideAISummary = new DwItemRelationship('CheckRideRequest|CheckRideAISummary|CheckRideRequestId', 'CheckRideAISummary', 'CheckRideAISummary');
            /** Relation: Check Ride Avionic Type */
            CheckRideAvionicType = new DwItemRelationship('CheckRideRequest|CheckRideAvionicType|CheckRideRequestId', 'CheckRideAvionicType', 'CheckRideAvionicType');
            /** Relation: Checkride Payment */
            CheckRidePayment = new DwItemRelationship('CheckRideRequest|CheckRidePayment|CheckRideRequestId', 'CheckRidePayment', 'CheckRidePayment');
            /** Relation: Check Ride Request Note */
            CheckRideRequestNote = new DwItemRelationship('CheckRideRequest|CheckRideRequestNote|CheckRideRequestId', 'CheckRideRequestNote', 'CheckRideRequestNote');
            /** Relation: Check Ride Request Pilot Certificate */
            CheckRideRequestPilotCertificate = new DwItemRelationship('CheckRideRequest|CheckRideRequestPilotCertificate|CheckRideRequestId', 'CheckRideRequestPilotCertificate', 'CheckRideRequestPilotCertificate');
            /** Relation: Checkride Result */
            CheckRideResult = new DwItemRelationship('CheckRideRequest|CheckRideResult|CheckRideRequestId', 'CheckRideResult', 'CheckRideResult');
            /** Relation: Check Ride Schedule Hold */
            CheckRideScheduleHold = new DwItemRelationship('CheckRideRequest|CheckRideScheduleHold|CheckRideRequestId', 'CheckRideScheduleHold', 'CheckRideScheduleHold');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('CheckRideRequest|PlanOfAction|CheckRideRequestId', 'PlanOfAction', 'PlanOfAction');
            /** Relation: Ro Checkride Aggregate Util - Checkride Request Id */
            RoCheckrideAggregateUtilByCheckrideRequestId = new DwItemRelationship('CheckRideRequest|roCheckRideAggregateUtil|CheckRideRequestId', 'CheckrideRequestIdRoCheckrideAggregateUtil', 'CheckrideRequestIdRoCheckrideAggregateUtil');
            /** Relation: Ro Checkride Applicant Final Name */
            RoCheckrideApplicantFinalName = new DwItemRelationship('CheckRideRequest|roCheckRideApplicanetFinalName|CheckRideRequestId', 'RoCheckrideApplicantFinalName', 'RoCheckrideApplicantFinalName');
            /** Relation: Ro Check Ride Request Applicant */
            RoCheckRideRequestApplicant = new DwItemRelationship('CheckrideRequest|RoCheckRideRequestApplicant|CheckrideRequestId', 'RoCheckRideRequestApplicant', 'RoCheckRideRequestApplicant');
            /** Relation: Ro Checkride Request Schedule Date Info - Checkride Request Id */
            RoCheckrideRequestScheduleDateInfoByCheckrideRequestId = new DwItemRelationship('CheckrideRequest|roCheckrideRequestScheduleDateInfo|CheckRideRequestId', 'CheckrideRequestIdRoCheckrideRequestScheduleDateInfo', 'CheckrideRequestIdRoCheckrideRequestScheduleDateInfo');
    };
export class CheckRideRequestNoteMetaData implements DwItem2<CheckRideRequestNoteEntity, CheckRideRequestNoteMetaDataAttributes,CheckRideRequestNoteMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1239;
        this.ItemDetail.itemName='CheckRideRequestNote';
        this.ItemDetail.keyName='CheckRideRequestNoteId';
    }

    CreateEntity(): CheckRideRequestNoteEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideRequestNoteQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideRequestNoteEntity, CheckRideRequestNoteMetaDataAttributes,CheckRideRequestNoteMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideRequestNoteMetaDataAttributes();
     Relations = new CheckRideRequestNoteMetaDataRelations();

}


export type CheckRideRequestNoteQueryBuilder = DwQueryBuilderGen<CheckRideRequestNoteEntity, CheckRideRequestNoteMetaDataAttributes,CheckRideRequestNoteMetaDataRelations>


export class CheckRideRequestNoteMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideRequestNote';
    // Attributes
    CheckRideRequestNoteId = new DwItemAttribute(this.i, 'CheckRideRequestNoteId');
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    NoteContent = new DwItemAttribute(this.i, 'NoteContent');
}

class CheckRideRequestNoteMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('CheckRideRequest|CheckRideRequestNote|CheckRideRequestId', 'CheckRideRequest', 'CheckRideRequest');
    };
export class CheckRideRequestPaymentPartyMetaData implements DwItem2<CheckRideRequestPaymentPartyEntity, CheckRideRequestPaymentPartyMetaDataAttributes,CheckRideRequestPaymentPartyMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1190;
        this.ItemDetail.itemName='CheckRideRequestPaymentParty';
        this.ItemDetail.keyName='CheckRideRequestPaymentPartyId';
    }

    CreateEntity(): CheckRideRequestPaymentPartyEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideRequestPaymentPartyQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideRequestPaymentPartyEntity, CheckRideRequestPaymentPartyMetaDataAttributes,CheckRideRequestPaymentPartyMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideRequestPaymentPartyMetaDataAttributes();
     Relations = new CheckRideRequestPaymentPartyMetaDataRelations();

}


export type CheckRideRequestPaymentPartyQueryBuilder = DwQueryBuilderGen<CheckRideRequestPaymentPartyEntity, CheckRideRequestPaymentPartyMetaDataAttributes,CheckRideRequestPaymentPartyMetaDataRelations>


export class CheckRideRequestPaymentPartyMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideRequestPaymentParty';
    // Attributes
    CheckRideRequestPaymentPartyId = new DwItemAttribute(this.i, 'CheckRideRequestPaymentPartyId');
    PaymentPartyDisplay = new DwItemAttribute(this.i, 'PaymentPartyDisplay');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    PaymentPartyDescription = new DwItemAttribute(this.i, 'PaymentPartyDescription');
    PilexosBookingCost = new DwItemAttribute(this.i, 'PilexosBookingCost');
    PilexosBookingRetestCost = new DwItemAttribute(this.i, 'PilexosBookingRetestCost');
}

class CheckRideRequestPaymentPartyMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Payment - Payment Party - Many */
            CheckRidePaymentByPaymentPartyId = new DwItemRelationship('CheckRideRequestPaymentParty|CheckRidePayment|PaymentPartyId', 'PaymentPartyIdCheckRidePayment', 'PaymentPartyIdCheckRidePayment');
            /** Relation: Checkride Request - Pilexos Booking Cost Payment Party - Many */
            CheckRideRequestByPilexosBookingCostPaymentPartyId = new DwItemRelationship('CheckRideRequestPaymentParty|CheckRideRequest|PilexosBookingCostPaymentPartyId', 'PilexosBookingCostPaymentPartyIdCheckRideRequest', 'PilexosBookingCostPaymentPartyIdCheckRideRequest');
            /** Relation: Flight School Organization - Pilexos Booking Cost Payment Party - Many */
            FlightSchoolOrganizationByPilexosBookingCostPaymentPartyId = new DwItemRelationship('CheckRideRequestPaymentParty|FlightSchoolOrganization|PilexosBookingCostPaymentPartyId', 'PilexosBookingCostPaymentPartyIdFlightSchoolOrganization', 'PilexosBookingCostPaymentPartyIdFlightSchoolOrganization');
            /** Relation: Payment Customer Reference */
            PaymentCustomerReference = new DwItemRelationship('CheckRideRequestPaymentParty|PaymentCustomerReference|CheckRideRequestPaymentPartyId', 'PaymentCustomerReference', 'PaymentCustomerReference');
    };
export class CheckRideRequestPilotCertificateMetaData implements DwItem2<CheckRideRequestPilotCertificateEntity, CheckRideRequestPilotCertificateMetaDataAttributes,CheckRideRequestPilotCertificateMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2277;
        this.ItemDetail.itemName='CheckRideRequestPilotCertificate';
        this.ItemDetail.keyName='CheckRideRequestPilotCertificateId';
    }

    CreateEntity(): CheckRideRequestPilotCertificateEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideRequestPilotCertificateQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideRequestPilotCertificateEntity, CheckRideRequestPilotCertificateMetaDataAttributes,CheckRideRequestPilotCertificateMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideRequestPilotCertificateMetaDataAttributes();
     Relations = new CheckRideRequestPilotCertificateMetaDataRelations();

}


export type CheckRideRequestPilotCertificateQueryBuilder = DwQueryBuilderGen<CheckRideRequestPilotCertificateEntity, CheckRideRequestPilotCertificateMetaDataAttributes,CheckRideRequestPilotCertificateMetaDataRelations>


export class CheckRideRequestPilotCertificateMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideRequestPilotCertificate';
    // Attributes
    CheckRideRequestPilotCertificateId = new DwItemAttribute(this.i, 'CheckRideRequestPilotCertificateId');
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    CheckRideTypeId = new DwItemAttribute(this.i, 'CheckRideTypeId');
}

class CheckRideRequestPilotCertificateMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Group */
            CheckRideGroup = new DwItemRelationship('CheckRideGroup|CheckRideRequestPilotCertificate|CheckRideGroupId', 'CheckRideGroup', 'CheckRideGroup');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('CheckRideRequest|CheckRideRequestPilotCertificate|CheckRideRequestId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Checkride Type */
            CheckRideType = new DwItemRelationship('CheckRideType|CheckRideRequestPilotCertificate|CheckRideTypeId', 'CheckRideType', 'CheckRideType');
    };
export class CheckRideRequestStatusMetaData implements DwItem2<CheckRideRequestStatusEntity, CheckRideRequestStatusMetaDataAttributes,CheckRideRequestStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1145;
        this.ItemDetail.itemName='CheckRideRequestStatus';
        this.ItemDetail.keyName='CheckRideRequestStatusId';
    }

    CreateEntity(): CheckRideRequestStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideRequestStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideRequestStatusEntity, CheckRideRequestStatusMetaDataAttributes,CheckRideRequestStatusMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideRequestStatusMetaDataAttributes();
     Relations = new CheckRideRequestStatusMetaDataRelations();

}


export type CheckRideRequestStatusQueryBuilder = DwQueryBuilderGen<CheckRideRequestStatusEntity, CheckRideRequestStatusMetaDataAttributes,CheckRideRequestStatusMetaDataRelations>


export class CheckRideRequestStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideRequestStatus';
    // Attributes
    CheckRideRequestStatusId = new DwItemAttribute(this.i, 'CheckRideRequestStatusId');
    CheckRideRequestStatus = new DwItemAttribute(this.i, 'CheckRideRequestStatus');
}

class CheckRideRequestStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Request Sub Status */
            CheckRideRequestSubStatus = new DwItemRelationship('CheckRideRequestStatus|CheckRideRequestSubStatus|CheckRideRequestStatusId', 'CheckRideRequestSubStatus', 'CheckRideRequestSubStatus');
    };
export class CheckRideRequestSubStatusMetaData implements DwItem2<CheckRideRequestSubStatusEntity, CheckRideRequestSubStatusMetaDataAttributes,CheckRideRequestSubStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1146;
        this.ItemDetail.itemName='CheckRideRequestSubStatus';
        this.ItemDetail.keyName='CheckRideRequestSubStatusId';
    }

    CreateEntity(): CheckRideRequestSubStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideRequestSubStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideRequestSubStatusEntity, CheckRideRequestSubStatusMetaDataAttributes,CheckRideRequestSubStatusMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideRequestSubStatusMetaDataAttributes();
     Relations = new CheckRideRequestSubStatusMetaDataRelations();

}


export type CheckRideRequestSubStatusQueryBuilder = DwQueryBuilderGen<CheckRideRequestSubStatusEntity, CheckRideRequestSubStatusMetaDataAttributes,CheckRideRequestSubStatusMetaDataRelations>


export class CheckRideRequestSubStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideRequestSubStatus';
    // Attributes
    CheckRideRequestSubStatusId = new DwItemAttribute(this.i, 'CheckRideRequestSubStatusId');
    CheckRideRequestStatusId = new DwItemAttribute(this.i, 'CheckRideRequestStatusId');
    CheckRideRequestSubStatus = new DwItemAttribute(this.i, 'CheckRideRequestSubStatus');
    WorkflowStatusDetailId = new DwItemAttribute(this.i, 'WorkflowStatusDetailId');
    ApplicantNotes = new DwItemAttribute(this.i, 'ApplicantNotes');
    ExaminerNotes = new DwItemAttribute(this.i, 'ExaminerNotes');
    ApplicantStatusLevelId = new DwItemAttribute(this.i, 'ApplicantStatusLevelId');
    ExaminerStatusLevelId = new DwItemAttribute(this.i, 'ExaminerStatusLevelId');
    ApplicantAllowEdit = new DwItemAttribute(this.i, 'ApplicantAllowEdit');
    ApplicantAllowExaminerChange = new DwItemAttribute(this.i, 'ApplicantAllowExaminerChange');
    ExaminerAllowEdit = new DwItemAttribute(this.i, 'ExaminerAllowEdit');
    OutcomeIsRequested = new DwItemAttribute(this.i, 'OutcomeIsRequested');
    OutcomeIsCancelled = new DwItemAttribute(this.i, 'OutcomeIsCancelled');
    OutcomeIsBooked = new DwItemAttribute(this.i, 'OutcomeIsBooked');
    OutcomeIsComplete = new DwItemAttribute(this.i, 'OutcomeIsComplete');
    SchoolAllowEdit = new DwItemAttribute(this.i, 'SchoolAllowEdit');
    SchoolNotes = new DwItemAttribute(this.i, 'SchoolNotes');
    SchoolStatusLevelId = new DwItemAttribute(this.i, 'SchoolStatusLevelId');
    SchoolManualAllowEdit = new DwItemAttribute(this.i, 'SchoolManualAllowEdit');
    SchoolManualNotes = new DwItemAttribute(this.i, 'SchoolManualNotes');
    SchoolManualStatusLevelId = new DwItemAttribute(this.i, 'SchoolManualStatusLevelId');
    SchoolAllowExaminerChange = new DwItemAttribute(this.i, 'SchoolAllowExaminerChange');
}

class CheckRideRequestSubStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride State */
            CheckRideRequestStatus = new DwItemRelationship('CheckRideRequestStatus|CheckRideRequestSubStatus|CheckRideRequestStatusId', 'CheckRideRequestStatus', 'CheckRideRequestStatus');
            /** Relation: Check Ride Status Level - Applicant Status Level */
            CheckRideStatusLevelByApplicantStatusLevelId = new DwItemRelationship('CheckRideStatusLevel|CheckRideRequestSubStatus|ApplicantStatusLevelId', 'ApplicantStatusLevelIdCheckRideStatusLevel', 'ApplicantStatusLevelIdCheckRideStatusLevel');
            /** Relation: Check Ride Status Level - Examiner Status Level */
            CheckRideStatusLevelByExaminerStatusLevelId = new DwItemRelationship('CheckRideStatusLevel|CheckRideRequestSubStatus|ExaminerStatusLevelId', 'ExaminerStatusLevelIdCheckRideStatusLevel', 'ExaminerStatusLevelIdCheckRideStatusLevel');
            /** Relation: Check Ride Status Level - School Status Level */
            CheckRideStatusLevelBySchoolStatusLevelId = new DwItemRelationship('CheckRideStatusLevel|CheckRideRequestSubStatus|SchoolStatusLevelId', 'SchoolStatusLevelIdCheckRideStatusLevel', 'SchoolStatusLevelIdCheckRideStatusLevel');
            /** Relation: Check Ride Status Level - School Manual Status Level */
            CheckRideStatusLevelBySchoolManualStatusLevelId = new DwItemRelationship('CheckRideStatusLevel|CheckRideRequestSubStatus|SchoolManualStatusLevelId', 'SchoolManualStatusLevelIdCheckRideStatusLevel', 'SchoolManualStatusLevelIdCheckRideStatusLevel');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('CheckRideRequestSubStatus|CheckRideRequest|CheckRideRequestSubStatusId', 'CheckRideRequest', 'CheckRideRequest');
    };
export class CheckRideResultMetaData implements DwItem2<CheckRideResultEntity, CheckRideResultMetaDataAttributes,CheckRideResultMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1151;
        this.ItemDetail.itemName='CheckRideResult';
        this.ItemDetail.keyName='CheckRideResultId';
    }

    CreateEntity(): CheckRideResultEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideResultQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideResultEntity, CheckRideResultMetaDataAttributes,CheckRideResultMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideResultMetaDataAttributes();
     Relations = new CheckRideResultMetaDataRelations();

}


export type CheckRideResultQueryBuilder = DwQueryBuilderGen<CheckRideResultEntity, CheckRideResultMetaDataAttributes,CheckRideResultMetaDataRelations>


export class CheckRideResultMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideResult';
    // Attributes
    CheckRideResultId = new DwItemAttribute(this.i, 'CheckRideResultId');
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    CheckRideDateTime = new DwItemAttribute(this.i, 'CheckRideDateTime');
    CheckRideOutcomeId = new DwItemAttribute(this.i, 'CheckRideOutcomeId');
    AllowRetest = new DwItemAttribute(this.i, 'AllowRetest');
    AllowRetestReason = new DwItemAttribute(this.i, 'AllowRetestReason');
    RetestCost = new DwItemAttribute(this.i, 'RetestCost');
    FlagApplicant = new DwItemAttribute(this.i, 'FlagApplicant');
    FlagApplicantNotes = new DwItemAttribute(this.i, 'FlagApplicantNotes');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    AddToWaitlist = new DwItemAttribute(this.i, 'AddToWaitlist');
    GroundPortionComplete = new DwItemAttribute(this.i, 'GroundPortionComplete');
    PostApplicantAcsWrittenResultId = new DwItemAttribute(this.i, 'PostApplicantAcsWrittenResultId');
}

class CheckRideResultMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Applicant Acs Written Result - Post Applicant Acs Written Result */
            ApplicantAcsWrittenResultByPostApplicantAcsWrittenResultId = new DwItemRelationship('ApplicantAcsWrittenResult|CheckRideResult|PostApplicantAcsWrittenResultId', 'PostApplicantAcsWrittenResult', 'PostApplicantAcsWrittenResult');
            /** Relation: Checkride Outcome */
            CheckRideOutcome = new DwItemRelationship('CheckRideOutcome|CheckRideResult|CheckRideOutcomeId', 'CheckRideOutcome', 'CheckRideOutcome');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('CheckRideRequest|CheckRideResult|CheckRideRequestId', 'CheckRideRequest', 'CheckRideRequest');
    };
export class CheckRideScenarioMetaData implements DwItem2<CheckRideScenarioEntity, CheckRideScenarioMetaDataAttributes,CheckRideScenarioMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1142;
        this.ItemDetail.itemName='CheckRideScenario';
        this.ItemDetail.keyName='CheckRideScenarioId';
    }

    CreateEntity(): CheckRideScenarioEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideScenarioQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideScenarioEntity, CheckRideScenarioMetaDataAttributes,CheckRideScenarioMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideScenarioMetaDataAttributes();
     Relations = new CheckRideScenarioMetaDataRelations();

}


export type CheckRideScenarioQueryBuilder = DwQueryBuilderGen<CheckRideScenarioEntity, CheckRideScenarioMetaDataAttributes,CheckRideScenarioMetaDataRelations>


export class CheckRideScenarioMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideScenario';
    // Attributes
    CheckRideScenarioId = new DwItemAttribute(this.i, 'CheckRideScenarioId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    ScenarioName = new DwItemAttribute(this.i, 'ScenarioName');
    TimeRequiredHours = new DwItemAttribute(this.i, 'TimeRequiredHours');
    PreTimeMinutes = new DwItemAttribute(this.i, 'PreTimeMinutes');
    PostTimeMinutes = new DwItemAttribute(this.i, 'PostTimeMinutes');
    CheckRideCost = new DwItemAttribute(this.i, 'CheckRideCost');
    RetestCost = new DwItemAttribute(this.i, 'RetestCost');
    DiscontinuedRetestCost = new DwItemAttribute(this.i, 'DiscontinuedRetestCost');
    DocumentsMediaGroupId = new DwItemAttribute(this.i, 'DocumentsMediaGroupId');
    RequiredDocumentNotes = new DwItemAttribute(this.i, 'RequiredDocumentNotes');
    BookingCost = new DwItemAttribute(this.i, 'BookingCost');
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    TravelCost = new DwItemAttribute(this.i, 'TravelCost');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    TimeRequiredMinutes = new DwItemAttribute(this.i, 'TimeRequiredMinutes');
    RetestFlightOnlyCost = new DwItemAttribute(this.i, 'RetestFlightOnlyCost');
    DiscontinuedRetestFlightOnlyCost = new DwItemAttribute(this.i, 'DiscontinuedRetestFlightOnlyCost');
    RetestFlightOnlyTimeReqirementMinutes = new DwItemAttribute(this.i, 'RetestFlightOnlyTimeReqirementMinutes');
    RetestTimeRequiredMinutes = new DwItemAttribute(this.i, 'RetestTimeRequiredMinutes');
    RetestFlightOnlyTimeRequiredMinutes = new DwItemAttribute(this.i, 'RetestFlightOnlyTimeRequiredMinutes');
    DiscontinuedTimeRequiredMinutes = new DwItemAttribute(this.i, 'DiscontinuedTimeRequiredMinutes');
    DiscontinuedFlightOnlyTimeRequiredMinutes = new DwItemAttribute(this.i, 'DiscontinuedFlightOnlyTimeRequiredMinutes');
}

class CheckRideScenarioMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Group */
            CheckRideGroup = new DwItemRelationship('CheckRideGroup|CheckRideScenario|CheckRideGroupId', 'CheckRideGroup', 'CheckRideGroup');
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('PilotExaminer|CheckRideScenario|PilotExaminerId', 'PilotExaminer', 'PilotExaminer');
            /** Relation: Checkride Request - Checkride Type Id - Many */
            CheckRideRequestByScheduledCheckRideScenarioId = new DwItemRelationship('CheckRideScenario|CheckRideRequest|ScheduledCheckRideScenarioId', 'ScheduledCheckRideRequest', 'ScheduledCheckRideRequest');
            /** Relation: Checkride Scenario Type Map */
            CheckRideScenarioTypeMap = new DwItemRelationship('CheckRideScenario|CheckRideScenarioTypeMap|CheckRideScenarioId', 'CheckRideScenarioTypeMap', 'CheckRideScenarioTypeMap');
            /** Relation: Ro Pilot Examiner Scenario */
            RoPilotExaminerScenario = new DwItemRelationship('CheckRideScenario|roPilotExaminerScenario', 'RoPilotExaminerScenario', 'RoPilotExaminerScenario');
    };
export class CheckRideScenarioTypeMapMetaData implements DwItem2<CheckRideScenarioTypeMapEntity, CheckRideScenarioTypeMapMetaDataAttributes,CheckRideScenarioTypeMapMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1143;
        this.ItemDetail.itemName='CheckRideScenarioTypeMap';
        this.ItemDetail.keyName='CheckRideScenarioTypeMapId';
    }

    CreateEntity(): CheckRideScenarioTypeMapEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideScenarioTypeMapQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideScenarioTypeMapEntity, CheckRideScenarioTypeMapMetaDataAttributes,CheckRideScenarioTypeMapMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideScenarioTypeMapMetaDataAttributes();
     Relations = new CheckRideScenarioTypeMapMetaDataRelations();

}


export type CheckRideScenarioTypeMapQueryBuilder = DwQueryBuilderGen<CheckRideScenarioTypeMapEntity, CheckRideScenarioTypeMapMetaDataAttributes,CheckRideScenarioTypeMapMetaDataRelations>


export class CheckRideScenarioTypeMapMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideScenarioTypeMap';
    // Attributes
    CheckRideScenarioTypeMapId = new DwItemAttribute(this.i, 'CheckRideScenarioTypeMapId');
    CheckRideScenarioId = new DwItemAttribute(this.i, 'CheckRideScenarioId');
    CheckRideTypeId = new DwItemAttribute(this.i, 'CheckRideTypeId');
}

class CheckRideScenarioTypeMapMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Exam Type */
            CheckRideScenario = new DwItemRelationship('CheckRideScenario|CheckRideScenarioTypeMap|CheckRideScenarioId', 'CheckRideScenario', 'CheckRideScenario');
            /** Relation: Checkride Type */
            CheckRideType = new DwItemRelationship('CheckRideType|CheckRideScenarioTypeMap|CheckRideTypeId', 'CheckRideType', 'CheckRideType');
    };
export class CheckRideScheduleHoldMetaData implements DwItem2<CheckRideScheduleHoldEntity, CheckRideScheduleHoldMetaDataAttributes,CheckRideScheduleHoldMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1252;
        this.ItemDetail.itemName='CheckRideScheduleHold';
        this.ItemDetail.keyName='CheckRideScheduleHoldId';
    }

    CreateEntity(): CheckRideScheduleHoldEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideScheduleHoldQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideScheduleHoldEntity, CheckRideScheduleHoldMetaDataAttributes,CheckRideScheduleHoldMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideScheduleHoldMetaDataAttributes();
     Relations = new CheckRideScheduleHoldMetaDataRelations();

}


export type CheckRideScheduleHoldQueryBuilder = DwQueryBuilderGen<CheckRideScheduleHoldEntity, CheckRideScheduleHoldMetaDataAttributes,CheckRideScheduleHoldMetaDataRelations>


export class CheckRideScheduleHoldMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideScheduleHold';
    // Attributes
    CheckRideScheduleHoldId = new DwItemAttribute(this.i, 'CheckRideScheduleHoldId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    CheckRideDateTime = new DwItemAttribute(this.i, 'CheckRideDateTime');
    AirportId = new DwItemAttribute(this.i, 'AirportId');
    StartDateTime = new DwItemAttribute(this.i, 'StartDateTime');
    ExpirationDateTime = new DwItemAttribute(this.i, 'ExpirationDateTime');
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    UserId = new DwItemAttribute(this.i, 'UserId');
    DurationMinutes = new DwItemAttribute(this.i, 'DurationMinutes');
}

class CheckRideScheduleHoldMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Airport */
            Airport = new DwItemRelationship('Airport|CheckRideScheduleHold|AirportId', 'Airport', 'Airport');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('CheckRideRequest|CheckRideScheduleHold|CheckRideRequestId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('PilotExaminer|CheckRideScheduleHold|PilotExaminerId', 'PilotExaminer', 'PilotExaminer');
            /** Relation: Student Applicant - User */
            StudentApplicantByUserId = new DwItemRelationship('StudentApplicant|CheckRideScheduleHold|StudentApplicantId', 'UserIdStudentApplicant', 'UserIdStudentApplicant');
            /** Relation: User - Created By */
            DwUserByCreatedBy = new DwItemRelationship('dw_User|CheckRideScheduleHold|CreatedBy', 'CreatedByDwUser', 'CreatedByDwUser');
            /** Relation: User - Modified By */
            DwUserByModifiedBy = new DwItemRelationship('dw_User|CheckRideScheduleHold|ModifiedBy', 'ModifiedByDwUser', 'ModifiedByDwUser');
    };
export class CheckRideStatusLevelMetaData implements DwItem2<CheckRideStatusLevelEntity, CheckRideStatusLevelMetaDataAttributes,CheckRideStatusLevelMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1182;
        this.ItemDetail.itemName='CheckRideStatusLevel';
        this.ItemDetail.keyName='CheckRideStatusLevelId';
    }

    CreateEntity(): CheckRideStatusLevelEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideStatusLevelQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideStatusLevelEntity, CheckRideStatusLevelMetaDataAttributes,CheckRideStatusLevelMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideStatusLevelMetaDataAttributes();
     Relations = new CheckRideStatusLevelMetaDataRelations();

}


export type CheckRideStatusLevelQueryBuilder = DwQueryBuilderGen<CheckRideStatusLevelEntity, CheckRideStatusLevelMetaDataAttributes,CheckRideStatusLevelMetaDataRelations>


export class CheckRideStatusLevelMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideStatusLevel';
    // Attributes
    CheckRideStatusLevelId = new DwItemAttribute(this.i, 'CheckRideStatusLevelId');
    StatusLevelDisplay = new DwItemAttribute(this.i, 'StatusLevelDisplay');
}

class CheckRideStatusLevelMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Request Sub Status - Applicant Status Level - Many */
            CheckRideRequestSubStatusByApplicantStatusLevelId = new DwItemRelationship('CheckRideStatusLevel|CheckRideRequestSubStatus|ApplicantStatusLevelId', 'ApplicantStatusLevelIdCheckRideRequestSubStatus', 'ApplicantStatusLevelIdCheckRideRequestSubStatus');
            /** Relation: Checkride Request Sub Status - Examiner Status Level - Many */
            CheckRideRequestSubStatusByExaminerStatusLevelId = new DwItemRelationship('CheckRideStatusLevel|CheckRideRequestSubStatus|ExaminerStatusLevelId', 'ExaminerStatusLevelIdCheckRideRequestSubStatus', 'ExaminerStatusLevelIdCheckRideRequestSubStatus');
            /** Relation: Checkride Request Sub Status - School Status Level - Many */
            CheckRideRequestSubStatusBySchoolStatusLevelId = new DwItemRelationship('CheckRideStatusLevel|CheckRideRequestSubStatus|SchoolStatusLevelId', 'SchoolStatusLevelIdCheckRideRequestSubStatus', 'SchoolStatusLevelIdCheckRideRequestSubStatus');
            /** Relation: Checkride Request Sub Status - School Manual Status Level - Many */
            CheckRideRequestSubStatusBySchoolManualStatusLevelId = new DwItemRelationship('CheckRideStatusLevel|CheckRideRequestSubStatus|SchoolManualStatusLevelId', 'SchoolManualStatusLevelIdCheckRideRequestSubStatus', 'SchoolManualStatusLevelIdCheckRideRequestSubStatus');
    };
export class CheckRideTestAttemptClassificationMetaData implements DwItem2<CheckRideTestAttemptClassificationEntity, CheckRideTestAttemptClassificationMetaDataAttributes,CheckRideTestAttemptClassificationMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2362;
        this.ItemDetail.itemName='CheckRideTestAttemptClassification';
        this.ItemDetail.keyName='CheckRideTestAttemptClassificationId';
    }

    CreateEntity(): CheckRideTestAttemptClassificationEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideTestAttemptClassificationQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideTestAttemptClassificationEntity, CheckRideTestAttemptClassificationMetaDataAttributes,CheckRideTestAttemptClassificationMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideTestAttemptClassificationMetaDataAttributes();
     Relations = new CheckRideTestAttemptClassificationMetaDataRelations();

}


export type CheckRideTestAttemptClassificationQueryBuilder = DwQueryBuilderGen<CheckRideTestAttemptClassificationEntity, CheckRideTestAttemptClassificationMetaDataAttributes,CheckRideTestAttemptClassificationMetaDataRelations>


export class CheckRideTestAttemptClassificationMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideTestAttemptClassification';
    // Attributes
    CheckRideTestAttemptClassificationId = new DwItemAttribute(this.i, 'CheckRideTestAttemptClassificationId');
    AttemptClassification = new DwItemAttribute(this.i, 'AttemptClassification');
}

class CheckRideTestAttemptClassificationMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Test Type */
            CheckRideTestType = new DwItemRelationship('CheckRideTestAttemptClassification|CheckRideTestType|CheckRideTestAttemptClassificationId', 'CheckRideTestType', 'CheckRideTestType');
    };
export class CheckRideTestTypeMetaData implements DwItem2<CheckRideTestTypeEntity, CheckRideTestTypeMetaDataAttributes,CheckRideTestTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1147;
        this.ItemDetail.itemName='CheckRideTestType';
        this.ItemDetail.keyName='CheckRideTestTypeId';
    }

    CreateEntity(): CheckRideTestTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideTestTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideTestTypeEntity, CheckRideTestTypeMetaDataAttributes,CheckRideTestTypeMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideTestTypeMetaDataAttributes();
     Relations = new CheckRideTestTypeMetaDataRelations();

}


export type CheckRideTestTypeQueryBuilder = DwQueryBuilderGen<CheckRideTestTypeEntity, CheckRideTestTypeMetaDataAttributes,CheckRideTestTypeMetaDataRelations>


export class CheckRideTestTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideTestType';
    // Attributes
    CheckRideTestTypeId = new DwItemAttribute(this.i, 'CheckRideTestTypeId');
    TestType = new DwItemAttribute(this.i, 'TestType');
    UseStageCheckOutcomes = new DwItemAttribute(this.i, 'UseStageCheckOutcomes');
    ReTestCheckrideTestTypeId = new DwItemAttribute(this.i, 'ReTestCheckrideTestTypeId');
    ReTestFlightOnlyCheckrideTestTypeId = new DwItemAttribute(this.i, 'ReTestFlightOnlyCheckrideTestTypeId');
    IncompleteTestTypeId = new DwItemAttribute(this.i, 'IncompleteTestTypeId');
    IncompleteFlightOnlyTestTypeId = new DwItemAttribute(this.i, 'IncompleteFlightOnlyTestTypeId');
    CheckRideTestAttemptClassificationId = new DwItemAttribute(this.i, 'CheckRideTestAttemptClassificationId');
}

class CheckRideTestTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Check Ride Test Attempt Classification */
            CheckRideTestAttemptClassification = new DwItemRelationship('CheckRideTestAttemptClassification|CheckRideTestType|CheckRideTestAttemptClassificationId', 'CheckRideTestAttemptClassification', 'CheckRideTestAttemptClassification');
            /** Relation: Checkride Test Type - Incomplete Flight Only Test Type - One */
            CheckRideTestTypeByIncompleteFlightOnlyTestTypeId = new DwItemRelationship('CheckRideTestType|CheckRideTestType|IncompleteFlightOnlyTestTypeId', 'IncompleteFlightOnlyTestTypeIdCheckRideTestType', 'IncompleteFlightOnlyTestTypeIdCheckRideTestType');
            /** Relation: Checkride Test Type - Incomplete Test Type - One */
            CheckRideTestTypeByIncompleteTestTypeId = new DwItemRelationship('CheckRideTestType|CheckRideTestType|IncompleteTestTypeId', 'IncompleteTestTypeIdCheckRideTestType', 'IncompleteTestTypeIdCheckRideTestType');
            /** Relation: Checkride Test Type - Re-test Test Type - One */
            CheckRideTestTypeByReTestCheckrideTestTypeId = new DwItemRelationship('CheckRideTestType|CheckRideTestType|ReTestCheckrideTestTypeId', 'ReTestCheckrideTestTypeIdCheckRideTestType', 'ReTestCheckrideTestTypeIdCheckRideTestType');
            /** Relation: Checkride Test Type - Re-test Flight Only Test Type - One */
            CheckRideTestTypeByReTestFlightOnlyCheckrideTestTypeId = new DwItemRelationship('CheckRideTestType|CheckRideTestType|ReTestFlightOnlyCheckrideTestTypeId', 'ReTestFlightOnlyCheckrideTestTypeIdCheckRideTestType', 'ReTestFlightOnlyCheckrideTestTypeIdCheckRideTestType');
            /** Relation: Applicant Wait List */
            ApplicantPlaceholder = new DwItemRelationship('CheckRideTestType|ApplicantPlaceholder|CheckRideTtestTypeId', 'ApplicantPlaceholder', 'ApplicantPlaceholder');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('CheckRideTestType|CheckRideRequest|CheckRideTestTypeId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Flight School Applicant */
            FlightSchoolApplicant = new DwItemRelationship('CheckRideTestType|FlightSchoolApplicant|CheckRideTestTypeId', 'FlightSchoolApplicant', 'FlightSchoolApplicant');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('CheckRideTestType|PlanOfAction|CheckRideTestTypeId', 'PlanOfAction', 'PlanOfAction');
    };
export class CheckRideTypeMetaData implements DwItem2<CheckRideTypeEntity, CheckRideTypeMetaDataAttributes,CheckRideTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1135;
        this.ItemDetail.itemName='CheckRideType';
        this.ItemDetail.keyName='CheckRideTypeId';
    }

    CreateEntity(): CheckRideTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideTypeEntity, CheckRideTypeMetaDataAttributes,CheckRideTypeMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideTypeMetaDataAttributes();
     Relations = new CheckRideTypeMetaDataRelations();

}


export type CheckRideTypeQueryBuilder = DwQueryBuilderGen<CheckRideTypeEntity, CheckRideTypeMetaDataAttributes,CheckRideTypeMetaDataRelations>


export class CheckRideTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideType';
    // Attributes
    CheckRideTypeId = new DwItemAttribute(this.i, 'CheckRideTypeId');
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    CheckRideType = new DwItemAttribute(this.i, 'CheckRideType');
    CheckRideDesignation = new DwItemAttribute(this.i, 'CheckRideDesignation');
    TypeOrder = new DwItemAttribute(this.i, 'TypeOrder');
    TimeRequiredMinutes = new DwItemAttribute(this.i, 'TimeRequiredMinutes');
    RetestTimeRequiredMinutes = new DwItemAttribute(this.i, 'RetestTimeRequiredMinutes');
    RetestFlightOnlyTimeRequiredMinutes = new DwItemAttribute(this.i, 'RetestFlightOnlyTimeRequiredMinutes');
    DiscontinuedTimeRequiredMinutes = new DwItemAttribute(this.i, 'DiscontinuedTimeRequiredMinutes');
    DiscontinuedFlightOnlyTimeRequiredMinutes = new DwItemAttribute(this.i, 'DiscontinuedFlightOnlyTimeRequiredMinutes');
    ReportShortName = new DwItemAttribute(this.i, 'ReportShortName');
}

class CheckRideTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Group */
            CheckRideGroup = new DwItemRelationship('CheckRideGroup|CheckRideType|CheckRideGroupId', 'CheckRideGroup', 'CheckRideGroup');
            /** Relation: Acs Test Check Ride Type */
            AcsTestCheckRideType = new DwItemRelationship('CheckRideType|AcsTestCheckRideType|CheckRideTypeId', 'AcsTestCheckRideType', 'AcsTestCheckRideType');
            /** Relation: Applicant Wait List */
            ApplicantPlaceholder = new DwItemRelationship('CheckRideType|ApplicantPlaceholder|CheckRideTypeId', 'ApplicantPlaceholder', 'ApplicantPlaceholder');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('CheckRideType|CheckRideRequest|CheckRideTypeId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Check Ride Request Pilot Certificate */
            CheckRideRequestPilotCertificate = new DwItemRelationship('CheckRideType|CheckRideRequestPilotCertificate|CheckRideTypeId', 'CheckRideRequestPilotCertificate', 'CheckRideRequestPilotCertificate');
            /** Relation: Checkride Scenario Type Map */
            CheckRideScenarioTypeMap = new DwItemRelationship('CheckRideType|CheckRideScenarioTypeMap|CheckRideTypeId', 'CheckRideScenarioTypeMap', 'CheckRideScenarioTypeMap');
            /** Relation: Flight School Applicant */
            FlightSchoolApplicant = new DwItemRelationship('CheckRideType|FlightSchoolApplicant|CheckRideTypeId', 'FlightSchoolApplicant', 'FlightSchoolApplicant');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('CheckRideType|PlanOfAction|CheckRideTypeId', 'PlanOfAction', 'PlanOfAction');
            /** Relation: Schedule Block Check Ride Type */
            ScheduleBlockCheckRideType = new DwItemRelationship('CheckRideType|ScheduleBlockCheckRideType|CheckRideTypeId', 'ScheduleBlockCheckRideType', 'ScheduleBlockCheckRideType');
    };
export class CheckRideWorkflowMetaData implements DwItem2<CheckRideWorkflowEntity, CheckRideWorkflowMetaDataAttributes,CheckRideWorkflowMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2287;
        this.ItemDetail.itemName='CheckRideWorkflow';
        this.ItemDetail.keyName='CheckRideWorkflowId';
    }

    CreateEntity(): CheckRideWorkflowEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CheckRideWorkflowQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CheckRideWorkflowEntity, CheckRideWorkflowMetaDataAttributes,CheckRideWorkflowMetaDataRelations>(query, this);
    }
     Attributes = new CheckRideWorkflowMetaDataAttributes();
     Relations = new CheckRideWorkflowMetaDataRelations();

}


export type CheckRideWorkflowQueryBuilder = DwQueryBuilderGen<CheckRideWorkflowEntity, CheckRideWorkflowMetaDataAttributes,CheckRideWorkflowMetaDataRelations>


export class CheckRideWorkflowMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideWorkflow';
    // Attributes
    CheckRideWorkflowId = new DwItemAttribute(this.i, 'CheckRideWorkflowId');
    CheckRideWorkflow = new DwItemAttribute(this.i, 'CheckRideWorkflow');
    FlightSchoolStatusLookupId = new DwItemAttribute(this.i, 'FlightSchoolStatusLookupId');
    ExaminerStatusLookupId = new DwItemAttribute(this.i, 'ExaminerStatusLookupId');
    ApplicantStatusLookupId = new DwItemAttribute(this.i, 'ApplicantStatusLookupId');
}

class CheckRideWorkflowMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('CheckRideWorkflow|CheckRideRequest|CheckRideWorkflowId', 'CheckRideRequest', 'CheckRideRequest');
    };
export class CountryMetaData implements DwItem2<CountryEntity, CountryMetaDataAttributes,CountryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1156;
        this.ItemDetail.itemName='Country';
        this.ItemDetail.keyName='CountryId';
    }

    CreateEntity(): CountryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CountryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CountryEntity, CountryMetaDataAttributes,CountryMetaDataRelations>(query, this);
    }
     Attributes = new CountryMetaDataAttributes();
     Relations = new CountryMetaDataRelations();

}


export type CountryQueryBuilder = DwQueryBuilderGen<CountryEntity, CountryMetaDataAttributes,CountryMetaDataRelations>


export class CountryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Country';
    // Attributes
    CountryId = new DwItemAttribute(this.i, 'CountryId');
    CountryName = new DwItemAttribute(this.i, 'CountryName');
    CountryShortName = new DwItemAttribute(this.i, 'CountryShortName');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
}

class CountryMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Address */
            Address = new DwItemRelationship('Country|Address|CountryId', 'Address', 'Address');
            /** Relation: Applicant Wait List - Student Applicant Citizenship County - Many */
            ApplicantPlaceholderByStudentApplicantCitizenshipCountyId = new DwItemRelationship('Country|ApplicantPlaceholder|StudentApplicantCitizenshipCountyId', 'StudentApplicantCitizenshipCountyIdApplicantPlaceholder', 'StudentApplicantCitizenshipCountyIdApplicantPlaceholder');
            /** Relation: Checkride Request - Student Applicant Citizenship County - Many */
            CheckRideRequestByStudentApplicantCitizenshipCountyId = new DwItemRelationship('Country|CheckRideRequest|StudentApplicantCitizenshipCountyId', 'StudentApplicantCitizenshipCountyIdCheckRideRequest', 'StudentApplicantCitizenshipCountyIdCheckRideRequest');
            /** Relation: Flight School Applicant - Citizenship - Many */
            FlightSchoolApplicantByCitizenshipCountryId = new DwItemRelationship('Country|FlightSchoolApplicant|CitizenshipCountryId', 'CitizenshipFlightSchoolApplicant', 'CitizenshipFlightSchoolApplicant');
            /** Relation: Plan Of Action - Student Applicant Citizenship - Many */
            PlanOfActionByStudentApplicantCitizenshipCountryId = new DwItemRelationship('Country|PlanOfAction|StudentApplicantCitizenshipCountryId', 'StudentApplicantCitizenshipPlanOfAction', 'StudentApplicantCitizenshipPlanOfAction');
            /** Relation: State Province */
            StateProvince = new DwItemRelationship('Country|StateProvince|CountryId', 'StateProvince', 'StateProvince');
            /** Relation: Student Applicant - Citzenship County - Many */
            StudentApplicantByCitzenshipCountyId = new DwItemRelationship('Country|StudentApplicant|CitzenshipCountyId', 'CitzenshipCountyIdStudentApplicant', 'CitzenshipCountyIdStudentApplicant');
    };
export class DurationMetaData implements DwItem2<DurationEntity, DurationMetaDataAttributes,DurationMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1185;
        this.ItemDetail.itemName='Duration';
        this.ItemDetail.keyName='DurationId';
    }

    CreateEntity(): DurationEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DurationQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DurationEntity, DurationMetaDataAttributes,DurationMetaDataRelations>(query, this);
    }
     Attributes = new DurationMetaDataAttributes();
     Relations = new DurationMetaDataRelations();

}


export type DurationQueryBuilder = DwQueryBuilderGen<DurationEntity, DurationMetaDataAttributes,DurationMetaDataRelations>


export class DurationMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Duration';
    // Attributes
    DurationId = new DwItemAttribute(this.i, 'DurationId');
    DurationMinutes = new DwItemAttribute(this.i, 'DurationMinutes');
    DurationDisplay = new DwItemAttribute(this.i, 'DurationDisplay');
}

class DurationMetaDataRelations implements DwItemRelationshipCollection {
    };
export class ElectronicFlightBagTypeMetaData implements DwItem2<ElectronicFlightBagTypeEntity, ElectronicFlightBagTypeMetaDataAttributes,ElectronicFlightBagTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2278;
        this.ItemDetail.itemName='ElectronicFlightBagType';
        this.ItemDetail.keyName='ElectronicFlightBagTypeId';
    }

    CreateEntity(): ElectronicFlightBagTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ElectronicFlightBagTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ElectronicFlightBagTypeEntity, ElectronicFlightBagTypeMetaDataAttributes,ElectronicFlightBagTypeMetaDataRelations>(query, this);
    }
     Attributes = new ElectronicFlightBagTypeMetaDataAttributes();
     Relations = new ElectronicFlightBagTypeMetaDataRelations();

}


export type ElectronicFlightBagTypeQueryBuilder = DwQueryBuilderGen<ElectronicFlightBagTypeEntity, ElectronicFlightBagTypeMetaDataAttributes,ElectronicFlightBagTypeMetaDataRelations>


export class ElectronicFlightBagTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ElectronicFlightBagType';
    // Attributes
    ElectronicFlightBagTypeId = new DwItemAttribute(this.i, 'ElectronicFlightBagTypeId');
    ElectronicFlightBagType = new DwItemAttribute(this.i, 'ElectronicFlightBagType');
}

class ElectronicFlightBagTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('ElectronicFlightBagType|CheckRideRequest|ElectronicFlightBagTypeId', 'CheckRideRequest', 'CheckRideRequest');
    };
export class FlightSchoolMetaData implements DwItem2<FlightSchoolEntity, FlightSchoolMetaDataAttributes,FlightSchoolMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1194;
        this.ItemDetail.itemName='FlightSchool';
        this.ItemDetail.keyName='FlightSchoolId';
    }

    CreateEntity(): FlightSchoolEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolEntity, FlightSchoolMetaDataAttributes,FlightSchoolMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolMetaDataAttributes();
     Relations = new FlightSchoolMetaDataRelations();

}


export type FlightSchoolQueryBuilder = DwQueryBuilderGen<FlightSchoolEntity, FlightSchoolMetaDataAttributes,FlightSchoolMetaDataRelations>


export class FlightSchoolMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchool';
    // Attributes
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolName = new DwItemAttribute(this.i, 'FlightSchoolName');
    IsOther = new DwItemAttribute(this.i, 'IsOther');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class FlightSchoolMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Applicant Wait List */
            ApplicantPlaceholder = new DwItemRelationship('FlightSchool|ApplicantPlaceholder|FlightSchoolId', 'ApplicantPlaceholder', 'ApplicantPlaceholder');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('FlightSchool|CheckRideRequest|FlightSchoolId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Checkride Request - Oda - Many */
            CheckRideRequestByOdaFlightSchoolId = new DwItemRelationship('FlightSchool|CheckRideRequest|OdaFlightSchoolId', 'OdaCheckRideRequest', 'OdaCheckRideRequest');
            /** Relation: Flight School Applicant - O D A - Many */
            FlightSchoolApplicantByODAFlightSchoolId = new DwItemRelationship('FlightSchool|FlightSchoolApplicant|FlightSchoolId', 'ODAFlightSchoolApplicant', 'ODAFlightSchoolApplicant');
            /** Relation: Flight School Organization */
            FlightSchoolOrganization = new DwItemRelationship('FlightSchool|FlightSchoolOrganization|FlightSchoolId', 'FlightSchoolOrganization', 'FlightSchoolOrganization');
            /** Relation: Flight School Setup Request */
            FlightSchoolSetupRequest = new DwItemRelationship('FlightSchool|FlightSchoolSetupRequest|FlightSchoolId', 'FlightSchoolSetupRequest', 'FlightSchoolSetupRequest');
            /** Relation: Pilot Examiner Flight School Setup */
            PilotExaminerFlightSchoolSetup = new DwItemRelationship('FlightSchool|PilotExaminerFlightSchoolSetup|FlightSchoolId', 'PilotExaminerFlightSchoolSetup', 'PilotExaminerFlightSchoolSetup');
            /** Relation: Plan Of Action - Oda - Many */
            PlanOfActionByOdaFlightSchoolId = new DwItemRelationship('FlightSchool|PlanOfAction|OdaFlightSchoolId', 'OdaPlanOfAction', 'OdaPlanOfAction');
            /** Relation: Schedule Block */
            ScheduleBlock = new DwItemRelationship('FlightSchool|ScheduleBlock|FlightSchoolId', 'ScheduleBlock', 'ScheduleBlock');
    };
export class FlightSchoolApplicantMetaData implements DwItem2<FlightSchoolApplicantEntity, FlightSchoolApplicantMetaDataAttributes,FlightSchoolApplicantMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1258;
        this.ItemDetail.itemName='FlightSchoolApplicant';
        this.ItemDetail.keyName='FlightSchoolApplicantId';
    }

    CreateEntity(): FlightSchoolApplicantEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolApplicantQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolApplicantEntity, FlightSchoolApplicantMetaDataAttributes,FlightSchoolApplicantMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolApplicantMetaDataAttributes();
     Relations = new FlightSchoolApplicantMetaDataRelations();

}


export type FlightSchoolApplicantQueryBuilder = DwQueryBuilderGen<FlightSchoolApplicantEntity, FlightSchoolApplicantMetaDataAttributes,FlightSchoolApplicantMetaDataRelations>


export class FlightSchoolApplicantMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolApplicant';
    // Attributes
    FlightSchoolApplicantId = new DwItemAttribute(this.i, 'FlightSchoolApplicantId');
    ApplicantName = new DwItemAttribute(this.i, 'ApplicantName');
    ApplicantEmail = new DwItemAttribute(this.i, 'ApplicantEmail');
    ApplicantPhone = new DwItemAttribute(this.i, 'ApplicantPhone');
    FlightSchoolApplicantStatusId = new DwItemAttribute(this.i, 'FlightSchoolApplicantStatusId');
    ExpectedCheckrideDateTime = new DwItemAttribute(this.i, 'ExpectedCheckrideDateTime');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    CheckRideTypeId = new DwItemAttribute(this.i, 'CheckRideTypeId');
    CheckRideTestTypeId = new DwItemAttribute(this.i, 'CheckRideTestTypeId');
    FlightSchoolBranchId = new DwItemAttribute(this.i, 'FlightSchoolBranchId');
    IsEndorsed = new DwItemAttribute(this.i, 'IsEndorsed');
    EndorsedDate = new DwItemAttribute(this.i, 'EndorsedDate');
    StudentApplicantId = new DwItemAttribute(this.i, 'StudentApplicantId');
    PilotCertificateNumber = new DwItemAttribute(this.i, 'PilotCertificateNumber');
    CurrentPilotCertificateTypeId = new DwItemAttribute(this.i, 'CurrentPilotCertificateTypeId');
    CitizenshipCountryId = new DwItemAttribute(this.i, 'CitizenshipCountryId');
    PrimaryFlightSchoolInstructorId = new DwItemAttribute(this.i, 'PrimaryFlightSchoolInstructorId');
    AirplaneMakeModal = new DwItemAttribute(this.i, 'AirplaneMakeModal');
    AuthorityPreCheckRideNumber = new DwItemAttribute(this.i, 'AuthorityPreCheckRideNumber');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    AuthorityApplicationNumber = new DwItemAttribute(this.i, 'AuthorityApplicationNumber');
    StateProvinceId = new DwItemAttribute(this.i, 'StateProvinceId');
    ForeignPilotMeetsQualifications = new DwItemAttribute(this.i, 'ForeignPilotMeetsQualifications');
    ApplicantAcsWrittenResultId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultId');
    AirmanKnowledgeTestScore = new DwItemAttribute(this.i, 'AirmanKnowledgeTestScore');
    AirmanKnowledgeTestDate = new DwItemAttribute(this.i, 'AirmanKnowledgeTestDate');
    AirmanKnowledgeTestPDFMediaId = new DwItemAttribute(this.i, 'AirmanKnowledgeTestPDFMediaId');
    AdditionalDocumentationNotes = new DwItemAttribute(this.i, 'AdditionalDocumentationNotes');
    LogBookMediaId = new DwItemAttribute(this.i, 'LogBookMediaId');
    TrainingMediaId = new DwItemAttribute(this.i, 'TrainingMediaId');
    AdditionalDocumentsMediaGroupId = new DwItemAttribute(this.i, 'AdditionalDocumentsMediaGroupId');
    CurrentCheckRideRequestId = new DwItemAttribute(this.i, 'CurrentCheckRideRequestId');
    PublicPortalSubmission = new DwItemAttribute(this.i, 'PublicPortalSubmission');
    EndOfCourseDate = new DwItemAttribute(this.i, 'EndOfCourseDate');
    FlightSchoolPrivateNotes = new DwItemAttribute(this.i, 'FlightSchoolPrivateNotes');
    ExaminerPreferenceNotes = new DwItemAttribute(this.i, 'ExaminerPreferenceNotes');
    AdditionalAirmanKnowledgeTestScore = new DwItemAttribute(this.i, 'AdditionalAirmanKnowledgeTestScore');
    AdditionalAirmanKnowledgeTestDate = new DwItemAttribute(this.i, 'AdditionalAirmanKnowledgeTestDate');
    AdditionalAirmanKnowledgeTestPDFMediaId = new DwItemAttribute(this.i, 'AdditionalAirmanKnowledgeTestPDFMediaId');
    CheckRideInstructorTypeId = new DwItemAttribute(this.i, 'CheckRideInstructorTypeId');
    FlightInstructorName = new DwItemAttribute(this.i, 'FlightInstructorName');
    FlightInstructorEmail = new DwItemAttribute(this.i, 'FlightInstructorEmail');
    FlightSchoolTypeId = new DwItemAttribute(this.i, 'FlightSchoolTypeId');
    ODAFlightSchoolId = new DwItemAttribute(this.i, 'ODAFlightSchoolId');
    FlightInstructorCertificateNumber = new DwItemAttribute(this.i, 'FlightInstructorCertificateNumber');
    FlightInstructorPhone = new DwItemAttribute(this.i, 'FlightInstructorPhone');
}

class FlightSchoolApplicantMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Applicant Acs Written Result */
            ApplicantAcsWrittenResult = new DwItemRelationship('ApplicantAcsWrittenResult|FlightSchoolApplicant|ApplicantAcsWrittenResultId', 'ApplicantAcsWrittenResult', 'ApplicantAcsWrittenResult');
            /** Relation: Checkride Group */
            CheckRideGroup = new DwItemRelationship('CheckRideGroup|FlightSchoolApplicant|CheckRideGroupId', 'CheckRideGroup', 'CheckRideGroup');
            /** Relation: Check Ride Instructor Type */
            CheckRideInstructorType = new DwItemRelationship('CheckRideInstructorType|FlightSchoolApplicant|CheckRideInstructorTypeId', 'CheckRideInstructorType', 'CheckRideInstructorType');
            /** Relation: Checkride Test Type */
            CheckRideTestType = new DwItemRelationship('CheckRideTestType|FlightSchoolApplicant|CheckRideTestTypeId', 'CheckRideTestType', 'CheckRideTestType');
            /** Relation: Checkride Type */
            CheckRideType = new DwItemRelationship('CheckRideType|FlightSchoolApplicant|CheckRideTypeId', 'CheckRideType', 'CheckRideType');
            /** Relation: Country - Citizenship Country */
            CountryByCitizenshipCountryId = new DwItemRelationship('Country|FlightSchoolApplicant|CitizenshipCountryId', 'CitizenshipCountry', 'CitizenshipCountry');
            /** Relation: Flight School - O D A Flight School */
            FlightSchoolByODAFlightSchoolId = new DwItemRelationship('FlightSchool|FlightSchoolApplicant|FlightSchoolId', 'ODAFlightSchool', 'ODAFlightSchool');
            /** Relation: Flight School Applicant Status */
            FlightSchoolApplicantStatus = new DwItemRelationship('FlightSchoolApplicantStatus|FlightSchoolApplicant|FlightSchoolApplicantStatusId', 'FlightSchoolApplicantStatus', 'FlightSchoolApplicantStatus');
            /** Relation: Flight School Branch */
            FlightSchoolBranch = new DwItemRelationship('FlightSchoolBranch|FlightSchoolApplicant|FlightSchoolBranchId', 'FlightSchoolBranch', 'FlightSchoolBranch');
            /** Relation: Flight School Instructor - Primary Instructor */
            FlightSchoolInstructorByPrimaryFlightSchoolInstructorId = new DwItemRelationship('FlightSchoolInstructor|FlightSchoolApplicant|PrimaryFlightSchoolInstructorId', 'PrimaryFlightSchoolInstructor', 'PrimaryFlightSchoolInstructor');
            /** Relation: Flight School Organization */
            FlightSchoolOrganization = new DwItemRelationship('FlightSchoolOrganization|FlightSchoolApplicant|FlightSchoolOrganizationId', 'FlightSchoolOrganization', 'FlightSchoolOrganization');
            /** Relation: Flight School Type */
            FlightSchoolType = new DwItemRelationship('FlightSchoolType|FlightSchoolApplicant|FlightSchoolTypeId', 'FlightSchoolType', 'FlightSchoolType');
            /** Relation: Pilot Certificate Type - Current Pilot Certificate Type */
            PilotCertificateTypeByCurrentPilotCertificateTypeId = new DwItemRelationship('PilotCertificateType|FlightSchoolApplicant|CurrentPilotCertificateTypeId', 'CurrentPilotCertificateType', 'CurrentPilotCertificateType');
            /** Relation: State Province */
            StateProvince = new DwItemRelationship('StateProvince|FlightSchoolApplicant|StateProvinceId', 'StateProvince', 'StateProvince');
            /** Relation: Student Applicant */
            StudentApplicant = new DwItemRelationship('StudentApplicant|FlightSchoolApplicant|StudentApplicantId', 'StudentApplicant', 'StudentApplicant');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('FlightSchoolApplicant|CheckRideRequest|FlightSchoolApplicantId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Flight School Applicant Branch */
            FlightSchoolApplicantBranch = new DwItemRelationship('FlightSchoolApplicant|FlightSchoolApplicantBranch|FlightSchoolApplicantId', 'FlightSchoolApplicantBranch', 'FlightSchoolApplicantBranch');
            /** Relation: Flight School Instructor Applicant */
            FlightSchoolInstructorApplicant = new DwItemRelationship('FlightSchoolApplicant|FlightSchoolInstructorApplicant|FlightSchoolApplicantId', 'FlightSchoolInstructorApplicant', 'FlightSchoolInstructorApplicant');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('FlightSchoolApplicant|PlanOfAction|FlightSchoolApplicantId', 'PlanOfAction', 'PlanOfAction');
    };
export class FlightSchoolApplicantBranchMetaData implements DwItem2<FlightSchoolApplicantBranchEntity, FlightSchoolApplicantBranchMetaDataAttributes,FlightSchoolApplicantBranchMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1261;
        this.ItemDetail.itemName='FlightSchoolApplicantBranch';
        this.ItemDetail.keyName='FlightSchoolApplicantBranchId';
    }

    CreateEntity(): FlightSchoolApplicantBranchEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolApplicantBranchQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolApplicantBranchEntity, FlightSchoolApplicantBranchMetaDataAttributes,FlightSchoolApplicantBranchMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolApplicantBranchMetaDataAttributes();
     Relations = new FlightSchoolApplicantBranchMetaDataRelations();

}


export type FlightSchoolApplicantBranchQueryBuilder = DwQueryBuilderGen<FlightSchoolApplicantBranchEntity, FlightSchoolApplicantBranchMetaDataAttributes,FlightSchoolApplicantBranchMetaDataRelations>


export class FlightSchoolApplicantBranchMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolApplicantBranch';
    // Attributes
    FlightSchoolApplicantBranchId = new DwItemAttribute(this.i, 'FlightSchoolApplicantBranchId');
    FlightSchoolApplicantId = new DwItemAttribute(this.i, 'FlightSchoolApplicantId');
    FlightSchoolBranchId = new DwItemAttribute(this.i, 'FlightSchoolBranchId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class FlightSchoolApplicantBranchMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Applicant */
            FlightSchoolApplicant = new DwItemRelationship('FlightSchoolApplicant|FlightSchoolApplicantBranch|FlightSchoolApplicantId', 'FlightSchoolApplicant', 'FlightSchoolApplicant');
            /** Relation: Flight School Branch */
            FlightSchoolBranch = new DwItemRelationship('FlightSchoolBranch|FlightSchoolApplicantBranch|FlightSchoolBranchId', 'FlightSchoolBranch', 'FlightSchoolBranch');
    };
export class FlightSchoolApplicantStatusMetaData implements DwItem2<FlightSchoolApplicantStatusEntity, FlightSchoolApplicantStatusMetaDataAttributes,FlightSchoolApplicantStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1259;
        this.ItemDetail.itemName='FlightSchoolApplicantStatus';
        this.ItemDetail.keyName='FlightSchoolApplicantStatusId';
    }

    CreateEntity(): FlightSchoolApplicantStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolApplicantStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolApplicantStatusEntity, FlightSchoolApplicantStatusMetaDataAttributes,FlightSchoolApplicantStatusMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolApplicantStatusMetaDataAttributes();
     Relations = new FlightSchoolApplicantStatusMetaDataRelations();

}


export type FlightSchoolApplicantStatusQueryBuilder = DwQueryBuilderGen<FlightSchoolApplicantStatusEntity, FlightSchoolApplicantStatusMetaDataAttributes,FlightSchoolApplicantStatusMetaDataRelations>


export class FlightSchoolApplicantStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolApplicantStatus';
    // Attributes
    FlightSchoolApplicantStatusId = new DwItemAttribute(this.i, 'FlightSchoolApplicantStatusId');
    FlightSchoolApplicantStatus = new DwItemAttribute(this.i, 'FlightSchoolApplicantStatus');
}

class FlightSchoolApplicantStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Applicant */
            FlightSchoolApplicant = new DwItemRelationship('FlightSchoolApplicantStatus|FlightSchoolApplicant|FlightSchoolApplicantStatusId', 'FlightSchoolApplicant', 'FlightSchoolApplicant');
    };
export class FlightSchoolBranchMetaData implements DwItem2<FlightSchoolBranchEntity, FlightSchoolBranchMetaDataAttributes,FlightSchoolBranchMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1256;
        this.ItemDetail.itemName='FlightSchoolBranch';
        this.ItemDetail.keyName='FlightSchoolBranchId';
    }

    CreateEntity(): FlightSchoolBranchEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolBranchQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolBranchEntity, FlightSchoolBranchMetaDataAttributes,FlightSchoolBranchMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolBranchMetaDataAttributes();
     Relations = new FlightSchoolBranchMetaDataRelations();

}


export type FlightSchoolBranchQueryBuilder = DwQueryBuilderGen<FlightSchoolBranchEntity, FlightSchoolBranchMetaDataAttributes,FlightSchoolBranchMetaDataRelations>


export class FlightSchoolBranchMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolBranch';
    // Attributes
    FlightSchoolBranchId = new DwItemAttribute(this.i, 'FlightSchoolBranchId');
    BranchName = new DwItemAttribute(this.i, 'BranchName');
    FlightSchoolBranchStatusId = new DwItemAttribute(this.i, 'FlightSchoolBranchStatusId');
    MainAirportId = new DwItemAttribute(this.i, 'MainAirportId');
    BranchAddressId = new DwItemAttribute(this.i, 'BranchAddressId');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    IsDefaultBranch = new DwItemAttribute(this.i, 'IsDefaultBranch');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ShowMetar = new DwItemAttribute(this.i, 'ShowMetar');
}

class FlightSchoolBranchMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Address - Location Address */
            AddressByBranchAddressId = new DwItemRelationship('Address|FlightSchoolBranch|BranchAddressId', 'BranchAddress', 'BranchAddress');
            /** Relation: Airport - Main Airport */
            AirportByMainAirportId = new DwItemRelationship('Airport|FlightSchoolBranch|MainAirportId', 'MainAirport', 'MainAirport');
            /** Relation: Flight School Organization */
            FlightSchoolOrganization = new DwItemRelationship('FlightSchoolOrganization|FlightSchoolBranch|FlightSchoolOrganizationId', 'FlightSchoolOrganization', 'FlightSchoolOrganization');
            /** Relation: Flight School Reference Status - Location Status */
            FlightSchoolReferenceStatusByFlightSchoolBranchStatusId = new DwItemRelationship('FlightSchoolReferenceStatus|FlightSchoolBranch|FlightSchoolBranchStatusId', 'FlightSchoolBranchStatusIdFlightSchoolReferenceStatus', 'FlightSchoolBranchStatusIdFlightSchoolReferenceStatus');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('FlightSchoolBranch|CheckRideRequest|FlightSchoolBranchId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Flight School Applicant */
            FlightSchoolApplicant = new DwItemRelationship('FlightSchoolBranch|FlightSchoolApplicant|FlightSchoolBranchId', 'FlightSchoolApplicant', 'FlightSchoolApplicant');
            /** Relation: Flight School Applicant Branch */
            FlightSchoolApplicantBranch = new DwItemRelationship('FlightSchoolBranch|FlightSchoolApplicantBranch|FlightSchoolBranchId', 'FlightSchoolApplicantBranch', 'FlightSchoolApplicantBranch');
            /** Relation: Flight School User Branch */
            FlightSchoolUserBranch = new DwItemRelationship('FlightSchoolBranch|FlightSchoolUserBranch|FlightSchoolBranchId', 'FlightSchoolUserBranch', 'FlightSchoolUserBranch');
            /** Relation: User Invite Request School Branch */
            UserInviteRequestSchoolBranch = new DwItemRelationship('FlightSchoolBranch|UserInviteRequestSchoolBranch|FlightSchoolBranchId', 'UserInviteRequestSchoolBranch', 'UserInviteRequestSchoolBranch');
    };
export class FlightSchoolExaminerMetaData implements DwItem2<FlightSchoolExaminerEntity, FlightSchoolExaminerMetaDataAttributes,FlightSchoolExaminerMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1263;
        this.ItemDetail.itemName='FlightSchoolExaminer';
        this.ItemDetail.keyName='FlightSchoolExaminerId';
    }

    CreateEntity(): FlightSchoolExaminerEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolExaminerQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolExaminerEntity, FlightSchoolExaminerMetaDataAttributes,FlightSchoolExaminerMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolExaminerMetaDataAttributes();
     Relations = new FlightSchoolExaminerMetaDataRelations();

}


export type FlightSchoolExaminerQueryBuilder = DwQueryBuilderGen<FlightSchoolExaminerEntity, FlightSchoolExaminerMetaDataAttributes,FlightSchoolExaminerMetaDataRelations>


export class FlightSchoolExaminerMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolExaminer';
    // Attributes
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    ExaminerName = new DwItemAttribute(this.i, 'ExaminerName');
    ExaminerEmail = new DwItemAttribute(this.i, 'ExaminerEmail');
    ExaminerPhone = new DwItemAttribute(this.i, 'ExaminerPhone');
    FlightSchoolExaminerStatusId = new DwItemAttribute(this.i, 'FlightSchoolExaminerStatusId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    FlightSchoolExaminerTypeId = new DwItemAttribute(this.i, 'FlightSchoolExaminerTypeId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    LastInviteSendDateTime = new DwItemAttribute(this.i, 'LastInviteSendDateTime');
    SendInviteEmail = new DwItemAttribute(this.i, 'SendInviteEmail');
    SendCheckrideEmails = new DwItemAttribute(this.i, 'SendCheckrideEmails');
    UseExaminerBlockBooking = new DwItemAttribute(this.i, 'UseExaminerBlockBooking');
    FlightSchoolInstructorId = new DwItemAttribute(this.i, 'FlightSchoolInstructorId');
    RecurrencyDate = new DwItemAttribute(this.i, 'RecurrencyDate');
    TrainingCurrent = new DwItemAttribute(this.i, 'TrainingCurrent');
    TrainingCurrentEvaluatedDateTime = new DwItemAttribute(this.i, 'TrainingCurrentEvaluatedDateTime');
    DpeSupplementReviewedDateTime = new DwItemAttribute(this.i, 'DpeSupplementReviewedDateTime');
    DpeSupplementReviewedBy = new DwItemAttribute(this.i, 'DpeSupplementReviewedBy');
    DocumentsMediaGroupId = new DwItemAttribute(this.i, 'DocumentsMediaGroupId');
    TrainingCurrentReason = new DwItemAttribute(this.i, 'TrainingCurrentReason');
}

class FlightSchoolExaminerMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Examiner Status */
            FlightSchoolExaminerStatus = new DwItemRelationship('FlightSchoolExaminerStatus|FlightSchoolExaminer|FlightSchoolExaminerStatusId', 'FlightSchoolExaminerStatus', 'FlightSchoolExaminerStatus');
            /** Relation: Flight School Examiner Type */
            FlightSchoolExaminerType = new DwItemRelationship('FlightSchoolExaminerType|FlightSchoolExaminer|FlightSchoolExaminerTypeId', 'FlightSchoolExaminerType', 'FlightSchoolExaminerType');
            /** Relation: Flight School Instructor */
            FlightSchoolInstructor = new DwItemRelationship('FlightSchoolInstructor|FlightSchoolExaminer|FlightSchoolInstructorId', 'FlightSchoolInstructor', 'FlightSchoolInstructor');
            /** Relation: Flight School Organization */
            FlightSchoolOrganization = new DwItemRelationship('FlightSchoolOrganization|FlightSchoolExaminer|FlightSchoolOrganizationId', 'FlightSchoolOrganization', 'FlightSchoolOrganization');
            /** Relation: Media Group - Documents Media Group */
            DwMediaGroupByDocumentsMediaGroupId = new DwItemRelationship('dw_MediaGroup|FlightSchoolExaminer|DocumentsMediaGroupId', 'DocumentsDwMediaGroup', 'DocumentsDwMediaGroup');
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('PilotExaminer|FlightSchoolExaminer|PilotExaminerId', 'PilotExaminer', 'PilotExaminer');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('FlightSchoolExaminer|CheckRideRequest|FlightSchoolExaminerId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Flight School User */
            FlightSchoolUser = new DwItemRelationship('FlightSchoolExaminer|FlightSchoolUser|FlightSchoolExaminerId', 'FlightSchoolUser', 'FlightSchoolUser');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('FlightSchoolExaminer|PlanOfAction|FlightSchoolExaminerId', 'PlanOfAction', 'PlanOfAction');
            /** Relation: Ro Flight School Examiner */
            RoFlightSchoolExaminer = new DwItemRelationship('FlightSchoolExaminer|roFlightSchoolExaminer|FlightSchoolExaminerId', 'RoFlightSchoolExaminer', 'RoFlightSchoolExaminer');
            /** Relation: Schedule Block */
            ScheduleBlock = new DwItemRelationship('FlightSchoolExaminer|ScheduleBlock|FlightSchoolExaminerId', 'ScheduleBlock', 'ScheduleBlock');
            /** Relation: Training Record */
            TrainingRecord = new DwItemRelationship('FlightSchoolExaminer|TrainingRecord|FlightSchoolExaminerId', 'TrainingRecord', 'TrainingRecord');
            /** Relation: Unit Member Aircraft Experience */
            UnitMemberAircraftExperience = new DwItemRelationship('FlightSchoolExaminer|UnitMemberAircraftExperience|FlightSchoolExaminerId', 'UnitMemberAircraftExperience', 'UnitMemberAircraftExperience');
            /** Relation: Unit Member Certificate */
            UnitMemberCertificate = new DwItemRelationship('FlightSchoolExaminer|UnitMemberCertificate|FlightSchoolExaminerId', 'UnitMemberCertificate', 'UnitMemberCertificate');
            /** Relation: Unit Member Employment */
            UnitMemberEmployment = new DwItemRelationship('FlightSchoolExaminer|UnitMemberEmployment|FlightSchoolExaminerId', 'UnitMemberEmployment', 'UnitMemberEmployment');
            /** Relation: Unit Member Flight Experience */
            UnitMemberFlightExperience = new DwItemRelationship('FlightSchoolExaminer|UnitMemberFlightExperience|FlightSchoolExaminerId', 'UnitMemberFlightExperience', 'UnitMemberFlightExperience');
            /** Relation: Unit Member Profile */
            UnitMemberProfile = new DwItemRelationship('FlightSchoolExaminer|UnitMemberProfile|FlightSchoolExaminerId', 'UnitMemberProfile', 'UnitMemberProfile');
            /** Relation: Unit Member Qualification Response */
            UnitMemberQualificationResponse = new DwItemRelationship('FlightSchoolExaminer|UnitMemberQualificationResponse|FlightSchoolExaminerId', 'UnitMemberQualificationResponse', 'UnitMemberQualificationResponse');
            /** Relation: User Invite Request Detail */
            UserInviteRequestDetail = new DwItemRelationship('FlightSchoolExaminer|UserInviteRequestDetail|FlightSchoolExaminerId', 'UserInviteRequestDetail', 'UserInviteRequestDetail');
    };
export class FlightSchoolExaminerStatusMetaData implements DwItem2<FlightSchoolExaminerStatusEntity, FlightSchoolExaminerStatusMetaDataAttributes,FlightSchoolExaminerStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1264;
        this.ItemDetail.itemName='FlightSchoolExaminerStatus';
        this.ItemDetail.keyName='FlightSchoolExaminerStatusId';
    }

    CreateEntity(): FlightSchoolExaminerStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolExaminerStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolExaminerStatusEntity, FlightSchoolExaminerStatusMetaDataAttributes,FlightSchoolExaminerStatusMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolExaminerStatusMetaDataAttributes();
     Relations = new FlightSchoolExaminerStatusMetaDataRelations();

}


export type FlightSchoolExaminerStatusQueryBuilder = DwQueryBuilderGen<FlightSchoolExaminerStatusEntity, FlightSchoolExaminerStatusMetaDataAttributes,FlightSchoolExaminerStatusMetaDataRelations>


export class FlightSchoolExaminerStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolExaminerStatus';
    // Attributes
    FlightSchoolExaminerStatusId = new DwItemAttribute(this.i, 'FlightSchoolExaminerStatusId');
    FlightSchoolExaminerStatus = new DwItemAttribute(this.i, 'FlightSchoolExaminerStatus');
}

class FlightSchoolExaminerStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Examiner */
            FlightSchoolExaminer = new DwItemRelationship('FlightSchoolExaminerStatus|FlightSchoolExaminer|FlightSchoolExaminerStatusId', 'FlightSchoolExaminer', 'FlightSchoolExaminer');
    };
export class FlightSchoolExaminerTypeMetaData implements DwItem2<FlightSchoolExaminerTypeEntity, FlightSchoolExaminerTypeMetaDataAttributes,FlightSchoolExaminerTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2281;
        this.ItemDetail.itemName='FlightSchoolExaminerType';
        this.ItemDetail.keyName='FlightSchoolExaminerTypeId';
    }

    CreateEntity(): FlightSchoolExaminerTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolExaminerTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolExaminerTypeEntity, FlightSchoolExaminerTypeMetaDataAttributes,FlightSchoolExaminerTypeMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolExaminerTypeMetaDataAttributes();
     Relations = new FlightSchoolExaminerTypeMetaDataRelations();

}


export type FlightSchoolExaminerTypeQueryBuilder = DwQueryBuilderGen<FlightSchoolExaminerTypeEntity, FlightSchoolExaminerTypeMetaDataAttributes,FlightSchoolExaminerTypeMetaDataRelations>


export class FlightSchoolExaminerTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolExaminerType';
    // Attributes
    FlightSchoolExaminerTypeId = new DwItemAttribute(this.i, 'FlightSchoolExaminerTypeId');
    FlightSchoolExaminerType = new DwItemAttribute(this.i, 'FlightSchoolExaminerType');
    Description = new DwItemAttribute(this.i, 'Description');
}

class FlightSchoolExaminerTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Examiner */
            FlightSchoolExaminer = new DwItemRelationship('FlightSchoolExaminerType|FlightSchoolExaminer|FlightSchoolExaminerTypeId', 'FlightSchoolExaminer', 'FlightSchoolExaminer');
    };
export class FlightSchoolInstructorMetaData implements DwItem2<FlightSchoolInstructorEntity, FlightSchoolInstructorMetaDataAttributes,FlightSchoolInstructorMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2283;
        this.ItemDetail.itemName='FlightSchoolInstructor';
        this.ItemDetail.keyName='FlightSchoolInstructorId';
    }

    CreateEntity(): FlightSchoolInstructorEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolInstructorQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolInstructorEntity, FlightSchoolInstructorMetaDataAttributes,FlightSchoolInstructorMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolInstructorMetaDataAttributes();
     Relations = new FlightSchoolInstructorMetaDataRelations();

}


export type FlightSchoolInstructorQueryBuilder = DwQueryBuilderGen<FlightSchoolInstructorEntity, FlightSchoolInstructorMetaDataAttributes,FlightSchoolInstructorMetaDataRelations>


export class FlightSchoolInstructorMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolInstructor';
    // Attributes
    FlightSchoolInstructorId = new DwItemAttribute(this.i, 'FlightSchoolInstructorId');
    InstructorName = new DwItemAttribute(this.i, 'InstructorName');
    InstructorEmail = new DwItemAttribute(this.i, 'InstructorEmail');
    InstructorPhone = new DwItemAttribute(this.i, 'InstructorPhone');
    InstructorCertifcateNumber = new DwItemAttribute(this.i, 'InstructorCertifcateNumber');
    FlightSchoolUserId = new DwItemAttribute(this.i, 'FlightSchoolUserId');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    FlightSchoolInstructorStatusId = new DwItemAttribute(this.i, 'FlightSchoolInstructorStatusId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    FlightSchoolInstructorTypeId = new DwItemAttribute(this.i, 'FlightSchoolInstructorTypeId');
    RecurrencyDate = new DwItemAttribute(this.i, 'RecurrencyDate');
}

class FlightSchoolInstructorMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Instructor Status */
            FlightSchoolInstructorStatus = new DwItemRelationship('FlightSchoolInstructorStatus|FlightSchoolInstructor|FlightSchoolInstructorStatusId', 'FlightSchoolInstructorStatus', 'FlightSchoolInstructorStatus');
            /** Relation: Flight School Instructor Type */
            FlightSchoolInstructorType = new DwItemRelationship('FlightSchoolInstructorType|FlightSchoolInstructor|FlightSchoolInstructorTypeId', 'FlightSchoolInstructorType', 'FlightSchoolInstructorType');
            /** Relation: Flight School Organization */
            FlightSchoolOrganization = new DwItemRelationship('FlightSchoolOrganization|FlightSchoolInstructor|FlightSchoolOrganizationId', 'FlightSchoolOrganization', 'FlightSchoolOrganization');
            /** Relation: Flight School User */
            FlightSchoolUser = new DwItemRelationship('FlightSchoolUser|FlightSchoolInstructor|FlightSchoolUserId', 'FlightSchoolUser', 'FlightSchoolUser');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('FlightSchoolInstructor|CheckRideRequest|FlightSchoolInstructorId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Flight School Applicant - Primary - Many */
            FlightSchoolApplicantByPrimaryFlightSchoolInstructorId = new DwItemRelationship('FlightSchoolInstructor|FlightSchoolApplicant|PrimaryFlightSchoolInstructorId', 'PrimaryFlightSchoolApplicant', 'PrimaryFlightSchoolApplicant');
            /** Relation: Flight School Examiner */
            FlightSchoolExaminer = new DwItemRelationship('FlightSchoolInstructor|FlightSchoolExaminer|FlightSchoolInstructorId', 'FlightSchoolExaminer', 'FlightSchoolExaminer');
            /** Relation: Flight School Instructor Applicant */
            FlightSchoolInstructorApplicant = new DwItemRelationship('FlightSchoolInstructor|FlightSchoolInstructorApplicant|FlightSchoolInstructorId', 'FlightSchoolInstructorApplicant', 'FlightSchoolInstructorApplicant');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('FlightSchoolInstructor|PlanOfAction|FlightSchoolInstructorId', 'PlanOfAction', 'PlanOfAction');
            /** Relation: User Invite Request Detail */
            UserInviteRequestDetail = new DwItemRelationship('FlightSchoolInstructor|UserInviteRequestDetail|FlightSchoolInstructorId', 'UserInviteRequestDetail', 'UserInviteRequestDetail');
    };
export class FlightSchoolInstructorApplicantMetaData implements DwItem2<FlightSchoolInstructorApplicantEntity, FlightSchoolInstructorApplicantMetaDataAttributes,FlightSchoolInstructorApplicantMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2285;
        this.ItemDetail.itemName='FlightSchoolInstructorApplicant';
        this.ItemDetail.keyName='FlightSchoolInstructorApplicantId';
    }

    CreateEntity(): FlightSchoolInstructorApplicantEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolInstructorApplicantQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolInstructorApplicantEntity, FlightSchoolInstructorApplicantMetaDataAttributes,FlightSchoolInstructorApplicantMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolInstructorApplicantMetaDataAttributes();
     Relations = new FlightSchoolInstructorApplicantMetaDataRelations();

}


export type FlightSchoolInstructorApplicantQueryBuilder = DwQueryBuilderGen<FlightSchoolInstructorApplicantEntity, FlightSchoolInstructorApplicantMetaDataAttributes,FlightSchoolInstructorApplicantMetaDataRelations>


export class FlightSchoolInstructorApplicantMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolInstructorApplicant';
    // Attributes
    FlightSchoolInstructorApplicantId = new DwItemAttribute(this.i, 'FlightSchoolInstructorApplicantId');
    FlightSchoolInstructorId = new DwItemAttribute(this.i, 'FlightSchoolInstructorId');
    FlightSchoolApplicantId = new DwItemAttribute(this.i, 'FlightSchoolApplicantId');
}

class FlightSchoolInstructorApplicantMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Applicant */
            FlightSchoolApplicant = new DwItemRelationship('FlightSchoolApplicant|FlightSchoolInstructorApplicant|FlightSchoolApplicantId', 'FlightSchoolApplicant', 'FlightSchoolApplicant');
            /** Relation: Flight School Instructor */
            FlightSchoolInstructor = new DwItemRelationship('FlightSchoolInstructor|FlightSchoolInstructorApplicant|FlightSchoolInstructorId', 'FlightSchoolInstructor', 'FlightSchoolInstructor');
    };
export class FlightSchoolInstructorStatusMetaData implements DwItem2<FlightSchoolInstructorStatusEntity, FlightSchoolInstructorStatusMetaDataAttributes,FlightSchoolInstructorStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2284;
        this.ItemDetail.itemName='FlightSchoolInstructorStatus';
        this.ItemDetail.keyName='FlightSchoolInstructorStatusId';
    }

    CreateEntity(): FlightSchoolInstructorStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolInstructorStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolInstructorStatusEntity, FlightSchoolInstructorStatusMetaDataAttributes,FlightSchoolInstructorStatusMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolInstructorStatusMetaDataAttributes();
     Relations = new FlightSchoolInstructorStatusMetaDataRelations();

}


export type FlightSchoolInstructorStatusQueryBuilder = DwQueryBuilderGen<FlightSchoolInstructorStatusEntity, FlightSchoolInstructorStatusMetaDataAttributes,FlightSchoolInstructorStatusMetaDataRelations>


export class FlightSchoolInstructorStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolInstructorStatus';
    // Attributes
    FlightSchoolInstructorStatusId = new DwItemAttribute(this.i, 'FlightSchoolInstructorStatusId');
    FlightSchoolInstructorStatus = new DwItemAttribute(this.i, 'FlightSchoolInstructorStatus');
}

class FlightSchoolInstructorStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Instructor */
            FlightSchoolInstructor = new DwItemRelationship('FlightSchoolInstructorStatus|FlightSchoolInstructor|FlightSchoolInstructorStatusId', 'FlightSchoolInstructor', 'FlightSchoolInstructor');
    };
export class FlightSchoolInstructorTypeMetaData implements DwItem2<FlightSchoolInstructorTypeEntity, FlightSchoolInstructorTypeMetaDataAttributes,FlightSchoolInstructorTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2335;
        this.ItemDetail.itemName='FlightSchoolInstructorType';
        this.ItemDetail.keyName='FlightSchoolInstructorTypeId';
    }

    CreateEntity(): FlightSchoolInstructorTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolInstructorTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolInstructorTypeEntity, FlightSchoolInstructorTypeMetaDataAttributes,FlightSchoolInstructorTypeMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolInstructorTypeMetaDataAttributes();
     Relations = new FlightSchoolInstructorTypeMetaDataRelations();

}


export type FlightSchoolInstructorTypeQueryBuilder = DwQueryBuilderGen<FlightSchoolInstructorTypeEntity, FlightSchoolInstructorTypeMetaDataAttributes,FlightSchoolInstructorTypeMetaDataRelations>


export class FlightSchoolInstructorTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolInstructorType';
    // Attributes
    FlightSchoolInstructorTypeId = new DwItemAttribute(this.i, 'FlightSchoolInstructorTypeId');
    FlightSchoolInstructorType = new DwItemAttribute(this.i, 'FlightSchoolInstructorType');
}

class FlightSchoolInstructorTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Instructor */
            FlightSchoolInstructor = new DwItemRelationship('FlightSchoolInstructorType|FlightSchoolInstructor|FlightSchoolInstructorTypeId', 'FlightSchoolInstructor', 'FlightSchoolInstructor');
    };
export class FlightSchoolOrganizationMetaData implements DwItem2<FlightSchoolOrganizationEntity, FlightSchoolOrganizationMetaDataAttributes,FlightSchoolOrganizationMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1260;
        this.ItemDetail.itemName='FlightSchoolOrganization';
        this.ItemDetail.keyName='FlightSchoolOrganizationId';
    }

    CreateEntity(): FlightSchoolOrganizationEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolOrganizationQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolOrganizationEntity, FlightSchoolOrganizationMetaDataAttributes,FlightSchoolOrganizationMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolOrganizationMetaDataAttributes();
     Relations = new FlightSchoolOrganizationMetaDataRelations();

}


export type FlightSchoolOrganizationQueryBuilder = DwQueryBuilderGen<FlightSchoolOrganizationEntity, FlightSchoolOrganizationMetaDataAttributes,FlightSchoolOrganizationMetaDataRelations>


export class FlightSchoolOrganizationMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolOrganization';
    // Attributes
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    OtherNameRequest = new DwItemAttribute(this.i, 'OtherNameRequest');
    FlightSchoolStatusId = new DwItemAttribute(this.i, 'FlightSchoolStatusId');
    BillingAddressId = new DwItemAttribute(this.i, 'BillingAddressId');
    HeadquatersAddressId = new DwItemAttribute(this.i, 'HeadquatersAddressId');
    BillingSameAsHeadquarters = new DwItemAttribute(this.i, 'BillingSameAsHeadquarters');
    OriginalOwnerUserId = new DwItemAttribute(this.i, 'OriginalOwnerUserId');
    FlightSchoolCertificateNumber = new DwItemAttribute(this.i, 'FlightSchoolCertificateNumber');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    PilexosBookingCostPaymentPartyId = new DwItemAttribute(this.i, 'PilexosBookingCostPaymentPartyId');
    ForceSchoolPaymentParty = new DwItemAttribute(this.i, 'ForceSchoolPaymentParty');
    PublicPortalIsActive = new DwItemAttribute(this.i, 'PublicPortalIsActive');
    PublicPortalSlug = new DwItemAttribute(this.i, 'PublicPortalSlug');
    AllowPublicStudentCreation = new DwItemAttribute(this.i, 'AllowPublicStudentCreation');
    UseExaminerBlockBooking = new DwItemAttribute(this.i, 'UseExaminerBlockBooking');
    PreTimeMinutes = new DwItemAttribute(this.i, 'PreTimeMinutes');
    PostTimeMinutes = new DwItemAttribute(this.i, 'PostTimeMinutes');
    MaxTravelRadiusMiles = new DwItemAttribute(this.i, 'MaxTravelRadiusMiles');
    FlightSchoolTypeId = new DwItemAttribute(this.i, 'FlightSchoolTypeId');
    CalendarReferenceId = new DwItemAttribute(this.i, 'CalendarReferenceId');
    ValidateExaminerTrainingForPOA = new DwItemAttribute(this.i, 'ValidateExaminerTrainingForPOA');
}

class FlightSchoolOrganizationMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Address - Billing Address */
            AddressByBillingAddressId = new DwItemRelationship('Address|FlightSchoolOrganization|BillingAddressId', 'BillingAddress', 'BillingAddress');
            /** Relation: Address - Headquaters Address */
            AddressByHeadquatersAddressId = new DwItemRelationship('Address|FlightSchoolOrganization|HeadquatersAddressId', 'HeadquatersAddress', 'HeadquatersAddress');
            /** Relation: Calendar Reference */
            CalendarReference = new DwItemRelationship('CalendarReference|FlightSchoolOrganization|CalendarReferenceId', 'CalendarReference', 'CalendarReference');
            /** Relation: Check Ride Request Payment Party - Pilexos Booking Cost Payment Party */
            CheckRideRequestPaymentPartyByPilexosBookingCostPaymentPartyId = new DwItemRelationship('CheckRideRequestPaymentParty|FlightSchoolOrganization|PilexosBookingCostPaymentPartyId', 'PilexosBookingCostPaymentPartyIdCheckRideRequestPaymentParty', 'PilexosBookingCostPaymentPartyIdCheckRideRequestPaymentParty');
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|FlightSchoolOrganization|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Flight School Status */
            FlightSchoolStatus = new DwItemRelationship('FlightSchoolStatus|FlightSchoolOrganization|FlightSchoolStatusId', 'FlightSchoolStatus', 'FlightSchoolStatus');
            /** Relation: Flight School Type */
            FlightSchoolType = new DwItemRelationship('FlightSchoolType|FlightSchoolOrganization|FlightSchoolTypeId', 'FlightSchoolType', 'FlightSchoolType');
            /** Relation: User - Original Owner User */
            DwUserByOriginalOwnerUserId = new DwItemRelationship('dw_User|FlightSchoolOrganization|OriginalOwnerUserId', 'OriginalOwnerDwUser', 'OriginalOwnerDwUser');
            /** Relation: Calendar Sync Request */
            CalendarSyncRequest = new DwItemRelationship('FlightSchoolOrganization|CalendarSyncRequest|FlightSchoolOrganizationId', 'CalendarSyncRequest', 'CalendarSyncRequest');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('FlightSchoolOrganization|CheckRideRequest|FlightSchoolOrganizationId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Flight School Applicant */
            FlightSchoolApplicant = new DwItemRelationship('FlightSchoolOrganization|FlightSchoolApplicant|FlightSchoolOrganizationId', 'FlightSchoolApplicant', 'FlightSchoolApplicant');
            /** Relation: Flight School Branch */
            FlightSchoolBranch = new DwItemRelationship('FlightSchoolOrganization|FlightSchoolBranch|FlightSchoolOrganizationId', 'FlightSchoolBranch', 'FlightSchoolBranch');
            /** Relation: Flight School Examiner */
            FlightSchoolExaminer = new DwItemRelationship('FlightSchoolOrganization|FlightSchoolExaminer|FlightSchoolOrganizationId', 'FlightSchoolExaminer', 'FlightSchoolExaminer');
            /** Relation: Flight School Instructor */
            FlightSchoolInstructor = new DwItemRelationship('FlightSchoolOrganization|FlightSchoolInstructor|FlightSchoolOrganizationId', 'FlightSchoolInstructor', 'FlightSchoolInstructor');
            /** Relation: Flight School Organization Feature */
            FlightSchoolOrganizationFeature = new DwItemRelationship('FlightSchoolOrganization|FlightSchoolOrganizationFeature|FlightSchoolOrganizationId', 'FlightSchoolOrganizationFeature', 'FlightSchoolOrganizationFeature');
            /** Relation: Flight School Training Program */
            FlightSchoolTrainingProgram = new DwItemRelationship('FlightSchoolOrganization|FlightSchoolTrainingProgram|FlightSchooOrganizationIdlId', 'FlightSchoolTrainingProgram', 'FlightSchoolTrainingProgram');
            /** Relation: Flight School User */
            FlightSchoolUser = new DwItemRelationship('FlightSchoolOrganization|FlightSchoolUser|FlightSchooOrganizationId', 'FlightSchoolUser', 'FlightSchoolUser');
            /** Relation: Payment Customer Reference */
            PaymentCustomerReference = new DwItemRelationship('FlightSchoolOrganization|PaymentCustomerReference|FlightSchoolOrganizationId', 'PaymentCustomerReference', 'PaymentCustomerReference');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('FlightSchoolOrganization|PlanOfAction|FlightSchoolOrganizationId', 'PlanOfAction', 'PlanOfAction');
            /** Relation: Question Bank */
            QuestionBank = new DwItemRelationship('FlightSchoolOrganization|QuestionBank|FlightSchoolOrganizationId', 'QuestionBank', 'QuestionBank');
            /** Relation: Subscription */
            Subscription = new DwItemRelationship('FlightSchoolOrganization|Subscription|FlightSchoolOrganizationId', 'Subscription', 'Subscription');
            /** Relation: User Invite Request Detail */
            UserInviteRequestDetail = new DwItemRelationship('FlightSchoolOrganization|UserInviteRequestDetail|FlightSchoolOrganizationId', 'UserInviteRequestDetail', 'UserInviteRequestDetail');
    };
export class FlightSchoolOrganizationFeatureMetaData implements DwItem2<FlightSchoolOrganizationFeatureEntity, FlightSchoolOrganizationFeatureMetaDataAttributes,FlightSchoolOrganizationFeatureMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2290;
        this.ItemDetail.itemName='FlightSchoolOrganizationFeature';
        this.ItemDetail.keyName='FlightSchoolOrganizationFeatureId';
    }

    CreateEntity(): FlightSchoolOrganizationFeatureEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolOrganizationFeatureQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolOrganizationFeatureEntity, FlightSchoolOrganizationFeatureMetaDataAttributes,FlightSchoolOrganizationFeatureMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolOrganizationFeatureMetaDataAttributes();
     Relations = new FlightSchoolOrganizationFeatureMetaDataRelations();

}


export type FlightSchoolOrganizationFeatureQueryBuilder = DwQueryBuilderGen<FlightSchoolOrganizationFeatureEntity, FlightSchoolOrganizationFeatureMetaDataAttributes,FlightSchoolOrganizationFeatureMetaDataRelations>


export class FlightSchoolOrganizationFeatureMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolOrganizationFeature';
    // Attributes
    FlightSchoolOrganizationFeatureId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationFeatureId');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    SchoolFeatureId = new DwItemAttribute(this.i, 'SchoolFeatureId');
}

class FlightSchoolOrganizationFeatureMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Organization */
            FlightSchoolOrganization = new DwItemRelationship('FlightSchoolOrganization|FlightSchoolOrganizationFeature|FlightSchoolOrganizationId', 'FlightSchoolOrganization', 'FlightSchoolOrganization');
            /** Relation: School Feature */
            SchoolFeature = new DwItemRelationship('SchoolFeature|FlightSchoolOrganizationFeature|SchoolFeatureId', 'SchoolFeature', 'SchoolFeature');
    };
export class FlightSchoolReferenceStatusMetaData implements DwItem2<FlightSchoolReferenceStatusEntity, FlightSchoolReferenceStatusMetaDataAttributes,FlightSchoolReferenceStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1255;
        this.ItemDetail.itemName='FlightSchoolReferenceStatus';
        this.ItemDetail.keyName='FlightSchoolReferenceStatusId';
    }

    CreateEntity(): FlightSchoolReferenceStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolReferenceStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolReferenceStatusEntity, FlightSchoolReferenceStatusMetaDataAttributes,FlightSchoolReferenceStatusMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolReferenceStatusMetaDataAttributes();
     Relations = new FlightSchoolReferenceStatusMetaDataRelations();

}


export type FlightSchoolReferenceStatusQueryBuilder = DwQueryBuilderGen<FlightSchoolReferenceStatusEntity, FlightSchoolReferenceStatusMetaDataAttributes,FlightSchoolReferenceStatusMetaDataRelations>


export class FlightSchoolReferenceStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolReferenceStatus';
    // Attributes
    FlightSchoolReferenceStatusId = new DwItemAttribute(this.i, 'FlightSchoolReferenceStatusId');
    FlightSchoolReferenceStatus = new DwItemAttribute(this.i, 'FlightSchoolReferenceStatus');
}

class FlightSchoolReferenceStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Branch - Flight School Branch Status - Many */
            FlightSchoolBranchByFlightSchoolBranchStatusId = new DwItemRelationship('FlightSchoolReferenceStatus|FlightSchoolBranch|FlightSchoolBranchStatusId', 'FlightSchoolBranchStatusIdFlightSchoolBranch', 'FlightSchoolBranchStatusIdFlightSchoolBranch');
    };
export class FlightSchoolSetupRequestMetaData implements DwItem2<FlightSchoolSetupRequestEntity, FlightSchoolSetupRequestMetaDataAttributes,FlightSchoolSetupRequestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2318;
        this.ItemDetail.itemName='FlightSchoolSetupRequest';
        this.ItemDetail.keyName='FlightSchoolSetupRequestId';
    }

    CreateEntity(): FlightSchoolSetupRequestEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolSetupRequestQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolSetupRequestEntity, FlightSchoolSetupRequestMetaDataAttributes,FlightSchoolSetupRequestMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolSetupRequestMetaDataAttributes();
     Relations = new FlightSchoolSetupRequestMetaDataRelations();

}


export type FlightSchoolSetupRequestQueryBuilder = DwQueryBuilderGen<FlightSchoolSetupRequestEntity, FlightSchoolSetupRequestMetaDataAttributes,FlightSchoolSetupRequestMetaDataRelations>


export class FlightSchoolSetupRequestMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolSetupRequest';
    // Attributes
    FlightSchoolSetupRequestId = new DwItemAttribute(this.i, 'FlightSchoolSetupRequestId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    OtherNameRequest = new DwItemAttribute(this.i, 'OtherNameRequest');
    RequestorName = new DwItemAttribute(this.i, 'RequestorName');
    RequestorEmail = new DwItemAttribute(this.i, 'RequestorEmail');
    RequestorPhone = new DwItemAttribute(this.i, 'RequestorPhone');
    FlightSchoolSetupRequestStatusId = new DwItemAttribute(this.i, 'FlightSchoolSetupRequestStatusId');
}

class FlightSchoolSetupRequestMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|FlightSchoolSetupRequest|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Flight School Setup Request Status */
            FlightSchoolSetupRequestStatus = new DwItemRelationship('FlightSchoolSetupRequestStatus|FlightSchoolSetupRequest|FlightSchoolSetupRequestStatusId', 'FlightSchoolSetupRequestStatus', 'FlightSchoolSetupRequestStatus');
    };
export class FlightSchoolSetupRequestStatusMetaData implements DwItem2<FlightSchoolSetupRequestStatusEntity, FlightSchoolSetupRequestStatusMetaDataAttributes,FlightSchoolSetupRequestStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2319;
        this.ItemDetail.itemName='FlightSchoolSetupRequestStatus';
        this.ItemDetail.keyName='FlightSchoolSetupRequestStatusId';
    }

    CreateEntity(): FlightSchoolSetupRequestStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolSetupRequestStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolSetupRequestStatusEntity, FlightSchoolSetupRequestStatusMetaDataAttributes,FlightSchoolSetupRequestStatusMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolSetupRequestStatusMetaDataAttributes();
     Relations = new FlightSchoolSetupRequestStatusMetaDataRelations();

}


export type FlightSchoolSetupRequestStatusQueryBuilder = DwQueryBuilderGen<FlightSchoolSetupRequestStatusEntity, FlightSchoolSetupRequestStatusMetaDataAttributes,FlightSchoolSetupRequestStatusMetaDataRelations>


export class FlightSchoolSetupRequestStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolSetupRequestStatus';
    // Attributes
    FlightSchoolSetupRequestStatusId = new DwItemAttribute(this.i, 'FlightSchoolSetupRequestStatusId');
    FlightSchoolSetupRequestStatus = new DwItemAttribute(this.i, 'FlightSchoolSetupRequestStatus');
}

class FlightSchoolSetupRequestStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Setup Request */
            FlightSchoolSetupRequest = new DwItemRelationship('FlightSchoolSetupRequestStatus|FlightSchoolSetupRequest|FlightSchoolSetupRequestStatusId', 'FlightSchoolSetupRequest', 'FlightSchoolSetupRequest');
    };
export class FlightSchoolStatusMetaData implements DwItem2<FlightSchoolStatusEntity, FlightSchoolStatusMetaDataAttributes,FlightSchoolStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1254;
        this.ItemDetail.itemName='FlightSchoolStatus';
        this.ItemDetail.keyName='FlightSchoolStatusId';
    }

    CreateEntity(): FlightSchoolStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolStatusEntity, FlightSchoolStatusMetaDataAttributes,FlightSchoolStatusMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolStatusMetaDataAttributes();
     Relations = new FlightSchoolStatusMetaDataRelations();

}


export type FlightSchoolStatusQueryBuilder = DwQueryBuilderGen<FlightSchoolStatusEntity, FlightSchoolStatusMetaDataAttributes,FlightSchoolStatusMetaDataRelations>


export class FlightSchoolStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolStatus';
    // Attributes
    FlightSchoolStatusId = new DwItemAttribute(this.i, 'FlightSchoolStatusId');
    FlightSchoolStatus = new DwItemAttribute(this.i, 'FlightSchoolStatus');
}

class FlightSchoolStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Organization */
            FlightSchoolOrganization = new DwItemRelationship('FlightSchoolStatus|FlightSchoolOrganization|FlightSchoolStatusId', 'FlightSchoolOrganization', 'FlightSchoolOrganization');
    };
export class FlightSchoolTrainingProgramMetaData implements DwItem2<FlightSchoolTrainingProgramEntity, FlightSchoolTrainingProgramMetaDataAttributes,FlightSchoolTrainingProgramMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1253;
        this.ItemDetail.itemName='FlightSchoolTrainingProgram';
        this.ItemDetail.keyName='FlightSchoolTrainingProgramId';
    }

    CreateEntity(): FlightSchoolTrainingProgramEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolTrainingProgramQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolTrainingProgramEntity, FlightSchoolTrainingProgramMetaDataAttributes,FlightSchoolTrainingProgramMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolTrainingProgramMetaDataAttributes();
     Relations = new FlightSchoolTrainingProgramMetaDataRelations();

}


export type FlightSchoolTrainingProgramQueryBuilder = DwQueryBuilderGen<FlightSchoolTrainingProgramEntity, FlightSchoolTrainingProgramMetaDataAttributes,FlightSchoolTrainingProgramMetaDataRelations>


export class FlightSchoolTrainingProgramMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolTrainingProgram';
    // Attributes
    FlightSchoolTrainingProgramId = new DwItemAttribute(this.i, 'FlightSchoolTrainingProgramId');
    AviationTrainingProgramId = new DwItemAttribute(this.i, 'AviationTrainingProgramId');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
}

class FlightSchoolTrainingProgramMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Aviation Training Program */
            AviationTrainingProgram = new DwItemRelationship('AviationTrainingProgram|FlightSchoolTrainingProgram|AviationTrainingProgramId', 'AviationTrainingProgram', 'AviationTrainingProgram');
            /** Relation: Flight School Organization */
            FlightSchoolOrganization = new DwItemRelationship('FlightSchoolOrganization|FlightSchoolTrainingProgram|FlightSchooOrganizationIdlId', 'FlightSchoolOrganization', 'FlightSchoolOrganization');
    };
export class FlightSchoolTypeMetaData implements DwItem2<FlightSchoolTypeEntity, FlightSchoolTypeMetaDataAttributes,FlightSchoolTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2348;
        this.ItemDetail.itemName='FlightSchoolType';
        this.ItemDetail.keyName='FlightSchoolTypeId';
    }

    CreateEntity(): FlightSchoolTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolTypeEntity, FlightSchoolTypeMetaDataAttributes,FlightSchoolTypeMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolTypeMetaDataAttributes();
     Relations = new FlightSchoolTypeMetaDataRelations();

}


export type FlightSchoolTypeQueryBuilder = DwQueryBuilderGen<FlightSchoolTypeEntity, FlightSchoolTypeMetaDataAttributes,FlightSchoolTypeMetaDataRelations>


export class FlightSchoolTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolType';
    // Attributes
    FlightSchoolTypeId = new DwItemAttribute(this.i, 'FlightSchoolTypeId');
    FlightSchoolType = new DwItemAttribute(this.i, 'FlightSchoolType');
    TypeDescription = new DwItemAttribute(this.i, 'TypeDescription');
}

class FlightSchoolTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('FlightSchoolType|CheckRideRequest|FlightSchoolTypeId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Flight School Applicant */
            FlightSchoolApplicant = new DwItemRelationship('FlightSchoolType|FlightSchoolApplicant|FlightSchoolTypeId', 'FlightSchoolApplicant', 'FlightSchoolApplicant');
            /** Relation: Flight School Organization */
            FlightSchoolOrganization = new DwItemRelationship('FlightSchoolType|FlightSchoolOrganization|FlightSchoolTypeId', 'FlightSchoolOrganization', 'FlightSchoolOrganization');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('FlightSchoolType|PlanOfAction|FlightSchoolTypeId', 'PlanOfAction', 'PlanOfAction');
    };
export class FlightSchoolUserMetaData implements DwItem2<FlightSchoolUserEntity, FlightSchoolUserMetaDataAttributes,FlightSchoolUserMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1257;
        this.ItemDetail.itemName='FlightSchoolUser';
        this.ItemDetail.keyName='FlightSchoolUserId';
    }

    CreateEntity(): FlightSchoolUserEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolUserQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolUserEntity, FlightSchoolUserMetaDataAttributes,FlightSchoolUserMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolUserMetaDataAttributes();
     Relations = new FlightSchoolUserMetaDataRelations();

}


export type FlightSchoolUserQueryBuilder = DwQueryBuilderGen<FlightSchoolUserEntity, FlightSchoolUserMetaDataAttributes,FlightSchoolUserMetaDataRelations>


export class FlightSchoolUserMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolUser';
    // Attributes
    FlightSchoolUserId = new DwItemAttribute(this.i, 'FlightSchoolUserId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    CanAccessAllLocations = new DwItemAttribute(this.i, 'CanAccessAllLocations');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    FlightSchoolInstructorId = new DwItemAttribute(this.i, 'FlightSchoolInstructorId');
    UserInviteRequestTypeId = new DwItemAttribute(this.i, 'UserInviteRequestTypeId');
}

class FlightSchoolUserMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Examiner */
            FlightSchoolExaminer = new DwItemRelationship('FlightSchoolExaminer|FlightSchoolUser|FlightSchoolExaminerId', 'FlightSchoolExaminer', 'FlightSchoolExaminer');
            /** Relation: Flight School Instructor */
            FlightSchoolInstructor = new DwItemRelationship('FlightSchoolInstructor|FlightSchoolUser|FlightSchoolInstructorId', 'FlightSchoolInstructor', 'FlightSchoolInstructor');
            /** Relation: Flight School Organization */
            FlightSchoolOrganization = new DwItemRelationship('FlightSchoolOrganization|FlightSchoolUser|FlightSchooOrganizationId', 'FlightSchoolOrganization', 'FlightSchoolOrganization');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|FlightSchoolUser|UserId', 'DwUser', 'DwUser');
            /** Relation: User Invite Request Type */
            DwUserInviteRequestType = new DwItemRelationship('dw_UserInviteRequestType|FlightSchoolUser|UserInviteRequestTypeId', 'DwUserInviteRequestType', 'DwUserInviteRequestType');
            /** Relation: Flight School User Branch */
            FlightSchoolUserBranch = new DwItemRelationship('FlightSchoolUser|FlightSchoolUserBranch|FlightSchoolUserId', 'FlightSchoolUserBranch', 'FlightSchoolUserBranch');
    };
export class FlightSchoolUserBranchMetaData implements DwItem2<FlightSchoolUserBranchEntity, FlightSchoolUserBranchMetaDataAttributes,FlightSchoolUserBranchMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1262;
        this.ItemDetail.itemName='FlightSchoolUserBranch';
        this.ItemDetail.keyName='FlightSchoolUserBranchId';
    }

    CreateEntity(): FlightSchoolUserBranchEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolUserBranchQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolUserBranchEntity, FlightSchoolUserBranchMetaDataAttributes,FlightSchoolUserBranchMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolUserBranchMetaDataAttributes();
     Relations = new FlightSchoolUserBranchMetaDataRelations();

}


export type FlightSchoolUserBranchQueryBuilder = DwQueryBuilderGen<FlightSchoolUserBranchEntity, FlightSchoolUserBranchMetaDataAttributes,FlightSchoolUserBranchMetaDataRelations>


export class FlightSchoolUserBranchMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolUserBranch';
    // Attributes
    FlightSchoolUserBranchId = new DwItemAttribute(this.i, 'FlightSchoolUserBranchId');
    FlightSchoolUserId = new DwItemAttribute(this.i, 'FlightSchoolUserId');
    FlightSchoolBranchId = new DwItemAttribute(this.i, 'FlightSchoolBranchId');
}

class FlightSchoolUserBranchMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Branch */
            FlightSchoolBranch = new DwItemRelationship('FlightSchoolBranch|FlightSchoolUserBranch|FlightSchoolBranchId', 'FlightSchoolBranch', 'FlightSchoolBranch');
            /** Relation: Flight School User */
            FlightSchoolUser = new DwItemRelationship('FlightSchoolUser|FlightSchoolUserBranch|FlightSchoolUserId', 'FlightSchoolUser', 'FlightSchoolUser');
    };
export class DwMediaGroupMetaData implements DwItem2<DwMediaGroupEntity, DwMediaGroupMetaDataAttributes,DwMediaGroupMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=188;
        this.ItemDetail.itemName='dw_MediaGroup';
        this.ItemDetail.keyName='MediaGroupId';
    }

    CreateEntity(): DwMediaGroupEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwMediaGroupQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwMediaGroupEntity, DwMediaGroupMetaDataAttributes,DwMediaGroupMetaDataRelations>(query, this);
    }
     Attributes = new DwMediaGroupMetaDataAttributes();
     Relations = new DwMediaGroupMetaDataRelations();

}


export type DwMediaGroupQueryBuilder = DwQueryBuilderGen<DwMediaGroupEntity, DwMediaGroupMetaDataAttributes,DwMediaGroupMetaDataRelations>


export class DwMediaGroupMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_MediaGroup';
    // Attributes
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    GroupName = new DwItemAttribute(this.i, 'GroupName');
    IsGlobalGroup = new DwItemAttribute(this.i, 'IsGlobalGroup');
    IsSecure = new DwItemAttribute(this.i, 'IsSecure');
    MediaGroupId = new DwItemAttribute(this.i, 'MediaGroupId');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    PartyReferenceId = new DwItemAttribute(this.i, 'PartyReferenceId');
}

class DwMediaGroupMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Request - Documents - Many */
            CheckRideRequestByDocumentsMediaGroupId = new DwItemRelationship('dw_MediaGroup|CheckRideRequest|DocumentsMediaGroupId', 'DocumentsCheckRideRequest', 'DocumentsCheckRideRequest');
            /** Relation: Flight School Examiner - Documents - Many */
            FlightSchoolExaminerByDocumentsMediaGroupId = new DwItemRelationship('dw_MediaGroup|FlightSchoolExaminer|DocumentsMediaGroupId', 'DocumentsFlightSchoolExaminer', 'DocumentsFlightSchoolExaminer');
            /** Relation: Ro Media */
            DwRoMedia = new DwItemRelationship('MediaGroup_roMedia', 'DwroMedia', 'DwroMedia');
    };
export class PaymentAttemptMetaData implements DwItem2<PaymentAttemptEntity, PaymentAttemptMetaDataAttributes,PaymentAttemptMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2361;
        this.ItemDetail.itemName='PaymentAttempt';
        this.ItemDetail.keyName='PaymentAttemptId';
    }

    CreateEntity(): PaymentAttemptEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PaymentAttemptQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PaymentAttemptEntity, PaymentAttemptMetaDataAttributes,PaymentAttemptMetaDataRelations>(query, this);
    }
     Attributes = new PaymentAttemptMetaDataAttributes();
     Relations = new PaymentAttemptMetaDataRelations();

}


export type PaymentAttemptQueryBuilder = DwQueryBuilderGen<PaymentAttemptEntity, PaymentAttemptMetaDataAttributes,PaymentAttemptMetaDataRelations>


export class PaymentAttemptMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PaymentAttempt';
    // Attributes
    PaymentAttemptId = new DwItemAttribute(this.i, 'PaymentAttemptId');
    CheckRidePaymentId = new DwItemAttribute(this.i, 'CheckRidePaymentId');
    PaymentReferenceId = new DwItemAttribute(this.i, 'PaymentReferenceId');
    PaymentOperationMeaning = new DwItemAttribute(this.i, 'PaymentOperationMeaning');
    PaymentAttemptStatusMeaning = new DwItemAttribute(this.i, 'PaymentAttemptStatusMeaning');
    AttemptNumber = new DwItemAttribute(this.i, 'AttemptNumber');
    AttemptDateTime = new DwItemAttribute(this.i, 'AttemptDateTime');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    InitiatedByUserId = new DwItemAttribute(this.i, 'InitiatedByUserId');
    ProviderErrorType = new DwItemAttribute(this.i, 'ProviderErrorType');
    ProviderErrorCode = new DwItemAttribute(this.i, 'ProviderErrorCode');
    ProviderErrorMessage = new DwItemAttribute(this.i, 'ProviderErrorMessage');
    UserMessage = new DwItemAttribute(this.i, 'UserMessage');
    ProviderCorrelationId = new DwItemAttribute(this.i, 'ProviderCorrelationId');
    RequiresPayerAction = new DwItemAttribute(this.i, 'RequiresPayerAction');
    IsRetryable = new DwItemAttribute(this.i, 'IsRetryable');
    NextAttemptDateTime = new DwItemAttribute(this.i, 'NextAttemptDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class PaymentAttemptMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Payment */
            CheckRidePayment = new DwItemRelationship('CheckRidePayment|PaymentAttempt|CheckRidePaymentId', 'CheckRidePayment', 'CheckRidePayment');
            /** Relation: Payment Reference */
            PaymentReference = new DwItemRelationship('PaymentReference|PaymentAttempt|PaymentReferenceId', 'PaymentReference', 'PaymentReference');
            /** Relation: User - Initiated By User */
            DwUserByInitiatedByUserId = new DwItemRelationship('dw_User|PaymentAttempt|InitiatedByUserId', 'InitiatedByDwUser', 'InitiatedByDwUser');
    };
export class PaymentCardMetaData implements DwItem2<PaymentCardEntity, PaymentCardMetaDataAttributes,PaymentCardMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2276;
        this.ItemDetail.itemName='PaymentCard';
        this.ItemDetail.keyName='PaymentCardId';
    }

    CreateEntity(): PaymentCardEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PaymentCardQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PaymentCardEntity, PaymentCardMetaDataAttributes,PaymentCardMetaDataRelations>(query, this);
    }
     Attributes = new PaymentCardMetaDataAttributes();
     Relations = new PaymentCardMetaDataRelations();

}


export type PaymentCardQueryBuilder = DwQueryBuilderGen<PaymentCardEntity, PaymentCardMetaDataAttributes,PaymentCardMetaDataRelations>


export class PaymentCardMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PaymentCard';
    // Attributes
    PaymentCardId = new DwItemAttribute(this.i, 'PaymentCardId');
    PaymentCustomerReferenceId = new DwItemAttribute(this.i, 'PaymentCustomerReferenceId');
    PaymentReferenceCardTypeId = new DwItemAttribute(this.i, 'PaymentReferenceCardTypeId');
    CardName = new DwItemAttribute(this.i, 'CardName');
    PaymentCardStatusId = new DwItemAttribute(this.i, 'PaymentCardStatusId');
    CardReferenceKey = new DwItemAttribute(this.i, 'CardReferenceKey');
    ExpirationMonth = new DwItemAttribute(this.i, 'ExpirationMonth');
    ExpirationYear = new DwItemAttribute(this.i, 'ExpirationYear');
    Last4 = new DwItemAttribute(this.i, 'Last4');
    IsDefaultCard = new DwItemAttribute(this.i, 'IsDefaultCard');
    CardholderName = new DwItemAttribute(this.i, 'CardholderName');
}

class PaymentCardMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Payment Card Status */
            PaymentCardStatus = new DwItemRelationship('PaymentCardStatus|PaymentCard|PaymentCardStatusId', 'PaymentCardStatus', 'PaymentCardStatus');
            /** Relation: Payment Customer Reference */
            PaymentCustomerReference = new DwItemRelationship('PaymentCustomerReference|PaymentCard|PaymentCustomerReferenceId', 'PaymentCustomerReference', 'PaymentCustomerReference');
            /** Relation: Payment Reference Card Type */
            PaymentReferenceCardType = new DwItemRelationship('PaymentReferenceCardType|PaymentCard|PaymentReferenceCardTypeId', 'PaymentReferenceCardType', 'PaymentReferenceCardType');
    };
export class PaymentCardStatusMetaData implements DwItem2<PaymentCardStatusEntity, PaymentCardStatusMetaDataAttributes,PaymentCardStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2275;
        this.ItemDetail.itemName='PaymentCardStatus';
        this.ItemDetail.keyName='PaymentCardStatusId';
    }

    CreateEntity(): PaymentCardStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PaymentCardStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PaymentCardStatusEntity, PaymentCardStatusMetaDataAttributes,PaymentCardStatusMetaDataRelations>(query, this);
    }
     Attributes = new PaymentCardStatusMetaDataAttributes();
     Relations = new PaymentCardStatusMetaDataRelations();

}


export type PaymentCardStatusQueryBuilder = DwQueryBuilderGen<PaymentCardStatusEntity, PaymentCardStatusMetaDataAttributes,PaymentCardStatusMetaDataRelations>


export class PaymentCardStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PaymentCardStatus';
    // Attributes
    PaymentCardStatusId = new DwItemAttribute(this.i, 'PaymentCardStatusId');
    PaymentCardStatus = new DwItemAttribute(this.i, 'PaymentCardStatus');
}

class PaymentCardStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Payment Card */
            PaymentCard = new DwItemRelationship('PaymentCardStatus|PaymentCard|PaymentCardStatusId', 'PaymentCard', 'PaymentCard');
    };
export class PaymentCustomerReferenceMetaData implements DwItem2<PaymentCustomerReferenceEntity, PaymentCustomerReferenceMetaDataAttributes,PaymentCustomerReferenceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1174;
        this.ItemDetail.itemName='PaymentCustomerReference';
        this.ItemDetail.keyName='PaymentCustomerReferenceId';
    }

    CreateEntity(): PaymentCustomerReferenceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PaymentCustomerReferenceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PaymentCustomerReferenceEntity, PaymentCustomerReferenceMetaDataAttributes,PaymentCustomerReferenceMetaDataRelations>(query, this);
    }
     Attributes = new PaymentCustomerReferenceMetaDataAttributes();
     Relations = new PaymentCustomerReferenceMetaDataRelations();

}


export type PaymentCustomerReferenceQueryBuilder = DwQueryBuilderGen<PaymentCustomerReferenceEntity, PaymentCustomerReferenceMetaDataAttributes,PaymentCustomerReferenceMetaDataRelations>


export class PaymentCustomerReferenceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PaymentCustomerReference';
    // Attributes
    PaymentCustomerReferenceId = new DwItemAttribute(this.i, 'PaymentCustomerReferenceId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    CustomerReferenceKey = new DwItemAttribute(this.i, 'CustomerReferenceKey');
    PaymentProviderId = new DwItemAttribute(this.i, 'PaymentProviderId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    CheckRideRequestPaymentPartyId = new DwItemAttribute(this.i, 'CheckRideRequestPaymentPartyId');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
}

class PaymentCustomerReferenceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Check Ride Request Payment Party */
            CheckRideRequestPaymentParty = new DwItemRelationship('CheckRideRequestPaymentParty|PaymentCustomerReference|CheckRideRequestPaymentPartyId', 'CheckRideRequestPaymentParty', 'CheckRideRequestPaymentParty');
            /** Relation: Flight School Organization */
            FlightSchoolOrganization = new DwItemRelationship('FlightSchoolOrganization|PaymentCustomerReference|FlightSchoolOrganizationId', 'FlightSchoolOrganization', 'FlightSchoolOrganization');
            /** Relation: Payment Provider */
            PaymentProvider = new DwItemRelationship('PaymentProvider|PaymentCustomerReference|PaymentProviderId', 'PaymentProvider', 'PaymentProvider');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|PaymentCustomerReference|UserId', 'DwUser', 'DwUser');
            /** Relation: Payment Card */
            PaymentCard = new DwItemRelationship('PaymentCustomerReference|PaymentCard|PaymentCustomerReferenceId', 'PaymentCard', 'PaymentCard');
            /** Relation: Payment Reference */
            PaymentReference = new DwItemRelationship('PaymentCustomerReference|PaymentReference|PaymentCustomerReferenceId', 'PaymentReference', 'PaymentReference');
    };
export class PaymentDiscountCodeMetaData implements DwItem2<PaymentDiscountCodeEntity, PaymentDiscountCodeMetaDataAttributes,PaymentDiscountCodeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1180;
        this.ItemDetail.itemName='PaymentDiscountCode';
        this.ItemDetail.keyName='PaymentDiscountCodeId';
    }

    CreateEntity(): PaymentDiscountCodeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PaymentDiscountCodeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PaymentDiscountCodeEntity, PaymentDiscountCodeMetaDataAttributes,PaymentDiscountCodeMetaDataRelations>(query, this);
    }
     Attributes = new PaymentDiscountCodeMetaDataAttributes();
     Relations = new PaymentDiscountCodeMetaDataRelations();

}


export type PaymentDiscountCodeQueryBuilder = DwQueryBuilderGen<PaymentDiscountCodeEntity, PaymentDiscountCodeMetaDataAttributes,PaymentDiscountCodeMetaDataRelations>


export class PaymentDiscountCodeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PaymentDiscountCode';
    // Attributes
    PaymentDiscountCodeId = new DwItemAttribute(this.i, 'PaymentDiscountCodeId');
    DiscountName = new DwItemAttribute(this.i, 'DiscountName');
    DiscountCode = new DwItemAttribute(this.i, 'DiscountCode');
    StartDate = new DwItemAttribute(this.i, 'StartDate');
    EndDate = new DwItemAttribute(this.i, 'EndDate');
    AllowedUses = new DwItemAttribute(this.i, 'AllowedUses');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    LimitToUserId = new DwItemAttribute(this.i, 'LimitToUserId');
    DiscountAmount = new DwItemAttribute(this.i, 'DiscountAmount');
    CurrentUses = new DwItemAttribute(this.i, 'CurrentUses');
    DiscountPercent = new DwItemAttribute(this.i, 'DiscountPercent');
}

class PaymentDiscountCodeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User - Limit To User */
            DwUserByLimitToUserId = new DwItemRelationship('dw_User|PaymentDiscountCode|LimitToUserId', 'LimitToDwUser', 'LimitToDwUser');
            /** Relation: Checkride Payment - Payment Discountid - Many */
            CheckRidePaymentByPaymentDiscountid = new DwItemRelationship('PaymentDiscountCode|CheckRidePayment|PaymentDiscountid', 'PaymentDiscountidCheckRidePayment', 'PaymentDiscountidCheckRidePayment');
            /** Relation: Subscription */
            Subscription = new DwItemRelationship('PaymentDiscountCode|Subscription|PaymentDiscountCodeId', 'Subscription', 'Subscription');
    };
export class PaymentMethodMetaData implements DwItem2<PaymentMethodEntity, PaymentMethodMetaDataAttributes,PaymentMethodMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1149;
        this.ItemDetail.itemName='PaymentMethod';
        this.ItemDetail.keyName='PaymentMethodId';
    }

    CreateEntity(): PaymentMethodEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PaymentMethodQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PaymentMethodEntity, PaymentMethodMetaDataAttributes,PaymentMethodMetaDataRelations>(query, this);
    }
     Attributes = new PaymentMethodMetaDataAttributes();
     Relations = new PaymentMethodMetaDataRelations();

}


export type PaymentMethodQueryBuilder = DwQueryBuilderGen<PaymentMethodEntity, PaymentMethodMetaDataAttributes,PaymentMethodMetaDataRelations>


export class PaymentMethodMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PaymentMethod';
    // Attributes
    PaymentMethodId = new DwItemAttribute(this.i, 'PaymentMethodId');
    PaymentMethod = new DwItemAttribute(this.i, 'PaymentMethod');
}

class PaymentMethodMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Payment */
            CheckRidePayment = new DwItemRelationship('PaymentMethod|CheckRidePayment|PaymentMethodId', 'CheckRidePayment', 'CheckRidePayment');
    };
export class PaymentProviderMetaData implements DwItem2<PaymentProviderEntity, PaymentProviderMetaDataAttributes,PaymentProviderMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1178;
        this.ItemDetail.itemName='PaymentProvider';
        this.ItemDetail.keyName='PaymentProviderId';
    }

    CreateEntity(): PaymentProviderEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PaymentProviderQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PaymentProviderEntity, PaymentProviderMetaDataAttributes,PaymentProviderMetaDataRelations>(query, this);
    }
     Attributes = new PaymentProviderMetaDataAttributes();
     Relations = new PaymentProviderMetaDataRelations();

}


export type PaymentProviderQueryBuilder = DwQueryBuilderGen<PaymentProviderEntity, PaymentProviderMetaDataAttributes,PaymentProviderMetaDataRelations>


export class PaymentProviderMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PaymentProvider';
    // Attributes
    PaymentProviderId = new DwItemAttribute(this.i, 'PaymentProviderId');
    PaymentProviderDisplay = new DwItemAttribute(this.i, 'PaymentProviderDisplay');
    PaymentProviderMeaning = new DwItemAttribute(this.i, 'PaymentProviderMeaning');
}

class PaymentProviderMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Payment Customer Reference */
            PaymentCustomerReference = new DwItemRelationship('PaymentProvider|PaymentCustomerReference|PaymentProviderId', 'PaymentCustomerReference', 'PaymentCustomerReference');
    };
export class PaymentReferenceMetaData implements DwItem2<PaymentReferenceEntity, PaymentReferenceMetaDataAttributes,PaymentReferenceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1175;
        this.ItemDetail.itemName='PaymentReference';
        this.ItemDetail.keyName='PaymentReferenceId';
    }

    CreateEntity(): PaymentReferenceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PaymentReferenceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PaymentReferenceEntity, PaymentReferenceMetaDataAttributes,PaymentReferenceMetaDataRelations>(query, this);
    }
     Attributes = new PaymentReferenceMetaDataAttributes();
     Relations = new PaymentReferenceMetaDataRelations();

}


export type PaymentReferenceQueryBuilder = DwQueryBuilderGen<PaymentReferenceEntity, PaymentReferenceMetaDataAttributes,PaymentReferenceMetaDataRelations>


export class PaymentReferenceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PaymentReference';
    // Attributes
    PaymentReferenceId = new DwItemAttribute(this.i, 'PaymentReferenceId');
    PaymentCustomerReferenceId = new DwItemAttribute(this.i, 'PaymentCustomerReferenceId');
    PaymentReferenceKey = new DwItemAttribute(this.i, 'PaymentReferenceKey');
    PaymentReferenceCardTypeId = new DwItemAttribute(this.i, 'PaymentReferenceCardTypeId');
    PaymentReference = new DwItemAttribute(this.i, 'PaymentReference');
    PaymentReferenceStatusId = new DwItemAttribute(this.i, 'PaymentReferenceStatusId');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    PaymentAmount = new DwItemAttribute(this.i, 'PaymentAmount');
    CardHolderName = new DwItemAttribute(this.i, 'CardHolderName');
}

class PaymentReferenceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Payment Customer Reference */
            PaymentCustomerReference = new DwItemRelationship('PaymentCustomerReference|PaymentReference|PaymentCustomerReferenceId', 'PaymentCustomerReference', 'PaymentCustomerReference');
            /** Relation: Payment Reference Card Type */
            PaymentReferenceCardType = new DwItemRelationship('PaymentReferenceCardType|PaymentReference|PaymentReferenceCardTypeId', 'PaymentReferenceCardType', 'PaymentReferenceCardType');
            /** Relation: Payment Reference Status */
            PaymentReferenceStatus = new DwItemRelationship('PaymentReferenceStatus|PaymentReference|PaymentReferenceStatusId', 'PaymentReferenceStatus', 'PaymentReferenceStatus');
            /** Relation: Checkride Payment */
            CheckRidePayment = new DwItemRelationship('PaymentReference|CheckRidePayment|PaymentReferenceId', 'CheckRidePayment', 'CheckRidePayment');
            /** Relation: Payment Attempt */
            PaymentAttempt = new DwItemRelationship('PaymentReference|PaymentAttempt|PaymentReferenceId', 'PaymentAttempt', 'PaymentAttempt');
    };
export class PaymentReferenceCardTypeMetaData implements DwItem2<PaymentReferenceCardTypeEntity, PaymentReferenceCardTypeMetaDataAttributes,PaymentReferenceCardTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1176;
        this.ItemDetail.itemName='PaymentReferenceCardType';
        this.ItemDetail.keyName='PaymentReferenceCardTypeId';
    }

    CreateEntity(): PaymentReferenceCardTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PaymentReferenceCardTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PaymentReferenceCardTypeEntity, PaymentReferenceCardTypeMetaDataAttributes,PaymentReferenceCardTypeMetaDataRelations>(query, this);
    }
     Attributes = new PaymentReferenceCardTypeMetaDataAttributes();
     Relations = new PaymentReferenceCardTypeMetaDataRelations();

}


export type PaymentReferenceCardTypeQueryBuilder = DwQueryBuilderGen<PaymentReferenceCardTypeEntity, PaymentReferenceCardTypeMetaDataAttributes,PaymentReferenceCardTypeMetaDataRelations>


export class PaymentReferenceCardTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PaymentReferenceCardType';
    // Attributes
    PaymentReferenceCardTypeId = new DwItemAttribute(this.i, 'PaymentReferenceCardTypeId');
    CardTypeDisplay = new DwItemAttribute(this.i, 'CardTypeDisplay');
    CardTypeMeaning = new DwItemAttribute(this.i, 'CardTypeMeaning');
}

class PaymentReferenceCardTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Payment Card */
            PaymentCard = new DwItemRelationship('PaymentReferenceCardType|PaymentCard|PaymentReferenceCardTypeId', 'PaymentCard', 'PaymentCard');
            /** Relation: Payment Reference */
            PaymentReference = new DwItemRelationship('PaymentReferenceCardType|PaymentReference|PaymentReferenceCardTypeId', 'PaymentReference', 'PaymentReference');
    };
export class PaymentReferenceStatusMetaData implements DwItem2<PaymentReferenceStatusEntity, PaymentReferenceStatusMetaDataAttributes,PaymentReferenceStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1177;
        this.ItemDetail.itemName='PaymentReferenceStatus';
        this.ItemDetail.keyName='PaymentReferenceStatusId';
    }

    CreateEntity(): PaymentReferenceStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PaymentReferenceStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PaymentReferenceStatusEntity, PaymentReferenceStatusMetaDataAttributes,PaymentReferenceStatusMetaDataRelations>(query, this);
    }
     Attributes = new PaymentReferenceStatusMetaDataAttributes();
     Relations = new PaymentReferenceStatusMetaDataRelations();

}


export type PaymentReferenceStatusQueryBuilder = DwQueryBuilderGen<PaymentReferenceStatusEntity, PaymentReferenceStatusMetaDataAttributes,PaymentReferenceStatusMetaDataRelations>


export class PaymentReferenceStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PaymentReferenceStatus';
    // Attributes
    PaymentReferenceStatusId = new DwItemAttribute(this.i, 'PaymentReferenceStatusId');
    PaymentReferenceStatus = new DwItemAttribute(this.i, 'PaymentReferenceStatus');
}

class PaymentReferenceStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Payment Reference */
            PaymentReference = new DwItemRelationship('PaymentReferenceStatus|PaymentReference|PaymentReferenceStatusId', 'PaymentReference', 'PaymentReference');
    };
export class PaymentTypeMetaData implements DwItem2<PaymentTypeEntity, PaymentTypeMetaDataAttributes,PaymentTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1150;
        this.ItemDetail.itemName='PaymentType';
        this.ItemDetail.keyName='PaymentTypeId';
    }

    CreateEntity(): PaymentTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PaymentTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PaymentTypeEntity, PaymentTypeMetaDataAttributes,PaymentTypeMetaDataRelations>(query, this);
    }
     Attributes = new PaymentTypeMetaDataAttributes();
     Relations = new PaymentTypeMetaDataRelations();

}


export type PaymentTypeQueryBuilder = DwQueryBuilderGen<PaymentTypeEntity, PaymentTypeMetaDataAttributes,PaymentTypeMetaDataRelations>


export class PaymentTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PaymentType';
    // Attributes
    PaymentTypeId = new DwItemAttribute(this.i, 'PaymentTypeId');
    PaymentType = new DwItemAttribute(this.i, 'PaymentType');
}

class PaymentTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Payment */
            CheckRidePayment = new DwItemRelationship('PaymentType|CheckRidePayment|PaymentTypeId', 'CheckRidePayment', 'CheckRidePayment');
    };
export class PilotCertificateTypeMetaData implements DwItem2<PilotCertificateTypeEntity, PilotCertificateTypeMetaDataAttributes,PilotCertificateTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1195;
        this.ItemDetail.itemName='PilotCertificateType';
        this.ItemDetail.keyName='PilotCertificateTypeId';
    }

    CreateEntity(): PilotCertificateTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PilotCertificateTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PilotCertificateTypeEntity, PilotCertificateTypeMetaDataAttributes,PilotCertificateTypeMetaDataRelations>(query, this);
    }
     Attributes = new PilotCertificateTypeMetaDataAttributes();
     Relations = new PilotCertificateTypeMetaDataRelations();

}


export type PilotCertificateTypeQueryBuilder = DwQueryBuilderGen<PilotCertificateTypeEntity, PilotCertificateTypeMetaDataAttributes,PilotCertificateTypeMetaDataRelations>


export class PilotCertificateTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PilotCertificateType';
    // Attributes
    PilotCertificateTypeId = new DwItemAttribute(this.i, 'PilotCertificateTypeId');
    PilotCertiicateTypeId = new DwItemAttribute(this.i, 'PilotCertiicateTypeId');
}

class PilotCertificateTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Request - Current Pilot Certifiate Type - Many */
            CheckRideRequestByCurrentPilotCertifiateTypeId = new DwItemRelationship('PilotCertificateType|CheckRideRequest|CurrentPilotCertifiateTypeId', 'CurrentPilotCertifiateTypeIdCheckRideRequest', 'CurrentPilotCertifiateTypeIdCheckRideRequest');
            /** Relation: Flight School Applicant - Current - Many */
            FlightSchoolApplicantByCurrentPilotCertificateTypeId = new DwItemRelationship('PilotCertificateType|FlightSchoolApplicant|CurrentPilotCertificateTypeId', 'CurrentFlightSchoolApplicant', 'CurrentFlightSchoolApplicant');
    };
export class PilotExaminerMetaData implements DwItem2<PilotExaminerEntity, PilotExaminerMetaDataAttributes,PilotExaminerMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1137;
        this.ItemDetail.itemName='PilotExaminer';
        this.ItemDetail.keyName='PilotExaminerId';
    }

    CreateEntity(): PilotExaminerEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PilotExaminerQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PilotExaminerEntity, PilotExaminerMetaDataAttributes,PilotExaminerMetaDataRelations>(query, this);
    }
     Attributes = new PilotExaminerMetaDataAttributes();
     Relations = new PilotExaminerMetaDataRelations();

}


export type PilotExaminerQueryBuilder = DwQueryBuilderGen<PilotExaminerEntity, PilotExaminerMetaDataAttributes,PilotExaminerMetaDataRelations>


export class PilotExaminerMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PilotExaminer';
    // Attributes
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    PilotExaminerStatusId = new DwItemAttribute(this.i, 'PilotExaminerStatusId');
    Description = new DwItemAttribute(this.i, 'Description');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    DefaultPreTimeMinutes = new DwItemAttribute(this.i, 'DefaultPreTimeMinutes');
    DefaultPostTimeMinutes = new DwItemAttribute(this.i, 'DefaultPostTimeMinutes');
    TravelRadiusMiles = new DwItemAttribute(this.i, 'TravelRadiusMiles');
    AuthorityExaminerNumber = new DwItemAttribute(this.i, 'AuthorityExaminerNumber');
    CalendarIsLinked = new DwItemAttribute(this.i, 'CalendarIsLinked');
    CalendarReferenceId = new DwItemAttribute(this.i, 'CalendarReferenceId');
    RequireAuthorityPreCheckRideNumber = new DwItemAttribute(this.i, 'RequireAuthorityPreCheckRideNumber');
    PublicProfileIsActive = new DwItemAttribute(this.i, 'PublicProfileIsActive');
    PublicProfileSlug = new DwItemAttribute(this.i, 'PublicProfileSlug');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    CheckRideRequestLeadTimeDays = new DwItemAttribute(this.i, 'CheckRideRequestLeadTimeDays');
    CheckRideRequestBookingMaxWeeksOut = new DwItemAttribute(this.i, 'CheckRideRequestBookingMaxWeeksOut');
    AviationAuthorityDistrictOfficeId = new DwItemAttribute(this.i, 'AviationAuthorityDistrictOfficeId');
    DailyTravelRadiusLockMiles = new DwItemAttribute(this.i, 'DailyTravelRadiusLockMiles');
    PilotExaminerTypeId = new DwItemAttribute(this.i, 'PilotExaminerTypeId');
    AllowAnyFlightSchool = new DwItemAttribute(this.i, 'AllowAnyFlightSchool');
    FlightSchoolScheduleId = new DwItemAttribute(this.i, 'FlightSchoolScheduleId');
    PreventApplicantBooking = new DwItemAttribute(this.i, 'PreventApplicantBooking');
    UseBlockBooking = new DwItemAttribute(this.i, 'UseBlockBooking');
    ScheduleBlockSchoolDefaultOptionId = new DwItemAttribute(this.i, 'ScheduleBlockSchoolDefaultOptionId');
}

class PilotExaminerMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Aviation Authority */
            AviationAuthority = new DwItemRelationship('AviationAuthority|PilotExaminer|AviationAuthorityId', 'AviationAuthority', 'AviationAuthority');
            /** Relation: FSDO */
            AviationAuthorityDistrictOffice = new DwItemRelationship('AviationAuthorityDistrictOffice|PilotExaminer|AviationAuthorityDistrictOfficeId', 'AviationAuthorityDistrictOffice', 'AviationAuthorityDistrictOffice');
            /** Relation: Calendar Reference */
            CalendarReference = new DwItemRelationship('CalendarReference|PilotExaminer|CalendarReferenceId', 'CalendarReference', 'CalendarReference');
            /** Relation: Pilot Examiner Status */
            PilotExaminerStatus = new DwItemRelationship('PilotExaminerStatus|PilotExaminer|PilotExaminerStatusId', 'PilotExaminerStatus', 'PilotExaminerStatus');
            /** Relation: Pilot Examiner Type */
            PilotExaminerType = new DwItemRelationship('PilotExaminerType|PilotExaminer|PilotExaminerTypeId', 'PilotExaminerType', 'PilotExaminerType');
            /** Relation: Custom Calendar - Flight School Schedule */
            ScheduleByFlightSchoolScheduleId = new DwItemRelationship('Schedule|PilotExaminer|FlightSchoolScheduleId', 'FlightSchoolSchedule', 'FlightSchoolSchedule');
            /** Relation: Schedule Block School Booking Option - Schedule Block School Default Option */
            ScheduleBlockSchoolBookingOptionByScheduleBlockSchoolDefaultOptionId = new DwItemRelationship('ScheduleBlockSchoolBookingOption|PilotExaminer|ScheduleBlockSchoolDefaultOptionId', 'ScheduleBlockSchoolDefaultOptionIdScheduleBlockSchoolBookingOption', 'ScheduleBlockSchoolDefaultOptionIdScheduleBlockSchoolBookingOption');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|PilotExaminer|UserId', 'DwUser', 'DwUser');
            /** Relation: Applicant Wait List */
            ApplicantPlaceholder = new DwItemRelationship('PilotExaminer|ApplicantPlaceholder|PilotExaminerId', 'ApplicantPlaceholder', 'ApplicantPlaceholder');
            /** Relation: Calendar Sync Request */
            CalendarSyncRequest = new DwItemRelationship('PilotExaminer|CalendarSyncRequest|PilotExaminerId', 'CalendarSyncRequest', 'CalendarSyncRequest');
            /** Relation: Checkride Request - Scheduled - Many */
            CheckRideRequestByScheduledPilotExaminerId = new DwItemRelationship('PilotExaminer|CheckRideRequest|ScheduledPilotExaminerId', 'ScheduledCheckRideRequest', 'ScheduledCheckRideRequest');
            /** Relation: Exam Type */
            CheckRideScenario = new DwItemRelationship('PilotExaminer|CheckRideScenario|PilotExaminerId', 'CheckRideScenario', 'CheckRideScenario');
            /** Relation: Check Ride Schedule Hold */
            CheckRideScheduleHold = new DwItemRelationship('PilotExaminer|CheckRideScheduleHold|PilotExaminerId', 'CheckRideScheduleHold', 'CheckRideScheduleHold');
            /** Relation: Flight School Examiner */
            FlightSchoolExaminer = new DwItemRelationship('PilotExaminer|FlightSchoolExaminer|PilotExaminerId', 'FlightSchoolExaminer', 'FlightSchoolExaminer');
            /** Relation: Pilot Examiner Flight School Setup */
            PilotExaminerFlightSchoolSetup = new DwItemRelationship('PilotExaminer|PilotExaminerFlightSchoolSetup|PilotExaminerId', 'PilotExaminerFlightSchoolSetup', 'PilotExaminerFlightSchoolSetup');
            /** Relation: Pilot Examiner Location */
            PilotExaminerLocation = new DwItemRelationship('PilotExaminer|PilotExaminerLocation|PilotExaminerId', 'PilotExaminerLocation', 'PilotExaminerLocation');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('PilotExaminer|PlanOfAction|PilotExaminerId', 'PlanOfAction', 'PlanOfAction');
            /** Relation: Question Bank */
            QuestionBank = new DwItemRelationship('PilotExaminer|QuestionBank|PilotExaminerId', 'QuestionBank', 'QuestionBank');
            /** Relation: Ro Pilot Examiner Location Distances */
            RoPilotExaminerLocationDistances = new DwItemRelationship('PilotExaminer|RoPilotExaminerLocation', 'RoPilotExaminerLocationDistances', 'RoPilotExaminerLocationDistances');
            /** Relation: Ro Pilot Examiner Scenario */
            RoPilotExaminerScenario = new DwItemRelationship('PIlotExaminer|RoPilotExaminerScenario', 'RoPilotExaminerScenario', 'RoPilotExaminerScenario');
            /** Relation: Schedule Block */
            ScheduleBlock = new DwItemRelationship('PilotExaminer|ScheduleBlock|PilotExaminerId', 'ScheduleBlock', 'ScheduleBlock');
            /** Relation: Student Applicant - Referred - Many */
            StudentApplicantByReferredPilotExaminerId = new DwItemRelationship('PilotExaminer|StudentApplicant|ReferredPilotExaminerId', 'ReferredStudentApplicant', 'ReferredStudentApplicant');
            /** Relation: Subscription */
            Subscription = new DwItemRelationship('PilotExaminer|Subscription|PilotExaminerId', 'Subscription', 'Subscription');
            /** Relation: Training Record */
            TrainingRecord = new DwItemRelationship('PilotExaminer|TrainingRecord|PilotExaminerId', 'TrainingRecord', 'TrainingRecord');
    };
export class PilotExaminerFlightSchoolSetupMetaData implements DwItem2<PilotExaminerFlightSchoolSetupEntity, PilotExaminerFlightSchoolSetupMetaDataAttributes,PilotExaminerFlightSchoolSetupMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2286;
        this.ItemDetail.itemName='PilotExaminerFlightSchoolSetup';
        this.ItemDetail.keyName='PilotExaminerFlightSchoolSetupId';
    }

    CreateEntity(): PilotExaminerFlightSchoolSetupEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PilotExaminerFlightSchoolSetupQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PilotExaminerFlightSchoolSetupEntity, PilotExaminerFlightSchoolSetupMetaDataAttributes,PilotExaminerFlightSchoolSetupMetaDataRelations>(query, this);
    }
     Attributes = new PilotExaminerFlightSchoolSetupMetaDataAttributes();
     Relations = new PilotExaminerFlightSchoolSetupMetaDataRelations();

}


export type PilotExaminerFlightSchoolSetupQueryBuilder = DwQueryBuilderGen<PilotExaminerFlightSchoolSetupEntity, PilotExaminerFlightSchoolSetupMetaDataAttributes,PilotExaminerFlightSchoolSetupMetaDataRelations>


export class PilotExaminerFlightSchoolSetupMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PilotExaminerFlightSchoolSetup';
    // Attributes
    PilotExaminerFlightSchoolSetupId = new DwItemAttribute(this.i, 'PilotExaminerFlightSchoolSetupId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    AllowFlightSchoolScheduling = new DwItemAttribute(this.i, 'AllowFlightSchoolScheduling');
    FlightSchoolScheduleId = new DwItemAttribute(this.i, 'FlightSchoolScheduleId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    PreventBookingOpenDays = new DwItemAttribute(this.i, 'PreventBookingOpenDays');
    CalendarColorName = new DwItemAttribute(this.i, 'CalendarColorName');
    CalendarBackgroundColor = new DwItemAttribute(this.i, 'CalendarBackgroundColor');
    CalendarForegroundColor = new DwItemAttribute(this.i, 'CalendarForegroundColor');
    ScheduleBlockSchoolDefaultOptionId = new DwItemAttribute(this.i, 'ScheduleBlockSchoolDefaultOptionId');
}

class PilotExaminerFlightSchoolSetupMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|PilotExaminerFlightSchoolSetup|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('PilotExaminer|PilotExaminerFlightSchoolSetup|PilotExaminerId', 'PilotExaminer', 'PilotExaminer');
            /** Relation: Custom Calendar - Flight School Schedule */
            ScheduleByFlightSchoolScheduleId = new DwItemRelationship('Schedule|PilotExaminerFlightSchoolSetup|FlightSchoolScheduleId', 'FlightSchoolSchedule', 'FlightSchoolSchedule');
            /** Relation: Schedule Block School Booking Option - Schedule Block School Default Option */
            ScheduleBlockSchoolBookingOptionByScheduleBlockSchoolDefaultOptionId = new DwItemRelationship('ScheduleBlockSchoolBookingOption|PilotExaminerFlightSchoolSetup|ScheduleBlockSchoolDefaultOptionId', 'ScheduleBlockSchoolDefaultOptionIdScheduleBlockSchoolBookingOption', 'ScheduleBlockSchoolDefaultOptionIdScheduleBlockSchoolBookingOption');
    };
export class PilotExaminerLocationMetaData implements DwItem2<PilotExaminerLocationEntity, PilotExaminerLocationMetaDataAttributes,PilotExaminerLocationMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1141;
        this.ItemDetail.itemName='PilotExaminerLocation';
        this.ItemDetail.keyName='PilotExaminerLocationId';
    }

    CreateEntity(): PilotExaminerLocationEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PilotExaminerLocationQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PilotExaminerLocationEntity, PilotExaminerLocationMetaDataAttributes,PilotExaminerLocationMetaDataRelations>(query, this);
    }
     Attributes = new PilotExaminerLocationMetaDataAttributes();
     Relations = new PilotExaminerLocationMetaDataRelations();

}


export type PilotExaminerLocationQueryBuilder = DwQueryBuilderGen<PilotExaminerLocationEntity, PilotExaminerLocationMetaDataAttributes,PilotExaminerLocationMetaDataRelations>


export class PilotExaminerLocationMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PilotExaminerLocation';
    // Attributes
    PilotExaminerLocationId = new DwItemAttribute(this.i, 'PilotExaminerLocationId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    LocationName = new DwItemAttribute(this.i, 'LocationName');
    SchedulingStartDate = new DwItemAttribute(this.i, 'SchedulingStartDate');
    SchedulingEndDate = new DwItemAttribute(this.i, 'SchedulingEndDate');
    TravelRadiusMile = new DwItemAttribute(this.i, 'TravelRadiusMile');
    BookingScheduleId = new DwItemAttribute(this.i, 'BookingScheduleId');
    TravelCost = new DwItemAttribute(this.i, 'TravelCost');
    IsDefaultLocation = new DwItemAttribute(this.i, 'IsDefaultLocation');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    AdditionalLocationCost = new DwItemAttribute(this.i, 'AdditionalLocationCost');
    BookingScheduleTimeZoneId = new DwItemAttribute(this.i, 'BookingScheduleTimeZoneId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ShowMetar = new DwItemAttribute(this.i, 'ShowMetar');
    PilotExaminerLocationTypeId = new DwItemAttribute(this.i, 'PilotExaminerLocationTypeId');
}

class PilotExaminerLocationMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('PilotExaminer|PilotExaminerLocation|PilotExaminerId', 'PilotExaminer', 'PilotExaminer');
            /** Relation: Pilot Examiner Location Type */
            PilotExaminerLocationType = new DwItemRelationship('PilotExaminerLocationType|PilotExaminerLocation|PilotExaminerLocationTypeId', 'PilotExaminerLocationType', 'PilotExaminerLocationType');
            /** Relation: Custom Calendar - Booking Days */
            ScheduleByBookingScheduleId = new DwItemRelationship('Schedule|PilotExaminerLocation|BookingScheduleId', 'BookingSchedule', 'BookingSchedule');
            /** Relation: Time Zone - Booking Timezone */
            TimeZoneByBookingScheduleTimeZoneId = new DwItemRelationship('TimeZone|PilotExaminerLocation|BookingScheduleTimeZoneId', 'BookingScheduleTimeZoneIdTimeZone', 'BookingScheduleTimeZoneIdTimeZone');
            /** Relation: Checkride Request - Scheduled - Many */
            CheckRideRequestByScheduledPilotExaminerLocationId = new DwItemRelationship('PilotExaminerLocation|CheckRideRequest|ScheduledPilotExaminerLocationId', 'ScheduledCheckRideRequest', 'ScheduledCheckRideRequest');
            /** Relation: Pilot Examiner Location Airport */
            PilotExaminerLocationAirport = new DwItemRelationship('PilotExaminerLocation|PilotExaminerLocationAirport|PilotExaminerLocationId', 'PilotExaminerLocationAirport', 'PilotExaminerLocationAirport');
            /** Relation: Ro Pilot Examiner Location Current */
            RoPilotExaminerLocationCurrent = new DwItemRelationship('PilotExaminerLocation|roPilotExaminerLocationCurrent', 'RoPilotExaminerLocationCurrent', 'RoPilotExaminerLocationCurrent');
            /** Relation: Ro Pilot Examiner Location Distances */
            RoPilotExaminerLocationDistances = new DwItemRelationship('PIlotExaminerLocation|RoPilotExaminerLocation', 'RoPilotExaminerLocationDistances', 'RoPilotExaminerLocationDistances');
            /** Relation: Schedule Block Location */
            ScheduleBlockLocation = new DwItemRelationship('PilotExaminerLocation|ScheduleBlockLocation|PilotExaminerLocaiontId', 'ScheduleBlockLocation', 'ScheduleBlockLocation');
    };
export class PilotExaminerLocationAirportMetaData implements DwItem2<PilotExaminerLocationAirportEntity, PilotExaminerLocationAirportMetaDataAttributes,PilotExaminerLocationAirportMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1160;
        this.ItemDetail.itemName='PilotExaminerLocationAirport';
        this.ItemDetail.keyName='PilotExaminerLocationAirportId';
    }

    CreateEntity(): PilotExaminerLocationAirportEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PilotExaminerLocationAirportQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PilotExaminerLocationAirportEntity, PilotExaminerLocationAirportMetaDataAttributes,PilotExaminerLocationAirportMetaDataRelations>(query, this);
    }
     Attributes = new PilotExaminerLocationAirportMetaDataAttributes();
     Relations = new PilotExaminerLocationAirportMetaDataRelations();

}


export type PilotExaminerLocationAirportQueryBuilder = DwQueryBuilderGen<PilotExaminerLocationAirportEntity, PilotExaminerLocationAirportMetaDataAttributes,PilotExaminerLocationAirportMetaDataRelations>


export class PilotExaminerLocationAirportMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PilotExaminerLocationAirport';
    // Attributes
    PilotExaminerLocationAirportId = new DwItemAttribute(this.i, 'PilotExaminerLocationAirportId');
    PilotExaminerLocationId = new DwItemAttribute(this.i, 'PilotExaminerLocationId');
    AirportId = new DwItemAttribute(this.i, 'AirportId');
}

class PilotExaminerLocationAirportMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Airport */
            Airport = new DwItemRelationship('Airport|PilotExaminerLocationAirport|AirportId', 'Airport', 'Airport');
            /** Relation: Pilot Examiner Location */
            PilotExaminerLocation = new DwItemRelationship('PilotExaminerLocation|PilotExaminerLocationAirport|PilotExaminerLocationId', 'PilotExaminerLocation', 'PilotExaminerLocation');
    };
export class PilotExaminerLocationStateMetaData implements DwItem2<PilotExaminerLocationStateEntity, PilotExaminerLocationStateMetaDataAttributes,PilotExaminerLocationStateMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1168;
        this.ItemDetail.itemName='PilotExaminerLocationState';
        this.ItemDetail.keyName='PilotExaminerLocationStateId';
    }

    CreateEntity(): PilotExaminerLocationStateEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PilotExaminerLocationStateQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PilotExaminerLocationStateEntity, PilotExaminerLocationStateMetaDataAttributes,PilotExaminerLocationStateMetaDataRelations>(query, this);
    }
     Attributes = new PilotExaminerLocationStateMetaDataAttributes();
     Relations = new PilotExaminerLocationStateMetaDataRelations();

}


export type PilotExaminerLocationStateQueryBuilder = DwQueryBuilderGen<PilotExaminerLocationStateEntity, PilotExaminerLocationStateMetaDataAttributes,PilotExaminerLocationStateMetaDataRelations>


export class PilotExaminerLocationStateMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PilotExaminerLocationState';
    // Attributes
    PilotExaminerLocationStateId = new DwItemAttribute(this.i, 'PilotExaminerLocationStateId');
    StateMeaning = new DwItemAttribute(this.i, 'StateMeaning');
    StateDisplay = new DwItemAttribute(this.i, 'StateDisplay');
}

class PilotExaminerLocationStateMetaDataRelations implements DwItemRelationshipCollection {
    };
export class PilotExaminerLocationTypeMetaData implements DwItem2<PilotExaminerLocationTypeEntity, PilotExaminerLocationTypeMetaDataAttributes,PilotExaminerLocationTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1224;
        this.ItemDetail.itemName='PilotExaminerLocationType';
        this.ItemDetail.keyName='PilotExaminerLocationTypeId';
    }

    CreateEntity(): PilotExaminerLocationTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PilotExaminerLocationTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PilotExaminerLocationTypeEntity, PilotExaminerLocationTypeMetaDataAttributes,PilotExaminerLocationTypeMetaDataRelations>(query, this);
    }
     Attributes = new PilotExaminerLocationTypeMetaDataAttributes();
     Relations = new PilotExaminerLocationTypeMetaDataRelations();

}


export type PilotExaminerLocationTypeQueryBuilder = DwQueryBuilderGen<PilotExaminerLocationTypeEntity, PilotExaminerLocationTypeMetaDataAttributes,PilotExaminerLocationTypeMetaDataRelations>


export class PilotExaminerLocationTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PilotExaminerLocationType';
    // Attributes
    PilotExaminerLocationTypeId = new DwItemAttribute(this.i, 'PilotExaminerLocationTypeId');
    PilotExaminerLocationType = new DwItemAttribute(this.i, 'PilotExaminerLocationType');
}

class PilotExaminerLocationTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Pilot Examiner Location */
            PilotExaminerLocation = new DwItemRelationship('PilotExaminerLocationType|PilotExaminerLocation|PilotExaminerLocationTypeId', 'PilotExaminerLocation', 'PilotExaminerLocation');
    };
export class PilotExaminerStatusMetaData implements DwItem2<PilotExaminerStatusEntity, PilotExaminerStatusMetaDataAttributes,PilotExaminerStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1136;
        this.ItemDetail.itemName='PilotExaminerStatus';
        this.ItemDetail.keyName='PilotExaminerStatusId';
    }

    CreateEntity(): PilotExaminerStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PilotExaminerStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PilotExaminerStatusEntity, PilotExaminerStatusMetaDataAttributes,PilotExaminerStatusMetaDataRelations>(query, this);
    }
     Attributes = new PilotExaminerStatusMetaDataAttributes();
     Relations = new PilotExaminerStatusMetaDataRelations();

}


export type PilotExaminerStatusQueryBuilder = DwQueryBuilderGen<PilotExaminerStatusEntity, PilotExaminerStatusMetaDataAttributes,PilotExaminerStatusMetaDataRelations>


export class PilotExaminerStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PilotExaminerStatus';
    // Attributes
    PilotExaminerStatusId = new DwItemAttribute(this.i, 'PilotExaminerStatusId');
    PilotExaminerStatus = new DwItemAttribute(this.i, 'PilotExaminerStatus');
    WorkflowStatusDetailId = new DwItemAttribute(this.i, 'WorkflowStatusDetailId');
}

class PilotExaminerStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('PilotExaminerStatus|PilotExaminer|PilotExaminerStatusId', 'PilotExaminer', 'PilotExaminer');
    };
export class PilotExaminerTypeMetaData implements DwItem2<PilotExaminerTypeEntity, PilotExaminerTypeMetaDataAttributes,PilotExaminerTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1268;
        this.ItemDetail.itemName='PilotExaminerType';
        this.ItemDetail.keyName='PilotExaminerTypeId';
    }

    CreateEntity(): PilotExaminerTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PilotExaminerTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PilotExaminerTypeEntity, PilotExaminerTypeMetaDataAttributes,PilotExaminerTypeMetaDataRelations>(query, this);
    }
     Attributes = new PilotExaminerTypeMetaDataAttributes();
     Relations = new PilotExaminerTypeMetaDataRelations();

}


export type PilotExaminerTypeQueryBuilder = DwQueryBuilderGen<PilotExaminerTypeEntity, PilotExaminerTypeMetaDataAttributes,PilotExaminerTypeMetaDataRelations>


export class PilotExaminerTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PilotExaminerType';
    // Attributes
    PilotExaminerTypeId = new DwItemAttribute(this.i, 'PilotExaminerTypeId');
    PilotExaminerType = new DwItemAttribute(this.i, 'PilotExaminerType');
    TypeDescription = new DwItemAttribute(this.i, 'TypeDescription');
}

class PilotExaminerTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('PilotExaminerType|PilotExaminer|PilotExaminerTypeId', 'PilotExaminer', 'PilotExaminer');
    };
export class PlanOfActionMetaData implements DwItem2<PlanOfActionEntity, PlanOfActionMetaDataAttributes,PlanOfActionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1217;
        this.ItemDetail.itemName='PlanOfAction';
        this.ItemDetail.keyName='PlanOfActionId';
    }

    CreateEntity(): PlanOfActionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PlanOfActionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PlanOfActionEntity, PlanOfActionMetaDataAttributes,PlanOfActionMetaDataRelations>(query, this);
    }
     Attributes = new PlanOfActionMetaDataAttributes();
     Relations = new PlanOfActionMetaDataRelations();

}


export type PlanOfActionQueryBuilder = DwQueryBuilderGen<PlanOfActionEntity, PlanOfActionMetaDataAttributes,PlanOfActionMetaDataRelations>


export class PlanOfActionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PlanOfAction';
    // Attributes
    PlanOfActionId = new DwItemAttribute(this.i, 'PlanOfActionId');
    PlanOfActionName = new DwItemAttribute(this.i, 'PlanOfActionName');
    PlanOfActionStatusId = new DwItemAttribute(this.i, 'PlanOfActionStatusId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    AcsTestId = new DwItemAttribute(this.i, 'AcsTestId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    CheckrideDateTime = new DwItemAttribute(this.i, 'CheckrideDateTime');
    StudentApplicantNameManual = new DwItemAttribute(this.i, 'StudentApplicantNameManual');
    StudentApplicantEmailManual = new DwItemAttribute(this.i, 'StudentApplicantEmailManual');
    StudentApplicantPhoneManual = new DwItemAttribute(this.i, 'StudentApplicantPhoneManual');
    StudentApplicantCitizenshipCountryId = new DwItemAttribute(this.i, 'StudentApplicantCitizenshipCountryId');
    AuthorityPreCheckRideNumber = new DwItemAttribute(this.i, 'AuthorityPreCheckRideNumber');
    PilotCertificateNumber = new DwItemAttribute(this.i, 'PilotCertificateNumber');
    AirplaneNNumber = new DwItemAttribute(this.i, 'AirplaneNNumber');
    AuthorityPreapprovalCode = new DwItemAttribute(this.i, 'AuthorityPreapprovalCode');
    AuthorityApprovalCode = new DwItemAttribute(this.i, 'Authority Approval Code');
    ApplicationPaperworkCorrect = new DwItemAttribute(this.i, 'ApplicationPaperworkCorrect');
    EndorsementsPaperworkCorrect = new DwItemAttribute(this.i, 'EndorsementsPaperworkCorrect');
    OptionsShowQuestionForAcsCode = new DwItemAttribute(this.i, 'OptionsShowQuestionForAcsCode');
    IsTemplate = new DwItemAttribute(this.i, 'IsTemplate');
    IsSharedTemplate = new DwItemAttribute(this.i, 'IsSharedTemplate');
    TemplatePlanOfActionId = new DwItemAttribute(this.i, 'TemplatePlanOfActionId');
    IsBuiltIn = new DwItemAttribute(this.i, 'IsBuiltIn');
    OwnerUserId = new DwItemAttribute(this.i, 'OwnerUserId');
    PlanOfActionResultId = new DwItemAttribute(this.i, 'PlanOfActionResultId');
    LinkToCheckride = new DwItemAttribute(this.i, 'LinkToCheckride');
    ApplicantAcsWrittenResultId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultId');
    CheckRideAirportId = new DwItemAttribute(this.i, 'CheckRideAirportId');
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    CheckRideTypeId = new DwItemAttribute(this.i, 'CheckRideTypeId');
    CheckRideTestTypeId = new DwItemAttribute(this.i, 'CheckRideTestTypeId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    StudentApplicantStateProvinceId = new DwItemAttribute(this.i, 'StudentApplicantStateProvinceId');
    ForeignPilotMeetsQualifications = new DwItemAttribute(this.i, 'ForeignPilotMeetsQualifications');
    PrimaryTraningAirportId = new DwItemAttribute(this.i, 'PrimaryTraningAirportId');
    // Attribute code name is not unique - appending Meta Data Attribute Id;
    AuthorityApprovalCode_6114 = new DwItemAttribute(this.i, 'AuthorityApprovalCode');
    AuthorityApplicationNumber = new DwItemAttribute(this.i, 'AuthorityApplicationNumber');
    CheckRideOwnershipTypeId = new DwItemAttribute(this.i, 'CheckRideOwnershipTypeId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    FlightSchoolApplicantId = new DwItemAttribute(this.i, 'FlightSchoolApplicantId');
    FlightSchoolInstructorId = new DwItemAttribute(this.i, 'FlightSchoolInstructorId');
    CheckRideExaminerTypeId = new DwItemAttribute(this.i, 'CheckRideExaminerTypeId');
    CheckRideApplicantTypeId = new DwItemAttribute(this.i, 'CheckRideApplicantTypeId');
    FlightSchoolTypeId = new DwItemAttribute(this.i, 'FlightSchoolTypeId');
    CheckRideInstructorTypeId = new DwItemAttribute(this.i, 'CheckRideInstructorTypeId');
    FlightInstructorName = new DwItemAttribute(this.i, 'FlightInstructorName');
    FlightInstructorEmail = new DwItemAttribute(this.i, 'FlightInstructorEmail');
    FlightInstructorPhone = new DwItemAttribute(this.i, 'FlightInstructorPhone');
    FlightInstructorCertificateNumber = new DwItemAttribute(this.i, 'FlightInstructorCertificateNumber');
    OdaFlightSchoolId = new DwItemAttribute(this.i, 'OdaFlightSchoolId');
}

class PlanOfActionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: ACS Test */
            AcsTest = new DwItemRelationship('AcsTest|PlanOfAction|AcsTestId', 'AcsTest', 'AcsTest');
            /** Relation: Airport - Checkride Airport */
            AirportByCheckRideAirportId = new DwItemRelationship('Airport|PlanOfAction|CheckRideAirportId', 'CheckRideAirport', 'CheckRideAirport');
            /** Relation: Airport - Primary Traning Airport */
            AirportByPrimaryTraningAirportId = new DwItemRelationship('Airport|PlanOfAction|PrimaryTraningAirportId', 'PrimaryTraningAirport', 'PrimaryTraningAirport');
            /** Relation: Applicant Acs Written Result */
            ApplicantAcsWrittenResult = new DwItemRelationship('ApplicantAcsWrittenResult|PlanOfAction|ApplicantAcsWrittenResultId', 'ApplicantAcsWrittenResult', 'ApplicantAcsWrittenResult');
            /** Relation: Aviation Authority */
            AviationAuthority = new DwItemRelationship('AviationAuthority|PlanOfAction|AviationAuthorityId', 'AviationAuthority', 'AviationAuthority');
            /** Relation: Check Ride Applicant Type */
            CheckRideApplicantType = new DwItemRelationship('CheckRideApplicantType|PlanOfAction|CheckRideApplicantTypeId', 'CheckRideApplicantType', 'CheckRideApplicantType');
            /** Relation: Check Ride Examiner Type */
            CheckRideExaminerType = new DwItemRelationship('CheckRideExaminerType|PlanOfAction|CheckRideExaminerTypeId', 'CheckRideExaminerType', 'CheckRideExaminerType');
            /** Relation: Checkride Group */
            CheckRideGroup = new DwItemRelationship('CheckRideGroup|PlanOfAction|CheckRideGroupId', 'CheckRideGroup', 'CheckRideGroup');
            /** Relation: Check Ride Instructor Type */
            CheckRideInstructorType = new DwItemRelationship('CheckRideInstructorType|PlanOfAction|CheckRideInstructorTypeId', 'CheckRideInstructorType', 'CheckRideInstructorType');
            /** Relation: Check Ride Ownership Type */
            CheckRideOwnershipType = new DwItemRelationship('CheckRideOwnershipType|PlanOfAction|CheckRideOwnershipTypeId', 'CheckRideOwnershipType', 'CheckRideOwnershipType');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('CheckRideRequest|PlanOfAction|CheckRideRequestId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Checkride Test Type */
            CheckRideTestType = new DwItemRelationship('CheckRideTestType|PlanOfAction|CheckRideTestTypeId', 'CheckRideTestType', 'CheckRideTestType');
            /** Relation: Checkride Type */
            CheckRideType = new DwItemRelationship('CheckRideType|PlanOfAction|CheckRideTypeId', 'CheckRideType', 'CheckRideType');
            /** Relation: Country - Applicant Citizenship */
            CountryByStudentApplicantCitizenshipCountryId = new DwItemRelationship('Country|PlanOfAction|StudentApplicantCitizenshipCountryId', 'StudentApplicantCitizenshipCountry', 'StudentApplicantCitizenshipCountry');
            /** Relation: Flight School - Oda Flight School */
            FlightSchoolByOdaFlightSchoolId = new DwItemRelationship('FlightSchool|PlanOfAction|OdaFlightSchoolId', 'OdaFlightSchool', 'OdaFlightSchool');
            /** Relation: Flight School Applicant */
            FlightSchoolApplicant = new DwItemRelationship('FlightSchoolApplicant|PlanOfAction|FlightSchoolApplicantId', 'FlightSchoolApplicant', 'FlightSchoolApplicant');
            /** Relation: Flight School Examiner */
            FlightSchoolExaminer = new DwItemRelationship('FlightSchoolExaminer|PlanOfAction|FlightSchoolExaminerId', 'FlightSchoolExaminer', 'FlightSchoolExaminer');
            /** Relation: Flight School Instructor */
            FlightSchoolInstructor = new DwItemRelationship('FlightSchoolInstructor|PlanOfAction|FlightSchoolInstructorId', 'FlightSchoolInstructor', 'FlightSchoolInstructor');
            /** Relation: Flight School Organization */
            FlightSchoolOrganization = new DwItemRelationship('FlightSchoolOrganization|PlanOfAction|FlightSchoolOrganizationId', 'FlightSchoolOrganization', 'FlightSchoolOrganization');
            /** Relation: Flight School Type */
            FlightSchoolType = new DwItemRelationship('FlightSchoolType|PlanOfAction|FlightSchoolTypeId', 'FlightSchoolType', 'FlightSchoolType');
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('PilotExaminer|PlanOfAction|PilotExaminerId', 'PilotExaminer', 'PilotExaminer');
            /** Relation: Plan Of Action Result */
            PlanOfActionResult = new DwItemRelationship('PlanOfActionResult|PlanOfAction|PlanOfActionResultId', 'PlanOfActionResult', 'PlanOfActionResult');
            /** Relation: Plan Of Action Status */
            PlanOfActionStatus = new DwItemRelationship('PlanOfActionStatus|PlanOfAction|PlanOfActionStatusId', 'PlanOfActionStatus', 'PlanOfActionStatus');
            /** Relation: State Province - Student Applicant State Province */
            StateProvinceByStudentApplicantStateProvinceId = new DwItemRelationship('StateProvince|PlanOfAction|StudentApplicantStateProvinceId', 'StudentApplicantStateProvince', 'StudentApplicantStateProvince');
            /** Relation: Plan Of Action - Template Plan Of Action - One */
            PlanOfActionByTemplatePlanOfActionId = new DwItemRelationship('PlanOfAction|PlanOfAction|TemplatePlanOfActionId', 'TemplatePlanOfAction', 'TemplatePlanOfAction');
            /** Relation: Post Exam AI Summary */
            CheckRideAISummary = new DwItemRelationship('PlanOfAction|CheckRideAISummary|PlanOfActionId', 'CheckRideAISummary', 'CheckRideAISummary');
            /** Relation: Plan Of Action Required Acs Code */
            PlanOfActionRequiredAcsCode = new DwItemRelationship('PlanOfAction|PlanOfActionRequiredAcsCode|PlanOfActionId', 'PlanOfActionRequiredAcsCode', 'PlanOfActionRequiredAcsCode');
            /** Relation: Plan Of Action Section */
            PlanOfActionSection = new DwItemRelationship('PlanOfAction|PlanOfActionSection|PlanOfActionId', 'PlanOfActionSection', 'PlanOfActionSection');
            /** Relation: Ro Plan Of Action Details */
            RoPlanOfActionDetails = new DwItemRelationship('PlanOfAction|roPlanOfActionDetails|PlanOfActionId', 'RoPlanOfActionDetails', 'RoPlanOfActionDetails');
    };
export class PlanOfActionQuestionResultMetaData implements DwItem2<PlanOfActionQuestionResultEntity, PlanOfActionQuestionResultMetaDataAttributes,PlanOfActionQuestionResultMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1226;
        this.ItemDetail.itemName='PlanOfActionQuestionResult';
        this.ItemDetail.keyName='PlanOfActionQuestionResultId';
    }

    CreateEntity(): PlanOfActionQuestionResultEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PlanOfActionQuestionResultQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PlanOfActionQuestionResultEntity, PlanOfActionQuestionResultMetaDataAttributes,PlanOfActionQuestionResultMetaDataRelations>(query, this);
    }
     Attributes = new PlanOfActionQuestionResultMetaDataAttributes();
     Relations = new PlanOfActionQuestionResultMetaDataRelations();

}


export type PlanOfActionQuestionResultQueryBuilder = DwQueryBuilderGen<PlanOfActionQuestionResultEntity, PlanOfActionQuestionResultMetaDataAttributes,PlanOfActionQuestionResultMetaDataRelations>


export class PlanOfActionQuestionResultMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PlanOfActionQuestionResult';
    // Attributes
    PlanOfActionQuestionResultId = new DwItemAttribute(this.i, 'PlanOfActionQuestionResultId');
    PlanOfActionResultId = new DwItemAttribute(this.i, 'PlanOfActionResultId');
    PlanOfActionSectionQuestionId = new DwItemAttribute(this.i, 'PlanOfActionSectionQuestionId');
    QuestionOutcomeId = new DwItemAttribute(this.i, 'QuestionOutcomeId');
    DiscussQuestion = new DwItemAttribute(this.i, 'DiscussQuestion');
    Notes = new DwItemAttribute(this.i, 'Notes');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class PlanOfActionQuestionResultMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Plan Of Action Result */
            PlanOfActionResult = new DwItemRelationship('PlanOfActionResult|PlanOfActionQuestionResult|PlanOfActionResultId', 'PlanOfActionResult', 'PlanOfActionResult');
            /** Relation: Plan Of Action Section Question */
            PlanOfActionSectionQuestion = new DwItemRelationship('PlanOfActionSectionQuestion|PlanOfActionQuestionResult|PlanOfActionSectionQuestionId', 'PlanOfActionSectionQuestion', 'PlanOfActionSectionQuestion');
            /** Relation: Question Outcome */
            QuestionOutcome = new DwItemRelationship('QuestionOutcome|PlanOfActionQuestionResult|QuestionOutcomeId', 'QuestionOutcome', 'QuestionOutcome');
    };
export class PlanOfActionRequiredAcsCodeMetaData implements DwItem2<PlanOfActionRequiredAcsCodeEntity, PlanOfActionRequiredAcsCodeMetaDataAttributes,PlanOfActionRequiredAcsCodeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1222;
        this.ItemDetail.itemName='PlanOfActionRequiredAcsCode';
        this.ItemDetail.keyName='PlanOfActionRequiredAcsCodeId';
    }

    CreateEntity(): PlanOfActionRequiredAcsCodeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PlanOfActionRequiredAcsCodeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PlanOfActionRequiredAcsCodeEntity, PlanOfActionRequiredAcsCodeMetaDataAttributes,PlanOfActionRequiredAcsCodeMetaDataRelations>(query, this);
    }
     Attributes = new PlanOfActionRequiredAcsCodeMetaDataAttributes();
     Relations = new PlanOfActionRequiredAcsCodeMetaDataRelations();

}


export type PlanOfActionRequiredAcsCodeQueryBuilder = DwQueryBuilderGen<PlanOfActionRequiredAcsCodeEntity, PlanOfActionRequiredAcsCodeMetaDataAttributes,PlanOfActionRequiredAcsCodeMetaDataRelations>


export class PlanOfActionRequiredAcsCodeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PlanOfActionRequiredAcsCode';
    // Attributes
    PlanOfActionRequiredAcsCodeId = new DwItemAttribute(this.i, 'PlanOfActionRequiredAcsCodeId');
    PlanOfActionId = new DwItemAttribute(this.i, 'PlanOfActionId');
    AcsCodeId = new DwItemAttribute(this.i, 'AcsCodeId');
}

class PlanOfActionRequiredAcsCodeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: ACS Code */
            AcsCode = new DwItemRelationship('AcsCode|PlanOfActionRequiredAcsCode|AscCodeId', 'AcsCode', 'AcsCode');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('PlanOfAction|PlanOfActionRequiredAcsCode|PlanOfActionId', 'PlanOfAction', 'PlanOfAction');
    };
export class PlanOfActionResultMetaData implements DwItem2<PlanOfActionResultEntity, PlanOfActionResultMetaDataAttributes,PlanOfActionResultMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1225;
        this.ItemDetail.itemName='PlanOfActionResult';
        this.ItemDetail.keyName='PlanOfActionResultId';
    }

    CreateEntity(): PlanOfActionResultEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PlanOfActionResultQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PlanOfActionResultEntity, PlanOfActionResultMetaDataAttributes,PlanOfActionResultMetaDataRelations>(query, this);
    }
     Attributes = new PlanOfActionResultMetaDataAttributes();
     Relations = new PlanOfActionResultMetaDataRelations();

}


export type PlanOfActionResultQueryBuilder = DwQueryBuilderGen<PlanOfActionResultEntity, PlanOfActionResultMetaDataAttributes,PlanOfActionResultMetaDataRelations>


export class PlanOfActionResultMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PlanOfActionResult';
    // Attributes
    PlanOfActionResultId = new DwItemAttribute(this.i, 'PlanOfActionResultId');
    CheckRideStartDateTime = new DwItemAttribute(this.i, 'CheckRideStartDateTime');
    CheckRideEndDateTime = new DwItemAttribute(this.i, 'CheckRideEndDateTime');
    TotalTimeGroundMinutes = new DwItemAttribute(this.i, 'TotalTimeGroundMinutes');
    TotalTimeFlightMinute = new DwItemAttribute(this.i, 'TotalTimeFlightMinute');
    CheckRideOutcomeId = new DwItemAttribute(this.i, 'CheckRideOutcomeId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    AllowRetest = new DwItemAttribute(this.i, 'AllowRetest');
    AllowRetestReason = new DwItemAttribute(this.i, 'AllowRetestReason');
    RetestCost = new DwItemAttribute(this.i, 'RetestCost');
    FlagApplicant = new DwItemAttribute(this.i, 'FlagApplicant');
    FlagApplicantNotes = new DwItemAttribute(this.i, 'FlagApplicantNotes');
    AddToWaitlist = new DwItemAttribute(this.i, 'AddToWaitlist');
    GroundPortionComplete = new DwItemAttribute(this.i, 'GroundPortionComplete');
    PostApplicantAcsWrittenResultId = new DwItemAttribute(this.i, 'PostApplicantAcsWrittenResultId');
}

class PlanOfActionResultMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Applicant Acs Written Result - Post Applicant Acs Written Result */
            ApplicantAcsWrittenResultByPostApplicantAcsWrittenResultId = new DwItemRelationship('ApplicantAcsWrittenResult|PlanOfActionResult|PostApplicantAcsWrittenResultId', 'PostApplicantAcsWrittenResult', 'PostApplicantAcsWrittenResult');
            /** Relation: Checkride Outcome */
            CheckRideOutcome = new DwItemRelationship('CheckRideOutcome|PlanOfActionResult|CheckRideOutcomeId', 'CheckRideOutcome', 'CheckRideOutcome');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('PlanOfActionResult|PlanOfAction|PlanOfActionResultId', 'PlanOfAction', 'PlanOfAction');
            /** Relation: Plan Of Action Question Result */
            PlanOfActionQuestionResult = new DwItemRelationship('PlanOfActionResult|PlanOfActionQuestionResult|PlanOfActionResultId', 'PlanOfActionQuestionResult', 'PlanOfActionQuestionResult');
    };
export class PlanOfActionSectionMetaData implements DwItem2<PlanOfActionSectionEntity, PlanOfActionSectionMetaDataAttributes,PlanOfActionSectionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1214;
        this.ItemDetail.itemName='PlanOfActionSection';
        this.ItemDetail.keyName='PlanOfActionSectionId';
    }

    CreateEntity(): PlanOfActionSectionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PlanOfActionSectionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PlanOfActionSectionEntity, PlanOfActionSectionMetaDataAttributes,PlanOfActionSectionMetaDataRelations>(query, this);
    }
     Attributes = new PlanOfActionSectionMetaDataAttributes();
     Relations = new PlanOfActionSectionMetaDataRelations();

}


export type PlanOfActionSectionQueryBuilder = DwQueryBuilderGen<PlanOfActionSectionEntity, PlanOfActionSectionMetaDataAttributes,PlanOfActionSectionMetaDataRelations>


export class PlanOfActionSectionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PlanOfActionSection';
    // Attributes
    PlanOfActionSectionId = new DwItemAttribute(this.i, 'PlanOfActionSectionId');
    PlanOfActionId = new DwItemAttribute(this.i, 'PlanOfActionId');
    SectionName = new DwItemAttribute(this.i, 'SectionName');
    PlanOfActionSectionTypeId = new DwItemAttribute(this.i, 'PlanOfActionSectionTypeId');
    AcsAreaOfOperationId = new DwItemAttribute(this.i, 'AcsAreaOfOperationId');
    AcsAreaOfOperationTaskId = new DwItemAttribute(this.i, 'AcsAreaOfOperationTaskId');
    SectionOrder = new DwItemAttribute(this.i, 'SectionOrder');
    AcsTestPortionId = new DwItemAttribute(this.i, 'AcsTestPortionId');
}

class PlanOfActionSectionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Area Of Operation */
            AcsAreaOfOperation = new DwItemRelationship('AcsAreaOfOperation|PlanOfActionSection|AcsAreaOfOperationId', 'AcsAreaOfOperation', 'AcsAreaOfOperation');
            /** Relation: Acs Area Of Operation Task */
            AcsAreaOfOperationTask = new DwItemRelationship('AcsAreaOfOperationTask|PlanOfActionSection|AcsAreaOfOperationTaskId', 'AcsAreaOfOperationTask', 'AcsAreaOfOperationTask');
            /** Relation: Acs Test Portion */
            AcsTestPortion = new DwItemRelationship('AcsTestPortion|PlanOfActionSection|AcsTestPortionId', 'AcsTestPortion', 'AcsTestPortion');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('PlanOfAction|PlanOfActionSection|PlanOfActionId', 'PlanOfAction', 'PlanOfAction');
            /** Relation: Plan Of Action Section Type */
            PlanOfActionSectionType = new DwItemRelationship('PlanOfActionSectionType|PlanOfActionSection|PlanOfActionSectionTypeId', 'PlanOfActionSectionType', 'PlanOfActionSectionType');
            /** Relation: Plan Of Action Section Question */
            PlanOfActionSectionQuestion = new DwItemRelationship('PlanOfActionSection|PlanOfActionSectionQuestion|PlanOfActionSectionId', 'PlanOfActionSectionQuestion', 'PlanOfActionSectionQuestion');
    };
export class PlanOfActionSectionQuestionMetaData implements DwItem2<PlanOfActionSectionQuestionEntity, PlanOfActionSectionQuestionMetaDataAttributes,PlanOfActionSectionQuestionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1215;
        this.ItemDetail.itemName='PlanOfActionSectionQuestion';
        this.ItemDetail.keyName='PlanOfActionSectionQuestionId';
    }

    CreateEntity(): PlanOfActionSectionQuestionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PlanOfActionSectionQuestionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PlanOfActionSectionQuestionEntity, PlanOfActionSectionQuestionMetaDataAttributes,PlanOfActionSectionQuestionMetaDataRelations>(query, this);
    }
     Attributes = new PlanOfActionSectionQuestionMetaDataAttributes();
     Relations = new PlanOfActionSectionQuestionMetaDataRelations();

}


export type PlanOfActionSectionQuestionQueryBuilder = DwQueryBuilderGen<PlanOfActionSectionQuestionEntity, PlanOfActionSectionQuestionMetaDataAttributes,PlanOfActionSectionQuestionMetaDataRelations>


export class PlanOfActionSectionQuestionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PlanOfActionSectionQuestion';
    // Attributes
    PlanOfActionSectionQuestionId = new DwItemAttribute(this.i, 'PlanOfActionSectionQuestionId');
    PlanOfActionSectionId = new DwItemAttribute(this.i, 'PlanOfActionSectionId');
    AcsCodeId = new DwItemAttribute(this.i, 'AcsCodeId');
    QuestionHtml = new DwItemAttribute(this.i, 'QuestionHtml');
    QuestionOrder = new DwItemAttribute(this.i, 'QuestionOrder');
    ShowNotes = new DwItemAttribute(this.i, 'ShowNotes');
}

class PlanOfActionSectionQuestionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: ACS Code */
            AcsCode = new DwItemRelationship('AcsCode|PlanOfActionSectionQuestion|AcsCodeId', 'AcsCode', 'AcsCode');
            /** Relation: Plan Of Action Section */
            PlanOfActionSection = new DwItemRelationship('PlanOfActionSection|PlanOfActionSectionQuestion|PlanOfActionSectionId', 'PlanOfActionSection', 'PlanOfActionSection');
            /** Relation: Plan Of Action Question Result */
            PlanOfActionQuestionResult = new DwItemRelationship('PlanOfActionSectionQuestion|PlanOfActionQuestionResult|PlanOfActionSectionQuestionId', 'PlanOfActionQuestionResult', 'PlanOfActionQuestionResult');
    };
export class PlanOfActionSectionTypeMetaData implements DwItem2<PlanOfActionSectionTypeEntity, PlanOfActionSectionTypeMetaDataAttributes,PlanOfActionSectionTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1213;
        this.ItemDetail.itemName='PlanOfActionSectionType';
        this.ItemDetail.keyName='PlanOfActionSectionTypeId';
    }

    CreateEntity(): PlanOfActionSectionTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PlanOfActionSectionTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PlanOfActionSectionTypeEntity, PlanOfActionSectionTypeMetaDataAttributes,PlanOfActionSectionTypeMetaDataRelations>(query, this);
    }
     Attributes = new PlanOfActionSectionTypeMetaDataAttributes();
     Relations = new PlanOfActionSectionTypeMetaDataRelations();

}


export type PlanOfActionSectionTypeQueryBuilder = DwQueryBuilderGen<PlanOfActionSectionTypeEntity, PlanOfActionSectionTypeMetaDataAttributes,PlanOfActionSectionTypeMetaDataRelations>


export class PlanOfActionSectionTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PlanOfActionSectionType';
    // Attributes
    PlanOfActionSectionTypeId = new DwItemAttribute(this.i, 'PlanOfActionSectionTypeId');
    PlanOfActionSectionType = new DwItemAttribute(this.i, 'PlanOfActionSectionType');
    HasAreaOfOperation = new DwItemAttribute(this.i, 'HasAreaOfOperation');
    HasAreaOfOperationTask = new DwItemAttribute(this.i, 'HasAreaOfOperationTask');
    ShowSkillsOnly = new DwItemAttribute(this.i, 'ShowSkillsOnly');
    AcsTestPortionId = new DwItemAttribute(this.i, 'AcsTestPortionId');
}

class PlanOfActionSectionTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Test Portion */
            AcsTestPortion = new DwItemRelationship('AcsTestPortion|PlanOfActionSectionType|AcsTestPortionId', 'AcsTestPortion', 'AcsTestPortion');
            /** Relation: Plan Of Action Section */
            PlanOfActionSection = new DwItemRelationship('PlanOfActionSectionType|PlanOfActionSection|PlanOfActionSectionTypeId', 'PlanOfActionSection', 'PlanOfActionSection');
    };
export class PlanOfActionStatusMetaData implements DwItem2<PlanOfActionStatusEntity, PlanOfActionStatusMetaDataAttributes,PlanOfActionStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1212;
        this.ItemDetail.itemName='PlanOfActionStatus';
        this.ItemDetail.keyName='PlanOfActionStatusId';
    }

    CreateEntity(): PlanOfActionStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PlanOfActionStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PlanOfActionStatusEntity, PlanOfActionStatusMetaDataAttributes,PlanOfActionStatusMetaDataRelations>(query, this);
    }
     Attributes = new PlanOfActionStatusMetaDataAttributes();
     Relations = new PlanOfActionStatusMetaDataRelations();

}


export type PlanOfActionStatusQueryBuilder = DwQueryBuilderGen<PlanOfActionStatusEntity, PlanOfActionStatusMetaDataAttributes,PlanOfActionStatusMetaDataRelations>


export class PlanOfActionStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PlanOfActionStatus';
    // Attributes
    PlanOfActionStatusId = new DwItemAttribute(this.i, 'PlanOfActionStatusId');
    PlanOfActionStatus = new DwItemAttribute(this.i, 'PlanOfActionStatus');
    PlanOfActionStatusTypeId = new DwItemAttribute(this.i, 'PlanOfActionStatusTypeId');
}

class PlanOfActionStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Plan Of Action Status Type */
            PlanOfActionStatusType = new DwItemRelationship('PlanOfActionStatusType|PlanOfActionStatus|PlanOfActionStatusTypeId', 'PlanOfActionStatusType', 'PlanOfActionStatusType');
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('PlanOfActionStatus|PlanOfAction|PlanOfActionStatusId', 'PlanOfAction', 'PlanOfAction');
    };
export class PlanOfActionStatusTypeMetaData implements DwItem2<PlanOfActionStatusTypeEntity, PlanOfActionStatusTypeMetaDataAttributes,PlanOfActionStatusTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1220;
        this.ItemDetail.itemName='PlanOfActionStatusType';
        this.ItemDetail.keyName='PlanOfActionStatusTypeId';
    }

    CreateEntity(): PlanOfActionStatusTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PlanOfActionStatusTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PlanOfActionStatusTypeEntity, PlanOfActionStatusTypeMetaDataAttributes,PlanOfActionStatusTypeMetaDataRelations>(query, this);
    }
     Attributes = new PlanOfActionStatusTypeMetaDataAttributes();
     Relations = new PlanOfActionStatusTypeMetaDataRelations();

}


export type PlanOfActionStatusTypeQueryBuilder = DwQueryBuilderGen<PlanOfActionStatusTypeEntity, PlanOfActionStatusTypeMetaDataAttributes,PlanOfActionStatusTypeMetaDataRelations>


export class PlanOfActionStatusTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PlanOfActionStatusType';
    // Attributes
    PlanOfActionStatusTypeId = new DwItemAttribute(this.i, 'PlanOfActionStatusTypeId');
    PlanOfActionStatusType = new DwItemAttribute(this.i, 'PlanOfActionStatusType');
}

class PlanOfActionStatusTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Plan Of Action Status */
            PlanOfActionStatus = new DwItemRelationship('PlanOfActionStatusType|PlanOfActionStatus|PlanOfActionStatusTypeId', 'PlanOfActionStatus', 'PlanOfActionStatus');
    };
export class PostalCodeMetaData implements DwItem2<PostalCodeEntity, PostalCodeMetaDataAttributes,PostalCodeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1131;
        this.ItemDetail.itemName='PostalCode';
        this.ItemDetail.keyName='PostalCodeId';
    }

    CreateEntity(): PostalCodeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PostalCodeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PostalCodeEntity, PostalCodeMetaDataAttributes,PostalCodeMetaDataRelations>(query, this);
    }
     Attributes = new PostalCodeMetaDataAttributes();
     Relations = new PostalCodeMetaDataRelations();

}


export type PostalCodeQueryBuilder = DwQueryBuilderGen<PostalCodeEntity, PostalCodeMetaDataAttributes,PostalCodeMetaDataRelations>


export class PostalCodeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PostalCode';
    // Attributes
    PostalCodeId = new DwItemAttribute(this.i, 'PostalCodeId');
    StateProvinceId = new DwItemAttribute(this.i, 'StateProvinceId');
    PostalCode = new DwItemAttribute(this.i, 'PostalCode');
    Plus4 = new DwItemAttribute(this.i, 'Plus4');
    City = new DwItemAttribute(this.i, 'City');
    County = new DwItemAttribute(this.i, 'County');
    AreaCode = new DwItemAttribute(this.i, 'AreaCode');
    Latitude = new DwItemAttribute(this.i, 'Latitude');
    Longitude = new DwItemAttribute(this.i, 'Longitude');
    GmtOffset = new DwItemAttribute(this.i, 'GmtOffset');
    ObservesDst = new DwItemAttribute(this.i, 'ObservesDst');
    IsMetropolitanArea = new DwItemAttribute(this.i, 'IsMetropolitanArea');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    TimeZoneId = new DwItemAttribute(this.i, 'TimeZoneId');
}

class PostalCodeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: State Province */
            StateProvince = new DwItemRelationship('StateProvince|PostalCode|StateProvinceId', 'StateProvince', 'StateProvince');
            /** Relation: Time Zone - Timezone */
            TimeZoneByTimeZoneId = new DwItemRelationship('TimeZone|PostalCode|TimeZoneId', 'TimeZoneIdTimeZone', 'TimeZoneIdTimeZone');
    };
export class DwProcessDefinitionMetaData implements DwItem2<DwProcessDefinitionEntity, DwProcessDefinitionMetaDataAttributes,DwProcessDefinitionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=239;
        this.ItemDetail.itemName='dw_ProcessDefinition';
        this.ItemDetail.keyName='ProcessDefinitionId';
    }

    CreateEntity(): DwProcessDefinitionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwProcessDefinitionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwProcessDefinitionEntity, DwProcessDefinitionMetaDataAttributes,DwProcessDefinitionMetaDataRelations>(query, this);
    }
     Attributes = new DwProcessDefinitionMetaDataAttributes();
     Relations = new DwProcessDefinitionMetaDataRelations();

}


export type DwProcessDefinitionQueryBuilder = DwQueryBuilderGen<DwProcessDefinitionEntity, DwProcessDefinitionMetaDataAttributes,DwProcessDefinitionMetaDataRelations>


export class DwProcessDefinitionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_ProcessDefinition';
    // Attributes
    ConfigJSON = new DwItemAttribute(this.i, 'ConfigJSON');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ProcessDefinitionId = new DwItemAttribute(this.i, 'ProcessDefinitionId');
    ProcessDescription = new DwItemAttribute(this.i, 'ProcessDescription');
    ProcessDisplay = new DwItemAttribute(this.i, 'ProcessDisplay');
    ProcessMeaning = new DwItemAttribute(this.i, 'ProcessMeaning');
    ProcessTypeId = new DwItemAttribute(this.i, 'ProcessTypeId');
}

class DwProcessDefinitionMetaDataRelations implements DwItemRelationshipCollection {
    };
export class QuestionBankMetaData implements DwItem2<QuestionBankEntity, QuestionBankMetaDataAttributes,QuestionBankMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1216;
        this.ItemDetail.itemName='QuestionBank';
        this.ItemDetail.keyName='QuestionBankId';
    }

    CreateEntity(): QuestionBankEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuestionBankQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuestionBankEntity, QuestionBankMetaDataAttributes,QuestionBankMetaDataRelations>(query, this);
    }
     Attributes = new QuestionBankMetaDataAttributes();
     Relations = new QuestionBankMetaDataRelations();

}


export type QuestionBankQueryBuilder = DwQueryBuilderGen<QuestionBankEntity, QuestionBankMetaDataAttributes,QuestionBankMetaDataRelations>


export class QuestionBankMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuestionBank';
    // Attributes
    QuestionBankId = new DwItemAttribute(this.i, 'QuestionBankId');
    OwnerUserId = new DwItemAttribute(this.i, 'OwnerUserId');
    AcsTestId = new DwItemAttribute(this.i, 'AcsTestId');
    AcsCodeId = new DwItemAttribute(this.i, 'AcsCodeId');
    QuestionHtml = new DwItemAttribute(this.i, 'QuestionHtml');
    IsBuiltIn = new DwItemAttribute(this.i, 'IsBuiltIn');
    IsShared = new DwItemAttribute(this.i, 'IsShared');
    QuestionShortName = new DwItemAttribute(this.i, 'QuestionShortName');
    CheckRideOwnershipTypeId = new DwItemAttribute(this.i, 'CheckRideOwnershipTypeId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    QuestionBankStatusId = new DwItemAttribute(this.i, 'QuestionBankStatusId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class QuestionBankMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: ACS Code */
            AcsCode = new DwItemRelationship('AcsCode|QuestionBank|AcsCodeId', 'AcsCode', 'AcsCode');
            /** Relation: ACS Test */
            AcsTest = new DwItemRelationship('AcsTest|QuestionBank|AcsTestId', 'AcsTest', 'AcsTest');
            /** Relation: Check Ride Ownership Type */
            CheckRideOwnershipType = new DwItemRelationship('CheckRideOwnershipType|QuestionBank|CheckRideOwnershipTypeId', 'CheckRideOwnershipType', 'CheckRideOwnershipType');
            /** Relation: Flight School Organization */
            FlightSchoolOrganization = new DwItemRelationship('FlightSchoolOrganization|QuestionBank|FlightSchoolOrganizationId', 'FlightSchoolOrganization', 'FlightSchoolOrganization');
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('PilotExaminer|QuestionBank|PilotExaminerId', 'PilotExaminer', 'PilotExaminer');
            /** Relation: Question Bank Status */
            QuestionBankStatus = new DwItemRelationship('QuestionBankStatus|QuestionBank|QuestionBankStatusId', 'QuestionBankStatus', 'QuestionBankStatus');
    };
export class QuestionBankStatusMetaData implements DwItem2<QuestionBankStatusEntity, QuestionBankStatusMetaDataAttributes,QuestionBankStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2334;
        this.ItemDetail.itemName='QuestionBankStatus';
        this.ItemDetail.keyName='QuestionBankStatusId';
    }

    CreateEntity(): QuestionBankStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuestionBankStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuestionBankStatusEntity, QuestionBankStatusMetaDataAttributes,QuestionBankStatusMetaDataRelations>(query, this);
    }
     Attributes = new QuestionBankStatusMetaDataAttributes();
     Relations = new QuestionBankStatusMetaDataRelations();

}


export type QuestionBankStatusQueryBuilder = DwQueryBuilderGen<QuestionBankStatusEntity, QuestionBankStatusMetaDataAttributes,QuestionBankStatusMetaDataRelations>


export class QuestionBankStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuestionBankStatus';
    // Attributes
    QuestionBankStatusId = new DwItemAttribute(this.i, 'QuestionBankStatusId');
    QuestionBankStatus = new DwItemAttribute(this.i, 'QuestionBankStatus');
}

class QuestionBankStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Question Bank */
            QuestionBank = new DwItemRelationship('QuestionBankStatus|QuestionBank|QuestionBankStatusId', 'QuestionBank', 'QuestionBank');
    };
export class QuestionOutcomeMetaData implements DwItem2<QuestionOutcomeEntity, QuestionOutcomeMetaDataAttributes,QuestionOutcomeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1227;
        this.ItemDetail.itemName='QuestionOutcome';
        this.ItemDetail.keyName='QuestionOutcomeId';
    }

    CreateEntity(): QuestionOutcomeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuestionOutcomeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuestionOutcomeEntity, QuestionOutcomeMetaDataAttributes,QuestionOutcomeMetaDataRelations>(query, this);
    }
     Attributes = new QuestionOutcomeMetaDataAttributes();
     Relations = new QuestionOutcomeMetaDataRelations();

}


export type QuestionOutcomeQueryBuilder = DwQueryBuilderGen<QuestionOutcomeEntity, QuestionOutcomeMetaDataAttributes,QuestionOutcomeMetaDataRelations>


export class QuestionOutcomeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuestionOutcome';
    // Attributes
    QuestionOutcomeId = new DwItemAttribute(this.i, 'QuestionOutcomeId');
    QuestionOutcome = new DwItemAttribute(this.i, 'QuestionOutcome');
    OutcomeOrder = new DwItemAttribute(this.i, 'OutcomeOrder');
}

class QuestionOutcomeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Plan Of Action Question Result */
            PlanOfActionQuestionResult = new DwItemRelationship('QuestionOutcome|PlanOfActionQuestionResult|QuestionOutcomeId', 'PlanOfActionQuestionResult', 'PlanOfActionQuestionResult');
    };
export class ReferenceStatusMetaData implements DwItem2<ReferenceStatusEntity, ReferenceStatusMetaDataAttributes,ReferenceStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2346;
        this.ItemDetail.itemName='ReferenceStatus';
        this.ItemDetail.keyName='ReferenceStatusId';
    }

    CreateEntity(): ReferenceStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ReferenceStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ReferenceStatusEntity, ReferenceStatusMetaDataAttributes,ReferenceStatusMetaDataRelations>(query, this);
    }
     Attributes = new ReferenceStatusMetaDataAttributes();
     Relations = new ReferenceStatusMetaDataRelations();

}


export type ReferenceStatusQueryBuilder = DwQueryBuilderGen<ReferenceStatusEntity, ReferenceStatusMetaDataAttributes,ReferenceStatusMetaDataRelations>


export class ReferenceStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ReferenceStatus';
    // Attributes
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
    ReferenceStatus = new DwItemAttribute(this.i, 'ReferenceStatus');
}

class ReferenceStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Report Data Source */
            ReportDataSource = new DwItemRelationship('ReferenceStatus|ReportDataSource|ReferenceStatusId', 'ReportDataSource', 'ReportDataSource');
            /** Relation: Report Data Source Column */
            ReportDataSourceColumn = new DwItemRelationship('ReferenceStatus|ReportDataSourceColumn|ReferenceStatusId', 'ReportDataSourceColumn', 'ReportDataSourceColumn');
            /** Relation: Custom Calendar */
            Schedule = new DwItemRelationship('ReferenceStatus|Schedule|ReferenceStatusId', 'Schedule', 'Schedule');
            /** Relation: Training Type */
            TrainingType = new DwItemRelationship('ReferenceStatus|TrainingType|ReferenceStatusId', 'TrainingType', 'TrainingType');
            /** Relation: Unit Member Aircraft Category Class */
            UnitMemberAircraftCategoryClass = new DwItemRelationship('ReferenceStatus|UnitMemberAircraftCategoryClass|ReferenceStatusId', 'UnitMemberAircraftCategoryClass', 'UnitMemberAircraftCategoryClass');
            /** Relation: Unit Member Aircraft Experience Type */
            UnitMemberAircraftExperienceType = new DwItemRelationship('ReferenceStatus|UnitMemberAircraftExperienceType|ReferenceStatusId', 'UnitMemberAircraftExperienceType', 'UnitMemberAircraftExperienceType');
            /** Relation: Unit Member Qualification Option */
            UnitMemberQualificationOption = new DwItemRelationship('ReferenceStatus|UnitMemberQualificationOption|ReferenceStatusId', 'UnitMemberQualificationOption', 'UnitMemberQualificationOption');
            /** Relation: Unit Member Qualification Type */
            UnitMemberQualificationType = new DwItemRelationship('ReferenceStatus|UnitMemberQualificationType|ReferenceStatusId', 'UnitMemberQualificationType', 'UnitMemberQualificationType');
    };
export class ReportDashboardMetaData implements DwItem2<ReportDashboardEntity, ReportDashboardMetaDataAttributes,ReportDashboardMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2364;
        this.ItemDetail.itemName='ReportDashboard';
        this.ItemDetail.keyName='ReportDashboardId';
    }

    CreateEntity(): ReportDashboardEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ReportDashboardQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ReportDashboardEntity, ReportDashboardMetaDataAttributes,ReportDashboardMetaDataRelations>(query, this);
    }
     Attributes = new ReportDashboardMetaDataAttributes();
     Relations = new ReportDashboardMetaDataRelations();

}


export type ReportDashboardQueryBuilder = DwQueryBuilderGen<ReportDashboardEntity, ReportDashboardMetaDataAttributes,ReportDashboardMetaDataRelations>


export class ReportDashboardMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ReportDashboard';
    // Attributes
    ReportDashboardId = new DwItemAttribute(this.i, 'ReportDashboardId');
    DashboardKey = new DwItemAttribute(this.i, 'DashboardKey');
    DashboardDisplay = new DwItemAttribute(this.i, 'DashboardDisplay');
    DashboardConfigJSON = new DwItemAttribute(this.i, 'DashboardConfigJSON');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ReportDashboardMetaDataRelations implements DwItemRelationshipCollection {
    };
export class ReportDashboardGroupMetaData implements DwItem2<ReportDashboardGroupEntity, ReportDashboardGroupMetaDataAttributes,ReportDashboardGroupMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2363;
        this.ItemDetail.itemName='ReportDashboardGroup';
        this.ItemDetail.keyName='ReportDashboardGroupId';
    }

    CreateEntity(): ReportDashboardGroupEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ReportDashboardGroupQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ReportDashboardGroupEntity, ReportDashboardGroupMetaDataAttributes,ReportDashboardGroupMetaDataRelations>(query, this);
    }
     Attributes = new ReportDashboardGroupMetaDataAttributes();
     Relations = new ReportDashboardGroupMetaDataRelations();

}


export type ReportDashboardGroupQueryBuilder = DwQueryBuilderGen<ReportDashboardGroupEntity, ReportDashboardGroupMetaDataAttributes,ReportDashboardGroupMetaDataRelations>


export class ReportDashboardGroupMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ReportDashboardGroup';
    // Attributes
    ReportDashboardGroupId = new DwItemAttribute(this.i, 'ReportDashboardGroupId');
    DashboardGroupKey = new DwItemAttribute(this.i, 'DashboardGroupKey');
    DashboardGroupDisplay = new DwItemAttribute(this.i, 'DashboardGroupDisplay');
    DashboardGroupConfigJSON = new DwItemAttribute(this.i, 'DashboardGroupConfigJSON');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ReportDashboardGroupMetaDataRelations implements DwItemRelationshipCollection {
    };
export class ReportDashboardWidgetMetaData implements DwItem2<ReportDashboardWidgetEntity, ReportDashboardWidgetMetaDataAttributes,ReportDashboardWidgetMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2365;
        this.ItemDetail.itemName='ReportDashboardWidget';
        this.ItemDetail.keyName='ReportDashboardWidgetId';
    }

    CreateEntity(): ReportDashboardWidgetEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ReportDashboardWidgetQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ReportDashboardWidgetEntity, ReportDashboardWidgetMetaDataAttributes,ReportDashboardWidgetMetaDataRelations>(query, this);
    }
     Attributes = new ReportDashboardWidgetMetaDataAttributes();
     Relations = new ReportDashboardWidgetMetaDataRelations();

}


export type ReportDashboardWidgetQueryBuilder = DwQueryBuilderGen<ReportDashboardWidgetEntity, ReportDashboardWidgetMetaDataAttributes,ReportDashboardWidgetMetaDataRelations>


export class ReportDashboardWidgetMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ReportDashboardWidget';
    // Attributes
    ReportDashboardWidgetId = new DwItemAttribute(this.i, 'ReportDashboardWidgetId');
    WidgetKey = new DwItemAttribute(this.i, 'WidgetKey');
    WidgetDisplay = new DwItemAttribute(this.i, 'WidgetDisplay');
    WidgetConfigJSON = new DwItemAttribute(this.i, 'WidgetConfigJSON');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ReportDashboardWidgetMetaDataRelations implements DwItemRelationshipCollection {
    };
export class ReportDataSourceMetaData implements DwItem2<ReportDataSourceEntity, ReportDataSourceMetaDataAttributes,ReportDataSourceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2381;
        this.ItemDetail.itemName='ReportDataSource';
        this.ItemDetail.keyName='ReportDataSourceId';
    }

    CreateEntity(): ReportDataSourceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ReportDataSourceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ReportDataSourceEntity, ReportDataSourceMetaDataAttributes,ReportDataSourceMetaDataRelations>(query, this);
    }
     Attributes = new ReportDataSourceMetaDataAttributes();
     Relations = new ReportDataSourceMetaDataRelations();

}


export type ReportDataSourceQueryBuilder = DwQueryBuilderGen<ReportDataSourceEntity, ReportDataSourceMetaDataAttributes,ReportDataSourceMetaDataRelations>


export class ReportDataSourceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ReportDataSource';
    // Attributes
    ReportDataSourceId = new DwItemAttribute(this.i, 'ReportDataSourceId');
    DataSourceKey = new DwItemAttribute(this.i, 'DataSourceKey');
    DataSourceDisplay = new DwItemAttribute(this.i, 'DataSourceDisplay');
    DataSourceDescription = new DwItemAttribute(this.i, 'DataSourceDescription');
    MetaDataItemId = new DwItemAttribute(this.i, 'MetaDataItemId');
    MetaDataQueryId = new DwItemAttribute(this.i, 'MetaDataQueryId');
    IncludeAllFields = new DwItemAttribute(this.i, 'IncludeAllFields');
    DataSourceConfigJSON = new DwItemAttribute(this.i, 'DataSourceConfigJSON');
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ReportDataSourceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Reference Status */
            ReferenceStatus = new DwItemRelationship('ReferenceStatus|ReportDataSource|ReferenceStatusId', 'ReferenceStatus', 'ReferenceStatus');
            /** Relation: Report Data Source Column */
            ReportDataSourceColumn = new DwItemRelationship('ReportDataSource|ReportDataSourceColumn|ReportDataSourceId', 'ReportDataSourceColumn', 'ReportDataSourceColumn');
    };
export class ReportDataSourceColumnMetaData implements DwItem2<ReportDataSourceColumnEntity, ReportDataSourceColumnMetaDataAttributes,ReportDataSourceColumnMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2382;
        this.ItemDetail.itemName='ReportDataSourceColumn';
        this.ItemDetail.keyName='ReportDataSourceColumnId';
    }

    CreateEntity(): ReportDataSourceColumnEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ReportDataSourceColumnQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ReportDataSourceColumnEntity, ReportDataSourceColumnMetaDataAttributes,ReportDataSourceColumnMetaDataRelations>(query, this);
    }
     Attributes = new ReportDataSourceColumnMetaDataAttributes();
     Relations = new ReportDataSourceColumnMetaDataRelations();

}


export type ReportDataSourceColumnQueryBuilder = DwQueryBuilderGen<ReportDataSourceColumnEntity, ReportDataSourceColumnMetaDataAttributes,ReportDataSourceColumnMetaDataRelations>


export class ReportDataSourceColumnMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ReportDataSourceColumn';
    // Attributes
    ReportDataSourceColumnId = new DwItemAttribute(this.i, 'ReportDataSourceColumnId');
    ReportDataSourceId = new DwItemAttribute(this.i, 'ReportDataSourceId');
    ColumnKey = new DwItemAttribute(this.i, 'ColumnKey');
    MetaDataAttributeId = new DwItemAttribute(this.i, 'MetaDataAttributeId');
    MetaDataAttributeTypeId = new DwItemAttribute(this.i, 'MetaDataAttributeTypeId');
    AttributeName = new DwItemAttribute(this.i, 'AttributeName');
    LookupIdOverride = new DwItemAttribute(this.i, 'LookupIdOverride');
    ColumnDisplay = new DwItemAttribute(this.i, 'ColumnDisplay');
    UseLookupDisplay = new DwItemAttribute(this.i, 'UseLookupDisplay');
    IsExcluded = new DwItemAttribute(this.i, 'IsExcluded');
    IsDimension = new DwItemAttribute(this.i, 'IsDimension');
    IsMeasure = new DwItemAttribute(this.i, 'IsMeasure');
    IsFilter = new DwItemAttribute(this.i, 'IsFilter');
    ColumnConfigJSON = new DwItemAttribute(this.i, 'ColumnConfigJSON');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ReportDataSourceColumnMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Reference Status */
            ReferenceStatus = new DwItemRelationship('ReferenceStatus|ReportDataSourceColumn|ReferenceStatusId', 'ReferenceStatus', 'ReferenceStatus');
            /** Relation: Report Data Source */
            ReportDataSource = new DwItemRelationship('ReportDataSource|ReportDataSourceColumn|ReportDataSourceId', 'ReportDataSource', 'ReportDataSource');
    };
export class ReportFilterPreferenceMetaData implements DwItem2<ReportFilterPreferenceEntity, ReportFilterPreferenceMetaDataAttributes,ReportFilterPreferenceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2368;
        this.ItemDetail.itemName='ReportFilterPreference';
        this.ItemDetail.keyName='ReportFilterPreferenceId';
    }

    CreateEntity(): ReportFilterPreferenceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ReportFilterPreferenceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ReportFilterPreferenceEntity, ReportFilterPreferenceMetaDataAttributes,ReportFilterPreferenceMetaDataRelations>(query, this);
    }
     Attributes = new ReportFilterPreferenceMetaDataAttributes();
     Relations = new ReportFilterPreferenceMetaDataRelations();

}


export type ReportFilterPreferenceQueryBuilder = DwQueryBuilderGen<ReportFilterPreferenceEntity, ReportFilterPreferenceMetaDataAttributes,ReportFilterPreferenceMetaDataRelations>


export class ReportFilterPreferenceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ReportFilterPreference';
    // Attributes
    ReportFilterPreferenceId = new DwItemAttribute(this.i, 'ReportFilterPreferenceId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    DashboardKey = new DwItemAttribute(this.i, 'DashboardKey');
    DefaultReportFilterPresetId = new DwItemAttribute(this.i, 'DefaultReportFilterPresetId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ReportFilterPreferenceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Report Filter Preset - Default Report Filter Preset */
            ReportFilterPresetByDefaultReportFilterPresetId = new DwItemRelationship('ReportFilterPreset|ReportFilterPreference|DefaultReportFilterPresetId', 'DefaultReportFilterPreset', 'DefaultReportFilterPreset');
    };
export class ReportFilterPresetMetaData implements DwItem2<ReportFilterPresetEntity, ReportFilterPresetMetaDataAttributes,ReportFilterPresetMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2367;
        this.ItemDetail.itemName='ReportFilterPreset';
        this.ItemDetail.keyName='ReportFilterPresetId';
    }

    CreateEntity(): ReportFilterPresetEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ReportFilterPresetQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ReportFilterPresetEntity, ReportFilterPresetMetaDataAttributes,ReportFilterPresetMetaDataRelations>(query, this);
    }
     Attributes = new ReportFilterPresetMetaDataAttributes();
     Relations = new ReportFilterPresetMetaDataRelations();

}


export type ReportFilterPresetQueryBuilder = DwQueryBuilderGen<ReportFilterPresetEntity, ReportFilterPresetMetaDataAttributes,ReportFilterPresetMetaDataRelations>


export class ReportFilterPresetMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ReportFilterPreset';
    // Attributes
    ReportFilterPresetId = new DwItemAttribute(this.i, 'ReportFilterPresetId');
    DashboardKey = new DwItemAttribute(this.i, 'DashboardKey');
    PresetName = new DwItemAttribute(this.i, 'PresetName');
    PresetDescription = new DwItemAttribute(this.i, 'PresetDescription');
    ReportFilterPresetOwnershipTypeId = new DwItemAttribute(this.i, 'ReportFilterPresetOwnershipTypeId');
    OwnerUserId = new DwItemAttribute(this.i, 'OwnerUserId');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    FilterGroupJSON = new DwItemAttribute(this.i, 'FilterGroupJSON');
    FilterStateJSON = new DwItemAttribute(this.i, 'FilterStateJSON');
    SortOrder = new DwItemAttribute(this.i, 'SortOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ReportFilterPresetMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Report Filter Preset Ownership Type */
            ReportFilterPresetOwnershipType = new DwItemRelationship('ReportFilterPresetOwnershipType|ReportFilterPreset|ReportFilterPresetOwnershipTypeId', 'ReportFilterPresetOwnershipType', 'ReportFilterPresetOwnershipType');
            /** Relation: Report Filter Preference - Default - Many */
            ReportFilterPreferenceByDefaultReportFilterPresetId = new DwItemRelationship('ReportFilterPreset|ReportFilterPreference|DefaultReportFilterPresetId', 'DefaultReportFilterPreference', 'DefaultReportFilterPreference');
    };
export class ReportFilterPresetOwnershipTypeMetaData implements DwItem2<ReportFilterPresetOwnershipTypeEntity, ReportFilterPresetOwnershipTypeMetaDataAttributes,ReportFilterPresetOwnershipTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2366;
        this.ItemDetail.itemName='ReportFilterPresetOwnershipType';
        this.ItemDetail.keyName='ReportFilterPresetOwnershipTypeId';
    }

    CreateEntity(): ReportFilterPresetOwnershipTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ReportFilterPresetOwnershipTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ReportFilterPresetOwnershipTypeEntity, ReportFilterPresetOwnershipTypeMetaDataAttributes,ReportFilterPresetOwnershipTypeMetaDataRelations>(query, this);
    }
     Attributes = new ReportFilterPresetOwnershipTypeMetaDataAttributes();
     Relations = new ReportFilterPresetOwnershipTypeMetaDataRelations();

}


export type ReportFilterPresetOwnershipTypeQueryBuilder = DwQueryBuilderGen<ReportFilterPresetOwnershipTypeEntity, ReportFilterPresetOwnershipTypeMetaDataAttributes,ReportFilterPresetOwnershipTypeMetaDataRelations>


export class ReportFilterPresetOwnershipTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ReportFilterPresetOwnershipType';
    // Attributes
    ReportFilterPresetOwnershipTypeId = new DwItemAttribute(this.i, 'ReportFilterPresetOwnershipTypeId');
    OwnershipTypeDisplay = new DwItemAttribute(this.i, 'OwnershipTypeDisplay');
    OwnershipTypeMeaning = new DwItemAttribute(this.i, 'OwnershipTypeMeaning');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ReportFilterPresetOwnershipTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Report Filter Preset */
            ReportFilterPreset = new DwItemRelationship('ReportFilterPresetOwnershipType|ReportFilterPreset|ReportFilterPresetOwnershipTypeId', 'ReportFilterPreset', 'ReportFilterPreset');
    };
export class RoAcsCodeDimensionMetaData implements DwItem2<RoAcsCodeDimensionEntity, RoAcsCodeDimensionMetaDataAttributes,RoAcsCodeDimensionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2340;
        this.ItemDetail.itemName='roAcsCodeDimension';
        this.ItemDetail.keyName='AcsCodeId';
    }

    CreateEntity(): RoAcsCodeDimensionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoAcsCodeDimensionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoAcsCodeDimensionEntity, RoAcsCodeDimensionMetaDataAttributes,RoAcsCodeDimensionMetaDataRelations>(query, this);
    }
     Attributes = new RoAcsCodeDimensionMetaDataAttributes();
     Relations = new RoAcsCodeDimensionMetaDataRelations();

}


export type RoAcsCodeDimensionQueryBuilder = DwQueryBuilderGen<RoAcsCodeDimensionEntity, RoAcsCodeDimensionMetaDataAttributes,RoAcsCodeDimensionMetaDataRelations>


export class RoAcsCodeDimensionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roAcsCodeDimension';
    // Attributes
    AcsCodeId = new DwItemAttribute(this.i, 'AcsCodeId');
    AscCodeTypeId = new DwItemAttribute(this.i, 'AscCodeTypeId');
    AcsCodeTypeName = new DwItemAttribute(this.i, 'AcsCodeTypeName');
    AcsCode = new DwItemAttribute(this.i, 'AcsCode');
    AcsCodeOrder = new DwItemAttribute(this.i, 'AcsCodeOrder');
    AcsAreaOfOperationTaskId = new DwItemAttribute(this.i, 'AcsAreaOfOperationTaskId');
    AscCodeDescription = new DwItemAttribute(this.i, 'AscCodeDescription');
    AcsAreaOfOperationId = new DwItemAttribute(this.i, 'AcsAreaOfOperationId');
    TaskName = new DwItemAttribute(this.i, 'TaskName');
    TaskOrder = new DwItemAttribute(this.i, 'TaskOrder');
    TaskCode = new DwItemAttribute(this.i, 'TaskCode');
    AreaOfOperationName = new DwItemAttribute(this.i, 'AreaOfOperationName');
    AreaOfOperationOrder = new DwItemAttribute(this.i, 'AreaOfOperationOrder');
    AreaOfOperationCode = new DwItemAttribute(this.i, 'AreaOfOperationCode');
    AcsTestId = new DwItemAttribute(this.i, 'AcsTestId');
    TestName = new DwItemAttribute(this.i, 'TestName');
    TestDescription = new DwItemAttribute(this.i, 'TestDescription');
    TestCode = new DwItemAttribute(this.i, 'TestCode');
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    CheckRideGroup = new DwItemAttribute(this.i, 'CheckRideGroup');
}

class RoAcsCodeDimensionMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoAcsWrittenSourceMetaData implements DwItem2<RoAcsWrittenSourceEntity, RoAcsWrittenSourceMetaDataAttributes,RoAcsWrittenSourceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2336;
        this.ItemDetail.itemName='roAcsWrittenSource';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoAcsWrittenSourceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoAcsWrittenSourceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoAcsWrittenSourceEntity, RoAcsWrittenSourceMetaDataAttributes,RoAcsWrittenSourceMetaDataRelations>(query, this);
    }
     Attributes = new RoAcsWrittenSourceMetaDataAttributes();
     Relations = new RoAcsWrittenSourceMetaDataRelations();

}


export type RoAcsWrittenSourceQueryBuilder = DwQueryBuilderGen<RoAcsWrittenSourceEntity, RoAcsWrittenSourceMetaDataAttributes,RoAcsWrittenSourceMetaDataRelations>


export class RoAcsWrittenSourceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roAcsWrittenSource';
    // Attributes
    Source = new DwItemAttribute(this.i, 'Source');
    PlanOfActionId = new DwItemAttribute(this.i, 'PlanOfActionId');
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    ACSTestType = new DwItemAttribute(this.i, 'ACSTestType');
    ApplicantAcsWrittenResultId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultId');
}

class RoAcsWrittenSourceMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoAirportDistancesMetaData implements DwItem2<RoAirportDistancesEntity, RoAirportDistancesMetaDataAttributes,RoAirportDistancesMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1196;
        this.ItemDetail.itemName='roAirportDistances';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoAirportDistancesEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoAirportDistancesQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoAirportDistancesEntity, RoAirportDistancesMetaDataAttributes,RoAirportDistancesMetaDataRelations>(query, this);
    }
     Attributes = new RoAirportDistancesMetaDataAttributes();
     Relations = new RoAirportDistancesMetaDataRelations();

}


export type RoAirportDistancesQueryBuilder = DwQueryBuilderGen<RoAirportDistancesEntity, RoAirportDistancesMetaDataAttributes,RoAirportDistancesMetaDataRelations>


export class RoAirportDistancesMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roAirportDistances';
    // Attributes
    AirportId = new DwItemAttribute(this.i, 'AirportId');
    AirportName = new DwItemAttribute(this.i, 'AirportName');
    Airportcode = new DwItemAttribute(this.i, 'airportcode');
    ReferenceAirportName = new DwItemAttribute(this.i, 'ReferenceAirportName');
    ReferenceAirportCode = new DwItemAttribute(this.i, 'ReferenceAirportCode');
    Distance = new DwItemAttribute(this.i, 'Distance');
    ReferenceAirportId = new DwItemAttribute(this.i, 'ReferenceAirportId');
}

class RoAirportDistancesMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoAssessmentAcsFactBaseMetaData implements DwItem2<RoAssessmentAcsFactBaseEntity, RoAssessmentAcsFactBaseMetaDataAttributes,RoAssessmentAcsFactBaseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2339;
        this.ItemDetail.itemName='roAssessmentAcsFactBase';
        this.ItemDetail.keyName='AssessmentId';
    }

    CreateEntity(): RoAssessmentAcsFactBaseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoAssessmentAcsFactBaseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoAssessmentAcsFactBaseEntity, RoAssessmentAcsFactBaseMetaDataAttributes,RoAssessmentAcsFactBaseMetaDataRelations>(query, this);
    }
     Attributes = new RoAssessmentAcsFactBaseMetaDataAttributes();
     Relations = new RoAssessmentAcsFactBaseMetaDataRelations();

}


export type RoAssessmentAcsFactBaseQueryBuilder = DwQueryBuilderGen<RoAssessmentAcsFactBaseEntity, RoAssessmentAcsFactBaseMetaDataAttributes,RoAssessmentAcsFactBaseMetaDataRelations>


export class RoAssessmentAcsFactBaseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roAssessmentAcsFactBase';
    // Attributes
    SourceType = new DwItemAttribute(this.i, 'SourceType');
    AssessmentId = new DwItemAttribute(this.i, 'AssessmentId');
    AssessmentKey = new DwItemAttribute(this.i, 'AssessmentKey');
    PlanOfActionId = new DwItemAttribute(this.i, 'PlanOfActionId');
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    AcsTestId = new DwItemAttribute(this.i, 'AcsTestId');
    ApplicantAcsWrittenResultTypeId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultTypeId');
    ApplicantAcsWrittenResultId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultId');
    PlanOfActionName = new DwItemAttribute(this.i, 'PlanOfActionName');
    PlanOfActionStatusId = new DwItemAttribute(this.i, 'PlanOfActionStatusId');
    CheckrideRequestSubStatusId = new DwItemAttribute(this.i, 'CheckrideRequestSubStatusId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    CheckRideExaminerTypeId = new DwItemAttribute(this.i, 'CheckRideExaminerTypeId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    AuthorityPreCheckRideNumber = new DwItemAttribute(this.i, 'AuthorityPreCheckRideNumber');
    AuthorityPreapprovalCode = new DwItemAttribute(this.i, 'AuthorityPreapprovalCode');
    CheckRideOwnershipTypeId = new DwItemAttribute(this.i, 'CheckRideOwnershipTypeId');
    CheckRideApplicantTypeId = new DwItemAttribute(this.i, 'CheckRideApplicantTypeId');
    ApplicantName = new DwItemAttribute(this.i, 'ApplicantName');
    ApplicantEmail = new DwItemAttribute(this.i, 'ApplicantEmail');
    ApplicantPhone = new DwItemAttribute(this.i, 'ApplicantPhone');
    ExaminerName = new DwItemAttribute(this.i, 'ExaminerName');
    ExaminerEmail = new DwItemAttribute(this.i, 'ExaminerEmail');
    ExaminerPhone = new DwItemAttribute(this.i, 'ExaminerPhone');
    FlightSchoolApplicantId = new DwItemAttribute(this.i, 'FlightSchoolApplicantId');
    FlightSchoolInstructorId = new DwItemAttribute(this.i, 'FlightSchoolInstructorId');
    CheckrideDateTime = new DwItemAttribute(this.i, 'CheckrideDateTime');
    CheckrideAirportId = new DwItemAttribute(this.i, 'CheckrideAirportId');
    CheckrideGroupId = new DwItemAttribute(this.i, 'CheckrideGroupId');
    CheckrideTypeId = new DwItemAttribute(this.i, 'CheckrideTypeId');
    CheckRideTestTypeId = new DwItemAttribute(this.i, 'CheckRideTestTypeId');
    CheckrideDurationMinutes = new DwItemAttribute(this.i, 'CheckrideDurationMinutes');
    CheckrideEndDateTime = new DwItemAttribute(this.i, 'CheckrideEndDateTime');
    PlanOfActionResultId = new DwItemAttribute(this.i, 'PlanOfActionResultId');
    CheckrideResultId = new DwItemAttribute(this.i, 'CheckrideResultId');
    CheckRideOutcomeId = new DwItemAttribute(this.i, 'CheckRideOutcomeId');
    AllowRetest = new DwItemAttribute(this.i, 'AllowRetest');
    FlagApplicant = new DwItemAttribute(this.i, 'FlagApplicant');
    AllowRetestReason = new DwItemAttribute(this.i, 'AllowRetestReason');
    RetestCost = new DwItemAttribute(this.i, 'RetestCost');
    AddToWaitlist = new DwItemAttribute(this.i, 'AddToWaitlist');
    GroundPortionComplete = new DwItemAttribute(this.i, 'GroundPortionComplete');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    OdaFlightSchoolId = new DwItemAttribute(this.i, 'OdaFlightSchoolId');
    CheckrideTypeShortName = new DwItemAttribute(this.i, 'CheckrideTypeShortName');
    CheckRideTestAttemptClassificationId = new DwItemAttribute(this.i, 'CheckRideTestAttemptClassificationId');
    AttemptClassification = new DwItemAttribute(this.i, 'AttemptClassification');
    IsInitial = new DwItemAttribute(this.i, 'IsInitial');
    IsRetest = new DwItemAttribute(this.i, 'IsRetest');
    IsContinuance = new DwItemAttribute(this.i, 'IsContinuance');
}

class RoAssessmentAcsFactBaseMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoAssessmentAcsMissedCodeFactMetaData implements DwItem2<RoAssessmentAcsMissedCodeFactEntity, RoAssessmentAcsMissedCodeFactMetaDataAttributes,RoAssessmentAcsMissedCodeFactMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2341;
        this.ItemDetail.itemName='roAssessmentAcsMissedCodeFact';
        this.ItemDetail.keyName='AssessmentId';
    }

    CreateEntity(): RoAssessmentAcsMissedCodeFactEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoAssessmentAcsMissedCodeFactQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoAssessmentAcsMissedCodeFactEntity, RoAssessmentAcsMissedCodeFactMetaDataAttributes,RoAssessmentAcsMissedCodeFactMetaDataRelations>(query, this);
    }
     Attributes = new RoAssessmentAcsMissedCodeFactMetaDataAttributes();
     Relations = new RoAssessmentAcsMissedCodeFactMetaDataRelations();

}


export type RoAssessmentAcsMissedCodeFactQueryBuilder = DwQueryBuilderGen<RoAssessmentAcsMissedCodeFactEntity, RoAssessmentAcsMissedCodeFactMetaDataAttributes,RoAssessmentAcsMissedCodeFactMetaDataRelations>


export class RoAssessmentAcsMissedCodeFactMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roAssessmentAcsMissedCodeFact';
    // Attributes
    SourceType = new DwItemAttribute(this.i, 'SourceType');
    AssessmentId = new DwItemAttribute(this.i, 'AssessmentId');
    AssessmentKey = new DwItemAttribute(this.i, 'AssessmentKey');
    PlanOfActionId = new DwItemAttribute(this.i, 'PlanOfActionId');
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    AcsTestId = new DwItemAttribute(this.i, 'AcsTestId');
    ApplicantAcsWrittenResultTypeId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultTypeId');
    ApplicantAcsWrittenResultId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultId');
    PlanOfActionName = new DwItemAttribute(this.i, 'PlanOfActionName');
    PlanOfActionStatusId = new DwItemAttribute(this.i, 'PlanOfActionStatusId');
    CheckrideRequestSubStatusId = new DwItemAttribute(this.i, 'CheckrideRequestSubStatusId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    CheckRideExaminerTypeId = new DwItemAttribute(this.i, 'CheckRideExaminerTypeId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    AuthorityPreCheckRideNumber = new DwItemAttribute(this.i, 'AuthorityPreCheckRideNumber');
    AuthorityPreapprovalCode = new DwItemAttribute(this.i, 'AuthorityPreapprovalCode');
    CheckRideOwnershipTypeId = new DwItemAttribute(this.i, 'CheckRideOwnershipTypeId');
    CheckRideApplicantTypeId = new DwItemAttribute(this.i, 'CheckRideApplicantTypeId');
    ApplicantName = new DwItemAttribute(this.i, 'ApplicantName');
    ApplicantEmail = new DwItemAttribute(this.i, 'ApplicantEmail');
    ApplicantPhone = new DwItemAttribute(this.i, 'ApplicantPhone');
    ExaminerName = new DwItemAttribute(this.i, 'ExaminerName');
    ExaminerEmail = new DwItemAttribute(this.i, 'ExaminerEmail');
    ExaminerPhone = new DwItemAttribute(this.i, 'ExaminerPhone');
    FlightSchoolApplicantId = new DwItemAttribute(this.i, 'FlightSchoolApplicantId');
    FlightSchoolInstructorId = new DwItemAttribute(this.i, 'FlightSchoolInstructorId');
    CheckrideDateTime = new DwItemAttribute(this.i, 'CheckrideDateTime');
    CheckrideAirportId = new DwItemAttribute(this.i, 'CheckrideAirportId');
    CheckrideGroupId = new DwItemAttribute(this.i, 'CheckrideGroupId');
    CheckrideTypeId = new DwItemAttribute(this.i, 'CheckrideTypeId');
    CheckRideTestTypeId = new DwItemAttribute(this.i, 'CheckRideTestTypeId');
    CheckrideDurationMinutes = new DwItemAttribute(this.i, 'CheckrideDurationMinutes');
    CheckrideEndDateTime = new DwItemAttribute(this.i, 'CheckrideEndDateTime');
    PlanOfActionResultId = new DwItemAttribute(this.i, 'PlanOfActionResultId');
    CheckrideResultId = new DwItemAttribute(this.i, 'CheckrideResultId');
    CheckRideOutcomeId = new DwItemAttribute(this.i, 'CheckRideOutcomeId');
    AllowRetest = new DwItemAttribute(this.i, 'AllowRetest');
    FlagApplicant = new DwItemAttribute(this.i, 'FlagApplicant');
    AllowRetestReason = new DwItemAttribute(this.i, 'AllowRetestReason');
    RetestCost = new DwItemAttribute(this.i, 'RetestCost');
    AddToWaitlist = new DwItemAttribute(this.i, 'AddToWaitlist');
    GroundPortionComplete = new DwItemAttribute(this.i, 'GroundPortionComplete');
    ApplicantAcsWrittenResultMissedCodeId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultMissedCodeId');
    AcsCodeId = new DwItemAttribute(this.i, 'AcsCodeId');
    AscCodeTypeId = new DwItemAttribute(this.i, 'AscCodeTypeId');
    AcsCodeTypeName = new DwItemAttribute(this.i, 'AcsCodeTypeName');
    AcsCode = new DwItemAttribute(this.i, 'AcsCode');
    AcsCodeOrder = new DwItemAttribute(this.i, 'AcsCodeOrder');
    AcsAreaOfOperationTaskId = new DwItemAttribute(this.i, 'AcsAreaOfOperationTaskId');
    AscCodeDescription = new DwItemAttribute(this.i, 'AscCodeDescription');
    AcsAreaOfOperationId = new DwItemAttribute(this.i, 'AcsAreaOfOperationId');
    TaskName = new DwItemAttribute(this.i, 'TaskName');
    TaskOrder = new DwItemAttribute(this.i, 'TaskOrder');
    TaskCode = new DwItemAttribute(this.i, 'TaskCode');
    AreaOfOperationName = new DwItemAttribute(this.i, 'AreaOfOperationName');
    AreaOfOperationOrder = new DwItemAttribute(this.i, 'AreaOfOperationOrder');
    AreaOfOperationCode = new DwItemAttribute(this.i, 'AreaOfOperationCode');
    TestName = new DwItemAttribute(this.i, 'TestName');
    TestDescription = new DwItemAttribute(this.i, 'TestDescription');
    TestCode = new DwItemAttribute(this.i, 'TestCode');
    CheckRideGroup = new DwItemAttribute(this.i, 'CheckRideGroup');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    OdaFlightSchoolId = new DwItemAttribute(this.i, 'OdaFlightSchoolId');
    CheckrideTypeShortName = new DwItemAttribute(this.i, 'CheckrideTypeShortName');
    CheckRideTestAttemptClassificationId = new DwItemAttribute(this.i, 'CheckRideTestAttemptClassificationId');
    AttemptClassification = new DwItemAttribute(this.i, 'AttemptClassification');
    IsInitial = new DwItemAttribute(this.i, 'IsInitial');
    IsRetest = new DwItemAttribute(this.i, 'IsRetest');
    IsContinuance = new DwItemAttribute(this.i, 'IsContinuance');
}

class RoAssessmentAcsMissedCodeFactMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: ACS Code */
            AcsCode = new DwItemRelationship('ACSCode|RoAssessmentAcsMissedCodeFact|AcsCodeID', 'AcsCode3', 'AcsCode3');
    };
export class RoAssessmentFactBaseMetaData implements DwItem2<RoAssessmentFactBaseEntity, RoAssessmentFactBaseMetaDataAttributes,RoAssessmentFactBaseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2338;
        this.ItemDetail.itemName='roAssessmentFactBase';
        this.ItemDetail.keyName='AssessmentId';
    }

    CreateEntity(): RoAssessmentFactBaseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoAssessmentFactBaseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoAssessmentFactBaseEntity, RoAssessmentFactBaseMetaDataAttributes,RoAssessmentFactBaseMetaDataRelations>(query, this);
    }
     Attributes = new RoAssessmentFactBaseMetaDataAttributes();
     Relations = new RoAssessmentFactBaseMetaDataRelations();

}


export type RoAssessmentFactBaseQueryBuilder = DwQueryBuilderGen<RoAssessmentFactBaseEntity, RoAssessmentFactBaseMetaDataAttributes,RoAssessmentFactBaseMetaDataRelations>


export class RoAssessmentFactBaseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roAssessmentFactBase';
    // Attributes
    SourceType = new DwItemAttribute(this.i, 'SourceType');
    AssessmentId = new DwItemAttribute(this.i, 'AssessmentId');
    AssessmentKey = new DwItemAttribute(this.i, 'AssessmentKey');
    PlanOfActionId = new DwItemAttribute(this.i, 'PlanOfActionId');
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    PlanOfActionName = new DwItemAttribute(this.i, 'PlanOfActionName');
    PlanOfActionStatusId = new DwItemAttribute(this.i, 'PlanOfActionStatusId');
    CheckrideRequestSubStatusId = new DwItemAttribute(this.i, 'CheckrideRequestSubStatusId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    CheckRideExaminerTypeId = new DwItemAttribute(this.i, 'CheckRideExaminerTypeId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    AuthorityPreCheckRideNumber = new DwItemAttribute(this.i, 'AuthorityPreCheckRideNumber');
    AuthorityPreapprovalCode = new DwItemAttribute(this.i, 'AuthorityPreapprovalCode');
    CheckRideOwnershipTypeId = new DwItemAttribute(this.i, 'CheckRideOwnershipTypeId');
    CheckRideApplicantTypeId = new DwItemAttribute(this.i, 'CheckRideApplicantTypeId');
    ApplicantName = new DwItemAttribute(this.i, 'ApplicantName');
    ApplicantEmail = new DwItemAttribute(this.i, 'ApplicantEmail');
    ApplicantPhone = new DwItemAttribute(this.i, 'ApplicantPhone');
    ExaminerName = new DwItemAttribute(this.i, 'ExaminerName');
    ExaminerEmail = new DwItemAttribute(this.i, 'ExaminerEmail');
    ExaminerPhone = new DwItemAttribute(this.i, 'ExaminerPhone');
    FlightSchoolApplicantId = new DwItemAttribute(this.i, 'FlightSchoolApplicantId');
    FlightSchoolInstructorId = new DwItemAttribute(this.i, 'FlightSchoolInstructorId');
    CheckrideDateTime = new DwItemAttribute(this.i, 'CheckrideDateTime');
    CheckrideAirportId = new DwItemAttribute(this.i, 'CheckrideAirportId');
    CheckrideGroupId = new DwItemAttribute(this.i, 'CheckrideGroupId');
    CheckrideTypeId = new DwItemAttribute(this.i, 'CheckrideTypeId');
    CheckRideTestTypeId = new DwItemAttribute(this.i, 'CheckRideTestTypeId');
    CheckrideDurationMinutes = new DwItemAttribute(this.i, 'CheckrideDurationMinutes');
    CheckrideEndDateTime = new DwItemAttribute(this.i, 'CheckrideEndDateTime');
    PlanOfActionResultId = new DwItemAttribute(this.i, 'PlanOfActionResultId');
    CheckrideResultId = new DwItemAttribute(this.i, 'CheckrideResultId');
    CheckRideOutcomeId = new DwItemAttribute(this.i, 'CheckRideOutcomeId');
    AllowRetest = new DwItemAttribute(this.i, 'AllowRetest');
    FlagApplicant = new DwItemAttribute(this.i, 'FlagApplicant');
    AllowRetestReason = new DwItemAttribute(this.i, 'AllowRetestReason');
    RetestCost = new DwItemAttribute(this.i, 'RetestCost');
    AddToWaitlist = new DwItemAttribute(this.i, 'AddToWaitlist');
    GroundPortionComplete = new DwItemAttribute(this.i, 'GroundPortionComplete');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    OdaFlightSchoolId = new DwItemAttribute(this.i, 'OdaFlightSchoolId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    CheckrideTypeShortName = new DwItemAttribute(this.i, 'CheckrideTypeShortName');
}

class RoAssessmentFactBaseMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoCalendarSyncRequestDisplayMetaData implements DwItem2<RoCalendarSyncRequestDisplayEntity, RoCalendarSyncRequestDisplayMetaDataAttributes,RoCalendarSyncRequestDisplayMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2356;
        this.ItemDetail.itemName='roCalendarSyncRequestDisplay';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoCalendarSyncRequestDisplayEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoCalendarSyncRequestDisplayQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoCalendarSyncRequestDisplayEntity, RoCalendarSyncRequestDisplayMetaDataAttributes,RoCalendarSyncRequestDisplayMetaDataRelations>(query, this);
    }
     Attributes = new RoCalendarSyncRequestDisplayMetaDataAttributes();
     Relations = new RoCalendarSyncRequestDisplayMetaDataRelations();

}


export type RoCalendarSyncRequestDisplayQueryBuilder = DwQueryBuilderGen<RoCalendarSyncRequestDisplayEntity, RoCalendarSyncRequestDisplayMetaDataAttributes,RoCalendarSyncRequestDisplayMetaDataRelations>


export class RoCalendarSyncRequestDisplayMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roCalendarSyncRequestDisplay';
    // Attributes
    CalendarSyncRequestId = new DwItemAttribute(this.i, 'CalendarSyncRequestId');
    SourceRecordKeyDisplay = new DwItemAttribute(this.i, 'SourceRecordKeyDisplay');
    SourceDisplayName = new DwItemAttribute(this.i, 'SourceDisplayName');
}

class RoCalendarSyncRequestDisplayMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Calendar Sync Request */
            CalendarSyncRequest = new DwItemRelationship('CalendarSyncRequest|RoCalendarSyncRequestDisplay', 'CalendarSyncRequest', 'CalendarSyncRequest');
    };
export class RoCheckrideAcsFactBaseMetaData implements DwItem2<RoCheckrideAcsFactBaseEntity, RoCheckrideAcsFactBaseMetaDataAttributes,RoCheckrideAcsFactBaseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2342;
        this.ItemDetail.itemName='roCheckrideAcsFactBase';
        this.ItemDetail.keyName='AssessmentId';
    }

    CreateEntity(): RoCheckrideAcsFactBaseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoCheckrideAcsFactBaseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoCheckrideAcsFactBaseEntity, RoCheckrideAcsFactBaseMetaDataAttributes,RoCheckrideAcsFactBaseMetaDataRelations>(query, this);
    }
     Attributes = new RoCheckrideAcsFactBaseMetaDataAttributes();
     Relations = new RoCheckrideAcsFactBaseMetaDataRelations();

}


export type RoCheckrideAcsFactBaseQueryBuilder = DwQueryBuilderGen<RoCheckrideAcsFactBaseEntity, RoCheckrideAcsFactBaseMetaDataAttributes,RoCheckrideAcsFactBaseMetaDataRelations>


export class RoCheckrideAcsFactBaseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roCheckrideAcsFactBase';
    // Attributes
    SourceType = new DwItemAttribute(this.i, 'SourceType');
    AssessmentId = new DwItemAttribute(this.i, 'AssessmentId');
    AssessmentKey = new DwItemAttribute(this.i, 'AssessmentKey');
    PlanOfActionId = new DwItemAttribute(this.i, 'PlanOfActionId');
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    AcsTestId = new DwItemAttribute(this.i, 'AcsTestId');
    ApplicantAcsWrittenResultTypeId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultTypeId');
    ApplicantAcsWrittenResultId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultId');
    PlanOfActionName = new DwItemAttribute(this.i, 'PlanOfActionName');
    PlanOfActionStatusId = new DwItemAttribute(this.i, 'PlanOfActionStatusId');
    CheckrideRequestSubStatusId = new DwItemAttribute(this.i, 'CheckrideRequestSubStatusId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    CheckRideExaminerTypeId = new DwItemAttribute(this.i, 'CheckRideExaminerTypeId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    AuthorityPreCheckRideNumber = new DwItemAttribute(this.i, 'AuthorityPreCheckRideNumber');
    AuthorityPreapprovalCode = new DwItemAttribute(this.i, 'AuthorityPreapprovalCode');
    CheckRideOwnershipTypeId = new DwItemAttribute(this.i, 'CheckRideOwnershipTypeId');
    CheckRideApplicantTypeId = new DwItemAttribute(this.i, 'CheckRideApplicantTypeId');
    ApplicantName = new DwItemAttribute(this.i, 'ApplicantName');
    ApplicantEmail = new DwItemAttribute(this.i, 'ApplicantEmail');
    ApplicantPhone = new DwItemAttribute(this.i, 'ApplicantPhone');
    ExaminerName = new DwItemAttribute(this.i, 'ExaminerName');
    ExaminerEmail = new DwItemAttribute(this.i, 'ExaminerEmail');
    ExaminerPhone = new DwItemAttribute(this.i, 'ExaminerPhone');
    FlightSchoolApplicantId = new DwItemAttribute(this.i, 'FlightSchoolApplicantId');
    FlightSchoolInstructorId = new DwItemAttribute(this.i, 'FlightSchoolInstructorId');
    CheckrideDateTime = new DwItemAttribute(this.i, 'CheckrideDateTime');
    CheckrideAirportId = new DwItemAttribute(this.i, 'CheckrideAirportId');
    CheckrideGroupId = new DwItemAttribute(this.i, 'CheckrideGroupId');
    CheckrideTypeId = new DwItemAttribute(this.i, 'CheckrideTypeId');
    CheckRideTestTypeId = new DwItemAttribute(this.i, 'CheckRideTestTypeId');
    CheckrideDurationMinutes = new DwItemAttribute(this.i, 'CheckrideDurationMinutes');
    CheckrideEndDateTime = new DwItemAttribute(this.i, 'CheckrideEndDateTime');
    PlanOfActionResultId = new DwItemAttribute(this.i, 'PlanOfActionResultId');
    CheckrideResultId = new DwItemAttribute(this.i, 'CheckrideResultId');
    CheckRideOutcomeId = new DwItemAttribute(this.i, 'CheckRideOutcomeId');
    AllowRetest = new DwItemAttribute(this.i, 'AllowRetest');
    FlagApplicant = new DwItemAttribute(this.i, 'FlagApplicant');
    AllowRetestReason = new DwItemAttribute(this.i, 'AllowRetestReason');
    RetestCost = new DwItemAttribute(this.i, 'RetestCost');
    AddToWaitlist = new DwItemAttribute(this.i, 'AddToWaitlist');
    GroundPortionComplete = new DwItemAttribute(this.i, 'GroundPortionComplete');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    OdaFlightSchoolId = new DwItemAttribute(this.i, 'OdaFlightSchoolId');
    CheckrideTypeShortName = new DwItemAttribute(this.i, 'CheckrideTypeShortName');
    CheckRideTestAttemptClassificationId = new DwItemAttribute(this.i, 'CheckRideTestAttemptClassificationId');
    AttemptClassification = new DwItemAttribute(this.i, 'AttemptClassification');
    IsInitial = new DwItemAttribute(this.i, 'IsInitial');
    IsRetest = new DwItemAttribute(this.i, 'IsRetest');
    IsContinuance = new DwItemAttribute(this.i, 'IsContinuance');
}

class RoCheckrideAcsFactBaseMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoCheckrideAggregateUtilMetaData implements DwItem2<RoCheckrideAggregateUtilEntity, RoCheckrideAggregateUtilMetaDataAttributes,RoCheckrideAggregateUtilMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1187;
        this.ItemDetail.itemName='roCheckrideAggregateUtil';
        this.ItemDetail.keyName='CheckrideRequestId';
    }

    CreateEntity(): RoCheckrideAggregateUtilEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoCheckrideAggregateUtilQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoCheckrideAggregateUtilEntity, RoCheckrideAggregateUtilMetaDataAttributes,RoCheckrideAggregateUtilMetaDataRelations>(query, this);
    }
     Attributes = new RoCheckrideAggregateUtilMetaDataAttributes();
     Relations = new RoCheckrideAggregateUtilMetaDataRelations();

}


export type RoCheckrideAggregateUtilQueryBuilder = DwQueryBuilderGen<RoCheckrideAggregateUtilEntity, RoCheckrideAggregateUtilMetaDataAttributes,RoCheckrideAggregateUtilMetaDataRelations>


export class RoCheckrideAggregateUtilMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roCheckrideAggregateUtil';
    // Attributes
    CheckrideRequestId = new DwItemAttribute(this.i, 'CheckrideRequestId');
    ScheduledDateTime = new DwItemAttribute(this.i, 'ScheduledDateTime');
    ScheduledDateTimeYear = new DwItemAttribute(this.i, 'ScheduledDateTimeYear');
    ScheduledDateTimeMonth = new DwItemAttribute(this.i, 'ScheduledDateTimeMonth');
    ScheduledDateTimeMonthDisplay = new DwItemAttribute(this.i, 'ScheduledDateTimeMonthDisplay');
    CheckRideRequestStatusId = new DwItemAttribute(this.i, 'CheckRideRequestStatusId');
    CheckRideRequestStatus = new DwItemAttribute(this.i, 'CheckRideRequestStatus');
    PilexosPaymentDateTimeYear = new DwItemAttribute(this.i, 'PilexosPaymentDateTimeYear');
    PilexosPaymentDateTimeMonth = new DwItemAttribute(this.i, 'PilexosPaymentDateTimeMonth');
    PilexosPaymentTotal = new DwItemAttribute(this.i, 'PilexosPaymentTotal');
    CheckridePaymentDateTimeYear = new DwItemAttribute(this.i, 'CheckridePaymentDateTimeYear');
    CheckridePaymentDateTimeMonth = new DwItemAttribute(this.i, 'CheckridePaymentDateTimeMonth');
    CheckridePaymentTotal = new DwItemAttribute(this.i, 'CheckridePaymentTotal');
    OutcomeIsRequested = new DwItemAttribute(this.i, 'OutcomeIsRequested');
    OutcomeIsBooked = new DwItemAttribute(this.i, 'OutcomeIsBooked');
    OutcomeIsComplete = new DwItemAttribute(this.i, 'OutcomeIsComplete');
    OutcomeIsCancelled = new DwItemAttribute(this.i, 'OutcomeIsCancelled');
    RevenueIsRequested = new DwItemAttribute(this.i, 'RevenueIsRequested');
    RevenueIsBooked = new DwItemAttribute(this.i, 'RevenueIsBooked');
    RevenueIsComplete = new DwItemAttribute(this.i, 'RevenueIsComplete');
    RevenueIsCancelled = new DwItemAttribute(this.i, 'RevenueIsCancelled');
    CheckRideTypeDisplay = new DwItemAttribute(this.i, 'CheckRideTypeDisplay');
    ScheduledDateTimeMonthYearDisplay = new DwItemAttribute(this.i, 'ScheduledDateTimeMonthYearDisplay');
    CheckRideAcceptedDateTime = new DwItemAttribute(this.i, 'CheckRideAcceptedDateTime');
    CheckRideOutcomeId = new DwItemAttribute(this.i, 'CheckRideOutcomeId');
    CheckRideOutcome = new DwItemAttribute(this.i, 'CheckRideOutcome');
    ResultIsPassed = new DwItemAttribute(this.i, 'ResultIsPassed');
    ResultIsFailed = new DwItemAttribute(this.i, 'ResultIsFailed');
    ResultIsDiscontinued = new DwItemAttribute(this.i, 'ResultIsDiscontinued');
    FinalWaitTimeDays = new DwItemAttribute(this.i, 'FinalWaitTimeDays');
    CurrentWaitTimeDays = new DwItemAttribute(this.i, 'CurrentWaitTimeDays');
    CheckRideDateTime = new DwItemAttribute(this.i, 'CheckRideDateTime');
    CheckRideRequestSubStatusId = new DwItemAttribute(this.i, 'CheckRideRequestSubStatusId');
    CheckRideRequestSubStatus = new DwItemAttribute(this.i, 'CheckRideRequestSubStatus');
}

class RoCheckrideAggregateUtilMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Request - Check Re Request */
            CheckRideRequestByCheckrideRequestId = new DwItemRelationship('CheckRideRequest|roCheckRideAggregateUtil|CheckRideRequestId', 'CheckrideRequestIdCheckRideRequest', 'CheckrideRequestIdCheckRideRequest');
    };
export class RoCheckrideApplicantFinalNameMetaData implements DwItem2<RoCheckrideApplicantFinalNameEntity, RoCheckrideApplicantFinalNameMetaDataAttributes,RoCheckrideApplicantFinalNameMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1184;
        this.ItemDetail.itemName='roCheckrideApplicantFinalName';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoCheckrideApplicantFinalNameEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoCheckrideApplicantFinalNameQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoCheckrideApplicantFinalNameEntity, RoCheckrideApplicantFinalNameMetaDataAttributes,RoCheckrideApplicantFinalNameMetaDataRelations>(query, this);
    }
     Attributes = new RoCheckrideApplicantFinalNameMetaDataAttributes();
     Relations = new RoCheckrideApplicantFinalNameMetaDataRelations();

}


export type RoCheckrideApplicantFinalNameQueryBuilder = DwQueryBuilderGen<RoCheckrideApplicantFinalNameEntity, RoCheckrideApplicantFinalNameMetaDataAttributes,RoCheckrideApplicantFinalNameMetaDataRelations>


export class RoCheckrideApplicantFinalNameMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roCheckrideApplicantFinalName';
    // Attributes
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    StudentApplicantNameManual = new DwItemAttribute(this.i, 'StudentApplicantNameManual');
    StudentProfileName = new DwItemAttribute(this.i, 'StudentProfileName');
    ApplicantFinalName = new DwItemAttribute(this.i, 'ApplicantFinalName');
    CheckRideApplicantTypeId = new DwItemAttribute(this.i, 'CheckRideApplicantTypeId');
    ApplicantFinalEmail = new DwItemAttribute(this.i, 'ApplicantFinalEmail');
    ApplicantFinalPhone = new DwItemAttribute(this.i, 'ApplicantFinalPhone');
    FlightSchoolFinalName = new DwItemAttribute(this.i, 'FlightSchoolFinalName');
    PilotExaminerFinalName = new DwItemAttribute(this.i, 'PilotExaminerFinalName');
    PilotExaminerFinalEmail = new DwItemAttribute(this.i, 'PilotExaminerFinalEmail');
    PilotExaminerFinalPhone = new DwItemAttribute(this.i, 'PilotExaminerFinalPhone');
    FlightInstructorFinalName = new DwItemAttribute(this.i, 'FlightInstructorFinalName');
    FlightInstructorFinalEmail = new DwItemAttribute(this.i, 'FlightInstructorFinalEmail');
    FlightInstructorFinalPhone = new DwItemAttribute(this.i, 'FlightInstructorFinalPhone');
    CheckRideExaminerTypeId = new DwItemAttribute(this.i, 'CheckRideExaminerTypeId');
}

class RoCheckrideApplicantFinalNameMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('CheckRideRequest|roCheckRideApplicanetFinalName|CheckRideRequestId', 'CheckRideRequest', 'CheckRideRequest');
    };
export class RoCheckrideFactBaseMetaData implements DwItem2<RoCheckrideFactBaseEntity, RoCheckrideFactBaseMetaDataAttributes,RoCheckrideFactBaseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2345;
        this.ItemDetail.itemName='roCheckrideFactBase';
        this.ItemDetail.keyName='AssessmentId';
    }

    CreateEntity(): RoCheckrideFactBaseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoCheckrideFactBaseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoCheckrideFactBaseEntity, RoCheckrideFactBaseMetaDataAttributes,RoCheckrideFactBaseMetaDataRelations>(query, this);
    }
     Attributes = new RoCheckrideFactBaseMetaDataAttributes();
     Relations = new RoCheckrideFactBaseMetaDataRelations();

}


export type RoCheckrideFactBaseQueryBuilder = DwQueryBuilderGen<RoCheckrideFactBaseEntity, RoCheckrideFactBaseMetaDataAttributes,RoCheckrideFactBaseMetaDataRelations>


export class RoCheckrideFactBaseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roCheckrideFactBase';
    // Attributes
    SourceType = new DwItemAttribute(this.i, 'SourceType');
    AssessmentId = new DwItemAttribute(this.i, 'AssessmentId');
    AssessmentKey = new DwItemAttribute(this.i, 'AssessmentKey');
    PlanOfActionId = new DwItemAttribute(this.i, 'PlanOfActionId');
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    PlanOfActionName = new DwItemAttribute(this.i, 'PlanOfActionName');
    PlanOfActionStatusId = new DwItemAttribute(this.i, 'PlanOfActionStatusId');
    CheckrideRequestSubStatusId = new DwItemAttribute(this.i, 'CheckrideRequestSubStatusId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    CheckRideExaminerTypeId = new DwItemAttribute(this.i, 'CheckRideExaminerTypeId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    AuthorityPreCheckRideNumber = new DwItemAttribute(this.i, 'AuthorityPreCheckRideNumber');
    AuthorityPreapprovalCode = new DwItemAttribute(this.i, 'AuthorityPreapprovalCode');
    CheckRideOwnershipTypeId = new DwItemAttribute(this.i, 'CheckRideOwnershipTypeId');
    CheckRideApplicantTypeId = new DwItemAttribute(this.i, 'CheckRideApplicantTypeId');
    ApplicantName = new DwItemAttribute(this.i, 'ApplicantName');
    ApplicantEmail = new DwItemAttribute(this.i, 'ApplicantEmail');
    ApplicantPhone = new DwItemAttribute(this.i, 'ApplicantPhone');
    ExaminerName = new DwItemAttribute(this.i, 'ExaminerName');
    ExaminerEmail = new DwItemAttribute(this.i, 'ExaminerEmail');
    ExaminerPhone = new DwItemAttribute(this.i, 'ExaminerPhone');
    FlightSchoolApplicantId = new DwItemAttribute(this.i, 'FlightSchoolApplicantId');
    FlightSchoolInstructorId = new DwItemAttribute(this.i, 'FlightSchoolInstructorId');
    CheckrideDateTime = new DwItemAttribute(this.i, 'CheckrideDateTime');
    CheckrideAirportId = new DwItemAttribute(this.i, 'CheckrideAirportId');
    CheckrideGroupId = new DwItemAttribute(this.i, 'CheckrideGroupId');
    CheckrideTypeId = new DwItemAttribute(this.i, 'CheckrideTypeId');
    CheckRideTestTypeId = new DwItemAttribute(this.i, 'CheckRideTestTypeId');
    CheckrideDurationMinutes = new DwItemAttribute(this.i, 'CheckrideDurationMinutes');
    CheckrideEndDateTime = new DwItemAttribute(this.i, 'CheckrideEndDateTime');
    PlanOfActionResultId = new DwItemAttribute(this.i, 'PlanOfActionResultId');
    CheckrideResultId = new DwItemAttribute(this.i, 'CheckrideResultId');
    CheckRideOutcomeId = new DwItemAttribute(this.i, 'CheckRideOutcomeId');
    AllowRetest = new DwItemAttribute(this.i, 'AllowRetest');
    FlagApplicant = new DwItemAttribute(this.i, 'FlagApplicant');
    AllowRetestReason = new DwItemAttribute(this.i, 'AllowRetestReason');
    RetestCost = new DwItemAttribute(this.i, 'RetestCost');
    AddToWaitlist = new DwItemAttribute(this.i, 'AddToWaitlist');
    GroundPortionComplete = new DwItemAttribute(this.i, 'GroundPortionComplete');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    OdaFlightSchoolId = new DwItemAttribute(this.i, 'OdaFlightSchoolId');
    CheckRideTestAttemptClassificationId = new DwItemAttribute(this.i, 'CheckRideTestAttemptClassificationId');
    AttemptClassification = new DwItemAttribute(this.i, 'AttemptClassification');
    PerformanceOutcome = new DwItemAttribute(this.i, 'PerformanceOutcome');
    IsInitial = new DwItemAttribute(this.i, 'IsInitial');
    IsRetest = new DwItemAttribute(this.i, 'IsRetest');
    IsContinuance = new DwItemAttribute(this.i, 'IsContinuance');
    IsPerformanceEligible = new DwItemAttribute(this.i, 'IsPerformanceEligible');
    EligibleAssessmentCount = new DwItemAttribute(this.i, 'EligibleAssessmentCount');
    PassCount = new DwItemAttribute(this.i, 'PassCount');
    FailCount = new DwItemAttribute(this.i, 'FailCount');
    CheckrideTypeShortName = new DwItemAttribute(this.i, 'CheckrideTypeShortName');
    CheckrideYear = new DwItemAttribute(this.i, 'CheckrideYear');
    CheckRideRequestStatusId = new DwItemAttribute(this.i, 'CheckRideRequestStatusId');
    CheckRideRequestStatus = new DwItemAttribute(this.i, 'CheckRideRequestStatus');
    InstructorName = new DwItemAttribute(this.i, 'InstructorName');
    CheckRideCancellationTypeId = new DwItemAttribute(this.i, 'CheckRideCancellationTypeId');
    ApplicantFlightSchoolName = new DwItemAttribute(this.i, 'ApplicantFlightSchoolName');
    CheckrideMonth = new DwItemAttribute(this.i, 'CheckrideMonth');
    CheckrideMonthKey = new DwItemAttribute(this.i, 'CheckrideMonthKey');
    CheckrideMonthYearDisplay = new DwItemAttribute(this.i, 'CheckrideMonthYearDisplay');
    FinalWaitTimeDays = new DwItemAttribute(this.i, 'FinalWaitTimeDays');
    CurrentWaitTimeDays = new DwItemAttribute(this.i, 'CurrentWaitTimeDays');
    AviationTrainingProgramId = new DwItemAttribute(this.i, 'AviationTrainingProgramId');
    RequestedCount = new DwItemAttribute(this.i, 'RequestedCount');
    BookedCount = new DwItemAttribute(this.i, 'BookedCount');
    CompletedCount = new DwItemAttribute(this.i, 'CompletedCount');
    CancelledCount = new DwItemAttribute(this.i, 'CancelledCount');
    RequestedRevenue = new DwItemAttribute(this.i, 'RequestedRevenue');
    BookedRevenue = new DwItemAttribute(this.i, 'BookedRevenue');
    CompletedRevenue = new DwItemAttribute(this.i, 'CompletedRevenue');
    PaidRevenue = new DwItemAttribute(this.i, 'PaidRevenue');
    ResultPassCount = new DwItemAttribute(this.i, 'ResultPassCount');
    ResultFailCount = new DwItemAttribute(this.i, 'ResultFailCount');
    ResultDiscontinuedCount = new DwItemAttribute(this.i, 'ResultDiscontinuedCount');
}

class RoCheckrideFactBaseMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoCheckRidePaymentAggregateMetaData implements DwItem2<RoCheckRidePaymentAggregateEntity, RoCheckRidePaymentAggregateMetaDataAttributes,RoCheckRidePaymentAggregateMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1188;
        this.ItemDetail.itemName='roCheckRidePaymentAggregate';
        this.ItemDetail.keyName='CheckrideRequestId';
    }

    CreateEntity(): RoCheckRidePaymentAggregateEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoCheckRidePaymentAggregateQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoCheckRidePaymentAggregateEntity, RoCheckRidePaymentAggregateMetaDataAttributes,RoCheckRidePaymentAggregateMetaDataRelations>(query, this);
    }
     Attributes = new RoCheckRidePaymentAggregateMetaDataAttributes();
     Relations = new RoCheckRidePaymentAggregateMetaDataRelations();

}


export type RoCheckRidePaymentAggregateQueryBuilder = DwQueryBuilderGen<RoCheckRidePaymentAggregateEntity, RoCheckRidePaymentAggregateMetaDataAttributes,RoCheckRidePaymentAggregateMetaDataRelations>


export class RoCheckRidePaymentAggregateMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roCheckRidePaymentAggregate';
    // Attributes
    CheckrideRequestId = new DwItemAttribute(this.i, 'CheckrideRequestId');
    PaymentDateTimeYear = new DwItemAttribute(this.i, 'PaymentDateTimeYear');
    PaymentDateTimeMonth = new DwItemAttribute(this.i, 'PaymentDateTimeMonth');
    IsCheckridePayment = new DwItemAttribute(this.i, 'IsCheckridePayment');
    Count = new DwItemAttribute(this.i, 'Count');
    PaymentTotal = new DwItemAttribute(this.i, 'PaymentTotal');
    PaymentPartyId = new DwItemAttribute(this.i, 'PaymentPartyId');
}

class RoCheckRidePaymentAggregateMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoCheckRideRequestApplicantMetaData implements DwItem2<RoCheckRideRequestApplicantEntity, RoCheckRideRequestApplicantMetaDataAttributes,RoCheckRideRequestApplicantMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2289;
        this.ItemDetail.itemName='roCheckRideRequestApplicant';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoCheckRideRequestApplicantEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoCheckRideRequestApplicantQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoCheckRideRequestApplicantEntity, RoCheckRideRequestApplicantMetaDataAttributes,RoCheckRideRequestApplicantMetaDataRelations>(query, this);
    }
     Attributes = new RoCheckRideRequestApplicantMetaDataAttributes();
     Relations = new RoCheckRideRequestApplicantMetaDataRelations();

}


export type RoCheckRideRequestApplicantQueryBuilder = DwQueryBuilderGen<RoCheckRideRequestApplicantEntity, RoCheckRideRequestApplicantMetaDataAttributes,RoCheckRideRequestApplicantMetaDataRelations>


export class RoCheckRideRequestApplicantMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roCheckRideRequestApplicant';
    // Attributes
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    AuthorityPreCheckRideNumber = new DwItemAttribute(this.i, 'AuthorityPreCheckRideNumber');
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    CheckRideTypeId = new DwItemAttribute(this.i, 'CheckRideTypeId');
    CheckRideTestTypeId = new DwItemAttribute(this.i, 'CheckRideTestTypeId');
    CheckRideRequestSubStatusId = new DwItemAttribute(this.i, 'CheckRideRequestSubStatusId');
    StudentApplicantNameManual = new DwItemAttribute(this.i, 'StudentApplicantNameManual');
    StudentApplicantEmailManual = new DwItemAttribute(this.i, 'StudentApplicantEmailManual');
    FlightSchoolApplicantId = new DwItemAttribute(this.i, 'FlightSchoolApplicantId');
    StudentApplicantId = new DwItemAttribute(this.i, 'StudentApplicantId');
    StudentApplicantEmail = new DwItemAttribute(this.i, 'StudentApplicantEmail');
    StudentApplicantName = new DwItemAttribute(this.i, 'StudentApplicantName');
    FlightSchoolApplicantEmail = new DwItemAttribute(this.i, 'FlightSchoolApplicantEmail');
    FlightSchoolApplicantName = new DwItemAttribute(this.i, 'FlightSchoolApplicantName');
}

class RoCheckRideRequestApplicantMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('CheckrideRequest|RoCheckRideRequestApplicant|CheckrideRequestId', 'CheckRideRequest', 'CheckRideRequest');
    };
export class RoCheckrideRequestScheduleDateInfoMetaData implements DwItem2<RoCheckrideRequestScheduleDateInfoEntity, RoCheckrideRequestScheduleDateInfoMetaDataAttributes,RoCheckrideRequestScheduleDateInfoMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1186;
        this.ItemDetail.itemName='roCheckrideRequestScheduleDateInfo';
        this.ItemDetail.keyName='CheckrideRequestId';
    }

    CreateEntity(): RoCheckrideRequestScheduleDateInfoEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoCheckrideRequestScheduleDateInfoQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoCheckrideRequestScheduleDateInfoEntity, RoCheckrideRequestScheduleDateInfoMetaDataAttributes,RoCheckrideRequestScheduleDateInfoMetaDataRelations>(query, this);
    }
     Attributes = new RoCheckrideRequestScheduleDateInfoMetaDataAttributes();
     Relations = new RoCheckrideRequestScheduleDateInfoMetaDataRelations();

}


export type RoCheckrideRequestScheduleDateInfoQueryBuilder = DwQueryBuilderGen<RoCheckrideRequestScheduleDateInfoEntity, RoCheckrideRequestScheduleDateInfoMetaDataAttributes,RoCheckrideRequestScheduleDateInfoMetaDataRelations>


export class RoCheckrideRequestScheduleDateInfoMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roCheckrideRequestScheduleDateInfo';
    // Attributes
    ScheduledDateTime = new DwItemAttribute(this.i, 'ScheduledDateTime');
    ScheduledDateTimeYear = new DwItemAttribute(this.i, 'ScheduledDateTimeYear');
    ScheduledDateTimeMonth = new DwItemAttribute(this.i, 'ScheduledDateTimeMonth');
    CheckrideRequestId = new DwItemAttribute(this.i, 'CheckrideRequestId');
    ScheduledDateTimeMonthDisplay = new DwItemAttribute(this.i, 'ScheduledDateTimeMonthDisplay');
}

class RoCheckrideRequestScheduleDateInfoMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Request - Check Re Request */
            CheckRideRequestByCheckrideRequestId = new DwItemRelationship('CheckrideRequest|roCheckrideRequestScheduleDateInfo|CheckRideRequestId', 'CheckrideRequestIdCheckRideRequest', 'CheckrideRequestIdCheckRideRequest');
    };
export class RoFlightSchoolExaminerMetaData implements DwItem2<RoFlightSchoolExaminerEntity, RoFlightSchoolExaminerMetaDataAttributes,RoFlightSchoolExaminerMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2282;
        this.ItemDetail.itemName='roFlightSchoolExaminer';
        this.ItemDetail.keyName='FlightSchoolExaminerId';
    }

    CreateEntity(): RoFlightSchoolExaminerEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoFlightSchoolExaminerQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoFlightSchoolExaminerEntity, RoFlightSchoolExaminerMetaDataAttributes,RoFlightSchoolExaminerMetaDataRelations>(query, this);
    }
     Attributes = new RoFlightSchoolExaminerMetaDataAttributes();
     Relations = new RoFlightSchoolExaminerMetaDataRelations();

}


export type RoFlightSchoolExaminerQueryBuilder = DwQueryBuilderGen<RoFlightSchoolExaminerEntity, RoFlightSchoolExaminerMetaDataAttributes,RoFlightSchoolExaminerMetaDataRelations>


export class RoFlightSchoolExaminerMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roFlightSchoolExaminer';
    // Attributes
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    ExaminerNameFinal = new DwItemAttribute(this.i, 'ExaminerNameFinal');
    ExaminerEmailFinal = new DwItemAttribute(this.i, 'ExaminerEmailFinal');
    ExaminerPhoneFinal = new DwItemAttribute(this.i, 'ExaminerPhoneFinal');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    PilotExaminerStatusId = new DwItemAttribute(this.i, 'PilotExaminerStatusId');
    ExaminerGroup = new DwItemAttribute(this.i, 'ExaminerGroup');
    PilotExaminerTypeId = new DwItemAttribute(this.i, 'PilotExaminerTypeId');
    FinalExaminerTypeId = new DwItemAttribute(this.i, 'FinalExaminerTypeId');
    HasPilexosAccount = new DwItemAttribute(this.i, 'HasPilexosAccount');
}

class RoFlightSchoolExaminerMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Examiner */
            FlightSchoolExaminer = new DwItemRelationship('FlightSchoolExaminer|roFlightSchoolExaminer|FlightSchoolExaminerId', 'FlightSchoolExaminer', 'FlightSchoolExaminer');
    };
export class RoFlightSchoolExaminerSearchMetaData implements DwItem2<RoFlightSchoolExaminerSearchEntity, RoFlightSchoolExaminerSearchMetaDataAttributes,RoFlightSchoolExaminerSearchMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2333;
        this.ItemDetail.itemName='roFlightSchoolExaminerSearch';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoFlightSchoolExaminerSearchEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoFlightSchoolExaminerSearchQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoFlightSchoolExaminerSearchEntity, RoFlightSchoolExaminerSearchMetaDataAttributes,RoFlightSchoolExaminerSearchMetaDataRelations>(query, this);
    }
     Attributes = new RoFlightSchoolExaminerSearchMetaDataAttributes();
     Relations = new RoFlightSchoolExaminerSearchMetaDataRelations();

}


export type RoFlightSchoolExaminerSearchQueryBuilder = DwQueryBuilderGen<RoFlightSchoolExaminerSearchEntity, RoFlightSchoolExaminerSearchMetaDataAttributes,RoFlightSchoolExaminerSearchMetaDataRelations>


export class RoFlightSchoolExaminerSearchMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roFlightSchoolExaminerSearch';
    // Attributes
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    ExaminerNameFinal = new DwItemAttribute(this.i, 'ExaminerNameFinal');
    ExaminerEmailFinal = new DwItemAttribute(this.i, 'ExaminerEmailFinal');
    ExaminerPhoneFinal = new DwItemAttribute(this.i, 'ExaminerPhoneFinal');
    FinalExaminerTypeId = new DwItemAttribute(this.i, 'FinalExaminerTypeId');
    ExaminerGroup = new DwItemAttribute(this.i, 'ExaminerGroup');
    PreTimeMinutes = new DwItemAttribute(this.i, 'PreTimeMinutes');
    PostTimeMinutes = new DwItemAttribute(this.i, 'PostTimeMinutes');
    FirstDate = new DwItemAttribute(this.i, 'FirstDate');
    LastDate = new DwItemAttribute(this.i, 'LastDate');
    AirportId = new DwItemAttribute(this.i, 'AirportId');
    Distance = new DwItemAttribute(this.i, 'Distance');
    ReferenceAirportId = new DwItemAttribute(this.i, 'ReferenceAirportId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    TimezoneId = new DwItemAttribute(this.i, 'TimezoneId');
    ObservesDST = new DwItemAttribute(this.i, 'ObservesDST');
    ReferenceAirportTimezoneId = new DwItemAttribute(this.i, 'ReferenceAirportTimezoneId');
    ReferenceAirportObservesDST = new DwItemAttribute(this.i, 'ReferenceAirportObservesDST');
}

class RoFlightSchoolExaminerSearchMetaDataRelations implements DwItemRelationshipCollection {
    };
export class DwRoleMetaData implements DwItem2<DwRoleEntity, DwRoleMetaDataAttributes,DwRoleMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=171;
        this.ItemDetail.itemName='dw_Role';
        this.ItemDetail.keyName='RoleId';
    }

    CreateEntity(): DwRoleEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwRoleQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwRoleEntity, DwRoleMetaDataAttributes,DwRoleMetaDataRelations>(query, this);
    }
     Attributes = new DwRoleMetaDataAttributes();
     Relations = new DwRoleMetaDataRelations();

}


export type DwRoleQueryBuilder = DwQueryBuilderGen<DwRoleEntity, DwRoleMetaDataAttributes,DwRoleMetaDataRelations>


export class DwRoleMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_Role';
    // Attributes
    ApplicationId = new DwItemAttribute(this.i, 'ApplicationId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    IsBuiltIn = new DwItemAttribute(this.i, 'IsBuiltIn');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    RoleDisplay = new DwItemAttribute(this.i, 'RoleDisplay');
    RoleId = new DwItemAttribute(this.i, 'RoleId');
    RoleMeaning = new DwItemAttribute(this.i, 'RoleMeaning');
    UniqueId = new DwItemAttribute(this.i, 'UniqueId');
}

class DwRoleMetaDataRelations implements DwItemRelationshipCollection {
    };
export class DwRoMediaMetaData implements DwItem2<DwRoMediaEntity, DwRoMediaMetaDataAttributes,DwRoMediaMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=201;
        this.ItemDetail.itemName='dw_roMedia';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): DwRoMediaEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwRoMediaQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwRoMediaEntity, DwRoMediaMetaDataAttributes,DwRoMediaMetaDataRelations>(query, this);
    }
     Attributes = new DwRoMediaMetaDataAttributes();
     Relations = new DwRoMediaMetaDataRelations();

}


export type DwRoMediaQueryBuilder = DwQueryBuilderGen<DwRoMediaEntity, DwRoMediaMetaDataAttributes,DwRoMediaMetaDataRelations>


export class DwRoMediaMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_roMedia';
    // Attributes
    ContainerName = new DwItemAttribute(this.i, 'ContainerName');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    FileName = new DwItemAttribute(this.i, 'FileName');
    ImageHeight = new DwItemAttribute(this.i, 'ImageHeight');
    ImageWidth = new DwItemAttribute(this.i, 'ImageWidth');
    IsDeleted = new DwItemAttribute(this.i, 'IsDeleted');
    IsSecure = new DwItemAttribute(this.i, 'IsSecure');
    MediaDetailKey = new DwItemAttribute(this.i, 'MediaDetailKey');
    MediaFolderId = new DwItemAttribute(this.i, 'MediaFolderId');
    MediaGroupId = new DwItemAttribute(this.i, 'MediaGroupId');
    MediaId = new DwItemAttribute(this.i, 'MediaId');
    MediaName = new DwItemAttribute(this.i, 'MediaName');
    MediaPath = new DwItemAttribute(this.i, 'MediaPath');
    MediaSizeType = new DwItemAttribute(this.i, 'MediaSizeType');
    MediaSizeTypeId = new DwItemAttribute(this.i, 'MediaSizeTypeId');
    MediaTypeId = new DwItemAttribute(this.i, 'MediaTypeId');
    SizeInBytes = new DwItemAttribute(this.i, 'SizeInBytes');
    Version = new DwItemAttribute(this.i, 'Version');
}

class DwRoMediaMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Media Group */
            DwMediaGroup = new DwItemRelationship('MediaGroup_roMedia', 'DwMediaGroup', 'DwMediaGroup');
            /** Relation: User - Media */
            DwUserByUserPictureMediaId = new DwItemRelationship('roMedia|User|UserPictureMediaId', 'UserPictureDwUser', 'UserPictureDwUser');
    };
export class RoPilotExaminerLocationCurrentMetaData implements DwItem2<RoPilotExaminerLocationCurrentEntity, RoPilotExaminerLocationCurrentMetaDataAttributes,RoPilotExaminerLocationCurrentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1167;
        this.ItemDetail.itemName='roPilotExaminerLocationCurrent';
        this.ItemDetail.keyName='PilotExaminerLocationId';
    }

    CreateEntity(): RoPilotExaminerLocationCurrentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoPilotExaminerLocationCurrentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoPilotExaminerLocationCurrentEntity, RoPilotExaminerLocationCurrentMetaDataAttributes,RoPilotExaminerLocationCurrentMetaDataRelations>(query, this);
    }
     Attributes = new RoPilotExaminerLocationCurrentMetaDataAttributes();
     Relations = new RoPilotExaminerLocationCurrentMetaDataRelations();

}


export type RoPilotExaminerLocationCurrentQueryBuilder = DwQueryBuilderGen<RoPilotExaminerLocationCurrentEntity, RoPilotExaminerLocationCurrentMetaDataAttributes,RoPilotExaminerLocationCurrentMetaDataRelations>


export class RoPilotExaminerLocationCurrentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roPilotExaminerLocationCurrent';
    // Attributes
    PilotExaminerLocationId = new DwItemAttribute(this.i, 'PilotExaminerLocationId');
    PilotExaminerLocationStateId = new DwItemAttribute(this.i, 'PilotExaminerLocationStateId');
}

class RoPilotExaminerLocationCurrentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Pilot Examiner Location */
            PilotExaminerLocation = new DwItemRelationship('PilotExaminerLocation|roPilotExaminerLocationCurrent', 'PilotExaminerLocation', 'PilotExaminerLocation');
    };
export class RoPilotExaminerLocationDistancesMetaData implements DwItem2<RoPilotExaminerLocationDistancesEntity, RoPilotExaminerLocationDistancesMetaDataAttributes,RoPilotExaminerLocationDistancesMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1165;
        this.ItemDetail.itemName='roPilotExaminerLocationDistances';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoPilotExaminerLocationDistancesEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoPilotExaminerLocationDistancesQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoPilotExaminerLocationDistancesEntity, RoPilotExaminerLocationDistancesMetaDataAttributes,RoPilotExaminerLocationDistancesMetaDataRelations>(query, this);
    }
     Attributes = new RoPilotExaminerLocationDistancesMetaDataAttributes();
     Relations = new RoPilotExaminerLocationDistancesMetaDataRelations();

}


export type RoPilotExaminerLocationDistancesQueryBuilder = DwQueryBuilderGen<RoPilotExaminerLocationDistancesEntity, RoPilotExaminerLocationDistancesMetaDataAttributes,RoPilotExaminerLocationDistancesMetaDataRelations>


export class RoPilotExaminerLocationDistancesMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roPilotExaminerLocationDistances';
    // Attributes
    ReferenceAirportId = new DwItemAttribute(this.i, 'ReferenceAirportId');
    ReferenceAirportName = new DwItemAttribute(this.i, 'ReferenceAirportName');
    ReferenceAirportLatitude = new DwItemAttribute(this.i, 'ReferenceAirportLatitude');
    ReferenceAirportLongitude = new DwItemAttribute(this.i, 'ReferenceAirportLongitude');
    AirportId = new DwItemAttribute(this.i, 'AirportId');
    AirportName = new DwItemAttribute(this.i, 'AirportName');
    Latitude = new DwItemAttribute(this.i, 'Latitude');
    Longitude = new DwItemAttribute(this.i, 'Longitude');
    Distance = new DwItemAttribute(this.i, 'Distance');
    PilotExaminerLocationId = new DwItemAttribute(this.i, 'PilotExaminerLocationId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    WithinTravelRadius = new DwItemAttribute(this.i, 'WithinTravelRadius');
    TravelRadiusMile = new DwItemAttribute(this.i, 'TravelRadiusMile');
    ReferenceAirportCode = new DwItemAttribute(this.i, 'ReferenceAirportCode');
    AirportCode = new DwItemAttribute(this.i, 'AirportCode');
}

class RoPilotExaminerLocationDistancesMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Airport */
            Airport = new DwItemRelationship('RoPilotExaminerLocationDistances|Airport|AirportId', 'Airport', 'Airport');
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('PilotExaminer|RoPilotExaminerLocation', 'PilotExaminer', 'PilotExaminer');
            /** Relation: Pilot Examiner Location */
            PilotExaminerLocation = new DwItemRelationship('PIlotExaminerLocation|RoPilotExaminerLocation', 'PilotExaminerLocation', 'PilotExaminerLocation');
    };
export class RoPilotExaminerScenarioMetaData implements DwItem2<RoPilotExaminerScenarioEntity, RoPilotExaminerScenarioMetaDataAttributes,RoPilotExaminerScenarioMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1166;
        this.ItemDetail.itemName='roPilotExaminerScenario';
        this.ItemDetail.keyName='CheckRideScenarioTypeMapId';
    }

    CreateEntity(): RoPilotExaminerScenarioEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoPilotExaminerScenarioQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoPilotExaminerScenarioEntity, RoPilotExaminerScenarioMetaDataAttributes,RoPilotExaminerScenarioMetaDataRelations>(query, this);
    }
     Attributes = new RoPilotExaminerScenarioMetaDataAttributes();
     Relations = new RoPilotExaminerScenarioMetaDataRelations();

}


export type RoPilotExaminerScenarioQueryBuilder = DwQueryBuilderGen<RoPilotExaminerScenarioEntity, RoPilotExaminerScenarioMetaDataAttributes,RoPilotExaminerScenarioMetaDataRelations>


export class RoPilotExaminerScenarioMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roPilotExaminerScenario';
    // Attributes
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    UserId = new DwItemAttribute(this.i, 'userId');
    PilotExaminerStatusId = new DwItemAttribute(this.i, 'PilotExaminerStatusId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    CheckRideScenarioId = new DwItemAttribute(this.i, 'CheckRideScenarioId');
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    PreTimeMinutes = new DwItemAttribute(this.i, 'PreTimeMinutes');
    PostTimeMinutes = new DwItemAttribute(this.i, 'PostTimeMinutes');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    TimeRequiredHours = new DwItemAttribute(this.i, 'TimeRequiredHours');
    CheckRideTypeId = new DwItemAttribute(this.i, 'CheckRideTypeId');
    CheckRideGroup = new DwItemAttribute(this.i, 'CheckRideGroup');
    CheckRideType = new DwItemAttribute(this.i, 'CheckRideType');
    CheckRideScenarioTypeMapId = new DwItemAttribute(this.i, 'CheckRideScenarioTypeMapId');
}

class RoPilotExaminerScenarioMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Exam Type */
            CheckRideScenario = new DwItemRelationship('CheckRideScenario|roPilotExaminerScenario', 'CheckRideScenario', 'CheckRideScenario');
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('PIlotExaminer|RoPilotExaminerScenario', 'PilotExaminer', 'PilotExaminer');
            /** Relation: User - Examiner Name */
            DwUserByuserId = new DwItemRelationship('User|RoPilotExaminer|UserId', 'UserIdDwUser', 'UserIdDwUser');
    };
export class RoPlanOfActionAcsFactBaseMetaData implements DwItem2<RoPlanOfActionAcsFactBaseEntity, RoPlanOfActionAcsFactBaseMetaDataAttributes,RoPlanOfActionAcsFactBaseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2343;
        this.ItemDetail.itemName='roPlanOfActionAcsFactBase';
        this.ItemDetail.keyName='AssessmentId';
    }

    CreateEntity(): RoPlanOfActionAcsFactBaseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoPlanOfActionAcsFactBaseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoPlanOfActionAcsFactBaseEntity, RoPlanOfActionAcsFactBaseMetaDataAttributes,RoPlanOfActionAcsFactBaseMetaDataRelations>(query, this);
    }
     Attributes = new RoPlanOfActionAcsFactBaseMetaDataAttributes();
     Relations = new RoPlanOfActionAcsFactBaseMetaDataRelations();

}


export type RoPlanOfActionAcsFactBaseQueryBuilder = DwQueryBuilderGen<RoPlanOfActionAcsFactBaseEntity, RoPlanOfActionAcsFactBaseMetaDataAttributes,RoPlanOfActionAcsFactBaseMetaDataRelations>


export class RoPlanOfActionAcsFactBaseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roPlanOfActionAcsFactBase';
    // Attributes
    SourceType = new DwItemAttribute(this.i, 'SourceType');
    AssessmentId = new DwItemAttribute(this.i, 'AssessmentId');
    AssessmentKey = new DwItemAttribute(this.i, 'AssessmentKey');
    PlanOfActionId = new DwItemAttribute(this.i, 'PlanOfActionId');
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    AcsTestId = new DwItemAttribute(this.i, 'AcsTestId');
    ApplicantAcsWrittenResultTypeId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultTypeId');
    ApplicantAcsWrittenResultId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultId');
    PlanOfActionName = new DwItemAttribute(this.i, 'PlanOfActionName');
    PlanOfActionStatusId = new DwItemAttribute(this.i, 'PlanOfActionStatusId');
    CheckrideRequestSubStatusId = new DwItemAttribute(this.i, 'CheckrideRequestSubStatusId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    CheckRideExaminerTypeId = new DwItemAttribute(this.i, 'CheckRideExaminerTypeId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    AuthorityPreCheckRideNumber = new DwItemAttribute(this.i, 'AuthorityPreCheckRideNumber');
    AuthorityPreapprovalCode = new DwItemAttribute(this.i, 'AuthorityPreapprovalCode');
    CheckRideOwnershipTypeId = new DwItemAttribute(this.i, 'CheckRideOwnershipTypeId');
    CheckRideApplicantTypeId = new DwItemAttribute(this.i, 'CheckRideApplicantTypeId');
    ApplicantName = new DwItemAttribute(this.i, 'ApplicantName');
    ApplicantEmail = new DwItemAttribute(this.i, 'ApplicantEmail');
    ApplicantPhone = new DwItemAttribute(this.i, 'ApplicantPhone');
    ExaminerName = new DwItemAttribute(this.i, 'ExaminerName');
    ExaminerEmail = new DwItemAttribute(this.i, 'ExaminerEmail');
    ExaminerPhone = new DwItemAttribute(this.i, 'ExaminerPhone');
    FlightSchoolApplicantId = new DwItemAttribute(this.i, 'FlightSchoolApplicantId');
    FlightSchoolInstructorId = new DwItemAttribute(this.i, 'FlightSchoolInstructorId');
    CheckrideDateTime = new DwItemAttribute(this.i, 'CheckrideDateTime');
    CheckrideAirportId = new DwItemAttribute(this.i, 'CheckrideAirportId');
    CheckrideGroupId = new DwItemAttribute(this.i, 'CheckrideGroupId');
    CheckrideTypeId = new DwItemAttribute(this.i, 'CheckrideTypeId');
    CheckRideTestTypeId = new DwItemAttribute(this.i, 'CheckRideTestTypeId');
    CheckrideDurationMinutes = new DwItemAttribute(this.i, 'CheckrideDurationMinutes');
    CheckrideEndDateTime = new DwItemAttribute(this.i, 'CheckrideEndDateTime');
    PlanOfActionResultId = new DwItemAttribute(this.i, 'PlanOfActionResultId');
    CheckrideResultId = new DwItemAttribute(this.i, 'CheckrideResultId');
    CheckRideOutcomeId = new DwItemAttribute(this.i, 'CheckRideOutcomeId');
    AllowRetest = new DwItemAttribute(this.i, 'AllowRetest');
    FlagApplicant = new DwItemAttribute(this.i, 'FlagApplicant');
    AllowRetestReason = new DwItemAttribute(this.i, 'AllowRetestReason');
    RetestCost = new DwItemAttribute(this.i, 'RetestCost');
    AddToWaitlist = new DwItemAttribute(this.i, 'AddToWaitlist');
    GroundPortionComplete = new DwItemAttribute(this.i, 'GroundPortionComplete');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    OdaFlightSchoolId = new DwItemAttribute(this.i, 'OdaFlightSchoolId');
    CheckrideTypeShortName = new DwItemAttribute(this.i, 'CheckrideTypeShortName');
    CheckRideTestAttemptClassificationId = new DwItemAttribute(this.i, 'CheckRideTestAttemptClassificationId');
    AttemptClassification = new DwItemAttribute(this.i, 'AttemptClassification');
    IsInitial = new DwItemAttribute(this.i, 'IsInitial');
    IsRetest = new DwItemAttribute(this.i, 'IsRetest');
    IsContinuance = new DwItemAttribute(this.i, 'IsContinuance');
}

class RoPlanOfActionAcsFactBaseMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoPlanOfActionDetailsMetaData implements DwItem2<RoPlanOfActionDetailsEntity, RoPlanOfActionDetailsMetaDataAttributes,RoPlanOfActionDetailsMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1230;
        this.ItemDetail.itemName='roPlanOfActionDetails';
        this.ItemDetail.keyName='PlanOfActionId';
    }

    CreateEntity(): RoPlanOfActionDetailsEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoPlanOfActionDetailsQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoPlanOfActionDetailsEntity, RoPlanOfActionDetailsMetaDataAttributes,RoPlanOfActionDetailsMetaDataRelations>(query, this);
    }
     Attributes = new RoPlanOfActionDetailsMetaDataAttributes();
     Relations = new RoPlanOfActionDetailsMetaDataRelations();

}


export type RoPlanOfActionDetailsQueryBuilder = DwQueryBuilderGen<RoPlanOfActionDetailsEntity, RoPlanOfActionDetailsMetaDataAttributes,RoPlanOfActionDetailsMetaDataRelations>


export class RoPlanOfActionDetailsMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roPlanOfActionDetails';
    // Attributes
    PlanOfActionId = new DwItemAttribute(this.i, 'PlanOfActionId');
    PlanOfActionName = new DwItemAttribute(this.i, 'PlanOfActionName');
    ApplicantFinalName = new DwItemAttribute(this.i, 'ApplicantFinalName');
    ApplicantFinalEmail = new DwItemAttribute(this.i, 'ApplicantFinalEmail');
    ApplicationFinalPhone = new DwItemAttribute(this.i, 'ApplicationFinalPhone');
    CheckRideFinalDateTime = new DwItemAttribute(this.i, 'CheckRideFinalDateTime');
    CheckRideFinalAirportId = new DwItemAttribute(this.i, 'CheckRideFinalAirportId');
    CheckRideFinalGroupId = new DwItemAttribute(this.i, 'CheckRideFinalGroupId');
    CheckRideFInalTypeId = new DwItemAttribute(this.i, 'CheckRideFInalTypeId');
    CheckRideFinalTestTypeId = new DwItemAttribute(this.i, 'CheckRideFinalTestTypeId');
    CheckRideFinalDurationMinutes = new DwItemAttribute(this.i, 'CheckRideFinalDurationMinutes');
    CheckRideFinalEndDateTime = new DwItemAttribute(this.i, 'CheckRideFinalEndDateTime');
    FlightInstructorFinalId = new DwItemAttribute(this.i, 'FlightInstructorFinalId');
    FlightSchoolApplicantId = new DwItemAttribute(this.i, 'FlightSchoolApplicantId');
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
}

class RoPlanOfActionDetailsMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Plan Of Action */
            PlanOfAction = new DwItemRelationship('PlanOfAction|roPlanOfActionDetails|PlanOfActionId', 'PlanOfAction', 'PlanOfAction');
    };
export class RoPlanOfActionFactBaseMetaData implements DwItem2<RoPlanOfActionFactBaseEntity, RoPlanOfActionFactBaseMetaDataAttributes,RoPlanOfActionFactBaseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2344;
        this.ItemDetail.itemName='roPlanOfActionFactBase';
        this.ItemDetail.keyName='AssessmentId';
    }

    CreateEntity(): RoPlanOfActionFactBaseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoPlanOfActionFactBaseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoPlanOfActionFactBaseEntity, RoPlanOfActionFactBaseMetaDataAttributes,RoPlanOfActionFactBaseMetaDataRelations>(query, this);
    }
     Attributes = new RoPlanOfActionFactBaseMetaDataAttributes();
     Relations = new RoPlanOfActionFactBaseMetaDataRelations();

}


export type RoPlanOfActionFactBaseQueryBuilder = DwQueryBuilderGen<RoPlanOfActionFactBaseEntity, RoPlanOfActionFactBaseMetaDataAttributes,RoPlanOfActionFactBaseMetaDataRelations>


export class RoPlanOfActionFactBaseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roPlanOfActionFactBase';
    // Attributes
    SourceType = new DwItemAttribute(this.i, 'SourceType');
    AssessmentId = new DwItemAttribute(this.i, 'AssessmentId');
    AssessmentKey = new DwItemAttribute(this.i, 'AssessmentKey');
    PlanOfActionId = new DwItemAttribute(this.i, 'PlanOfActionId');
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    PlanOfActionName = new DwItemAttribute(this.i, 'PlanOfActionName');
    PlanOfActionStatusId = new DwItemAttribute(this.i, 'PlanOfActionStatusId');
    CheckrideRequestSubStatusId = new DwItemAttribute(this.i, 'CheckrideRequestSubStatusId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    CheckRideExaminerTypeId = new DwItemAttribute(this.i, 'CheckRideExaminerTypeId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    AuthorityPreCheckRideNumber = new DwItemAttribute(this.i, 'AuthorityPreCheckRideNumber');
    AuthorityPreapprovalCode = new DwItemAttribute(this.i, 'AuthorityPreapprovalCode');
    CheckRideOwnershipTypeId = new DwItemAttribute(this.i, 'CheckRideOwnershipTypeId');
    CheckRideApplicantTypeId = new DwItemAttribute(this.i, 'CheckRideApplicantTypeId');
    ApplicantName = new DwItemAttribute(this.i, 'ApplicantName');
    ApplicantEmail = new DwItemAttribute(this.i, 'ApplicantEmail');
    ApplicantPhone = new DwItemAttribute(this.i, 'ApplicantPhone');
    ExaminerName = new DwItemAttribute(this.i, 'ExaminerName');
    ExaminerEmail = new DwItemAttribute(this.i, 'ExaminerEmail');
    ExaminerPhone = new DwItemAttribute(this.i, 'ExaminerPhone');
    FlightSchoolApplicantId = new DwItemAttribute(this.i, 'FlightSchoolApplicantId');
    FlightSchoolInstructorId = new DwItemAttribute(this.i, 'FlightSchoolInstructorId');
    CheckrideDateTime = new DwItemAttribute(this.i, 'CheckrideDateTime');
    CheckrideAirportId = new DwItemAttribute(this.i, 'CheckrideAirportId');
    CheckrideGroupId = new DwItemAttribute(this.i, 'CheckrideGroupId');
    CheckrideTypeId = new DwItemAttribute(this.i, 'CheckrideTypeId');
    CheckRideTestTypeId = new DwItemAttribute(this.i, 'CheckRideTestTypeId');
    CheckrideDurationMinutes = new DwItemAttribute(this.i, 'CheckrideDurationMinutes');
    CheckrideEndDateTime = new DwItemAttribute(this.i, 'CheckrideEndDateTime');
    PlanOfActionResultId = new DwItemAttribute(this.i, 'PlanOfActionResultId');
    CheckrideResultId = new DwItemAttribute(this.i, 'CheckrideResultId');
    CheckRideOutcomeId = new DwItemAttribute(this.i, 'CheckRideOutcomeId');
    AllowRetest = new DwItemAttribute(this.i, 'AllowRetest');
    FlagApplicant = new DwItemAttribute(this.i, 'FlagApplicant');
    AllowRetestReason = new DwItemAttribute(this.i, 'AllowRetestReason');
    RetestCost = new DwItemAttribute(this.i, 'RetestCost');
    AddToWaitlist = new DwItemAttribute(this.i, 'AddToWaitlist');
    GroundPortionComplete = new DwItemAttribute(this.i, 'GroundPortionComplete');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    OdaFlightSchoolId = new DwItemAttribute(this.i, 'OdaFlightSchoolId');
    CheckrideTypeShortName = new DwItemAttribute(this.i, 'CheckrideTypeShortName');
}

class RoPlanOfActionFactBaseMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoScheduleBlockSchoolExaminerFinalMetaData implements DwItem2<RoScheduleBlockSchoolExaminerFinalEntity, RoScheduleBlockSchoolExaminerFinalMetaDataAttributes,RoScheduleBlockSchoolExaminerFinalMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2332;
        this.ItemDetail.itemName='roScheduleBlockSchoolExaminerFinal';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoScheduleBlockSchoolExaminerFinalEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoScheduleBlockSchoolExaminerFinalQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoScheduleBlockSchoolExaminerFinalEntity, RoScheduleBlockSchoolExaminerFinalMetaDataAttributes,RoScheduleBlockSchoolExaminerFinalMetaDataRelations>(query, this);
    }
     Attributes = new RoScheduleBlockSchoolExaminerFinalMetaDataAttributes();
     Relations = new RoScheduleBlockSchoolExaminerFinalMetaDataRelations();

}


export type RoScheduleBlockSchoolExaminerFinalQueryBuilder = DwQueryBuilderGen<RoScheduleBlockSchoolExaminerFinalEntity, RoScheduleBlockSchoolExaminerFinalMetaDataAttributes,RoScheduleBlockSchoolExaminerFinalMetaDataRelations>


export class RoScheduleBlockSchoolExaminerFinalMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roScheduleBlockSchoolExaminerFinal';
    // Attributes
    ScheduleBlockId = new DwItemAttribute(this.i, 'ScheduleBlockId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    ExaminerNameFinal = new DwItemAttribute(this.i, 'ExaminerNameFinal');
    ExaminerEmailFinal = new DwItemAttribute(this.i, 'ExaminerEmailFinal');
    FlightScholExaminerTypeIdFinal = new DwItemAttribute(this.i, 'FlightScholExaminerTypeIdFinal');
}

class RoScheduleBlockSchoolExaminerFinalMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Schedule Block */
            ScheduleBlock = new DwItemRelationship('ScheduleBlock|RoScheduleBlockSchoolExaminerFinal|ScheduleBlockId', 'ScheduleBlock', 'ScheduleBlock');
    };
export class RoSchoolExaminersMetaData implements DwItem2<RoSchoolExaminersEntity, RoSchoolExaminersMetaDataAttributes,RoSchoolExaminersMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2288;
        this.ItemDetail.itemName='roSchoolExaminers';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoSchoolExaminersEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoSchoolExaminersQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoSchoolExaminersEntity, RoSchoolExaminersMetaDataAttributes,RoSchoolExaminersMetaDataRelations>(query, this);
    }
     Attributes = new RoSchoolExaminersMetaDataAttributes();
     Relations = new RoSchoolExaminersMetaDataRelations();

}


export type RoSchoolExaminersQueryBuilder = DwQueryBuilderGen<RoSchoolExaminersEntity, RoSchoolExaminersMetaDataAttributes,RoSchoolExaminersMetaDataRelations>


export class RoSchoolExaminersMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roSchoolExaminers';
    // Attributes
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    ExaminerName = new DwItemAttribute(this.i, 'ExaminerName');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    Type = new DwItemAttribute(this.i, 'Type');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
}

class RoSchoolExaminersMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoUnitMemberDpeSupplementSummaryMetaData implements DwItem2<RoUnitMemberDpeSupplementSummaryEntity, RoUnitMemberDpeSupplementSummaryMetaDataAttributes,RoUnitMemberDpeSupplementSummaryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2380;
        this.ItemDetail.itemName='roUnitMemberDpeSupplementSummary';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoUnitMemberDpeSupplementSummaryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoUnitMemberDpeSupplementSummaryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoUnitMemberDpeSupplementSummaryEntity, RoUnitMemberDpeSupplementSummaryMetaDataAttributes,RoUnitMemberDpeSupplementSummaryMetaDataRelations>(query, this);
    }
     Attributes = new RoUnitMemberDpeSupplementSummaryMetaDataAttributes();
     Relations = new RoUnitMemberDpeSupplementSummaryMetaDataRelations();

}


export type RoUnitMemberDpeSupplementSummaryQueryBuilder = DwQueryBuilderGen<RoUnitMemberDpeSupplementSummaryEntity, RoUnitMemberDpeSupplementSummaryMetaDataAttributes,RoUnitMemberDpeSupplementSummaryMetaDataRelations>


export class RoUnitMemberDpeSupplementSummaryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roUnitMemberDpeSupplementSummary';
    // Attributes
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    ExaminerName = new DwItemAttribute(this.i, 'ExaminerName');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    FlightSchoolExaminerTypeId = new DwItemAttribute(this.i, 'FlightSchoolExaminerTypeId');
    TrainingCurrent = new DwItemAttribute(this.i, 'TrainingCurrent');
    TrainingCurrentEvaluatedDateTime = new DwItemAttribute(this.i, 'TrainingCurrentEvaluatedDateTime');
    DpeSupplementReviewedDateTime = new DwItemAttribute(this.i, 'DpeSupplementReviewedDateTime');
    DpeSupplementReviewedBy = new DwItemAttribute(this.i, 'DpeSupplementReviewedBy');
    DpeSupplementLastUpdatedDateTime = new DwItemAttribute(this.i, 'DpeSupplementLastUpdatedDateTime');
}

class RoUnitMemberDpeSupplementSummaryMetaDataRelations implements DwItemRelationshipCollection {
    };
export class ScheduleMetaData implements DwItem2<ScheduleEntity, ScheduleMetaDataAttributes,ScheduleMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1139;
        this.ItemDetail.itemName='Schedule';
        this.ItemDetail.keyName='ScheduleId';
    }

    CreateEntity(): ScheduleEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ScheduleQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ScheduleEntity, ScheduleMetaDataAttributes,ScheduleMetaDataRelations>(query, this);
    }
     Attributes = new ScheduleMetaDataAttributes();
     Relations = new ScheduleMetaDataRelations();

}


export type ScheduleQueryBuilder = DwQueryBuilderGen<ScheduleEntity, ScheduleMetaDataAttributes,ScheduleMetaDataRelations>


export class ScheduleMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Schedule';
    // Attributes
    ScheduleId = new DwItemAttribute(this.i, 'ScheduleId');
    ScheduleName = new DwItemAttribute(this.i, 'ScheduleName');
    DefaultStartTime = new DwItemAttribute(this.i, 'DefaultStartTime');
    DefaultEndTime = new DwItemAttribute(this.i, 'DefaultEndTime');
    WeekDaysOnly = new DwItemAttribute(this.i, 'WeekDaysOnly');
    UseCustomDays = new DwItemAttribute(this.i, 'UseCustomDays');
    ScheduleOwnerUserId = new DwItemAttribute(this.i, 'ScheduleOwnerUserId');
    IsBuiltInSchedule = new DwItemAttribute(this.i, 'IsBuiltInSchedule');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
}

class ScheduleMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Reference Status */
            ReferenceStatus = new DwItemRelationship('ReferenceStatus|Schedule|ReferenceStatusId', 'ReferenceStatus', 'ReferenceStatus');
            /** Relation: User - Calendar Owner User */
            DwUserByScheduleOwnerUserId = new DwItemRelationship('dw_User|Schedule|ScheduleOwnerUserId', 'ScheduleOwnerDwUser', 'ScheduleOwnerDwUser');
            /** Relation: Pilot Examiner - Calendar Id - Many */
            PilotExaminerByFlightSchoolScheduleId = new DwItemRelationship('Schedule|PilotExaminer|FlightSchoolScheduleId', 'FlightSchoolPilotExaminer', 'FlightSchoolPilotExaminer');
            /** Relation: Pilot Examiner Flight School Setup - Calendar Id - Many */
            PilotExaminerFlightSchoolSetupByFlightSchoolScheduleId = new DwItemRelationship('Schedule|PilotExaminerFlightSchoolSetup|FlightSchoolScheduleId', 'FlightSchoolPilotExaminerFlightSchoolSetup', 'FlightSchoolPilotExaminerFlightSchoolSetup');
            /** Relation: Pilot Examiner Location - Calendar Id - Many */
            PilotExaminerLocationByBookingScheduleId = new DwItemRelationship('Schedule|PilotExaminerLocation|BookingScheduleId', 'BookingPilotExaminerLocation', 'BookingPilotExaminerLocation');
            /** Relation: Schedule Block Item - Calendar Id - Many */
            ScheduleBlockItemByBookingScheduleId = new DwItemRelationship('Schedule|ScheduleBlockItem|BookingScheduleId', 'BookingScheduleBlockItem', 'BookingScheduleBlockItem');
            /** Relation: Calendar Detail */
            ScheduleDetail = new DwItemRelationship('Schedule|ScheduleDetail|ScheduleId', 'ScheduleDetail', 'ScheduleDetail');
    };
export class ScheduleBlockMetaData implements DwItem2<ScheduleBlockEntity, ScheduleBlockMetaDataAttributes,ScheduleBlockMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2322;
        this.ItemDetail.itemName='ScheduleBlock';
        this.ItemDetail.keyName='ScheduleBlockId';
    }

    CreateEntity(): ScheduleBlockEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ScheduleBlockQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ScheduleBlockEntity, ScheduleBlockMetaDataAttributes,ScheduleBlockMetaDataRelations>(query, this);
    }
     Attributes = new ScheduleBlockMetaDataAttributes();
     Relations = new ScheduleBlockMetaDataRelations();

}


export type ScheduleBlockQueryBuilder = DwQueryBuilderGen<ScheduleBlockEntity, ScheduleBlockMetaDataAttributes,ScheduleBlockMetaDataRelations>


export class ScheduleBlockMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ScheduleBlock';
    // Attributes
    ScheduleBlockId = new DwItemAttribute(this.i, 'ScheduleBlockId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    ScheduleBlockStatusId = new DwItemAttribute(this.i, 'ScheduleBlockStatusId');
    ScheduleBlockName = new DwItemAttribute(this.i, 'ScheduleBlockName');
    ScheduleBlockDescription = new DwItemAttribute(this.i, 'ScheduleBlockDescription');
    FirstDate = new DwItemAttribute(this.i, 'FirstDate');
    LastDate = new DwItemAttribute(this.i, 'LastDate');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    BookingTimeZoneId = new DwItemAttribute(this.i, 'BookingTimeZoneId');
    ColorName = new DwItemAttribute(this.i, 'ColorName');
    BackgroundColor = new DwItemAttribute(this.i, 'BackgroundColor');
    ForegroundColor = new DwItemAttribute(this.i, 'ForegroundColor');
    OwnershipTypeId = new DwItemAttribute(this.i, 'OwnershipTypeId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ScheduleBlockMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Check Ride Ownership Type - Ownership Type */
            CheckRideOwnershipTypeByOwnershipTypeId = new DwItemRelationship('CheckRideOwnershipType|ScheduleBlock|OwnershipTypeId', 'OwnershipTypeIdCheckRideOwnershipType', 'OwnershipTypeIdCheckRideOwnershipType');
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|ScheduleBlock|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Flight School Examiner */
            FlightSchoolExaminer = new DwItemRelationship('FlightSchoolExaminer|ScheduleBlock|FlightSchoolExaminerId', 'FlightSchoolExaminer', 'FlightSchoolExaminer');
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('PilotExaminer|ScheduleBlock|PilotExaminerId', 'PilotExaminer', 'PilotExaminer');
            /** Relation: Schedule Block Status */
            ScheduleBlockStatus = new DwItemRelationship('ScheduleBlockStatus|ScheduleBlock|ScheduleBlockStatusId', 'ScheduleBlockStatus', 'ScheduleBlockStatus');
            /** Relation: Time Zone - Booking Time Zone */
            TimeZoneByBookingTimeZoneId = new DwItemRelationship('TimeZone|ScheduleBlock|BookingTimeZoneId', 'BookingTimeZoneIdTimeZone', 'BookingTimeZoneIdTimeZone');
            /** Relation: Ro Schedule Block School Examiner Final */
            RoScheduleBlockSchoolExaminerFinal = new DwItemRelationship('ScheduleBlock|RoScheduleBlockSchoolExaminerFinal|ScheduleBlockId', 'RoScheduleBlockSchoolExaminerFinal', 'RoScheduleBlockSchoolExaminerFinal');
            /** Relation: Schedule Block Airport */
            ScheduleBlockAirport = new DwItemRelationship('ScheduleBlock|ScheduleBlockAirport|ScheduleBlockId', 'ScheduleBlockAirport', 'ScheduleBlockAirport');
            /** Relation: Schedule Block Check Ride Type */
            ScheduleBlockCheckRideType = new DwItemRelationship('ScheduleBlock|ScheduleBlockCheckRideType|ScheduleBlockId', 'ScheduleBlockCheckRideType', 'ScheduleBlockCheckRideType');
            /** Relation: Schedule Block Item */
            ScheduleBlockItem = new DwItemRelationship('ScheduleBlock|ScheduleBlockItem|ScheduleBlockId', 'ScheduleBlockItem', 'ScheduleBlockItem');
            /** Relation: Schedule Block Location */
            ScheduleBlockLocation = new DwItemRelationship('ScheduleBlock|ScheduleBlockLocation|ScheduleBlockId', 'ScheduleBlockLocation', 'ScheduleBlockLocation');
    };
export class ScheduleBlockAirportMetaData implements DwItem2<ScheduleBlockAirportEntity, ScheduleBlockAirportMetaDataAttributes,ScheduleBlockAirportMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2330;
        this.ItemDetail.itemName='ScheduleBlockAirport';
        this.ItemDetail.keyName='ScheduleBlockAirport';
    }

    CreateEntity(): ScheduleBlockAirportEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ScheduleBlockAirportQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ScheduleBlockAirportEntity, ScheduleBlockAirportMetaDataAttributes,ScheduleBlockAirportMetaDataRelations>(query, this);
    }
     Attributes = new ScheduleBlockAirportMetaDataAttributes();
     Relations = new ScheduleBlockAirportMetaDataRelations();

}


export type ScheduleBlockAirportQueryBuilder = DwQueryBuilderGen<ScheduleBlockAirportEntity, ScheduleBlockAirportMetaDataAttributes,ScheduleBlockAirportMetaDataRelations>


export class ScheduleBlockAirportMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ScheduleBlockAirport';
    // Attributes
    ScheduleBlockAirport = new DwItemAttribute(this.i, 'ScheduleBlockAirport');
    ScheduleBlockId = new DwItemAttribute(this.i, 'ScheduleBlockId');
    AirportId = new DwItemAttribute(this.i, 'AirportId');
}

class ScheduleBlockAirportMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Airport */
            Airport = new DwItemRelationship('Airport|ScheduleBlockAirport|AirportId', 'Airport', 'Airport');
            /** Relation: Schedule Block */
            ScheduleBlock = new DwItemRelationship('ScheduleBlock|ScheduleBlockAirport|ScheduleBlockId', 'ScheduleBlock', 'ScheduleBlock');
    };
export class ScheduleBlockCheckRideTypeMetaData implements DwItem2<ScheduleBlockCheckRideTypeEntity, ScheduleBlockCheckRideTypeMetaDataAttributes,ScheduleBlockCheckRideTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2329;
        this.ItemDetail.itemName='ScheduleBlockCheckRideType';
        this.ItemDetail.keyName='ScheduleBlockCheckRideTypeId';
    }

    CreateEntity(): ScheduleBlockCheckRideTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ScheduleBlockCheckRideTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ScheduleBlockCheckRideTypeEntity, ScheduleBlockCheckRideTypeMetaDataAttributes,ScheduleBlockCheckRideTypeMetaDataRelations>(query, this);
    }
     Attributes = new ScheduleBlockCheckRideTypeMetaDataAttributes();
     Relations = new ScheduleBlockCheckRideTypeMetaDataRelations();

}


export type ScheduleBlockCheckRideTypeQueryBuilder = DwQueryBuilderGen<ScheduleBlockCheckRideTypeEntity, ScheduleBlockCheckRideTypeMetaDataAttributes,ScheduleBlockCheckRideTypeMetaDataRelations>


export class ScheduleBlockCheckRideTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ScheduleBlockCheckRideType';
    // Attributes
    ScheduleBlockCheckRideTypeId = new DwItemAttribute(this.i, 'ScheduleBlockCheckRideTypeId');
    ScheduleBlockId = new DwItemAttribute(this.i, 'ScheduleBlockId');
    CheckRideTypeId = new DwItemAttribute(this.i, 'CheckRideTypeId');
}

class ScheduleBlockCheckRideTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checkride Type */
            CheckRideType = new DwItemRelationship('CheckRideType|ScheduleBlockCheckRideType|CheckRideTypeId', 'CheckRideType', 'CheckRideType');
            /** Relation: Schedule Block */
            ScheduleBlock = new DwItemRelationship('ScheduleBlock|ScheduleBlockCheckRideType|ScheduleBlockId', 'ScheduleBlock', 'ScheduleBlock');
    };
export class ScheduleBlockItemMetaData implements DwItem2<ScheduleBlockItemEntity, ScheduleBlockItemMetaDataAttributes,ScheduleBlockItemMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2326;
        this.ItemDetail.itemName='ScheduleBlockItem';
        this.ItemDetail.keyName='ScheduleBlockItemId';
    }

    CreateEntity(): ScheduleBlockItemEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ScheduleBlockItemQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ScheduleBlockItemEntity, ScheduleBlockItemMetaDataAttributes,ScheduleBlockItemMetaDataRelations>(query, this);
    }
     Attributes = new ScheduleBlockItemMetaDataAttributes();
     Relations = new ScheduleBlockItemMetaDataRelations();

}


export type ScheduleBlockItemQueryBuilder = DwQueryBuilderGen<ScheduleBlockItemEntity, ScheduleBlockItemMetaDataAttributes,ScheduleBlockItemMetaDataRelations>


export class ScheduleBlockItemMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ScheduleBlockItem';
    // Attributes
    ScheduleBlockItemId = new DwItemAttribute(this.i, 'ScheduleBlockItemId');
    ScheduleBlockId = new DwItemAttribute(this.i, 'ScheduleBlockId');
    ScheduleBlockItemTypeId = new DwItemAttribute(this.i, 'ScheduleBlockItemTypeId');
    ScheduleBlockItemStatusId = new DwItemAttribute(this.i, 'ScheduleBlockItemStatusId');
    StartDate = new DwItemAttribute(this.i, 'StartDate');
    EndDate = new DwItemAttribute(this.i, 'EndDate');
    StartTime = new DwItemAttribute(this.i, 'StartTime');
    EndTime = new DwItemAttribute(this.i, 'EndTime');
    BookingScheduleId = new DwItemAttribute(this.i, 'BookingScheduleId');
    BlockItemDescription = new DwItemAttribute(this.i, 'BlockItemDescription');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ScheduleBlockItemMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Custom Calendar - Booking Schedule */
            ScheduleByBookingScheduleId = new DwItemRelationship('Schedule|ScheduleBlockItem|BookingScheduleId', 'BookingSchedule', 'BookingSchedule');
            /** Relation: Schedule Block */
            ScheduleBlock = new DwItemRelationship('ScheduleBlock|ScheduleBlockItem|ScheduleBlockId', 'ScheduleBlock', 'ScheduleBlock');
            /** Relation: Schedule Block Item Status */
            ScheduleBlockItemStatus = new DwItemRelationship('ScheduleBlockItemStatus|ScheduleBlockItem|ScheduleBlockItemStatusId', 'ScheduleBlockItemStatus', 'ScheduleBlockItemStatus');
            /** Relation: Schedule Block Item Type */
            ScheduleBlockItemType = new DwItemRelationship('ScheduleBlockItemType|ScheduleBlockItem|ScheduleBlockItemTypeId', 'ScheduleBlockItemType', 'ScheduleBlockItemType');
            /** Relation: Schedule Block Item Calendar Item */
            ScheduleBlockItemCalendarItem = new DwItemRelationship('ScheduleBlockItem|ScheduleBlockItemCalendarItem|ScheduleBlockItemId', 'ScheduleBlockItemCalendarItem', 'ScheduleBlockItemCalendarItem');
    };
export class ScheduleBlockItemCalendarItemMetaData implements DwItem2<ScheduleBlockItemCalendarItemEntity, ScheduleBlockItemCalendarItemMetaDataAttributes,ScheduleBlockItemCalendarItemMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2324;
        this.ItemDetail.itemName='ScheduleBlockItemCalendarItem';
        this.ItemDetail.keyName='ScheduleBlockItemCalendarRefId';
    }

    CreateEntity(): ScheduleBlockItemCalendarItemEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ScheduleBlockItemCalendarItemQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ScheduleBlockItemCalendarItemEntity, ScheduleBlockItemCalendarItemMetaDataAttributes,ScheduleBlockItemCalendarItemMetaDataRelations>(query, this);
    }
     Attributes = new ScheduleBlockItemCalendarItemMetaDataAttributes();
     Relations = new ScheduleBlockItemCalendarItemMetaDataRelations();

}


export type ScheduleBlockItemCalendarItemQueryBuilder = DwQueryBuilderGen<ScheduleBlockItemCalendarItemEntity, ScheduleBlockItemCalendarItemMetaDataAttributes,ScheduleBlockItemCalendarItemMetaDataRelations>


export class ScheduleBlockItemCalendarItemMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ScheduleBlockItemCalendarItem';
    // Attributes
    ScheduleBlockItemCalendarRefId = new DwItemAttribute(this.i, 'ScheduleBlockItemCalendarRefId');
    ScheduleBlockItemId = new DwItemAttribute(this.i, 'ScheduleBlockItemId');
    CalendarEventReferenceId = new DwItemAttribute(this.i, 'CalendarEventReferenceId');
    StartDateTime = new DwItemAttribute(this.i, 'StartDateTime');
    EndDateTime = new DwItemAttribute(this.i, 'EndDateTime');
    SubjectText = new DwItemAttribute(this.i, 'SubjectText');
    BodyHtml = new DwItemAttribute(this.i, 'BodyHtml');
    IsCancelled = new DwItemAttribute(this.i, 'IsCancelled');
    BackgroundColor = new DwItemAttribute(this.i, 'BackgroundColor');
    ForegroundColor = new DwItemAttribute(this.i, 'ForegroundColor');
}

class ScheduleBlockItemCalendarItemMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Calendar Event Reference */
            CalendarEventReference = new DwItemRelationship('CalendarEventReference|ScheduleBlockItemCalendarItem|CalendarEventReferenceId', 'CalendarEventReference', 'CalendarEventReference');
            /** Relation: Schedule Block Item */
            ScheduleBlockItem = new DwItemRelationship('ScheduleBlockItem|ScheduleBlockItemCalendarItem|ScheduleBlockItemId', 'ScheduleBlockItem', 'ScheduleBlockItem');
    };
export class ScheduleBlockItemStatusMetaData implements DwItem2<ScheduleBlockItemStatusEntity, ScheduleBlockItemStatusMetaDataAttributes,ScheduleBlockItemStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2325;
        this.ItemDetail.itemName='ScheduleBlockItemStatus';
        this.ItemDetail.keyName='ScheduleBlockItemStatusId';
    }

    CreateEntity(): ScheduleBlockItemStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ScheduleBlockItemStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ScheduleBlockItemStatusEntity, ScheduleBlockItemStatusMetaDataAttributes,ScheduleBlockItemStatusMetaDataRelations>(query, this);
    }
     Attributes = new ScheduleBlockItemStatusMetaDataAttributes();
     Relations = new ScheduleBlockItemStatusMetaDataRelations();

}


export type ScheduleBlockItemStatusQueryBuilder = DwQueryBuilderGen<ScheduleBlockItemStatusEntity, ScheduleBlockItemStatusMetaDataAttributes,ScheduleBlockItemStatusMetaDataRelations>


export class ScheduleBlockItemStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ScheduleBlockItemStatus';
    // Attributes
    ScheduleBlockItemStatusId = new DwItemAttribute(this.i, 'ScheduleBlockItemStatusId');
    ScheduleBlockItemStatus = new DwItemAttribute(this.i, 'ScheduleBlockItemStatus');
}

class ScheduleBlockItemStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Schedule Block Item */
            ScheduleBlockItem = new DwItemRelationship('ScheduleBlockItemStatus|ScheduleBlockItem|ScheduleBlockItemStatusId', 'ScheduleBlockItem', 'ScheduleBlockItem');
    };
export class ScheduleBlockItemTypeMetaData implements DwItem2<ScheduleBlockItemTypeEntity, ScheduleBlockItemTypeMetaDataAttributes,ScheduleBlockItemTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2323;
        this.ItemDetail.itemName='ScheduleBlockItemType';
        this.ItemDetail.keyName='ScheduleBlockItemTypeId';
    }

    CreateEntity(): ScheduleBlockItemTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ScheduleBlockItemTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ScheduleBlockItemTypeEntity, ScheduleBlockItemTypeMetaDataAttributes,ScheduleBlockItemTypeMetaDataRelations>(query, this);
    }
     Attributes = new ScheduleBlockItemTypeMetaDataAttributes();
     Relations = new ScheduleBlockItemTypeMetaDataRelations();

}


export type ScheduleBlockItemTypeQueryBuilder = DwQueryBuilderGen<ScheduleBlockItemTypeEntity, ScheduleBlockItemTypeMetaDataAttributes,ScheduleBlockItemTypeMetaDataRelations>


export class ScheduleBlockItemTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ScheduleBlockItemType';
    // Attributes
    ScheduleBlockItemTypeId = new DwItemAttribute(this.i, 'ScheduleBlockItemTypeId');
    ScheduleBlockItemType = new DwItemAttribute(this.i, 'ScheduleBlockItemType');
}

class ScheduleBlockItemTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Schedule Block Item */
            ScheduleBlockItem = new DwItemRelationship('ScheduleBlockItemType|ScheduleBlockItem|ScheduleBlockItemTypeId', 'ScheduleBlockItem', 'ScheduleBlockItem');
    };
export class ScheduleBlockLocationMetaData implements DwItem2<ScheduleBlockLocationEntity, ScheduleBlockLocationMetaDataAttributes,ScheduleBlockLocationMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2320;
        this.ItemDetail.itemName='ScheduleBlockLocation';
        this.ItemDetail.keyName='ScheduleBlockLocationId';
    }

    CreateEntity(): ScheduleBlockLocationEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ScheduleBlockLocationQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ScheduleBlockLocationEntity, ScheduleBlockLocationMetaDataAttributes,ScheduleBlockLocationMetaDataRelations>(query, this);
    }
     Attributes = new ScheduleBlockLocationMetaDataAttributes();
     Relations = new ScheduleBlockLocationMetaDataRelations();

}


export type ScheduleBlockLocationQueryBuilder = DwQueryBuilderGen<ScheduleBlockLocationEntity, ScheduleBlockLocationMetaDataAttributes,ScheduleBlockLocationMetaDataRelations>


export class ScheduleBlockLocationMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ScheduleBlockLocation';
    // Attributes
    ScheduleBlockLocationId = new DwItemAttribute(this.i, 'ScheduleBlockLocationId');
    ScheduleBlockId = new DwItemAttribute(this.i, 'ScheduleBlockId');
    PilotExaminerLocationId = new DwItemAttribute(this.i, 'PilotExaminerLocationId');
}

class ScheduleBlockLocationMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Pilot Examiner Location */
            PilotExaminerLocation = new DwItemRelationship('PilotExaminerLocation|ScheduleBlockLocation|PilotExaminerLocaiontId', 'PilotExaminerLocation', 'PilotExaminerLocation');
            /** Relation: Schedule Block */
            ScheduleBlock = new DwItemRelationship('ScheduleBlock|ScheduleBlockLocation|ScheduleBlockId', 'ScheduleBlock', 'ScheduleBlock');
    };
export class ScheduleBlockSchoolBookingOptionMetaData implements DwItem2<ScheduleBlockSchoolBookingOptionEntity, ScheduleBlockSchoolBookingOptionMetaDataAttributes,ScheduleBlockSchoolBookingOptionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2331;
        this.ItemDetail.itemName='ScheduleBlockSchoolBookingOption';
        this.ItemDetail.keyName='ScheduleBlockSchoolBookingOptionId';
    }

    CreateEntity(): ScheduleBlockSchoolBookingOptionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ScheduleBlockSchoolBookingOptionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ScheduleBlockSchoolBookingOptionEntity, ScheduleBlockSchoolBookingOptionMetaDataAttributes,ScheduleBlockSchoolBookingOptionMetaDataRelations>(query, this);
    }
     Attributes = new ScheduleBlockSchoolBookingOptionMetaDataAttributes();
     Relations = new ScheduleBlockSchoolBookingOptionMetaDataRelations();

}


export type ScheduleBlockSchoolBookingOptionQueryBuilder = DwQueryBuilderGen<ScheduleBlockSchoolBookingOptionEntity, ScheduleBlockSchoolBookingOptionMetaDataAttributes,ScheduleBlockSchoolBookingOptionMetaDataRelations>


export class ScheduleBlockSchoolBookingOptionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ScheduleBlockSchoolBookingOption';
    // Attributes
    ScheduleBlockSchoolBookingOptionId = new DwItemAttribute(this.i, 'ScheduleBlockSchoolBookingOptionId');
    SchoolBookingOption = new DwItemAttribute(this.i, 'SchoolBookingOption');
    SchoolBookingOptionDescription = new DwItemAttribute(this.i, 'SchoolBookingOptionDescription');
    OptionOrder = new DwItemAttribute(this.i, 'OptionOrder');
}

class ScheduleBlockSchoolBookingOptionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Pilot Examiner - Schedule Block School Default Option - Many */
            PilotExaminerByScheduleBlockSchoolDefaultOptionId = new DwItemRelationship('ScheduleBlockSchoolBookingOption|PilotExaminer|ScheduleBlockSchoolDefaultOptionId', 'ScheduleBlockSchoolDefaultOptionIdPilotExaminer', 'ScheduleBlockSchoolDefaultOptionIdPilotExaminer');
            /** Relation: Pilot Examiner Flight School Setup - Schedule Block School Default Option - Many */
            PilotExaminerFlightSchoolSetupByScheduleBlockSchoolDefaultOptionId = new DwItemRelationship('ScheduleBlockSchoolBookingOption|PilotExaminerFlightSchoolSetup|ScheduleBlockSchoolDefaultOptionId', 'ScheduleBlockSchoolDefaultOptionIdPilotExaminerFlightSchoolSetup', 'ScheduleBlockSchoolDefaultOptionIdPilotExaminerFlightSchoolSetup');
    };
export class ScheduleBlockStatusMetaData implements DwItem2<ScheduleBlockStatusEntity, ScheduleBlockStatusMetaDataAttributes,ScheduleBlockStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2321;
        this.ItemDetail.itemName='ScheduleBlockStatus';
        this.ItemDetail.keyName='ScheduleBlockStatusId';
    }

    CreateEntity(): ScheduleBlockStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ScheduleBlockStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ScheduleBlockStatusEntity, ScheduleBlockStatusMetaDataAttributes,ScheduleBlockStatusMetaDataRelations>(query, this);
    }
     Attributes = new ScheduleBlockStatusMetaDataAttributes();
     Relations = new ScheduleBlockStatusMetaDataRelations();

}


export type ScheduleBlockStatusQueryBuilder = DwQueryBuilderGen<ScheduleBlockStatusEntity, ScheduleBlockStatusMetaDataAttributes,ScheduleBlockStatusMetaDataRelations>


export class ScheduleBlockStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ScheduleBlockStatus';
    // Attributes
    ScheduleBlockStatusId = new DwItemAttribute(this.i, 'ScheduleBlockStatusId');
    ScheduleBlockStatus = new DwItemAttribute(this.i, 'ScheduleBlockStatus');
}

class ScheduleBlockStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Schedule Block */
            ScheduleBlock = new DwItemRelationship('ScheduleBlockStatus|ScheduleBlock|ScheduleBlockStatusId', 'ScheduleBlock', 'ScheduleBlock');
    };
export class ScheduleDayOfWeekMetaData implements DwItem2<ScheduleDayOfWeekEntity, ScheduleDayOfWeekMetaDataAttributes,ScheduleDayOfWeekMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1138;
        this.ItemDetail.itemName='ScheduleDayOfWeek';
        this.ItemDetail.keyName='ScheduleDayOfWeekId';
    }

    CreateEntity(): ScheduleDayOfWeekEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ScheduleDayOfWeekQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ScheduleDayOfWeekEntity, ScheduleDayOfWeekMetaDataAttributes,ScheduleDayOfWeekMetaDataRelations>(query, this);
    }
     Attributes = new ScheduleDayOfWeekMetaDataAttributes();
     Relations = new ScheduleDayOfWeekMetaDataRelations();

}


export type ScheduleDayOfWeekQueryBuilder = DwQueryBuilderGen<ScheduleDayOfWeekEntity, ScheduleDayOfWeekMetaDataAttributes,ScheduleDayOfWeekMetaDataRelations>


export class ScheduleDayOfWeekMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ScheduleDayOfWeek';
    // Attributes
    ScheduleDayOfWeekId = new DwItemAttribute(this.i, 'ScheduleDayOfWeekId');
    DayOfWeek = new DwItemAttribute(this.i, 'DayOfWeek');
    DayOfWeekOrder = new DwItemAttribute(this.i, 'DayOfWeekOrder');
}

class ScheduleDayOfWeekMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Calendar Detail */
            ScheduleDetail = new DwItemRelationship('ScheduleDayOfWeek|ScheduleDetail|ScheduleDayOfWeekId', 'ScheduleDetail', 'ScheduleDetail');
    };
export class ScheduleDetailMetaData implements DwItem2<ScheduleDetailEntity, ScheduleDetailMetaDataAttributes,ScheduleDetailMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1140;
        this.ItemDetail.itemName='ScheduleDetail';
        this.ItemDetail.keyName='ScheduleDetailId';
    }

    CreateEntity(): ScheduleDetailEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ScheduleDetailQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ScheduleDetailEntity, ScheduleDetailMetaDataAttributes,ScheduleDetailMetaDataRelations>(query, this);
    }
     Attributes = new ScheduleDetailMetaDataAttributes();
     Relations = new ScheduleDetailMetaDataRelations();

}


export type ScheduleDetailQueryBuilder = DwQueryBuilderGen<ScheduleDetailEntity, ScheduleDetailMetaDataAttributes,ScheduleDetailMetaDataRelations>


export class ScheduleDetailMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ScheduleDetail';
    // Attributes
    ScheduleDetailId = new DwItemAttribute(this.i, 'ScheduleDetailId');
    ScheduleId = new DwItemAttribute(this.i, 'ScheduleId');
    ScheduleDayOfWeekId = new DwItemAttribute(this.i, 'ScheduleDayOfWeekId');
    StartTime = new DwItemAttribute(this.i, 'StartTime');
    EndTime = new DwItemAttribute(this.i, 'EndTime');
}

class ScheduleDetailMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Custom Calendar */
            Schedule = new DwItemRelationship('Schedule|ScheduleDetail|ScheduleId', 'Schedule', 'Schedule');
            /** Relation: Calendar Day Of Week */
            ScheduleDayOfWeek = new DwItemRelationship('ScheduleDayOfWeek|ScheduleDetail|ScheduleDayOfWeekId', 'ScheduleDayOfWeek', 'ScheduleDayOfWeek');
    };
export class SchoolFeatureMetaData implements DwItem2<SchoolFeatureEntity, SchoolFeatureMetaDataAttributes,SchoolFeatureMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2291;
        this.ItemDetail.itemName='SchoolFeature';
        this.ItemDetail.keyName='SchoolFeatureId';
    }

    CreateEntity(): SchoolFeatureEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SchoolFeatureQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SchoolFeatureEntity, SchoolFeatureMetaDataAttributes,SchoolFeatureMetaDataRelations>(query, this);
    }
     Attributes = new SchoolFeatureMetaDataAttributes();
     Relations = new SchoolFeatureMetaDataRelations();

}


export type SchoolFeatureQueryBuilder = DwQueryBuilderGen<SchoolFeatureEntity, SchoolFeatureMetaDataAttributes,SchoolFeatureMetaDataRelations>


export class SchoolFeatureMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SchoolFeature';
    // Attributes
    SchoolFeatureId = new DwItemAttribute(this.i, 'SchoolFeatureId');
    SchoolFeature = new DwItemAttribute(this.i, 'SchoolFeature');
}

class SchoolFeatureMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Organization Feature */
            FlightSchoolOrganizationFeature = new DwItemRelationship('SchoolFeature|FlightSchoolOrganizationFeature|SchoolFeatureId', 'FlightSchoolOrganizationFeature', 'FlightSchoolOrganizationFeature');
    };
export class StateProvinceMetaData implements DwItem2<StateProvinceEntity, StateProvinceMetaDataAttributes,StateProvinceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1158;
        this.ItemDetail.itemName='StateProvince';
        this.ItemDetail.keyName='StateProvinceId';
    }

    CreateEntity(): StateProvinceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StateProvinceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StateProvinceEntity, StateProvinceMetaDataAttributes,StateProvinceMetaDataRelations>(query, this);
    }
     Attributes = new StateProvinceMetaDataAttributes();
     Relations = new StateProvinceMetaDataRelations();

}


export type StateProvinceQueryBuilder = DwQueryBuilderGen<StateProvinceEntity, StateProvinceMetaDataAttributes,StateProvinceMetaDataRelations>


export class StateProvinceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StateProvince';
    // Attributes
    StateProvinceId = new DwItemAttribute(this.i, 'StateProvinceId');
    CountryId = new DwItemAttribute(this.i, 'CountryId');
    StateProvinceName = new DwItemAttribute(this.i, 'StateProvinceName');
    StateProvinceShortName = new DwItemAttribute(this.i, 'StateProvinceShortName');
    StateCode = new DwItemAttribute(this.i, 'StateCode');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
}

class StateProvinceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Country */
            Country = new DwItemRelationship('Country|StateProvince|CountryId', 'Country', 'Country');
            /** Relation: Address */
            Address = new DwItemRelationship('StateProvince|Address|StateProvinceId', 'Address', 'Address');
            /** Relation: Checkride Request - Student Applicant - Many */
            CheckRideRequestByStudentApplicantStateProvinceId = new DwItemRelationship('StateProvince|CheckRideRequest|StudentApplicantStateProvinceId', 'StudentApplicantCheckRideRequest', 'StudentApplicantCheckRideRequest');
            /** Relation: Flight School Applicant */
            FlightSchoolApplicant = new DwItemRelationship('StateProvince|FlightSchoolApplicant|StateProvinceId', 'FlightSchoolApplicant', 'FlightSchoolApplicant');
            /** Relation: Plan Of Action - Student Applicant - Many */
            PlanOfActionByStudentApplicantStateProvinceId = new DwItemRelationship('StateProvince|PlanOfAction|StudentApplicantStateProvinceId', 'StudentApplicantPlanOfAction', 'StudentApplicantPlanOfAction');
            /** Relation: Postal Code */
            PostalCode = new DwItemRelationship('StateProvince|PostalCode|StateProvinceId', 'PostalCode', 'PostalCode');
    };
export class StudentApplicantMetaData implements DwItem2<StudentApplicantEntity, StudentApplicantMetaDataAttributes,StudentApplicantMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1144;
        this.ItemDetail.itemName='StudentApplicant';
        this.ItemDetail.keyName='StudentApplicantId';
    }

    CreateEntity(): StudentApplicantEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StudentApplicantQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StudentApplicantEntity, StudentApplicantMetaDataAttributes,StudentApplicantMetaDataRelations>(query, this);
    }
     Attributes = new StudentApplicantMetaDataAttributes();
     Relations = new StudentApplicantMetaDataRelations();

}


export type StudentApplicantQueryBuilder = DwQueryBuilderGen<StudentApplicantEntity, StudentApplicantMetaDataAttributes,StudentApplicantMetaDataRelations>


export class StudentApplicantMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StudentApplicant';
    // Attributes
    StudentApplicantId = new DwItemAttribute(this.i, 'StudentApplicantId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    ApplicationDescription = new DwItemAttribute(this.i, 'ApplicationDescription');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    PilotCertificateNumber = new DwItemAttribute(this.i, 'PilotCertificateNumber');
    TravelRadiusMiles = new DwItemAttribute(this.i, 'TravelRadiusMiles');
    Citizenship = new DwItemAttribute(this.i, 'Citizenship');
    ApplicantAddressId = new DwItemAttribute(this.i, 'ApplicantAddressId');
    MainAirportId = new DwItemAttribute(this.i, 'MainAirportId');
    MainAircraft = new DwItemAttribute(this.i, 'MainAircraft');
    ReferredPilotExaminerId = new DwItemAttribute(this.i, 'ReferredPilotExaminerId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    AviationTrainingProgramId = new DwItemAttribute(this.i, 'AviationTrainingProgramId');
    CitzenshipCountyId = new DwItemAttribute(this.i, 'CitzenshipCountyId');
}

class StudentApplicantMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Address - Applicant Address */
            AddressByApplicantAddressId = new DwItemRelationship('Address|StudentApplicant|ApplicantAddressId', 'ApplicantAddress', 'ApplicantAddress');
            /** Relation: Airport - Main Airport */
            AirportByMainAirportId = new DwItemRelationship('Airport|StudentApplicant|MainAirportId', 'MainAirport', 'MainAirport');
            /** Relation: Aviation Authority */
            AviationAuthority = new DwItemRelationship('AviationAuthority|StudentApplicant|AviationAuthorityId', 'AviationAuthority', 'AviationAuthority');
            /** Relation: Aviation Training Program */
            AviationTrainingProgram = new DwItemRelationship('AviationTrainingProgram|StudentApplicant|AviationTrainingProgramId', 'AviationTrainingProgram', 'AviationTrainingProgram');
            /** Relation: Country - Citzenship */
            CountryByCitzenshipCountyId = new DwItemRelationship('Country|StudentApplicant|CitzenshipCountyId', 'CitzenshipCountyIdCountry', 'CitzenshipCountyIdCountry');
            /** Relation: Pilot Examiner - Referred Pilot Examiner */
            PilotExaminerByReferredPilotExaminerId = new DwItemRelationship('PilotExaminer|StudentApplicant|ReferredPilotExaminerId', 'ReferredPilotExaminer', 'ReferredPilotExaminer');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|StudentApplicant|UserId', 'DwUser', 'DwUser');
            /** Relation: Applicant Wait List */
            ApplicantPlaceholder = new DwItemRelationship('StudentApplicant|ApplicantPlaceholder|StudentApplicantId', 'ApplicantPlaceholder', 'ApplicantPlaceholder');
            /** Relation: Checkride Request */
            CheckRideRequest = new DwItemRelationship('StudentApplicant|CheckRideRequest|StudentApplicantId', 'CheckRideRequest', 'CheckRideRequest');
            /** Relation: Check Ride Schedule Hold - User - Many */
            CheckRideScheduleHoldByUserId = new DwItemRelationship('StudentApplicant|CheckRideScheduleHold|StudentApplicantId', 'UserIdCheckRideScheduleHold', 'UserIdCheckRideScheduleHold');
            /** Relation: Flight School Applicant */
            FlightSchoolApplicant = new DwItemRelationship('StudentApplicant|FlightSchoolApplicant|StudentApplicantId', 'FlightSchoolApplicant', 'FlightSchoolApplicant');
    };
export class SubscriptionMetaData implements DwItem2<SubscriptionEntity, SubscriptionMetaDataAttributes,SubscriptionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2268;
        this.ItemDetail.itemName='Subscription';
        this.ItemDetail.keyName='SubscriptionId';
    }

    CreateEntity(): SubscriptionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubscriptionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubscriptionEntity, SubscriptionMetaDataAttributes,SubscriptionMetaDataRelations>(query, this);
    }
     Attributes = new SubscriptionMetaDataAttributes();
     Relations = new SubscriptionMetaDataRelations();

}


export type SubscriptionQueryBuilder = DwQueryBuilderGen<SubscriptionEntity, SubscriptionMetaDataAttributes,SubscriptionMetaDataRelations>


export class SubscriptionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Subscription';
    // Attributes
    SubscriptionId = new DwItemAttribute(this.i, 'SubscriptionId');
    SubscriptionPartyId = new DwItemAttribute(this.i, 'SubscriptionPartyId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    SubscriptionTierId = new DwItemAttribute(this.i, 'SubscriptionTierId');
    SubscriptionStatusId = new DwItemAttribute(this.i, 'SubscriptionStatusId');
    EffectiveStartDate = new DwItemAttribute(this.i, 'EffectiveStartDate');
    EffectiveEndDate = new DwItemAttribute(this.i, 'EffectiveEndDate');
    PaymentDiscountCodeId = new DwItemAttribute(this.i, 'PaymentDiscountCodeId');
    DiscountAppliedDate = new DwItemAttribute(this.i, 'DiscountAppliedDate');
    DiscountExpirationDate = new DwItemAttribute(this.i, 'DiscountExpirationDate');
    FirstInvoiceDate = new DwItemAttribute(this.i, 'FirstInvoiceDate');
    LastInvoiceDate = new DwItemAttribute(this.i, 'LastInvoiceDate');
    NextInvoiceDate = new DwItemAttribute(this.i, 'NextInvoiceDate');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
}

class SubscriptionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Organization */
            FlightSchoolOrganization = new DwItemRelationship('FlightSchoolOrganization|Subscription|FlightSchoolOrganizationId', 'FlightSchoolOrganization', 'FlightSchoolOrganization');
            /** Relation: Payment Discount Code */
            PaymentDiscountCode = new DwItemRelationship('PaymentDiscountCode|Subscription|PaymentDiscountCodeId', 'PaymentDiscountCode', 'PaymentDiscountCode');
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('PilotExaminer|Subscription|PilotExaminerId', 'PilotExaminer', 'PilotExaminer');
            /** Relation: Subscription Party */
            SubscriptionParty = new DwItemRelationship('SubscriptionParty|Subscription|SubscriptionPartyId', 'SubscriptionParty', 'SubscriptionParty');
            /** Relation: Subscription Status */
            SubscriptionStatus = new DwItemRelationship('SubscriptionStatus|Subscription|SubscriptionStatusId', 'SubscriptionStatus', 'SubscriptionStatus');
            /** Relation: Subscription Tier */
            SubscriptionTier = new DwItemRelationship('SubscriptionTier|Subscription|SubscriptionTierId', 'SubscriptionTier', 'SubscriptionTier');
    };
export class SubscriptionFeatureMetaData implements DwItem2<SubscriptionFeatureEntity, SubscriptionFeatureMetaDataAttributes,SubscriptionFeatureMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2273;
        this.ItemDetail.itemName='SubscriptionFeature';
        this.ItemDetail.keyName='SubscriptionFeatureId';
    }

    CreateEntity(): SubscriptionFeatureEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubscriptionFeatureQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubscriptionFeatureEntity, SubscriptionFeatureMetaDataAttributes,SubscriptionFeatureMetaDataRelations>(query, this);
    }
     Attributes = new SubscriptionFeatureMetaDataAttributes();
     Relations = new SubscriptionFeatureMetaDataRelations();

}


export type SubscriptionFeatureQueryBuilder = DwQueryBuilderGen<SubscriptionFeatureEntity, SubscriptionFeatureMetaDataAttributes,SubscriptionFeatureMetaDataRelations>


export class SubscriptionFeatureMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubscriptionFeature';
    // Attributes
    SubscriptionFeatureId = new DwItemAttribute(this.i, 'SubscriptionFeatureId');
    SubscriptionFeature = new DwItemAttribute(this.i, 'SubscriptionFeature');
    FeatureKey = new DwItemAttribute(this.i, 'FeatureKey');
}

class SubscriptionFeatureMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Subscription Tier Feature */
            SubscriptionTierFeature = new DwItemRelationship('SubscriptionFeature|SubscriptionTierFeature|SubscriptionFeatureId', 'SubscriptionTierFeature', 'SubscriptionTierFeature');
    };
export class SubscriptionPartyMetaData implements DwItem2<SubscriptionPartyEntity, SubscriptionPartyMetaDataAttributes,SubscriptionPartyMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2269;
        this.ItemDetail.itemName='SubscriptionParty';
        this.ItemDetail.keyName='SubscriptionPartyId';
    }

    CreateEntity(): SubscriptionPartyEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubscriptionPartyQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubscriptionPartyEntity, SubscriptionPartyMetaDataAttributes,SubscriptionPartyMetaDataRelations>(query, this);
    }
     Attributes = new SubscriptionPartyMetaDataAttributes();
     Relations = new SubscriptionPartyMetaDataRelations();

}


export type SubscriptionPartyQueryBuilder = DwQueryBuilderGen<SubscriptionPartyEntity, SubscriptionPartyMetaDataAttributes,SubscriptionPartyMetaDataRelations>


export class SubscriptionPartyMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubscriptionParty';
    // Attributes
    SubscriptionPartyId = new DwItemAttribute(this.i, 'SubscriptionPartyId');
    SubscriptionParty = new DwItemAttribute(this.i, 'SubscriptionParty');
}

class SubscriptionPartyMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Subscription */
            Subscription = new DwItemRelationship('SubscriptionParty|Subscription|SubscriptionPartyId', 'Subscription', 'Subscription');
            /** Relation: Subscription Tier */
            SubscriptionTier = new DwItemRelationship('SubscriptionParty|SubscriptionTier|SubscriptionPartyId', 'SubscriptionTier', 'SubscriptionTier');
    };
export class SubscriptionStatusMetaData implements DwItem2<SubscriptionStatusEntity, SubscriptionStatusMetaDataAttributes,SubscriptionStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2270;
        this.ItemDetail.itemName='SubscriptionStatus';
        this.ItemDetail.keyName='SubscriptionStatusId';
    }

    CreateEntity(): SubscriptionStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubscriptionStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubscriptionStatusEntity, SubscriptionStatusMetaDataAttributes,SubscriptionStatusMetaDataRelations>(query, this);
    }
     Attributes = new SubscriptionStatusMetaDataAttributes();
     Relations = new SubscriptionStatusMetaDataRelations();

}


export type SubscriptionStatusQueryBuilder = DwQueryBuilderGen<SubscriptionStatusEntity, SubscriptionStatusMetaDataAttributes,SubscriptionStatusMetaDataRelations>


export class SubscriptionStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubscriptionStatus';
    // Attributes
    SubscriptionStatusId = new DwItemAttribute(this.i, 'SubscriptionStatusId');
    SubscriptionStatus = new DwItemAttribute(this.i, 'SubscriptionStatus');
}

class SubscriptionStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Subscription */
            Subscription = new DwItemRelationship('SubscriptionStatus|Subscription|SubscriptionStatusId', 'Subscription', 'Subscription');
    };
export class SubscriptionTierMetaData implements DwItem2<SubscriptionTierEntity, SubscriptionTierMetaDataAttributes,SubscriptionTierMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2271;
        this.ItemDetail.itemName='SubscriptionTier';
        this.ItemDetail.keyName='SubscriptionTierId';
    }

    CreateEntity(): SubscriptionTierEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubscriptionTierQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubscriptionTierEntity, SubscriptionTierMetaDataAttributes,SubscriptionTierMetaDataRelations>(query, this);
    }
     Attributes = new SubscriptionTierMetaDataAttributes();
     Relations = new SubscriptionTierMetaDataRelations();

}


export type SubscriptionTierQueryBuilder = DwQueryBuilderGen<SubscriptionTierEntity, SubscriptionTierMetaDataAttributes,SubscriptionTierMetaDataRelations>


export class SubscriptionTierMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubscriptionTier';
    // Attributes
    SubscriptionTierId = new DwItemAttribute(this.i, 'SubscriptionTierId');
    SubscriptionTierName = new DwItemAttribute(this.i, 'SubscriptionTierName');
    SubscriptionTierStatusId = new DwItemAttribute(this.i, 'SubscriptionTierStatusId');
    PlatformMonthlyCost = new DwItemAttribute(this.i, 'PlatformMonthlyCost');
    IncludedCheckrides = new DwItemAttribute(this.i, 'IncludedCheckrides');
    SubscriptionPartyId = new DwItemAttribute(this.i, 'SubscriptionPartyId');
    SubscriptionTierDescriptionHtml = new DwItemAttribute(this.i, 'SubscriptionTierDescriptionHtml');
}

class SubscriptionTierMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Subscription Party */
            SubscriptionParty = new DwItemRelationship('SubscriptionParty|SubscriptionTier|SubscriptionPartyId', 'SubscriptionParty', 'SubscriptionParty');
            /** Relation: Subscription Tier Status */
            SubscriptionTierStatus = new DwItemRelationship('SubscriptionTierStatus|SubscriptionTier|SubscriptionTierStatusId', 'SubscriptionTierStatus', 'SubscriptionTierStatus');
            /** Relation: Subscription */
            Subscription = new DwItemRelationship('SubscriptionTier|Subscription|SubscriptionTierId', 'Subscription', 'Subscription');
            /** Relation: Subscription Tier Feature */
            SubscriptionTierFeature = new DwItemRelationship('SubscriptionTier|SubscriptionTierFeature|SubscriptionTierId', 'SubscriptionTierFeature', 'SubscriptionTierFeature');
    };
export class SubscriptionTierFeatureMetaData implements DwItem2<SubscriptionTierFeatureEntity, SubscriptionTierFeatureMetaDataAttributes,SubscriptionTierFeatureMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2274;
        this.ItemDetail.itemName='SubscriptionTierFeature';
        this.ItemDetail.keyName='SubscriptionTierFeatureId';
    }

    CreateEntity(): SubscriptionTierFeatureEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubscriptionTierFeatureQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubscriptionTierFeatureEntity, SubscriptionTierFeatureMetaDataAttributes,SubscriptionTierFeatureMetaDataRelations>(query, this);
    }
     Attributes = new SubscriptionTierFeatureMetaDataAttributes();
     Relations = new SubscriptionTierFeatureMetaDataRelations();

}


export type SubscriptionTierFeatureQueryBuilder = DwQueryBuilderGen<SubscriptionTierFeatureEntity, SubscriptionTierFeatureMetaDataAttributes,SubscriptionTierFeatureMetaDataRelations>


export class SubscriptionTierFeatureMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubscriptionTierFeature';
    // Attributes
    SubscriptionTierFeatureId = new DwItemAttribute(this.i, 'SubscriptionTierFeatureId');
    SubscriptionTierId = new DwItemAttribute(this.i, 'SubscriptionTierId');
    SubscriptionFeatureId = new DwItemAttribute(this.i, 'SubscriptionFeatureId');
}

class SubscriptionTierFeatureMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Subscription Feature */
            SubscriptionFeature = new DwItemRelationship('SubscriptionFeature|SubscriptionTierFeature|SubscriptionFeatureId', 'SubscriptionFeature', 'SubscriptionFeature');
            /** Relation: Subscription Tier */
            SubscriptionTier = new DwItemRelationship('SubscriptionTier|SubscriptionTierFeature|SubscriptionTierId', 'SubscriptionTier', 'SubscriptionTier');
    };
export class SubscriptionTierStatusMetaData implements DwItem2<SubscriptionTierStatusEntity, SubscriptionTierStatusMetaDataAttributes,SubscriptionTierStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2272;
        this.ItemDetail.itemName='SubscriptionTierStatus';
        this.ItemDetail.keyName='SubscriptionTierStatusId';
    }

    CreateEntity(): SubscriptionTierStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubscriptionTierStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubscriptionTierStatusEntity, SubscriptionTierStatusMetaDataAttributes,SubscriptionTierStatusMetaDataRelations>(query, this);
    }
     Attributes = new SubscriptionTierStatusMetaDataAttributes();
     Relations = new SubscriptionTierStatusMetaDataRelations();

}


export type SubscriptionTierStatusQueryBuilder = DwQueryBuilderGen<SubscriptionTierStatusEntity, SubscriptionTierStatusMetaDataAttributes,SubscriptionTierStatusMetaDataRelations>


export class SubscriptionTierStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubscriptionTierStatus';
    // Attributes
    SubscriptionTierStatusId = new DwItemAttribute(this.i, 'SubscriptionTierStatusId');
    SubscriptionTierStatus = new DwItemAttribute(this.i, 'SubscriptionTierStatus');
}

class SubscriptionTierStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Subscription Tier */
            SubscriptionTier = new DwItemRelationship('SubscriptionTierStatus|SubscriptionTier|SubscriptionTierStatusId', 'SubscriptionTier', 'SubscriptionTier');
    };
export class TimeZoneMetaData implements DwItem2<TimeZoneEntity, TimeZoneMetaDataAttributes,TimeZoneMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1132;
        this.ItemDetail.itemName='TimeZone';
        this.ItemDetail.keyName='TimezoneId';
    }

    CreateEntity(): TimeZoneEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): TimeZoneQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<TimeZoneEntity, TimeZoneMetaDataAttributes,TimeZoneMetaDataRelations>(query, this);
    }
     Attributes = new TimeZoneMetaDataAttributes();
     Relations = new TimeZoneMetaDataRelations();

}


export type TimeZoneQueryBuilder = DwQueryBuilderGen<TimeZoneEntity, TimeZoneMetaDataAttributes,TimeZoneMetaDataRelations>


export class TimeZoneMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'TimeZone';
    // Attributes
    TimezoneId = new DwItemAttribute(this.i, 'TimezoneId');
    TimezoneName = new DwItemAttribute(this.i, 'TimezoneName');
    TimezoneShortName = new DwItemAttribute(this.i, 'TimezoneShortName');
    GmtOffSet = new DwItemAttribute(this.i, 'GmtOffSet');
    TimeZoneDescription = new DwItemAttribute(this.i, 'TimeZoneDescription');
    IANAIdentifier = new DwItemAttribute(this.i, 'IANAIdentifier');
    DotNetBCLIdentifier = new DwItemAttribute(this.i, 'DotNetBCLIdentifier');
}

class TimeZoneMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Address */
            Address = new DwItemRelationship('TimeZone|Address|TimezoneId', 'Address', 'Address');
            /** Relation: Pilot Examiner Location - Booking Schedule - Many */
            PilotExaminerLocationByBookingScheduleTimeZoneId = new DwItemRelationship('TimeZone|PilotExaminerLocation|BookingScheduleTimeZoneId', 'BookingScheduleTimeZoneIdPilotExaminerLocation', 'BookingScheduleTimeZoneIdPilotExaminerLocation');
            /** Relation: Postal Code - Many */
            PostalCodeByTimeZoneId = new DwItemRelationship('TimeZone|PostalCode|TimeZoneId', 'TimeZoneIdPostalCode', 'TimeZoneIdPostalCode');
            /** Relation: Schedule Block - Booking - Many */
            ScheduleBlockByBookingTimeZoneId = new DwItemRelationship('TimeZone|ScheduleBlock|BookingTimeZoneId', 'BookingTimeZoneIdScheduleBlock', 'BookingTimeZoneIdScheduleBlock');
    };
export class TrainingRecordMetaData implements DwItem2<TrainingRecordEntity, TrainingRecordMetaDataAttributes,TrainingRecordMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2360;
        this.ItemDetail.itemName='TrainingRecord';
        this.ItemDetail.keyName='TrainingRecordId';
    }

    CreateEntity(): TrainingRecordEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): TrainingRecordQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<TrainingRecordEntity, TrainingRecordMetaDataAttributes,TrainingRecordMetaDataRelations>(query, this);
    }
     Attributes = new TrainingRecordMetaDataAttributes();
     Relations = new TrainingRecordMetaDataRelations();

}


export type TrainingRecordQueryBuilder = DwQueryBuilderGen<TrainingRecordEntity, TrainingRecordMetaDataAttributes,TrainingRecordMetaDataRelations>


export class TrainingRecordMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'TrainingRecord';
    // Attributes
    TrainingRecordId = new DwItemAttribute(this.i, 'TrainingRecordId');
    TrainingTypeId = new DwItemAttribute(this.i, 'TrainingTypeId');
    IssuedDate = new DwItemAttribute(this.i, 'IssuedDate');
    DateCompleted = new DwItemAttribute(this.i, 'DateCompleted');
    ExpirationDate = new DwItemAttribute(this.i, 'ExpirationDate');
    TrainingRecordStatusId = new DwItemAttribute(this.i, 'TrainingRecordStatusId');
    NotifyExpiringSoon = new DwItemAttribute(this.i, 'NotifyExpiringSoon');
    NotifyExpired = new DwItemAttribute(this.i, 'NotifyExpired');
    Notes = new DwItemAttribute(this.i, 'Notes');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    OwnershipTypeId = new DwItemAttribute(this.i, 'OwnershipTypeId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    CompletionDocumentMediaId = new DwItemAttribute(this.i, 'CompletionDocumentMediaId');
}

class TrainingRecordMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Check Ride Ownership Type - Ownership Type */
            CheckRideOwnershipTypeByOwnershipTypeId = new DwItemRelationship('CheckRideOwnershipType|TrainingRecord|OwnershipTypeId', 'OwnershipTypeIdCheckRideOwnershipType', 'OwnershipTypeIdCheckRideOwnershipType');
            /** Relation: Flight School Examiner */
            FlightSchoolExaminer = new DwItemRelationship('FlightSchoolExaminer|TrainingRecord|FlightSchoolExaminerId', 'FlightSchoolExaminer', 'FlightSchoolExaminer');
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('PilotExaminer|TrainingRecord|PilotExaminerId', 'PilotExaminer', 'PilotExaminer');
            /** Relation: Training Record Status */
            TrainingRecordStatus = new DwItemRelationship('TrainingRecordStatus|TrainingRecord|TrainingRecordStatusId', 'TrainingRecordStatus', 'TrainingRecordStatus');
            /** Relation: Training Type */
            TrainingType = new DwItemRelationship('TrainingType|TrainingRecord|TrainingTypeId', 'TrainingType', 'TrainingType');
    };
export class TrainingRecordStatusMetaData implements DwItem2<TrainingRecordStatusEntity, TrainingRecordStatusMetaDataAttributes,TrainingRecordStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2357;
        this.ItemDetail.itemName='TrainingRecordStatus';
        this.ItemDetail.keyName='TrainingRecordStatusId';
    }

    CreateEntity(): TrainingRecordStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): TrainingRecordStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<TrainingRecordStatusEntity, TrainingRecordStatusMetaDataAttributes,TrainingRecordStatusMetaDataRelations>(query, this);
    }
     Attributes = new TrainingRecordStatusMetaDataAttributes();
     Relations = new TrainingRecordStatusMetaDataRelations();

}


export type TrainingRecordStatusQueryBuilder = DwQueryBuilderGen<TrainingRecordStatusEntity, TrainingRecordStatusMetaDataAttributes,TrainingRecordStatusMetaDataRelations>


export class TrainingRecordStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'TrainingRecordStatus';
    // Attributes
    TrainingRecordStatusId = new DwItemAttribute(this.i, 'TrainingRecordStatusId');
    TrainingRecordStatus = new DwItemAttribute(this.i, 'TrainingRecordStatus');
    CssClass = new DwItemAttribute(this.i, 'CssClass');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class TrainingRecordStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Training Record */
            TrainingRecord = new DwItemRelationship('TrainingRecordStatus|TrainingRecord|TrainingRecordStatusId', 'TrainingRecord', 'TrainingRecord');
    };
export class TrainingTypeMetaData implements DwItem2<TrainingTypeEntity, TrainingTypeMetaDataAttributes,TrainingTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2358;
        this.ItemDetail.itemName='TrainingType';
        this.ItemDetail.keyName='TrainingTypeId';
    }

    CreateEntity(): TrainingTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): TrainingTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<TrainingTypeEntity, TrainingTypeMetaDataAttributes,TrainingTypeMetaDataRelations>(query, this);
    }
     Attributes = new TrainingTypeMetaDataAttributes();
     Relations = new TrainingTypeMetaDataRelations();

}


export type TrainingTypeQueryBuilder = DwQueryBuilderGen<TrainingTypeEntity, TrainingTypeMetaDataAttributes,TrainingTypeMetaDataRelations>


export class TrainingTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'TrainingType';
    // Attributes
    TrainingTypeId = new DwItemAttribute(this.i, 'TrainingTypeId');
    TrainingType = new DwItemAttribute(this.i, 'TrainingType');
    RequiredForPoa = new DwItemAttribute(this.i, 'RequiredForPoa');
    FileRequired = new DwItemAttribute(this.i, 'FileRequired');
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class TrainingTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Reference Status */
            ReferenceStatus = new DwItemRelationship('ReferenceStatus|TrainingType|ReferenceStatusId', 'ReferenceStatus', 'ReferenceStatus');
            /** Relation: Training Record */
            TrainingRecord = new DwItemRelationship('TrainingType|TrainingRecord|TrainingTypeId', 'TrainingRecord', 'TrainingRecord');
    };
export class UnitMemberAircraftCategoryClassMetaData implements DwItem2<UnitMemberAircraftCategoryClassEntity, UnitMemberAircraftCategoryClassMetaDataAttributes,UnitMemberAircraftCategoryClassMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2369;
        this.ItemDetail.itemName='UnitMemberAircraftCategoryClass';
        this.ItemDetail.keyName='UnitMemberAircraftCategoryClassId';
    }

    CreateEntity(): UnitMemberAircraftCategoryClassEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UnitMemberAircraftCategoryClassQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UnitMemberAircraftCategoryClassEntity, UnitMemberAircraftCategoryClassMetaDataAttributes,UnitMemberAircraftCategoryClassMetaDataRelations>(query, this);
    }
     Attributes = new UnitMemberAircraftCategoryClassMetaDataAttributes();
     Relations = new UnitMemberAircraftCategoryClassMetaDataRelations();

}


export type UnitMemberAircraftCategoryClassQueryBuilder = DwQueryBuilderGen<UnitMemberAircraftCategoryClassEntity, UnitMemberAircraftCategoryClassMetaDataAttributes,UnitMemberAircraftCategoryClassMetaDataRelations>


export class UnitMemberAircraftCategoryClassMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UnitMemberAircraftCategoryClass';
    // Attributes
    UnitMemberAircraftCategoryClassId = new DwItemAttribute(this.i, 'UnitMemberAircraftCategoryClassId');
    UnitMemberAircraftCategoryClass = new DwItemAttribute(this.i, 'UnitMemberAircraftCategoryClass');
    SortOrder = new DwItemAttribute(this.i, 'SortOrder');
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class UnitMemberAircraftCategoryClassMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Reference Status */
            ReferenceStatus = new DwItemRelationship('ReferenceStatus|UnitMemberAircraftCategoryClass|ReferenceStatusId', 'ReferenceStatus', 'ReferenceStatus');
            /** Relation: Unit Member Flight Experience */
            UnitMemberFlightExperience = new DwItemRelationship('UnitMemberAircraftCategoryClass|UnitMemberFlightExperience|UnitMemberAircraftCategoryClassId', 'UnitMemberFlightExperience', 'UnitMemberFlightExperience');
    };
export class UnitMemberAircraftExperienceMetaData implements DwItem2<UnitMemberAircraftExperienceEntity, UnitMemberAircraftExperienceMetaDataAttributes,UnitMemberAircraftExperienceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2378;
        this.ItemDetail.itemName='UnitMemberAircraftExperience';
        this.ItemDetail.keyName='UnitMemberAircraftExperienceId';
    }

    CreateEntity(): UnitMemberAircraftExperienceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UnitMemberAircraftExperienceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UnitMemberAircraftExperienceEntity, UnitMemberAircraftExperienceMetaDataAttributes,UnitMemberAircraftExperienceMetaDataRelations>(query, this);
    }
     Attributes = new UnitMemberAircraftExperienceMetaDataAttributes();
     Relations = new UnitMemberAircraftExperienceMetaDataRelations();

}


export type UnitMemberAircraftExperienceQueryBuilder = DwQueryBuilderGen<UnitMemberAircraftExperienceEntity, UnitMemberAircraftExperienceMetaDataAttributes,UnitMemberAircraftExperienceMetaDataRelations>


export class UnitMemberAircraftExperienceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UnitMemberAircraftExperience';
    // Attributes
    UnitMemberAircraftExperienceId = new DwItemAttribute(this.i, 'UnitMemberAircraftExperienceId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    UnitMemberAircraftExperienceTypeId = new DwItemAttribute(this.i, 'UnitMemberAircraftExperienceTypeId');
    AircraftMake = new DwItemAttribute(this.i, 'AircraftMake');
    AircraftModel = new DwItemAttribute(this.i, 'AircraftModel');
    PicHoursPastTwelveMonths = new DwItemAttribute(this.i, 'PicHoursPastTwelveMonths');
    TotalPicHours = new DwItemAttribute(this.i, 'TotalPicHours');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class UnitMemberAircraftExperienceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Examiner */
            FlightSchoolExaminer = new DwItemRelationship('FlightSchoolExaminer|UnitMemberAircraftExperience|FlightSchoolExaminerId', 'FlightSchoolExaminer', 'FlightSchoolExaminer');
            /** Relation: Unit Member Aircraft Experience Type */
            UnitMemberAircraftExperienceType = new DwItemRelationship('UnitMemberAircraftExperienceType|UnitMemberAircraftExperience|UnitMemberAircraftExperienceTypeId', 'UnitMemberAircraftExperienceType', 'UnitMemberAircraftExperienceType');
    };
export class UnitMemberAircraftExperienceTypeMetaData implements DwItem2<UnitMemberAircraftExperienceTypeEntity, UnitMemberAircraftExperienceTypeMetaDataAttributes,UnitMemberAircraftExperienceTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2370;
        this.ItemDetail.itemName='UnitMemberAircraftExperienceType';
        this.ItemDetail.keyName='UnitMemberAircraftExperienceTypeId';
    }

    CreateEntity(): UnitMemberAircraftExperienceTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UnitMemberAircraftExperienceTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UnitMemberAircraftExperienceTypeEntity, UnitMemberAircraftExperienceTypeMetaDataAttributes,UnitMemberAircraftExperienceTypeMetaDataRelations>(query, this);
    }
     Attributes = new UnitMemberAircraftExperienceTypeMetaDataAttributes();
     Relations = new UnitMemberAircraftExperienceTypeMetaDataRelations();

}


export type UnitMemberAircraftExperienceTypeQueryBuilder = DwQueryBuilderGen<UnitMemberAircraftExperienceTypeEntity, UnitMemberAircraftExperienceTypeMetaDataAttributes,UnitMemberAircraftExperienceTypeMetaDataRelations>


export class UnitMemberAircraftExperienceTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UnitMemberAircraftExperienceType';
    // Attributes
    UnitMemberAircraftExperienceTypeId = new DwItemAttribute(this.i, 'UnitMemberAircraftExperienceTypeId');
    UnitMemberAircraftExperienceType = new DwItemAttribute(this.i, 'UnitMemberAircraftExperienceType');
    SortOrder = new DwItemAttribute(this.i, 'SortOrder');
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class UnitMemberAircraftExperienceTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Reference Status */
            ReferenceStatus = new DwItemRelationship('ReferenceStatus|UnitMemberAircraftExperienceType|ReferenceStatusId', 'ReferenceStatus', 'ReferenceStatus');
            /** Relation: Unit Member Aircraft Experience */
            UnitMemberAircraftExperience = new DwItemRelationship('UnitMemberAircraftExperienceType|UnitMemberAircraftExperience|UnitMemberAircraftExperienceTypeId', 'UnitMemberAircraftExperience', 'UnitMemberAircraftExperience');
    };
export class UnitMemberCertificateMetaData implements DwItem2<UnitMemberCertificateEntity, UnitMemberCertificateMetaDataAttributes,UnitMemberCertificateMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2376;
        this.ItemDetail.itemName='UnitMemberCertificate';
        this.ItemDetail.keyName='UnitMemberCertificateId';
    }

    CreateEntity(): UnitMemberCertificateEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UnitMemberCertificateQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UnitMemberCertificateEntity, UnitMemberCertificateMetaDataAttributes,UnitMemberCertificateMetaDataRelations>(query, this);
    }
     Attributes = new UnitMemberCertificateMetaDataAttributes();
     Relations = new UnitMemberCertificateMetaDataRelations();

}


export type UnitMemberCertificateQueryBuilder = DwQueryBuilderGen<UnitMemberCertificateEntity, UnitMemberCertificateMetaDataAttributes,UnitMemberCertificateMetaDataRelations>


export class UnitMemberCertificateMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UnitMemberCertificate';
    // Attributes
    UnitMemberCertificateId = new DwItemAttribute(this.i, 'UnitMemberCertificateId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    CertificateType = new DwItemAttribute(this.i, 'CertificateType');
    CertificateNumber = new DwItemAttribute(this.i, 'CertificateNumber');
    Ratings = new DwItemAttribute(this.i, 'Ratings');
    IssuanceDate = new DwItemAttribute(this.i, 'IssuanceDate');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class UnitMemberCertificateMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Examiner */
            FlightSchoolExaminer = new DwItemRelationship('FlightSchoolExaminer|UnitMemberCertificate|FlightSchoolExaminerId', 'FlightSchoolExaminer', 'FlightSchoolExaminer');
    };
export class UnitMemberEmploymentMetaData implements DwItem2<UnitMemberEmploymentEntity, UnitMemberEmploymentMetaDataAttributes,UnitMemberEmploymentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2375;
        this.ItemDetail.itemName='UnitMemberEmployment';
        this.ItemDetail.keyName='UnitMemberEmploymentId';
    }

    CreateEntity(): UnitMemberEmploymentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UnitMemberEmploymentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UnitMemberEmploymentEntity, UnitMemberEmploymentMetaDataAttributes,UnitMemberEmploymentMetaDataRelations>(query, this);
    }
     Attributes = new UnitMemberEmploymentMetaDataAttributes();
     Relations = new UnitMemberEmploymentMetaDataRelations();

}


export type UnitMemberEmploymentQueryBuilder = DwQueryBuilderGen<UnitMemberEmploymentEntity, UnitMemberEmploymentMetaDataAttributes,UnitMemberEmploymentMetaDataRelations>


export class UnitMemberEmploymentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UnitMemberEmployment';
    // Attributes
    UnitMemberEmploymentId = new DwItemAttribute(this.i, 'UnitMemberEmploymentId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    EmployerOrganizationName = new DwItemAttribute(this.i, 'EmployerOrganizationName');
    TelephoneNumber = new DwItemAttribute(this.i, 'TelephoneNumber');
    StreetAddress = new DwItemAttribute(this.i, 'StreetAddress');
    City = new DwItemAttribute(this.i, 'City');
    StateOrCountry = new DwItemAttribute(this.i, 'StateOrCountry');
    PostalCode = new DwItemAttribute(this.i, 'PostalCode');
    PositionTitle = new DwItemAttribute(this.i, 'PositionTitle');
    EmployedFromDate = new DwItemAttribute(this.i, 'EmployedFromDate');
    EmployedToDate = new DwItemAttribute(this.i, 'EmployedToDate');
    SupervisorName = new DwItemAttribute(this.i, 'SupervisorName');
    FaaAirAgencyOrOperatorCertificateNumber = new DwItemAttribute(this.i, 'FaaAirAgencyOrOperatorCertificateNumber');
    Experience = new DwItemAttribute(this.i, 'Experience');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class UnitMemberEmploymentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Examiner */
            FlightSchoolExaminer = new DwItemRelationship('FlightSchoolExaminer|UnitMemberEmployment|FlightSchoolExaminerId', 'FlightSchoolExaminer', 'FlightSchoolExaminer');
    };
export class UnitMemberFlightExperienceMetaData implements DwItem2<UnitMemberFlightExperienceEntity, UnitMemberFlightExperienceMetaDataAttributes,UnitMemberFlightExperienceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2377;
        this.ItemDetail.itemName='UnitMemberFlightExperience';
        this.ItemDetail.keyName='UnitMemberFlightExperienceId';
    }

    CreateEntity(): UnitMemberFlightExperienceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UnitMemberFlightExperienceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UnitMemberFlightExperienceEntity, UnitMemberFlightExperienceMetaDataAttributes,UnitMemberFlightExperienceMetaDataRelations>(query, this);
    }
     Attributes = new UnitMemberFlightExperienceMetaDataAttributes();
     Relations = new UnitMemberFlightExperienceMetaDataRelations();

}


export type UnitMemberFlightExperienceQueryBuilder = DwQueryBuilderGen<UnitMemberFlightExperienceEntity, UnitMemberFlightExperienceMetaDataAttributes,UnitMemberFlightExperienceMetaDataRelations>


export class UnitMemberFlightExperienceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UnitMemberFlightExperience';
    // Attributes
    UnitMemberFlightExperienceId = new DwItemAttribute(this.i, 'UnitMemberFlightExperienceId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    UnitMemberAircraftCategoryClassId = new DwItemAttribute(this.i, 'UnitMemberAircraftCategoryClassId');
    TotalHours = new DwItemAttribute(this.i, 'TotalHours');
    TotalPicHours = new DwItemAttribute(this.i, 'TotalPicHours');
    PicHoursPastTwelveMonths = new DwItemAttribute(this.i, 'PicHoursPastTwelveMonths');
    TotalInstructionGivenHours = new DwItemAttribute(this.i, 'TotalInstructionGivenHours');
    CfiiInstructionGivenHours = new DwItemAttribute(this.i, 'CfiiInstructionGivenHours');
    BalloonInstructionPastTwelveMonthsHours = new DwItemAttribute(this.i, 'BalloonInstructionPastTwelveMonthsHours');
    NightPicHours = new DwItemAttribute(this.i, 'NightPicHours');
    InstrumentPicHours = new DwItemAttribute(this.i, 'InstrumentPicHours');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class UnitMemberFlightExperienceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Examiner */
            FlightSchoolExaminer = new DwItemRelationship('FlightSchoolExaminer|UnitMemberFlightExperience|FlightSchoolExaminerId', 'FlightSchoolExaminer', 'FlightSchoolExaminer');
            /** Relation: Unit Member Aircraft Category Class */
            UnitMemberAircraftCategoryClass = new DwItemRelationship('UnitMemberAircraftCategoryClass|UnitMemberFlightExperience|UnitMemberAircraftCategoryClassId', 'UnitMemberAircraftCategoryClass', 'UnitMemberAircraftCategoryClass');
    };
export class UnitMemberProfileMetaData implements DwItem2<UnitMemberProfileEntity, UnitMemberProfileMetaDataAttributes,UnitMemberProfileMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2374;
        this.ItemDetail.itemName='UnitMemberProfile';
        this.ItemDetail.keyName='UnitMemberProfileId';
    }

    CreateEntity(): UnitMemberProfileEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UnitMemberProfileQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UnitMemberProfileEntity, UnitMemberProfileMetaDataAttributes,UnitMemberProfileMetaDataRelations>(query, this);
    }
     Attributes = new UnitMemberProfileMetaDataAttributes();
     Relations = new UnitMemberProfileMetaDataRelations();

}


export type UnitMemberProfileQueryBuilder = DwQueryBuilderGen<UnitMemberProfileEntity, UnitMemberProfileMetaDataAttributes,UnitMemberProfileMetaDataRelations>


export class UnitMemberProfileMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UnitMemberProfile';
    // Attributes
    UnitMemberProfileId = new DwItemAttribute(this.i, 'UnitMemberProfileId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    MedicalCertificateClass = new DwItemAttribute(this.i, 'MedicalCertificateClass');
    MedicalExaminationDate = new DwItemAttribute(this.i, 'MedicalExaminationDate');
    MedicalLimitations = new DwItemAttribute(this.i, 'MedicalLimitations');
    BasicMedCmecDate = new DwItemAttribute(this.i, 'BasicMedCmecDate');
    BasicMedCourseCompletionDate = new DwItemAttribute(this.i, 'BasicMedCourseCompletionDate');
    PoweredLiftAtpInstructionHours = new DwItemAttribute(this.i, 'PoweredLiftAtpInstructionHours');
    PoweredLiftTypeRatingInstructionHours = new DwItemAttribute(this.i, 'PoweredLiftTypeRatingInstructionHours');
    PoweredLiftCfiiInstructionHours = new DwItemAttribute(this.i, 'PoweredLiftCfiiInstructionHours');
    PoweredLiftCommercialInstructionHours = new DwItemAttribute(this.i, 'PoweredLiftCommercialInstructionHours');
    HelicopterCommercialInstructionHours = new DwItemAttribute(this.i, 'HelicopterCommercialInstructionHours');
    HelicopterAtpInstructionHours = new DwItemAttribute(this.i, 'HelicopterAtpInstructionHours');
    GliderPicFlightsPastYear = new DwItemAttribute(this.i, 'GliderPicFlightsPastYear');
    BalloonPicFlightsPastYear = new DwItemAttribute(this.i, 'BalloonPicFlightsPastYear');
    HelicopterCfiiInstructionHours = new DwItemAttribute(this.i, 'HelicopterCfiiInstructionHours');
    CommercialPreparationInstructionHours = new DwItemAttribute(this.i, 'CommercialPreparationInstructionHours');
    InstructionHoursPastThreeYears = new DwItemAttribute(this.i, 'InstructionHoursPastThreeYears');
    ComplexAirplanePicHours = new DwItemAttribute(this.i, 'ComplexAirplanePicHours');
    AtpPreparationInstructionHours = new DwItemAttribute(this.i, 'AtpPreparationInstructionHours');
    TypeRatingPreparationInstructionHours = new DwItemAttribute(this.i, 'TypeRatingPreparationInstructionHours');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    MedicalCertificateExpirationDate = new DwItemAttribute(this.i, 'MedicalCertificateExpirationDate');
}

class UnitMemberProfileMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Examiner */
            FlightSchoolExaminer = new DwItemRelationship('FlightSchoolExaminer|UnitMemberProfile|FlightSchoolExaminerId', 'FlightSchoolExaminer', 'FlightSchoolExaminer');
    };
export class UnitMemberQualificationOptionMetaData implements DwItem2<UnitMemberQualificationOptionEntity, UnitMemberQualificationOptionMetaDataAttributes,UnitMemberQualificationOptionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2373;
        this.ItemDetail.itemName='UnitMemberQualificationOption';
        this.ItemDetail.keyName='UnitMemberQualificationOptionId';
    }

    CreateEntity(): UnitMemberQualificationOptionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UnitMemberQualificationOptionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UnitMemberQualificationOptionEntity, UnitMemberQualificationOptionMetaDataAttributes,UnitMemberQualificationOptionMetaDataRelations>(query, this);
    }
     Attributes = new UnitMemberQualificationOptionMetaDataAttributes();
     Relations = new UnitMemberQualificationOptionMetaDataRelations();

}


export type UnitMemberQualificationOptionQueryBuilder = DwQueryBuilderGen<UnitMemberQualificationOptionEntity, UnitMemberQualificationOptionMetaDataAttributes,UnitMemberQualificationOptionMetaDataRelations>


export class UnitMemberQualificationOptionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UnitMemberQualificationOption';
    // Attributes
    UnitMemberQualificationOptionId = new DwItemAttribute(this.i, 'UnitMemberQualificationOptionId');
    UnitMemberQualificationTypeId = new DwItemAttribute(this.i, 'UnitMemberQualificationTypeId');
    UnitMemberQualificationOption = new DwItemAttribute(this.i, 'UnitMemberQualificationOption');
    OptionValue = new DwItemAttribute(this.i, 'OptionValue');
    SortOrder = new DwItemAttribute(this.i, 'SortOrder');
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class UnitMemberQualificationOptionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Reference Status */
            ReferenceStatus = new DwItemRelationship('ReferenceStatus|UnitMemberQualificationOption|ReferenceStatusId', 'ReferenceStatus', 'ReferenceStatus');
            /** Relation: Unit Member Qualification Type */
            UnitMemberQualificationType = new DwItemRelationship('UnitMemberQualificationType|UnitMemberQualificationOption|UnitMemberQualificationTypeId', 'UnitMemberQualificationType', 'UnitMemberQualificationType');
            /** Relation: Unit Member Qualification Response */
            UnitMemberQualificationResponse = new DwItemRelationship('UnitMemberQualificationOption|UnitMemberQualificationResponse|UnitMemberQualificationOptionId', 'UnitMemberQualificationResponse', 'UnitMemberQualificationResponse');
    };
export class UnitMemberQualificationResponseMetaData implements DwItem2<UnitMemberQualificationResponseEntity, UnitMemberQualificationResponseMetaDataAttributes,UnitMemberQualificationResponseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2379;
        this.ItemDetail.itemName='UnitMemberQualificationResponse';
        this.ItemDetail.keyName='UnitMemberQualificationResponseId';
    }

    CreateEntity(): UnitMemberQualificationResponseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UnitMemberQualificationResponseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UnitMemberQualificationResponseEntity, UnitMemberQualificationResponseMetaDataAttributes,UnitMemberQualificationResponseMetaDataRelations>(query, this);
    }
     Attributes = new UnitMemberQualificationResponseMetaDataAttributes();
     Relations = new UnitMemberQualificationResponseMetaDataRelations();

}


export type UnitMemberQualificationResponseQueryBuilder = DwQueryBuilderGen<UnitMemberQualificationResponseEntity, UnitMemberQualificationResponseMetaDataAttributes,UnitMemberQualificationResponseMetaDataRelations>


export class UnitMemberQualificationResponseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UnitMemberQualificationResponse';
    // Attributes
    UnitMemberQualificationResponseId = new DwItemAttribute(this.i, 'UnitMemberQualificationResponseId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    UnitMemberQualificationTypeId = new DwItemAttribute(this.i, 'UnitMemberQualificationTypeId');
    YesNoValue = new DwItemAttribute(this.i, 'YesNoValue');
    NumericValue = new DwItemAttribute(this.i, 'NumericValue');
    UnitMemberQualificationOptionId = new DwItemAttribute(this.i, 'UnitMemberQualificationOptionId');
    Notes = new DwItemAttribute(this.i, 'Notes');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class UnitMemberQualificationResponseMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Examiner */
            FlightSchoolExaminer = new DwItemRelationship('FlightSchoolExaminer|UnitMemberQualificationResponse|FlightSchoolExaminerId', 'FlightSchoolExaminer', 'FlightSchoolExaminer');
            /** Relation: Unit Member Qualification Option */
            UnitMemberQualificationOption = new DwItemRelationship('UnitMemberQualificationOption|UnitMemberQualificationResponse|UnitMemberQualificationOptionId', 'UnitMemberQualificationOption', 'UnitMemberQualificationOption');
            /** Relation: Unit Member Qualification Type */
            UnitMemberQualificationType = new DwItemRelationship('UnitMemberQualificationType|UnitMemberQualificationResponse|UnitMemberQualificationTypeId', 'UnitMemberQualificationType', 'UnitMemberQualificationType');
    };
export class UnitMemberQualificationResponseTypeMetaData implements DwItem2<UnitMemberQualificationResponseTypeEntity, UnitMemberQualificationResponseTypeMetaDataAttributes,UnitMemberQualificationResponseTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2371;
        this.ItemDetail.itemName='UnitMemberQualificationResponseType';
        this.ItemDetail.keyName='UnitMemberQualificationResponseTypeId';
    }

    CreateEntity(): UnitMemberQualificationResponseTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UnitMemberQualificationResponseTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UnitMemberQualificationResponseTypeEntity, UnitMemberQualificationResponseTypeMetaDataAttributes,UnitMemberQualificationResponseTypeMetaDataRelations>(query, this);
    }
     Attributes = new UnitMemberQualificationResponseTypeMetaDataAttributes();
     Relations = new UnitMemberQualificationResponseTypeMetaDataRelations();

}


export type UnitMemberQualificationResponseTypeQueryBuilder = DwQueryBuilderGen<UnitMemberQualificationResponseTypeEntity, UnitMemberQualificationResponseTypeMetaDataAttributes,UnitMemberQualificationResponseTypeMetaDataRelations>


export class UnitMemberQualificationResponseTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UnitMemberQualificationResponseType';
    // Attributes
    UnitMemberQualificationResponseTypeId = new DwItemAttribute(this.i, 'UnitMemberQualificationResponseTypeId');
    UnitMemberQualificationResponseType = new DwItemAttribute(this.i, 'UnitMemberQualificationResponseType');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class UnitMemberQualificationResponseTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Unit Member Qualification Type */
            UnitMemberQualificationType = new DwItemRelationship('UnitMemberQualificationResponseType|UnitMemberQualificationType|UnitMemberQualificationResponseTypeId', 'UnitMemberQualificationType', 'UnitMemberQualificationType');
    };
export class UnitMemberQualificationTypeMetaData implements DwItem2<UnitMemberQualificationTypeEntity, UnitMemberQualificationTypeMetaDataAttributes,UnitMemberQualificationTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2372;
        this.ItemDetail.itemName='UnitMemberQualificationType';
        this.ItemDetail.keyName='UnitMemberQualificationTypeId';
    }

    CreateEntity(): UnitMemberQualificationTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UnitMemberQualificationTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UnitMemberQualificationTypeEntity, UnitMemberQualificationTypeMetaDataAttributes,UnitMemberQualificationTypeMetaDataRelations>(query, this);
    }
     Attributes = new UnitMemberQualificationTypeMetaDataAttributes();
     Relations = new UnitMemberQualificationTypeMetaDataRelations();

}


export type UnitMemberQualificationTypeQueryBuilder = DwQueryBuilderGen<UnitMemberQualificationTypeEntity, UnitMemberQualificationTypeMetaDataAttributes,UnitMemberQualificationTypeMetaDataRelations>


export class UnitMemberQualificationTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UnitMemberQualificationType';
    // Attributes
    UnitMemberQualificationTypeId = new DwItemAttribute(this.i, 'UnitMemberQualificationTypeId');
    QualificationCode = new DwItemAttribute(this.i, 'QualificationCode');
    UnitMemberQualificationType = new DwItemAttribute(this.i, 'UnitMemberQualificationType');
    UnitMemberQualificationResponseTypeId = new DwItemAttribute(this.i, 'UnitMemberQualificationResponseTypeId');
    MaximumValue = new DwItemAttribute(this.i, 'MaximumValue');
    SortOrder = new DwItemAttribute(this.i, 'SortOrder');
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class UnitMemberQualificationTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Reference Status */
            ReferenceStatus = new DwItemRelationship('ReferenceStatus|UnitMemberQualificationType|ReferenceStatusId', 'ReferenceStatus', 'ReferenceStatus');
            /** Relation: Unit Member Qualification Response Type */
            UnitMemberQualificationResponseType = new DwItemRelationship('UnitMemberQualificationResponseType|UnitMemberQualificationType|UnitMemberQualificationResponseTypeId', 'UnitMemberQualificationResponseType', 'UnitMemberQualificationResponseType');
            /** Relation: Unit Member Qualification Option */
            UnitMemberQualificationOption = new DwItemRelationship('UnitMemberQualificationType|UnitMemberQualificationOption|UnitMemberQualificationTypeId', 'UnitMemberQualificationOption', 'UnitMemberQualificationOption');
            /** Relation: Unit Member Qualification Response */
            UnitMemberQualificationResponse = new DwItemRelationship('UnitMemberQualificationType|UnitMemberQualificationResponse|UnitMemberQualificationTypeId', 'UnitMemberQualificationResponse', 'UnitMemberQualificationResponse');
    };
export class DwUserMetaData implements DwItem2<DwUserEntity, DwUserMetaDataAttributes,DwUserMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=176;
        this.ItemDetail.itemName='dw_User';
        this.ItemDetail.keyName='UserId';
    }

    CreateEntity(): DwUserEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwUserQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwUserEntity, DwUserMetaDataAttributes,DwUserMetaDataRelations>(query, this);
    }
     Attributes = new DwUserMetaDataAttributes();
     Relations = new DwUserMetaDataRelations();

}


export type DwUserQueryBuilder = DwQueryBuilderGen<DwUserEntity, DwUserMetaDataAttributes,DwUserMetaDataRelations>


export class DwUserMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_User';
    // Attributes
    AlternateName = new DwItemAttribute(this.i, 'AlternateName');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    Email = new DwItemAttribute(this.i, 'Email');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    ForcePasswordChange = new DwItemAttribute(this.i, 'ForcePasswordChange');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    IsEmailVerified = new DwItemAttribute(this.i, 'IsEmailVerified');
    IsTwoFactorAuthenticationEnabled = new DwItemAttribute(this.i, 'IsTwoFactorAuthenticationEnabled');
    LastLoginDateTime = new DwItemAttribute(this.i, 'LastLoginDateTime');
    LastName = new DwItemAttribute(this.i, 'LastName');
    LastPasswordChangeDateTime = new DwItemAttribute(this.i, 'LastPasswordChangeDateTime');
    MobilePhone = new DwItemAttribute(this.i, 'MobilePhone');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    OrganizationId = new DwItemAttribute(this.i, 'OrganizationId');
    PartyReferenceId = new DwItemAttribute(this.i, 'PartyReferenceId');
    TwoFactorAuthenticationTypeId = new DwItemAttribute(this.i, 'TwoFactorAuthenticationTypeId');
    UserBackgroundMediaId = new DwItemAttribute(this.i, 'UserBackgroundMediaId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    UserKey = new DwItemAttribute(this.i, 'UserKey');
    UserName = new DwItemAttribute(this.i, 'UserName');
    UserPictureMediaId = new DwItemAttribute(this.i, 'UserPictureMediaId');
    UserTypeId = new DwItemAttribute(this.i, 'UserTypeId');
    Password = new DwItemAttribute(this.i, 'Password');
}

class DwUserMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Ro Media - User Picture Media */
            DwRoMediaByUserPictureMediaId = new DwItemRelationship('roMedia|User|UserPictureMediaId', 'UserPictureDwroMedia', 'UserPictureDwroMedia');
            /** Relation: User Type */
            DwUserType = new DwItemRelationship('dw_UserType|dw_User|UserTypeId', 'DwUserType', 'DwUserType');
            /** Relation: Check Ride Schedule Hold - Created By - Many */
            CheckRideScheduleHoldByCreatedBy = new DwItemRelationship('dw_User|CheckRideScheduleHold|CreatedBy', 'CreatedByCheckRideScheduleHold', 'CreatedByCheckRideScheduleHold');
            /** Relation: Check Ride Schedule Hold - Modified By - Many */
            CheckRideScheduleHoldByModifiedBy = new DwItemRelationship('dw_User|CheckRideScheduleHold|ModifiedBy', 'ModifiedByCheckRideScheduleHold', 'ModifiedByCheckRideScheduleHold');
            /** Relation: Flight School Organization - Original Owner - Many */
            FlightSchoolOrganizationByOriginalOwnerUserId = new DwItemRelationship('dw_User|FlightSchoolOrganization|OriginalOwnerUserId', 'OriginalOwnerFlightSchoolOrganization', 'OriginalOwnerFlightSchoolOrganization');
            /** Relation: Flight School User */
            FlightSchoolUser = new DwItemRelationship('dw_User|FlightSchoolUser|UserId', 'FlightSchoolUser', 'FlightSchoolUser');
            /** Relation: Payment Attempt - Initiated By - Many */
            PaymentAttemptByInitiatedByUserId = new DwItemRelationship('dw_User|PaymentAttempt|InitiatedByUserId', 'InitiatedByPaymentAttempt', 'InitiatedByPaymentAttempt');
            /** Relation: Payment Customer Reference */
            PaymentCustomerReference = new DwItemRelationship('dw_User|PaymentCustomerReference|UserId', 'PaymentCustomerReference', 'PaymentCustomerReference');
            /** Relation: Payment Discount Code - Limit To - Many */
            PaymentDiscountCodeByLimitToUserId = new DwItemRelationship('dw_User|PaymentDiscountCode|LimitToUserId', 'LimitToPaymentDiscountCode', 'LimitToPaymentDiscountCode');
            /** Relation: Pilot Examiner */
            PilotExaminer = new DwItemRelationship('dw_User|PilotExaminer|UserId', 'PilotExaminer', 'PilotExaminer');
            /** Relation: Ro Pilot Examiner Scenario - User - Many */
            RoPilotExaminerScenarioByuserId = new DwItemRelationship('User|RoPilotExaminer|UserId', 'UserIdRoPilotExaminerScenario', 'UserIdRoPilotExaminerScenario');
            /** Relation: Custom Calendar - Schedule Owner - Many */
            ScheduleByScheduleOwnerUserId = new DwItemRelationship('dw_User|Schedule|ScheduleOwnerUserId', 'ScheduleOwnerSchedule', 'ScheduleOwnerSchedule');
            /** Relation: Student Applicant */
            StudentApplicant = new DwItemRelationship('dw_User|StudentApplicant|UserId', 'StudentApplicant', 'StudentApplicant');
    };
export class DwUserInviteRequestMetaData implements DwItem2<DwUserInviteRequestEntity, DwUserInviteRequestMetaDataAttributes,DwUserInviteRequestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2293;
        this.ItemDetail.itemName='dw_UserInviteRequest';
        this.ItemDetail.keyName='UserInviteRequestId';
    }

    CreateEntity(): DwUserInviteRequestEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwUserInviteRequestQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwUserInviteRequestEntity, DwUserInviteRequestMetaDataAttributes,DwUserInviteRequestMetaDataRelations>(query, this);
    }
     Attributes = new DwUserInviteRequestMetaDataAttributes();
     Relations = new DwUserInviteRequestMetaDataRelations();

}


export type DwUserInviteRequestQueryBuilder = DwQueryBuilderGen<DwUserInviteRequestEntity, DwUserInviteRequestMetaDataAttributes,DwUserInviteRequestMetaDataRelations>


export class DwUserInviteRequestMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_UserInviteRequest';
    // Attributes
    UserInviteRequestId = new DwItemAttribute(this.i, 'UserInviteRequestId');
    InviteRequestTypeId = new DwItemAttribute(this.i, 'InviteRequestTypeId');
    MessageHtml = new DwItemAttribute(this.i, 'MessageHtml');
    InviteRequestStatusId = new DwItemAttribute(this.i, 'InviteRequestStatusId');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwUserInviteRequestMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User Invite Request Status - Invite Request Status */
            DwUserInviteRequestStatusByInviteRequestStatusId = new DwItemRelationship('dw_UserInviteRequestStatus|dw_UserInviteRequest|InviteRequestStatusId', 'InviteRequestStatusIdDwUserInviteRequestStatus', 'InviteRequestStatusIdDwUserInviteRequestStatus');
            /** Relation: User Invite Request Type - Invite Request Type */
            DwUserInviteRequestTypeByInviteRequestTypeId = new DwItemRelationship('dw_UserInviteRequestType|dw_UserInviteRequest|InviteRequestTypeId', 'InviteRequestTypeIdDwUserInviteRequestType', 'InviteRequestTypeIdDwUserInviteRequestType');
            /** Relation: User Invite Request Detail */
            UserInviteRequestDetail = new DwItemRelationship('dw_UserInviteRequest|UserInviteRequestDetail|UserInviteRequestId', 'UserInviteRequestDetail', 'UserInviteRequestDetail');
            /** Relation: User Invite Request Email */
            DwUserInviteRequestEmail = new DwItemRelationship('dw_UserInviteRequest|dw_UserInviteRequestEmail|UserInviteRequestId', 'DwUserInviteRequestEmail', 'DwUserInviteRequestEmail');
    };
export class UserInviteRequestDetailMetaData implements DwItem2<UserInviteRequestDetailEntity, UserInviteRequestDetailMetaDataAttributes,UserInviteRequestDetailMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2316;
        this.ItemDetail.itemName='UserInviteRequestDetail';
        this.ItemDetail.keyName='UserInviteRequestDetailId';
    }

    CreateEntity(): UserInviteRequestDetailEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UserInviteRequestDetailQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UserInviteRequestDetailEntity, UserInviteRequestDetailMetaDataAttributes,UserInviteRequestDetailMetaDataRelations>(query, this);
    }
     Attributes = new UserInviteRequestDetailMetaDataAttributes();
     Relations = new UserInviteRequestDetailMetaDataRelations();

}


export type UserInviteRequestDetailQueryBuilder = DwQueryBuilderGen<UserInviteRequestDetailEntity, UserInviteRequestDetailMetaDataAttributes,UserInviteRequestDetailMetaDataRelations>


export class UserInviteRequestDetailMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UserInviteRequestDetail';
    // Attributes
    UserInviteRequestDetailId = new DwItemAttribute(this.i, 'UserInviteRequestDetailId');
    UserInviteRequestId = new DwItemAttribute(this.i, 'UserInviteRequestId');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    CanAccessAllLocations = new DwItemAttribute(this.i, 'CanAccessAllLocations');
    FlightSchoolInstructorId = new DwItemAttribute(this.i, 'FlightSchoolInstructorId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
}

class UserInviteRequestDetailMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Examiner */
            FlightSchoolExaminer = new DwItemRelationship('FlightSchoolExaminer|UserInviteRequestDetail|FlightSchoolExaminerId', 'FlightSchoolExaminer', 'FlightSchoolExaminer');
            /** Relation: Flight School Instructor */
            FlightSchoolInstructor = new DwItemRelationship('FlightSchoolInstructor|UserInviteRequestDetail|FlightSchoolInstructorId', 'FlightSchoolInstructor', 'FlightSchoolInstructor');
            /** Relation: Flight School Organization */
            FlightSchoolOrganization = new DwItemRelationship('FlightSchoolOrganization|UserInviteRequestDetail|FlightSchoolOrganizationId', 'FlightSchoolOrganization', 'FlightSchoolOrganization');
            /** Relation: User Invite Request */
            DwUserInviteRequest = new DwItemRelationship('dw_UserInviteRequest|UserInviteRequestDetail|UserInviteRequestId', 'DwUserInviteRequest', 'DwUserInviteRequest');
            /** Relation: User Invite Request School Branch */
            UserInviteRequestSchoolBranch = new DwItemRelationship('UserInviteRequestDetail|UserInviteRequestSchoolBranch|UserInviteRequestDetailId', 'UserInviteRequestSchoolBranch', 'UserInviteRequestSchoolBranch');
    };
export class DwUserInviteRequestEmailMetaData implements DwItem2<DwUserInviteRequestEmailEntity, DwUserInviteRequestEmailMetaDataAttributes,DwUserInviteRequestEmailMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2298;
        this.ItemDetail.itemName='dw_UserInviteRequestEmail';
        this.ItemDetail.keyName='UserInviteRequestEmailId';
    }

    CreateEntity(): DwUserInviteRequestEmailEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwUserInviteRequestEmailQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwUserInviteRequestEmailEntity, DwUserInviteRequestEmailMetaDataAttributes,DwUserInviteRequestEmailMetaDataRelations>(query, this);
    }
     Attributes = new DwUserInviteRequestEmailMetaDataAttributes();
     Relations = new DwUserInviteRequestEmailMetaDataRelations();

}


export type DwUserInviteRequestEmailQueryBuilder = DwQueryBuilderGen<DwUserInviteRequestEmailEntity, DwUserInviteRequestEmailMetaDataAttributes,DwUserInviteRequestEmailMetaDataRelations>


export class DwUserInviteRequestEmailMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_UserInviteRequestEmail';
    // Attributes
    UserInviteRequestEmailId = new DwItemAttribute(this.i, 'UserInviteRequestEmailId');
    UserInviteRequestId = new DwItemAttribute(this.i, 'UserInviteRequestId');
    EmailAddress = new DwItemAttribute(this.i, 'EmailAddress');
    Accepted = new DwItemAttribute(this.i, 'Accepted');
    AcceptedDateTime = new DwItemAttribute(this.i, 'AcceptedDateTime');
    UserId = new DwItemAttribute(this.i, 'UserId');
    LastResendRequestDateTime = new DwItemAttribute(this.i, 'LastResendRequestDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwUserInviteRequestEmailMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User Invite Request */
            DwUserInviteRequest = new DwItemRelationship('dw_UserInviteRequest|dw_UserInviteRequestEmail|UserInviteRequestId', 'DwUserInviteRequest', 'DwUserInviteRequest');
    };
export class UserInviteRequestSchoolBranchMetaData implements DwItem2<UserInviteRequestSchoolBranchEntity, UserInviteRequestSchoolBranchMetaDataAttributes,UserInviteRequestSchoolBranchMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2317;
        this.ItemDetail.itemName='UserInviteRequestSchoolBranch';
        this.ItemDetail.keyName='UserInviteRequestSchoolBranchId';
    }

    CreateEntity(): UserInviteRequestSchoolBranchEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UserInviteRequestSchoolBranchQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UserInviteRequestSchoolBranchEntity, UserInviteRequestSchoolBranchMetaDataAttributes,UserInviteRequestSchoolBranchMetaDataRelations>(query, this);
    }
     Attributes = new UserInviteRequestSchoolBranchMetaDataAttributes();
     Relations = new UserInviteRequestSchoolBranchMetaDataRelations();

}


export type UserInviteRequestSchoolBranchQueryBuilder = DwQueryBuilderGen<UserInviteRequestSchoolBranchEntity, UserInviteRequestSchoolBranchMetaDataAttributes,UserInviteRequestSchoolBranchMetaDataRelations>


export class UserInviteRequestSchoolBranchMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UserInviteRequestSchoolBranch';
    // Attributes
    UserInviteRequestSchoolBranchId = new DwItemAttribute(this.i, 'UserInviteRequestSchoolBranchId');
    FlightSchoolBranchId = new DwItemAttribute(this.i, 'FlightSchoolBranchId');
    UserInviteRequestDetailId = new DwItemAttribute(this.i, 'UserInviteRequestDetailId');
}

class UserInviteRequestSchoolBranchMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Branch */
            FlightSchoolBranch = new DwItemRelationship('FlightSchoolBranch|UserInviteRequestSchoolBranch|FlightSchoolBranchId', 'FlightSchoolBranch', 'FlightSchoolBranch');
            /** Relation: User Invite Request Detail */
            UserInviteRequestDetail = new DwItemRelationship('UserInviteRequestDetail|UserInviteRequestSchoolBranch|UserInviteRequestDetailId', 'UserInviteRequestDetail', 'UserInviteRequestDetail');
    };
export class DwUserInviteRequestStatusMetaData implements DwItem2<DwUserInviteRequestStatusEntity, DwUserInviteRequestStatusMetaDataAttributes,DwUserInviteRequestStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2292;
        this.ItemDetail.itemName='dw_UserInviteRequestStatus';
        this.ItemDetail.keyName='UserInviteRequestStatusId';
    }

    CreateEntity(): DwUserInviteRequestStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwUserInviteRequestStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwUserInviteRequestStatusEntity, DwUserInviteRequestStatusMetaDataAttributes,DwUserInviteRequestStatusMetaDataRelations>(query, this);
    }
     Attributes = new DwUserInviteRequestStatusMetaDataAttributes();
     Relations = new DwUserInviteRequestStatusMetaDataRelations();

}


export type DwUserInviteRequestStatusQueryBuilder = DwQueryBuilderGen<DwUserInviteRequestStatusEntity, DwUserInviteRequestStatusMetaDataAttributes,DwUserInviteRequestStatusMetaDataRelations>


export class DwUserInviteRequestStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_UserInviteRequestStatus';
    // Attributes
    UserInviteRequestStatusId = new DwItemAttribute(this.i, 'UserInviteRequestStatusId');
    UserInviteRequestStatus = new DwItemAttribute(this.i, 'UserInviteRequestStatus');
}

class DwUserInviteRequestStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User Invite Request - Invite Request Status - Many */
            DwUserInviteRequestByInviteRequestStatusId = new DwItemRelationship('dw_UserInviteRequestStatus|dw_UserInviteRequest|InviteRequestStatusId', 'InviteRequestStatusIdDwUserInviteRequest', 'InviteRequestStatusIdDwUserInviteRequest');
    };
export class DwUserInviteRequestTypeMetaData implements DwItem2<DwUserInviteRequestTypeEntity, DwUserInviteRequestTypeMetaDataAttributes,DwUserInviteRequestTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2296;
        this.ItemDetail.itemName='dw_UserInviteRequestType';
        this.ItemDetail.keyName='UserInviteRequestTypeId';
    }

    CreateEntity(): DwUserInviteRequestTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwUserInviteRequestTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwUserInviteRequestTypeEntity, DwUserInviteRequestTypeMetaDataAttributes,DwUserInviteRequestTypeMetaDataRelations>(query, this);
    }
     Attributes = new DwUserInviteRequestTypeMetaDataAttributes();
     Relations = new DwUserInviteRequestTypeMetaDataRelations();

}


export type DwUserInviteRequestTypeQueryBuilder = DwQueryBuilderGen<DwUserInviteRequestTypeEntity, DwUserInviteRequestTypeMetaDataAttributes,DwUserInviteRequestTypeMetaDataRelations>


export class DwUserInviteRequestTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_UserInviteRequestType';
    // Attributes
    UserInviteRequestTypeId = new DwItemAttribute(this.i, 'UserInviteRequestTypeId');
    UserInviteRequestType = new DwItemAttribute(this.i, 'UserInviteRequestType');
    UserTypeId = new DwItemAttribute(this.i, 'UserTypeId');
    Description = new DwItemAttribute(this.i, 'Description');
}

class DwUserInviteRequestTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User Type */
            DwUserType = new DwItemRelationship('dw_UserType|dw_UserInviteRequestType|UserTypeId', 'DwUserType', 'DwUserType');
            /** Relation: Flight School User */
            FlightSchoolUser = new DwItemRelationship('dw_UserInviteRequestType|FlightSchoolUser|UserInviteRequestTypeId', 'FlightSchoolUser', 'FlightSchoolUser');
            /** Relation: User Invite Request - Invite Request Type - Many */
            DwUserInviteRequestByInviteRequestTypeId = new DwItemRelationship('dw_UserInviteRequestType|dw_UserInviteRequest|InviteRequestTypeId', 'InviteRequestTypeIdDwUserInviteRequest', 'InviteRequestTypeIdDwUserInviteRequest');
    };
export class DwUserTypeMetaData implements DwItem2<DwUserTypeEntity, DwUserTypeMetaDataAttributes,DwUserTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=1162;
        this.ItemDetail.itemName='dw_UserType';
        this.ItemDetail.keyName='UserTypeId';
    }

    CreateEntity(): DwUserTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwUserTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwUserTypeEntity, DwUserTypeMetaDataAttributes,DwUserTypeMetaDataRelations>(query, this);
    }
     Attributes = new DwUserTypeMetaDataAttributes();
     Relations = new DwUserTypeMetaDataRelations();

}


export type DwUserTypeQueryBuilder = DwQueryBuilderGen<DwUserTypeEntity, DwUserTypeMetaDataAttributes,DwUserTypeMetaDataRelations>


export class DwUserTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_UserType';
    // Attributes
    UserTypeId = new DwItemAttribute(this.i, 'UserTypeId');
    UserTypeDisplay = new DwItemAttribute(this.i, 'UserTypeDisplay');
    UserTypeDescription = new DwItemAttribute(this.i, 'UserTypeDescription');
    UserTypeClasses = new DwItemAttribute(this.i, 'UserTypeClasses');
    ShowOnRegistration = new DwItemAttribute(this.i, 'ShowOnRegistration');
    UserTypeOrder = new DwItemAttribute(this.i, 'UserTypeOrder');
}

class DwUserTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_UserType|dw_User|UserTypeId', 'DwUser', 'DwUser');
            /** Relation: User Invite Request Type */
            DwUserInviteRequestType = new DwItemRelationship('dw_UserType|dw_UserInviteRequestType|UserTypeId', 'DwUserInviteRequestType', 'DwUserInviteRequestType');
    };
// Generated Query Classes for MetaData Service
export class PilotExaminerSearchQueryMetaData implements DwItem2<PilotExaminerSearchQueryEntity, PilotExaminerSearchQueryMetaDataAttributes,PilotExaminerMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Pilot_Examiner_Search';

    constructor() {
        this.ItemDetail.itemId=1137;
        this.ItemDetail.itemName='PilotExaminer';
        this.ItemDetail.keyName='PilotExaminerId';
    }

    CreateEntity(): PilotExaminerSearchQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): PilotExaminerSearchQueryBuilder {
        return new DwQueryBuilderGen<PilotExaminerSearchQueryEntity, PilotExaminerSearchQueryMetaDataAttributes,PilotExaminerMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<PilotExaminerSearchQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: PilotExaminerSearchQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<PilotExaminerSearchQueryEntity, PilotExaminerSearchQueryMetaDataAttributes,PilotExaminerMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new PilotExaminerSearchQueryMetaDataAttributes();
     Relations = new PilotExaminerMetaDataRelations();

}


export type PilotExaminerSearchQueryBuilder = DwQueryBuilderGen<PilotExaminerSearchQueryEntity, PilotExaminerSearchQueryMetaDataAttributes,PilotExaminerMetaDataRelations>


export class PilotExaminerSearchQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PilotExaminer';
    // Attributes
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    PilotExaminerStatusId = new DwItemAttribute(this.i, 'PilotExaminerStatusId');
    Description = new DwItemAttribute(this.i, 'Description');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    DefaultPreTimeMinutes = new DwItemAttribute(this.i, 'DefaultPreTimeMinutes');
    DefaultPostTimeMinutes = new DwItemAttribute(this.i, 'DefaultPostTimeMinutes');
    TravelRadiusMiles = new DwItemAttribute(this.i, 'TravelRadiusMiles');
    AuthorityExaminerNumber = new DwItemAttribute(this.i, 'AuthorityExaminerNumber');
    CalendarIsLinked = new DwItemAttribute(this.i, 'CalendarIsLinked');
    CalendarReferenceId = new DwItemAttribute(this.i, 'CalendarReferenceId');
    RequireAuthorityPreCheckRideNumber = new DwItemAttribute(this.i, 'RequireAuthorityPreCheckRideNumber');
    PublicProfileIsActive = new DwItemAttribute(this.i, 'PublicProfileIsActive');
    PublicProfileSlug = new DwItemAttribute(this.i, 'PublicProfileSlug');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    CheckRideRequestLeadTimeDays = new DwItemAttribute(this.i, 'CheckRideRequestLeadTimeDays');
    CheckRideRequestBookingMaxWeeksOut = new DwItemAttribute(this.i, 'CheckRideRequestBookingMaxWeeksOut');
    AviationAuthorityDistrictOfficeId = new DwItemAttribute(this.i, 'AviationAuthorityDistrictOfficeId');
    DailyTravelRadiusLockMiles = new DwItemAttribute(this.i, 'DailyTravelRadiusLockMiles');
    PilotExaminerTypeId = new DwItemAttribute(this.i, 'PilotExaminerTypeId');
    AllowAnyFlightSchool = new DwItemAttribute(this.i, 'AllowAnyFlightSchool');
    FlightSchoolScheduleId = new DwItemAttribute(this.i, 'FlightSchoolScheduleId');
    PreventApplicantBooking = new DwItemAttribute(this.i, 'PreventApplicantBooking');
    UseBlockBooking = new DwItemAttribute(this.i, 'UseBlockBooking');
    ScheduleBlockSchoolDefaultOptionId = new DwItemAttribute(this.i, 'ScheduleBlockSchoolDefaultOptionId');
    ScenarioCheckRideScenarioId = new DwItemAttribute('roPilotExaminerScenario', 'ScenarioCheckRideScenarioId');
    ScenarioPreTimeMinutes = new DwItemAttribute('roPilotExaminerScenario', 'ScenarioPreTimeMinutes');
    ScenarioPostTimeMinutes = new DwItemAttribute('roPilotExaminerScenario', 'ScenarioPostTimeMinutes');
    ScenarioIsActive = new DwItemAttribute('roPilotExaminerScenario', 'ScenarioIsActive');
    ScenarioTimeRequiredHours = new DwItemAttribute('roPilotExaminerScenario', 'ScenarioTimeRequiredHours');
    ScenarioCheckRideGroupId = new DwItemAttribute('roPilotExaminerScenario', 'ScenarioCheckRideGroupId');
    ScenarioCheckRideTypeId = new DwItemAttribute('roPilotExaminerScenario', 'ScenarioCheckRideTypeId');
    CheckRideScenarioCheckRideCost = new DwItemAttribute('CheckRideScenario', 'CheckRideScenarioCheckRideCost');
    CheckRideScenarioRetestCost = new DwItemAttribute('CheckRideScenario', 'CheckRideScenarioRetestCost');
    CheckRideScenarioDiscontinuedRetestCost = new DwItemAttribute('CheckRideScenario', 'CheckRideScenarioDiscontinuedRetestCost');
    CheckRideScenarioBookingCost = new DwItemAttribute('CheckRideScenario', 'CheckRideScenarioBookingCost');
    CheckRideScenarioDiscontinuedRetestFlightOnlyCost = new DwItemAttribute('CheckRideScenario', 'CheckRideScenarioDiscontinuedRetestFlightOnlyCost');
    CheckRideScenarioRetestFlightOnlyCost = new DwItemAttribute('CheckRideScenario', 'CheckRideScenarioRetestFlightOnlyCost');
    CheckRideScenarioTravelCost = new DwItemAttribute('CheckRideScenario', 'CheckRideScenarioTravelCost');
    CheckRideScenarioTimeRequiredMinutes = new DwItemAttribute('CheckRideScenario', 'CheckRideScenarioTimeRequiredMinutes');
    CheckRideScenarioRequiredDocumentNotes = new DwItemAttribute('CheckRideScenario', 'CheckRideScenarioRequiredDocumentNotes');
    CheckRideScenarioRetestTimeRequiredMinutes = new DwItemAttribute('CheckRideScenario', 'CheckRideScenarioRetestTimeRequiredMinutes');
    CheckRideScenarioRetestFlightOnlyTimeRequiredMinutes = new DwItemAttribute('CheckRideScenario', 'CheckRideScenarioRetestFlightOnlyTimeRequiredMinutes');
    CheckRideScenarioDiscontinuedTimeRequiredMinutes = new DwItemAttribute('CheckRideScenario', 'CheckRideScenarioDiscontinuedTimeRequiredMinutes');
    CheckRideScenarioDiscontinuedFlightOnlyTimeRequiredMinutes = new DwItemAttribute('CheckRideScenario', 'CheckRideScenarioDiscontinuedFlightOnlyTimeRequiredMinutes');
    LocationDistancesPilotExaminerLocationId = new DwItemAttribute('roPilotExaminerLocationDistances', 'LocationDistancesPilotExaminerLocationId');
    LocationDistancesAirportId = new DwItemAttribute('roPilotExaminerLocationDistances', 'LocationDistancesAirportId');
    LocationDistancesDistance = new DwItemAttribute('roPilotExaminerLocationDistances', 'LocationDistancesDistance');
    LocationDistancesReferenceAirportId = new DwItemAttribute('roPilotExaminerLocationDistances', 'LocationDistancesReferenceAirportId');
    LocationDistancesWithinTravelRadius = new DwItemAttribute('roPilotExaminerLocationDistances', 'LocationDistancesWithinTravelRadius');
    PilotExaminerLocationSchedulingStartDate = new DwItemAttribute('PilotExaminerLocation', 'PilotExaminerLocationSchedulingStartDate');
    PilotExaminerLocationSchedulingEndDate = new DwItemAttribute('PilotExaminerLocation', 'PilotExaminerLocationSchedulingEndDate');
    PilotExaminerLocationTravelRadiusMile = new DwItemAttribute('PilotExaminerLocation', 'PilotExaminerLocationTravelRadiusMile');
    PilotExaminerLocationBookingScheduleId = new DwItemAttribute('PilotExaminerLocation', 'PilotExaminerLocationBookingScheduleId');
    PilotExaminerLocationIsActive = new DwItemAttribute('PilotExaminerLocation', 'PilotExaminerLocationIsActive');
    PilotExaminerLocationTravelCost = new DwItemAttribute('PilotExaminerLocation', 'PilotExaminerLocationTravelCost');
    PilotExaminerLocationAdditionalLocationCost = new DwItemAttribute('PilotExaminerLocation', 'PilotExaminerLocationAdditionalLocationCost');
    PilotExaminerLocationBookingScheduleTimeZoneId = new DwItemAttribute('PilotExaminerLocation', 'PilotExaminerLocationBookingScheduleTimeZoneId');
    PilotExaminerLocationPilotExaminerLocationId = new DwItemAttribute('PilotExaminerLocation', 'PilotExaminerLocationPilotExaminerLocationId');
    PilotExaminerLocationLocationName = new DwItemAttribute('PilotExaminerLocation', 'PilotExaminerLocationLocationName');
    PilotExaminerLocationPilotExaminerLocationTypeId = new DwItemAttribute('PilotExaminerLocation', 'PilotExaminerLocationPilotExaminerLocationTypeId');
    RoPilotExaminerLocationCurrentPilotExaminerLocationStateId = new DwItemAttribute('roPilotExaminerLocationCurrent', 'RoPilotExaminerLocationCurrentPilotExaminerLocationStateId');
    AirportAddressTimezoneId = new DwItemAttribute('Address', 'AirportAddressTimezoneId');
    AirportAddressObservesDst = new DwItemAttribute('Address', 'AirportAddressObservesDst');
    DwUserFirstName = new DwItemAttribute('dw_User', 'DwUserFirstName');
    DwUserLastName = new DwItemAttribute('dw_User', 'DwUserLastName');
    DwUserUserPictureMediaId = new DwItemAttribute('dw_User', 'DwUserUserPictureMediaId');
    DwUserUserBackgroundMediaId = new DwItemAttribute('dw_User', 'DwUserUserBackgroundMediaId');
    DwUserEmail = new DwItemAttribute('dw_User', 'DwUserEmail');
    UserPictureDwroMediaMediaPath = new DwItemAttribute('dw_roMedia', 'UserPictureDwroMediaMediaPath');
    UserPictureDwroMediaImageWidth = new DwItemAttribute('dw_roMedia', 'UserPictureDwroMediaImageWidth');
    UserPictureDwroMediaImageHeight = new DwItemAttribute('dw_roMedia', 'UserPictureDwroMediaImageHeight');
}
export class PilotExaminerCalendarReferenceQueryMetaData implements DwItem2<PilotExaminerCalendarReferenceQueryEntity, PilotExaminerCalendarReferenceQueryMetaDataAttributes,PilotExaminerMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Pilot_Examiner_Calendar_Reference';

    constructor() {
        this.ItemDetail.itemId=1137;
        this.ItemDetail.itemName='PilotExaminer';
        this.ItemDetail.keyName='PilotExaminerId';
    }

    CreateEntity(): PilotExaminerCalendarReferenceQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): PilotExaminerCalendarReferenceQueryBuilder {
        return new DwQueryBuilderGen<PilotExaminerCalendarReferenceQueryEntity, PilotExaminerCalendarReferenceQueryMetaDataAttributes,PilotExaminerMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<PilotExaminerCalendarReferenceQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: PilotExaminerCalendarReferenceQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<PilotExaminerCalendarReferenceQueryEntity, PilotExaminerCalendarReferenceQueryMetaDataAttributes,PilotExaminerMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new PilotExaminerCalendarReferenceQueryMetaDataAttributes();
     Relations = new PilotExaminerMetaDataRelations();

}


export type PilotExaminerCalendarReferenceQueryBuilder = DwQueryBuilderGen<PilotExaminerCalendarReferenceQueryEntity, PilotExaminerCalendarReferenceQueryMetaDataAttributes,PilotExaminerMetaDataRelations>


export class PilotExaminerCalendarReferenceQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PilotExaminer';
    // Attributes
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    PilotExaminerStatusId = new DwItemAttribute(this.i, 'PilotExaminerStatusId');
    CalendarReferenceCalendarReferenceId = new DwItemAttribute('CalendarReference', 'CalendarReferenceCalendarReferenceId');
    CalendarReferenceCalendarReferenceTypeId = new DwItemAttribute('CalendarReference', 'CalendarReferenceCalendarReferenceTypeId');
    CalendarReferenceMainCalendarKey = new DwItemAttribute('CalendarReference', 'CalendarReferenceMainCalendarKey');
    CalendarReferenceCalendarConfigJSON = new DwItemAttribute('CalendarReference', 'CalendarReferenceCalendarConfigJSON');
    DwUserUserId = new DwItemAttribute('dw_User', 'DwUserUserId');
    DwUserUserName = new DwItemAttribute('dw_User', 'DwUserUserName');
    DwUserUserTypeId = new DwItemAttribute('dw_User', 'DwUserUserTypeId');
    DwUserEmail = new DwItemAttribute('dw_User', 'DwUserEmail');
    DwUserFirstName = new DwItemAttribute('dw_User', 'DwUserFirstName');
    DwUserLastName = new DwItemAttribute('dw_User', 'DwUserLastName');
    DwUserLastLoginDateTime = new DwItemAttribute('dw_User', 'DwUserLastLoginDateTime');
}
export class CheckRideRequestCalendarQueryMetaData implements DwItem2<CheckRideRequestCalendarQueryEntity, CheckRideRequestCalendarQueryMetaDataAttributes,CheckRideRequestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Check_Ride_Request-Calendar';

    constructor() {
        this.ItemDetail.itemId=1153;
        this.ItemDetail.itemName='CheckRideRequest';
        this.ItemDetail.keyName='CheckRideRequestId';
    }

    CreateEntity(): CheckRideRequestCalendarQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): CheckRideRequestCalendarQueryBuilder {
        return new DwQueryBuilderGen<CheckRideRequestCalendarQueryEntity, CheckRideRequestCalendarQueryMetaDataAttributes,CheckRideRequestMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<CheckRideRequestCalendarQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: CheckRideRequestCalendarQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<CheckRideRequestCalendarQueryEntity, CheckRideRequestCalendarQueryMetaDataAttributes,CheckRideRequestMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new CheckRideRequestCalendarQueryMetaDataAttributes();
     Relations = new CheckRideRequestMetaDataRelations();

}


export type CheckRideRequestCalendarQueryBuilder = DwQueryBuilderGen<CheckRideRequestCalendarQueryEntity, CheckRideRequestCalendarQueryMetaDataAttributes,CheckRideRequestMetaDataRelations>


export class CheckRideRequestCalendarQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideRequest';
    // Attributes
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    CheckRideTypeId = new DwItemAttribute(this.i, 'CheckRideTypeId');
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    CheckRideTestTypeId = new DwItemAttribute(this.i, 'CheckRideTestTypeId');
    PilotCertificateNumber = new DwItemAttribute(this.i, 'PilotCertificateNumber');
    CheckRideRequestSubStatusId = new DwItemAttribute(this.i, 'CheckRideRequestSubStatusId');
    ScheduledDateTime = new DwItemAttribute(this.i, 'ScheduledDateTime');
    ScheduledTimeMinutes = new DwItemAttribute(this.i, 'ScheduledTimeMinutes');
    ProposedDateTime = new DwItemAttribute(this.i, 'ProposedDateTime');
    ScheduledAirportId = new DwItemAttribute(this.i, 'ScheduledAirportId');
    AuthorityPreapprovalCode = new DwItemAttribute(this.i, 'AuthorityPreapprovalCode');
    AuthorityApprovalCode = new DwItemAttribute(this.i, 'AuthorityApprovalCode');
    ProposedAirportId = new DwItemAttribute(this.i, 'ProposedAirportId');
    ProposedTimeMinutes = new DwItemAttribute(this.i, 'ProposedTimeMinutes');
    AuthorityPreCheckRideNumber = new DwItemAttribute(this.i, 'AuthorityPreCheckRideNumber');
    CheckRideRequestSubStatusCheckRideRequestStatusId = new DwItemAttribute('CheckRideRequestSubStatus', 'CheckRideRequestSubStatusCheckRideRequestStatusId');
    CheckRideResultCheckRideRequestId = new DwItemAttribute('CheckRideResult', 'CheckRideResultCheckRideRequestId');
    CheckRideResultCheckRideDateTime = new DwItemAttribute('CheckRideResult', 'CheckRideResultCheckRideDateTime');
    CheckRideResultCheckRideOutcomeId = new DwItemAttribute('CheckRideResult', 'CheckRideResultCheckRideOutcomeId');
    CheckRideResultAllowRetest = new DwItemAttribute('CheckRideResult', 'CheckRideResultAllowRetest');
    CheckRideResultAllowRetestReason = new DwItemAttribute('CheckRideResult', 'CheckRideResultAllowRetestReason');
    CheckRideResultRetestCost = new DwItemAttribute('CheckRideResult', 'CheckRideResultRetestCost');
    AirportAirportName = new DwItemAttribute('Airport', 'AirportAirportName');
    AirportAirportCode = new DwItemAttribute('Airport', 'AirportAirportCode');
    AirportAddressCity = new DwItemAttribute('Address', 'AirportAddressCity');
    AirportAddressStateProvinceId = new DwItemAttribute('Address', 'AirportAddressStateProvinceId');
    AirportAddressPostalCode = new DwItemAttribute('Address', 'AirportAddressPostalCode');
    AirportAddressCountryId = new DwItemAttribute('Address', 'AirportAddressCountryId');
    AirportAddressLatitude = new DwItemAttribute('Address', 'AirportAddressLatitude');
    AirportAddressLongitude = new DwItemAttribute('Address', 'AirportAddressLongitude');
    AirportAddressTimezoneId = new DwItemAttribute('Address', 'AirportAddressTimezoneId');
    AirportAddressObservesDst = new DwItemAttribute('Address', 'AirportAddressObservesDst');
    ScheduledPilotExaminerUserId = new DwItemAttribute('PilotExaminer', 'ScheduledPilotExaminerUserId');
    CalendarEventReferenceKey = new DwItemAttribute('CalendarEventReference', 'CalendarEventReferenceKey');
    ApplicantNameApplicantFinalEmail = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNameApplicantFinalEmail');
    ApplicantNameApplicantFinalName = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNameApplicantFinalName');
    ApplicantNameApplicantFinalPhone = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNameApplicantFinalPhone');
    ApplicantNameFlightSchoolFinalName = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNameFlightSchoolFinalName');
    ApplicantNameCheckRideApplicantTypeId = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNameCheckRideApplicantTypeId');
    ApplicantNamePilotExaminerFinalName = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNamePilotExaminerFinalName');
    ApplicantNamePilotExaminerFinalEmail = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNamePilotExaminerFinalEmail');
    ApplicantNamePilotExaminerFinalPhone = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNamePilotExaminerFinalPhone');
    ApplicantNameFlightInstructorFinalName = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNameFlightInstructorFinalName');
    ApplicantNameFlightInstructorFinalEmail = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNameFlightInstructorFinalEmail');
    ApplicantNameFlightInstructorFinalPhone = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNameFlightInstructorFinalPhone');
}
export class PilotExaminerCurrentAirportsQueryMetaData implements DwItem2<PilotExaminerCurrentAirportsQueryEntity, PilotExaminerCurrentAirportsQueryMetaDataAttributes,AirportMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Pilot_Examiner_Current_Airports';

    constructor() {
        this.ItemDetail.itemId=1159;
        this.ItemDetail.itemName='Airport';
        this.ItemDetail.keyName='AirportId';
    }

    CreateEntity(): PilotExaminerCurrentAirportsQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): PilotExaminerCurrentAirportsQueryBuilder {
        return new DwQueryBuilderGen<PilotExaminerCurrentAirportsQueryEntity, PilotExaminerCurrentAirportsQueryMetaDataAttributes,AirportMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<PilotExaminerCurrentAirportsQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: PilotExaminerCurrentAirportsQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<PilotExaminerCurrentAirportsQueryEntity, PilotExaminerCurrentAirportsQueryMetaDataAttributes,AirportMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new PilotExaminerCurrentAirportsQueryMetaDataAttributes();
     Relations = new AirportMetaDataRelations();

}


export type PilotExaminerCurrentAirportsQueryBuilder = DwQueryBuilderGen<PilotExaminerCurrentAirportsQueryEntity, PilotExaminerCurrentAirportsQueryMetaDataAttributes,AirportMetaDataRelations>


export class PilotExaminerCurrentAirportsQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Airport';
    // Attributes
    AirportId = new DwItemAttribute(this.i, 'AirportId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    AirportName = new DwItemAttribute(this.i, 'AirportName');
    AirportCode = new DwItemAttribute(this.i, 'AirportCode');
    AirportAddressId = new DwItemAttribute(this.i, 'AirportAddressId');
    Elevation = new DwItemAttribute(this.i, 'Elevation');
    OwnershipCode = new DwItemAttribute(this.i, 'OwnershipCode');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    PilotExaminerLocationPilotExaminerId = new DwItemAttribute('PilotExaminerLocation', 'PilotExaminerLocationPilotExaminerId');
    PilotExaminerLocationShowMetar = new DwItemAttribute('PilotExaminerLocation', 'PilotExaminerLocationShowMetar');
    RoPilotExaminerLocationCurrentPilotExaminerLocationStateId = new DwItemAttribute('roPilotExaminerLocationCurrent', 'RoPilotExaminerLocationCurrentPilotExaminerLocationStateId');
}
export class PilotExaminerPublicProfileQueryMetaData implements DwItem2<PilotExaminerPublicProfileQueryEntity, PilotExaminerPublicProfileQueryMetaDataAttributes,PilotExaminerMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Pilot_Examiner_Public_Profile';

    constructor() {
        this.ItemDetail.itemId=1137;
        this.ItemDetail.itemName='PilotExaminer';
        this.ItemDetail.keyName='PilotExaminerId';
    }

    CreateEntity(): PilotExaminerPublicProfileQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): PilotExaminerPublicProfileQueryBuilder {
        return new DwQueryBuilderGen<PilotExaminerPublicProfileQueryEntity, PilotExaminerPublicProfileQueryMetaDataAttributes,PilotExaminerMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<PilotExaminerPublicProfileQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: PilotExaminerPublicProfileQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<PilotExaminerPublicProfileQueryEntity, PilotExaminerPublicProfileQueryMetaDataAttributes,PilotExaminerMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new PilotExaminerPublicProfileQueryMetaDataAttributes();
     Relations = new PilotExaminerMetaDataRelations();

}


export type PilotExaminerPublicProfileQueryBuilder = DwQueryBuilderGen<PilotExaminerPublicProfileQueryEntity, PilotExaminerPublicProfileQueryMetaDataAttributes,PilotExaminerMetaDataRelations>


export class PilotExaminerPublicProfileQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PilotExaminer';
    // Attributes
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    Description = new DwItemAttribute(this.i, 'Description');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    AuthorityExaminerNumber = new DwItemAttribute(this.i, 'AuthorityExaminerNumber');
    PublicProfileIsActive = new DwItemAttribute(this.i, 'PublicProfileIsActive');
    PublicProfileSlug = new DwItemAttribute(this.i, 'PublicProfileSlug');
    DwUserUserBackgroundMediaId = new DwItemAttribute('dw_User', 'DwUserUserBackgroundMediaId');
    DwUserUserPictureMediaId = new DwItemAttribute('dw_User', 'DwUserUserPictureMediaId');
}
export class StudentApplicantWithDetailQueryMetaData implements DwItem2<StudentApplicantWithDetailQueryEntity, StudentApplicantWithDetailQueryMetaDataAttributes,StudentApplicantMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Student_Applicant_with_detail';

    constructor() {
        this.ItemDetail.itemId=1144;
        this.ItemDetail.itemName='StudentApplicant';
        this.ItemDetail.keyName='StudentApplicantId';
    }

    CreateEntity(): StudentApplicantWithDetailQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): StudentApplicantWithDetailQueryBuilder {
        return new DwQueryBuilderGen<StudentApplicantWithDetailQueryEntity, StudentApplicantWithDetailQueryMetaDataAttributes,StudentApplicantMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<StudentApplicantWithDetailQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: StudentApplicantWithDetailQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<StudentApplicantWithDetailQueryEntity, StudentApplicantWithDetailQueryMetaDataAttributes,StudentApplicantMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new StudentApplicantWithDetailQueryMetaDataAttributes();
     Relations = new StudentApplicantMetaDataRelations();

}


export type StudentApplicantWithDetailQueryBuilder = DwQueryBuilderGen<StudentApplicantWithDetailQueryEntity, StudentApplicantWithDetailQueryMetaDataAttributes,StudentApplicantMetaDataRelations>


export class StudentApplicantWithDetailQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StudentApplicant';
    // Attributes
    StudentApplicantId = new DwItemAttribute(this.i, 'StudentApplicantId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    ApplicationDescription = new DwItemAttribute(this.i, 'ApplicationDescription');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    PilotCertificateNumber = new DwItemAttribute(this.i, 'PilotCertificateNumber');
    TravelRadiusMiles = new DwItemAttribute(this.i, 'TravelRadiusMiles');
    Citizenship = new DwItemAttribute(this.i, 'Citizenship');
    ApplicantAddressId = new DwItemAttribute(this.i, 'ApplicantAddressId');
    MainAirportId = new DwItemAttribute(this.i, 'MainAirportId');
    MainAircraft = new DwItemAttribute(this.i, 'MainAircraft');
    ReferredPilotExaminerId = new DwItemAttribute(this.i, 'ReferredPilotExaminerId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    AviationTrainingProgramId = new DwItemAttribute(this.i, 'AviationTrainingProgramId');
    CitzenshipCountyId = new DwItemAttribute(this.i, 'CitzenshipCountyId');
    DwUserFirstName = new DwItemAttribute('dw_User', 'DwUserFirstName');
    DwUserLastName = new DwItemAttribute('dw_User', 'DwUserLastName');
    DwUserEmail = new DwItemAttribute('dw_User', 'DwUserEmail');
    DwUserUserBackgroundMediaId = new DwItemAttribute('dw_User', 'DwUserUserBackgroundMediaId');
    DwUserUserPictureMediaId = new DwItemAttribute('dw_User', 'DwUserUserPictureMediaId');
    DwUserMobilePhone = new DwItemAttribute('dw_User', 'DwUserMobilePhone');
    ApplicantAddressStreetAddress1 = new DwItemAttribute('Address', 'ApplicantAddressStreetAddress1');
    ApplicantAddressStreetAddress2 = new DwItemAttribute('Address', 'ApplicantAddressStreetAddress2');
    ApplicantAddressCity = new DwItemAttribute('Address', 'ApplicantAddressCity');
    ApplicantAddressStateProvinceId = new DwItemAttribute('Address', 'ApplicantAddressStateProvinceId');
    ApplicantAddressCountryId = new DwItemAttribute('Address', 'ApplicantAddressCountryId');
    ApplicantAddressPostalCode = new DwItemAttribute('Address', 'ApplicantAddressPostalCode');
    ApplicantAddressLatitude = new DwItemAttribute('Address', 'ApplicantAddressLatitude');
    ApplicantAddressLongitude = new DwItemAttribute('Address', 'ApplicantAddressLongitude');
}
export class AirportWithAddressInfoQueryMetaData implements DwItem2<AirportWithAddressInfoQueryEntity, AirportWithAddressInfoQueryMetaDataAttributes,AirportMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Airport_with_Address_info';

    constructor() {
        this.ItemDetail.itemId=1159;
        this.ItemDetail.itemName='Airport';
        this.ItemDetail.keyName='AirportId';
    }

    CreateEntity(): AirportWithAddressInfoQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): AirportWithAddressInfoQueryBuilder {
        return new DwQueryBuilderGen<AirportWithAddressInfoQueryEntity, AirportWithAddressInfoQueryMetaDataAttributes,AirportMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<AirportWithAddressInfoQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: AirportWithAddressInfoQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<AirportWithAddressInfoQueryEntity, AirportWithAddressInfoQueryMetaDataAttributes,AirportMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new AirportWithAddressInfoQueryMetaDataAttributes();
     Relations = new AirportMetaDataRelations();

}


export type AirportWithAddressInfoQueryBuilder = DwQueryBuilderGen<AirportWithAddressInfoQueryEntity, AirportWithAddressInfoQueryMetaDataAttributes,AirportMetaDataRelations>


export class AirportWithAddressInfoQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Airport';
    // Attributes
    AirportId = new DwItemAttribute(this.i, 'AirportId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    AirportName = new DwItemAttribute(this.i, 'AirportName');
    AirportCode = new DwItemAttribute(this.i, 'AirportCode');
    AirportAddressId = new DwItemAttribute(this.i, 'AirportAddressId');
    Elevation = new DwItemAttribute(this.i, 'Elevation');
    OwnershipCode = new DwItemAttribute(this.i, 'OwnershipCode');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    AirportAddressCity = new DwItemAttribute('Address', 'AirportAddressCity');
    AirportAddressStateProvinceId = new DwItemAttribute('Address', 'AirportAddressStateProvinceId');
    AirportAddressPostalCode = new DwItemAttribute('Address', 'AirportAddressPostalCode');
    AirportAddressCountyName = new DwItemAttribute('Address', 'AirportAddressCountyName');
    AirportAddressTimezoneId = new DwItemAttribute('Address', 'AirportAddressTimezoneId');
    AirportAddressObservesDst = new DwItemAttribute('Address', 'AirportAddressObservesDst');
    AirportAddressLatitude = new DwItemAttribute('Address', 'AirportAddressLatitude');
    AirportAddressLongitude = new DwItemAttribute('Address', 'AirportAddressLongitude');
    TimeZoneIANAIdentifier = new DwItemAttribute('TimeZone', 'TimeZoneIANAIdentifier');
    TimeZoneTimezoneShortName = new DwItemAttribute('TimeZone', 'TimeZoneTimezoneShortName');
    TimeZoneTimezoneName = new DwItemAttribute('TimeZone', 'TimeZoneTimezoneName');
    TimeZoneTimezoneId = new DwItemAttribute('TimeZone', 'TimeZoneTimezoneId');
}
export class CheckrideRequestAggregateBaseQueryMetaData implements DwItem2<CheckrideRequestAggregateBaseQueryEntity, CheckrideRequestAggregateBaseQueryMetaDataAttributes,CheckRideRequestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Checkride_Request-Aggregate_Base';

    constructor() {
        this.ItemDetail.itemId=1153;
        this.ItemDetail.itemName='CheckRideRequest';
        this.ItemDetail.keyName='CheckRideRequestId';
    }

    CreateEntity(): CheckrideRequestAggregateBaseQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): CheckrideRequestAggregateBaseQueryBuilder {
        return new DwQueryBuilderGen<CheckrideRequestAggregateBaseQueryEntity, CheckrideRequestAggregateBaseQueryMetaDataAttributes,CheckRideRequestMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<CheckrideRequestAggregateBaseQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: CheckrideRequestAggregateBaseQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<CheckrideRequestAggregateBaseQueryEntity, CheckrideRequestAggregateBaseQueryMetaDataAttributes,CheckRideRequestMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new CheckrideRequestAggregateBaseQueryMetaDataAttributes();
     Relations = new CheckRideRequestMetaDataRelations();

}


export type CheckrideRequestAggregateBaseQueryBuilder = DwQueryBuilderGen<CheckrideRequestAggregateBaseQueryEntity, CheckrideRequestAggregateBaseQueryMetaDataAttributes,CheckRideRequestMetaDataRelations>


export class CheckrideRequestAggregateBaseQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideRequest';
    // Attributes
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    CheckRideTypeId = new DwItemAttribute(this.i, 'CheckRideTypeId');
    CheckRideTestTypeId = new DwItemAttribute(this.i, 'CheckRideTestTypeId');
    CheckRideRequestSubStatusId = new DwItemAttribute(this.i, 'CheckRideRequestSubStatusId');
    CheckRideApplicantTypeId = new DwItemAttribute(this.i, 'CheckRideApplicantTypeId');
    AvaiationTrainingProgramId = new DwItemAttribute(this.i, 'AvaiationTrainingProgramId');
    ScheduledDateTime = new DwItemAttribute(this.i, 'ScheduledDateTime');
    ScheduledAirportId = new DwItemAttribute(this.i, 'ScheduledAirportId');
    ScheduledCheckRideCost = new DwItemAttribute(this.i, 'ScheduledCheckRideCost');
    PilexosBookingCost = new DwItemAttribute(this.i, 'PilexosBookingCost');
    ExaminerBookingCost = new DwItemAttribute(this.i, 'ExaminerBookingCost');
    AdditionalTravelCost = new DwItemAttribute(this.i, 'AdditionalTravelCost');
    ScheduledPilotExaminerId = new DwItemAttribute(this.i, 'ScheduledPilotExaminerId');
    CheckRideCancellationTypeId = new DwItemAttribute(this.i, 'CheckRideCancellationTypeId');
    CheckRideCancellationTypeOther = new DwItemAttribute(this.i, 'CheckRideCancellationTypeOther');
    PilexosBookingCostPaymentPartyId = new DwItemAttribute(this.i, 'PilexosBookingCostPaymentPartyId');
    StudentApplicantCitizenshipCountyId = new DwItemAttribute(this.i, 'StudentApplicantCitizenshipCountyId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolNameOther = new DwItemAttribute(this.i, 'FlightSchoolNameOther');
    FlightSchoolBranchId = new DwItemAttribute(this.i, 'FlightSchoolBranchId');
    FlightSchoolName = new DwItemAttribute(this.i, 'FlightSchoolName');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    FlightSchoolApplicantId = new DwItemAttribute(this.i, 'FlightSchoolApplicantId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    ElectronicFlightBagTypeId = new DwItemAttribute(this.i, 'ElectronicFlightBagTypeId');
    FlightSchoolInstructorId = new DwItemAttribute(this.i, 'FlightSchoolInstructorId');
    AggrScheduledDateTime = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrScheduledDateTime');
    AggrScheduledDateTimeYear = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrScheduledDateTimeYear');
    AggrScheduledDateTimeMonth = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrScheduledDateTimeMonth');
    AggrScheduledDateTimeMonthDisplay = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrScheduledDateTimeMonthDisplay');
    AggrScheduledDateTimeMonthYearDisplay = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrScheduledDateTimeMonthYearDisplay');
    AggrCheckRideRequestStatusId = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrCheckRideRequestStatusId');
    AggrCheckRideRequestStatus = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrCheckRideRequestStatus');
    AggrPilexosPaymentDateTimeYear = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrPilexosPaymentDateTimeYear');
    AggrPilexosPaymentDateTimeMonth = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrPilexosPaymentDateTimeMonth');
    AggrPilexosPaymentTotal = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrPilexosPaymentTotal');
    AggrCheckridePaymentDateTimeYear = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrCheckridePaymentDateTimeYear');
    AggrCheckridePaymentDateTimeMonth = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrCheckridePaymentDateTimeMonth');
    AggrCheckridePaymentTotal = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrCheckridePaymentTotal');
    AggrOutcomeIsRequested = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrOutcomeIsRequested');
    AggrOutcomeIsBooked = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrOutcomeIsBooked');
    AggrOutcomeIsComplete = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrOutcomeIsComplete');
    AggrOutcomeIsCancelled = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrOutcomeIsCancelled');
    AggrRevenueIsRequested = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrRevenueIsRequested');
    AggrRevenueIsBooked = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrRevenueIsBooked');
    AggrRevenueIsComplete = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrRevenueIsComplete');
    AggrRevenueIsCancelled = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrRevenueIsCancelled');
    AggrCheckRideTypeDisplay = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrCheckRideTypeDisplay');
    AggrCheckRideAcceptedDateTime = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrCheckRideAcceptedDateTime');
    AggrCheckRideOutcomeId = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrCheckRideOutcomeId');
    AggrCheckRideOutcome = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrCheckRideOutcome');
    AggrResultIsPassed = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrResultIsPassed');
    AggrResultIsFailed = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrResultIsFailed');
    AggrResultIsDiscontinued = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrResultIsDiscontinued');
    AggrFinalWaitTimeDays = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrFinalWaitTimeDays');
    AggrCurrentWaitTimeDays = new DwItemAttribute('roCheckrideAggregateUtil', 'AggrCurrentWaitTimeDays');
    CheckRideResultCheckRideOutcomeId = new DwItemAttribute('CheckRideResult', 'CheckRideResultCheckRideOutcomeId');
    AirportAirportCode = new DwItemAttribute('Airport', 'AirportAirportCode');
    RoCheckrideApplicantInfoFlightSchoolFinalName = new DwItemAttribute('roCheckrideApplicantFinalName', 'RoCheckrideApplicantInfoFlightSchoolFinalName');
    RoCheckrideApplicantInfoApplicantFinalName = new DwItemAttribute('roCheckrideApplicantFinalName', 'RoCheckrideApplicantInfoApplicantFinalName');
    RoCheckrideApplicantInfoPilotExaminerFinalName = new DwItemAttribute('roCheckrideApplicantFinalName', 'RoCheckrideApplicantInfoPilotExaminerFinalName');
    RoCheckrideApplicantInfoFlightInstructorFinalName = new DwItemAttribute('roCheckrideApplicantFinalName', 'RoCheckrideApplicantInfoFlightInstructorFinalName');
}
export class CheckrideActiveApplicantCheckridesQueryMetaData implements DwItem2<CheckrideActiveApplicantCheckridesQueryEntity, CheckrideActiveApplicantCheckridesQueryMetaDataAttributes,CheckRideRequestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Checkride-Active_Applicant_Checkrides';

    constructor() {
        this.ItemDetail.itemId=1153;
        this.ItemDetail.itemName='CheckRideRequest';
        this.ItemDetail.keyName='CheckRideRequestId';
    }

    CreateEntity(): CheckrideActiveApplicantCheckridesQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): CheckrideActiveApplicantCheckridesQueryBuilder {
        return new DwQueryBuilderGen<CheckrideActiveApplicantCheckridesQueryEntity, CheckrideActiveApplicantCheckridesQueryMetaDataAttributes,CheckRideRequestMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<CheckrideActiveApplicantCheckridesQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: CheckrideActiveApplicantCheckridesQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<CheckrideActiveApplicantCheckridesQueryEntity, CheckrideActiveApplicantCheckridesQueryMetaDataAttributes,CheckRideRequestMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new CheckrideActiveApplicantCheckridesQueryMetaDataAttributes();
     Relations = new CheckRideRequestMetaDataRelations();

}


export type CheckrideActiveApplicantCheckridesQueryBuilder = DwQueryBuilderGen<CheckrideActiveApplicantCheckridesQueryEntity, CheckrideActiveApplicantCheckridesQueryMetaDataAttributes,CheckRideRequestMetaDataRelations>


export class CheckrideActiveApplicantCheckridesQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideRequest';
    // Attributes
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    StudentApplicantId = new DwItemAttribute(this.i, 'StudentApplicantId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    CheckRideRequestSubStatusId = new DwItemAttribute(this.i, 'CheckRideRequestSubStatusId');
    ScheduledDateTime = new DwItemAttribute(this.i, 'ScheduledDateTime');
    CheckRideTypeId = new DwItemAttribute(this.i, 'CheckRideTypeId');
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    AuthorityPreCheckRideNumber = new DwItemAttribute(this.i, 'AuthorityPreCheckRideNumber');
    RoAppCheckRideRequestId = new DwItemAttribute('roCheckRideRequestApplicant', 'RoAppCheckRideRequestId');
    RoAppStudentApplicantNameManual = new DwItemAttribute('roCheckRideRequestApplicant', 'RoAppStudentApplicantNameManual');
    RoAppStudentApplicantEmailManual = new DwItemAttribute('roCheckRideRequestApplicant', 'RoAppStudentApplicantEmailManual');
    RoAppFlightSchoolApplicantId = new DwItemAttribute('roCheckRideRequestApplicant', 'RoAppFlightSchoolApplicantId');
    RoAppStudentApplicantId = new DwItemAttribute('roCheckRideRequestApplicant', 'RoAppStudentApplicantId');
    RoAppStudentApplicantEmail = new DwItemAttribute('roCheckRideRequestApplicant', 'RoAppStudentApplicantEmail');
    RoAppStudentApplicantName = new DwItemAttribute('roCheckRideRequestApplicant', 'RoAppStudentApplicantName');
    RoAppFlightSchoolApplicantEmail = new DwItemAttribute('roCheckRideRequestApplicant', 'RoAppFlightSchoolApplicantEmail');
    RoAppFlightSchoolApplicantName = new DwItemAttribute('roCheckRideRequestApplicant', 'RoAppFlightSchoolApplicantName');
}
export class AcsCodesLookupQueryMetaData implements DwItem2<AcsCodesLookupQueryEntity, AcsCodesLookupQueryMetaDataAttributes,AcsCodeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Acs_Codes-Lookup';

    constructor() {
        this.ItemDetail.itemId=1201;
        this.ItemDetail.itemName='AcsCode';
        this.ItemDetail.keyName='AcsCodeId';
    }

    CreateEntity(): AcsCodesLookupQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): AcsCodesLookupQueryBuilder {
        return new DwQueryBuilderGen<AcsCodesLookupQueryEntity, AcsCodesLookupQueryMetaDataAttributes,AcsCodeMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<AcsCodesLookupQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: AcsCodesLookupQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<AcsCodesLookupQueryEntity, AcsCodesLookupQueryMetaDataAttributes,AcsCodeMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new AcsCodesLookupQueryMetaDataAttributes();
     Relations = new AcsCodeMetaDataRelations();

}


export type AcsCodesLookupQueryBuilder = DwQueryBuilderGen<AcsCodesLookupQueryEntity, AcsCodesLookupQueryMetaDataAttributes,AcsCodeMetaDataRelations>


export class AcsCodesLookupQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsCode';
    // Attributes
    AcsCodeId = new DwItemAttribute(this.i, 'AcsCodeId');
    AscCodeTypeId = new DwItemAttribute(this.i, 'AscCodeTypeId');
    AcsCode = new DwItemAttribute(this.i, 'AcsCode');
    AcsCodeOrder = new DwItemAttribute(this.i, 'AcsCodeOrder');
    AcsAreaOfOperationTaskId = new DwItemAttribute(this.i, 'AcsAreaOfOperationTaskId');
    AscCodeDescription = new DwItemAttribute(this.i, 'AscCodeDescription');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    TaskTaskName = new DwItemAttribute('AcsAreaOfOperationTask', 'TaskTaskName');
    TaskTaskOrder = new DwItemAttribute('AcsAreaOfOperationTask', 'TaskTaskOrder');
    TaskTaskCode = new DwItemAttribute('AcsAreaOfOperationTask', 'TaskTaskCode');
    TaskAcsAreaOfOperationTaskId = new DwItemAttribute('AcsAreaOfOperationTask', 'TaskAcsAreaOfOperationTaskId');
    AcsAreaOfOperationAcsAreaOfOperationId = new DwItemAttribute('AcsAreaOfOperation', 'AcsAreaOfOperationAcsAreaOfOperationId');
    AcsAreaOfOperationAreaOfOperationName = new DwItemAttribute('AcsAreaOfOperation', 'AcsAreaOfOperationAreaOfOperationName');
    AcsAreaOfOperationAreaOfOperationOrder = new DwItemAttribute('AcsAreaOfOperation', 'AcsAreaOfOperationAreaOfOperationOrder');
    AcsAreaOfOperationAreaOfOperationCode = new DwItemAttribute('AcsAreaOfOperation', 'AcsAreaOfOperationAreaOfOperationCode');
    AcsTestTestName = new DwItemAttribute('AcsTest', 'AcsTestTestName');
    AcsTestTestDescription = new DwItemAttribute('AcsTest', 'AcsTestTestDescription');
    AcsTestCheckRideGroupId = new DwItemAttribute('AcsTest', 'AcsTestCheckRideGroupId');
    AcsTestTestCode = new DwItemAttribute('AcsTest', 'AcsTestTestCode');
    AcsTestAcsTestId = new DwItemAttribute('AcsTest', 'AcsTestAcsTestId');
    AcsTestAcsTestStatusId = new DwItemAttribute('AcsTest', 'AcsTestAcsTestStatusId');
}
export class AcsCodesGridQueryMetaData implements DwItem2<AcsCodesGridQueryEntity, AcsCodesGridQueryMetaDataAttributes,AcsCodeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Acs_Codes-Grid';

    constructor() {
        this.ItemDetail.itemId=1201;
        this.ItemDetail.itemName='AcsCode';
        this.ItemDetail.keyName='AcsCodeId';
    }

    CreateEntity(): AcsCodesGridQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): AcsCodesGridQueryBuilder {
        return new DwQueryBuilderGen<AcsCodesGridQueryEntity, AcsCodesGridQueryMetaDataAttributes,AcsCodeMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<AcsCodesGridQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: AcsCodesGridQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<AcsCodesGridQueryEntity, AcsCodesGridQueryMetaDataAttributes,AcsCodeMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new AcsCodesGridQueryMetaDataAttributes();
     Relations = new AcsCodeMetaDataRelations();

}


export type AcsCodesGridQueryBuilder = DwQueryBuilderGen<AcsCodesGridQueryEntity, AcsCodesGridQueryMetaDataAttributes,AcsCodeMetaDataRelations>


export class AcsCodesGridQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsCode';
    // Attributes
    AcsCodeId = new DwItemAttribute(this.i, 'AcsCodeId');
    AscCodeTypeId = new DwItemAttribute(this.i, 'AscCodeTypeId');
    AcsCode = new DwItemAttribute(this.i, 'AcsCode');
    AcsCodeOrder = new DwItemAttribute(this.i, 'AcsCodeOrder');
    AcsAreaOfOperationTaskId = new DwItemAttribute(this.i, 'AcsAreaOfOperationTaskId');
    AscCodeDescription = new DwItemAttribute(this.i, 'AscCodeDescription');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    TaskTaskName = new DwItemAttribute('AcsAreaOfOperationTask', 'TaskTaskName');
    TaskTaskOrder = new DwItemAttribute('AcsAreaOfOperationTask', 'TaskTaskOrder');
    TaskTaskCode = new DwItemAttribute('AcsAreaOfOperationTask', 'TaskTaskCode');
    TaskAcsAreaOfOperationId = new DwItemAttribute('AcsAreaOfOperationTask', 'TaskAcsAreaOfOperationId');
    AcsAreaOfOperationAreaOfOperationName = new DwItemAttribute('AcsAreaOfOperation', 'AcsAreaOfOperationAreaOfOperationName');
    AcsAreaOfOperationAreaOfOperationOrder = new DwItemAttribute('AcsAreaOfOperation', 'AcsAreaOfOperationAreaOfOperationOrder');
    AcsAreaOfOperationAreaOfOperationCode = new DwItemAttribute('AcsAreaOfOperation', 'AcsAreaOfOperationAreaOfOperationCode');
    AcsAreaOfOperationAcsTestId = new DwItemAttribute('AcsAreaOfOperation', 'AcsAreaOfOperationAcsTestId');
    AcsTestTestName = new DwItemAttribute('AcsTest', 'AcsTestTestName');
    AcsTestTestDescription = new DwItemAttribute('AcsTest', 'AcsTestTestDescription');
    AcsTestCheckRideGroupId = new DwItemAttribute('AcsTest', 'AcsTestCheckRideGroupId');
    AcsTestTestCode = new DwItemAttribute('AcsTest', 'AcsTestTestCode');
}
export class AcsCodesWithQuestionsQueryMetaData implements DwItem2<AcsCodesWithQuestionsQueryEntity, AcsCodesWithQuestionsQueryMetaDataAttributes,AcsCodeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Acs_Codes_With_Questions';

    constructor() {
        this.ItemDetail.itemId=1201;
        this.ItemDetail.itemName='AcsCode';
        this.ItemDetail.keyName='AcsCodeId';
    }

    CreateEntity(): AcsCodesWithQuestionsQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): AcsCodesWithQuestionsQueryBuilder {
        return new DwQueryBuilderGen<AcsCodesWithQuestionsQueryEntity, AcsCodesWithQuestionsQueryMetaDataAttributes,AcsCodeMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<AcsCodesWithQuestionsQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: AcsCodesWithQuestionsQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<AcsCodesWithQuestionsQueryEntity, AcsCodesWithQuestionsQueryMetaDataAttributes,AcsCodeMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new AcsCodesWithQuestionsQueryMetaDataAttributes();
     Relations = new AcsCodeMetaDataRelations();

}


export type AcsCodesWithQuestionsQueryBuilder = DwQueryBuilderGen<AcsCodesWithQuestionsQueryEntity, AcsCodesWithQuestionsQueryMetaDataAttributes,AcsCodeMetaDataRelations>


export class AcsCodesWithQuestionsQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsCode';
    // Attributes
    AcsCodeId = new DwItemAttribute(this.i, 'AcsCodeId');
    AscCodeTypeId = new DwItemAttribute(this.i, 'AscCodeTypeId');
    AcsCode = new DwItemAttribute(this.i, 'AcsCode');
    AcsCodeOrder = new DwItemAttribute(this.i, 'AcsCodeOrder');
    AcsAreaOfOperationTaskId = new DwItemAttribute(this.i, 'AcsAreaOfOperationTaskId');
    AscCodeDescription = new DwItemAttribute(this.i, 'AscCodeDescription');
    AcsAreaOfOperationTaskAcsAreaOfOperationTaskId = new DwItemAttribute('AcsAreaOfOperationTask', 'AcsAreaOfOperationTaskAcsAreaOfOperationTaskId');
    AcsAreaOfOperationTaskAcsAreaOfOperationId = new DwItemAttribute('AcsAreaOfOperationTask', 'AcsAreaOfOperationTaskAcsAreaOfOperationId');
    AcsAreaOfOperationTaskTaskName = new DwItemAttribute('AcsAreaOfOperationTask', 'AcsAreaOfOperationTaskTaskName');
    AcsAreaOfOperationTaskTaskOrder = new DwItemAttribute('AcsAreaOfOperationTask', 'AcsAreaOfOperationTaskTaskOrder');
    AcsAreaOfOperationTaskTaskCode = new DwItemAttribute('AcsAreaOfOperationTask', 'AcsAreaOfOperationTaskTaskCode');
    AcsAreaOfOperationAcsTestId = new DwItemAttribute('AcsAreaOfOperation', 'AcsAreaOfOperationAcsTestId');
    AcsAreaOfOperationAreaOfOperationName = new DwItemAttribute('AcsAreaOfOperation', 'AcsAreaOfOperationAreaOfOperationName');
    AcsAreaOfOperationAreaOfOperationOrder = new DwItemAttribute('AcsAreaOfOperation', 'AcsAreaOfOperationAreaOfOperationOrder');
    AcsAreaOfOperationAreaOfOperationCode = new DwItemAttribute('AcsAreaOfOperation', 'AcsAreaOfOperationAreaOfOperationCode');
    AcsAreaOfOperationAcsAreaOfOperationId = new DwItemAttribute('AcsAreaOfOperation', 'AcsAreaOfOperationAcsAreaOfOperationId');
    QuestionBankQuestionBankId = new DwItemAttribute('QuestionBank', 'QuestionBankQuestionBankId');
    QuestionBankIsBuiltIn = new DwItemAttribute('QuestionBank', 'QuestionBankIsBuiltIn');
    QuestionBankIsShared = new DwItemAttribute('QuestionBank', 'QuestionBankIsShared');
    QuestionBankOwnerUserId = new DwItemAttribute('QuestionBank', 'QuestionBankOwnerUserId');
    QuestionBankAcsTestId = new DwItemAttribute('QuestionBank', 'QuestionBankAcsTestId');
    QuestionBankAcsCodeId = new DwItemAttribute('QuestionBank', 'QuestionBankAcsCodeId');
    QuestionBankQuestionHtml = new DwItemAttribute('QuestionBank', 'QuestionBankQuestionHtml');
    QuestionBankQuestionShortName = new DwItemAttribute('QuestionBank', 'QuestionBankQuestionShortName');
}
export class CheckrideGroupACSTestQueryMetaData implements DwItem2<CheckrideGroupACSTestQueryEntity, CheckrideGroupACSTestQueryMetaDataAttributes,CheckRideGroupMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Checkride_Group_ACS_Test';

    constructor() {
        this.ItemDetail.itemId=1134;
        this.ItemDetail.itemName='CheckRideGroup';
        this.ItemDetail.keyName='CheckRideGroupId';
    }

    CreateEntity(): CheckrideGroupACSTestQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): CheckrideGroupACSTestQueryBuilder {
        return new DwQueryBuilderGen<CheckrideGroupACSTestQueryEntity, CheckrideGroupACSTestQueryMetaDataAttributes,CheckRideGroupMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<CheckrideGroupACSTestQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: CheckrideGroupACSTestQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<CheckrideGroupACSTestQueryEntity, CheckrideGroupACSTestQueryMetaDataAttributes,CheckRideGroupMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new CheckrideGroupACSTestQueryMetaDataAttributes();
     Relations = new CheckRideGroupMetaDataRelations();

}


export type CheckrideGroupACSTestQueryBuilder = DwQueryBuilderGen<CheckrideGroupACSTestQueryEntity, CheckrideGroupACSTestQueryMetaDataAttributes,CheckRideGroupMetaDataRelations>


export class CheckrideGroupACSTestQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideGroup';
    // Attributes
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    CheckRideGroup = new DwItemAttribute(this.i, 'CheckRideGroup');
    GroupOrder = new DwItemAttribute(this.i, 'GroupOrder');
    AcsTestAcsTestId = new DwItemAttribute('AcsTest', 'AcsTestAcsTestId');
    AcsTestAcsTestStatusId = new DwItemAttribute('AcsTest', 'AcsTestAcsTestStatusId');
    AcsTestCheckRideGroupId = new DwItemAttribute('AcsTest', 'AcsTestCheckRideGroupId');
    AcsTestTestCode = new DwItemAttribute('AcsTest', 'AcsTestTestCode');
    AcsTestTestDescription = new DwItemAttribute('AcsTest', 'AcsTestTestDescription');
    AcsTestTestExpirationDate = new DwItemAttribute('AcsTest', 'AcsTestTestExpirationDate');
    AcsTestTestName = new DwItemAttribute('AcsTest', 'AcsTestTestName');
}
export class PlanOfActionDetailsQueryMetaData implements DwItem2<PlanOfActionDetailsQueryEntity, PlanOfActionDetailsQueryMetaDataAttributes,RoPlanOfActionDetailsMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Plan_of_Action_Details';

    constructor() {
        this.ItemDetail.itemId=1230;
        this.ItemDetail.itemName='roPlanOfActionDetails';
        this.ItemDetail.keyName='PlanOfActionId';
    }

    CreateEntity(): PlanOfActionDetailsQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): PlanOfActionDetailsQueryBuilder {
        return new DwQueryBuilderGen<PlanOfActionDetailsQueryEntity, PlanOfActionDetailsQueryMetaDataAttributes,RoPlanOfActionDetailsMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<PlanOfActionDetailsQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: PlanOfActionDetailsQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<PlanOfActionDetailsQueryEntity, PlanOfActionDetailsQueryMetaDataAttributes,RoPlanOfActionDetailsMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new PlanOfActionDetailsQueryMetaDataAttributes();
     Relations = new RoPlanOfActionDetailsMetaDataRelations();

}


export type PlanOfActionDetailsQueryBuilder = DwQueryBuilderGen<PlanOfActionDetailsQueryEntity, PlanOfActionDetailsQueryMetaDataAttributes,RoPlanOfActionDetailsMetaDataRelations>


export class PlanOfActionDetailsQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roPlanOfActionDetails';
    // Attributes
    PlanOfActionId = new DwItemAttribute(this.i, 'PlanOfActionId');
    PlanOfActionName = new DwItemAttribute(this.i, 'PlanOfActionName');
    ApplicantFinalName = new DwItemAttribute(this.i, 'ApplicantFinalName');
    ApplicantFinalEmail = new DwItemAttribute(this.i, 'ApplicantFinalEmail');
    ApplicationFinalPhone = new DwItemAttribute(this.i, 'ApplicationFinalPhone');
    CheckRideFinalDateTime = new DwItemAttribute(this.i, 'CheckRideFinalDateTime');
    CheckRideFinalAirportId = new DwItemAttribute(this.i, 'CheckRideFinalAirportId');
    CheckRideFinalGroupId = new DwItemAttribute(this.i, 'CheckRideFinalGroupId');
    CheckRideFInalTypeId = new DwItemAttribute(this.i, 'CheckRideFInalTypeId');
    CheckRideFinalTestTypeId = new DwItemAttribute(this.i, 'CheckRideFinalTestTypeId');
    CheckRideFinalDurationMinutes = new DwItemAttribute(this.i, 'CheckRideFinalDurationMinutes');
    CheckRideFinalEndDateTime = new DwItemAttribute(this.i, 'CheckRideFinalEndDateTime');
    FlightInstructorFinalId = new DwItemAttribute(this.i, 'FlightInstructorFinalId');
    FlightSchoolApplicantId = new DwItemAttribute(this.i, 'FlightSchoolApplicantId');
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    PlanOfActionAcsTestId = new DwItemAttribute('PlanOfAction', 'PlanOfActionAcsTestId');
    PlanOfActionCheckRideOwnershipTypeId = new DwItemAttribute('PlanOfAction', 'PlanOfActionCheckRideOwnershipTypeId');
}
export class FlightSchoolApplicantAwaitingCheckridesQueryMetaData implements DwItem2<FlightSchoolApplicantAwaitingCheckridesQueryEntity, FlightSchoolApplicantAwaitingCheckridesQueryMetaDataAttributes,FlightSchoolApplicantMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Flight_School_Applicant-Awaiting_Checkrides';

    constructor() {
        this.ItemDetail.itemId=1258;
        this.ItemDetail.itemName='FlightSchoolApplicant';
        this.ItemDetail.keyName='FlightSchoolApplicantId';
    }

    CreateEntity(): FlightSchoolApplicantAwaitingCheckridesQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): FlightSchoolApplicantAwaitingCheckridesQueryBuilder {
        return new DwQueryBuilderGen<FlightSchoolApplicantAwaitingCheckridesQueryEntity, FlightSchoolApplicantAwaitingCheckridesQueryMetaDataAttributes,FlightSchoolApplicantMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<FlightSchoolApplicantAwaitingCheckridesQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: FlightSchoolApplicantAwaitingCheckridesQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<FlightSchoolApplicantAwaitingCheckridesQueryEntity, FlightSchoolApplicantAwaitingCheckridesQueryMetaDataAttributes,FlightSchoolApplicantMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new FlightSchoolApplicantAwaitingCheckridesQueryMetaDataAttributes();
     Relations = new FlightSchoolApplicantMetaDataRelations();

}


export type FlightSchoolApplicantAwaitingCheckridesQueryBuilder = DwQueryBuilderGen<FlightSchoolApplicantAwaitingCheckridesQueryEntity, FlightSchoolApplicantAwaitingCheckridesQueryMetaDataAttributes,FlightSchoolApplicantMetaDataRelations>


export class FlightSchoolApplicantAwaitingCheckridesQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolApplicant';
    // Attributes
    FlightSchoolApplicantId = new DwItemAttribute(this.i, 'FlightSchoolApplicantId');
    ApplicantName = new DwItemAttribute(this.i, 'ApplicantName');
    FlightSchoolApplicantStatusId = new DwItemAttribute(this.i, 'FlightSchoolApplicantStatusId');
    FlightSchoolBranchId = new DwItemAttribute(this.i, 'FlightSchoolBranchId');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    CheckRideTypeId = new DwItemAttribute(this.i, 'CheckRideTypeId');
    ExpectedCheckrideDateTime = new DwItemAttribute(this.i, 'ExpectedCheckrideDateTime');
    CheckRideTestTypeId = new DwItemAttribute(this.i, 'CheckRideTestTypeId');
}
export class FlightSchoolAirportsQueryMetaData implements DwItem2<FlightSchoolAirportsQueryEntity, FlightSchoolAirportsQueryMetaDataAttributes,AirportMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Flight_School_Airports';

    constructor() {
        this.ItemDetail.itemId=1159;
        this.ItemDetail.itemName='Airport';
        this.ItemDetail.keyName='AirportId';
    }

    CreateEntity(): FlightSchoolAirportsQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): FlightSchoolAirportsQueryBuilder {
        return new DwQueryBuilderGen<FlightSchoolAirportsQueryEntity, FlightSchoolAirportsQueryMetaDataAttributes,AirportMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<FlightSchoolAirportsQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: FlightSchoolAirportsQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<FlightSchoolAirportsQueryEntity, FlightSchoolAirportsQueryMetaDataAttributes,AirportMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new FlightSchoolAirportsQueryMetaDataAttributes();
     Relations = new AirportMetaDataRelations();

}


export type FlightSchoolAirportsQueryBuilder = DwQueryBuilderGen<FlightSchoolAirportsQueryEntity, FlightSchoolAirportsQueryMetaDataAttributes,AirportMetaDataRelations>


export class FlightSchoolAirportsQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Airport';
    // Attributes
    AirportId = new DwItemAttribute(this.i, 'AirportId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    AirportName = new DwItemAttribute(this.i, 'AirportName');
    AirportCode = new DwItemAttribute(this.i, 'AirportCode');
    AirportAddressId = new DwItemAttribute(this.i, 'AirportAddressId');
    Elevation = new DwItemAttribute(this.i, 'Elevation');
    OwnershipCode = new DwItemAttribute(this.i, 'OwnershipCode');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    MainFlightSchoolBranchFlightSchoolBranchId = new DwItemAttribute('FlightSchoolBranch', 'MainFlightSchoolBranchFlightSchoolBranchId');
    MainFlightSchoolBranchBranchName = new DwItemAttribute('FlightSchoolBranch', 'MainFlightSchoolBranchBranchName');
    MainFlightSchoolBranchFlightSchoolBranchStatusId = new DwItemAttribute('FlightSchoolBranch', 'MainFlightSchoolBranchFlightSchoolBranchStatusId');
    MainFlightSchoolBranchFlightSchoolOrganizationId = new DwItemAttribute('FlightSchoolBranch', 'MainFlightSchoolBranchFlightSchoolOrganizationId');
    MainFlightSchoolBranchIsDefaultBranch = new DwItemAttribute('FlightSchoolBranch', 'MainFlightSchoolBranchIsDefaultBranch');
    MainFlightSchoolBranchShowMetar = new DwItemAttribute('FlightSchoolBranch', 'MainFlightSchoolBranchShowMetar');
}
export class CheckrideRequestSchoolCalendarQueryMetaData implements DwItem2<CheckrideRequestSchoolCalendarQueryEntity, CheckrideRequestSchoolCalendarQueryMetaDataAttributes,CheckRideRequestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Checkride_Request_School-Calendar';

    constructor() {
        this.ItemDetail.itemId=1153;
        this.ItemDetail.itemName='CheckRideRequest';
        this.ItemDetail.keyName='CheckRideRequestId';
    }

    CreateEntity(): CheckrideRequestSchoolCalendarQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): CheckrideRequestSchoolCalendarQueryBuilder {
        return new DwQueryBuilderGen<CheckrideRequestSchoolCalendarQueryEntity, CheckrideRequestSchoolCalendarQueryMetaDataAttributes,CheckRideRequestMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<CheckrideRequestSchoolCalendarQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: CheckrideRequestSchoolCalendarQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<CheckrideRequestSchoolCalendarQueryEntity, CheckrideRequestSchoolCalendarQueryMetaDataAttributes,CheckRideRequestMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new CheckrideRequestSchoolCalendarQueryMetaDataAttributes();
     Relations = new CheckRideRequestMetaDataRelations();

}


export type CheckrideRequestSchoolCalendarQueryBuilder = DwQueryBuilderGen<CheckrideRequestSchoolCalendarQueryEntity, CheckrideRequestSchoolCalendarQueryMetaDataAttributes,CheckRideRequestMetaDataRelations>


export class CheckrideRequestSchoolCalendarQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideRequest';
    // Attributes
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    CheckRideTypeId = new DwItemAttribute(this.i, 'CheckRideTypeId');
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    CheckRideTestTypeId = new DwItemAttribute(this.i, 'CheckRideTestTypeId');
    PilotCertificateNumber = new DwItemAttribute(this.i, 'PilotCertificateNumber');
    CheckRideRequestSubStatusId = new DwItemAttribute(this.i, 'CheckRideRequestSubStatusId');
    ScheduledDateTime = new DwItemAttribute(this.i, 'ScheduledDateTime');
    ScheduledTimeMinutes = new DwItemAttribute(this.i, 'ScheduledTimeMinutes');
    ProposedDateTime = new DwItemAttribute(this.i, 'ProposedDateTime');
    ScheduledAirportId = new DwItemAttribute(this.i, 'ScheduledAirportId');
    AuthorityPreapprovalCode = new DwItemAttribute(this.i, 'AuthorityPreapprovalCode');
    AuthorityApprovalCode = new DwItemAttribute(this.i, 'AuthorityApprovalCode');
    ProposedAirportId = new DwItemAttribute(this.i, 'ProposedAirportId');
    ProposedTimeMinutes = new DwItemAttribute(this.i, 'ProposedTimeMinutes');
    AuthorityPreCheckRideNumber = new DwItemAttribute(this.i, 'AuthorityPreCheckRideNumber');
    CheckRideRequestSubStatusCheckRideRequestStatusId = new DwItemAttribute('CheckRideRequestSubStatus', 'CheckRideRequestSubStatusCheckRideRequestStatusId');
    CheckRideResultCheckRideRequestId = new DwItemAttribute('CheckRideResult', 'CheckRideResultCheckRideRequestId');
    CheckRideResultCheckRideDateTime = new DwItemAttribute('CheckRideResult', 'CheckRideResultCheckRideDateTime');
    CheckRideResultCheckRideOutcomeId = new DwItemAttribute('CheckRideResult', 'CheckRideResultCheckRideOutcomeId');
    CheckRideResultAllowRetest = new DwItemAttribute('CheckRideResult', 'CheckRideResultAllowRetest');
    CheckRideResultAllowRetestReason = new DwItemAttribute('CheckRideResult', 'CheckRideResultAllowRetestReason');
    CheckRideResultRetestCost = new DwItemAttribute('CheckRideResult', 'CheckRideResultRetestCost');
    AirportAirportName = new DwItemAttribute('Airport', 'AirportAirportName');
    AirportAirportCode = new DwItemAttribute('Airport', 'AirportAirportCode');
    AirportAddressCity = new DwItemAttribute('Address', 'AirportAddressCity');
    AirportAddressStateProvinceId = new DwItemAttribute('Address', 'AirportAddressStateProvinceId');
    AirportAddressPostalCode = new DwItemAttribute('Address', 'AirportAddressPostalCode');
    AirportAddressCountryId = new DwItemAttribute('Address', 'AirportAddressCountryId');
    AirportAddressLatitude = new DwItemAttribute('Address', 'AirportAddressLatitude');
    AirportAddressLongitude = new DwItemAttribute('Address', 'AirportAddressLongitude');
    AirportAddressTimezoneId = new DwItemAttribute('Address', 'AirportAddressTimezoneId');
    AirportAddressObservesDst = new DwItemAttribute('Address', 'AirportAddressObservesDst');
    ScheduledPilotExaminerUserId = new DwItemAttribute('PilotExaminer', 'ScheduledPilotExaminerUserId');
    CalendarEventReferenceKey = new DwItemAttribute('CalendarEventReference', 'CalendarEventReferenceKey');
    ApplicantNameApplicantFinalEmail = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNameApplicantFinalEmail');
    ApplicantNameApplicantFinalName = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNameApplicantFinalName');
    ApplicantNameApplicantFinalPhone = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNameApplicantFinalPhone');
    ApplicantNameFlightSchoolFinalName = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNameFlightSchoolFinalName');
    ApplicantNameCheckRideApplicantTypeId = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNameCheckRideApplicantTypeId');
    ApplicantNamePilotExaminerFinalName = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNamePilotExaminerFinalName');
    ApplicantNamePilotExaminerFinalEmail = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNamePilotExaminerFinalEmail');
    ApplicantNamePilotExaminerFinalPhone = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNamePilotExaminerFinalPhone');
    ApplicantNameFlightInstructorFinalName = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNameFlightInstructorFinalName');
    ApplicantNameFlightInstructorFinalEmail = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNameFlightInstructorFinalEmail');
    ApplicantNameFlightInstructorFinalPhone = new DwItemAttribute('roCheckrideApplicantFinalName', 'ApplicantNameFlightInstructorFinalPhone');
}
export class FlightSchoolExaminerWithExaminerDetailsQueryMetaData implements DwItem2<FlightSchoolExaminerWithExaminerDetailsQueryEntity, FlightSchoolExaminerWithExaminerDetailsQueryMetaDataAttributes,FlightSchoolExaminerMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Flight_School_Examiner-With_Examiner_Details';

    constructor() {
        this.ItemDetail.itemId=1263;
        this.ItemDetail.itemName='FlightSchoolExaminer';
        this.ItemDetail.keyName='FlightSchoolExaminerId';
    }

    CreateEntity(): FlightSchoolExaminerWithExaminerDetailsQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): FlightSchoolExaminerWithExaminerDetailsQueryBuilder {
        return new DwQueryBuilderGen<FlightSchoolExaminerWithExaminerDetailsQueryEntity, FlightSchoolExaminerWithExaminerDetailsQueryMetaDataAttributes,FlightSchoolExaminerMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<FlightSchoolExaminerWithExaminerDetailsQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: FlightSchoolExaminerWithExaminerDetailsQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<FlightSchoolExaminerWithExaminerDetailsQueryEntity, FlightSchoolExaminerWithExaminerDetailsQueryMetaDataAttributes,FlightSchoolExaminerMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new FlightSchoolExaminerWithExaminerDetailsQueryMetaDataAttributes();
     Relations = new FlightSchoolExaminerMetaDataRelations();

}


export type FlightSchoolExaminerWithExaminerDetailsQueryBuilder = DwQueryBuilderGen<FlightSchoolExaminerWithExaminerDetailsQueryEntity, FlightSchoolExaminerWithExaminerDetailsQueryMetaDataAttributes,FlightSchoolExaminerMetaDataRelations>


export class FlightSchoolExaminerWithExaminerDetailsQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolExaminer';
    // Attributes
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    ExaminerName = new DwItemAttribute(this.i, 'ExaminerName');
    ExaminerEmail = new DwItemAttribute(this.i, 'ExaminerEmail');
    ExaminerPhone = new DwItemAttribute(this.i, 'ExaminerPhone');
    FlightSchoolExaminerStatusId = new DwItemAttribute(this.i, 'FlightSchoolExaminerStatusId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    FlightSchoolExaminerTypeId = new DwItemAttribute(this.i, 'FlightSchoolExaminerTypeId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    LastInviteSendDateTime = new DwItemAttribute(this.i, 'LastInviteSendDateTime');
    SendInviteEmail = new DwItemAttribute(this.i, 'SendInviteEmail');
    SendCheckrideEmails = new DwItemAttribute(this.i, 'SendCheckrideEmails');
    UseExaminerBlockBooking = new DwItemAttribute(this.i, 'UseExaminerBlockBooking');
    FlightSchoolInstructorId = new DwItemAttribute(this.i, 'FlightSchoolInstructorId');
    RecurrencyDate = new DwItemAttribute(this.i, 'RecurrencyDate');
    TrainingCurrent = new DwItemAttribute(this.i, 'TrainingCurrent');
    TrainingCurrentEvaluatedDateTime = new DwItemAttribute(this.i, 'TrainingCurrentEvaluatedDateTime');
    DpeSupplementReviewedDateTime = new DwItemAttribute(this.i, 'DpeSupplementReviewedDateTime');
    DpeSupplementReviewedBy = new DwItemAttribute(this.i, 'DpeSupplementReviewedBy');
    DocumentsMediaGroupId = new DwItemAttribute(this.i, 'DocumentsMediaGroupId');
    TrainingCurrentReason = new DwItemAttribute(this.i, 'TrainingCurrentReason');
    RoFlightSchoolExaminerExaminerEmailFinal = new DwItemAttribute('roFlightSchoolExaminer', 'RoFlightSchoolExaminerExaminerEmailFinal');
    RoFlightSchoolExaminerExaminerNameFinal = new DwItemAttribute('roFlightSchoolExaminer', 'RoFlightSchoolExaminerExaminerNameFinal');
    RoFlightSchoolExaminerExaminerPhoneFinal = new DwItemAttribute('roFlightSchoolExaminer', 'RoFlightSchoolExaminerExaminerPhoneFinal');
    RoFlightSchoolExaminerFlightSchoolExaminerId = new DwItemAttribute('roFlightSchoolExaminer', 'RoFlightSchoolExaminerFlightSchoolExaminerId');
    RoFlightSchoolExaminerPilotExaminerTypeId = new DwItemAttribute('roFlightSchoolExaminer', 'RoFlightSchoolExaminerPilotExaminerTypeId');
    RoFlightSchoolExaminerPilotExaminerStatusId = new DwItemAttribute('roFlightSchoolExaminer', 'RoFlightSchoolExaminerPilotExaminerStatusId');
    RoFlightSchoolExaminerFinalExaminerTypeId = new DwItemAttribute('roFlightSchoolExaminer', 'RoFlightSchoolExaminerFinalExaminerTypeId');
    RoFlightSchoolExaminerHasPilexosAccount = new DwItemAttribute('roFlightSchoolExaminer', 'RoFlightSchoolExaminerHasPilexosAccount');
    RoFlightSchoolExaminerExaminerGroup = new DwItemAttribute('roFlightSchoolExaminer', 'RoFlightSchoolExaminerExaminerGroup');
}
export class PilotExaminerAirportListQueryMetaData implements DwItem2<PilotExaminerAirportListQueryEntity, PilotExaminerAirportListQueryMetaDataAttributes,PilotExaminerLocationMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Pilot_Examiner-Airport_List';

    constructor() {
        this.ItemDetail.itemId=1141;
        this.ItemDetail.itemName='PilotExaminerLocation';
        this.ItemDetail.keyName='PilotExaminerLocationId';
    }

    CreateEntity(): PilotExaminerAirportListQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): PilotExaminerAirportListQueryBuilder {
        return new DwQueryBuilderGen<PilotExaminerAirportListQueryEntity, PilotExaminerAirportListQueryMetaDataAttributes,PilotExaminerLocationMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<PilotExaminerAirportListQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: PilotExaminerAirportListQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<PilotExaminerAirportListQueryEntity, PilotExaminerAirportListQueryMetaDataAttributes,PilotExaminerLocationMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new PilotExaminerAirportListQueryMetaDataAttributes();
     Relations = new PilotExaminerLocationMetaDataRelations();

}


export type PilotExaminerAirportListQueryBuilder = DwQueryBuilderGen<PilotExaminerAirportListQueryEntity, PilotExaminerAirportListQueryMetaDataAttributes,PilotExaminerLocationMetaDataRelations>


export class PilotExaminerAirportListQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PilotExaminerLocation';
    // Attributes
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    LocationName = new DwItemAttribute(this.i, 'LocationName');
    SchedulingStartDate = new DwItemAttribute(this.i, 'SchedulingStartDate');
    SchedulingEndDate = new DwItemAttribute(this.i, 'SchedulingEndDate');
    IsDefaultLocation = new DwItemAttribute(this.i, 'IsDefaultLocation');
    PilotExaminerLocationTypeId = new DwItemAttribute(this.i, 'PilotExaminerLocationTypeId');
    PilotExaminerLocationAirportAirportId = new DwItemAttribute('PilotExaminerLocationAirport', 'PilotExaminerLocationAirportAirportId');
    AirportAirportId = new DwItemAttribute('Airport', 'AirportAirportId');
    AirportAviationAuthorityId = new DwItemAttribute('Airport', 'AirportAviationAuthorityId');
    AirportAirportName = new DwItemAttribute('Airport', 'AirportAirportName');
    AirportAirportCode = new DwItemAttribute('Airport', 'AirportAirportCode');
    AirportElevation = new DwItemAttribute('Airport', 'AirportElevation');
    AirportAddressPostalCode = new DwItemAttribute('Address', 'AirportAddressPostalCode');
    AirportAddressTimezoneId = new DwItemAttribute('Address', 'AirportAddressTimezoneId');
    AirportAddressLongitude = new DwItemAttribute('Address', 'AirportAddressLongitude');
    AirportAddressLatitude = new DwItemAttribute('Address', 'AirportAddressLatitude');
    RoPilotExaminerLocationCurrentPilotExaminerLocationStateId = new DwItemAttribute('roPilotExaminerLocationCurrent', 'RoPilotExaminerLocationCurrentPilotExaminerLocationStateId');
}
export class ReportingACSMissedCodesAggregateQueryMetaData implements DwItem2<ReportingACSMissedCodesAggregateQueryEntity, ReportingACSMissedCodesAggregateQueryMetaDataAttributes,RoAssessmentAcsMissedCodeFactMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Reporting-ACS_Missed_Codes_Aggregate';

    constructor() {
        this.ItemDetail.itemId=2341;
        this.ItemDetail.itemName='roAssessmentAcsMissedCodeFact';
        this.ItemDetail.keyName='AssessmentId';
    }

    CreateEntity(): ReportingACSMissedCodesAggregateQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): ReportingACSMissedCodesAggregateQueryBuilder {
        return new DwQueryBuilderGen<ReportingACSMissedCodesAggregateQueryEntity, ReportingACSMissedCodesAggregateQueryMetaDataAttributes,RoAssessmentAcsMissedCodeFactMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<ReportingACSMissedCodesAggregateQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: ReportingACSMissedCodesAggregateQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<ReportingACSMissedCodesAggregateQueryEntity, ReportingACSMissedCodesAggregateQueryMetaDataAttributes,RoAssessmentAcsMissedCodeFactMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new ReportingACSMissedCodesAggregateQueryMetaDataAttributes();
     Relations = new RoAssessmentAcsMissedCodeFactMetaDataRelations();

}


export type ReportingACSMissedCodesAggregateQueryBuilder = DwQueryBuilderGen<ReportingACSMissedCodesAggregateQueryEntity, ReportingACSMissedCodesAggregateQueryMetaDataAttributes,RoAssessmentAcsMissedCodeFactMetaDataRelations>


export class ReportingACSMissedCodesAggregateQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roAssessmentAcsMissedCodeFact';
    // Attributes
    SourceType = new DwItemAttribute(this.i, 'SourceType');
    AssessmentId = new DwItemAttribute(this.i, 'AssessmentId');
    AssessmentKey = new DwItemAttribute(this.i, 'AssessmentKey');
    PlanOfActionId = new DwItemAttribute(this.i, 'PlanOfActionId');
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    AcsTestId = new DwItemAttribute(this.i, 'AcsTestId');
    ApplicantAcsWrittenResultTypeId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultTypeId');
    ApplicantAcsWrittenResultId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultId');
    PlanOfActionName = new DwItemAttribute(this.i, 'PlanOfActionName');
    PlanOfActionStatusId = new DwItemAttribute(this.i, 'PlanOfActionStatusId');
    CheckrideRequestSubStatusId = new DwItemAttribute(this.i, 'CheckrideRequestSubStatusId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    CheckRideExaminerTypeId = new DwItemAttribute(this.i, 'CheckRideExaminerTypeId');
    PilotExaminerId = new DwItemAttribute(this.i, 'PilotExaminerId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    AuthorityPreCheckRideNumber = new DwItemAttribute(this.i, 'AuthorityPreCheckRideNumber');
    AuthorityPreapprovalCode = new DwItemAttribute(this.i, 'AuthorityPreapprovalCode');
    CheckRideOwnershipTypeId = new DwItemAttribute(this.i, 'CheckRideOwnershipTypeId');
    CheckRideApplicantTypeId = new DwItemAttribute(this.i, 'CheckRideApplicantTypeId');
    ApplicantName = new DwItemAttribute(this.i, 'ApplicantName');
    ApplicantEmail = new DwItemAttribute(this.i, 'ApplicantEmail');
    ApplicantPhone = new DwItemAttribute(this.i, 'ApplicantPhone');
    ExaminerName = new DwItemAttribute(this.i, 'ExaminerName');
    ExaminerEmail = new DwItemAttribute(this.i, 'ExaminerEmail');
    ExaminerPhone = new DwItemAttribute(this.i, 'ExaminerPhone');
    FlightSchoolApplicantId = new DwItemAttribute(this.i, 'FlightSchoolApplicantId');
    FlightSchoolInstructorId = new DwItemAttribute(this.i, 'FlightSchoolInstructorId');
    CheckrideDateTime = new DwItemAttribute(this.i, 'CheckrideDateTime');
    CheckrideAirportId = new DwItemAttribute(this.i, 'CheckrideAirportId');
    CheckrideGroupId = new DwItemAttribute(this.i, 'CheckrideGroupId');
    CheckrideTypeId = new DwItemAttribute(this.i, 'CheckrideTypeId');
    CheckRideTestTypeId = new DwItemAttribute(this.i, 'CheckRideTestTypeId');
    CheckrideDurationMinutes = new DwItemAttribute(this.i, 'CheckrideDurationMinutes');
    CheckrideEndDateTime = new DwItemAttribute(this.i, 'CheckrideEndDateTime');
    PlanOfActionResultId = new DwItemAttribute(this.i, 'PlanOfActionResultId');
    CheckrideResultId = new DwItemAttribute(this.i, 'CheckrideResultId');
    CheckRideOutcomeId = new DwItemAttribute(this.i, 'CheckRideOutcomeId');
    AllowRetest = new DwItemAttribute(this.i, 'AllowRetest');
    FlagApplicant = new DwItemAttribute(this.i, 'FlagApplicant');
    AllowRetestReason = new DwItemAttribute(this.i, 'AllowRetestReason');
    RetestCost = new DwItemAttribute(this.i, 'RetestCost');
    AddToWaitlist = new DwItemAttribute(this.i, 'AddToWaitlist');
    GroundPortionComplete = new DwItemAttribute(this.i, 'GroundPortionComplete');
    ApplicantAcsWrittenResultMissedCodeId = new DwItemAttribute(this.i, 'ApplicantAcsWrittenResultMissedCodeId');
    AcsCodeId = new DwItemAttribute(this.i, 'AcsCodeId');
    AscCodeTypeId = new DwItemAttribute(this.i, 'AscCodeTypeId');
    AcsCodeTypeName = new DwItemAttribute(this.i, 'AcsCodeTypeName');
    AcsCode = new DwItemAttribute(this.i, 'AcsCode');
    AcsCodeOrder = new DwItemAttribute(this.i, 'AcsCodeOrder');
    AcsAreaOfOperationTaskId = new DwItemAttribute(this.i, 'AcsAreaOfOperationTaskId');
    AscCodeDescription = new DwItemAttribute(this.i, 'AscCodeDescription');
    AcsAreaOfOperationId = new DwItemAttribute(this.i, 'AcsAreaOfOperationId');
    TaskName = new DwItemAttribute(this.i, 'TaskName');
    TaskOrder = new DwItemAttribute(this.i, 'TaskOrder');
    TaskCode = new DwItemAttribute(this.i, 'TaskCode');
    AreaOfOperationName = new DwItemAttribute(this.i, 'AreaOfOperationName');
    AreaOfOperationOrder = new DwItemAttribute(this.i, 'AreaOfOperationOrder');
    AreaOfOperationCode = new DwItemAttribute(this.i, 'AreaOfOperationCode');
    TestName = new DwItemAttribute(this.i, 'TestName');
    TestDescription = new DwItemAttribute(this.i, 'TestDescription');
    TestCode = new DwItemAttribute(this.i, 'TestCode');
    CheckRideGroup = new DwItemAttribute(this.i, 'CheckRideGroup');
    AssessmentCount = new DwItemAttribute(this.i, 'AssessmentCount');
    CheckrideCount = new DwItemAttribute(this.i, 'CheckrideCount');
    POACount = new DwItemAttribute(this.i, 'POACount');
    MissedCodeCount = new DwItemAttribute(this.i, 'MissedCodeCount');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    OdaFlightSchoolId = new DwItemAttribute(this.i, 'OdaFlightSchoolId');
}
export class CheckrideRequestHomePageQueryMetaData implements DwItem2<CheckrideRequestHomePageQueryEntity, CheckrideRequestHomePageQueryMetaDataAttributes,CheckRideRequestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'CheckrideRequest_HomePage';

    constructor() {
        this.ItemDetail.itemId=1153;
        this.ItemDetail.itemName='CheckRideRequest';
        this.ItemDetail.keyName='CheckRideRequestId';
    }

    CreateEntity(): CheckrideRequestHomePageQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): CheckrideRequestHomePageQueryBuilder {
        return new DwQueryBuilderGen<CheckrideRequestHomePageQueryEntity, CheckrideRequestHomePageQueryMetaDataAttributes,CheckRideRequestMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<CheckrideRequestHomePageQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: CheckrideRequestHomePageQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<CheckrideRequestHomePageQueryEntity, CheckrideRequestHomePageQueryMetaDataAttributes,CheckRideRequestMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new CheckrideRequestHomePageQueryMetaDataAttributes();
     Relations = new CheckRideRequestMetaDataRelations();

}


export type CheckrideRequestHomePageQueryBuilder = DwQueryBuilderGen<CheckrideRequestHomePageQueryEntity, CheckrideRequestHomePageQueryMetaDataAttributes,CheckRideRequestMetaDataRelations>


export class CheckrideRequestHomePageQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CheckRideRequest';
    // Attributes
    CheckRideRequestId = new DwItemAttribute(this.i, 'CheckRideRequestId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    CheckRideTypeId = new DwItemAttribute(this.i, 'CheckRideTypeId');
    CheckRideTestTypeId = new DwItemAttribute(this.i, 'CheckRideTestTypeId');
    PilotCertificateNumber = new DwItemAttribute(this.i, 'PilotCertificateNumber');
    CheckRideRequestSubStatusId = new DwItemAttribute(this.i, 'CheckRideRequestSubStatusId');
    PreferredDateTime = new DwItemAttribute(this.i, 'PreferredDateTime');
    ScheduledTimeMinutes = new DwItemAttribute(this.i, 'ScheduledTimeMinutes');
    ScheduledPilotExaminerId = new DwItemAttribute(this.i, 'ScheduledPilotExaminerId');
    ScheduledPreTimeMinutes = new DwItemAttribute(this.i, 'ScheduledPreTimeMinutes');
    ScheduledPostTimeMinutes = new DwItemAttribute(this.i, 'ScheduledPostTimeMinutes');
    AuthorityPreCheckRideNumber = new DwItemAttribute(this.i, 'AuthorityPreCheckRideNumber');
    AirplaneMakeModel = new DwItemAttribute(this.i, 'AirplaneMakeModel');
    AirplaneNNumber = new DwItemAttribute(this.i, 'AirplaneNNumber');
    DocumentsMediaGroupId = new DwItemAttribute(this.i, 'DocumentsMediaGroupId');
    AuthorityPreapprovalCode = new DwItemAttribute(this.i, 'AuthorityPreapprovalCode');
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    ScheduledAirportId = new DwItemAttribute(this.i, 'ScheduledAirportId');
    ScheduledDateTime = new DwItemAttribute(this.i, 'ScheduledDateTime');
    ScheduledCheckRideScenarioId = new DwItemAttribute(this.i, 'ScheduledCheckRideScenarioId');
    EndorsedAndCheckRideReady = new DwItemAttribute(this.i, 'EndorsedAndCheckRideReady');
    AvaiationTrainingProgramId = new DwItemAttribute(this.i, 'AvaiationTrainingProgramId');
    CheckRideApplicantTypeId = new DwItemAttribute(this.i, 'CheckRideApplicantTypeId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    PilexosBookingPaymentAdded = new DwItemAttribute(this.i, 'PilexosBookingPaymentAdded');
    ExaminerBookingCost = new DwItemAttribute(this.i, 'ExaminerBookingCost');
    PilexosBookingCost = new DwItemAttribute(this.i, 'PilexosBookingCost');
    AdditionalTravelCost = new DwItemAttribute(this.i, 'AdditionalTravelCost');
    ScheduledCheckRideCost = new DwItemAttribute(this.i, 'ScheduledCheckRideCost');
    FlightSchoolName = new DwItemAttribute(this.i, 'FlightSchoolName');
    CancelledRequestBookingFeeRefund = new DwItemAttribute(this.i, 'CancelledRequestBookingFeeRefund');
    StudentApplicantId = new DwItemAttribute(this.i, 'StudentApplicantId');
    StudentApplicantCitizenshipCountyId = new DwItemAttribute(this.i, 'StudentApplicantCitizenshipCountyId');
    CheckRideExaminerTypeId = new DwItemAttribute(this.i, 'CheckRideExaminerTypeId');
    CheckRideOwnershipTypeId = new DwItemAttribute(this.i, 'CheckRideOwnershipTypeId');
    FlightSchoolOrganizationId = new DwItemAttribute(this.i, 'FlightSchoolOrganizationId');
    FlightSchoolExaminerId = new DwItemAttribute(this.i, 'FlightSchoolExaminerId');
    FlightSchoolApplicantId = new DwItemAttribute(this.i, 'FlightSchoolApplicantId');
    FlightSchoolBranchId = new DwItemAttribute(this.i, 'FlightSchoolBranchId');
    CheckRideWorkflowId = new DwItemAttribute(this.i, 'CheckRideWorkflowId');
    PrimaryTrainingAirportId = new DwItemAttribute(this.i, 'PrimaryTrainingAirportId');
    StudentApplicantStateProvinceId = new DwItemAttribute(this.i, 'StudentApplicantStateProvinceId');
    ForeignPilotMeetsQualifications = new DwItemAttribute(this.i, 'ForeignPilotMeetsQualifications');
    AuthorityApplicationNumber = new DwItemAttribute(this.i, 'AuthorityApplicationNumber');
    AuthorityApprovalCode = new DwItemAttribute(this.i, 'AuthorityApprovalCode');
    OdaFlightSchoolId = new DwItemAttribute(this.i, 'OdaFlightSchoolId');
    SendExaminerCheckrideEmails = new DwItemAttribute(this.i, 'SendExaminerCheckrideEmails');
    SendApplicantCheckrideEmails = new DwItemAttribute(this.i, 'SendApplicantCheckrideEmails');
    PilexosBookingCostPaymentPartyId = new DwItemAttribute(this.i, 'PilexosBookingCostPaymentPartyId');
    CheckRideRequestSubStatusCheckRideRequestStatusId = new DwItemAttribute('CheckRideRequestSubStatus', 'CheckRideRequestSubStatusCheckRideRequestStatusId');
    CheckRideResultCheckRideDateTime = new DwItemAttribute('CheckRideResult', 'CheckRideResultCheckRideDateTime');
    CheckRideResultCheckRideOutcomeId = new DwItemAttribute('CheckRideResult', 'CheckRideResultCheckRideOutcomeId');
    CheckRideResultAllowRetest = new DwItemAttribute('CheckRideResult', 'CheckRideResultAllowRetest');
    CheckRideResultAllowRetestReason = new DwItemAttribute('CheckRideResult', 'CheckRideResultAllowRetestReason');
    CheckRideResultRetestCost = new DwItemAttribute('CheckRideResult', 'CheckRideResultRetestCost');
    AirportAirportName = new DwItemAttribute('Airport', 'AirportAirportName');
    AirportAirportCode = new DwItemAttribute('Airport', 'AirportAirportCode');
    RoCheckrideApplicantInfoApplicantFinalName = new DwItemAttribute('roCheckrideApplicantFinalName', 'RoCheckrideApplicantInfoApplicantFinalName');
    RoCheckrideApplicantInfoCheckRideRequestId = new DwItemAttribute('roCheckrideApplicantFinalName', 'RoCheckrideApplicantInfoCheckRideRequestId');
    RoCheckrideApplicantInfoFlightSchoolFinalName = new DwItemAttribute('roCheckrideApplicantFinalName', 'RoCheckrideApplicantInfoFlightSchoolFinalName');
    RoCheckrideApplicantInfoApplicantFinalEmail = new DwItemAttribute('roCheckrideApplicantFinalName', 'RoCheckrideApplicantInfoApplicantFinalEmail');
    RoCheckrideApplicantInfoApplicantFinalPhone = new DwItemAttribute('roCheckrideApplicantFinalName', 'RoCheckrideApplicantInfoApplicantFinalPhone');
    RoCheckrideApplicantInfoPilotExaminerFinalName = new DwItemAttribute('roCheckrideApplicantFinalName', 'RoCheckrideApplicantInfoPilotExaminerFinalName');
    RoCheckrideApplicantInfoPilotExaminerFinalEmail = new DwItemAttribute('roCheckrideApplicantFinalName', 'RoCheckrideApplicantInfoPilotExaminerFinalEmail');
    RoCheckrideApplicantInfoPilotExaminerFinalPhone = new DwItemAttribute('roCheckrideApplicantFinalName', 'RoCheckrideApplicantInfoPilotExaminerFinalPhone');
    RoCheckrideApplicantInfoFlightInstructorFinalName = new DwItemAttribute('roCheckrideApplicantFinalName', 'RoCheckrideApplicantInfoFlightInstructorFinalName');
    RoCheckrideApplicantInfoFlightInstructorFinalEmail = new DwItemAttribute('roCheckrideApplicantFinalName', 'RoCheckrideApplicantInfoFlightInstructorFinalEmail');
    RoCheckrideApplicantInfoFlightInstructorFinalPhone = new DwItemAttribute('roCheckrideApplicantFinalName', 'RoCheckrideApplicantInfoFlightInstructorFinalPhone');
    PilexosBookingCheckRidePaymentPaymentDateTime = new DwItemAttribute('CheckRidePayment', 'PilexosBookingCheckRidePaymentPaymentDateTime');
    PilexosBookingCheckRidePaymentPaymentAmount = new DwItemAttribute('CheckRidePayment', 'PilexosBookingCheckRidePaymentPaymentAmount');
    PilexosBookingCheckRidePaymentEmailCCReceipt = new DwItemAttribute('CheckRidePayment', 'PilexosBookingCheckRidePaymentEmailCCReceipt');
    PilexosBookingCheckRidePaymentPaymentPartyId = new DwItemAttribute('CheckRidePayment', 'PilexosBookingCheckRidePaymentPaymentPartyId');
    PaymentReferencePaymentReferenceCardTypeId = new DwItemAttribute('PaymentReference', 'PaymentReferencePaymentReferenceCardTypeId');
    PaymentReferenceCardHolderName = new DwItemAttribute('PaymentReference', 'PaymentReferenceCardHolderName');
    PaymentReferencePaymentReference = new DwItemAttribute('PaymentReference', 'PaymentReferencePaymentReference');
    PaymentReferencePaymentReferenceStatusId = new DwItemAttribute('PaymentReference', 'PaymentReferencePaymentReferenceStatusId');
    PaymentReferencePaymentAmount = new DwItemAttribute('PaymentReference', 'PaymentReferencePaymentAmount');
}


// Generated Query Classes for MetaData Service

class MetaDataQueries {
    PilotExaminerSearch : PilotExaminerSearchQueryMetaData = new PilotExaminerSearchQueryMetaData();
    PilotExaminerCalendarReference : PilotExaminerCalendarReferenceQueryMetaData = new PilotExaminerCalendarReferenceQueryMetaData();
    CheckRideRequestCalendar : CheckRideRequestCalendarQueryMetaData = new CheckRideRequestCalendarQueryMetaData();
    PilotExaminerCurrentAirports : PilotExaminerCurrentAirportsQueryMetaData = new PilotExaminerCurrentAirportsQueryMetaData();
    PilotExaminerPublicProfile : PilotExaminerPublicProfileQueryMetaData = new PilotExaminerPublicProfileQueryMetaData();
    StudentApplicantWithDetail : StudentApplicantWithDetailQueryMetaData = new StudentApplicantWithDetailQueryMetaData();
    AirportWithAddressInfo : AirportWithAddressInfoQueryMetaData = new AirportWithAddressInfoQueryMetaData();
    CheckrideRequestAggregateBase : CheckrideRequestAggregateBaseQueryMetaData = new CheckrideRequestAggregateBaseQueryMetaData();
    CheckrideActiveApplicantCheckrides : CheckrideActiveApplicantCheckridesQueryMetaData = new CheckrideActiveApplicantCheckridesQueryMetaData();
    AcsCodesLookup : AcsCodesLookupQueryMetaData = new AcsCodesLookupQueryMetaData();
    AcsCodesGrid : AcsCodesGridQueryMetaData = new AcsCodesGridQueryMetaData();
    AcsCodesWithQuestions : AcsCodesWithQuestionsQueryMetaData = new AcsCodesWithQuestionsQueryMetaData();
    CheckrideGroupACSTest : CheckrideGroupACSTestQueryMetaData = new CheckrideGroupACSTestQueryMetaData();
    PlanOfActionDetails : PlanOfActionDetailsQueryMetaData = new PlanOfActionDetailsQueryMetaData();
    FlightSchoolApplicantAwaitingCheckrides : FlightSchoolApplicantAwaitingCheckridesQueryMetaData = new FlightSchoolApplicantAwaitingCheckridesQueryMetaData();
    FlightSchoolAirports : FlightSchoolAirportsQueryMetaData = new FlightSchoolAirportsQueryMetaData();
    CheckrideRequestSchoolCalendar : CheckrideRequestSchoolCalendarQueryMetaData = new CheckrideRequestSchoolCalendarQueryMetaData();
    FlightSchoolExaminerWithExaminerDetails : FlightSchoolExaminerWithExaminerDetailsQueryMetaData = new FlightSchoolExaminerWithExaminerDetailsQueryMetaData();
    PilotExaminerAirportList : PilotExaminerAirportListQueryMetaData = new PilotExaminerAirportListQueryMetaData();
    ReportingACSMissedCodesAggregate : ReportingACSMissedCodesAggregateQueryMetaData = new ReportingACSMissedCodesAggregateQueryMetaData();
    CheckrideRequestHomePage : CheckrideRequestHomePageQueryMetaData = new CheckrideRequestHomePageQueryMetaData();
}

export class AppMetaData {

    static AcsAreaOfOperation : AcsAreaOfOperationMetaData = new AcsAreaOfOperationMetaData();
    static AcsAreaOfOperationTask : AcsAreaOfOperationTaskMetaData = new AcsAreaOfOperationTaskMetaData();
    static AcsCode : AcsCodeMetaData = new AcsCodeMetaData();
    static AcsCodeLookupRequest : AcsCodeLookupRequestMetaData = new AcsCodeLookupRequestMetaData();
    static AcsCodeSelectionMode : AcsCodeSelectionModeMetaData = new AcsCodeSelectionModeMetaData();
    static AcsCodeType : AcsCodeTypeMetaData = new AcsCodeTypeMetaData();
    static AcsTest : AcsTestMetaData = new AcsTestMetaData();
    static AcsTestCheckRideType : AcsTestCheckRideTypeMetaData = new AcsTestCheckRideTypeMetaData();
    static AcsTestPortion : AcsTestPortionMetaData = new AcsTestPortionMetaData();
    static AcsTestStatus : AcsTestStatusMetaData = new AcsTestStatusMetaData();
    static Address : AddressMetaData = new AddressMetaData();
    static DwAiFunction : DwAiFunctionMetaData = new DwAiFunctionMetaData();
    static DwAiPromptRequest : DwAiPromptRequestMetaData = new DwAiPromptRequestMetaData();
    static Airport : AirportMetaData = new AirportMetaData();
    static ApplicantAcsWrittenResult : ApplicantAcsWrittenResultMetaData = new ApplicantAcsWrittenResultMetaData();
    static ApplicantAcsWrittenResultMissedCode : ApplicantAcsWrittenResultMissedCodeMetaData = new ApplicantAcsWrittenResultMissedCodeMetaData();
    static ApplicantAcsWrittenResultType : ApplicantAcsWrittenResultTypeMetaData = new ApplicantAcsWrittenResultTypeMetaData();
    static ApplicantPlaceholder : ApplicantPlaceholderMetaData = new ApplicantPlaceholderMetaData();
    static ApplicantPlaceholderStatus : ApplicantPlaceholderStatusMetaData = new ApplicantPlaceholderStatusMetaData();
    static AviationAuthority : AviationAuthorityMetaData = new AviationAuthorityMetaData();
    static AviationAuthorityDistrictOffice : AviationAuthorityDistrictOfficeMetaData = new AviationAuthorityDistrictOfficeMetaData();
    static AviationTrainingProgram : AviationTrainingProgramMetaData = new AviationTrainingProgramMetaData();
    static AvionicType : AvionicTypeMetaData = new AvionicTypeMetaData();
    static CalendarEventReference : CalendarEventReferenceMetaData = new CalendarEventReferenceMetaData();
    static CalendarOwnerType : CalendarOwnerTypeMetaData = new CalendarOwnerTypeMetaData();
    static CalendarReference : CalendarReferenceMetaData = new CalendarReferenceMetaData();
    static CalendarReferenceLog : CalendarReferenceLogMetaData = new CalendarReferenceLogMetaData();
    static CalendarReferenceType : CalendarReferenceTypeMetaData = new CalendarReferenceTypeMetaData();
    static CalendarSyncRequest : CalendarSyncRequestMetaData = new CalendarSyncRequestMetaData();
    static CalendarSyncRequestActionType : CalendarSyncRequestActionTypeMetaData = new CalendarSyncRequestActionTypeMetaData();
    static CalendarSyncRequestErrorType : CalendarSyncRequestErrorTypeMetaData = new CalendarSyncRequestErrorTypeMetaData();
    static CalendarSyncRequestSourceSubType : CalendarSyncRequestSourceSubTypeMetaData = new CalendarSyncRequestSourceSubTypeMetaData();
    static CalendarSyncRequestSourceType : CalendarSyncRequestSourceTypeMetaData = new CalendarSyncRequestSourceTypeMetaData();
    static CalendarSyncRequestStatus : CalendarSyncRequestStatusMetaData = new CalendarSyncRequestStatusMetaData();
    static CheckRideAISummary : CheckRideAISummaryMetaData = new CheckRideAISummaryMetaData();
    static CheckRideAISummaryStatus : CheckRideAISummaryStatusMetaData = new CheckRideAISummaryStatusMetaData();
    static CheckRideApplicantType : CheckRideApplicantTypeMetaData = new CheckRideApplicantTypeMetaData();
    static CheckRideAvionicType : CheckRideAvionicTypeMetaData = new CheckRideAvionicTypeMetaData();
    static CheckRideCancellationType : CheckRideCancellationTypeMetaData = new CheckRideCancellationTypeMetaData();
    static CheckRideExaminerType : CheckRideExaminerTypeMetaData = new CheckRideExaminerTypeMetaData();
    static CheckRideGroup : CheckRideGroupMetaData = new CheckRideGroupMetaData();
    static CheckRideInstructorType : CheckRideInstructorTypeMetaData = new CheckRideInstructorTypeMetaData();
    static CheckRideOutcome : CheckRideOutcomeMetaData = new CheckRideOutcomeMetaData();
    static CheckRideOwnershipType : CheckRideOwnershipTypeMetaData = new CheckRideOwnershipTypeMetaData();
    static CheckRidePayment : CheckRidePaymentMetaData = new CheckRidePaymentMetaData();
    static CheckRideRequest : CheckRideRequestMetaData = new CheckRideRequestMetaData();
    static CheckRideRequestNote : CheckRideRequestNoteMetaData = new CheckRideRequestNoteMetaData();
    static CheckRideRequestPaymentParty : CheckRideRequestPaymentPartyMetaData = new CheckRideRequestPaymentPartyMetaData();
    static CheckRideRequestPilotCertificate : CheckRideRequestPilotCertificateMetaData = new CheckRideRequestPilotCertificateMetaData();
    static CheckRideRequestStatus : CheckRideRequestStatusMetaData = new CheckRideRequestStatusMetaData();
    static CheckRideRequestSubStatus : CheckRideRequestSubStatusMetaData = new CheckRideRequestSubStatusMetaData();
    static CheckRideResult : CheckRideResultMetaData = new CheckRideResultMetaData();
    static CheckRideScenario : CheckRideScenarioMetaData = new CheckRideScenarioMetaData();
    static CheckRideScenarioTypeMap : CheckRideScenarioTypeMapMetaData = new CheckRideScenarioTypeMapMetaData();
    static CheckRideScheduleHold : CheckRideScheduleHoldMetaData = new CheckRideScheduleHoldMetaData();
    static CheckRideStatusLevel : CheckRideStatusLevelMetaData = new CheckRideStatusLevelMetaData();
    static CheckRideTestAttemptClassification : CheckRideTestAttemptClassificationMetaData = new CheckRideTestAttemptClassificationMetaData();
    static CheckRideTestType : CheckRideTestTypeMetaData = new CheckRideTestTypeMetaData();
    static CheckRideType : CheckRideTypeMetaData = new CheckRideTypeMetaData();
    static CheckRideWorkflow : CheckRideWorkflowMetaData = new CheckRideWorkflowMetaData();
    static Country : CountryMetaData = new CountryMetaData();
    static Duration : DurationMetaData = new DurationMetaData();
    static ElectronicFlightBagType : ElectronicFlightBagTypeMetaData = new ElectronicFlightBagTypeMetaData();
    static FlightSchool : FlightSchoolMetaData = new FlightSchoolMetaData();
    static FlightSchoolApplicant : FlightSchoolApplicantMetaData = new FlightSchoolApplicantMetaData();
    static FlightSchoolApplicantBranch : FlightSchoolApplicantBranchMetaData = new FlightSchoolApplicantBranchMetaData();
    static FlightSchoolApplicantStatus : FlightSchoolApplicantStatusMetaData = new FlightSchoolApplicantStatusMetaData();
    static FlightSchoolBranch : FlightSchoolBranchMetaData = new FlightSchoolBranchMetaData();
    static FlightSchoolExaminer : FlightSchoolExaminerMetaData = new FlightSchoolExaminerMetaData();
    static FlightSchoolExaminerStatus : FlightSchoolExaminerStatusMetaData = new FlightSchoolExaminerStatusMetaData();
    static FlightSchoolExaminerType : FlightSchoolExaminerTypeMetaData = new FlightSchoolExaminerTypeMetaData();
    static FlightSchoolInstructor : FlightSchoolInstructorMetaData = new FlightSchoolInstructorMetaData();
    static FlightSchoolInstructorApplicant : FlightSchoolInstructorApplicantMetaData = new FlightSchoolInstructorApplicantMetaData();
    static FlightSchoolInstructorStatus : FlightSchoolInstructorStatusMetaData = new FlightSchoolInstructorStatusMetaData();
    static FlightSchoolInstructorType : FlightSchoolInstructorTypeMetaData = new FlightSchoolInstructorTypeMetaData();
    static FlightSchoolOrganization : FlightSchoolOrganizationMetaData = new FlightSchoolOrganizationMetaData();
    static FlightSchoolOrganizationFeature : FlightSchoolOrganizationFeatureMetaData = new FlightSchoolOrganizationFeatureMetaData();
    static FlightSchoolReferenceStatus : FlightSchoolReferenceStatusMetaData = new FlightSchoolReferenceStatusMetaData();
    static FlightSchoolSetupRequest : FlightSchoolSetupRequestMetaData = new FlightSchoolSetupRequestMetaData();
    static FlightSchoolSetupRequestStatus : FlightSchoolSetupRequestStatusMetaData = new FlightSchoolSetupRequestStatusMetaData();
    static FlightSchoolStatus : FlightSchoolStatusMetaData = new FlightSchoolStatusMetaData();
    static FlightSchoolTrainingProgram : FlightSchoolTrainingProgramMetaData = new FlightSchoolTrainingProgramMetaData();
    static FlightSchoolType : FlightSchoolTypeMetaData = new FlightSchoolTypeMetaData();
    static FlightSchoolUser : FlightSchoolUserMetaData = new FlightSchoolUserMetaData();
    static FlightSchoolUserBranch : FlightSchoolUserBranchMetaData = new FlightSchoolUserBranchMetaData();
    static DwMediaGroup : DwMediaGroupMetaData = new DwMediaGroupMetaData();
    static PaymentAttempt : PaymentAttemptMetaData = new PaymentAttemptMetaData();
    static PaymentCard : PaymentCardMetaData = new PaymentCardMetaData();
    static PaymentCardStatus : PaymentCardStatusMetaData = new PaymentCardStatusMetaData();
    static PaymentCustomerReference : PaymentCustomerReferenceMetaData = new PaymentCustomerReferenceMetaData();
    static PaymentDiscountCode : PaymentDiscountCodeMetaData = new PaymentDiscountCodeMetaData();
    static PaymentMethod : PaymentMethodMetaData = new PaymentMethodMetaData();
    static PaymentProvider : PaymentProviderMetaData = new PaymentProviderMetaData();
    static PaymentReference : PaymentReferenceMetaData = new PaymentReferenceMetaData();
    static PaymentReferenceCardType : PaymentReferenceCardTypeMetaData = new PaymentReferenceCardTypeMetaData();
    static PaymentReferenceStatus : PaymentReferenceStatusMetaData = new PaymentReferenceStatusMetaData();
    static PaymentType : PaymentTypeMetaData = new PaymentTypeMetaData();
    static PilotCertificateType : PilotCertificateTypeMetaData = new PilotCertificateTypeMetaData();
    static PilotExaminer : PilotExaminerMetaData = new PilotExaminerMetaData();
    static PilotExaminerFlightSchoolSetup : PilotExaminerFlightSchoolSetupMetaData = new PilotExaminerFlightSchoolSetupMetaData();
    static PilotExaminerLocation : PilotExaminerLocationMetaData = new PilotExaminerLocationMetaData();
    static PilotExaminerLocationAirport : PilotExaminerLocationAirportMetaData = new PilotExaminerLocationAirportMetaData();
    static PilotExaminerLocationState : PilotExaminerLocationStateMetaData = new PilotExaminerLocationStateMetaData();
    static PilotExaminerLocationType : PilotExaminerLocationTypeMetaData = new PilotExaminerLocationTypeMetaData();
    static PilotExaminerStatus : PilotExaminerStatusMetaData = new PilotExaminerStatusMetaData();
    static PilotExaminerType : PilotExaminerTypeMetaData = new PilotExaminerTypeMetaData();
    static PlanOfAction : PlanOfActionMetaData = new PlanOfActionMetaData();
    static PlanOfActionQuestionResult : PlanOfActionQuestionResultMetaData = new PlanOfActionQuestionResultMetaData();
    static PlanOfActionRequiredAcsCode : PlanOfActionRequiredAcsCodeMetaData = new PlanOfActionRequiredAcsCodeMetaData();
    static PlanOfActionResult : PlanOfActionResultMetaData = new PlanOfActionResultMetaData();
    static PlanOfActionSection : PlanOfActionSectionMetaData = new PlanOfActionSectionMetaData();
    static PlanOfActionSectionQuestion : PlanOfActionSectionQuestionMetaData = new PlanOfActionSectionQuestionMetaData();
    static PlanOfActionSectionType : PlanOfActionSectionTypeMetaData = new PlanOfActionSectionTypeMetaData();
    static PlanOfActionStatus : PlanOfActionStatusMetaData = new PlanOfActionStatusMetaData();
    static PlanOfActionStatusType : PlanOfActionStatusTypeMetaData = new PlanOfActionStatusTypeMetaData();
    static PostalCode : PostalCodeMetaData = new PostalCodeMetaData();
    static DwProcessDefinition : DwProcessDefinitionMetaData = new DwProcessDefinitionMetaData();
    static QuestionBank : QuestionBankMetaData = new QuestionBankMetaData();
    static QuestionBankStatus : QuestionBankStatusMetaData = new QuestionBankStatusMetaData();
    static QuestionOutcome : QuestionOutcomeMetaData = new QuestionOutcomeMetaData();
    static ReferenceStatus : ReferenceStatusMetaData = new ReferenceStatusMetaData();
    static ReportDashboard : ReportDashboardMetaData = new ReportDashboardMetaData();
    static ReportDashboardGroup : ReportDashboardGroupMetaData = new ReportDashboardGroupMetaData();
    static ReportDashboardWidget : ReportDashboardWidgetMetaData = new ReportDashboardWidgetMetaData();
    static ReportDataSource : ReportDataSourceMetaData = new ReportDataSourceMetaData();
    static ReportDataSourceColumn : ReportDataSourceColumnMetaData = new ReportDataSourceColumnMetaData();
    static ReportFilterPreference : ReportFilterPreferenceMetaData = new ReportFilterPreferenceMetaData();
    static ReportFilterPreset : ReportFilterPresetMetaData = new ReportFilterPresetMetaData();
    static ReportFilterPresetOwnershipType : ReportFilterPresetOwnershipTypeMetaData = new ReportFilterPresetOwnershipTypeMetaData();
    static RoAcsCodeDimension : RoAcsCodeDimensionMetaData = new RoAcsCodeDimensionMetaData();
    static RoAcsWrittenSource : RoAcsWrittenSourceMetaData = new RoAcsWrittenSourceMetaData();
    static RoAirportDistances : RoAirportDistancesMetaData = new RoAirportDistancesMetaData();
    static RoAssessmentAcsFactBase : RoAssessmentAcsFactBaseMetaData = new RoAssessmentAcsFactBaseMetaData();
    static RoAssessmentAcsMissedCodeFact : RoAssessmentAcsMissedCodeFactMetaData = new RoAssessmentAcsMissedCodeFactMetaData();
    static RoAssessmentFactBase : RoAssessmentFactBaseMetaData = new RoAssessmentFactBaseMetaData();
    static RoCalendarSyncRequestDisplay : RoCalendarSyncRequestDisplayMetaData = new RoCalendarSyncRequestDisplayMetaData();
    static RoCheckrideAcsFactBase : RoCheckrideAcsFactBaseMetaData = new RoCheckrideAcsFactBaseMetaData();
    static RoCheckrideAggregateUtil : RoCheckrideAggregateUtilMetaData = new RoCheckrideAggregateUtilMetaData();
    static RoCheckrideApplicantFinalName : RoCheckrideApplicantFinalNameMetaData = new RoCheckrideApplicantFinalNameMetaData();
    static RoCheckrideFactBase : RoCheckrideFactBaseMetaData = new RoCheckrideFactBaseMetaData();
    static RoCheckRidePaymentAggregate : RoCheckRidePaymentAggregateMetaData = new RoCheckRidePaymentAggregateMetaData();
    static RoCheckRideRequestApplicant : RoCheckRideRequestApplicantMetaData = new RoCheckRideRequestApplicantMetaData();
    static RoCheckrideRequestScheduleDateInfo : RoCheckrideRequestScheduleDateInfoMetaData = new RoCheckrideRequestScheduleDateInfoMetaData();
    static RoFlightSchoolExaminer : RoFlightSchoolExaminerMetaData = new RoFlightSchoolExaminerMetaData();
    static RoFlightSchoolExaminerSearch : RoFlightSchoolExaminerSearchMetaData = new RoFlightSchoolExaminerSearchMetaData();
    static DwRole : DwRoleMetaData = new DwRoleMetaData();
    static DwRoMedia : DwRoMediaMetaData = new DwRoMediaMetaData();
    static RoPilotExaminerLocationCurrent : RoPilotExaminerLocationCurrentMetaData = new RoPilotExaminerLocationCurrentMetaData();
    static RoPilotExaminerLocationDistances : RoPilotExaminerLocationDistancesMetaData = new RoPilotExaminerLocationDistancesMetaData();
    static RoPilotExaminerScenario : RoPilotExaminerScenarioMetaData = new RoPilotExaminerScenarioMetaData();
    static RoPlanOfActionAcsFactBase : RoPlanOfActionAcsFactBaseMetaData = new RoPlanOfActionAcsFactBaseMetaData();
    static RoPlanOfActionDetails : RoPlanOfActionDetailsMetaData = new RoPlanOfActionDetailsMetaData();
    static RoPlanOfActionFactBase : RoPlanOfActionFactBaseMetaData = new RoPlanOfActionFactBaseMetaData();
    static RoScheduleBlockSchoolExaminerFinal : RoScheduleBlockSchoolExaminerFinalMetaData = new RoScheduleBlockSchoolExaminerFinalMetaData();
    static RoSchoolExaminers : RoSchoolExaminersMetaData = new RoSchoolExaminersMetaData();
    static RoUnitMemberDpeSupplementSummary : RoUnitMemberDpeSupplementSummaryMetaData = new RoUnitMemberDpeSupplementSummaryMetaData();
    static Schedule : ScheduleMetaData = new ScheduleMetaData();
    static ScheduleBlock : ScheduleBlockMetaData = new ScheduleBlockMetaData();
    static ScheduleBlockAirport : ScheduleBlockAirportMetaData = new ScheduleBlockAirportMetaData();
    static ScheduleBlockCheckRideType : ScheduleBlockCheckRideTypeMetaData = new ScheduleBlockCheckRideTypeMetaData();
    static ScheduleBlockItem : ScheduleBlockItemMetaData = new ScheduleBlockItemMetaData();
    static ScheduleBlockItemCalendarItem : ScheduleBlockItemCalendarItemMetaData = new ScheduleBlockItemCalendarItemMetaData();
    static ScheduleBlockItemStatus : ScheduleBlockItemStatusMetaData = new ScheduleBlockItemStatusMetaData();
    static ScheduleBlockItemType : ScheduleBlockItemTypeMetaData = new ScheduleBlockItemTypeMetaData();
    static ScheduleBlockLocation : ScheduleBlockLocationMetaData = new ScheduleBlockLocationMetaData();
    static ScheduleBlockSchoolBookingOption : ScheduleBlockSchoolBookingOptionMetaData = new ScheduleBlockSchoolBookingOptionMetaData();
    static ScheduleBlockStatus : ScheduleBlockStatusMetaData = new ScheduleBlockStatusMetaData();
    static ScheduleDayOfWeek : ScheduleDayOfWeekMetaData = new ScheduleDayOfWeekMetaData();
    static ScheduleDetail : ScheduleDetailMetaData = new ScheduleDetailMetaData();
    static SchoolFeature : SchoolFeatureMetaData = new SchoolFeatureMetaData();
    static StateProvince : StateProvinceMetaData = new StateProvinceMetaData();
    static StudentApplicant : StudentApplicantMetaData = new StudentApplicantMetaData();
    static Subscription : SubscriptionMetaData = new SubscriptionMetaData();
    static SubscriptionFeature : SubscriptionFeatureMetaData = new SubscriptionFeatureMetaData();
    static SubscriptionParty : SubscriptionPartyMetaData = new SubscriptionPartyMetaData();
    static SubscriptionStatus : SubscriptionStatusMetaData = new SubscriptionStatusMetaData();
    static SubscriptionTier : SubscriptionTierMetaData = new SubscriptionTierMetaData();
    static SubscriptionTierFeature : SubscriptionTierFeatureMetaData = new SubscriptionTierFeatureMetaData();
    static SubscriptionTierStatus : SubscriptionTierStatusMetaData = new SubscriptionTierStatusMetaData();
    static TimeZone : TimeZoneMetaData = new TimeZoneMetaData();
    static TrainingRecord : TrainingRecordMetaData = new TrainingRecordMetaData();
    static TrainingRecordStatus : TrainingRecordStatusMetaData = new TrainingRecordStatusMetaData();
    static TrainingType : TrainingTypeMetaData = new TrainingTypeMetaData();
    static UnitMemberAircraftCategoryClass : UnitMemberAircraftCategoryClassMetaData = new UnitMemberAircraftCategoryClassMetaData();
    static UnitMemberAircraftExperience : UnitMemberAircraftExperienceMetaData = new UnitMemberAircraftExperienceMetaData();
    static UnitMemberAircraftExperienceType : UnitMemberAircraftExperienceTypeMetaData = new UnitMemberAircraftExperienceTypeMetaData();
    static UnitMemberCertificate : UnitMemberCertificateMetaData = new UnitMemberCertificateMetaData();
    static UnitMemberEmployment : UnitMemberEmploymentMetaData = new UnitMemberEmploymentMetaData();
    static UnitMemberFlightExperience : UnitMemberFlightExperienceMetaData = new UnitMemberFlightExperienceMetaData();
    static UnitMemberProfile : UnitMemberProfileMetaData = new UnitMemberProfileMetaData();
    static UnitMemberQualificationOption : UnitMemberQualificationOptionMetaData = new UnitMemberQualificationOptionMetaData();
    static UnitMemberQualificationResponse : UnitMemberQualificationResponseMetaData = new UnitMemberQualificationResponseMetaData();
    static UnitMemberQualificationResponseType : UnitMemberQualificationResponseTypeMetaData = new UnitMemberQualificationResponseTypeMetaData();
    static UnitMemberQualificationType : UnitMemberQualificationTypeMetaData = new UnitMemberQualificationTypeMetaData();
    static DwUser : DwUserMetaData = new DwUserMetaData();
    static DwUserInviteRequest : DwUserInviteRequestMetaData = new DwUserInviteRequestMetaData();
    static UserInviteRequestDetail : UserInviteRequestDetailMetaData = new UserInviteRequestDetailMetaData();
    static DwUserInviteRequestEmail : DwUserInviteRequestEmailMetaData = new DwUserInviteRequestEmailMetaData();
    static UserInviteRequestSchoolBranch : UserInviteRequestSchoolBranchMetaData = new UserInviteRequestSchoolBranchMetaData();
    static DwUserInviteRequestStatus : DwUserInviteRequestStatusMetaData = new DwUserInviteRequestStatusMetaData();
    static DwUserInviteRequestType : DwUserInviteRequestTypeMetaData = new DwUserInviteRequestTypeMetaData();
    static DwUserType : DwUserTypeMetaData = new DwUserTypeMetaData();
    static Queries = new MetaDataQueries();
}
// Generated Entity Interfaces
export interface AcsAreaOfOperationEntity extends DwOrmData {
    // Attributes
    AcsAreaOfOperationId?: number;
    AcsTestId?: number;
    AreaOfOperationName?: string;
    AreaOfOperationOrder?: number;
    AreaOfOperationCode?: string;
    AcsTestPortionId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    AcsTestIdDisplay?: string;
    AcsTestPortionIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    AcsTest? : AcsTestEntity;
    AcsTestPortion? : AcsTestPortionEntity;
    AcsAreaOfOperationTask? : AcsAreaOfOperationTaskEntity[];
    PlanOfActionSection? : PlanOfActionSectionEntity[];
}

export interface AcsAreaOfOperationTaskEntity extends DwOrmData {
    // Attributes
    AcsAreaOfOperationTaskId?: number;
    AcsAreaOfOperationId?: number;
    TaskName?: string;
    TaskOrder?: number;
    TaskCode?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    AcsAreaOfOperationIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    AcsAreaOfOperation? : AcsAreaOfOperationEntity;
    AcsCode? : AcsCodeEntity[];
    PlanOfActionSection? : PlanOfActionSectionEntity[];
}

export interface AcsCodeEntity extends DwOrmData {
    // Attributes
    AcsCodeId?: number;
    AscCodeTypeId?: number;
    AcsCode?: string;
    AcsCodeOrder?: number;
    AcsAreaOfOperationTaskId?: number;
    AscCodeDescription?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    AscCodeTypeIdDisplay?: string;
    AcsAreaOfOperationTaskIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    AcsAreaOfOperationTask? : AcsAreaOfOperationTaskEntity;
    AscCodeTypeIdAcsCodeType? : AcsCodeTypeEntity;
    AcsCode2? : RoAssessmentAcsMissedCodeFactEntity[];
    ApplicantAcsWrittenResultMissedCode? : ApplicantAcsWrittenResultMissedCodeEntity[];
    PlanOfActionRequiredAcsCode? : PlanOfActionRequiredAcsCodeEntity[];
    PlanOfActionSectionQuestion? : PlanOfActionSectionQuestionEntity[];
    QuestionBank? : QuestionBankEntity[];
}

export interface AcsCodeLookupRequestEntity extends DwOrmData {
    // Attributes
    AcsCodeLookupRequestId?: number;
    EmailAddress?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ApplicantAcsWrittenResultId?: number;
    EmailNotes?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ApplicantAcsWrittenResultIdDisplay?: string;

    // Relations
    ApplicantAcsWrittenResult? : ApplicantAcsWrittenResultEntity;
}

export interface AcsCodeSelectionModeEntity extends DwOrmData {
    // Attributes
    AcsCodeSelectionModeId?: number;
    AcsCodeSelectionMode?: string;


    // Relations
}

export interface AcsCodeTypeEntity extends DwOrmData {
    // Attributes
    AcsCodeTypeId?: number;
    AcsCodeTypeName?: string;
    AcsCodeTypeShortName?: string;


    // Relations
    AscCodeTypeIdAcsCode? : AcsCodeEntity[];
}

export interface AcsTestEntity extends DwOrmData {
    // Attributes
    AcsTestId?: number;
    TestName?: string;
    TestDescription?: string;
    CheckRideGroupId?: number;
    TestCode?: string;
    TestExpirationDate?: string;
    AcsTestStatusId?: number;
    AcsTestPdfMediaId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    HasACSCodes?: boolean;
    ShowAdditionalTestResult?: boolean;

    // Display Attributes
    CheckRideGroupIdDisplay?: string;
    AcsTestStatusIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    AcsTestStatus? : AcsTestStatusEntity;
    CheckRideGroup? : CheckRideGroupEntity;
    AcsAreaOfOperation? : AcsAreaOfOperationEntity[];
    AcsTestCheckRideType? : AcsTestCheckRideTypeEntity[];
    ApplicantAcsWrittenResult? : ApplicantAcsWrittenResultEntity[];
    PlanOfAction? : PlanOfActionEntity[];
    QuestionBank? : QuestionBankEntity[];
}

export interface AcsTestCheckRideTypeEntity extends DwOrmData {
    // Attributes
    AcsTestCheckRideTypeId?: number;
    AcsTestId?: number;
    CheckRideTypeId?: number;

    // Display Attributes
    AcsTestIdDisplay?: string;
    CheckRideTypeIdDisplay?: string;

    // Relations
    AcsTest? : AcsTestEntity;
    CheckRideType? : CheckRideTypeEntity;
}

export interface AcsTestPortionEntity extends DwOrmData {
    // Attributes
    AcsTestPortionId?: number;
    AcsTestPortion?: string;
    HeaderClass?: string;
    IconClass?: string;
    AcsTestPortionOrder?: number;
    AllowAcsSections?: boolean;


    // Relations
    AcsAreaOfOperation? : AcsAreaOfOperationEntity[];
    PlanOfActionSection? : PlanOfActionSectionEntity[];
    PlanOfActionSectionType? : PlanOfActionSectionTypeEntity[];
}

export interface AcsTestStatusEntity extends DwOrmData {
    // Attributes
    AcsTestStatusId?: number;
    AcsTestStatus?: string;


    // Relations
    AcsTest? : AcsTestEntity[];
}

export interface AddressEntity extends DwOrmData {
    // Attributes
    AddressId?: number;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceId?: number;
    CountryId?: number;
    CountyName?: string;
    PostalCode?: string;
    PostalCodePlus4?: string;
    Phone?: string;
    Fax?: string;
    Latitude?: number;
    Longitude?: number;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;
    TimezoneId?: number;
    ObservesDst?: boolean;

    // Display Attributes
    StateProvinceIdDisplay?: string;
    CountryIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    TimezoneIdDisplay?: string;

    // Relations
    Country? : CountryEntity;
    StateProvince? : StateProvinceEntity;
    TimeZone? : TimeZoneEntity;
    AirportAirport? : AirportEntity[];
    BranchFlightSchoolBranch? : FlightSchoolBranchEntity[];
    BillingFlightSchoolOrganization? : FlightSchoolOrganizationEntity[];
    HeadquatersFlightSchoolOrganization? : FlightSchoolOrganizationEntity[];
    ApplicantStudentApplicant? : StudentApplicantEntity[];
}

export interface DwAiFunctionEntity extends DwOrmData {
    // Attributes
    AiFunctionId?: number;
    AiFunctionName?: string;


    // Relations
}

export interface DwAiPromptRequestEntity extends DwOrmData {
    // Attributes
    AiPromptRequestId?: number;
    AiPromptSetupId?: number;
    AiPromptRequestStatusId?: number;
    Result?: string;
    SystemPromptAcutal?: string;
    UserPromptActual?: string;
    InputTokens?: number;
    InputCachedTokens?: number;
    OutputTokens?: number;
    TotalCost?: number;
    UsePromptTokens?: boolean;
    ProcessingTimeSeconds?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    LastLogId?: number;

    // Display Attributes
    AiPromptSetupIdDisplay?: string;
    AiPromptRequestStatusIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    LastLogIdDisplay?: string;

    // Relations
    AIPromptRequestIdCheckRideAISummary? : CheckRideAISummaryEntity[];
}

export interface AirportEntity extends DwOrmData {
    // Attributes
    AirportId?: number;
    AviationAuthorityId?: number;
    AirportName?: string;
    AirportCode?: string;
    AirportAddressId?: number;
    Elevation?: number;
    OwnershipCode?: string;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    AviationAuthorityIdDisplay?: string;
    AirportAddressIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    AirportAddress? : AddressEntity;
    AviationAuthority? : AviationAuthorityEntity;
    PreferredApplicantPlaceholder? : ApplicantPlaceholderEntity[];
    ScheduledCheckRideRequest? : CheckRideRequestEntity[];
    PreferredCheckRideRequest? : CheckRideRequestEntity[];
    ProposedCheckRideRequest? : CheckRideRequestEntity[];
    PrimaryTrainingCheckRideRequest? : CheckRideRequestEntity[];
    CheckRideScheduleHold? : CheckRideScheduleHoldEntity[];
    MainFlightSchoolBranch? : FlightSchoolBranchEntity[];
    PilotExaminerLocationAirport? : PilotExaminerLocationAirportEntity[];
    CheckRidePlanOfAction? : PlanOfActionEntity[];
    PrimaryTraningPlanOfAction? : PlanOfActionEntity[];
    RoPilotExaminerLocationDistances? : RoPilotExaminerLocationDistancesEntity[];
    ScheduleBlockAirport? : ScheduleBlockAirportEntity[];
    MainStudentApplicant? : StudentApplicantEntity[];
}

export interface ApplicantAcsWrittenResultEntity extends DwOrmData {
    // Attributes
    ApplicantAcsWrittenResultId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    AcsTestId?: number;
    AcsMissedCodesRaw?: string;
    ApplicantAcsWrittenResultTypeId?: number;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    AcsTestIdDisplay?: string;
    ApplicantAcsWrittenResultTypeIdDisplay?: string;

    // Relations
    AcsTest? : AcsTestEntity;
    ApplicantAcsWrittenResultType? : ApplicantAcsWrittenResultTypeEntity;
    AcsCodeLookupRequest? : AcsCodeLookupRequestEntity[];
    ApplicantAcsWrittenResultMissedCode? : ApplicantAcsWrittenResultMissedCodeEntity[];
    CheckRideRequest? : CheckRideRequestEntity[];
    PostCheckRideResult? : CheckRideResultEntity[];
    FlightSchoolApplicant? : FlightSchoolApplicantEntity[];
    PlanOfAction? : PlanOfActionEntity[];
    PostPlanOfActionResult? : PlanOfActionResultEntity[];
}

export interface ApplicantAcsWrittenResultMissedCodeEntity extends DwOrmData {
    // Attributes
    ApplicantAcsWrittenResultMissedCodeId?: number;
    ApplicantAcsWrittenResultId?: number;
    AcsCodeId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ApplicantAcsWrittenResultIdDisplay?: string;
    AcsCodeIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    AcsCode? : AcsCodeEntity;
    ApplicantAcsWrittenResult? : ApplicantAcsWrittenResultEntity;
}

export interface ApplicantAcsWrittenResultTypeEntity extends DwOrmData {
    // Attributes
    ApplicantAcsWrittenResultTypeId?: number;
    ApplicantAcsWrittenResultType?: string;


    // Relations
    ApplicantAcsWrittenResult? : ApplicantAcsWrittenResultEntity[];
}

export interface ApplicantPlaceholderEntity extends DwOrmData {
    // Attributes
    ApplicantPlaceholderId?: number;
    ApplicantPlaceholderStatusId?: number;
    PilotExaminerId?: number;
    StudentApplicantId?: number;
    CheckRideApplicantTypeId?: number;
    StudentApplicantNameManual?: string;
    StudentApplicantEmailManual?: string;
    StudentApplicantPhoneManual?: string;
    AviationAuthorityId?: number;
    CheckRideGroupId?: number;
    CheckRideTypeId?: number;
    PreferredAirportId?: number;
    PreferredDateTime?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    PilotCertificateNumber?: string;
    FlightSchoolName?: string;
    FlightInstructorName?: string;
    PrivateNotes?: string;
    CheckRideTestTypeId?: number;
    FlightSchoolId?: number;
    FlightSchoolNameOther?: string;
    AuthorityPreCheckRideNumber?: string;
    StudentApplicantCitizenshipCountyId?: number;
    AviationTrainingProgramId?: number;
    OriginalCheckRideRequestId?: number;
    FlightInstructorEmail?: string;
    FlightInstructorPhone?: string;
    LastContactDateTime?: string;
    RankingDateTime?: string;
    DocumentsMediaGroupId?: number;

    // Display Attributes
    ApplicantPlaceholderStatusIdDisplay?: string;
    PilotExaminerIdDisplay?: string;
    StudentApplicantIdDisplay?: string;
    CheckRideApplicantTypeIdDisplay?: string;
    AviationAuthorityIdDisplay?: string;
    CheckRideGroupIdDisplay?: string;
    CheckRideTypeIdDisplay?: string;
    PreferredAirportIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    CheckRideTestTypeIdDisplay?: string;
    FlightSchoolIdDisplay?: string;
    StudentApplicantCitizenshipCountyIdDisplay?: string;
    AviationTrainingProgramIdDisplay?: string;

    // Relations
    PreferredAirport? : AirportEntity;
    ApplicantPlaceholderStatus? : ApplicantPlaceholderStatusEntity;
    AviationAuthority? : AviationAuthorityEntity;
    AviationTrainingProgram? : AviationTrainingProgramEntity;
    CheckRideApplicantType? : CheckRideApplicantTypeEntity;
    CheckRideGroup? : CheckRideGroupEntity;
    CheckRideTestType? : CheckRideTestTypeEntity;
    CheckRideType? : CheckRideTypeEntity;
    StudentApplicantCitizenshipCountyIdCountry? : CountryEntity;
    FlightSchool? : FlightSchoolEntity;
    PilotExaminer? : PilotExaminerEntity;
    StudentApplicant? : StudentApplicantEntity;
    CheckRideRequest? : CheckRideRequestEntity[];
}

export interface ApplicantPlaceholderStatusEntity extends DwOrmData {
    // Attributes
    ApplicantPlaceholderStatusId?: number;
    ApplicantPlaceholderStatus?: string;


    // Relations
    ApplicantPlaceholder? : ApplicantPlaceholderEntity[];
}

export interface AviationAuthorityEntity extends DwOrmData {
    // Attributes
    AviationAuthorityId?: number;
    AuthorityName?: string;


    // Relations
    Airport? : AirportEntity[];
    ApplicantPlaceholder? : ApplicantPlaceholderEntity[];
    AviationAuthorityDistrictOffice? : AviationAuthorityDistrictOfficeEntity[];
    AviationTrainingProgram? : AviationTrainingProgramEntity[];
    CheckRideGroup? : CheckRideGroupEntity[];
    CheckRideRequest? : CheckRideRequestEntity[];
    PilotExaminer? : PilotExaminerEntity[];
    PlanOfAction? : PlanOfActionEntity[];
    StudentApplicant? : StudentApplicantEntity[];
}

export interface AviationAuthorityDistrictOfficeEntity extends DwOrmData {
    // Attributes
    AviationAuthorityDistrictOfficeId?: number;
    AviationAuthorityId?: number;
    DistictOfficeName?: string;
    PhoneNumber?: string;

    // Display Attributes
    AviationAuthorityIdDisplay?: string;

    // Relations
    AviationAuthority? : AviationAuthorityEntity;
    PilotExaminer? : PilotExaminerEntity[];
}

export interface AviationTrainingProgramEntity extends DwOrmData {
    // Attributes
    AviationTrainingProgramId?: number;
    AviationAuthorityId?: number;
    TrainingProgramName?: string;
    TrainingProgramShortName?: string;

    // Display Attributes
    AviationAuthorityIdDisplay?: string;

    // Relations
    AviationAuthority? : AviationAuthorityEntity;
    ApplicantPlaceholder? : ApplicantPlaceholderEntity[];
    AvaiationTrainingProgramIdCheckRideRequest? : CheckRideRequestEntity[];
    FlightSchoolTrainingProgram? : FlightSchoolTrainingProgramEntity[];
    StudentApplicant? : StudentApplicantEntity[];
}

export interface AvionicTypeEntity extends DwOrmData {
    // Attributes
    AvionicTypeId?: number;
    AvionicType?: string;


    // Relations
    CheckRideAvionicType? : CheckRideAvionicTypeEntity[];
}

export interface CalendarEventReferenceEntity extends DwOrmData {
    // Attributes
    CalendarEventReferenceId?: number;
    CalendarReferenceId?: number;
    EventReferenceKey?: string;
    CalendarKey?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    IsCancelled?: boolean;

    // Display Attributes
    CalendarReferenceIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    CalendarReference? : CalendarReferenceEntity;
    CalendarReferenceEventIdCalendarReferenceLog? : CalendarReferenceLogEntity[];
    ScheduledCheckRideRequest? : CheckRideRequestEntity[];
    ScheduleBlockItemCalendarItem? : ScheduleBlockItemCalendarItemEntity[];
}

export interface CalendarOwnerTypeEntity extends DwOrmData {
    // Attributes
    CalendarOwnerTypeId?: number;
    CalendarOwnerType?: string;
    CalendarOwnerTypeMeaning?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    CalendarSyncRequest? : CalendarSyncRequestEntity[];
}

export interface CalendarReferenceEntity extends DwOrmData {
    // Attributes
    CalendarReferenceId?: number;
    CalendarReferenceTypeId?: number;
    MainCalendarKey?: string;
    RefreshSecretKey?: string;
    InitialSecretKey?: string;
    CalendarConfigJSON?: string;
    CalendarIsSetup?: boolean;
    RefreshCount?: number;
    LastRefreshDateTime?: string;
    CalendarHasErrors?: boolean;
    LastCalendarErrorDateTime?: string;
    MainCalendarTimezone?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CalendarReferenceTypeIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    CalendarReferenceType? : CalendarReferenceTypeEntity;
    CalendarEventReference? : CalendarEventReferenceEntity[];
    CalendarReferenceLog? : CalendarReferenceLogEntity[];
    CalendarSyncRequest? : CalendarSyncRequestEntity[];
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity[];
    PilotExaminer? : PilotExaminerEntity[];
}

export interface CalendarReferenceLogEntity extends DwOrmData {
    // Attributes
    CalendarReferenceLogId?: number;
    CalendarReferenceId?: number;
    LogId?: number;
    CalendarReferenceEventId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CalendarReferenceIdDisplay?: string;
    LogIdDisplay?: string;
    CalendarReferenceEventIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    CalendarReferenceEventIdCalendarEventReference? : CalendarEventReferenceEntity;
    CalendarReference? : CalendarReferenceEntity;
}

export interface CalendarReferenceTypeEntity extends DwOrmData {
    // Attributes
    CalendarReferenceTypeId?: number;
    CalendarReferenceTypeDisplay?: string;
    CalendarReferenceTypeMeaning?: string;


    // Relations
    CalendarReference? : CalendarReferenceEntity[];
}

export interface CalendarSyncRequestEntity extends DwOrmData {
    // Attributes
    CalendarSyncRequestId?: number;
    CalendarSyncRequestSourceTypeId?: number;
    SourceRecordId?: number;
    CalendarSyncRequestSourceSubTypeId?: number;
    CalendarOwnerTypeId?: number;
    CalendarOwnerRecordId?: number;
    PilotExaminerId?: number;
    FlightSchoolOrganizationId?: number;
    CalendarReferenceId?: number;
    CalendarSyncRequestActionTypeId?: number;
    CalendarSyncRequestStatusId?: number;
    RequestKey?: string;
    SourceModifiedDateTime?: string;
    SourceFingerprint?: string;
    PayloadJson?: string;
    AttemptCount?: number;
    MaxAttemptCount?: number;
    NextAttemptDateTime?: string;
    LastAttemptDateTime?: string;
    ClaimedDateTime?: string;
    LastCompletedDateTime?: string;
    CalendarSyncRequestErrorTypeId?: number;
    LastErrorMessage?: string;
    LastProviderStatusCode?: number;
    LastProviderRetryAfterDateTime?: string;
    LastResultJson?: string;
    SupersededByCalendarSyncRequestId?: number;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CalendarSyncRequestSourceTypeIdDisplay?: string;
    CalendarSyncRequestSourceSubTypeIdDisplay?: string;
    CalendarOwnerTypeIdDisplay?: string;
    PilotExaminerIdDisplay?: string;
    FlightSchoolOrganizationIdDisplay?: string;
    CalendarReferenceIdDisplay?: string;
    CalendarSyncRequestActionTypeIdDisplay?: string;
    CalendarSyncRequestStatusIdDisplay?: string;
    CalendarSyncRequestErrorTypeIdDisplay?: string;
    SupersededByCalendarSyncRequestIdDisplay?: string;

    // Relations
    CalendarOwnerType? : CalendarOwnerTypeEntity;
    CalendarReference? : CalendarReferenceEntity;
    CalendarSyncRequestActionType? : CalendarSyncRequestActionTypeEntity;
    CalendarSyncRequestErrorType? : CalendarSyncRequestErrorTypeEntity;
    CalendarSyncRequestSourceSubType? : CalendarSyncRequestSourceSubTypeEntity;
    CalendarSyncRequestSourceType? : CalendarSyncRequestSourceTypeEntity;
    CalendarSyncRequestStatus? : CalendarSyncRequestStatusEntity;
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    PilotExaminer? : PilotExaminerEntity;
    SupersededByCalendarSyncRequest? : CalendarSyncRequestEntity;
    RoCalendarSyncRequestDisplay? : RoCalendarSyncRequestDisplayEntity[];
    // Duplicate property excluded
    // SupersededByCalendarSyncRequest : CalendarSyncRequestEntity[];
}

export interface CalendarSyncRequestActionTypeEntity extends DwOrmData {
    // Attributes
    CalendarSyncRequestActionTypeId?: number;
    CalendarSyncRequestActionType?: string;
    CalendarSyncRequestActionTypeMeaning?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    CalendarSyncRequest? : CalendarSyncRequestEntity[];
}

export interface CalendarSyncRequestErrorTypeEntity extends DwOrmData {
    // Attributes
    CalendarSyncRequestErrorTypeId?: number;
    CalendarSyncRequestErrorType?: string;
    CalendarSyncRequestErrorTypeMeaning?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    CalendarSyncRequest? : CalendarSyncRequestEntity[];
}

export interface CalendarSyncRequestSourceSubTypeEntity extends DwOrmData {
    // Attributes
    CalendarSyncRequestSourceSubTypeId?: number;
    CalendarSyncRequestSourceSubType?: string;
    CalendarSyncRequestSourceSubTypeMeaning?: string;
    CalendarSyncRequestSourceTypeId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CalendarSyncRequestSourceTypeIdDisplay?: string;

    // Relations
    CalendarSyncRequestSourceType? : CalendarSyncRequestSourceTypeEntity;
    CalendarSyncRequest? : CalendarSyncRequestEntity[];
}

export interface CalendarSyncRequestSourceTypeEntity extends DwOrmData {
    // Attributes
    CalendarSyncRequestSourceTypeId?: number;
    CalendarSyncRequestSourceType?: string;
    CalendarSyncRequestSourceTypeMeaning?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    CalendarSyncRequest? : CalendarSyncRequestEntity[];
    CalendarSyncRequestSourceSubType? : CalendarSyncRequestSourceSubTypeEntity[];
}

export interface CalendarSyncRequestStatusEntity extends DwOrmData {
    // Attributes
    CalendarSyncRequestStatusId?: number;
    CalendarSyncRequestStatus?: string;
    CalendarSyncRequestStatusMeaning?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    CalendarSyncRequest? : CalendarSyncRequestEntity[];
}

export interface CheckRideAISummaryEntity extends DwOrmData {
    // Attributes
    CheckRideAISummaryId?: number;
    CheckRideRequestId?: number;
    PlanOfActionId?: number;
    CheckRideAISummaryStatusId?: number;
    AIPromptRequestId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    SummaryHeading?: string;
    SummaryFull?: string;
    SummaryIssues?: string;

    // Display Attributes
    CheckRideRequestIdDisplay?: string;
    PlanOfActionIdDisplay?: string;
    CheckRideAISummaryStatusIdDisplay?: string;
    AIPromptRequestIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    AIPromptRequestIdDwAiPromptRequest? : DwAiPromptRequestEntity;
    CheckRideAISummaryStatus? : CheckRideAISummaryStatusEntity;
    CheckRideRequest? : CheckRideRequestEntity;
    PlanOfAction? : PlanOfActionEntity;
}

export interface CheckRideAISummaryStatusEntity extends DwOrmData {
    // Attributes
    CheckRideAISummaryStatusId?: number;
    CheckRideAISummaryStatus?: string;


    // Relations
    CheckRideAISummary? : CheckRideAISummaryEntity[];
}

export interface CheckRideApplicantTypeEntity extends DwOrmData {
    // Attributes
    CheckRideApplicantTypeId?: number;
    ApplicantType?: string;


    // Relations
    ApplicantPlaceholder? : ApplicantPlaceholderEntity[];
    CheckRideRequest? : CheckRideRequestEntity[];
    PlanOfAction? : PlanOfActionEntity[];
}

export interface CheckRideAvionicTypeEntity extends DwOrmData {
    // Attributes
    CheckRideAvionicTypeId?: number;
    CheckRideRequestId?: number;
    AvionicTypeId?: number;

    // Display Attributes
    CheckRideRequestIdDisplay?: string;
    AvionicTypeIdDisplay?: string;

    // Relations
    AvionicType? : AvionicTypeEntity;
    CheckRideRequest? : CheckRideRequestEntity;
}

export interface CheckRideCancellationTypeEntity extends DwOrmData {
    // Attributes
    CheckRideCancellationTypeId?: number;
    CancellationTypeDisplay?: string;
    CancelOrder?: number;


    // Relations
    CheckRideRequest? : CheckRideRequestEntity[];
}

export interface CheckRideExaminerTypeEntity extends DwOrmData {
    // Attributes
    CheckRideExaminerTypeId?: number;
    CheckRideExaminerType?: string;


    // Relations
    CheckRideRequest? : CheckRideRequestEntity[];
    PlanOfAction? : PlanOfActionEntity[];
}

export interface CheckRideGroupEntity extends DwOrmData {
    // Attributes
    CheckRideGroupId?: number;
    AviationAuthorityId?: number;
    CheckRideGroup?: string;
    GroupOrder?: number;

    // Display Attributes
    AviationAuthorityIdDisplay?: string;

    // Relations
    AviationAuthority? : AviationAuthorityEntity;
    AcsTest? : AcsTestEntity[];
    ApplicantPlaceholder? : ApplicantPlaceholderEntity[];
    CheckRideRequest? : CheckRideRequestEntity[];
    CheckRideRequestPilotCertificate? : CheckRideRequestPilotCertificateEntity[];
    CheckRideScenario? : CheckRideScenarioEntity[];
    CheckRideType? : CheckRideTypeEntity[];
    FlightSchoolApplicant? : FlightSchoolApplicantEntity[];
    PlanOfAction? : PlanOfActionEntity[];
}

export interface CheckRideInstructorTypeEntity extends DwOrmData {
    // Attributes
    CheckRideInstructorTypeId?: number;
    CheckRideInstructorType?: string;


    // Relations
    CheckRideRequest? : CheckRideRequestEntity[];
    FlightSchoolApplicant? : FlightSchoolApplicantEntity[];
    PlanOfAction? : PlanOfActionEntity[];
}

export interface CheckRideOutcomeEntity extends DwOrmData {
    // Attributes
    CheckRideOutcomeId?: number;
    CheckRideOutcome?: string;
    AllowRetest?: boolean;
    IsStageCheckOutcome?: boolean;
    AllowFlagStudent?: boolean;
    IsIncomplete?: boolean;


    // Relations
    CheckRideResult? : CheckRideResultEntity[];
    PlanOfActionResult? : PlanOfActionResultEntity[];
}

export interface CheckRideOwnershipTypeEntity extends DwOrmData {
    // Attributes
    CheckRideOwnershipTypeId?: number;
    CheckRideOwnershipType?: string;


    // Relations
    CheckRideRequest? : CheckRideRequestEntity[];
    PlanOfAction? : PlanOfActionEntity[];
    QuestionBank? : QuestionBankEntity[];
    OwnershipTypeIdScheduleBlock? : ScheduleBlockEntity[];
    OwnershipTypeIdTrainingRecord? : TrainingRecordEntity[];
}

export interface CheckRidePaymentEntity extends DwOrmData {
    // Attributes
    CheckRidePaymentId?: number;
    PaymentTypeId?: number;
    PaymentMethodId?: number;
    PaymentDateTime?: string;
    PaymentAmount?: number;
    CheckRideRequestId?: number;
    PaymentReferenceId?: number;
    PaymentReferenceText?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    PaymentDiscountid?: number;
    PaymentPartyId?: number;
    EmailCCReceipt?: string;

    // Display Attributes
    PaymentTypeIdDisplay?: string;
    PaymentMethodIdDisplay?: string;
    CheckRideRequestIdDisplay?: string;
    PaymentReferenceIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    PaymentDiscountidDisplay?: string;
    PaymentPartyIdDisplay?: string;

    // Relations
    CheckRideRequest? : CheckRideRequestEntity;
    PaymentPartyIdCheckRideRequestPaymentParty? : CheckRideRequestPaymentPartyEntity;
    PaymentDiscountidPaymentDiscountCode? : PaymentDiscountCodeEntity;
    PaymentMethod? : PaymentMethodEntity;
    PaymentReference? : PaymentReferenceEntity;
    PaymentType? : PaymentTypeEntity;
    PilexosBookingCheckRideRequest? : CheckRideRequestEntity[];
    PaymentAttempt? : PaymentAttemptEntity[];
}

export interface CheckRideRequestEntity extends DwOrmData {
    // Attributes
    CheckRideRequestId?: number;
    StudentApplicantId?: number;
    AviationAuthorityId?: number;
    CheckRideTypeId?: number;
    CheckRideTestTypeId?: number;
    PilotCertificateNumber?: string;
    CheckRideRequestSubStatusId?: number;
    PreferredDateTime?: string;
    ScheduledTimeMinutes?: number;
    ScheduledPilotExaminerId?: number;
    ScheduledPreTimeMinutes?: number;
    ScheduledPostTimeMinutes?: number;
    AuthorityPreCheckRideNumber?: string;
    AirplaneMakeModel?: string;
    AirplaneNNumber?: string;
    DocumentsMediaGroupId?: number;
    AuthorityPreapprovalCode?: string;
    CheckRideGroupId?: number;
    CancellationNotes?: string;
    PreferredAirportId?: number;
    ScheduledAirportId?: number;
    ScheduledDateTime?: string;
    ScheduledCheckRideScenarioId?: number;
    MedicalCertificateMediaId?: number;
    LogBookMediaId?: number;
    AdditionalDocumentationNotes?: string;
    TrainingMediaId?: number;
    ScheduledCalendarEventReferenceId?: number;
    EndorsedAndCheckRideReady?: boolean;
    ScheduledPilotExaminerLocationId?: number;
    ProposedDateTime?: string;
    ProposedAirportId?: number;
    ProposedTimeMinutes?: number;
    ProposedCalendarEventReferenceId?: number;
    ScheduledCheckRideCost?: number;
    AdditionalTravelCost?: number;
    PilexosBookingCost?: number;
    ExaminerBookingCost?: number;
    RejectedNotes?: string;
    MoreInfoRequestedNotes?: string;
    PilexosBookingPaymentAdded?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    AvaiationTrainingProgramId?: number;
    CheckRideApplicantTypeId?: number;
    StudentApplicantNameManual?: string;
    StudentApplicantEmailManual?: string;
    StudentApplicantPhoneManual?: string;
    ExaminerPrivateNotes?: string;
    ExaminerToApplicantNotes?: string;
    ExaminerToApplicantMediaGroupId?: number;
    IsAirplaneAirworthy?: boolean;
    EmailApplicantReceipt?: boolean;
    CheckRideCancellationTypeId?: number;
    CheckRideCancellationTypeOther?: string;
    PilexosBookingCostPaymentPartyId?: number;
    FlightSchoolName?: string;
    EmailCCReceipt?: string;
    CancelledRequestBookingFeeRefund?: boolean;
    PilexosBookingCheckRidePaymentId?: number;
    ScheduleAirportLocationNotes?: string;
    AuthorityApprovalCode?: string;
    FlightInstructorName?: string;
    ApplicantPlaceholderId?: number;
    AddToWaitlist?: boolean;
    FlightSchoolId?: number;
    FlightSchoolNameOther?: string;
    StudentApplicantCitizenshipCountyId?: number;
    AirmanKnowledgeTestScore?: number;
    FlightInstructorCertificateNumber?: string;
    CurrentPilotCertifiateTypeId?: number;
    FlightInstructorEmail?: string;
    FlightInstructorPhone?: string;
    ApplicantAcsWrittenResultId?: number;
    AirmanKnowledgeTestDate?: string;
    AirmanKnowledgeTestPDFMediaId?: number;
    ExamScenarioNotes?: string;
    FlightSchoolCertificateNumber?: string;
    CheckRideExaminerTypeId?: number;
    CheckRideOwnershipTypeId?: number;
    FlightSchoolOrganizationId?: number;
    FlightSchoolApplicantId?: number;
    FlightSchoolExaminerId?: number;
    FlightSchoolBranchId?: number;
    ForeignPilotMeetsQualifications?: boolean;
    IsGPSWAASEquiped?: boolean;
    AuthorityApplicationNumber?: string;
    ElectronicFlightBagTypeId?: number;
    FlightSchoolInstructorId?: number;
    CheckRideAcceptedDateTime?: string;
    FlightSchoolPrivateNotes?: string;
    CheckRideWorkflowId?: number;
    PrimaryTrainingAirportId?: number;
    StudentApplicantStateProvinceId?: number;
    StudentEndOfCourseDate?: string;
    CheckRideExpirationDate?: string;
    EndorsedDate?: string;
    ExaminerLastSendDateTime?: string;
    SendExaminerCheckrideEmails?: boolean;
    AdditionalAirmanKnowledgeTestScore?: number;
    AdditionalAirmanKnowledgeTestDate?: string;
    AdditionalAirmanKnowledgeTestPDFMediaId?: number;
    CheckRideInstructorTypeId?: number;
    FlightSchoolTypeId?: number;
    OdaFlightSchoolId?: number;
    SendApplicantCheckrideEmails?: boolean;

    // Display Attributes
    StudentApplicantIdDisplay?: string;
    AviationAuthorityIdDisplay?: string;
    CheckRideTypeIdDisplay?: string;
    CheckRideTestTypeIdDisplay?: string;
    CheckRideRequestSubStatusIdDisplay?: string;
    ScheduledTimeMinutesDisplay?: string;
    ScheduledPilotExaminerIdDisplay?: string;
    DocumentsMediaGroupIdDisplay?: string;
    CheckRideGroupIdDisplay?: string;
    PreferredAirportIdDisplay?: string;
    ScheduledAirportIdDisplay?: string;
    ScheduledCheckRideScenarioIdDisplay?: string;
    MedicalCertificateMediaIdDisplay?: string;
    LogBookMediaIdDisplay?: string;
    ScheduledPilotExaminerLocationIdDisplay?: string;
    ProposedAirportIdDisplay?: string;
    ProposedTimeMinutesDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    AvaiationTrainingProgramIdDisplay?: string;
    CheckRideApplicantTypeIdDisplay?: string;
    CheckRideCancellationTypeIdDisplay?: string;
    PilexosBookingCostPaymentPartyIdDisplay?: string;
    PilexosBookingCheckRidePaymentIdDisplay?: string;
    ApplicantPlaceholderIdDisplay?: string;
    FlightSchoolIdDisplay?: string;
    StudentApplicantCitizenshipCountyIdDisplay?: string;
    CurrentPilotCertifiateTypeIdDisplay?: string;
    ApplicantAcsWrittenResultIdDisplay?: string;
    AirmanKnowledgeTestPDFMediaIdDisplay?: string;
    CheckRideExaminerTypeIdDisplay?: string;
    CheckRideOwnershipTypeIdDisplay?: string;
    FlightSchoolOrganizationIdDisplay?: string;
    FlightSchoolApplicantIdDisplay?: string;
    FlightSchoolExaminerIdDisplay?: string;
    FlightSchoolBranchIdDisplay?: string;
    ElectronicFlightBagTypeIdDisplay?: string;
    FlightSchoolInstructorIdDisplay?: string;
    CheckRideWorkflowIdDisplay?: string;
    PrimaryTrainingAirportIdDisplay?: string;
    StudentApplicantStateProvinceIdDisplay?: string;
    CheckRideInstructorTypeIdDisplay?: string;
    FlightSchoolTypeIdDisplay?: string;
    OdaFlightSchoolIdDisplay?: string;

    // Relations
    ScheduledAirport? : AirportEntity;
    PreferredAirport? : AirportEntity;
    ProposedAirport? : AirportEntity;
    PrimaryTrainingAirport? : AirportEntity;
    ApplicantAcsWrittenResult? : ApplicantAcsWrittenResultEntity;
    ApplicantPlaceholder? : ApplicantPlaceholderEntity;
    AviationAuthority? : AviationAuthorityEntity;
    AvaiationTrainingProgramIdAviationTrainingProgram? : AviationTrainingProgramEntity;
    ScheduledCalendarEventReference? : CalendarEventReferenceEntity;
    CheckRideApplicantType? : CheckRideApplicantTypeEntity;
    CheckRideCancellationType? : CheckRideCancellationTypeEntity;
    CheckRideExaminerType? : CheckRideExaminerTypeEntity;
    CheckRideGroup? : CheckRideGroupEntity;
    CheckRideInstructorType? : CheckRideInstructorTypeEntity;
    CheckRideOwnershipType? : CheckRideOwnershipTypeEntity;
    PilexosBookingCheckRidePayment? : CheckRidePaymentEntity;
    PilexosBookingCostPaymentPartyIdCheckRideRequestPaymentParty? : CheckRideRequestPaymentPartyEntity;
    CheckRideRequestSubStatus? : CheckRideRequestSubStatusEntity;
    ScheduledCheckRideScenario? : CheckRideScenarioEntity;
    CheckRideTestType? : CheckRideTestTypeEntity;
    CheckRideType? : CheckRideTypeEntity;
    CheckRideWorkflow? : CheckRideWorkflowEntity;
    StudentApplicantCitizenshipCountyIdCountry? : CountryEntity;
    ElectronicFlightBagType? : ElectronicFlightBagTypeEntity;
    FlightSchool? : FlightSchoolEntity;
    OdaFlightSchool? : FlightSchoolEntity;
    FlightSchoolApplicant? : FlightSchoolApplicantEntity;
    FlightSchoolBranch? : FlightSchoolBranchEntity;
    FlightSchoolExaminer? : FlightSchoolExaminerEntity;
    FlightSchoolInstructor? : FlightSchoolInstructorEntity;
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    FlightSchoolType? : FlightSchoolTypeEntity;
    DocumentsDwMediaGroup? : DwMediaGroupEntity;
    CurrentPilotCertifiateTypeIdPilotCertificateType? : PilotCertificateTypeEntity;
    ScheduledPilotExaminer? : PilotExaminerEntity;
    ScheduledPilotExaminerLocation? : PilotExaminerLocationEntity;
    StudentApplicantStateProvince? : StateProvinceEntity;
    StudentApplicant? : StudentApplicantEntity;
    CheckRideAISummary? : CheckRideAISummaryEntity[];
    CheckRideAvionicType? : CheckRideAvionicTypeEntity[];
    CheckRidePayment? : CheckRidePaymentEntity[];
    CheckRideRequestNote? : CheckRideRequestNoteEntity[];
    CheckRideRequestPilotCertificate? : CheckRideRequestPilotCertificateEntity[];
    CheckRideResult? : CheckRideResultEntity;
    CheckRideScheduleHold? : CheckRideScheduleHoldEntity[];
    PlanOfAction? : PlanOfActionEntity;
    CheckrideRequestIdRoCheckrideAggregateUtil? : RoCheckrideAggregateUtilEntity;
    RoCheckrideApplicantFinalName? : RoCheckrideApplicantFinalNameEntity;
    RoCheckRideRequestApplicant? : RoCheckRideRequestApplicantEntity;
    CheckrideRequestIdRoCheckrideRequestScheduleDateInfo? : RoCheckrideRequestScheduleDateInfoEntity;
}

export interface CheckRideRequestNoteEntity extends DwOrmData {
    // Attributes
    CheckRideRequestNoteId?: number;
    CheckRideRequestId?: number;
    NoteContent?: string;

    // Display Attributes
    CheckRideRequestIdDisplay?: string;

    // Relations
    CheckRideRequest? : CheckRideRequestEntity;
}

export interface CheckRideRequestPaymentPartyEntity extends DwOrmData {
    // Attributes
    CheckRideRequestPaymentPartyId?: number;
    PaymentPartyDisplay?: string;
    IsActive?: boolean;
    PaymentPartyDescription?: string;
    PilexosBookingCost?: number;
    PilexosBookingRetestCost?: number;


    // Relations
    PaymentPartyIdCheckRidePayment? : CheckRidePaymentEntity[];
    PilexosBookingCostPaymentPartyIdCheckRideRequest? : CheckRideRequestEntity[];
    PilexosBookingCostPaymentPartyIdFlightSchoolOrganization? : FlightSchoolOrganizationEntity[];
    PaymentCustomerReference? : PaymentCustomerReferenceEntity[];
}

export interface CheckRideRequestPilotCertificateEntity extends DwOrmData {
    // Attributes
    CheckRideRequestPilotCertificateId?: number;
    CheckRideRequestId?: number;
    CheckRideGroupId?: number;
    CheckRideTypeId?: number;

    // Display Attributes
    CheckRideRequestIdDisplay?: string;
    CheckRideGroupIdDisplay?: string;
    CheckRideTypeIdDisplay?: string;

    // Relations
    CheckRideGroup? : CheckRideGroupEntity;
    CheckRideRequest? : CheckRideRequestEntity;
    CheckRideType? : CheckRideTypeEntity;
}

export interface CheckRideRequestStatusEntity extends DwOrmData {
    // Attributes
    CheckRideRequestStatusId?: number;
    CheckRideRequestStatus?: string;


    // Relations
    CheckRideRequestSubStatus? : CheckRideRequestSubStatusEntity[];
}

export interface CheckRideRequestSubStatusEntity extends DwOrmData {
    // Attributes
    CheckRideRequestSubStatusId?: number;
    CheckRideRequestStatusId?: number;
    CheckRideRequestSubStatus?: string;
    WorkflowStatusDetailId?: number;
    ApplicantNotes?: string;
    ExaminerNotes?: string;
    ApplicantStatusLevelId?: number;
    ExaminerStatusLevelId?: number;
    ApplicantAllowEdit?: boolean;
    ApplicantAllowExaminerChange?: boolean;
    ExaminerAllowEdit?: boolean;
    OutcomeIsRequested?: number;
    OutcomeIsCancelled?: number;
    OutcomeIsBooked?: number;
    OutcomeIsComplete?: number;
    SchoolAllowEdit?: boolean;
    SchoolNotes?: string;
    SchoolStatusLevelId?: number;
    SchoolManualAllowEdit?: boolean;
    SchoolManualNotes?: string;
    SchoolManualStatusLevelId?: number;
    SchoolAllowExaminerChange?: boolean;

    // Display Attributes
    CheckRideRequestStatusIdDisplay?: string;
    WorkflowStatusDetailIdDisplay?: string;
    ApplicantStatusLevelIdDisplay?: string;
    ExaminerStatusLevelIdDisplay?: string;
    SchoolStatusLevelIdDisplay?: string;
    SchoolManualStatusLevelIdDisplay?: string;

    // Relations
    CheckRideRequestStatus? : CheckRideRequestStatusEntity;
    ApplicantStatusLevelIdCheckRideStatusLevel? : CheckRideStatusLevelEntity;
    ExaminerStatusLevelIdCheckRideStatusLevel? : CheckRideStatusLevelEntity;
    SchoolStatusLevelIdCheckRideStatusLevel? : CheckRideStatusLevelEntity;
    SchoolManualStatusLevelIdCheckRideStatusLevel? : CheckRideStatusLevelEntity;
    CheckRideRequest? : CheckRideRequestEntity[];
}

export interface CheckRideResultEntity extends DwOrmData {
    // Attributes
    CheckRideResultId?: number;
    CheckRideRequestId?: number;
    CheckRideDateTime?: string;
    CheckRideOutcomeId?: number;
    AllowRetest?: boolean;
    AllowRetestReason?: string;
    RetestCost?: number;
    FlagApplicant?: boolean;
    FlagApplicantNotes?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    AddToWaitlist?: boolean;
    GroundPortionComplete?: boolean;
    PostApplicantAcsWrittenResultId?: number;

    // Display Attributes
    CheckRideOutcomeIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    PostApplicantAcsWrittenResultIdDisplay?: string;

    // Relations
    PostApplicantAcsWrittenResult? : ApplicantAcsWrittenResultEntity;
    CheckRideOutcome? : CheckRideOutcomeEntity;
    CheckRideRequest? : CheckRideRequestEntity;
}

export interface CheckRideScenarioEntity extends DwOrmData {
    // Attributes
    CheckRideScenarioId?: number;
    PilotExaminerId?: number;
    ScenarioName?: string;
    TimeRequiredHours?: number;
    PreTimeMinutes?: number;
    PostTimeMinutes?: number;
    CheckRideCost?: number;
    RetestCost?: number;
    DiscontinuedRetestCost?: number;
    DocumentsMediaGroupId?: number;
    RequiredDocumentNotes?: string;
    BookingCost?: number;
    CheckRideGroupId?: number;
    IsActive?: boolean;
    TravelCost?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    TimeRequiredMinutes?: number;
    RetestFlightOnlyCost?: number;
    DiscontinuedRetestFlightOnlyCost?: number;
    RetestFlightOnlyTimeReqirementMinutes?: number;
    RetestTimeRequiredMinutes?: number;
    RetestFlightOnlyTimeRequiredMinutes?: number;
    DiscontinuedTimeRequiredMinutes?: number;
    DiscontinuedFlightOnlyTimeRequiredMinutes?: number;

    // Display Attributes
    PilotExaminerIdDisplay?: string;
    CheckRideGroupIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    TimeRequiredMinutesDisplay?: string;
    RetestFlightOnlyTimeReqirementMinutesDisplay?: string;
    RetestTimeRequiredMinutesDisplay?: string;
    RetestFlightOnlyTimeRequiredMinutesDisplay?: string;
    DiscontinuedTimeRequiredMinutesDisplay?: string;
    DiscontinuedFlightOnlyTimeRequiredMinutesDisplay?: string;

    // Relations
    CheckRideGroup? : CheckRideGroupEntity;
    PilotExaminer? : PilotExaminerEntity;
    ScheduledCheckRideRequest? : CheckRideRequestEntity[];
    CheckRideScenarioTypeMap? : CheckRideScenarioTypeMapEntity[];
    RoPilotExaminerScenario? : RoPilotExaminerScenarioEntity[];
}

export interface CheckRideScenarioTypeMapEntity extends DwOrmData {
    // Attributes
    CheckRideScenarioTypeMapId?: number;
    CheckRideScenarioId?: number;
    CheckRideTypeId?: number;

    // Display Attributes
    CheckRideScenarioIdDisplay?: string;
    CheckRideTypeIdDisplay?: string;

    // Relations
    CheckRideScenario? : CheckRideScenarioEntity;
    CheckRideType? : CheckRideTypeEntity;
}

export interface CheckRideScheduleHoldEntity extends DwOrmData {
    // Attributes
    CheckRideScheduleHoldId?: number;
    PilotExaminerId?: number;
    CheckRideDateTime?: string;
    AirportId?: number;
    StartDateTime?: string;
    ExpirationDateTime?: string;
    CheckRideRequestId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    UserId?: number;
    DurationMinutes?: number;

    // Display Attributes
    PilotExaminerIdDisplay?: string;
    AirportIdDisplay?: string;
    CheckRideRequestIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    UserIdDisplay?: string;

    // Relations
    Airport? : AirportEntity;
    CheckRideRequest? : CheckRideRequestEntity;
    PilotExaminer? : PilotExaminerEntity;
    UserIdStudentApplicant? : StudentApplicantEntity;
    CreatedByDwUser? : DwUserEntity;
    ModifiedByDwUser? : DwUserEntity;
}

export interface CheckRideStatusLevelEntity extends DwOrmData {
    // Attributes
    CheckRideStatusLevelId?: number;
    StatusLevelDisplay?: string;


    // Relations
    ApplicantStatusLevelIdCheckRideRequestSubStatus? : CheckRideRequestSubStatusEntity[];
    ExaminerStatusLevelIdCheckRideRequestSubStatus? : CheckRideRequestSubStatusEntity[];
    SchoolStatusLevelIdCheckRideRequestSubStatus? : CheckRideRequestSubStatusEntity[];
    SchoolManualStatusLevelIdCheckRideRequestSubStatus? : CheckRideRequestSubStatusEntity[];
}

export interface CheckRideTestAttemptClassificationEntity extends DwOrmData {
    // Attributes
    CheckRideTestAttemptClassificationId?: number;
    AttemptClassification?: string;


    // Relations
    CheckRideTestType? : CheckRideTestTypeEntity[];
}

export interface CheckRideTestTypeEntity extends DwOrmData {
    // Attributes
    CheckRideTestTypeId?: number;
    TestType?: string;
    UseStageCheckOutcomes?: boolean;
    ReTestCheckrideTestTypeId?: number;
    ReTestFlightOnlyCheckrideTestTypeId?: number;
    IncompleteTestTypeId?: number;
    IncompleteFlightOnlyTestTypeId?: number;
    CheckRideTestAttemptClassificationId?: number;

    // Display Attributes
    ReTestCheckrideTestTypeIdDisplay?: string;
    ReTestFlightOnlyCheckrideTestTypeIdDisplay?: string;
    IncompleteTestTypeIdDisplay?: string;
    IncompleteFlightOnlyTestTypeIdDisplay?: string;
    CheckRideTestAttemptClassificationIdDisplay?: string;

    // Relations
    CheckRideTestAttemptClassification? : CheckRideTestAttemptClassificationEntity;
    IncompleteFlightOnlyTestTypeIdCheckRideTestType? : CheckRideTestTypeEntity;
    IncompleteTestTypeIdCheckRideTestType? : CheckRideTestTypeEntity;
    ReTestCheckrideTestTypeIdCheckRideTestType? : CheckRideTestTypeEntity;
    ReTestFlightOnlyCheckrideTestTypeIdCheckRideTestType? : CheckRideTestTypeEntity;
    ApplicantPlaceholder? : ApplicantPlaceholderEntity[];
    CheckRideRequest? : CheckRideRequestEntity[];
    FlightSchoolApplicant? : FlightSchoolApplicantEntity[];
    // Duplicate property excluded
    // IncompleteFlightOnlyTestTypeIdCheckRideTestType : CheckRideTestTypeEntity[];
    // Duplicate property excluded
    // IncompleteTestTypeIdCheckRideTestType : CheckRideTestTypeEntity[];
    PlanOfAction? : PlanOfActionEntity[];
    // Duplicate property excluded
    // ReTestCheckrideTestTypeIdCheckRideTestType : CheckRideTestTypeEntity[];
    // Duplicate property excluded
    // ReTestFlightOnlyCheckrideTestTypeIdCheckRideTestType : CheckRideTestTypeEntity[];
}

export interface CheckRideTypeEntity extends DwOrmData {
    // Attributes
    CheckRideTypeId?: number;
    CheckRideGroupId?: number;
    CheckRideType?: string;
    CheckRideDesignation?: string;
    TypeOrder?: number;
    TimeRequiredMinutes?: number;
    RetestTimeRequiredMinutes?: number;
    RetestFlightOnlyTimeRequiredMinutes?: number;
    DiscontinuedTimeRequiredMinutes?: number;
    DiscontinuedFlightOnlyTimeRequiredMinutes?: number;
    ReportShortName?: string;

    // Display Attributes
    CheckRideGroupIdDisplay?: string;
    TimeRequiredMinutesDisplay?: string;
    RetestTimeRequiredMinutesDisplay?: string;
    RetestFlightOnlyTimeRequiredMinutesDisplay?: string;
    DiscontinuedTimeRequiredMinutesDisplay?: string;
    DiscontinuedFlightOnlyTimeRequiredMinutesDisplay?: string;

    // Relations
    CheckRideGroup? : CheckRideGroupEntity;
    AcsTestCheckRideType? : AcsTestCheckRideTypeEntity[];
    ApplicantPlaceholder? : ApplicantPlaceholderEntity[];
    CheckRideRequest? : CheckRideRequestEntity[];
    CheckRideRequestPilotCertificate? : CheckRideRequestPilotCertificateEntity[];
    CheckRideScenarioTypeMap? : CheckRideScenarioTypeMapEntity[];
    FlightSchoolApplicant? : FlightSchoolApplicantEntity[];
    PlanOfAction? : PlanOfActionEntity[];
    ScheduleBlockCheckRideType? : ScheduleBlockCheckRideTypeEntity[];
}

export interface CheckRideWorkflowEntity extends DwOrmData {
    // Attributes
    CheckRideWorkflowId?: number;
    CheckRideWorkflow?: string;
    FlightSchoolStatusLookupId?: number;
    ExaminerStatusLookupId?: number;
    ApplicantStatusLookupId?: number;

    // Display Attributes
    FlightSchoolStatusLookupIdDisplay?: string;
    ExaminerStatusLookupIdDisplay?: string;
    ApplicantStatusLookupIdDisplay?: string;

    // Relations
    CheckRideRequest? : CheckRideRequestEntity[];
}

export interface CountryEntity extends DwOrmData {
    // Attributes
    CountryId?: number;
    CountryName?: string;
    CountryShortName?: string;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Address? : AddressEntity[];
    StudentApplicantCitizenshipCountyIdApplicantPlaceholder? : ApplicantPlaceholderEntity[];
    StudentApplicantCitizenshipCountyIdCheckRideRequest? : CheckRideRequestEntity[];
    CitizenshipFlightSchoolApplicant? : FlightSchoolApplicantEntity[];
    StudentApplicantCitizenshipPlanOfAction? : PlanOfActionEntity[];
    StateProvince? : StateProvinceEntity[];
    CitzenshipCountyIdStudentApplicant? : StudentApplicantEntity[];
}

export interface DurationEntity extends DwOrmData {
    // Attributes
    DurationId?: number;
    DurationMinutes?: number;
    DurationDisplay?: string;


    // Relations
}

export interface ElectronicFlightBagTypeEntity extends DwOrmData {
    // Attributes
    ElectronicFlightBagTypeId?: number;
    ElectronicFlightBagType?: string;


    // Relations
    CheckRideRequest? : CheckRideRequestEntity[];
}

export interface FlightSchoolEntity extends DwOrmData {
    // Attributes
    FlightSchoolId?: number;
    FlightSchoolName?: string;
    IsOther?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    ApplicantPlaceholder? : ApplicantPlaceholderEntity[];
    CheckRideRequest? : CheckRideRequestEntity[];
    OdaCheckRideRequest? : CheckRideRequestEntity[];
    ODAFlightSchoolApplicant? : FlightSchoolApplicantEntity[];
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity[];
    FlightSchoolSetupRequest? : FlightSchoolSetupRequestEntity[];
    PilotExaminerFlightSchoolSetup? : PilotExaminerFlightSchoolSetupEntity[];
    OdaPlanOfAction? : PlanOfActionEntity[];
    ScheduleBlock? : ScheduleBlockEntity[];
}

export interface FlightSchoolApplicantEntity extends DwOrmData {
    // Attributes
    FlightSchoolApplicantId?: number;
    ApplicantName?: string;
    ApplicantEmail?: string;
    ApplicantPhone?: string;
    FlightSchoolApplicantStatusId?: number;
    ExpectedCheckrideDateTime?: string;
    FlightSchoolOrganizationId?: number;
    CheckRideGroupId?: number;
    CheckRideTypeId?: number;
    CheckRideTestTypeId?: number;
    FlightSchoolBranchId?: number;
    IsEndorsed?: boolean;
    EndorsedDate?: string;
    StudentApplicantId?: number;
    PilotCertificateNumber?: string;
    CurrentPilotCertificateTypeId?: number;
    CitizenshipCountryId?: number;
    PrimaryFlightSchoolInstructorId?: number;
    AirplaneMakeModal?: string;
    AuthorityPreCheckRideNumber?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    AuthorityApplicationNumber?: string;
    StateProvinceId?: number;
    ForeignPilotMeetsQualifications?: boolean;
    ApplicantAcsWrittenResultId?: number;
    AirmanKnowledgeTestScore?: number;
    AirmanKnowledgeTestDate?: string;
    AirmanKnowledgeTestPDFMediaId?: number;
    AdditionalDocumentationNotes?: string;
    LogBookMediaId?: number;
    TrainingMediaId?: number;
    AdditionalDocumentsMediaGroupId?: number;
    CurrentCheckRideRequestId?: number;
    PublicPortalSubmission?: boolean;
    EndOfCourseDate?: string;
    FlightSchoolPrivateNotes?: string;
    ExaminerPreferenceNotes?: string;
    AdditionalAirmanKnowledgeTestScore?: number;
    AdditionalAirmanKnowledgeTestDate?: string;
    AdditionalAirmanKnowledgeTestPDFMediaId?: number;
    CheckRideInstructorTypeId?: number;
    FlightInstructorName?: string;
    FlightInstructorEmail?: string;
    FlightSchoolTypeId?: number;
    ODAFlightSchoolId?: number;
    FlightInstructorCertificateNumber?: string;
    FlightInstructorPhone?: string;

    // Display Attributes
    FlightSchoolApplicantStatusIdDisplay?: string;
    FlightSchoolOrganizationIdDisplay?: string;
    CheckRideGroupIdDisplay?: string;
    CheckRideTypeIdDisplay?: string;
    CheckRideTestTypeIdDisplay?: string;
    FlightSchoolBranchIdDisplay?: string;
    StudentApplicantIdDisplay?: string;
    CurrentPilotCertificateTypeIdDisplay?: string;
    CitizenshipCountryIdDisplay?: string;
    PrimaryFlightSchoolInstructorIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    StateProvinceIdDisplay?: string;
    ApplicantAcsWrittenResultIdDisplay?: string;
    CheckRideInstructorTypeIdDisplay?: string;
    FlightSchoolTypeIdDisplay?: string;
    ODAFlightSchoolIdDisplay?: string;

    // Relations
    ApplicantAcsWrittenResult? : ApplicantAcsWrittenResultEntity;
    CheckRideGroup? : CheckRideGroupEntity;
    CheckRideInstructorType? : CheckRideInstructorTypeEntity;
    CheckRideTestType? : CheckRideTestTypeEntity;
    CheckRideType? : CheckRideTypeEntity;
    CitizenshipCountry? : CountryEntity;
    ODAFlightSchool? : FlightSchoolEntity;
    FlightSchoolApplicantStatus? : FlightSchoolApplicantStatusEntity;
    FlightSchoolBranch? : FlightSchoolBranchEntity;
    PrimaryFlightSchoolInstructor? : FlightSchoolInstructorEntity;
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    FlightSchoolType? : FlightSchoolTypeEntity;
    CurrentPilotCertificateType? : PilotCertificateTypeEntity;
    StateProvince? : StateProvinceEntity;
    StudentApplicant? : StudentApplicantEntity;
    CheckRideRequest? : CheckRideRequestEntity[];
    FlightSchoolApplicantBranch? : FlightSchoolApplicantBranchEntity[];
    FlightSchoolInstructorApplicant? : FlightSchoolInstructorApplicantEntity[];
    PlanOfAction? : PlanOfActionEntity[];
}

export interface FlightSchoolApplicantBranchEntity extends DwOrmData {
    // Attributes
    FlightSchoolApplicantBranchId?: number;
    FlightSchoolApplicantId?: number;
    FlightSchoolBranchId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    FlightSchoolApplicantIdDisplay?: string;
    FlightSchoolBranchIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    FlightSchoolApplicant? : FlightSchoolApplicantEntity;
    FlightSchoolBranch? : FlightSchoolBranchEntity;
}

export interface FlightSchoolApplicantStatusEntity extends DwOrmData {
    // Attributes
    FlightSchoolApplicantStatusId?: number;
    FlightSchoolApplicantStatus?: string;


    // Relations
    FlightSchoolApplicant? : FlightSchoolApplicantEntity[];
}

export interface FlightSchoolBranchEntity extends DwOrmData {
    // Attributes
    FlightSchoolBranchId?: number;
    BranchName?: string;
    FlightSchoolBranchStatusId?: number;
    MainAirportId?: number;
    BranchAddressId?: number;
    FlightSchoolOrganizationId?: number;
    IsDefaultBranch?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    ShowMetar?: boolean;

    // Display Attributes
    FlightSchoolBranchStatusIdDisplay?: string;
    MainAirportIdDisplay?: string;
    BranchAddressIdDisplay?: string;
    FlightSchoolOrganizationIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    BranchAddress? : AddressEntity;
    MainAirport? : AirportEntity;
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    FlightSchoolBranchStatusIdFlightSchoolReferenceStatus? : FlightSchoolReferenceStatusEntity;
    CheckRideRequest? : CheckRideRequestEntity[];
    FlightSchoolApplicant? : FlightSchoolApplicantEntity[];
    FlightSchoolApplicantBranch? : FlightSchoolApplicantBranchEntity[];
    FlightSchoolUserBranch? : FlightSchoolUserBranchEntity[];
    UserInviteRequestSchoolBranch? : UserInviteRequestSchoolBranchEntity[];
}

export interface FlightSchoolExaminerEntity extends DwOrmData {
    // Attributes
    FlightSchoolExaminerId?: number;
    ExaminerName?: string;
    ExaminerEmail?: string;
    ExaminerPhone?: string;
    FlightSchoolExaminerStatusId?: number;
    PilotExaminerId?: number;
    FlightSchoolOrganizationId?: number;
    FlightSchoolExaminerTypeId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    LastInviteSendDateTime?: string;
    SendInviteEmail?: boolean;
    SendCheckrideEmails?: boolean;
    UseExaminerBlockBooking?: boolean;
    FlightSchoolInstructorId?: number;
    RecurrencyDate?: string;
    TrainingCurrent?: boolean;
    TrainingCurrentEvaluatedDateTime?: string;
    DpeSupplementReviewedDateTime?: string;
    DpeSupplementReviewedBy?: number;
    DocumentsMediaGroupId?: number;
    TrainingCurrentReason?: string;

    // Display Attributes
    FlightSchoolExaminerStatusIdDisplay?: string;
    PilotExaminerIdDisplay?: string;
    FlightSchoolOrganizationIdDisplay?: string;
    FlightSchoolExaminerTypeIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    FlightSchoolInstructorIdDisplay?: string;
    DocumentsMediaGroupIdDisplay?: string;

    // Relations
    FlightSchoolExaminerStatus? : FlightSchoolExaminerStatusEntity;
    FlightSchoolExaminerType? : FlightSchoolExaminerTypeEntity;
    FlightSchoolInstructor? : FlightSchoolInstructorEntity;
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    DocumentsDwMediaGroup? : DwMediaGroupEntity;
    PilotExaminer? : PilotExaminerEntity;
    CheckRideRequest? : CheckRideRequestEntity[];
    FlightSchoolUser? : FlightSchoolUserEntity[];
    PlanOfAction? : PlanOfActionEntity[];
    RoFlightSchoolExaminer? : RoFlightSchoolExaminerEntity;
    ScheduleBlock? : ScheduleBlockEntity[];
    TrainingRecord? : TrainingRecordEntity[];
    UnitMemberAircraftExperience? : UnitMemberAircraftExperienceEntity[];
    UnitMemberCertificate? : UnitMemberCertificateEntity[];
    UnitMemberEmployment? : UnitMemberEmploymentEntity[];
    UnitMemberFlightExperience? : UnitMemberFlightExperienceEntity[];
    UnitMemberProfile? : UnitMemberProfileEntity;
    UnitMemberQualificationResponse? : UnitMemberQualificationResponseEntity[];
    UserInviteRequestDetail? : UserInviteRequestDetailEntity[];
}

export interface FlightSchoolExaminerStatusEntity extends DwOrmData {
    // Attributes
    FlightSchoolExaminerStatusId?: number;
    FlightSchoolExaminerStatus?: string;


    // Relations
    FlightSchoolExaminer? : FlightSchoolExaminerEntity[];
}

export interface FlightSchoolExaminerTypeEntity extends DwOrmData {
    // Attributes
    FlightSchoolExaminerTypeId?: number;
    FlightSchoolExaminerType?: string;
    Description?: string;


    // Relations
    FlightSchoolExaminer? : FlightSchoolExaminerEntity[];
}

export interface FlightSchoolInstructorEntity extends DwOrmData {
    // Attributes
    FlightSchoolInstructorId?: number;
    InstructorName?: string;
    InstructorEmail?: string;
    InstructorPhone?: string;
    InstructorCertifcateNumber?: string;
    FlightSchoolUserId?: number;
    FlightSchoolOrganizationId?: number;
    FlightSchoolInstructorStatusId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    FlightSchoolInstructorTypeId?: number;
    RecurrencyDate?: string;

    // Display Attributes
    FlightSchoolUserIdDisplay?: string;
    FlightSchoolOrganizationIdDisplay?: string;
    FlightSchoolInstructorStatusIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    FlightSchoolInstructorTypeIdDisplay?: string;

    // Relations
    FlightSchoolInstructorStatus? : FlightSchoolInstructorStatusEntity;
    FlightSchoolInstructorType? : FlightSchoolInstructorTypeEntity;
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    FlightSchoolUser? : FlightSchoolUserEntity;
    CheckRideRequest? : CheckRideRequestEntity[];
    PrimaryFlightSchoolApplicant? : FlightSchoolApplicantEntity[];
    FlightSchoolExaminer? : FlightSchoolExaminerEntity[];
    FlightSchoolInstructorApplicant? : FlightSchoolInstructorApplicantEntity[];
    // Duplicate property excluded
    // FlightSchoolUser : FlightSchoolUserEntity[];
    PlanOfAction? : PlanOfActionEntity[];
    UserInviteRequestDetail? : UserInviteRequestDetailEntity[];
}

export interface FlightSchoolInstructorApplicantEntity extends DwOrmData {
    // Attributes
    FlightSchoolInstructorApplicantId?: number;
    FlightSchoolInstructorId?: number;
    FlightSchoolApplicantId?: number;

    // Display Attributes
    FlightSchoolInstructorIdDisplay?: string;
    FlightSchoolApplicantIdDisplay?: string;

    // Relations
    FlightSchoolApplicant? : FlightSchoolApplicantEntity;
    FlightSchoolInstructor? : FlightSchoolInstructorEntity;
}

export interface FlightSchoolInstructorStatusEntity extends DwOrmData {
    // Attributes
    FlightSchoolInstructorStatusId?: number;
    FlightSchoolInstructorStatus?: string;


    // Relations
    FlightSchoolInstructor? : FlightSchoolInstructorEntity[];
}

export interface FlightSchoolInstructorTypeEntity extends DwOrmData {
    // Attributes
    FlightSchoolInstructorTypeId?: number;
    FlightSchoolInstructorType?: string;


    // Relations
    FlightSchoolInstructor? : FlightSchoolInstructorEntity[];
}

export interface FlightSchoolOrganizationEntity extends DwOrmData {
    // Attributes
    FlightSchoolOrganizationId?: number;
    FlightSchoolId?: number;
    OtherNameRequest?: string;
    FlightSchoolStatusId?: number;
    BillingAddressId?: number;
    HeadquatersAddressId?: number;
    BillingSameAsHeadquarters?: boolean;
    OriginalOwnerUserId?: number;
    FlightSchoolCertificateNumber?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    PilexosBookingCostPaymentPartyId?: number;
    ForceSchoolPaymentParty?: boolean;
    PublicPortalIsActive?: boolean;
    PublicPortalSlug?: string;
    AllowPublicStudentCreation?: boolean;
    UseExaminerBlockBooking?: boolean;
    PreTimeMinutes?: number;
    PostTimeMinutes?: number;
    MaxTravelRadiusMiles?: number;
    FlightSchoolTypeId?: number;
    CalendarReferenceId?: number;
    ValidateExaminerTrainingForPOA?: boolean;

    // Display Attributes
    FlightSchoolIdDisplay?: string;
    FlightSchoolStatusIdDisplay?: string;
    BillingAddressIdDisplay?: string;
    HeadquatersAddressIdDisplay?: string;
    OriginalOwnerUserIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    PilexosBookingCostPaymentPartyIdDisplay?: string;
    FlightSchoolTypeIdDisplay?: string;
    CalendarReferenceIdDisplay?: string;

    // Relations
    BillingAddress? : AddressEntity;
    HeadquatersAddress? : AddressEntity;
    CalendarReference? : CalendarReferenceEntity;
    PilexosBookingCostPaymentPartyIdCheckRideRequestPaymentParty? : CheckRideRequestPaymentPartyEntity;
    FlightSchool? : FlightSchoolEntity;
    FlightSchoolStatus? : FlightSchoolStatusEntity;
    FlightSchoolType? : FlightSchoolTypeEntity;
    OriginalOwnerDwUser? : DwUserEntity;
    CalendarSyncRequest? : CalendarSyncRequestEntity[];
    CheckRideRequest? : CheckRideRequestEntity[];
    FlightSchoolApplicant? : FlightSchoolApplicantEntity[];
    FlightSchoolBranch? : FlightSchoolBranchEntity[];
    FlightSchoolExaminer? : FlightSchoolExaminerEntity[];
    FlightSchoolInstructor? : FlightSchoolInstructorEntity[];
    FlightSchoolOrganizationFeature? : FlightSchoolOrganizationFeatureEntity[];
    FlightSchoolTrainingProgram? : FlightSchoolTrainingProgramEntity[];
    FlightSchoolUser? : FlightSchoolUserEntity[];
    PaymentCustomerReference? : PaymentCustomerReferenceEntity[];
    PlanOfAction? : PlanOfActionEntity[];
    QuestionBank? : QuestionBankEntity[];
    Subscription? : SubscriptionEntity[];
    UserInviteRequestDetail? : UserInviteRequestDetailEntity[];
}

export interface FlightSchoolOrganizationFeatureEntity extends DwOrmData {
    // Attributes
    FlightSchoolOrganizationFeatureId?: number;
    FlightSchoolOrganizationId?: number;
    SchoolFeatureId?: number;

    // Display Attributes
    FlightSchoolOrganizationIdDisplay?: string;
    SchoolFeatureIdDisplay?: string;

    // Relations
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    SchoolFeature? : SchoolFeatureEntity;
}

export interface FlightSchoolReferenceStatusEntity extends DwOrmData {
    // Attributes
    FlightSchoolReferenceStatusId?: number;
    FlightSchoolReferenceStatus?: string;


    // Relations
    FlightSchoolBranchStatusIdFlightSchoolBranch? : FlightSchoolBranchEntity[];
}

export interface FlightSchoolSetupRequestEntity extends DwOrmData {
    // Attributes
    FlightSchoolSetupRequestId?: number;
    FlightSchoolId?: number;
    OtherNameRequest?: string;
    RequestorName?: string;
    RequestorEmail?: string;
    RequestorPhone?: string;
    FlightSchoolSetupRequestStatusId?: number;

    // Display Attributes
    FlightSchoolIdDisplay?: string;
    FlightSchoolSetupRequestStatusIdDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    FlightSchoolSetupRequestStatus? : FlightSchoolSetupRequestStatusEntity;
}

export interface FlightSchoolSetupRequestStatusEntity extends DwOrmData {
    // Attributes
    FlightSchoolSetupRequestStatusId?: number;
    FlightSchoolSetupRequestStatus?: string;


    // Relations
    FlightSchoolSetupRequest? : FlightSchoolSetupRequestEntity[];
}

export interface FlightSchoolStatusEntity extends DwOrmData {
    // Attributes
    FlightSchoolStatusId?: number;
    FlightSchoolStatus?: string;


    // Relations
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity[];
}

export interface FlightSchoolTrainingProgramEntity extends DwOrmData {
    // Attributes
    FlightSchoolTrainingProgramId?: number;
    AviationTrainingProgramId?: number;
    FlightSchoolOrganizationId?: number;

    // Display Attributes
    AviationTrainingProgramIdDisplay?: string;
    FlightSchoolOrganizationIdDisplay?: string;

    // Relations
    AviationTrainingProgram? : AviationTrainingProgramEntity;
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
}

export interface FlightSchoolTypeEntity extends DwOrmData {
    // Attributes
    FlightSchoolTypeId?: number;
    FlightSchoolType?: string;
    TypeDescription?: string;


    // Relations
    CheckRideRequest? : CheckRideRequestEntity[];
    FlightSchoolApplicant? : FlightSchoolApplicantEntity[];
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity[];
    PlanOfAction? : PlanOfActionEntity[];
}

export interface FlightSchoolUserEntity extends DwOrmData {
    // Attributes
    FlightSchoolUserId?: number;
    UserId?: number;
    FlightSchoolOrganizationId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    CanAccessAllLocations?: boolean;
    FlightSchoolExaminerId?: number;
    FlightSchoolInstructorId?: number;
    UserInviteRequestTypeId?: number;

    // Display Attributes
    UserIdDisplay?: string;
    FlightSchoolOrganizationIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    FlightSchoolExaminerIdDisplay?: string;
    FlightSchoolInstructorIdDisplay?: string;
    UserInviteRequestTypeIdDisplay?: string;

    // Relations
    FlightSchoolExaminer? : FlightSchoolExaminerEntity;
    FlightSchoolInstructor? : FlightSchoolInstructorEntity;
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    DwUser? : DwUserEntity;
    DwUserInviteRequestType? : DwUserInviteRequestTypeEntity;
    // Duplicate property excluded
    // FlightSchoolInstructor : FlightSchoolInstructorEntity[];
    FlightSchoolUserBranch? : FlightSchoolUserBranchEntity[];
}

export interface FlightSchoolUserBranchEntity extends DwOrmData {
    // Attributes
    FlightSchoolUserBranchId?: number;
    FlightSchoolUserId?: number;
    FlightSchoolBranchId?: number;

    // Display Attributes
    FlightSchoolUserIdDisplay?: string;
    FlightSchoolBranchIdDisplay?: string;

    // Relations
    FlightSchoolBranch? : FlightSchoolBranchEntity;
    FlightSchoolUser? : FlightSchoolUserEntity;
}

export interface DwMediaGroupEntity extends DwOrmData {
    // Attributes
    CreatedBy?: number;
    CreatedDateTime?: string;
    GroupName?: string;
    IsGlobalGroup?: boolean;
    IsSecure?: boolean;
    MediaGroupId?: number;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    PartyReferenceId?: number;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    PartyReferenceIdDisplay?: string;

    // Relations
    DocumentsCheckRideRequest? : CheckRideRequestEntity[];
    DocumentsFlightSchoolExaminer? : FlightSchoolExaminerEntity[];
    DwroMedia? : DwRoMediaEntity[];
}

export interface PaymentAttemptEntity extends DwOrmData {
    // Attributes
    PaymentAttemptId?: number;
    CheckRidePaymentId?: number;
    PaymentReferenceId?: number;
    PaymentOperationMeaning?: string;
    PaymentAttemptStatusMeaning?: string;
    AttemptNumber?: number;
    AttemptDateTime?: string;
    CompletedDateTime?: string;
    InitiatedByUserId?: number;
    ProviderErrorType?: string;
    ProviderErrorCode?: string;
    ProviderErrorMessage?: string;
    UserMessage?: string;
    ProviderCorrelationId?: string;
    RequiresPayerAction?: boolean;
    IsRetryable?: boolean;
    NextAttemptDateTime?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CheckRidePaymentIdDisplay?: string;
    PaymentReferenceIdDisplay?: string;
    InitiatedByUserIdDisplay?: string;

    // Relations
    CheckRidePayment? : CheckRidePaymentEntity;
    PaymentReference? : PaymentReferenceEntity;
    InitiatedByDwUser? : DwUserEntity;
}

export interface PaymentCardEntity extends DwOrmData {
    // Attributes
    PaymentCardId?: number;
    PaymentCustomerReferenceId?: number;
    PaymentReferenceCardTypeId?: number;
    CardName?: string;
    PaymentCardStatusId?: number;
    CardReferenceKey?: string;
    ExpirationMonth?: string;
    ExpirationYear?: string;
    Last4?: number;
    IsDefaultCard?: boolean;
    CardholderName?: string;

    // Display Attributes
    PaymentCustomerReferenceIdDisplay?: string;
    PaymentReferenceCardTypeIdDisplay?: string;
    PaymentCardStatusIdDisplay?: string;

    // Relations
    PaymentCardStatus? : PaymentCardStatusEntity;
    PaymentCustomerReference? : PaymentCustomerReferenceEntity;
    PaymentReferenceCardType? : PaymentReferenceCardTypeEntity;
}

export interface PaymentCardStatusEntity extends DwOrmData {
    // Attributes
    PaymentCardStatusId?: number;
    PaymentCardStatus?: string;


    // Relations
    PaymentCard? : PaymentCardEntity[];
}

export interface PaymentCustomerReferenceEntity extends DwOrmData {
    // Attributes
    PaymentCustomerReferenceId?: number;
    UserId?: number;
    CustomerReferenceKey?: string;
    PaymentProviderId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    CheckRideRequestPaymentPartyId?: number;
    FlightSchoolOrganizationId?: number;

    // Display Attributes
    UserIdDisplay?: string;
    PaymentProviderIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    CheckRideRequestPaymentPartyIdDisplay?: string;
    FlightSchoolOrganizationIdDisplay?: string;

    // Relations
    CheckRideRequestPaymentParty? : CheckRideRequestPaymentPartyEntity;
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    PaymentProvider? : PaymentProviderEntity;
    DwUser? : DwUserEntity;
    PaymentCard? : PaymentCardEntity[];
    PaymentReference? : PaymentReferenceEntity[];
}

export interface PaymentDiscountCodeEntity extends DwOrmData {
    // Attributes
    PaymentDiscountCodeId?: number;
    DiscountName?: string;
    DiscountCode?: string;
    StartDate?: string;
    EndDate?: string;
    AllowedUses?: number;
    IsActive?: boolean;
    LimitToUserId?: number;
    DiscountAmount?: number;
    CurrentUses?: number;
    DiscountPercent?: number;

    // Display Attributes
    LimitToUserIdDisplay?: string;

    // Relations
    LimitToDwUser? : DwUserEntity;
    PaymentDiscountidCheckRidePayment? : CheckRidePaymentEntity[];
    Subscription? : SubscriptionEntity[];
}

export interface PaymentMethodEntity extends DwOrmData {
    // Attributes
    PaymentMethodId?: number;
    PaymentMethod?: string;


    // Relations
    CheckRidePayment? : CheckRidePaymentEntity[];
}

export interface PaymentProviderEntity extends DwOrmData {
    // Attributes
    PaymentProviderId?: number;
    PaymentProviderDisplay?: string;
    PaymentProviderMeaning?: string;


    // Relations
    PaymentCustomerReference? : PaymentCustomerReferenceEntity[];
}

export interface PaymentReferenceEntity extends DwOrmData {
    // Attributes
    PaymentReferenceId?: number;
    PaymentCustomerReferenceId?: number;
    PaymentReferenceKey?: string;
    PaymentReferenceCardTypeId?: number;
    PaymentReference?: string;
    PaymentReferenceStatusId?: number;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;
    PaymentAmount?: number;
    CardHolderName?: string;

    // Display Attributes
    PaymentCustomerReferenceIdDisplay?: string;
    PaymentReferenceCardTypeIdDisplay?: string;
    PaymentReferenceStatusIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    PaymentCustomerReference? : PaymentCustomerReferenceEntity;
    PaymentReferenceCardType? : PaymentReferenceCardTypeEntity;
    PaymentReferenceStatus? : PaymentReferenceStatusEntity;
    CheckRidePayment? : CheckRidePaymentEntity[];
    PaymentAttempt? : PaymentAttemptEntity[];
}

export interface PaymentReferenceCardTypeEntity extends DwOrmData {
    // Attributes
    PaymentReferenceCardTypeId?: number;
    CardTypeDisplay?: string;
    CardTypeMeaning?: string;


    // Relations
    PaymentCard? : PaymentCardEntity[];
    PaymentReference? : PaymentReferenceEntity[];
}

export interface PaymentReferenceStatusEntity extends DwOrmData {
    // Attributes
    PaymentReferenceStatusId?: number;
    PaymentReferenceStatus?: string;


    // Relations
    PaymentReference? : PaymentReferenceEntity[];
}

export interface PaymentTypeEntity extends DwOrmData {
    // Attributes
    PaymentTypeId?: number;
    PaymentType?: string;


    // Relations
    CheckRidePayment? : CheckRidePaymentEntity[];
}

export interface PilotCertificateTypeEntity extends DwOrmData {
    // Attributes
    PilotCertificateTypeId?: number;
    PilotCertiicateTypeId?: string;


    // Relations
    CurrentPilotCertifiateTypeIdCheckRideRequest? : CheckRideRequestEntity[];
    CurrentFlightSchoolApplicant? : FlightSchoolApplicantEntity[];
}

export interface PilotExaminerEntity extends DwOrmData {
    // Attributes
    PilotExaminerId?: number;
    UserId?: number;
    PilotExaminerStatusId?: number;
    Description?: string;
    AviationAuthorityId?: number;
    DefaultPreTimeMinutes?: number;
    DefaultPostTimeMinutes?: number;
    TravelRadiusMiles?: number;
    AuthorityExaminerNumber?: string;
    CalendarIsLinked?: boolean;
    CalendarReferenceId?: number;
    RequireAuthorityPreCheckRideNumber?: boolean;
    PublicProfileIsActive?: boolean;
    PublicProfileSlug?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    CheckRideRequestLeadTimeDays?: number;
    CheckRideRequestBookingMaxWeeksOut?: number;
    AviationAuthorityDistrictOfficeId?: number;
    DailyTravelRadiusLockMiles?: number;
    PilotExaminerTypeId?: number;
    AllowAnyFlightSchool?: boolean;
    FlightSchoolScheduleId?: number;
    PreventApplicantBooking?: boolean;
    UseBlockBooking?: boolean;
    ScheduleBlockSchoolDefaultOptionId?: number;

    // Display Attributes
    UserIdDisplay?: string;
    PilotExaminerStatusIdDisplay?: string;
    AviationAuthorityIdDisplay?: string;
    CalendarReferenceIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    AviationAuthorityDistrictOfficeIdDisplay?: string;
    PilotExaminerTypeIdDisplay?: string;
    FlightSchoolScheduleIdDisplay?: string;
    ScheduleBlockSchoolDefaultOptionIdDisplay?: string;

    // Relations
    AviationAuthority? : AviationAuthorityEntity;
    AviationAuthorityDistrictOffice? : AviationAuthorityDistrictOfficeEntity;
    CalendarReference? : CalendarReferenceEntity;
    PilotExaminerStatus? : PilotExaminerStatusEntity;
    PilotExaminerType? : PilotExaminerTypeEntity;
    FlightSchoolSchedule? : ScheduleEntity;
    ScheduleBlockSchoolDefaultOptionIdScheduleBlockSchoolBookingOption? : ScheduleBlockSchoolBookingOptionEntity;
    DwUser? : DwUserEntity;
    ApplicantPlaceholder? : ApplicantPlaceholderEntity[];
    CalendarSyncRequest? : CalendarSyncRequestEntity[];
    ScheduledCheckRideRequest? : CheckRideRequestEntity[];
    CheckRideScenario? : CheckRideScenarioEntity[];
    CheckRideScheduleHold? : CheckRideScheduleHoldEntity[];
    FlightSchoolExaminer? : FlightSchoolExaminerEntity[];
    PilotExaminerFlightSchoolSetup? : PilotExaminerFlightSchoolSetupEntity[];
    PilotExaminerLocation? : PilotExaminerLocationEntity[];
    PlanOfAction? : PlanOfActionEntity[];
    QuestionBank? : QuestionBankEntity[];
    RoPilotExaminerLocationDistances? : RoPilotExaminerLocationDistancesEntity[];
    RoPilotExaminerScenario? : RoPilotExaminerScenarioEntity[];
    ScheduleBlock? : ScheduleBlockEntity[];
    ReferredStudentApplicant? : StudentApplicantEntity[];
    Subscription? : SubscriptionEntity[];
    TrainingRecord? : TrainingRecordEntity[];
}

export interface PilotExaminerFlightSchoolSetupEntity extends DwOrmData {
    // Attributes
    PilotExaminerFlightSchoolSetupId?: number;
    PilotExaminerId?: number;
    FlightSchoolId?: number;
    AllowFlightSchoolScheduling?: boolean;
    FlightSchoolScheduleId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    PreventBookingOpenDays?: boolean;
    CalendarColorName?: string;
    CalendarBackgroundColor?: string;
    CalendarForegroundColor?: string;
    ScheduleBlockSchoolDefaultOptionId?: number;

    // Display Attributes
    PilotExaminerIdDisplay?: string;
    FlightSchoolIdDisplay?: string;
    FlightSchoolScheduleIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    ScheduleBlockSchoolDefaultOptionIdDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    PilotExaminer? : PilotExaminerEntity;
    FlightSchoolSchedule? : ScheduleEntity;
    ScheduleBlockSchoolDefaultOptionIdScheduleBlockSchoolBookingOption? : ScheduleBlockSchoolBookingOptionEntity;
}

export interface PilotExaminerLocationEntity extends DwOrmData {
    // Attributes
    PilotExaminerLocationId?: number;
    PilotExaminerId?: number;
    LocationName?: string;
    SchedulingStartDate?: string;
    SchedulingEndDate?: string;
    TravelRadiusMile?: number;
    BookingScheduleId?: number;
    TravelCost?: number;
    IsDefaultLocation?: boolean;
    IsActive?: boolean;
    AdditionalLocationCost?: number;
    BookingScheduleTimeZoneId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    ShowMetar?: boolean;
    PilotExaminerLocationTypeId?: number;

    // Display Attributes
    PilotExaminerIdDisplay?: string;
    BookingScheduleIdDisplay?: string;
    BookingScheduleTimeZoneIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    PilotExaminerLocationTypeIdDisplay?: string;

    // Relations
    PilotExaminer? : PilotExaminerEntity;
    PilotExaminerLocationType? : PilotExaminerLocationTypeEntity;
    BookingSchedule? : ScheduleEntity;
    BookingScheduleTimeZoneIdTimeZone? : TimeZoneEntity;
    ScheduledCheckRideRequest? : CheckRideRequestEntity[];
    PilotExaminerLocationAirport? : PilotExaminerLocationAirportEntity[];
    RoPilotExaminerLocationCurrent? : RoPilotExaminerLocationCurrentEntity;
    RoPilotExaminerLocationDistances? : RoPilotExaminerLocationDistancesEntity[];
    ScheduleBlockLocation? : ScheduleBlockLocationEntity[];
}

export interface PilotExaminerLocationAirportEntity extends DwOrmData {
    // Attributes
    PilotExaminerLocationAirportId?: number;
    PilotExaminerLocationId?: number;
    AirportId?: number;

    // Display Attributes
    PilotExaminerLocationAirportIdDisplay?: string;
    PilotExaminerLocationIdDisplay?: string;
    AirportIdDisplay?: string;

    // Relations
    Airport? : AirportEntity;
    PilotExaminerLocation? : PilotExaminerLocationEntity;
}

export interface PilotExaminerLocationStateEntity extends DwOrmData {
    // Attributes
    PilotExaminerLocationStateId?: number;
    StateMeaning?: string;
    StateDisplay?: string;


    // Relations
}

export interface PilotExaminerLocationTypeEntity extends DwOrmData {
    // Attributes
    PilotExaminerLocationTypeId?: number;
    PilotExaminerLocationType?: string;


    // Relations
    PilotExaminerLocation? : PilotExaminerLocationEntity[];
}

export interface PilotExaminerStatusEntity extends DwOrmData {
    // Attributes
    PilotExaminerStatusId?: number;
    PilotExaminerStatus?: string;
    WorkflowStatusDetailId?: number;

    // Display Attributes
    WorkflowStatusDetailIdDisplay?: string;

    // Relations
    PilotExaminer? : PilotExaminerEntity[];
}

export interface PilotExaminerTypeEntity extends DwOrmData {
    // Attributes
    PilotExaminerTypeId?: number;
    PilotExaminerType?: string;
    TypeDescription?: string;


    // Relations
    PilotExaminer? : PilotExaminerEntity[];
}

export interface PlanOfActionEntity extends DwOrmData {
    // Attributes
    PlanOfActionId?: number;
    PlanOfActionName?: string;
    PlanOfActionStatusId?: number;
    AviationAuthorityId?: number;
    AcsTestId?: number;
    PilotExaminerId?: number;
    CheckRideRequestId?: number;
    CheckrideDateTime?: string;
    StudentApplicantNameManual?: string;
    StudentApplicantEmailManual?: string;
    StudentApplicantPhoneManual?: string;
    StudentApplicantCitizenshipCountryId?: number;
    AuthorityPreCheckRideNumber?: string;
    PilotCertificateNumber?: string;
    AirplaneNNumber?: string;
    AuthorityPreapprovalCode?: string;
    // Attribute Authority Approval Code has invalid characters and can't be included
    ApplicationPaperworkCorrect?: boolean;
    EndorsementsPaperworkCorrect?: boolean;
    OptionsShowQuestionForAcsCode?: boolean;
    IsTemplate?: boolean;
    IsSharedTemplate?: boolean;
    TemplatePlanOfActionId?: number;
    IsBuiltIn?: boolean;
    OwnerUserId?: number;
    PlanOfActionResultId?: number;
    LinkToCheckride?: boolean;
    ApplicantAcsWrittenResultId?: number;
    CheckRideAirportId?: number;
    CheckRideGroupId?: number;
    CheckRideTypeId?: number;
    CheckRideTestTypeId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    FlightSchoolOrganizationId?: number;
    StudentApplicantStateProvinceId?: number;
    ForeignPilotMeetsQualifications?: boolean;
    PrimaryTraningAirportId?: number;
    AuthorityApprovalCode?: string;
    AuthorityApplicationNumber?: string;
    CheckRideOwnershipTypeId?: number;
    FlightSchoolExaminerId?: number;
    FlightSchoolApplicantId?: number;
    FlightSchoolInstructorId?: number;
    CheckRideExaminerTypeId?: number;
    CheckRideApplicantTypeId?: number;
    FlightSchoolTypeId?: number;
    CheckRideInstructorTypeId?: number;
    FlightInstructorName?: string;
    FlightInstructorEmail?: string;
    FlightInstructorPhone?: string;
    FlightInstructorCertificateNumber?: string;
    OdaFlightSchoolId?: number;

    // Display Attributes
    PlanOfActionStatusIdDisplay?: string;
    AviationAuthorityIdDisplay?: string;
    AcsTestIdDisplay?: string;
    PilotExaminerIdDisplay?: string;
    CheckRideRequestIdDisplay?: string;
    StudentApplicantCitizenshipCountryIdDisplay?: string;
    TemplatePlanOfActionIdDisplay?: string;
    PlanOfActionResultIdDisplay?: string;
    ApplicantAcsWrittenResultIdDisplay?: string;
    CheckRideAirportIdDisplay?: string;
    CheckRideGroupIdDisplay?: string;
    CheckRideTypeIdDisplay?: string;
    CheckRideTestTypeIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    FlightSchoolOrganizationIdDisplay?: string;
    StudentApplicantStateProvinceIdDisplay?: string;
    PrimaryTraningAirportIdDisplay?: string;
    CheckRideOwnershipTypeIdDisplay?: string;
    FlightSchoolExaminerIdDisplay?: string;
    FlightSchoolApplicantIdDisplay?: string;
    FlightSchoolInstructorIdDisplay?: string;
    CheckRideExaminerTypeIdDisplay?: string;
    CheckRideApplicantTypeIdDisplay?: string;
    FlightSchoolTypeIdDisplay?: string;
    CheckRideInstructorTypeIdDisplay?: string;
    OdaFlightSchoolIdDisplay?: string;

    // Relations
    AcsTest? : AcsTestEntity;
    CheckRideAirport? : AirportEntity;
    PrimaryTraningAirport? : AirportEntity;
    ApplicantAcsWrittenResult? : ApplicantAcsWrittenResultEntity;
    AviationAuthority? : AviationAuthorityEntity;
    CheckRideApplicantType? : CheckRideApplicantTypeEntity;
    CheckRideExaminerType? : CheckRideExaminerTypeEntity;
    CheckRideGroup? : CheckRideGroupEntity;
    CheckRideInstructorType? : CheckRideInstructorTypeEntity;
    CheckRideOwnershipType? : CheckRideOwnershipTypeEntity;
    CheckRideRequest? : CheckRideRequestEntity;
    CheckRideTestType? : CheckRideTestTypeEntity;
    CheckRideType? : CheckRideTypeEntity;
    StudentApplicantCitizenshipCountry? : CountryEntity;
    OdaFlightSchool? : FlightSchoolEntity;
    FlightSchoolApplicant? : FlightSchoolApplicantEntity;
    FlightSchoolExaminer? : FlightSchoolExaminerEntity;
    FlightSchoolInstructor? : FlightSchoolInstructorEntity;
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    FlightSchoolType? : FlightSchoolTypeEntity;
    PilotExaminer? : PilotExaminerEntity;
    PlanOfActionResult? : PlanOfActionResultEntity;
    PlanOfActionStatus? : PlanOfActionStatusEntity;
    StudentApplicantStateProvince? : StateProvinceEntity;
    TemplatePlanOfAction? : PlanOfActionEntity;
    CheckRideAISummary? : CheckRideAISummaryEntity[];
    PlanOfActionRequiredAcsCode? : PlanOfActionRequiredAcsCodeEntity[];
    PlanOfActionSection? : PlanOfActionSectionEntity[];
    RoPlanOfActionDetails? : RoPlanOfActionDetailsEntity;
    // Duplicate property excluded
    // TemplatePlanOfAction : PlanOfActionEntity[];
}

export interface PlanOfActionQuestionResultEntity extends DwOrmData {
    // Attributes
    PlanOfActionQuestionResultId?: number;
    PlanOfActionResultId?: number;
    PlanOfActionSectionQuestionId?: number;
    QuestionOutcomeId?: number;
    DiscussQuestion?: boolean;
    Notes?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    PlanOfActionResultIdDisplay?: string;
    PlanOfActionSectionQuestionIdDisplay?: string;
    QuestionOutcomeIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    PlanOfActionResult? : PlanOfActionResultEntity;
    PlanOfActionSectionQuestion? : PlanOfActionSectionQuestionEntity;
    QuestionOutcome? : QuestionOutcomeEntity;
}

export interface PlanOfActionRequiredAcsCodeEntity extends DwOrmData {
    // Attributes
    PlanOfActionRequiredAcsCodeId?: number;
    PlanOfActionId?: number;
    AcsCodeId?: number;

    // Display Attributes
    PlanOfActionIdDisplay?: string;
    AcsCodeIdDisplay?: string;

    // Relations
    AcsCode? : AcsCodeEntity;
    PlanOfAction? : PlanOfActionEntity;
}

export interface PlanOfActionResultEntity extends DwOrmData {
    // Attributes
    PlanOfActionResultId?: number;
    CheckRideStartDateTime?: string;
    CheckRideEndDateTime?: string;
    TotalTimeGroundMinutes?: number;
    TotalTimeFlightMinute?: number;
    CheckRideOutcomeId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    AllowRetest?: boolean;
    AllowRetestReason?: string;
    RetestCost?: number;
    FlagApplicant?: boolean;
    FlagApplicantNotes?: string;
    AddToWaitlist?: boolean;
    GroundPortionComplete?: boolean;
    PostApplicantAcsWrittenResultId?: number;

    // Display Attributes
    CheckRideOutcomeIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    PostApplicantAcsWrittenResultIdDisplay?: string;

    // Relations
    PostApplicantAcsWrittenResult? : ApplicantAcsWrittenResultEntity;
    CheckRideOutcome? : CheckRideOutcomeEntity;
    PlanOfAction? : PlanOfActionEntity[];
    PlanOfActionQuestionResult? : PlanOfActionQuestionResultEntity[];
}

export interface PlanOfActionSectionEntity extends DwOrmData {
    // Attributes
    PlanOfActionSectionId?: number;
    PlanOfActionId?: number;
    SectionName?: string;
    PlanOfActionSectionTypeId?: number;
    AcsAreaOfOperationId?: number;
    AcsAreaOfOperationTaskId?: number;
    SectionOrder?: number;
    AcsTestPortionId?: number;

    // Display Attributes
    PlanOfActionIdDisplay?: string;
    PlanOfActionSectionTypeIdDisplay?: string;
    AcsAreaOfOperationIdDisplay?: string;
    AcsAreaOfOperationTaskIdDisplay?: string;
    AcsTestPortionIdDisplay?: string;

    // Relations
    AcsAreaOfOperation? : AcsAreaOfOperationEntity;
    AcsAreaOfOperationTask? : AcsAreaOfOperationTaskEntity;
    AcsTestPortion? : AcsTestPortionEntity;
    PlanOfAction? : PlanOfActionEntity;
    PlanOfActionSectionType? : PlanOfActionSectionTypeEntity;
    PlanOfActionSectionQuestion? : PlanOfActionSectionQuestionEntity[];
}

export interface PlanOfActionSectionQuestionEntity extends DwOrmData {
    // Attributes
    PlanOfActionSectionQuestionId?: number;
    PlanOfActionSectionId?: number;
    AcsCodeId?: number;
    QuestionHtml?: string;
    QuestionOrder?: number;
    ShowNotes?: boolean;

    // Display Attributes
    PlanOfActionSectionIdDisplay?: string;
    AcsCodeIdDisplay?: string;

    // Relations
    AcsCode? : AcsCodeEntity;
    PlanOfActionSection? : PlanOfActionSectionEntity;
    PlanOfActionQuestionResult? : PlanOfActionQuestionResultEntity[];
}

export interface PlanOfActionSectionTypeEntity extends DwOrmData {
    // Attributes
    PlanOfActionSectionTypeId?: number;
    PlanOfActionSectionType?: string;
    HasAreaOfOperation?: boolean;
    HasAreaOfOperationTask?: boolean;
    ShowSkillsOnly?: boolean;
    AcsTestPortionId?: number;

    // Display Attributes
    AcsTestPortionIdDisplay?: string;

    // Relations
    AcsTestPortion? : AcsTestPortionEntity;
    PlanOfActionSection? : PlanOfActionSectionEntity[];
}

export interface PlanOfActionStatusEntity extends DwOrmData {
    // Attributes
    PlanOfActionStatusId?: number;
    PlanOfActionStatus?: string;
    PlanOfActionStatusTypeId?: number;

    // Display Attributes
    PlanOfActionStatusTypeIdDisplay?: string;

    // Relations
    PlanOfActionStatusType? : PlanOfActionStatusTypeEntity;
    PlanOfAction? : PlanOfActionEntity[];
}

export interface PlanOfActionStatusTypeEntity extends DwOrmData {
    // Attributes
    PlanOfActionStatusTypeId?: number;
    PlanOfActionStatusType?: string;


    // Relations
    PlanOfActionStatus? : PlanOfActionStatusEntity[];
}

export interface PostalCodeEntity extends DwOrmData {
    // Attributes
    PostalCodeId?: number;
    StateProvinceId?: number;
    PostalCode?: string;
    Plus4?: string;
    City?: string;
    County?: string;
    AreaCode?: string;
    Latitude?: number;
    Longitude?: number;
    GmtOffset?: number;
    ObservesDst?: boolean;
    IsMetropolitanArea?: boolean;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;
    TimeZoneId?: number;

    // Display Attributes
    StateProvinceIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    TimeZoneIdDisplay?: string;

    // Relations
    StateProvince? : StateProvinceEntity;
    TimeZoneIdTimeZone? : TimeZoneEntity;
}

export interface DwProcessDefinitionEntity extends DwOrmData {
    // Attributes
    ConfigJSON?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    ProcessDefinitionId?: number;
    ProcessDescription?: string;
    ProcessDisplay?: string;
    ProcessMeaning?: string;
    ProcessTypeId?: number;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    ProcessTypeIdDisplay?: string;

    // Relations
}

export interface QuestionBankEntity extends DwOrmData {
    // Attributes
    QuestionBankId?: number;
    OwnerUserId?: number;
    AcsTestId?: number;
    AcsCodeId?: number;
    QuestionHtml?: string;
    IsBuiltIn?: boolean;
    IsShared?: boolean;
    QuestionShortName?: string;
    CheckRideOwnershipTypeId?: number;
    PilotExaminerId?: number;
    FlightSchoolOrganizationId?: number;
    QuestionBankStatusId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    AcsTestIdDisplay?: string;
    AcsCodeIdDisplay?: string;
    CheckRideOwnershipTypeIdDisplay?: string;
    PilotExaminerIdDisplay?: string;
    FlightSchoolOrganizationIdDisplay?: string;
    QuestionBankStatusIdDisplay?: string;

    // Relations
    AcsCode? : AcsCodeEntity;
    AcsTest? : AcsTestEntity;
    CheckRideOwnershipType? : CheckRideOwnershipTypeEntity;
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    PilotExaminer? : PilotExaminerEntity;
    QuestionBankStatus? : QuestionBankStatusEntity;
}

export interface QuestionBankStatusEntity extends DwOrmData {
    // Attributes
    QuestionBankStatusId?: number;
    QuestionBankStatus?: string;


    // Relations
    QuestionBank? : QuestionBankEntity[];
}

export interface QuestionOutcomeEntity extends DwOrmData {
    // Attributes
    QuestionOutcomeId?: number;
    QuestionOutcome?: string;
    OutcomeOrder?: number;


    // Relations
    PlanOfActionQuestionResult? : PlanOfActionQuestionResultEntity[];
}

export interface ReferenceStatusEntity extends DwOrmData {
    // Attributes
    ReferenceStatusId?: number;
    ReferenceStatus?: string;


    // Relations
    ReportDataSource? : ReportDataSourceEntity[];
    ReportDataSourceColumn? : ReportDataSourceColumnEntity[];
    Schedule? : ScheduleEntity[];
    TrainingType? : TrainingTypeEntity[];
    UnitMemberAircraftCategoryClass? : UnitMemberAircraftCategoryClassEntity[];
    UnitMemberAircraftExperienceType? : UnitMemberAircraftExperienceTypeEntity[];
    UnitMemberQualificationOption? : UnitMemberQualificationOptionEntity[];
    UnitMemberQualificationType? : UnitMemberQualificationTypeEntity[];
}

export interface ReportDashboardEntity extends DwOrmData {
    // Attributes
    ReportDashboardId?: number;
    DashboardKey?: string;
    DashboardDisplay?: string;
    DashboardConfigJSON?: string;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface ReportDashboardGroupEntity extends DwOrmData {
    // Attributes
    ReportDashboardGroupId?: number;
    DashboardGroupKey?: string;
    DashboardGroupDisplay?: string;
    DashboardGroupConfigJSON?: string;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface ReportDashboardWidgetEntity extends DwOrmData {
    // Attributes
    ReportDashboardWidgetId?: number;
    WidgetKey?: string;
    WidgetDisplay?: string;
    WidgetConfigJSON?: string;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface ReportDataSourceEntity extends DwOrmData {
    // Attributes
    ReportDataSourceId?: number;
    DataSourceKey?: string;
    DataSourceDisplay?: string;
    DataSourceDescription?: string;
    MetaDataItemId?: number;
    MetaDataQueryId?: number;
    IncludeAllFields?: boolean;
    DataSourceConfigJSON?: string;
    ReferenceStatusId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    MetaDataItemIdDisplay?: string;
    MetaDataQueryIdDisplay?: string;
    ReferenceStatusIdDisplay?: string;

    // Relations
    ReferenceStatus? : ReferenceStatusEntity;
    ReportDataSourceColumn? : ReportDataSourceColumnEntity[];
}

export interface ReportDataSourceColumnEntity extends DwOrmData {
    // Attributes
    ReportDataSourceColumnId?: number;
    ReportDataSourceId?: number;
    ColumnKey?: string;
    MetaDataAttributeId?: number;
    MetaDataAttributeTypeId?: number;
    AttributeName?: string;
    LookupIdOverride?: number;
    ColumnDisplay?: string;
    UseLookupDisplay?: boolean;
    IsExcluded?: boolean;
    IsDimension?: boolean;
    IsMeasure?: boolean;
    IsFilter?: boolean;
    ColumnConfigJSON?: string;
    DisplayOrder?: number;
    ReferenceStatusId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ReportDataSourceIdDisplay?: string;
    MetaDataAttributeIdDisplay?: string;
    MetaDataAttributeTypeIdDisplay?: string;
    LookupIdOverrideDisplay?: string;
    ReferenceStatusIdDisplay?: string;

    // Relations
    ReferenceStatus? : ReferenceStatusEntity;
    ReportDataSource? : ReportDataSourceEntity;
}

export interface ReportFilterPreferenceEntity extends DwOrmData {
    // Attributes
    ReportFilterPreferenceId?: number;
    UserId?: number;
    DashboardKey?: string;
    DefaultReportFilterPresetId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    DefaultReportFilterPresetIdDisplay?: string;

    // Relations
    DefaultReportFilterPreset? : ReportFilterPresetEntity;
}

export interface ReportFilterPresetEntity extends DwOrmData {
    // Attributes
    ReportFilterPresetId?: number;
    DashboardKey?: string;
    PresetName?: string;
    PresetDescription?: string;
    ReportFilterPresetOwnershipTypeId?: number;
    OwnerUserId?: number;
    FlightSchoolOrganizationId?: number;
    FilterGroupJSON?: string;
    FilterStateJSON?: string;
    SortOrder?: number;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ReportFilterPresetOwnershipTypeIdDisplay?: string;

    // Relations
    ReportFilterPresetOwnershipType? : ReportFilterPresetOwnershipTypeEntity;
    DefaultReportFilterPreference? : ReportFilterPreferenceEntity[];
}

export interface ReportFilterPresetOwnershipTypeEntity extends DwOrmData {
    // Attributes
    ReportFilterPresetOwnershipTypeId?: number;
    OwnershipTypeDisplay?: string;
    OwnershipTypeMeaning?: string;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    ReportFilterPreset? : ReportFilterPresetEntity[];
}

export interface RoAcsCodeDimensionEntity extends DwOrmData {
    // Attributes
    AcsCodeId?: number;
    AscCodeTypeId?: number;
    AcsCodeTypeName?: string;
    AcsCode?: string;
    AcsCodeOrder?: number;
    AcsAreaOfOperationTaskId?: number;
    AscCodeDescription?: string;
    AcsAreaOfOperationId?: number;
    TaskName?: string;
    TaskOrder?: number;
    TaskCode?: string;
    AreaOfOperationName?: string;
    AreaOfOperationOrder?: number;
    AreaOfOperationCode?: string;
    AcsTestId?: number;
    TestName?: string;
    TestDescription?: string;
    TestCode?: string;
    CheckRideGroupId?: number;
    CheckRideGroup?: string;

    // Display Attributes
    AcsCodeIdDisplay?: string;
    AcsAreaOfOperationIdDisplay?: string;
    AcsTestIdDisplay?: string;
    CheckRideGroupIdDisplay?: string;

    // Relations
}

export interface RoAcsWrittenSourceEntity extends DwOrmData {
    // Attributes
    Source?: string;
    PlanOfActionId?: number;
    CheckRideRequestId?: number;
    ACSTestType?: string;
    ApplicantAcsWrittenResultId?: number;


    // Relations
}

export interface RoAirportDistancesEntity extends DwOrmData {
    // Attributes
    AirportId?: number;
    AirportName?: string;
    airportcode?: string;
    ReferenceAirportName?: string;
    ReferenceAirportCode?: string;
    Distance?: number;
    ReferenceAirportId?: number;


    // Relations
}

export interface RoAssessmentAcsFactBaseEntity extends DwOrmData {
    // Attributes
    SourceType?: string;
    AssessmentId?: number;
    AssessmentKey?: string;
    PlanOfActionId?: number;
    CheckRideRequestId?: number;
    AcsTestId?: number;
    ApplicantAcsWrittenResultTypeId?: number;
    ApplicantAcsWrittenResultId?: number;
    PlanOfActionName?: string;
    PlanOfActionStatusId?: number;
    CheckrideRequestSubStatusId?: number;
    AviationAuthorityId?: number;
    CheckRideExaminerTypeId?: number;
    PilotExaminerId?: number;
    FlightSchoolExaminerId?: number;
    AuthorityPreCheckRideNumber?: string;
    AuthorityPreapprovalCode?: string;
    CheckRideOwnershipTypeId?: number;
    CheckRideApplicantTypeId?: number;
    ApplicantName?: string;
    ApplicantEmail?: string;
    ApplicantPhone?: string;
    ExaminerName?: string;
    ExaminerEmail?: string;
    ExaminerPhone?: string;
    FlightSchoolApplicantId?: number;
    FlightSchoolInstructorId?: number;
    CheckrideDateTime?: string;
    CheckrideAirportId?: number;
    CheckrideGroupId?: number;
    CheckrideTypeId?: number;
    CheckRideTestTypeId?: number;
    CheckrideDurationMinutes?: number;
    CheckrideEndDateTime?: string;
    PlanOfActionResultId?: number;
    CheckrideResultId?: number;
    CheckRideOutcomeId?: number;
    AllowRetest?: boolean;
    FlagApplicant?: boolean;
    AllowRetestReason?: string;
    RetestCost?: number;
    AddToWaitlist?: boolean;
    GroundPortionComplete?: boolean;
    FlightSchoolOrganizationId?: number;
    FlightSchoolId?: number;
    OdaFlightSchoolId?: number;
    CheckrideTypeShortName?: string;
    CheckRideTestAttemptClassificationId?: number;
    AttemptClassification?: string;
    IsInitial?: boolean;
    IsRetest?: boolean;
    IsContinuance?: boolean;

    // Display Attributes
    AcsTestIdDisplay?: string;
    ApplicantAcsWrittenResultTypeIdDisplay?: string;
    PlanOfActionStatusIdDisplay?: string;
    CheckrideRequestSubStatusIdDisplay?: string;
    AviationAuthorityIdDisplay?: string;
    CheckRideExaminerTypeIdDisplay?: string;
    PilotExaminerIdDisplay?: string;
    FlightSchoolExaminerIdDisplay?: string;
    CheckRideOwnershipTypeIdDisplay?: string;
    CheckRideApplicantTypeIdDisplay?: string;
    FlightSchoolApplicantIdDisplay?: string;
    FlightSchoolInstructorIdDisplay?: string;
    CheckrideAirportIdDisplay?: string;
    CheckrideGroupIdDisplay?: string;
    CheckrideTypeIdDisplay?: string;
    CheckRideTestTypeIdDisplay?: string;
    CheckRideOutcomeIdDisplay?: string;

    // Relations
}

export interface RoAssessmentAcsMissedCodeFactEntity extends DwOrmData {
    // Attributes
    SourceType?: string;
    AssessmentId?: number;
    AssessmentKey?: string;
    PlanOfActionId?: number;
    CheckRideRequestId?: number;
    AcsTestId?: number;
    ApplicantAcsWrittenResultTypeId?: number;
    ApplicantAcsWrittenResultId?: number;
    PlanOfActionName?: string;
    PlanOfActionStatusId?: number;
    CheckrideRequestSubStatusId?: number;
    AviationAuthorityId?: number;
    CheckRideExaminerTypeId?: number;
    PilotExaminerId?: number;
    FlightSchoolExaminerId?: number;
    AuthorityPreCheckRideNumber?: string;
    AuthorityPreapprovalCode?: string;
    CheckRideOwnershipTypeId?: number;
    CheckRideApplicantTypeId?: number;
    ApplicantName?: string;
    ApplicantEmail?: string;
    ApplicantPhone?: string;
    ExaminerName?: string;
    ExaminerEmail?: string;
    ExaminerPhone?: string;
    FlightSchoolApplicantId?: number;
    FlightSchoolInstructorId?: number;
    CheckrideDateTime?: string;
    CheckrideAirportId?: number;
    CheckrideGroupId?: number;
    CheckrideTypeId?: number;
    CheckRideTestTypeId?: number;
    CheckrideDurationMinutes?: number;
    CheckrideEndDateTime?: string;
    PlanOfActionResultId?: number;
    CheckrideResultId?: number;
    CheckRideOutcomeId?: number;
    AllowRetest?: boolean;
    FlagApplicant?: boolean;
    AllowRetestReason?: string;
    RetestCost?: number;
    AddToWaitlist?: boolean;
    GroundPortionComplete?: boolean;
    ApplicantAcsWrittenResultMissedCodeId?: number;
    AcsCodeId?: number;
    AscCodeTypeId?: number;
    AcsCodeTypeName?: string;
    AcsCode?: string;
    AcsCodeOrder?: number;
    AcsAreaOfOperationTaskId?: number;
    AscCodeDescription?: string;
    AcsAreaOfOperationId?: number;
    TaskName?: string;
    TaskOrder?: number;
    TaskCode?: string;
    AreaOfOperationName?: string;
    AreaOfOperationOrder?: number;
    AreaOfOperationCode?: string;
    TestName?: string;
    TestDescription?: string;
    TestCode?: string;
    CheckRideGroup?: string;
    FlightSchoolOrganizationId?: number;
    FlightSchoolId?: number;
    OdaFlightSchoolId?: number;
    CheckrideTypeShortName?: string;
    CheckRideTestAttemptClassificationId?: number;
    AttemptClassification?: string;
    IsInitial?: boolean;
    IsRetest?: boolean;
    IsContinuance?: boolean;

    // Display Attributes
    AcsTestIdDisplay?: string;
    ApplicantAcsWrittenResultTypeIdDisplay?: string;
    PlanOfActionStatusIdDisplay?: string;
    CheckrideRequestSubStatusIdDisplay?: string;
    AviationAuthorityIdDisplay?: string;
    CheckRideExaminerTypeIdDisplay?: string;
    PilotExaminerIdDisplay?: string;
    FlightSchoolExaminerIdDisplay?: string;
    CheckRideOwnershipTypeIdDisplay?: string;
    CheckRideApplicantTypeIdDisplay?: string;
    FlightSchoolApplicantIdDisplay?: string;
    FlightSchoolInstructorIdDisplay?: string;
    CheckrideAirportIdDisplay?: string;
    CheckrideGroupIdDisplay?: string;
    CheckrideTypeIdDisplay?: string;
    CheckRideTestTypeIdDisplay?: string;
    CheckRideOutcomeIdDisplay?: string;
    AcsCodeIdDisplay?: string;
    AcsAreaOfOperationIdDisplay?: string;

    // Relations
    AcsCode3? : AcsCodeEntity;
}

export interface RoAssessmentFactBaseEntity extends DwOrmData {
    // Attributes
    SourceType?: string;
    AssessmentId?: number;
    AssessmentKey?: string;
    PlanOfActionId?: number;
    CheckRideRequestId?: number;
    PlanOfActionName?: string;
    PlanOfActionStatusId?: number;
    CheckrideRequestSubStatusId?: number;
    AviationAuthorityId?: number;
    CheckRideExaminerTypeId?: number;
    PilotExaminerId?: number;
    FlightSchoolExaminerId?: number;
    AuthorityPreCheckRideNumber?: string;
    AuthorityPreapprovalCode?: string;
    CheckRideOwnershipTypeId?: number;
    CheckRideApplicantTypeId?: number;
    ApplicantName?: string;
    ApplicantEmail?: string;
    ApplicantPhone?: string;
    ExaminerName?: string;
    ExaminerEmail?: string;
    ExaminerPhone?: string;
    FlightSchoolApplicantId?: number;
    FlightSchoolInstructorId?: number;
    CheckrideDateTime?: string;
    CheckrideAirportId?: number;
    CheckrideGroupId?: number;
    CheckrideTypeId?: number;
    CheckRideTestTypeId?: number;
    CheckrideDurationMinutes?: number;
    CheckrideEndDateTime?: string;
    PlanOfActionResultId?: number;
    CheckrideResultId?: number;
    CheckRideOutcomeId?: number;
    AllowRetest?: boolean;
    FlagApplicant?: boolean;
    AllowRetestReason?: string;
    RetestCost?: number;
    AddToWaitlist?: boolean;
    GroundPortionComplete?: boolean;
    FlightSchoolOrganizationId?: number;
    OdaFlightSchoolId?: number;
    FlightSchoolId?: number;
    CheckrideTypeShortName?: string;

    // Display Attributes
    PlanOfActionStatusIdDisplay?: string;
    CheckrideRequestSubStatusIdDisplay?: string;
    AviationAuthorityIdDisplay?: string;
    CheckRideExaminerTypeIdDisplay?: string;
    PilotExaminerIdDisplay?: string;
    FlightSchoolExaminerIdDisplay?: string;
    CheckRideOwnershipTypeIdDisplay?: string;
    CheckRideApplicantTypeIdDisplay?: string;
    FlightSchoolApplicantIdDisplay?: string;
    FlightSchoolInstructorIdDisplay?: string;
    CheckrideAirportIdDisplay?: string;
    CheckrideGroupIdDisplay?: string;
    CheckrideTypeIdDisplay?: string;
    CheckRideTestTypeIdDisplay?: string;
    CheckRideOutcomeIdDisplay?: string;

    // Relations
}

export interface RoCalendarSyncRequestDisplayEntity extends DwOrmData {
    // Attributes
    CalendarSyncRequestId?: number;
    SourceRecordKeyDisplay?: string;
    SourceDisplayName?: string;


    // Relations
    CalendarSyncRequest? : CalendarSyncRequestEntity;
}

export interface RoCheckrideAcsFactBaseEntity extends DwOrmData {
    // Attributes
    SourceType?: string;
    AssessmentId?: number;
    AssessmentKey?: string;
    PlanOfActionId?: number;
    CheckRideRequestId?: number;
    AcsTestId?: number;
    ApplicantAcsWrittenResultTypeId?: number;
    ApplicantAcsWrittenResultId?: number;
    PlanOfActionName?: string;
    PlanOfActionStatusId?: number;
    CheckrideRequestSubStatusId?: number;
    AviationAuthorityId?: number;
    CheckRideExaminerTypeId?: number;
    PilotExaminerId?: number;
    FlightSchoolExaminerId?: number;
    AuthorityPreCheckRideNumber?: string;
    AuthorityPreapprovalCode?: string;
    CheckRideOwnershipTypeId?: number;
    CheckRideApplicantTypeId?: number;
    ApplicantName?: string;
    ApplicantEmail?: string;
    ApplicantPhone?: string;
    ExaminerName?: string;
    ExaminerEmail?: string;
    ExaminerPhone?: string;
    FlightSchoolApplicantId?: number;
    FlightSchoolInstructorId?: number;
    CheckrideDateTime?: string;
    CheckrideAirportId?: number;
    CheckrideGroupId?: number;
    CheckrideTypeId?: number;
    CheckRideTestTypeId?: number;
    CheckrideDurationMinutes?: number;
    CheckrideEndDateTime?: string;
    PlanOfActionResultId?: number;
    CheckrideResultId?: number;
    CheckRideOutcomeId?: number;
    AllowRetest?: boolean;
    FlagApplicant?: boolean;
    AllowRetestReason?: string;
    RetestCost?: number;
    AddToWaitlist?: boolean;
    GroundPortionComplete?: boolean;
    FlightSchoolOrganizationId?: number;
    FlightSchoolId?: number;
    OdaFlightSchoolId?: number;
    CheckrideTypeShortName?: string;
    CheckRideTestAttemptClassificationId?: number;
    AttemptClassification?: string;
    IsInitial?: boolean;
    IsRetest?: boolean;
    IsContinuance?: boolean;

    // Display Attributes
    AcsTestIdDisplay?: string;
    ApplicantAcsWrittenResultTypeIdDisplay?: string;
    PlanOfActionStatusIdDisplay?: string;
    CheckrideRequestSubStatusIdDisplay?: string;
    AviationAuthorityIdDisplay?: string;
    CheckRideExaminerTypeIdDisplay?: string;
    PilotExaminerIdDisplay?: string;
    FlightSchoolExaminerIdDisplay?: string;
    CheckRideOwnershipTypeIdDisplay?: string;
    CheckRideApplicantTypeIdDisplay?: string;
    FlightSchoolApplicantIdDisplay?: string;
    FlightSchoolInstructorIdDisplay?: string;
    CheckrideAirportIdDisplay?: string;
    CheckrideGroupIdDisplay?: string;
    CheckrideTypeIdDisplay?: string;
    CheckRideTestTypeIdDisplay?: string;
    CheckRideOutcomeIdDisplay?: string;

    // Relations
}

export interface RoCheckrideAggregateUtilEntity extends DwOrmData {
    // Attributes
    CheckrideRequestId?: number;
    ScheduledDateTime?: string;
    ScheduledDateTimeYear?: number;
    ScheduledDateTimeMonth?: number;
    ScheduledDateTimeMonthDisplay?: string;
    CheckRideRequestStatusId?: number;
    CheckRideRequestStatus?: string;
    PilexosPaymentDateTimeYear?: number;
    PilexosPaymentDateTimeMonth?: number;
    PilexosPaymentTotal?: number;
    CheckridePaymentDateTimeYear?: number;
    CheckridePaymentDateTimeMonth?: number;
    CheckridePaymentTotal?: number;
    OutcomeIsRequested?: number;
    OutcomeIsBooked?: number;
    OutcomeIsComplete?: number;
    OutcomeIsCancelled?: number;
    RevenueIsRequested?: number;
    RevenueIsBooked?: number;
    RevenueIsComplete?: number;
    RevenueIsCancelled?: number;
    CheckRideTypeDisplay?: string;
    ScheduledDateTimeMonthYearDisplay?: string;
    CheckRideAcceptedDateTime?: string;
    CheckRideOutcomeId?: number;
    CheckRideOutcome?: string;
    ResultIsPassed?: number;
    ResultIsFailed?: number;
    ResultIsDiscontinued?: number;
    FinalWaitTimeDays?: number;
    CurrentWaitTimeDays?: number;
    CheckRideDateTime?: string;
    CheckRideRequestSubStatusId?: number;
    CheckRideRequestSubStatus?: string;

    // Display Attributes
    CheckrideRequestIdDisplay?: string;

    // Relations
    CheckrideRequestIdCheckRideRequest? : CheckRideRequestEntity;
}

export interface RoCheckrideApplicantFinalNameEntity extends DwOrmData {
    // Attributes
    CheckRideRequestId?: number;
    StudentApplicantNameManual?: string;
    StudentProfileName?: string;
    ApplicantFinalName?: string;
    CheckRideApplicantTypeId?: number;
    ApplicantFinalEmail?: string;
    ApplicantFinalPhone?: string;
    FlightSchoolFinalName?: string;
    PilotExaminerFinalName?: string;
    PilotExaminerFinalEmail?: string;
    PilotExaminerFinalPhone?: string;
    FlightInstructorFinalName?: string;
    FlightInstructorFinalEmail?: string;
    FlightInstructorFinalPhone?: string;
    CheckRideExaminerTypeId?: number;

    // Display Attributes
    CheckRideRequestIdDisplay?: string;

    // Relations
    CheckRideRequest? : CheckRideRequestEntity;
}

export interface RoCheckrideFactBaseEntity extends DwOrmData {
    // Attributes
    SourceType?: string;
    AssessmentId?: number;
    AssessmentKey?: string;
    PlanOfActionId?: number;
    CheckRideRequestId?: number;
    PlanOfActionName?: string;
    PlanOfActionStatusId?: number;
    CheckrideRequestSubStatusId?: number;
    AviationAuthorityId?: number;
    CheckRideExaminerTypeId?: number;
    PilotExaminerId?: number;
    FlightSchoolExaminerId?: number;
    AuthorityPreCheckRideNumber?: string;
    AuthorityPreapprovalCode?: string;
    CheckRideOwnershipTypeId?: number;
    CheckRideApplicantTypeId?: number;
    ApplicantName?: string;
    ApplicantEmail?: string;
    ApplicantPhone?: string;
    ExaminerName?: string;
    ExaminerEmail?: string;
    ExaminerPhone?: string;
    FlightSchoolApplicantId?: number;
    FlightSchoolInstructorId?: number;
    CheckrideDateTime?: string;
    CheckrideAirportId?: number;
    CheckrideGroupId?: number;
    CheckrideTypeId?: number;
    CheckRideTestTypeId?: number;
    CheckrideDurationMinutes?: number;
    CheckrideEndDateTime?: string;
    PlanOfActionResultId?: number;
    CheckrideResultId?: number;
    CheckRideOutcomeId?: number;
    AllowRetest?: boolean;
    FlagApplicant?: boolean;
    AllowRetestReason?: string;
    RetestCost?: number;
    AddToWaitlist?: boolean;
    GroundPortionComplete?: boolean;
    FlightSchoolId?: number;
    FlightSchoolOrganizationId?: number;
    OdaFlightSchoolId?: number;
    CheckRideTestAttemptClassificationId?: number;
    AttemptClassification?: string;
    PerformanceOutcome?: string;
    IsInitial?: boolean;
    IsRetest?: boolean;
    IsContinuance?: boolean;
    IsPerformanceEligible?: boolean;
    EligibleAssessmentCount?: number;
    PassCount?: number;
    FailCount?: number;
    CheckrideTypeShortName?: string;
    CheckrideYear?: number;
    CheckRideRequestStatusId?: number;
    CheckRideRequestStatus?: string;
    InstructorName?: string;
    CheckRideCancellationTypeId?: number;
    ApplicantFlightSchoolName?: string;
    CheckrideMonth?: number;
    CheckrideMonthKey?: number;
    CheckrideMonthYearDisplay?: string;
    FinalWaitTimeDays?: number;
    CurrentWaitTimeDays?: number;
    AviationTrainingProgramId?: number;
    RequestedCount?: number;
    BookedCount?: number;
    CompletedCount?: number;
    CancelledCount?: number;
    RequestedRevenue?: number;
    BookedRevenue?: number;
    CompletedRevenue?: number;
    PaidRevenue?: number;
    ResultPassCount?: number;
    ResultFailCount?: number;
    ResultDiscontinuedCount?: number;

    // Display Attributes
    PlanOfActionStatusIdDisplay?: string;
    CheckrideRequestSubStatusIdDisplay?: string;
    AviationAuthorityIdDisplay?: string;
    CheckRideExaminerTypeIdDisplay?: string;
    PilotExaminerIdDisplay?: string;
    FlightSchoolExaminerIdDisplay?: string;
    CheckRideOwnershipTypeIdDisplay?: string;
    CheckRideApplicantTypeIdDisplay?: string;
    FlightSchoolApplicantIdDisplay?: string;
    FlightSchoolInstructorIdDisplay?: string;
    CheckrideAirportIdDisplay?: string;
    CheckrideGroupIdDisplay?: string;
    CheckrideTypeIdDisplay?: string;
    CheckRideTestTypeIdDisplay?: string;
    CheckRideOutcomeIdDisplay?: string;
    CheckRideCancellationTypeIdDisplay?: string;
    AviationTrainingProgramIdDisplay?: string;

    // Relations
}

export interface RoCheckRidePaymentAggregateEntity extends DwOrmData {
    // Attributes
    CheckrideRequestId?: number;
    PaymentDateTimeYear?: number;
    PaymentDateTimeMonth?: number;
    IsCheckridePayment?: number;
    Count?: number;
    PaymentTotal?: number;
    PaymentPartyId?: number;


    // Relations
}

export interface RoCheckRideRequestApplicantEntity extends DwOrmData {
    // Attributes
    CheckRideRequestId?: number;
    AuthorityPreCheckRideNumber?: string;
    CheckRideGroupId?: number;
    CheckRideTypeId?: number;
    CheckRideTestTypeId?: number;
    CheckRideRequestSubStatusId?: number;
    StudentApplicantNameManual?: string;
    StudentApplicantEmailManual?: string;
    FlightSchoolApplicantId?: number;
    StudentApplicantId?: number;
    StudentApplicantEmail?: string;
    StudentApplicantName?: string;
    FlightSchoolApplicantEmail?: string;
    FlightSchoolApplicantName?: string;

    // Display Attributes
    CheckRideRequestIdDisplay?: string;

    // Relations
    CheckRideRequest? : CheckRideRequestEntity;
}

export interface RoCheckrideRequestScheduleDateInfoEntity extends DwOrmData {
    // Attributes
    ScheduledDateTime?: string;
    ScheduledDateTimeYear?: number;
    ScheduledDateTimeMonth?: number;
    CheckrideRequestId?: number;
    ScheduledDateTimeMonthDisplay?: string;

    // Display Attributes
    CheckrideRequestIdDisplay?: string;

    // Relations
    CheckrideRequestIdCheckRideRequest? : CheckRideRequestEntity;
}

export interface RoFlightSchoolExaminerEntity extends DwOrmData {
    // Attributes
    FlightSchoolExaminerId?: number;
    ExaminerNameFinal?: string;
    ExaminerEmailFinal?: string;
    ExaminerPhoneFinal?: string;
    PilotExaminerId?: number;
    PilotExaminerStatusId?: number;
    ExaminerGroup?: string;
    PilotExaminerTypeId?: number;
    FinalExaminerTypeId?: number;
    HasPilexosAccount?: boolean;

    // Display Attributes
    FlightSchoolExaminerIdDisplay?: string;
    FinalExaminerTypeIdDisplay?: string;

    // Relations
    FlightSchoolExaminer? : FlightSchoolExaminerEntity;
}

export interface RoFlightSchoolExaminerSearchEntity extends DwOrmData {
    // Attributes
    FlightSchoolExaminerId?: number;
    FlightSchoolOrganizationId?: number;
    FlightSchoolId?: number;
    ExaminerNameFinal?: string;
    ExaminerEmailFinal?: string;
    ExaminerPhoneFinal?: string;
    FinalExaminerTypeId?: number;
    ExaminerGroup?: string;
    PreTimeMinutes?: number;
    PostTimeMinutes?: number;
    FirstDate?: string;
    LastDate?: string;
    AirportId?: number;
    Distance?: number;
    ReferenceAirportId?: number;
    PilotExaminerId?: number;
    TimezoneId?: number;
    ObservesDST?: boolean;
    ReferenceAirportTimezoneId?: number;
    ReferenceAirportObservesDST?: boolean;

    // Display Attributes
    FinalExaminerTypeIdDisplay?: string;
    AirportIdDisplay?: string;
    ReferenceAirportIdDisplay?: string;
    TimezoneIdDisplay?: string;

    // Relations
}

export interface DwRoleEntity extends DwOrmData {
    // Attributes
    ApplicationId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    IsBuiltIn?: boolean;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    RoleDisplay?: string;
    RoleId?: number;
    RoleMeaning?: string;
    UniqueId?: string;

    // Display Attributes
    ApplicationIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
}

export interface DwRoMediaEntity extends DwOrmData {
    // Attributes
    ContainerName?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    FileName?: string;
    ImageHeight?: number;
    ImageWidth?: number;
    IsDeleted?: boolean;
    IsSecure?: boolean;
    MediaDetailKey?: string;
    MediaFolderId?: number;
    MediaGroupId?: number;
    MediaId?: number;
    MediaName?: string;
    MediaPath?: string;
    MediaSizeType?: string;
    MediaSizeTypeId?: number;
    MediaTypeId?: number;
    SizeInBytes?: number;
    Version?: number;

    // Display Attributes
    CreatedByDisplay?: string;
    MediaGroupIdDisplay?: string;
    MediaIdDisplay?: string;

    // Relations
    DwMediaGroup? : DwMediaGroupEntity;
    UserPictureDwUser? : DwUserEntity;
}

export interface RoPilotExaminerLocationCurrentEntity extends DwOrmData {
    // Attributes
    PilotExaminerLocationId?: number;
    PilotExaminerLocationStateId?: number;

    // Display Attributes
    PilotExaminerLocationIdDisplay?: string;
    PilotExaminerLocationStateIdDisplay?: string;

    // Relations
    PilotExaminerLocation? : PilotExaminerLocationEntity;
}

export interface RoPilotExaminerLocationDistancesEntity extends DwOrmData {
    // Attributes
    ReferenceAirportId?: number;
    ReferenceAirportName?: string;
    ReferenceAirportLatitude?: number;
    ReferenceAirportLongitude?: number;
    AirportId?: number;
    AirportName?: string;
    Latitude?: number;
    Longitude?: number;
    Distance?: number;
    PilotExaminerLocationId?: number;
    PilotExaminerId?: number;
    WithinTravelRadius?: boolean;
    TravelRadiusMile?: number;
    ReferenceAirportCode?: string;
    AirportCode?: string;

    // Display Attributes
    ReferenceAirportIdDisplay?: string;
    AirportIdDisplay?: string;
    PilotExaminerLocationIdDisplay?: string;
    PilotExaminerIdDisplay?: string;

    // Relations
    Airport? : AirportEntity;
    PilotExaminer? : PilotExaminerEntity;
    PilotExaminerLocation? : PilotExaminerLocationEntity;
}

export interface RoPilotExaminerScenarioEntity extends DwOrmData {
    // Attributes
    PilotExaminerId?: number;
    userId?: number;
    PilotExaminerStatusId?: number;
    AviationAuthorityId?: number;
    CheckRideScenarioId?: number;
    CheckRideGroupId?: number;
    PreTimeMinutes?: number;
    PostTimeMinutes?: number;
    IsActive?: boolean;
    TimeRequiredHours?: number;
    CheckRideTypeId?: number;
    CheckRideGroup?: string;
    CheckRideType?: string;
    CheckRideScenarioTypeMapId?: number;

    // Display Attributes
    PilotExaminerIdDisplay?: string;
    userIdDisplay?: string;
    CheckRideScenarioIdDisplay?: string;

    // Relations
    CheckRideScenario? : CheckRideScenarioEntity;
    PilotExaminer? : PilotExaminerEntity;
    UserIdDwUser? : DwUserEntity;
}

export interface RoPlanOfActionAcsFactBaseEntity extends DwOrmData {
    // Attributes
    SourceType?: string;
    AssessmentId?: number;
    AssessmentKey?: string;
    PlanOfActionId?: number;
    CheckRideRequestId?: number;
    AcsTestId?: number;
    ApplicantAcsWrittenResultTypeId?: number;
    ApplicantAcsWrittenResultId?: number;
    PlanOfActionName?: string;
    PlanOfActionStatusId?: number;
    CheckrideRequestSubStatusId?: number;
    AviationAuthorityId?: number;
    CheckRideExaminerTypeId?: number;
    PilotExaminerId?: number;
    FlightSchoolExaminerId?: number;
    AuthorityPreCheckRideNumber?: string;
    AuthorityPreapprovalCode?: string;
    CheckRideOwnershipTypeId?: number;
    CheckRideApplicantTypeId?: number;
    ApplicantName?: string;
    ApplicantEmail?: string;
    ApplicantPhone?: string;
    ExaminerName?: string;
    ExaminerEmail?: string;
    ExaminerPhone?: string;
    FlightSchoolApplicantId?: number;
    FlightSchoolInstructorId?: number;
    CheckrideDateTime?: string;
    CheckrideAirportId?: number;
    CheckrideGroupId?: number;
    CheckrideTypeId?: number;
    CheckRideTestTypeId?: number;
    CheckrideDurationMinutes?: number;
    CheckrideEndDateTime?: string;
    PlanOfActionResultId?: number;
    CheckrideResultId?: number;
    CheckRideOutcomeId?: number;
    AllowRetest?: boolean;
    FlagApplicant?: boolean;
    AllowRetestReason?: string;
    RetestCost?: number;
    AddToWaitlist?: boolean;
    GroundPortionComplete?: boolean;
    FlightSchoolOrganizationId?: number;
    OdaFlightSchoolId?: number;
    CheckrideTypeShortName?: string;
    CheckRideTestAttemptClassificationId?: number;
    AttemptClassification?: string;
    IsInitial?: boolean;
    IsRetest?: boolean;
    IsContinuance?: boolean;

    // Display Attributes
    AcsTestIdDisplay?: string;
    ApplicantAcsWrittenResultTypeIdDisplay?: string;
    PlanOfActionStatusIdDisplay?: string;
    CheckrideRequestSubStatusIdDisplay?: string;
    AviationAuthorityIdDisplay?: string;
    CheckRideExaminerTypeIdDisplay?: string;
    PilotExaminerIdDisplay?: string;
    FlightSchoolExaminerIdDisplay?: string;
    CheckRideOwnershipTypeIdDisplay?: string;
    CheckRideApplicantTypeIdDisplay?: string;
    FlightSchoolApplicantIdDisplay?: string;
    FlightSchoolInstructorIdDisplay?: string;
    CheckrideAirportIdDisplay?: string;
    CheckrideGroupIdDisplay?: string;
    CheckrideTypeIdDisplay?: string;
    CheckRideTestTypeIdDisplay?: string;
    CheckRideOutcomeIdDisplay?: string;

    // Relations
}

export interface RoPlanOfActionDetailsEntity extends DwOrmData {
    // Attributes
    PlanOfActionId?: number;
    PlanOfActionName?: string;
    ApplicantFinalName?: string;
    ApplicantFinalEmail?: string;
    ApplicationFinalPhone?: string;
    CheckRideFinalDateTime?: string;
    CheckRideFinalAirportId?: number;
    CheckRideFinalGroupId?: number;
    CheckRideFInalTypeId?: number;
    CheckRideFinalTestTypeId?: number;
    CheckRideFinalDurationMinutes?: number;
    CheckRideFinalEndDateTime?: string;
    FlightInstructorFinalId?: number;
    FlightSchoolApplicantId?: number;
    CheckRideRequestId?: number;

    // Display Attributes
    PlanOfActionIdDisplay?: string;
    CheckRideFinalAirportIdDisplay?: string;
    CheckRideFinalGroupIdDisplay?: string;
    CheckRideFInalTypeIdDisplay?: string;
    CheckRideFinalTestTypeIdDisplay?: string;
    FlightInstructorFinalIdDisplay?: string;

    // Relations
    PlanOfAction? : PlanOfActionEntity;
}

export interface RoPlanOfActionFactBaseEntity extends DwOrmData {
    // Attributes
    SourceType?: string;
    AssessmentId?: number;
    AssessmentKey?: string;
    PlanOfActionId?: number;
    CheckRideRequestId?: number;
    PlanOfActionName?: string;
    PlanOfActionStatusId?: number;
    CheckrideRequestSubStatusId?: number;
    AviationAuthorityId?: number;
    CheckRideExaminerTypeId?: number;
    PilotExaminerId?: number;
    FlightSchoolExaminerId?: number;
    AuthorityPreCheckRideNumber?: string;
    AuthorityPreapprovalCode?: string;
    CheckRideOwnershipTypeId?: number;
    CheckRideApplicantTypeId?: number;
    ApplicantName?: string;
    ApplicantEmail?: string;
    ApplicantPhone?: string;
    ExaminerName?: string;
    ExaminerEmail?: string;
    ExaminerPhone?: string;
    FlightSchoolApplicantId?: number;
    FlightSchoolInstructorId?: number;
    CheckrideDateTime?: string;
    CheckrideAirportId?: number;
    CheckrideGroupId?: number;
    CheckrideTypeId?: number;
    CheckRideTestTypeId?: number;
    CheckrideDurationMinutes?: number;
    CheckrideEndDateTime?: string;
    PlanOfActionResultId?: number;
    CheckrideResultId?: number;
    CheckRideOutcomeId?: number;
    AllowRetest?: boolean;
    FlagApplicant?: boolean;
    AllowRetestReason?: string;
    RetestCost?: number;
    AddToWaitlist?: boolean;
    GroundPortionComplete?: boolean;
    FlightSchoolOrganizationId?: number;
    OdaFlightSchoolId?: number;
    CheckrideTypeShortName?: string;

    // Display Attributes
    PlanOfActionStatusIdDisplay?: string;
    CheckrideRequestSubStatusIdDisplay?: string;
    AviationAuthorityIdDisplay?: string;
    CheckRideExaminerTypeIdDisplay?: string;
    PilotExaminerIdDisplay?: string;
    FlightSchoolExaminerIdDisplay?: string;
    CheckRideOwnershipTypeIdDisplay?: string;
    CheckRideApplicantTypeIdDisplay?: string;
    FlightSchoolApplicantIdDisplay?: string;
    FlightSchoolInstructorIdDisplay?: string;
    CheckrideAirportIdDisplay?: string;
    CheckrideGroupIdDisplay?: string;
    CheckrideTypeIdDisplay?: string;
    CheckRideTestTypeIdDisplay?: string;
    CheckRideOutcomeIdDisplay?: string;

    // Relations
}

export interface RoScheduleBlockSchoolExaminerFinalEntity extends DwOrmData {
    // Attributes
    ScheduleBlockId?: number;
    PilotExaminerId?: number;
    FlightSchoolExaminerId?: number;
    ExaminerNameFinal?: string;
    ExaminerEmailFinal?: string;
    FlightScholExaminerTypeIdFinal?: number;

    // Display Attributes
    FlightScholExaminerTypeIdFinalDisplay?: string;

    // Relations
    ScheduleBlock? : ScheduleBlockEntity;
}

export interface RoSchoolExaminersEntity extends DwOrmData {
    // Attributes
    PilotExaminerId?: number;
    ExaminerName?: string;
    FlightSchoolOrganizationId?: number;
    Type?: string;
    FlightSchoolExaminerId?: number;


    // Relations
}

export interface RoUnitMemberDpeSupplementSummaryEntity extends DwOrmData {
    // Attributes
    FlightSchoolExaminerId?: number;
    ExaminerName?: string;
    FlightSchoolOrganizationId?: number;
    FlightSchoolExaminerTypeId?: number;
    TrainingCurrent?: boolean;
    TrainingCurrentEvaluatedDateTime?: string;
    DpeSupplementReviewedDateTime?: string;
    DpeSupplementReviewedBy?: number;
    DpeSupplementLastUpdatedDateTime?: string;


    // Relations
}

export interface ScheduleEntity extends DwOrmData {
    // Attributes
    ScheduleId?: number;
    ScheduleName?: string;
    DefaultStartTime?: string;
    DefaultEndTime?: string;
    WeekDaysOnly?: boolean;
    UseCustomDays?: boolean;
    ScheduleOwnerUserId?: number;
    IsBuiltInSchedule?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    ReferenceStatusId?: number;

    // Display Attributes
    ScheduleOwnerUserIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    ReferenceStatusIdDisplay?: string;

    // Relations
    ReferenceStatus? : ReferenceStatusEntity;
    ScheduleOwnerDwUser? : DwUserEntity;
    FlightSchoolPilotExaminer? : PilotExaminerEntity[];
    FlightSchoolPilotExaminerFlightSchoolSetup? : PilotExaminerFlightSchoolSetupEntity[];
    BookingPilotExaminerLocation? : PilotExaminerLocationEntity[];
    BookingScheduleBlockItem? : ScheduleBlockItemEntity[];
    ScheduleDetail? : ScheduleDetailEntity[];
}

export interface ScheduleBlockEntity extends DwOrmData {
    // Attributes
    ScheduleBlockId?: number;
    PilotExaminerId?: number;
    ScheduleBlockStatusId?: number;
    ScheduleBlockName?: string;
    ScheduleBlockDescription?: string;
    FirstDate?: string;
    LastDate?: string;
    FlightSchoolId?: number;
    BookingTimeZoneId?: number;
    ColorName?: string;
    BackgroundColor?: string;
    ForegroundColor?: string;
    OwnershipTypeId?: number;
    FlightSchoolExaminerId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    PilotExaminerIdDisplay?: string;
    ScheduleBlockStatusIdDisplay?: string;
    FlightSchoolIdDisplay?: string;
    BookingTimeZoneIdDisplay?: string;
    OwnershipTypeIdDisplay?: string;
    FlightSchoolExaminerIdDisplay?: string;

    // Relations
    OwnershipTypeIdCheckRideOwnershipType? : CheckRideOwnershipTypeEntity;
    FlightSchool? : FlightSchoolEntity;
    FlightSchoolExaminer? : FlightSchoolExaminerEntity;
    PilotExaminer? : PilotExaminerEntity;
    ScheduleBlockStatus? : ScheduleBlockStatusEntity;
    BookingTimeZoneIdTimeZone? : TimeZoneEntity;
    RoScheduleBlockSchoolExaminerFinal? : RoScheduleBlockSchoolExaminerFinalEntity[];
    ScheduleBlockAirport? : ScheduleBlockAirportEntity[];
    ScheduleBlockCheckRideType? : ScheduleBlockCheckRideTypeEntity[];
    ScheduleBlockItem? : ScheduleBlockItemEntity[];
    ScheduleBlockLocation? : ScheduleBlockLocationEntity[];
}

export interface ScheduleBlockAirportEntity extends DwOrmData {
    // Attributes
    ScheduleBlockAirport?: number;
    ScheduleBlockId?: number;
    AirportId?: number;

    // Display Attributes
    ScheduleBlockIdDisplay?: string;
    AirportIdDisplay?: string;

    // Relations
    Airport? : AirportEntity;
    ScheduleBlock? : ScheduleBlockEntity;
}

export interface ScheduleBlockCheckRideTypeEntity extends DwOrmData {
    // Attributes
    ScheduleBlockCheckRideTypeId?: number;
    ScheduleBlockId?: number;
    CheckRideTypeId?: number;

    // Display Attributes
    ScheduleBlockIdDisplay?: string;
    CheckRideTypeIdDisplay?: string;

    // Relations
    CheckRideType? : CheckRideTypeEntity;
    ScheduleBlock? : ScheduleBlockEntity;
}

export interface ScheduleBlockItemEntity extends DwOrmData {
    // Attributes
    ScheduleBlockItemId?: number;
    ScheduleBlockId?: number;
    ScheduleBlockItemTypeId?: number;
    ScheduleBlockItemStatusId?: number;
    StartDate?: string;
    EndDate?: string;
    StartTime?: string;
    EndTime?: string;
    BookingScheduleId?: number;
    BlockItemDescription?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ScheduleBlockIdDisplay?: string;
    ScheduleBlockItemTypeIdDisplay?: string;
    ScheduleBlockItemStatusIdDisplay?: string;
    BookingScheduleIdDisplay?: string;

    // Relations
    BookingSchedule? : ScheduleEntity;
    ScheduleBlock? : ScheduleBlockEntity;
    ScheduleBlockItemStatus? : ScheduleBlockItemStatusEntity;
    ScheduleBlockItemType? : ScheduleBlockItemTypeEntity;
    ScheduleBlockItemCalendarItem? : ScheduleBlockItemCalendarItemEntity[];
}

export interface ScheduleBlockItemCalendarItemEntity extends DwOrmData {
    // Attributes
    ScheduleBlockItemCalendarRefId?: number;
    ScheduleBlockItemId?: number;
    CalendarEventReferenceId?: number;
    StartDateTime?: string;
    EndDateTime?: string;
    SubjectText?: string;
    BodyHtml?: string;
    IsCancelled?: boolean;
    BackgroundColor?: string;
    ForegroundColor?: string;

    // Display Attributes
    ScheduleBlockItemIdDisplay?: string;
    CalendarEventReferenceIdDisplay?: string;

    // Relations
    CalendarEventReference? : CalendarEventReferenceEntity;
    ScheduleBlockItem? : ScheduleBlockItemEntity;
}

export interface ScheduleBlockItemStatusEntity extends DwOrmData {
    // Attributes
    ScheduleBlockItemStatusId?: number;
    ScheduleBlockItemStatus?: string;


    // Relations
    ScheduleBlockItem? : ScheduleBlockItemEntity[];
}

export interface ScheduleBlockItemTypeEntity extends DwOrmData {
    // Attributes
    ScheduleBlockItemTypeId?: number;
    ScheduleBlockItemType?: string;


    // Relations
    ScheduleBlockItem? : ScheduleBlockItemEntity[];
}

export interface ScheduleBlockLocationEntity extends DwOrmData {
    // Attributes
    ScheduleBlockLocationId?: number;
    ScheduleBlockId?: number;
    PilotExaminerLocationId?: number;

    // Display Attributes
    ScheduleBlockIdDisplay?: string;
    PilotExaminerLocationIdDisplay?: string;

    // Relations
    PilotExaminerLocation? : PilotExaminerLocationEntity;
    ScheduleBlock? : ScheduleBlockEntity;
}

export interface ScheduleBlockSchoolBookingOptionEntity extends DwOrmData {
    // Attributes
    ScheduleBlockSchoolBookingOptionId?: number;
    SchoolBookingOption?: string;
    SchoolBookingOptionDescription?: string;
    OptionOrder?: number;


    // Relations
    ScheduleBlockSchoolDefaultOptionIdPilotExaminer? : PilotExaminerEntity[];
    ScheduleBlockSchoolDefaultOptionIdPilotExaminerFlightSchoolSetup? : PilotExaminerFlightSchoolSetupEntity[];
}

export interface ScheduleBlockStatusEntity extends DwOrmData {
    // Attributes
    ScheduleBlockStatusId?: number;
    ScheduleBlockStatus?: string;


    // Relations
    ScheduleBlock? : ScheduleBlockEntity[];
}

export interface ScheduleDayOfWeekEntity extends DwOrmData {
    // Attributes
    ScheduleDayOfWeekId?: number;
    DayOfWeek?: string;
    DayOfWeekOrder?: number;


    // Relations
    ScheduleDetail? : ScheduleDetailEntity[];
}

export interface ScheduleDetailEntity extends DwOrmData {
    // Attributes
    ScheduleDetailId?: number;
    ScheduleId?: number;
    ScheduleDayOfWeekId?: number;
    StartTime?: string;
    EndTime?: string;

    // Display Attributes
    ScheduleIdDisplay?: string;
    ScheduleDayOfWeekIdDisplay?: string;

    // Relations
    Schedule? : ScheduleEntity;
    ScheduleDayOfWeek? : ScheduleDayOfWeekEntity;
}

export interface SchoolFeatureEntity extends DwOrmData {
    // Attributes
    SchoolFeatureId?: number;
    SchoolFeature?: string;


    // Relations
    FlightSchoolOrganizationFeature? : FlightSchoolOrganizationFeatureEntity[];
}

export interface StateProvinceEntity extends DwOrmData {
    // Attributes
    StateProvinceId?: number;
    CountryId?: number;
    StateProvinceName?: string;
    StateProvinceShortName?: string;
    StateCode?: string;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;

    // Display Attributes
    CountryIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Country? : CountryEntity;
    Address? : AddressEntity[];
    StudentApplicantCheckRideRequest? : CheckRideRequestEntity[];
    FlightSchoolApplicant? : FlightSchoolApplicantEntity[];
    StudentApplicantPlanOfAction? : PlanOfActionEntity[];
    PostalCode? : PostalCodeEntity[];
}

export interface StudentApplicantEntity extends DwOrmData {
    // Attributes
    StudentApplicantId?: number;
    UserId?: number;
    ApplicationDescription?: string;
    AviationAuthorityId?: number;
    PilotCertificateNumber?: string;
    TravelRadiusMiles?: number;
    Citizenship?: string;
    ApplicantAddressId?: number;
    MainAirportId?: number;
    MainAircraft?: string;
    ReferredPilotExaminerId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    AviationTrainingProgramId?: number;
    CitzenshipCountyId?: number;

    // Display Attributes
    UserIdDisplay?: string;
    AviationAuthorityIdDisplay?: string;
    ApplicantAddressIdDisplay?: string;
    MainAirportIdDisplay?: string;
    ReferredPilotExaminerIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    AviationTrainingProgramIdDisplay?: string;
    CitzenshipCountyIdDisplay?: string;

    // Relations
    ApplicantAddress? : AddressEntity;
    MainAirport? : AirportEntity;
    AviationAuthority? : AviationAuthorityEntity;
    AviationTrainingProgram? : AviationTrainingProgramEntity;
    CitzenshipCountyIdCountry? : CountryEntity;
    ReferredPilotExaminer? : PilotExaminerEntity;
    DwUser? : DwUserEntity;
    ApplicantPlaceholder? : ApplicantPlaceholderEntity[];
    CheckRideRequest? : CheckRideRequestEntity[];
    UserIdCheckRideScheduleHold? : CheckRideScheduleHoldEntity[];
    FlightSchoolApplicant? : FlightSchoolApplicantEntity[];
}

export interface SubscriptionEntity extends DwOrmData {
    // Attributes
    SubscriptionId?: number;
    SubscriptionPartyId?: number;
    PilotExaminerId?: number;
    SubscriptionTierId?: number;
    SubscriptionStatusId?: number;
    EffectiveStartDate?: string;
    EffectiveEndDate?: string;
    PaymentDiscountCodeId?: number;
    DiscountAppliedDate?: string;
    DiscountExpirationDate?: string;
    FirstInvoiceDate?: string;
    LastInvoiceDate?: string;
    NextInvoiceDate?: string;
    FlightSchoolOrganizationId?: number;

    // Display Attributes
    SubscriptionPartyIdDisplay?: string;
    PilotExaminerIdDisplay?: string;
    SubscriptionTierIdDisplay?: string;
    SubscriptionStatusIdDisplay?: string;
    PaymentDiscountCodeIdDisplay?: string;
    FlightSchoolOrganizationIdDisplay?: string;

    // Relations
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    PaymentDiscountCode? : PaymentDiscountCodeEntity;
    PilotExaminer? : PilotExaminerEntity;
    SubscriptionParty? : SubscriptionPartyEntity;
    SubscriptionStatus? : SubscriptionStatusEntity;
    SubscriptionTier? : SubscriptionTierEntity;
}

export interface SubscriptionFeatureEntity extends DwOrmData {
    // Attributes
    SubscriptionFeatureId?: number;
    SubscriptionFeature?: string;
    FeatureKey?: string;


    // Relations
    SubscriptionTierFeature? : SubscriptionTierFeatureEntity[];
}

export interface SubscriptionPartyEntity extends DwOrmData {
    // Attributes
    SubscriptionPartyId?: number;
    SubscriptionParty?: string;


    // Relations
    Subscription? : SubscriptionEntity[];
    SubscriptionTier? : SubscriptionTierEntity[];
}

export interface SubscriptionStatusEntity extends DwOrmData {
    // Attributes
    SubscriptionStatusId?: number;
    SubscriptionStatus?: string;


    // Relations
    Subscription? : SubscriptionEntity[];
}

export interface SubscriptionTierEntity extends DwOrmData {
    // Attributes
    SubscriptionTierId?: number;
    SubscriptionTierName?: string;
    SubscriptionTierStatusId?: number;
    PlatformMonthlyCost?: number;
    IncludedCheckrides?: number;
    SubscriptionPartyId?: number;
    SubscriptionTierDescriptionHtml?: string;

    // Display Attributes
    SubscriptionTierStatusIdDisplay?: string;
    SubscriptionPartyIdDisplay?: string;

    // Relations
    SubscriptionParty? : SubscriptionPartyEntity;
    SubscriptionTierStatus? : SubscriptionTierStatusEntity;
    Subscription? : SubscriptionEntity[];
    SubscriptionTierFeature? : SubscriptionTierFeatureEntity[];
}

export interface SubscriptionTierFeatureEntity extends DwOrmData {
    // Attributes
    SubscriptionTierFeatureId?: number;
    SubscriptionTierId?: number;
    SubscriptionFeatureId?: number;

    // Display Attributes
    SubscriptionTierIdDisplay?: string;
    SubscriptionFeatureIdDisplay?: string;

    // Relations
    SubscriptionFeature? : SubscriptionFeatureEntity;
    SubscriptionTier? : SubscriptionTierEntity;
}

export interface SubscriptionTierStatusEntity extends DwOrmData {
    // Attributes
    SubscriptionTierStatusId?: number;
    SubscriptionTierStatus?: string;


    // Relations
    SubscriptionTier? : SubscriptionTierEntity[];
}

export interface TimeZoneEntity extends DwOrmData {
    // Attributes
    TimezoneId?: number;
    TimezoneName?: string;
    TimezoneShortName?: string;
    GmtOffSet?: number;
    TimeZoneDescription?: string;
    IANAIdentifier?: string;
    DotNetBCLIdentifier?: string;


    // Relations
    Address? : AddressEntity[];
    BookingScheduleTimeZoneIdPilotExaminerLocation? : PilotExaminerLocationEntity[];
    TimeZoneIdPostalCode? : PostalCodeEntity[];
    BookingTimeZoneIdScheduleBlock? : ScheduleBlockEntity[];
}

export interface TrainingRecordEntity extends DwOrmData {
    // Attributes
    TrainingRecordId?: number;
    TrainingTypeId?: number;
    IssuedDate?: string;
    DateCompleted?: string;
    ExpirationDate?: string;
    TrainingRecordStatusId?: number;
    NotifyExpiringSoon?: boolean;
    NotifyExpired?: boolean;
    Notes?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    OwnershipTypeId?: number;
    FlightSchoolExaminerId?: number;
    PilotExaminerId?: number;
    CompletionDocumentMediaId?: number;

    // Display Attributes
    TrainingTypeIdDisplay?: string;
    TrainingRecordStatusIdDisplay?: string;
    OwnershipTypeIdDisplay?: string;
    FlightSchoolExaminerIdDisplay?: string;
    PilotExaminerIdDisplay?: string;

    // Relations
    OwnershipTypeIdCheckRideOwnershipType? : CheckRideOwnershipTypeEntity;
    FlightSchoolExaminer? : FlightSchoolExaminerEntity;
    PilotExaminer? : PilotExaminerEntity;
    TrainingRecordStatus? : TrainingRecordStatusEntity;
    TrainingType? : TrainingTypeEntity;
}

export interface TrainingRecordStatusEntity extends DwOrmData {
    // Attributes
    TrainingRecordStatusId?: number;
    TrainingRecordStatus?: string;
    CssClass?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    TrainingRecord? : TrainingRecordEntity[];
}

export interface TrainingTypeEntity extends DwOrmData {
    // Attributes
    TrainingTypeId?: number;
    TrainingType?: string;
    RequiredForPoa?: boolean;
    FileRequired?: boolean;
    ReferenceStatusId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ReferenceStatusIdDisplay?: string;

    // Relations
    ReferenceStatus? : ReferenceStatusEntity;
    TrainingRecord? : TrainingRecordEntity[];
}

export interface UnitMemberAircraftCategoryClassEntity extends DwOrmData {
    // Attributes
    UnitMemberAircraftCategoryClassId?: number;
    UnitMemberAircraftCategoryClass?: string;
    SortOrder?: number;
    ReferenceStatusId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ReferenceStatusIdDisplay?: string;

    // Relations
    ReferenceStatus? : ReferenceStatusEntity;
    UnitMemberFlightExperience? : UnitMemberFlightExperienceEntity[];
}

export interface UnitMemberAircraftExperienceEntity extends DwOrmData {
    // Attributes
    UnitMemberAircraftExperienceId?: number;
    FlightSchoolExaminerId?: number;
    UnitMemberAircraftExperienceTypeId?: number;
    AircraftMake?: string;
    AircraftModel?: string;
    PicHoursPastTwelveMonths?: number;
    TotalPicHours?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    FlightSchoolExaminerIdDisplay?: string;
    UnitMemberAircraftExperienceTypeIdDisplay?: string;

    // Relations
    FlightSchoolExaminer? : FlightSchoolExaminerEntity;
    UnitMemberAircraftExperienceType? : UnitMemberAircraftExperienceTypeEntity;
}

export interface UnitMemberAircraftExperienceTypeEntity extends DwOrmData {
    // Attributes
    UnitMemberAircraftExperienceTypeId?: number;
    UnitMemberAircraftExperienceType?: string;
    SortOrder?: number;
    ReferenceStatusId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ReferenceStatusIdDisplay?: string;

    // Relations
    ReferenceStatus? : ReferenceStatusEntity;
    UnitMemberAircraftExperience? : UnitMemberAircraftExperienceEntity[];
}

export interface UnitMemberCertificateEntity extends DwOrmData {
    // Attributes
    UnitMemberCertificateId?: number;
    FlightSchoolExaminerId?: number;
    CertificateType?: string;
    CertificateNumber?: string;
    Ratings?: string;
    IssuanceDate?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    FlightSchoolExaminerIdDisplay?: string;

    // Relations
    FlightSchoolExaminer? : FlightSchoolExaminerEntity;
}

export interface UnitMemberEmploymentEntity extends DwOrmData {
    // Attributes
    UnitMemberEmploymentId?: number;
    FlightSchoolExaminerId?: number;
    EmployerOrganizationName?: string;
    TelephoneNumber?: string;
    StreetAddress?: string;
    City?: string;
    StateOrCountry?: string;
    PostalCode?: string;
    PositionTitle?: string;
    EmployedFromDate?: string;
    EmployedToDate?: string;
    SupervisorName?: string;
    FaaAirAgencyOrOperatorCertificateNumber?: string;
    Experience?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    FlightSchoolExaminerIdDisplay?: string;

    // Relations
    FlightSchoolExaminer? : FlightSchoolExaminerEntity;
}

export interface UnitMemberFlightExperienceEntity extends DwOrmData {
    // Attributes
    UnitMemberFlightExperienceId?: number;
    FlightSchoolExaminerId?: number;
    UnitMemberAircraftCategoryClassId?: number;
    TotalHours?: number;
    TotalPicHours?: number;
    PicHoursPastTwelveMonths?: number;
    TotalInstructionGivenHours?: number;
    CfiiInstructionGivenHours?: number;
    BalloonInstructionPastTwelveMonthsHours?: number;
    NightPicHours?: number;
    InstrumentPicHours?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    FlightSchoolExaminerIdDisplay?: string;
    UnitMemberAircraftCategoryClassIdDisplay?: string;

    // Relations
    FlightSchoolExaminer? : FlightSchoolExaminerEntity;
    UnitMemberAircraftCategoryClass? : UnitMemberAircraftCategoryClassEntity;
}

export interface UnitMemberProfileEntity extends DwOrmData {
    // Attributes
    UnitMemberProfileId?: number;
    FlightSchoolExaminerId?: number;
    MedicalCertificateClass?: string;
    MedicalExaminationDate?: string;
    MedicalLimitations?: string;
    BasicMedCmecDate?: string;
    BasicMedCourseCompletionDate?: string;
    PoweredLiftAtpInstructionHours?: number;
    PoweredLiftTypeRatingInstructionHours?: number;
    PoweredLiftCfiiInstructionHours?: number;
    PoweredLiftCommercialInstructionHours?: number;
    HelicopterCommercialInstructionHours?: number;
    HelicopterAtpInstructionHours?: number;
    GliderPicFlightsPastYear?: number;
    BalloonPicFlightsPastYear?: number;
    HelicopterCfiiInstructionHours?: number;
    CommercialPreparationInstructionHours?: number;
    InstructionHoursPastThreeYears?: number;
    ComplexAirplanePicHours?: number;
    AtpPreparationInstructionHours?: number;
    TypeRatingPreparationInstructionHours?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    MedicalCertificateExpirationDate?: string;

    // Display Attributes
    FlightSchoolExaminerIdDisplay?: string;

    // Relations
    FlightSchoolExaminer? : FlightSchoolExaminerEntity;
}

export interface UnitMemberQualificationOptionEntity extends DwOrmData {
    // Attributes
    UnitMemberQualificationOptionId?: number;
    UnitMemberQualificationTypeId?: number;
    UnitMemberQualificationOption?: string;
    OptionValue?: number;
    SortOrder?: number;
    ReferenceStatusId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    UnitMemberQualificationTypeIdDisplay?: string;
    ReferenceStatusIdDisplay?: string;

    // Relations
    ReferenceStatus? : ReferenceStatusEntity;
    UnitMemberQualificationType? : UnitMemberQualificationTypeEntity;
    UnitMemberQualificationResponse? : UnitMemberQualificationResponseEntity[];
}

export interface UnitMemberQualificationResponseEntity extends DwOrmData {
    // Attributes
    UnitMemberQualificationResponseId?: number;
    FlightSchoolExaminerId?: number;
    UnitMemberQualificationTypeId?: number;
    YesNoValue?: boolean;
    NumericValue?: number;
    UnitMemberQualificationOptionId?: number;
    Notes?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    FlightSchoolExaminerIdDisplay?: string;
    UnitMemberQualificationTypeIdDisplay?: string;
    UnitMemberQualificationOptionIdDisplay?: string;

    // Relations
    FlightSchoolExaminer? : FlightSchoolExaminerEntity;
    UnitMemberQualificationOption? : UnitMemberQualificationOptionEntity;
    UnitMemberQualificationType? : UnitMemberQualificationTypeEntity;
}

export interface UnitMemberQualificationResponseTypeEntity extends DwOrmData {
    // Attributes
    UnitMemberQualificationResponseTypeId?: number;
    UnitMemberQualificationResponseType?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    UnitMemberQualificationType? : UnitMemberQualificationTypeEntity[];
}

export interface UnitMemberQualificationTypeEntity extends DwOrmData {
    // Attributes
    UnitMemberQualificationTypeId?: number;
    QualificationCode?: string;
    UnitMemberQualificationType?: string;
    UnitMemberQualificationResponseTypeId?: number;
    MaximumValue?: number;
    SortOrder?: number;
    ReferenceStatusId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    UnitMemberQualificationResponseTypeIdDisplay?: string;
    ReferenceStatusIdDisplay?: string;

    // Relations
    ReferenceStatus? : ReferenceStatusEntity;
    UnitMemberQualificationResponseType? : UnitMemberQualificationResponseTypeEntity;
    UnitMemberQualificationOption? : UnitMemberQualificationOptionEntity[];
    UnitMemberQualificationResponse? : UnitMemberQualificationResponseEntity[];
}

export interface DwUserEntity extends DwOrmData {
    // Attributes
    AlternateName?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    Email?: string;
    FirstName?: string;
    ForcePasswordChange?: boolean;
    IsActive?: boolean;
    IsEmailVerified?: boolean;
    IsTwoFactorAuthenticationEnabled?: boolean;
    LastLoginDateTime?: string;
    LastName?: string;
    LastPasswordChangeDateTime?: string;
    MobilePhone?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    OrganizationId?: number;
    PartyReferenceId?: number;
    TwoFactorAuthenticationTypeId?: number;
    UserBackgroundMediaId?: number;
    UserId?: number;
    UserKey?: string;
    UserName?: string;
    UserPictureMediaId?: number;
    UserTypeId?: number;
    Password?: number;

    // Display Attributes
    AlternateNameDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    OrganizationIdDisplay?: string;
    PartyReferenceIdDisplay?: string;
    TwoFactorAuthenticationTypeIdDisplay?: string;
    UserBackgroundMediaIdDisplay?: string;
    UserPictureMediaIdDisplay?: string;
    UserTypeIdDisplay?: string;

    // Relations
    UserPictureDwroMedia? : DwRoMediaEntity;
    DwUserType? : DwUserTypeEntity;
    CreatedByCheckRideScheduleHold? : CheckRideScheduleHoldEntity[];
    ModifiedByCheckRideScheduleHold? : CheckRideScheduleHoldEntity[];
    OriginalOwnerFlightSchoolOrganization? : FlightSchoolOrganizationEntity[];
    FlightSchoolUser? : FlightSchoolUserEntity;
    InitiatedByPaymentAttempt? : PaymentAttemptEntity[];
    PaymentCustomerReference? : PaymentCustomerReferenceEntity[];
    LimitToPaymentDiscountCode? : PaymentDiscountCodeEntity[];
    PilotExaminer? : PilotExaminerEntity;
    UserIdRoPilotExaminerScenario? : RoPilotExaminerScenarioEntity[];
    ScheduleOwnerSchedule? : ScheduleEntity[];
    StudentApplicant? : StudentApplicantEntity;
}

export interface DwUserInviteRequestEntity extends DwOrmData {
    // Attributes
    UserInviteRequestId?: number;
    InviteRequestTypeId?: number;
    MessageHtml?: string;
    InviteRequestStatusId?: number;
    CompletedDateTime?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    InviteRequestTypeIdDisplay?: string;
    InviteRequestStatusIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    InviteRequestStatusIdDwUserInviteRequestStatus? : DwUserInviteRequestStatusEntity;
    InviteRequestTypeIdDwUserInviteRequestType? : DwUserInviteRequestTypeEntity;
    UserInviteRequestDetail? : UserInviteRequestDetailEntity;
    DwUserInviteRequestEmail? : DwUserInviteRequestEmailEntity[];
}

export interface UserInviteRequestDetailEntity extends DwOrmData {
    // Attributes
    UserInviteRequestDetailId?: number;
    UserInviteRequestId?: number;
    FlightSchoolOrganizationId?: number;
    CanAccessAllLocations?: boolean;
    FlightSchoolInstructorId?: number;
    FlightSchoolExaminerId?: number;

    // Display Attributes
    UserInviteRequestIdDisplay?: string;
    FlightSchoolOrganizationIdDisplay?: string;
    FlightSchoolInstructorIdDisplay?: string;
    FlightSchoolExaminerIdDisplay?: string;

    // Relations
    FlightSchoolExaminer? : FlightSchoolExaminerEntity;
    FlightSchoolInstructor? : FlightSchoolInstructorEntity;
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    DwUserInviteRequest? : DwUserInviteRequestEntity;
    UserInviteRequestSchoolBranch? : UserInviteRequestSchoolBranchEntity[];
}

export interface DwUserInviteRequestEmailEntity extends DwOrmData {
    // Attributes
    UserInviteRequestEmailId?: number;
    UserInviteRequestId?: number;
    EmailAddress?: string;
    Accepted?: boolean;
    AcceptedDateTime?: string;
    UserId?: number;
    LastResendRequestDateTime?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    UserInviteRequestIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    DwUserInviteRequest? : DwUserInviteRequestEntity;
}

export interface UserInviteRequestSchoolBranchEntity extends DwOrmData {
    // Attributes
    UserInviteRequestSchoolBranchId?: number;
    FlightSchoolBranchId?: number;
    UserInviteRequestDetailId?: number;

    // Display Attributes
    FlightSchoolBranchIdDisplay?: string;
    UserInviteRequestDetailIdDisplay?: string;

    // Relations
    FlightSchoolBranch? : FlightSchoolBranchEntity;
    UserInviteRequestDetail? : UserInviteRequestDetailEntity;
}

export interface DwUserInviteRequestStatusEntity extends DwOrmData {
    // Attributes
    UserInviteRequestStatusId?: number;
    UserInviteRequestStatus?: string;


    // Relations
    InviteRequestStatusIdDwUserInviteRequest? : DwUserInviteRequestEntity[];
}

export interface DwUserInviteRequestTypeEntity extends DwOrmData {
    // Attributes
    UserInviteRequestTypeId?: number;
    UserInviteRequestType?: string;
    UserTypeId?: number;
    Description?: string;

    // Display Attributes
    UserTypeIdDisplay?: string;

    // Relations
    DwUserType? : DwUserTypeEntity;
    FlightSchoolUser? : FlightSchoolUserEntity[];
    InviteRequestTypeIdDwUserInviteRequest? : DwUserInviteRequestEntity[];
}

export interface DwUserTypeEntity extends DwOrmData {
    // Attributes
    UserTypeId?: number;
    UserTypeDisplay?: string;
    UserTypeDescription?: string;
    UserTypeClasses?: string;
    ShowOnRegistration?: boolean;
    UserTypeOrder?: number;


    // Relations
    DwUser? : DwUserEntity[];
    DwUserInviteRequestType? : DwUserInviteRequestTypeEntity[];
}

// Generated Query Interfaces
/** Entity for Query Meaning Pilot_Examiner_Search  */
export interface PilotExaminerSearchQueryEntity extends DwOrmData {
    // Attributes
    PilotExaminerId?: number;
    UserId?: number;
    UserIdDisplay?: string;
    PilotExaminerStatusId?: number;
    PilotExaminerStatusIdDisplay?: string;
    Description?: string;
    AviationAuthorityId?: number;
    AviationAuthorityIdDisplay?: string;
    DefaultPreTimeMinutes?: number;
    DefaultPostTimeMinutes?: number;
    TravelRadiusMiles?: number;
    AuthorityExaminerNumber?: string;
    CalendarIsLinked?: boolean;
    CalendarReferenceId?: number;
    CalendarReferenceIdDisplay?: string;
    RequireAuthorityPreCheckRideNumber?: boolean;
    PublicProfileIsActive?: boolean;
    PublicProfileSlug?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    CheckRideRequestLeadTimeDays?: number;
    CheckRideRequestBookingMaxWeeksOut?: number;
    AviationAuthorityDistrictOfficeId?: number;
    AviationAuthorityDistrictOfficeIdDisplay?: string;
    DailyTravelRadiusLockMiles?: number;
    PilotExaminerTypeId?: number;
    PilotExaminerTypeIdDisplay?: string;
    AllowAnyFlightSchool?: boolean;
    FlightSchoolScheduleId?: number;
    FlightSchoolScheduleIdDisplay?: string;
    PreventApplicantBooking?: boolean;
    UseBlockBooking?: boolean;
    ScheduleBlockSchoolDefaultOptionId?: number;
    ScheduleBlockSchoolDefaultOptionIdDisplay?: string;
    ScenarioCheckRideScenarioId?: number;
    ScenarioCheckRideScenarioIdDisplay?: string;
    ScenarioPreTimeMinutes?: number;
    ScenarioPostTimeMinutes?: number;
    ScenarioIsActive?: boolean;
    ScenarioTimeRequiredHours?: number;
    ScenarioCheckRideGroupId?: number;
    ScenarioCheckRideTypeId?: number;
    CheckRideScenarioCheckRideCost?: number;
    CheckRideScenarioRetestCost?: number;
    CheckRideScenarioDiscontinuedRetestCost?: number;
    CheckRideScenarioBookingCost?: number;
    CheckRideScenarioDiscontinuedRetestFlightOnlyCost?: number;
    CheckRideScenarioRetestFlightOnlyCost?: number;
    CheckRideScenarioTravelCost?: number;
    CheckRideScenarioTimeRequiredMinutes?: number;
    CheckRideScenarioTimeRequiredMinutesDisplay?: string;
    CheckRideScenarioRequiredDocumentNotes?: string;
    CheckRideScenarioRetestTimeRequiredMinutes?: number;
    CheckRideScenarioRetestTimeRequiredMinutesDisplay?: string;
    CheckRideScenarioRetestFlightOnlyTimeRequiredMinutes?: number;
    CheckRideScenarioRetestFlightOnlyTimeRequiredMinutesDisplay?: string;
    CheckRideScenarioDiscontinuedTimeRequiredMinutes?: number;
    CheckRideScenarioDiscontinuedTimeRequiredMinutesDisplay?: string;
    CheckRideScenarioDiscontinuedFlightOnlyTimeRequiredMinutes?: number;
    CheckRideScenarioDiscontinuedFlightOnlyTimeRequiredMinutesDisplay?: string;
    LocationDistancesPilotExaminerLocationId?: number;
    LocationDistancesPilotExaminerLocationIdDisplay?: string;
    LocationDistancesAirportId?: number;
    LocationDistancesAirportIdDisplay?: string;
    LocationDistancesDistance?: number;
    LocationDistancesReferenceAirportId?: number;
    LocationDistancesReferenceAirportIdDisplay?: string;
    LocationDistancesWithinTravelRadius?: boolean;
    PilotExaminerLocationSchedulingStartDate?: string;
    PilotExaminerLocationSchedulingEndDate?: string;
    PilotExaminerLocationTravelRadiusMile?: number;
    PilotExaminerLocationBookingScheduleId?: number;
    PilotExaminerLocationBookingScheduleIdDisplay?: string;
    PilotExaminerLocationIsActive?: boolean;
    PilotExaminerLocationTravelCost?: number;
    PilotExaminerLocationAdditionalLocationCost?: number;
    PilotExaminerLocationBookingScheduleTimeZoneId?: number;
    PilotExaminerLocationBookingScheduleTimeZoneIdDisplay?: string;
    PilotExaminerLocationPilotExaminerLocationId?: number;
    PilotExaminerLocationLocationName?: string;
    PilotExaminerLocationPilotExaminerLocationTypeId?: number;
    PilotExaminerLocationPilotExaminerLocationTypeIdDisplay?: string;
    RoPilotExaminerLocationCurrentPilotExaminerLocationStateId?: number;
    RoPilotExaminerLocationCurrentPilotExaminerLocationStateIdDisplay?: string;
    AirportAddressTimezoneId?: number;
    AirportAddressTimezoneIdDisplay?: string;
    AirportAddressObservesDst?: boolean;
    DwUserFirstName?: string;
    DwUserLastName?: string;
    DwUserUserPictureMediaId?: number;
    DwUserUserPictureMediaIdDisplay?: string;
    DwUserUserBackgroundMediaId?: number;
    DwUserUserBackgroundMediaIdDisplay?: string;
    DwUserEmail?: string;
    UserPictureDwroMediaMediaPath?: string;
    UserPictureDwroMediaImageWidth?: number;
    UserPictureDwroMediaImageHeight?: number;

    // Relations
    AviationAuthority? : AviationAuthorityEntity;
    AviationAuthorityDistrictOffice? : AviationAuthorityDistrictOfficeEntity;
    CalendarReference? : CalendarReferenceEntity;
    PilotExaminerStatus? : PilotExaminerStatusEntity;
    PilotExaminerType? : PilotExaminerTypeEntity;
    FlightSchoolSchedule? : ScheduleEntity;
    ScheduleBlockSchoolDefaultOptionIdScheduleBlockSchoolBookingOption? : ScheduleBlockSchoolBookingOptionEntity;
    DwUser? : DwUserEntity;
    ApplicantPlaceholder? : ApplicantPlaceholderEntity[];
    CalendarSyncRequest? : CalendarSyncRequestEntity[];
    ScheduledCheckRideRequest? : CheckRideRequestEntity[];
    CheckRideScenario? : CheckRideScenarioEntity[];
    CheckRideScheduleHold? : CheckRideScheduleHoldEntity[];
    FlightSchoolExaminer? : FlightSchoolExaminerEntity[];
    PilotExaminerFlightSchoolSetup? : PilotExaminerFlightSchoolSetupEntity[];
    PilotExaminerLocation? : PilotExaminerLocationEntity[];
    PlanOfAction? : PlanOfActionEntity[];
    QuestionBank? : QuestionBankEntity[];
    RoPilotExaminerLocationDistances? : RoPilotExaminerLocationDistancesEntity[];
    RoPilotExaminerScenario? : RoPilotExaminerScenarioEntity[];
    ScheduleBlock? : ScheduleBlockEntity[];
    ReferredStudentApplicant? : StudentApplicantEntity[];
    Subscription? : SubscriptionEntity[];
    TrainingRecord? : TrainingRecordEntity[];
}

/** Entity for Query Meaning Pilot_Examiner_Calendar_Reference  */
export interface PilotExaminerCalendarReferenceQueryEntity extends DwOrmData {
    // Attributes
    PilotExaminerId?: number;
    UserId?: number;
    PilotExaminerStatusId?: number;
    CalendarReferenceCalendarReferenceId?: number;
    CalendarReferenceCalendarReferenceTypeId?: number;
    CalendarReferenceMainCalendarKey?: string;
    CalendarReferenceCalendarConfigJSON?: string;
    DwUserUserId?: number;
    DwUserUserName?: string;
    DwUserUserTypeId?: number;
    DwUserEmail?: string;
    DwUserFirstName?: string;
    DwUserLastName?: string;
    DwUserLastLoginDateTime?: string;

    // Relations
    AviationAuthority? : AviationAuthorityEntity;
    AviationAuthorityDistrictOffice? : AviationAuthorityDistrictOfficeEntity;
    CalendarReference? : CalendarReferenceEntity;
    PilotExaminerStatus? : PilotExaminerStatusEntity;
    PilotExaminerType? : PilotExaminerTypeEntity;
    FlightSchoolSchedule? : ScheduleEntity;
    ScheduleBlockSchoolDefaultOptionIdScheduleBlockSchoolBookingOption? : ScheduleBlockSchoolBookingOptionEntity;
    DwUser? : DwUserEntity;
    ApplicantPlaceholder? : ApplicantPlaceholderEntity[];
    CalendarSyncRequest? : CalendarSyncRequestEntity[];
    ScheduledCheckRideRequest? : CheckRideRequestEntity[];
    CheckRideScenario? : CheckRideScenarioEntity[];
    CheckRideScheduleHold? : CheckRideScheduleHoldEntity[];
    FlightSchoolExaminer? : FlightSchoolExaminerEntity[];
    PilotExaminerFlightSchoolSetup? : PilotExaminerFlightSchoolSetupEntity[];
    PilotExaminerLocation? : PilotExaminerLocationEntity[];
    PlanOfAction? : PlanOfActionEntity[];
    QuestionBank? : QuestionBankEntity[];
    RoPilotExaminerLocationDistances? : RoPilotExaminerLocationDistancesEntity[];
    RoPilotExaminerScenario? : RoPilotExaminerScenarioEntity[];
    ScheduleBlock? : ScheduleBlockEntity[];
    ReferredStudentApplicant? : StudentApplicantEntity[];
    Subscription? : SubscriptionEntity[];
    TrainingRecord? : TrainingRecordEntity[];
}

/** Entity for Query Meaning Check_Ride_Request-Calendar  */
export interface CheckRideRequestCalendarQueryEntity extends DwOrmData {
    // Attributes
    CheckRideRequestId?: number;
    CheckRideTypeId?: number;
    CheckRideTypeIdDisplay?: string;
    CheckRideGroupId?: number;
    CheckRideGroupIdDisplay?: string;
    CheckRideTestTypeId?: number;
    CheckRideTestTypeIdDisplay?: string;
    PilotCertificateNumber?: string;
    CheckRideRequestSubStatusId?: number;
    CheckRideRequestSubStatusIdDisplay?: string;
    ScheduledDateTime?: string;
    ScheduledTimeMinutes?: number;
    ScheduledTimeMinutesDisplay?: string;
    ProposedDateTime?: string;
    ScheduledAirportId?: number;
    ScheduledAirportIdDisplay?: string;
    AuthorityPreapprovalCode?: string;
    AuthorityApprovalCode?: string;
    ProposedAirportId?: number;
    ProposedAirportIdDisplay?: string;
    ProposedTimeMinutes?: number;
    ProposedTimeMinutesDisplay?: string;
    AuthorityPreCheckRideNumber?: string;
    CheckRideRequestSubStatusCheckRideRequestStatusId?: number;
    CheckRideRequestSubStatusCheckRideRequestStatusIdDisplay?: string;
    CheckRideResultCheckRideRequestId?: number;
    CheckRideResultCheckRideDateTime?: string;
    CheckRideResultCheckRideOutcomeId?: number;
    CheckRideResultCheckRideOutcomeIdDisplay?: string;
    CheckRideResultAllowRetest?: boolean;
    CheckRideResultAllowRetestReason?: string;
    CheckRideResultRetestCost?: number;
    AirportAirportName?: string;
    AirportAirportCode?: string;
    AirportAddressCity?: string;
    AirportAddressStateProvinceId?: number;
    AirportAddressStateProvinceIdDisplay?: string;
    AirportAddressPostalCode?: string;
    AirportAddressCountryId?: number;
    AirportAddressCountryIdDisplay?: string;
    AirportAddressLatitude?: number;
    AirportAddressLongitude?: number;
    AirportAddressTimezoneId?: number;
    AirportAddressTimezoneIdDisplay?: string;
    AirportAddressObservesDst?: boolean;
    ScheduledPilotExaminerUserId?: number;
    ScheduledPilotExaminerUserIdDisplay?: string;
    CalendarEventReferenceKey?: string;
    ApplicantNameApplicantFinalEmail?: string;
    ApplicantNameApplicantFinalName?: string;
    ApplicantNameApplicantFinalPhone?: string;
    ApplicantNameFlightSchoolFinalName?: string;
    ApplicantNameCheckRideApplicantTypeId?: number;
    ApplicantNamePilotExaminerFinalName?: string;
    ApplicantNamePilotExaminerFinalEmail?: string;
    ApplicantNamePilotExaminerFinalPhone?: string;
    ApplicantNameFlightInstructorFinalName?: string;
    ApplicantNameFlightInstructorFinalEmail?: string;
    ApplicantNameFlightInstructorFinalPhone?: string;

    // Relations
    ScheduledAirport? : AirportEntity;
    PreferredAirport? : AirportEntity;
    ProposedAirport? : AirportEntity;
    PrimaryTrainingAirport? : AirportEntity;
    ApplicantAcsWrittenResult? : ApplicantAcsWrittenResultEntity;
    ApplicantPlaceholder? : ApplicantPlaceholderEntity;
    AviationAuthority? : AviationAuthorityEntity;
    AvaiationTrainingProgramIdAviationTrainingProgram? : AviationTrainingProgramEntity;
    ScheduledCalendarEventReference? : CalendarEventReferenceEntity;
    CheckRideApplicantType? : CheckRideApplicantTypeEntity;
    CheckRideCancellationType? : CheckRideCancellationTypeEntity;
    CheckRideExaminerType? : CheckRideExaminerTypeEntity;
    CheckRideGroup? : CheckRideGroupEntity;
    CheckRideInstructorType? : CheckRideInstructorTypeEntity;
    CheckRideOwnershipType? : CheckRideOwnershipTypeEntity;
    PilexosBookingCheckRidePayment? : CheckRidePaymentEntity;
    PilexosBookingCostPaymentPartyIdCheckRideRequestPaymentParty? : CheckRideRequestPaymentPartyEntity;
    CheckRideRequestSubStatus? : CheckRideRequestSubStatusEntity;
    ScheduledCheckRideScenario? : CheckRideScenarioEntity;
    CheckRideTestType? : CheckRideTestTypeEntity;
    CheckRideType? : CheckRideTypeEntity;
    CheckRideWorkflow? : CheckRideWorkflowEntity;
    StudentApplicantCitizenshipCountyIdCountry? : CountryEntity;
    ElectronicFlightBagType? : ElectronicFlightBagTypeEntity;
    FlightSchool? : FlightSchoolEntity;
    OdaFlightSchool? : FlightSchoolEntity;
    FlightSchoolApplicant? : FlightSchoolApplicantEntity;
    FlightSchoolBranch? : FlightSchoolBranchEntity;
    FlightSchoolExaminer? : FlightSchoolExaminerEntity;
    FlightSchoolInstructor? : FlightSchoolInstructorEntity;
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    FlightSchoolType? : FlightSchoolTypeEntity;
    DocumentsDwMediaGroup? : DwMediaGroupEntity;
    CurrentPilotCertifiateTypeIdPilotCertificateType? : PilotCertificateTypeEntity;
    ScheduledPilotExaminer? : PilotExaminerEntity;
    ScheduledPilotExaminerLocation? : PilotExaminerLocationEntity;
    StudentApplicantStateProvince? : StateProvinceEntity;
    StudentApplicant? : StudentApplicantEntity;
    CheckRideAISummary? : CheckRideAISummaryEntity[];
    CheckRideAvionicType? : CheckRideAvionicTypeEntity[];
    CheckRidePayment? : CheckRidePaymentEntity[];
    CheckRideRequestNote? : CheckRideRequestNoteEntity[];
    CheckRideRequestPilotCertificate? : CheckRideRequestPilotCertificateEntity[];
    CheckRideResult? : CheckRideResultEntity;
    CheckRideScheduleHold? : CheckRideScheduleHoldEntity[];
    PlanOfAction? : PlanOfActionEntity;
    CheckrideRequestIdRoCheckrideAggregateUtil? : RoCheckrideAggregateUtilEntity;
    RoCheckrideApplicantFinalName? : RoCheckrideApplicantFinalNameEntity;
    RoCheckRideRequestApplicant? : RoCheckRideRequestApplicantEntity;
    CheckrideRequestIdRoCheckrideRequestScheduleDateInfo? : RoCheckrideRequestScheduleDateInfoEntity;
}

/** Entity for Query Meaning Pilot_Examiner_Current_Airports  */
export interface PilotExaminerCurrentAirportsQueryEntity extends DwOrmData {
    // Attributes
    AirportId?: number;
    AviationAuthorityId?: number;
    AviationAuthorityIdDisplay?: string;
    AirportName?: string;
    AirportCode?: string;
    AirportAddressId?: number;
    AirportAddressIdDisplay?: string;
    Elevation?: number;
    OwnershipCode?: string;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    PilotExaminerLocationPilotExaminerId?: number;
    PilotExaminerLocationPilotExaminerIdDisplay?: string;
    PilotExaminerLocationShowMetar?: boolean;
    RoPilotExaminerLocationCurrentPilotExaminerLocationStateId?: number;
    RoPilotExaminerLocationCurrentPilotExaminerLocationStateIdDisplay?: string;

    // Relations
    AirportAddress? : AddressEntity;
    AviationAuthority? : AviationAuthorityEntity;
    PreferredApplicantPlaceholder? : ApplicantPlaceholderEntity[];
    ScheduledCheckRideRequest? : CheckRideRequestEntity[];
    PreferredCheckRideRequest? : CheckRideRequestEntity[];
    ProposedCheckRideRequest? : CheckRideRequestEntity[];
    PrimaryTrainingCheckRideRequest? : CheckRideRequestEntity[];
    CheckRideScheduleHold? : CheckRideScheduleHoldEntity[];
    MainFlightSchoolBranch? : FlightSchoolBranchEntity[];
    PilotExaminerLocationAirport? : PilotExaminerLocationAirportEntity[];
    CheckRidePlanOfAction? : PlanOfActionEntity[];
    PrimaryTraningPlanOfAction? : PlanOfActionEntity[];
    RoPilotExaminerLocationDistances? : RoPilotExaminerLocationDistancesEntity[];
    ScheduleBlockAirport? : ScheduleBlockAirportEntity[];
    MainStudentApplicant? : StudentApplicantEntity[];
}

/** Entity for Query Meaning Pilot_Examiner_Public_Profile  */
export interface PilotExaminerPublicProfileQueryEntity extends DwOrmData {
    // Attributes
    PilotExaminerId?: number;
    UserId?: number;
    Description?: string;
    AviationAuthorityId?: number;
    AuthorityExaminerNumber?: string;
    PublicProfileIsActive?: boolean;
    PublicProfileSlug?: string;
    DwUserUserBackgroundMediaId?: number;
    DwUserUserPictureMediaId?: number;

    // Relations
    AviationAuthority? : AviationAuthorityEntity;
    AviationAuthorityDistrictOffice? : AviationAuthorityDistrictOfficeEntity;
    CalendarReference? : CalendarReferenceEntity;
    PilotExaminerStatus? : PilotExaminerStatusEntity;
    PilotExaminerType? : PilotExaminerTypeEntity;
    FlightSchoolSchedule? : ScheduleEntity;
    ScheduleBlockSchoolDefaultOptionIdScheduleBlockSchoolBookingOption? : ScheduleBlockSchoolBookingOptionEntity;
    DwUser? : DwUserEntity;
    ApplicantPlaceholder? : ApplicantPlaceholderEntity[];
    CalendarSyncRequest? : CalendarSyncRequestEntity[];
    ScheduledCheckRideRequest? : CheckRideRequestEntity[];
    CheckRideScenario? : CheckRideScenarioEntity[];
    CheckRideScheduleHold? : CheckRideScheduleHoldEntity[];
    FlightSchoolExaminer? : FlightSchoolExaminerEntity[];
    PilotExaminerFlightSchoolSetup? : PilotExaminerFlightSchoolSetupEntity[];
    PilotExaminerLocation? : PilotExaminerLocationEntity[];
    PlanOfAction? : PlanOfActionEntity[];
    QuestionBank? : QuestionBankEntity[];
    RoPilotExaminerLocationDistances? : RoPilotExaminerLocationDistancesEntity[];
    RoPilotExaminerScenario? : RoPilotExaminerScenarioEntity[];
    ScheduleBlock? : ScheduleBlockEntity[];
    ReferredStudentApplicant? : StudentApplicantEntity[];
    Subscription? : SubscriptionEntity[];
    TrainingRecord? : TrainingRecordEntity[];
}

/** Entity for Query Meaning Student_Applicant_with_detail  */
export interface StudentApplicantWithDetailQueryEntity extends DwOrmData {
    // Attributes
    StudentApplicantId?: number;
    UserId?: number;
    UserIdDisplay?: string;
    ApplicationDescription?: string;
    AviationAuthorityId?: number;
    AviationAuthorityIdDisplay?: string;
    PilotCertificateNumber?: string;
    TravelRadiusMiles?: number;
    Citizenship?: string;
    ApplicantAddressId?: number;
    ApplicantAddressIdDisplay?: string;
    MainAirportId?: number;
    MainAirportIdDisplay?: string;
    MainAircraft?: string;
    ReferredPilotExaminerId?: number;
    ReferredPilotExaminerIdDisplay?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    AviationTrainingProgramId?: number;
    AviationTrainingProgramIdDisplay?: string;
    CitzenshipCountyId?: number;
    CitzenshipCountyIdDisplay?: string;
    DwUserFirstName?: string;
    DwUserLastName?: string;
    DwUserEmail?: string;
    DwUserUserBackgroundMediaId?: number;
    DwUserUserBackgroundMediaIdDisplay?: string;
    DwUserUserPictureMediaId?: number;
    DwUserUserPictureMediaIdDisplay?: string;
    DwUserMobilePhone?: string;
    ApplicantAddressStreetAddress1?: string;
    ApplicantAddressStreetAddress2?: string;
    ApplicantAddressCity?: string;
    ApplicantAddressStateProvinceId?: number;
    ApplicantAddressStateProvinceIdDisplay?: string;
    ApplicantAddressCountryId?: number;
    ApplicantAddressCountryIdDisplay?: string;
    ApplicantAddressPostalCode?: string;
    ApplicantAddressLatitude?: number;
    ApplicantAddressLongitude?: number;

    // Relations
    ApplicantAddress? : AddressEntity;
    MainAirport? : AirportEntity;
    AviationAuthority? : AviationAuthorityEntity;
    AviationTrainingProgram? : AviationTrainingProgramEntity;
    CitzenshipCountyIdCountry? : CountryEntity;
    ReferredPilotExaminer? : PilotExaminerEntity;
    DwUser? : DwUserEntity;
    ApplicantPlaceholder? : ApplicantPlaceholderEntity[];
    CheckRideRequest? : CheckRideRequestEntity[];
    UserIdCheckRideScheduleHold? : CheckRideScheduleHoldEntity[];
    FlightSchoolApplicant? : FlightSchoolApplicantEntity[];
}

/** Entity for Query Meaning Airport_with_Address_info  */
export interface AirportWithAddressInfoQueryEntity extends DwOrmData {
    // Attributes
    AirportId?: number;
    AviationAuthorityId?: number;
    AviationAuthorityIdDisplay?: string;
    AirportName?: string;
    AirportCode?: string;
    AirportAddressId?: number;
    AirportAddressIdDisplay?: string;
    Elevation?: number;
    OwnershipCode?: string;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    AirportAddressCity?: string;
    AirportAddressStateProvinceId?: number;
    AirportAddressStateProvinceIdDisplay?: string;
    AirportAddressPostalCode?: string;
    AirportAddressCountyName?: string;
    AirportAddressTimezoneId?: number;
    AirportAddressTimezoneIdDisplay?: string;
    AirportAddressObservesDst?: boolean;
    AirportAddressLatitude?: number;
    AirportAddressLongitude?: number;
    TimeZoneIANAIdentifier?: string;
    TimeZoneTimezoneShortName?: string;
    TimeZoneTimezoneName?: string;
    TimeZoneTimezoneId?: number;

    // Relations
    AirportAddress? : AddressEntity;
    AviationAuthority? : AviationAuthorityEntity;
    PreferredApplicantPlaceholder? : ApplicantPlaceholderEntity[];
    ScheduledCheckRideRequest? : CheckRideRequestEntity[];
    PreferredCheckRideRequest? : CheckRideRequestEntity[];
    ProposedCheckRideRequest? : CheckRideRequestEntity[];
    PrimaryTrainingCheckRideRequest? : CheckRideRequestEntity[];
    CheckRideScheduleHold? : CheckRideScheduleHoldEntity[];
    MainFlightSchoolBranch? : FlightSchoolBranchEntity[];
    PilotExaminerLocationAirport? : PilotExaminerLocationAirportEntity[];
    CheckRidePlanOfAction? : PlanOfActionEntity[];
    PrimaryTraningPlanOfAction? : PlanOfActionEntity[];
    RoPilotExaminerLocationDistances? : RoPilotExaminerLocationDistancesEntity[];
    ScheduleBlockAirport? : ScheduleBlockAirportEntity[];
    MainStudentApplicant? : StudentApplicantEntity[];
}

/** Entity for Query Meaning Checkride_Request-Aggregate_Base  */
export interface CheckrideRequestAggregateBaseQueryEntity extends DwOrmData {
    // Attributes
    CheckRideRequestId?: number;
    CheckRideGroupId?: number;
    CheckRideGroupIdDisplay?: string;
    CheckRideTypeId?: number;
    CheckRideTypeIdDisplay?: string;
    CheckRideTestTypeId?: number;
    CheckRideTestTypeIdDisplay?: string;
    CheckRideRequestSubStatusId?: number;
    CheckRideRequestSubStatusIdDisplay?: string;
    CheckRideApplicantTypeId?: number;
    CheckRideApplicantTypeIdDisplay?: string;
    AvaiationTrainingProgramId?: number;
    AvaiationTrainingProgramIdDisplay?: string;
    ScheduledDateTime?: string;
    ScheduledAirportId?: number;
    ScheduledAirportIdDisplay?: string;
    ScheduledCheckRideCost?: number;
    PilexosBookingCost?: number;
    ExaminerBookingCost?: number;
    AdditionalTravelCost?: number;
    ScheduledPilotExaminerId?: number;
    ScheduledPilotExaminerIdDisplay?: string;
    CheckRideCancellationTypeId?: number;
    CheckRideCancellationTypeIdDisplay?: string;
    CheckRideCancellationTypeOther?: string;
    PilexosBookingCostPaymentPartyId?: number;
    PilexosBookingCostPaymentPartyIdDisplay?: string;
    StudentApplicantCitizenshipCountyId?: number;
    StudentApplicantCitizenshipCountyIdDisplay?: string;
    FlightSchoolId?: number;
    FlightSchoolIdDisplay?: string;
    FlightSchoolNameOther?: string;
    FlightSchoolBranchId?: number;
    FlightSchoolBranchIdDisplay?: string;
    FlightSchoolName?: string;
    FlightSchoolOrganizationId?: number;
    FlightSchoolOrganizationIdDisplay?: string;
    FlightSchoolApplicantId?: number;
    FlightSchoolApplicantIdDisplay?: string;
    FlightSchoolExaminerId?: number;
    FlightSchoolExaminerIdDisplay?: string;
    ElectronicFlightBagTypeId?: number;
    ElectronicFlightBagTypeIdDisplay?: string;
    FlightSchoolInstructorId?: number;
    FlightSchoolInstructorIdDisplay?: string;
    AggrScheduledDateTime?: string;
    AggrScheduledDateTimeYear?: number;
    AggrScheduledDateTimeMonth?: number;
    AggrScheduledDateTimeMonthDisplay?: string;
    AggrScheduledDateTimeMonthYearDisplay?: string;
    AggrCheckRideRequestStatusId?: number;
    AggrCheckRideRequestStatus?: string;
    AggrPilexosPaymentDateTimeYear?: number;
    AggrPilexosPaymentDateTimeMonth?: number;
    AggrPilexosPaymentTotal?: number;
    AggrCheckridePaymentDateTimeYear?: number;
    AggrCheckridePaymentDateTimeMonth?: number;
    AggrCheckridePaymentTotal?: number;
    AggrOutcomeIsRequested?: number;
    AggrOutcomeIsBooked?: number;
    AggrOutcomeIsComplete?: number;
    AggrOutcomeIsCancelled?: number;
    AggrRevenueIsRequested?: number;
    AggrRevenueIsBooked?: number;
    AggrRevenueIsComplete?: number;
    AggrRevenueIsCancelled?: number;
    AggrCheckRideTypeDisplay?: string;
    AggrCheckRideAcceptedDateTime?: string;
    AggrCheckRideOutcomeId?: number;
    AggrCheckRideOutcome?: string;
    AggrResultIsPassed?: number;
    AggrResultIsFailed?: number;
    AggrResultIsDiscontinued?: number;
    AggrFinalWaitTimeDays?: number;
    AggrCurrentWaitTimeDays?: number;
    CheckRideResultCheckRideOutcomeId?: number;
    CheckRideResultCheckRideOutcomeIdDisplay?: string;
    AirportAirportCode?: string;
    RoCheckrideApplicantInfoFlightSchoolFinalName?: string;
    RoCheckrideApplicantInfoApplicantFinalName?: string;
    RoCheckrideApplicantInfoPilotExaminerFinalName?: string;
    RoCheckrideApplicantInfoFlightInstructorFinalName?: string;

    // Relations
    ScheduledAirport? : AirportEntity;
    PreferredAirport? : AirportEntity;
    ProposedAirport? : AirportEntity;
    PrimaryTrainingAirport? : AirportEntity;
    ApplicantAcsWrittenResult? : ApplicantAcsWrittenResultEntity;
    ApplicantPlaceholder? : ApplicantPlaceholderEntity;
    AviationAuthority? : AviationAuthorityEntity;
    AvaiationTrainingProgramIdAviationTrainingProgram? : AviationTrainingProgramEntity;
    ScheduledCalendarEventReference? : CalendarEventReferenceEntity;
    CheckRideApplicantType? : CheckRideApplicantTypeEntity;
    CheckRideCancellationType? : CheckRideCancellationTypeEntity;
    CheckRideExaminerType? : CheckRideExaminerTypeEntity;
    CheckRideGroup? : CheckRideGroupEntity;
    CheckRideInstructorType? : CheckRideInstructorTypeEntity;
    CheckRideOwnershipType? : CheckRideOwnershipTypeEntity;
    PilexosBookingCheckRidePayment? : CheckRidePaymentEntity;
    PilexosBookingCostPaymentPartyIdCheckRideRequestPaymentParty? : CheckRideRequestPaymentPartyEntity;
    CheckRideRequestSubStatus? : CheckRideRequestSubStatusEntity;
    ScheduledCheckRideScenario? : CheckRideScenarioEntity;
    CheckRideTestType? : CheckRideTestTypeEntity;
    CheckRideType? : CheckRideTypeEntity;
    CheckRideWorkflow? : CheckRideWorkflowEntity;
    StudentApplicantCitizenshipCountyIdCountry? : CountryEntity;
    ElectronicFlightBagType? : ElectronicFlightBagTypeEntity;
    FlightSchool? : FlightSchoolEntity;
    OdaFlightSchool? : FlightSchoolEntity;
    FlightSchoolApplicant? : FlightSchoolApplicantEntity;
    FlightSchoolBranch? : FlightSchoolBranchEntity;
    FlightSchoolExaminer? : FlightSchoolExaminerEntity;
    FlightSchoolInstructor? : FlightSchoolInstructorEntity;
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    FlightSchoolType? : FlightSchoolTypeEntity;
    DocumentsDwMediaGroup? : DwMediaGroupEntity;
    CurrentPilotCertifiateTypeIdPilotCertificateType? : PilotCertificateTypeEntity;
    ScheduledPilotExaminer? : PilotExaminerEntity;
    ScheduledPilotExaminerLocation? : PilotExaminerLocationEntity;
    StudentApplicantStateProvince? : StateProvinceEntity;
    StudentApplicant? : StudentApplicantEntity;
    CheckRideAISummary? : CheckRideAISummaryEntity[];
    CheckRideAvionicType? : CheckRideAvionicTypeEntity[];
    CheckRidePayment? : CheckRidePaymentEntity[];
    CheckRideRequestNote? : CheckRideRequestNoteEntity[];
    CheckRideRequestPilotCertificate? : CheckRideRequestPilotCertificateEntity[];
    CheckRideResult? : CheckRideResultEntity;
    CheckRideScheduleHold? : CheckRideScheduleHoldEntity[];
    PlanOfAction? : PlanOfActionEntity;
    CheckrideRequestIdRoCheckrideAggregateUtil? : RoCheckrideAggregateUtilEntity;
    RoCheckrideApplicantFinalName? : RoCheckrideApplicantFinalNameEntity;
    RoCheckRideRequestApplicant? : RoCheckRideRequestApplicantEntity;
    CheckrideRequestIdRoCheckrideRequestScheduleDateInfo? : RoCheckrideRequestScheduleDateInfoEntity;
}

/** Entity for Query Meaning Checkride-Active_Applicant_Checkrides  */
export interface CheckrideActiveApplicantCheckridesQueryEntity extends DwOrmData {
    // Attributes
    CheckRideRequestId?: number;
    StudentApplicantId?: number;
    StudentApplicantIdDisplay?: string;
    AviationAuthorityId?: number;
    AviationAuthorityIdDisplay?: string;
    CheckRideRequestSubStatusId?: number;
    CheckRideRequestSubStatusIdDisplay?: string;
    ScheduledDateTime?: string;
    CheckRideTypeId?: number;
    CheckRideTypeIdDisplay?: string;
    CheckRideGroupId?: number;
    CheckRideGroupIdDisplay?: string;
    AuthorityPreCheckRideNumber?: string;
    RoAppCheckRideRequestId?: number;
    RoAppCheckRideRequestIdDisplay?: string;
    RoAppStudentApplicantNameManual?: string;
    RoAppStudentApplicantEmailManual?: string;
    RoAppFlightSchoolApplicantId?: number;
    RoAppStudentApplicantId?: number;
    RoAppStudentApplicantEmail?: string;
    RoAppStudentApplicantName?: string;
    RoAppFlightSchoolApplicantEmail?: string;
    RoAppFlightSchoolApplicantName?: string;

    // Relations
    ScheduledAirport? : AirportEntity;
    PreferredAirport? : AirportEntity;
    ProposedAirport? : AirportEntity;
    PrimaryTrainingAirport? : AirportEntity;
    ApplicantAcsWrittenResult? : ApplicantAcsWrittenResultEntity;
    ApplicantPlaceholder? : ApplicantPlaceholderEntity;
    AviationAuthority? : AviationAuthorityEntity;
    AvaiationTrainingProgramIdAviationTrainingProgram? : AviationTrainingProgramEntity;
    ScheduledCalendarEventReference? : CalendarEventReferenceEntity;
    CheckRideApplicantType? : CheckRideApplicantTypeEntity;
    CheckRideCancellationType? : CheckRideCancellationTypeEntity;
    CheckRideExaminerType? : CheckRideExaminerTypeEntity;
    CheckRideGroup? : CheckRideGroupEntity;
    CheckRideInstructorType? : CheckRideInstructorTypeEntity;
    CheckRideOwnershipType? : CheckRideOwnershipTypeEntity;
    PilexosBookingCheckRidePayment? : CheckRidePaymentEntity;
    PilexosBookingCostPaymentPartyIdCheckRideRequestPaymentParty? : CheckRideRequestPaymentPartyEntity;
    CheckRideRequestSubStatus? : CheckRideRequestSubStatusEntity;
    ScheduledCheckRideScenario? : CheckRideScenarioEntity;
    CheckRideTestType? : CheckRideTestTypeEntity;
    CheckRideType? : CheckRideTypeEntity;
    CheckRideWorkflow? : CheckRideWorkflowEntity;
    StudentApplicantCitizenshipCountyIdCountry? : CountryEntity;
    ElectronicFlightBagType? : ElectronicFlightBagTypeEntity;
    FlightSchool? : FlightSchoolEntity;
    OdaFlightSchool? : FlightSchoolEntity;
    FlightSchoolApplicant? : FlightSchoolApplicantEntity;
    FlightSchoolBranch? : FlightSchoolBranchEntity;
    FlightSchoolExaminer? : FlightSchoolExaminerEntity;
    FlightSchoolInstructor? : FlightSchoolInstructorEntity;
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    FlightSchoolType? : FlightSchoolTypeEntity;
    DocumentsDwMediaGroup? : DwMediaGroupEntity;
    CurrentPilotCertifiateTypeIdPilotCertificateType? : PilotCertificateTypeEntity;
    ScheduledPilotExaminer? : PilotExaminerEntity;
    ScheduledPilotExaminerLocation? : PilotExaminerLocationEntity;
    StudentApplicantStateProvince? : StateProvinceEntity;
    StudentApplicant? : StudentApplicantEntity;
    CheckRideAISummary? : CheckRideAISummaryEntity[];
    CheckRideAvionicType? : CheckRideAvionicTypeEntity[];
    CheckRidePayment? : CheckRidePaymentEntity[];
    CheckRideRequestNote? : CheckRideRequestNoteEntity[];
    CheckRideRequestPilotCertificate? : CheckRideRequestPilotCertificateEntity[];
    CheckRideResult? : CheckRideResultEntity;
    CheckRideScheduleHold? : CheckRideScheduleHoldEntity[];
    PlanOfAction? : PlanOfActionEntity;
    CheckrideRequestIdRoCheckrideAggregateUtil? : RoCheckrideAggregateUtilEntity;
    RoCheckrideApplicantFinalName? : RoCheckrideApplicantFinalNameEntity;
    RoCheckRideRequestApplicant? : RoCheckRideRequestApplicantEntity;
    CheckrideRequestIdRoCheckrideRequestScheduleDateInfo? : RoCheckrideRequestScheduleDateInfoEntity;
}

/** Entity for Query Meaning Acs_Codes-Lookup  */
export interface AcsCodesLookupQueryEntity extends DwOrmData {
    // Attributes
    AcsCodeId?: number;
    AscCodeTypeId?: number;
    AscCodeTypeIdDisplay?: string;
    AcsCode?: string;
    AcsCodeOrder?: number;
    AcsAreaOfOperationTaskId?: number;
    AcsAreaOfOperationTaskIdDisplay?: string;
    AscCodeDescription?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    TaskTaskName?: string;
    TaskTaskOrder?: number;
    TaskTaskCode?: string;
    TaskAcsAreaOfOperationTaskId?: number;
    AcsAreaOfOperationAcsAreaOfOperationId?: number;
    AcsAreaOfOperationAreaOfOperationName?: string;
    AcsAreaOfOperationAreaOfOperationOrder?: number;
    AcsAreaOfOperationAreaOfOperationCode?: string;
    AcsTestTestName?: string;
    AcsTestTestDescription?: string;
    AcsTestCheckRideGroupId?: number;
    AcsTestCheckRideGroupIdDisplay?: string;
    AcsTestTestCode?: string;
    AcsTestAcsTestId?: number;
    AcsTestAcsTestStatusId?: number;
    AcsTestAcsTestStatusIdDisplay?: string;

    // Relations
    AcsAreaOfOperationTask? : AcsAreaOfOperationTaskEntity;
    AscCodeTypeIdAcsCodeType? : AcsCodeTypeEntity;
    AcsCode2? : RoAssessmentAcsMissedCodeFactEntity[];
    ApplicantAcsWrittenResultMissedCode? : ApplicantAcsWrittenResultMissedCodeEntity[];
    PlanOfActionRequiredAcsCode? : PlanOfActionRequiredAcsCodeEntity[];
    PlanOfActionSectionQuestion? : PlanOfActionSectionQuestionEntity[];
    QuestionBank? : QuestionBankEntity[];
}

/** Entity for Query Meaning Acs_Codes-Grid  */
export interface AcsCodesGridQueryEntity extends DwOrmData {
    // Attributes
    AcsCodeId?: number;
    AscCodeTypeId?: number;
    AscCodeTypeIdDisplay?: string;
    AcsCode?: string;
    AcsCodeOrder?: number;
    AcsAreaOfOperationTaskId?: number;
    AcsAreaOfOperationTaskIdDisplay?: string;
    AscCodeDescription?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    TaskTaskName?: string;
    TaskTaskOrder?: number;
    TaskTaskCode?: string;
    TaskAcsAreaOfOperationId?: number;
    TaskAcsAreaOfOperationIdDisplay?: string;
    AcsAreaOfOperationAreaOfOperationName?: string;
    AcsAreaOfOperationAreaOfOperationOrder?: number;
    AcsAreaOfOperationAreaOfOperationCode?: string;
    AcsAreaOfOperationAcsTestId?: number;
    AcsAreaOfOperationAcsTestIdDisplay?: string;
    AcsTestTestName?: string;
    AcsTestTestDescription?: string;
    AcsTestCheckRideGroupId?: number;
    AcsTestCheckRideGroupIdDisplay?: string;
    AcsTestTestCode?: string;

    // Relations
    AcsAreaOfOperationTask? : AcsAreaOfOperationTaskEntity;
    AscCodeTypeIdAcsCodeType? : AcsCodeTypeEntity;
    AcsCode2? : RoAssessmentAcsMissedCodeFactEntity[];
    ApplicantAcsWrittenResultMissedCode? : ApplicantAcsWrittenResultMissedCodeEntity[];
    PlanOfActionRequiredAcsCode? : PlanOfActionRequiredAcsCodeEntity[];
    PlanOfActionSectionQuestion? : PlanOfActionSectionQuestionEntity[];
    QuestionBank? : QuestionBankEntity[];
}

/** Entity for Query Meaning Acs_Codes_With_Questions  */
export interface AcsCodesWithQuestionsQueryEntity extends DwOrmData {
    // Attributes
    AcsCodeId?: number;
    AscCodeTypeId?: number;
    AscCodeTypeIdDisplay?: string;
    AcsCode?: string;
    AcsCodeOrder?: number;
    AcsAreaOfOperationTaskId?: number;
    AcsAreaOfOperationTaskIdDisplay?: string;
    AscCodeDescription?: string;
    AcsAreaOfOperationTaskAcsAreaOfOperationTaskId?: number;
    AcsAreaOfOperationTaskAcsAreaOfOperationId?: number;
    AcsAreaOfOperationTaskAcsAreaOfOperationIdDisplay?: string;
    AcsAreaOfOperationTaskTaskName?: string;
    AcsAreaOfOperationTaskTaskOrder?: number;
    AcsAreaOfOperationTaskTaskCode?: string;
    AcsAreaOfOperationAcsTestId?: number;
    AcsAreaOfOperationAcsTestIdDisplay?: string;
    AcsAreaOfOperationAreaOfOperationName?: string;
    AcsAreaOfOperationAreaOfOperationOrder?: number;
    AcsAreaOfOperationAreaOfOperationCode?: string;
    AcsAreaOfOperationAcsAreaOfOperationId?: number;
    QuestionBankQuestionBankId?: number;
    QuestionBankIsBuiltIn?: boolean;
    QuestionBankIsShared?: boolean;
    QuestionBankOwnerUserId?: number;
    QuestionBankAcsTestId?: number;
    QuestionBankAcsTestIdDisplay?: string;
    QuestionBankAcsCodeId?: number;
    QuestionBankAcsCodeIdDisplay?: string;
    QuestionBankQuestionHtml?: string;
    QuestionBankQuestionShortName?: string;

    // Relations
    AcsAreaOfOperationTask? : AcsAreaOfOperationTaskEntity;
    AscCodeTypeIdAcsCodeType? : AcsCodeTypeEntity;
    AcsCode2? : RoAssessmentAcsMissedCodeFactEntity[];
    ApplicantAcsWrittenResultMissedCode? : ApplicantAcsWrittenResultMissedCodeEntity[];
    PlanOfActionRequiredAcsCode? : PlanOfActionRequiredAcsCodeEntity[];
    PlanOfActionSectionQuestion? : PlanOfActionSectionQuestionEntity[];
    QuestionBank? : QuestionBankEntity[];
}

/** Entity for Query Meaning Checkride_Group_ACS_Test  */
export interface CheckrideGroupACSTestQueryEntity extends DwOrmData {
    // Attributes
    CheckRideGroupId?: number;
    AviationAuthorityId?: number;
    AviationAuthorityIdDisplay?: string;
    CheckRideGroup?: string;
    GroupOrder?: number;
    AcsTestAcsTestId?: number;
    AcsTestAcsTestStatusId?: number;
    AcsTestAcsTestStatusIdDisplay?: string;
    AcsTestCheckRideGroupId?: number;
    AcsTestCheckRideGroupIdDisplay?: string;
    AcsTestTestCode?: string;
    AcsTestTestDescription?: string;
    AcsTestTestExpirationDate?: string;
    AcsTestTestName?: string;

    // Relations
    AviationAuthority? : AviationAuthorityEntity;
    AcsTest? : AcsTestEntity[];
    ApplicantPlaceholder? : ApplicantPlaceholderEntity[];
    CheckRideRequest? : CheckRideRequestEntity[];
    CheckRideRequestPilotCertificate? : CheckRideRequestPilotCertificateEntity[];
    CheckRideScenario? : CheckRideScenarioEntity[];
    CheckRideType? : CheckRideTypeEntity[];
    FlightSchoolApplicant? : FlightSchoolApplicantEntity[];
    PlanOfAction? : PlanOfActionEntity[];
}

/** Entity for Query Meaning Plan_of_Action_Details  */
export interface PlanOfActionDetailsQueryEntity extends DwOrmData {
    // Attributes
    PlanOfActionId?: number;
    PlanOfActionName?: string;
    ApplicantFinalName?: string;
    ApplicantFinalEmail?: string;
    ApplicationFinalPhone?: string;
    CheckRideFinalDateTime?: string;
    CheckRideFinalAirportId?: number;
    CheckRideFinalAirportIdDisplay?: string;
    CheckRideFinalGroupId?: number;
    CheckRideFinalGroupIdDisplay?: string;
    CheckRideFInalTypeId?: number;
    CheckRideFInalTypeIdDisplay?: string;
    CheckRideFinalTestTypeId?: number;
    CheckRideFinalTestTypeIdDisplay?: string;
    CheckRideFinalDurationMinutes?: number;
    CheckRideFinalEndDateTime?: string;
    FlightInstructorFinalId?: number;
    FlightInstructorFinalIdDisplay?: string;
    FlightSchoolApplicantId?: number;
    CheckRideRequestId?: number;
    PlanOfActionAcsTestId?: number;
    PlanOfActionAcsTestIdDisplay?: string;
    PlanOfActionCheckRideOwnershipTypeId?: number;
    PlanOfActionCheckRideOwnershipTypeIdDisplay?: string;

    // Relations
    PlanOfAction? : PlanOfActionEntity;
}

/** Entity for Query Meaning Flight_School_Applicant-Awaiting_Checkrides  */
export interface FlightSchoolApplicantAwaitingCheckridesQueryEntity extends DwOrmData {
    // Attributes
    FlightSchoolApplicantId?: number;
    ApplicantName?: string;
    FlightSchoolApplicantStatusId?: number;
    FlightSchoolApplicantStatusIdDisplay?: string;
    FlightSchoolBranchId?: number;
    FlightSchoolBranchIdDisplay?: string;
    FlightSchoolOrganizationId?: number;
    FlightSchoolOrganizationIdDisplay?: string;
    CheckRideGroupId?: number;
    CheckRideGroupIdDisplay?: string;
    CheckRideTypeId?: number;
    CheckRideTypeIdDisplay?: string;
    ExpectedCheckrideDateTime?: string;
    CheckRideTestTypeId?: number;
    CheckRideTestTypeIdDisplay?: string;

    // Relations
    ApplicantAcsWrittenResult? : ApplicantAcsWrittenResultEntity;
    CheckRideGroup? : CheckRideGroupEntity;
    CheckRideInstructorType? : CheckRideInstructorTypeEntity;
    CheckRideTestType? : CheckRideTestTypeEntity;
    CheckRideType? : CheckRideTypeEntity;
    CitizenshipCountry? : CountryEntity;
    ODAFlightSchool? : FlightSchoolEntity;
    FlightSchoolApplicantStatus? : FlightSchoolApplicantStatusEntity;
    FlightSchoolBranch? : FlightSchoolBranchEntity;
    PrimaryFlightSchoolInstructor? : FlightSchoolInstructorEntity;
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    FlightSchoolType? : FlightSchoolTypeEntity;
    CurrentPilotCertificateType? : PilotCertificateTypeEntity;
    StateProvince? : StateProvinceEntity;
    StudentApplicant? : StudentApplicantEntity;
    CheckRideRequest? : CheckRideRequestEntity[];
    FlightSchoolApplicantBranch? : FlightSchoolApplicantBranchEntity[];
    FlightSchoolInstructorApplicant? : FlightSchoolInstructorApplicantEntity[];
    PlanOfAction? : PlanOfActionEntity[];
}

/** Entity for Query Meaning Flight_School_Airports  */
export interface FlightSchoolAirportsQueryEntity extends DwOrmData {
    // Attributes
    AirportId?: number;
    AviationAuthorityId?: number;
    AviationAuthorityIdDisplay?: string;
    AirportName?: string;
    AirportCode?: string;
    AirportAddressId?: number;
    AirportAddressIdDisplay?: string;
    Elevation?: number;
    OwnershipCode?: string;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    MainFlightSchoolBranchFlightSchoolBranchId?: number;
    MainFlightSchoolBranchBranchName?: string;
    MainFlightSchoolBranchFlightSchoolBranchStatusId?: number;
    MainFlightSchoolBranchFlightSchoolBranchStatusIdDisplay?: string;
    MainFlightSchoolBranchFlightSchoolOrganizationId?: number;
    MainFlightSchoolBranchFlightSchoolOrganizationIdDisplay?: string;
    MainFlightSchoolBranchIsDefaultBranch?: boolean;
    MainFlightSchoolBranchShowMetar?: boolean;

    // Relations
    AirportAddress? : AddressEntity;
    AviationAuthority? : AviationAuthorityEntity;
    PreferredApplicantPlaceholder? : ApplicantPlaceholderEntity[];
    ScheduledCheckRideRequest? : CheckRideRequestEntity[];
    PreferredCheckRideRequest? : CheckRideRequestEntity[];
    ProposedCheckRideRequest? : CheckRideRequestEntity[];
    PrimaryTrainingCheckRideRequest? : CheckRideRequestEntity[];
    CheckRideScheduleHold? : CheckRideScheduleHoldEntity[];
    MainFlightSchoolBranch? : FlightSchoolBranchEntity[];
    PilotExaminerLocationAirport? : PilotExaminerLocationAirportEntity[];
    CheckRidePlanOfAction? : PlanOfActionEntity[];
    PrimaryTraningPlanOfAction? : PlanOfActionEntity[];
    RoPilotExaminerLocationDistances? : RoPilotExaminerLocationDistancesEntity[];
    ScheduleBlockAirport? : ScheduleBlockAirportEntity[];
    MainStudentApplicant? : StudentApplicantEntity[];
}

/** Entity for Query Meaning Checkride_Request_School-Calendar  */
export interface CheckrideRequestSchoolCalendarQueryEntity extends DwOrmData {
    // Attributes
    CheckRideRequestId?: number;
    CheckRideTypeId?: number;
    CheckRideTypeIdDisplay?: string;
    CheckRideGroupId?: number;
    CheckRideGroupIdDisplay?: string;
    CheckRideTestTypeId?: number;
    CheckRideTestTypeIdDisplay?: string;
    PilotCertificateNumber?: string;
    CheckRideRequestSubStatusId?: number;
    CheckRideRequestSubStatusIdDisplay?: string;
    ScheduledDateTime?: string;
    ScheduledTimeMinutes?: number;
    ScheduledTimeMinutesDisplay?: string;
    ProposedDateTime?: string;
    ScheduledAirportId?: number;
    ScheduledAirportIdDisplay?: string;
    AuthorityPreapprovalCode?: string;
    AuthorityApprovalCode?: string;
    ProposedAirportId?: number;
    ProposedAirportIdDisplay?: string;
    ProposedTimeMinutes?: number;
    ProposedTimeMinutesDisplay?: string;
    AuthorityPreCheckRideNumber?: string;
    CheckRideRequestSubStatusCheckRideRequestStatusId?: number;
    CheckRideRequestSubStatusCheckRideRequestStatusIdDisplay?: string;
    CheckRideResultCheckRideRequestId?: number;
    CheckRideResultCheckRideDateTime?: string;
    CheckRideResultCheckRideOutcomeId?: number;
    CheckRideResultCheckRideOutcomeIdDisplay?: string;
    CheckRideResultAllowRetest?: boolean;
    CheckRideResultAllowRetestReason?: string;
    CheckRideResultRetestCost?: number;
    AirportAirportName?: string;
    AirportAirportCode?: string;
    AirportAddressCity?: string;
    AirportAddressStateProvinceId?: number;
    AirportAddressStateProvinceIdDisplay?: string;
    AirportAddressPostalCode?: string;
    AirportAddressCountryId?: number;
    AirportAddressCountryIdDisplay?: string;
    AirportAddressLatitude?: number;
    AirportAddressLongitude?: number;
    AirportAddressTimezoneId?: number;
    AirportAddressTimezoneIdDisplay?: string;
    AirportAddressObservesDst?: boolean;
    ScheduledPilotExaminerUserId?: number;
    ScheduledPilotExaminerUserIdDisplay?: string;
    CalendarEventReferenceKey?: string;
    ApplicantNameApplicantFinalEmail?: string;
    ApplicantNameApplicantFinalName?: string;
    ApplicantNameApplicantFinalPhone?: string;
    ApplicantNameFlightSchoolFinalName?: string;
    ApplicantNameCheckRideApplicantTypeId?: number;
    ApplicantNamePilotExaminerFinalName?: string;
    ApplicantNamePilotExaminerFinalEmail?: string;
    ApplicantNamePilotExaminerFinalPhone?: string;
    ApplicantNameFlightInstructorFinalName?: string;
    ApplicantNameFlightInstructorFinalEmail?: string;
    ApplicantNameFlightInstructorFinalPhone?: string;

    // Relations
    ScheduledAirport? : AirportEntity;
    PreferredAirport? : AirportEntity;
    ProposedAirport? : AirportEntity;
    PrimaryTrainingAirport? : AirportEntity;
    ApplicantAcsWrittenResult? : ApplicantAcsWrittenResultEntity;
    ApplicantPlaceholder? : ApplicantPlaceholderEntity;
    AviationAuthority? : AviationAuthorityEntity;
    AvaiationTrainingProgramIdAviationTrainingProgram? : AviationTrainingProgramEntity;
    ScheduledCalendarEventReference? : CalendarEventReferenceEntity;
    CheckRideApplicantType? : CheckRideApplicantTypeEntity;
    CheckRideCancellationType? : CheckRideCancellationTypeEntity;
    CheckRideExaminerType? : CheckRideExaminerTypeEntity;
    CheckRideGroup? : CheckRideGroupEntity;
    CheckRideInstructorType? : CheckRideInstructorTypeEntity;
    CheckRideOwnershipType? : CheckRideOwnershipTypeEntity;
    PilexosBookingCheckRidePayment? : CheckRidePaymentEntity;
    PilexosBookingCostPaymentPartyIdCheckRideRequestPaymentParty? : CheckRideRequestPaymentPartyEntity;
    CheckRideRequestSubStatus? : CheckRideRequestSubStatusEntity;
    ScheduledCheckRideScenario? : CheckRideScenarioEntity;
    CheckRideTestType? : CheckRideTestTypeEntity;
    CheckRideType? : CheckRideTypeEntity;
    CheckRideWorkflow? : CheckRideWorkflowEntity;
    StudentApplicantCitizenshipCountyIdCountry? : CountryEntity;
    ElectronicFlightBagType? : ElectronicFlightBagTypeEntity;
    FlightSchool? : FlightSchoolEntity;
    OdaFlightSchool? : FlightSchoolEntity;
    FlightSchoolApplicant? : FlightSchoolApplicantEntity;
    FlightSchoolBranch? : FlightSchoolBranchEntity;
    FlightSchoolExaminer? : FlightSchoolExaminerEntity;
    FlightSchoolInstructor? : FlightSchoolInstructorEntity;
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    FlightSchoolType? : FlightSchoolTypeEntity;
    DocumentsDwMediaGroup? : DwMediaGroupEntity;
    CurrentPilotCertifiateTypeIdPilotCertificateType? : PilotCertificateTypeEntity;
    ScheduledPilotExaminer? : PilotExaminerEntity;
    ScheduledPilotExaminerLocation? : PilotExaminerLocationEntity;
    StudentApplicantStateProvince? : StateProvinceEntity;
    StudentApplicant? : StudentApplicantEntity;
    CheckRideAISummary? : CheckRideAISummaryEntity[];
    CheckRideAvionicType? : CheckRideAvionicTypeEntity[];
    CheckRidePayment? : CheckRidePaymentEntity[];
    CheckRideRequestNote? : CheckRideRequestNoteEntity[];
    CheckRideRequestPilotCertificate? : CheckRideRequestPilotCertificateEntity[];
    CheckRideResult? : CheckRideResultEntity;
    CheckRideScheduleHold? : CheckRideScheduleHoldEntity[];
    PlanOfAction? : PlanOfActionEntity;
    CheckrideRequestIdRoCheckrideAggregateUtil? : RoCheckrideAggregateUtilEntity;
    RoCheckrideApplicantFinalName? : RoCheckrideApplicantFinalNameEntity;
    RoCheckRideRequestApplicant? : RoCheckRideRequestApplicantEntity;
    CheckrideRequestIdRoCheckrideRequestScheduleDateInfo? : RoCheckrideRequestScheduleDateInfoEntity;
}

/** Entity for Query Meaning Flight_School_Examiner-With_Examiner_Details  */
export interface FlightSchoolExaminerWithExaminerDetailsQueryEntity extends DwOrmData {
    // Attributes
    FlightSchoolExaminerId?: number;
    ExaminerName?: string;
    ExaminerEmail?: string;
    ExaminerPhone?: string;
    FlightSchoolExaminerStatusId?: number;
    FlightSchoolExaminerStatusIdDisplay?: string;
    PilotExaminerId?: number;
    PilotExaminerIdDisplay?: string;
    FlightSchoolOrganizationId?: number;
    FlightSchoolOrganizationIdDisplay?: string;
    FlightSchoolExaminerTypeId?: number;
    FlightSchoolExaminerTypeIdDisplay?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    LastInviteSendDateTime?: string;
    SendInviteEmail?: boolean;
    SendCheckrideEmails?: boolean;
    UseExaminerBlockBooking?: boolean;
    FlightSchoolInstructorId?: number;
    FlightSchoolInstructorIdDisplay?: string;
    RecurrencyDate?: string;
    TrainingCurrent?: boolean;
    TrainingCurrentEvaluatedDateTime?: string;
    DpeSupplementReviewedDateTime?: string;
    DpeSupplementReviewedBy?: number;
    DocumentsMediaGroupId?: number;
    DocumentsMediaGroupIdDisplay?: string;
    TrainingCurrentReason?: string;
    RoFlightSchoolExaminerExaminerEmailFinal?: string;
    RoFlightSchoolExaminerExaminerNameFinal?: string;
    RoFlightSchoolExaminerExaminerPhoneFinal?: string;
    RoFlightSchoolExaminerFlightSchoolExaminerId?: number;
    RoFlightSchoolExaminerPilotExaminerTypeId?: number;
    RoFlightSchoolExaminerPilotExaminerStatusId?: number;
    RoFlightSchoolExaminerFinalExaminerTypeId?: number;
    RoFlightSchoolExaminerFinalExaminerTypeIdDisplay?: string;
    RoFlightSchoolExaminerHasPilexosAccount?: boolean;
    RoFlightSchoolExaminerExaminerGroup?: string;

    // Relations
    FlightSchoolExaminerStatus? : FlightSchoolExaminerStatusEntity;
    FlightSchoolExaminerType? : FlightSchoolExaminerTypeEntity;
    FlightSchoolInstructor? : FlightSchoolInstructorEntity;
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    DocumentsDwMediaGroup? : DwMediaGroupEntity;
    PilotExaminer? : PilotExaminerEntity;
    CheckRideRequest? : CheckRideRequestEntity[];
    FlightSchoolUser? : FlightSchoolUserEntity[];
    PlanOfAction? : PlanOfActionEntity[];
    RoFlightSchoolExaminer? : RoFlightSchoolExaminerEntity;
    ScheduleBlock? : ScheduleBlockEntity[];
    TrainingRecord? : TrainingRecordEntity[];
    UnitMemberAircraftExperience? : UnitMemberAircraftExperienceEntity[];
    UnitMemberCertificate? : UnitMemberCertificateEntity[];
    UnitMemberEmployment? : UnitMemberEmploymentEntity[];
    UnitMemberFlightExperience? : UnitMemberFlightExperienceEntity[];
    UnitMemberProfile? : UnitMemberProfileEntity;
    UnitMemberQualificationResponse? : UnitMemberQualificationResponseEntity[];
    UserInviteRequestDetail? : UserInviteRequestDetailEntity[];
}

/** Entity for Query Meaning Pilot_Examiner-Airport_List  */
export interface PilotExaminerAirportListQueryEntity extends DwOrmData {
    // Attributes
    PilotExaminerId?: number;
    PilotExaminerIdDisplay?: string;
    LocationName?: string;
    SchedulingStartDate?: string;
    SchedulingEndDate?: string;
    IsDefaultLocation?: boolean;
    PilotExaminerLocationTypeId?: number;
    PilotExaminerLocationTypeIdDisplay?: string;
    PilotExaminerLocationAirportAirportId?: number;
    PilotExaminerLocationAirportAirportIdDisplay?: string;
    AirportAirportId?: number;
    AirportAviationAuthorityId?: number;
    AirportAviationAuthorityIdDisplay?: string;
    AirportAirportName?: string;
    AirportAirportCode?: string;
    AirportElevation?: number;
    AirportAddressPostalCode?: string;
    AirportAddressTimezoneId?: number;
    AirportAddressTimezoneIdDisplay?: string;
    AirportAddressLongitude?: number;
    AirportAddressLatitude?: number;
    RoPilotExaminerLocationCurrentPilotExaminerLocationStateId?: number;
    RoPilotExaminerLocationCurrentPilotExaminerLocationStateIdDisplay?: string;

    // Relations
    PilotExaminer? : PilotExaminerEntity;
    PilotExaminerLocationType? : PilotExaminerLocationTypeEntity;
    BookingSchedule? : ScheduleEntity;
    BookingScheduleTimeZoneIdTimeZone? : TimeZoneEntity;
    ScheduledCheckRideRequest? : CheckRideRequestEntity[];
    PilotExaminerLocationAirport? : PilotExaminerLocationAirportEntity[];
    RoPilotExaminerLocationCurrent? : RoPilotExaminerLocationCurrentEntity;
    RoPilotExaminerLocationDistances? : RoPilotExaminerLocationDistancesEntity[];
    ScheduleBlockLocation? : ScheduleBlockLocationEntity[];
}

/** Entity for Query Meaning Reporting-ACS_Missed_Codes_Aggregate  */
export interface ReportingACSMissedCodesAggregateQueryEntity extends DwOrmData {
    // Attributes
    SourceType?: string;
    AssessmentId?: number;
    AssessmentKey?: string;
    PlanOfActionId?: number;
    CheckRideRequestId?: number;
    AcsTestId?: number;
    AcsTestIdDisplay?: string;
    ApplicantAcsWrittenResultTypeId?: number;
    ApplicantAcsWrittenResultTypeIdDisplay?: string;
    ApplicantAcsWrittenResultId?: number;
    PlanOfActionName?: string;
    PlanOfActionStatusId?: number;
    PlanOfActionStatusIdDisplay?: string;
    CheckrideRequestSubStatusId?: number;
    CheckrideRequestSubStatusIdDisplay?: string;
    AviationAuthorityId?: number;
    AviationAuthorityIdDisplay?: string;
    CheckRideExaminerTypeId?: number;
    CheckRideExaminerTypeIdDisplay?: string;
    PilotExaminerId?: number;
    PilotExaminerIdDisplay?: string;
    FlightSchoolExaminerId?: number;
    FlightSchoolExaminerIdDisplay?: string;
    AuthorityPreCheckRideNumber?: string;
    AuthorityPreapprovalCode?: string;
    CheckRideOwnershipTypeId?: number;
    CheckRideOwnershipTypeIdDisplay?: string;
    CheckRideApplicantTypeId?: number;
    CheckRideApplicantTypeIdDisplay?: string;
    ApplicantName?: string;
    ApplicantEmail?: string;
    ApplicantPhone?: string;
    ExaminerName?: string;
    ExaminerEmail?: string;
    ExaminerPhone?: string;
    FlightSchoolApplicantId?: number;
    FlightSchoolApplicantIdDisplay?: string;
    FlightSchoolInstructorId?: number;
    FlightSchoolInstructorIdDisplay?: string;
    CheckrideDateTime?: string;
    CheckrideAirportId?: number;
    CheckrideAirportIdDisplay?: string;
    CheckrideGroupId?: number;
    CheckrideGroupIdDisplay?: string;
    CheckrideTypeId?: number;
    CheckrideTypeIdDisplay?: string;
    CheckRideTestTypeId?: number;
    CheckRideTestTypeIdDisplay?: string;
    CheckrideDurationMinutes?: number;
    CheckrideEndDateTime?: string;
    PlanOfActionResultId?: number;
    CheckrideResultId?: number;
    CheckRideOutcomeId?: number;
    CheckRideOutcomeIdDisplay?: string;
    AllowRetest?: boolean;
    FlagApplicant?: boolean;
    AllowRetestReason?: string;
    RetestCost?: number;
    AddToWaitlist?: boolean;
    GroundPortionComplete?: boolean;
    ApplicantAcsWrittenResultMissedCodeId?: number;
    AcsCodeId?: number;
    AcsCodeIdDisplay?: string;
    AscCodeTypeId?: number;
    AcsCodeTypeName?: string;
    AcsCode?: string;
    AcsCodeOrder?: number;
    AcsAreaOfOperationTaskId?: number;
    AscCodeDescription?: string;
    AcsAreaOfOperationId?: number;
    AcsAreaOfOperationIdDisplay?: string;
    TaskName?: string;
    TaskOrder?: number;
    TaskCode?: string;
    AreaOfOperationName?: string;
    AreaOfOperationOrder?: number;
    AreaOfOperationCode?: string;
    TestName?: string;
    TestDescription?: string;
    TestCode?: string;
    CheckRideGroup?: string;
    AssessmentCount?: number;
    CheckrideCount?: number;
    POACount?: number;
    MissedCodeCount?: number;
    FlightSchoolId?: number;
    FlightSchoolOrganizationId?: number;
    OdaFlightSchoolId?: number;

    // Relations
    AcsCode3? : AcsCodeEntity;
}

/** Entity for Query Meaning CheckrideRequest_HomePage  */
export interface CheckrideRequestHomePageQueryEntity extends DwOrmData {
    // Attributes
    CheckRideRequestId?: number;
    AviationAuthorityId?: number;
    AviationAuthorityIdDisplay?: string;
    CheckRideTypeId?: number;
    CheckRideTypeIdDisplay?: string;
    CheckRideTestTypeId?: number;
    CheckRideTestTypeIdDisplay?: string;
    PilotCertificateNumber?: string;
    CheckRideRequestSubStatusId?: number;
    CheckRideRequestSubStatusIdDisplay?: string;
    PreferredDateTime?: string;
    ScheduledTimeMinutes?: number;
    ScheduledTimeMinutesDisplay?: string;
    ScheduledPilotExaminerId?: number;
    ScheduledPilotExaminerIdDisplay?: string;
    ScheduledPreTimeMinutes?: number;
    ScheduledPostTimeMinutes?: number;
    AuthorityPreCheckRideNumber?: string;
    AirplaneMakeModel?: string;
    AirplaneNNumber?: string;
    DocumentsMediaGroupId?: number;
    DocumentsMediaGroupIdDisplay?: string;
    AuthorityPreapprovalCode?: string;
    CheckRideGroupId?: number;
    CheckRideGroupIdDisplay?: string;
    ScheduledAirportId?: number;
    ScheduledAirportIdDisplay?: string;
    ScheduledDateTime?: string;
    ScheduledCheckRideScenarioId?: number;
    ScheduledCheckRideScenarioIdDisplay?: string;
    EndorsedAndCheckRideReady?: boolean;
    AvaiationTrainingProgramId?: number;
    AvaiationTrainingProgramIdDisplay?: string;
    CheckRideApplicantTypeId?: number;
    CheckRideApplicantTypeIdDisplay?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    PilexosBookingPaymentAdded?: boolean;
    ExaminerBookingCost?: number;
    PilexosBookingCost?: number;
    AdditionalTravelCost?: number;
    ScheduledCheckRideCost?: number;
    FlightSchoolName?: string;
    CancelledRequestBookingFeeRefund?: boolean;
    StudentApplicantId?: number;
    StudentApplicantIdDisplay?: string;
    StudentApplicantCitizenshipCountyId?: number;
    StudentApplicantCitizenshipCountyIdDisplay?: string;
    CheckRideExaminerTypeId?: number;
    CheckRideExaminerTypeIdDisplay?: string;
    CheckRideOwnershipTypeId?: number;
    CheckRideOwnershipTypeIdDisplay?: string;
    FlightSchoolOrganizationId?: number;
    FlightSchoolOrganizationIdDisplay?: string;
    FlightSchoolExaminerId?: number;
    FlightSchoolExaminerIdDisplay?: string;
    FlightSchoolApplicantId?: number;
    FlightSchoolApplicantIdDisplay?: string;
    FlightSchoolBranchId?: number;
    FlightSchoolBranchIdDisplay?: string;
    CheckRideWorkflowId?: number;
    CheckRideWorkflowIdDisplay?: string;
    PrimaryTrainingAirportId?: number;
    PrimaryTrainingAirportIdDisplay?: string;
    StudentApplicantStateProvinceId?: number;
    StudentApplicantStateProvinceIdDisplay?: string;
    ForeignPilotMeetsQualifications?: boolean;
    AuthorityApplicationNumber?: string;
    AuthorityApprovalCode?: string;
    OdaFlightSchoolId?: number;
    OdaFlightSchoolIdDisplay?: string;
    SendExaminerCheckrideEmails?: boolean;
    SendApplicantCheckrideEmails?: boolean;
    PilexosBookingCostPaymentPartyId?: number;
    PilexosBookingCostPaymentPartyIdDisplay?: string;
    CheckRideRequestSubStatusCheckRideRequestStatusId?: number;
    CheckRideRequestSubStatusCheckRideRequestStatusIdDisplay?: string;
    CheckRideResultCheckRideDateTime?: string;
    CheckRideResultCheckRideOutcomeId?: number;
    CheckRideResultCheckRideOutcomeIdDisplay?: string;
    CheckRideResultAllowRetest?: boolean;
    CheckRideResultAllowRetestReason?: string;
    CheckRideResultRetestCost?: number;
    AirportAirportName?: string;
    AirportAirportCode?: string;
    RoCheckrideApplicantInfoApplicantFinalName?: string;
    RoCheckrideApplicantInfoCheckRideRequestId?: number;
    RoCheckrideApplicantInfoCheckRideRequestIdDisplay?: string;
    RoCheckrideApplicantInfoFlightSchoolFinalName?: string;
    RoCheckrideApplicantInfoApplicantFinalEmail?: string;
    RoCheckrideApplicantInfoApplicantFinalPhone?: string;
    RoCheckrideApplicantInfoPilotExaminerFinalName?: string;
    RoCheckrideApplicantInfoPilotExaminerFinalEmail?: string;
    RoCheckrideApplicantInfoPilotExaminerFinalPhone?: string;
    RoCheckrideApplicantInfoFlightInstructorFinalName?: string;
    RoCheckrideApplicantInfoFlightInstructorFinalEmail?: string;
    RoCheckrideApplicantInfoFlightInstructorFinalPhone?: string;
    PilexosBookingCheckRidePaymentPaymentDateTime?: string;
    PilexosBookingCheckRidePaymentPaymentAmount?: number;
    PilexosBookingCheckRidePaymentEmailCCReceipt?: string;
    PilexosBookingCheckRidePaymentPaymentPartyId?: number;
    PilexosBookingCheckRidePaymentPaymentPartyIdDisplay?: string;
    PaymentReferencePaymentReferenceCardTypeId?: number;
    PaymentReferencePaymentReferenceCardTypeIdDisplay?: string;
    PaymentReferenceCardHolderName?: string;
    PaymentReferencePaymentReference?: string;
    PaymentReferencePaymentReferenceStatusId?: number;
    PaymentReferencePaymentReferenceStatusIdDisplay?: string;
    PaymentReferencePaymentAmount?: number;

    // Relations
    ScheduledAirport? : AirportEntity;
    PreferredAirport? : AirportEntity;
    ProposedAirport? : AirportEntity;
    PrimaryTrainingAirport? : AirportEntity;
    ApplicantAcsWrittenResult? : ApplicantAcsWrittenResultEntity;
    ApplicantPlaceholder? : ApplicantPlaceholderEntity;
    AviationAuthority? : AviationAuthorityEntity;
    AvaiationTrainingProgramIdAviationTrainingProgram? : AviationTrainingProgramEntity;
    ScheduledCalendarEventReference? : CalendarEventReferenceEntity;
    CheckRideApplicantType? : CheckRideApplicantTypeEntity;
    CheckRideCancellationType? : CheckRideCancellationTypeEntity;
    CheckRideExaminerType? : CheckRideExaminerTypeEntity;
    CheckRideGroup? : CheckRideGroupEntity;
    CheckRideInstructorType? : CheckRideInstructorTypeEntity;
    CheckRideOwnershipType? : CheckRideOwnershipTypeEntity;
    PilexosBookingCheckRidePayment? : CheckRidePaymentEntity;
    PilexosBookingCostPaymentPartyIdCheckRideRequestPaymentParty? : CheckRideRequestPaymentPartyEntity;
    CheckRideRequestSubStatus? : CheckRideRequestSubStatusEntity;
    ScheduledCheckRideScenario? : CheckRideScenarioEntity;
    CheckRideTestType? : CheckRideTestTypeEntity;
    CheckRideType? : CheckRideTypeEntity;
    CheckRideWorkflow? : CheckRideWorkflowEntity;
    StudentApplicantCitizenshipCountyIdCountry? : CountryEntity;
    ElectronicFlightBagType? : ElectronicFlightBagTypeEntity;
    FlightSchool? : FlightSchoolEntity;
    OdaFlightSchool? : FlightSchoolEntity;
    FlightSchoolApplicant? : FlightSchoolApplicantEntity;
    FlightSchoolBranch? : FlightSchoolBranchEntity;
    FlightSchoolExaminer? : FlightSchoolExaminerEntity;
    FlightSchoolInstructor? : FlightSchoolInstructorEntity;
    FlightSchoolOrganization? : FlightSchoolOrganizationEntity;
    FlightSchoolType? : FlightSchoolTypeEntity;
    DocumentsDwMediaGroup? : DwMediaGroupEntity;
    CurrentPilotCertifiateTypeIdPilotCertificateType? : PilotCertificateTypeEntity;
    ScheduledPilotExaminer? : PilotExaminerEntity;
    ScheduledPilotExaminerLocation? : PilotExaminerLocationEntity;
    StudentApplicantStateProvince? : StateProvinceEntity;
    StudentApplicant? : StudentApplicantEntity;
    CheckRideAISummary? : CheckRideAISummaryEntity[];
    CheckRideAvionicType? : CheckRideAvionicTypeEntity[];
    CheckRidePayment? : CheckRidePaymentEntity[];
    CheckRideRequestNote? : CheckRideRequestNoteEntity[];
    CheckRideRequestPilotCertificate? : CheckRideRequestPilotCertificateEntity[];
    CheckRideResult? : CheckRideResultEntity;
    CheckRideScheduleHold? : CheckRideScheduleHoldEntity[];
    PlanOfAction? : PlanOfActionEntity;
    CheckrideRequestIdRoCheckrideAggregateUtil? : RoCheckrideAggregateUtilEntity;
    RoCheckrideApplicantFinalName? : RoCheckrideApplicantFinalNameEntity;
    RoCheckRideRequestApplicant? : RoCheckRideRequestApplicantEntity;
    CheckrideRequestIdRoCheckrideRequestScheduleDateInfo? : RoCheckrideRequestScheduleDateInfoEntity;
}

    // Lookup Value Enums  {
export enum PilotExaminerStatusAllItems {
        Pending = 1,
        Submitted = 2,
        Rejected = 3,
        VerifiedLive = 4,
        Inactive = 1001,
    }

export enum CheckRideRequestStatusAllItems {
        Requested = 1,
        Booked = 2,
        Cancelled = 3,
        PostCheckride = 4,
        Complete = 5,
    }

export enum CheckRideRequestSubStatusExaminerWF {
        PendingApproval = 1,
        Cancelled = 3,
        NewDateProposedByExaminer = 4,
        Accepted = 5,
        RequiresAdditionalInfo = 6,
        AllDetailsComplete = 7,
        Rejected = 8,
        PendingOutcome = 9,
        Completed = 10,
        Deleted = 11,
        Draft = 12,
        PendingPayment = 14,
        AdditionalInformationNeeded = 15,
        AcceptedPendingPayment = 16,
        PendingReschedule = 17,
        PendingApprovalPayment = 18,
    }

export enum CheckRideRequestSubStatusFullStatusDesc {
        RequestedPendingApproval = 1,
        CancelledCancelled = 3,
        RequestedNewDateProposedByExaminer = 4,
        BookedAccepted = 5,
        BookedRequiresAdditionalInfo = 6,
        BookedAllDetailsComplete = 7,
        RequestedRejected = 8,
        PostCheckridePendingOutcome = 9,
        CompleteCompleted = 10,
        CompleteDeleted = 11,
        RequestedDraft = 12,
        RequestedPendingPayment = 14,
        RequestedAdditionalInformationNeeded = 15,
        BookedAcceptedPendingPayment = 16,
        PostCheckridePendingReschedule = 17,
        RequestedPendingApprovalPayment = 18,
    }

export enum CheckRideRequestSubStatusStudentWF {
        PendingApproval = 1,
        Cancelled = 3,
        NewDateProposedByExaminer = 4,
        Accepted = 5,
        RequiresAdditionalInfo = 6,
        AllDetailsComplete = 7,
        Rejected = 8,
        PendingOutcome = 9,
        Completed = 10,
        Deleted = 11,
        Draft = 12,
        PendingPayment = 14,
        AdditionalInformationNeeded = 15,
        AcceptedPendingPayment = 16,
        PendingReschedule = 17,
        PendingApprovalPayment = 18,
    }

export enum PaymentReferenceStatusAllItems {
        Pending = 1,
        Charged = 2,
        Refunded = 3,
        Cancelled = 4,
    }

export enum CheckRideStatusLevelAllItems {
        AllGoodGreen = 1,
        WarningOrange = 2,
        DangerRed = 3,
    }

export enum CheckRideRequestSubStatusExaminerManualWF {
        PendingApproval = 1,
        Cancelled = 3,
        NewDateProposedByExaminer = 4,
        Accepted = 5,
        RequiresAdditionalInfo = 6,
        AllDetailsComplete = 7,
        Rejected = 8,
        PendingOutcome = 9,
        Completed = 10,
        Deleted = 11,
        Draft = 12,
        PendingPayment = 14,
        AdditionalInformationNeeded = 15,
        AcceptedPendingPayment = 16,
        PendingReschedule = 17,
        PendingApprovalPayment = 18,
    }

export enum ApplicantPlaceholderStatusAllItems {
        Requested = 1,
        Booked = 2,
        Cancelled = 3,
        Complete = 4,
        Deleted = 5,
    }

export enum PlanOfActionStatusAllItems {
        Draft = 1,
        Active = 2,
        Complete = 3,
        Cancelled = 4,
        Deleted = 5,
        Inactive = 6,
        PendingOutcome = 7,
    }

export enum AcsTestStatusAllItems {
        Active = 1,
        Expired = 2,
        Deleted = 3,
    }

export enum PlanOfActionStatusPlan {
        Draft = 1,
        Active = 2,
        Complete = 3,
        Cancelled = 4,
        Deleted = 5,
        PendingOutcome = 7,
    }

export enum PlanOfActionStatusTypeAllItems {
        Shared = 1,
        PlanStatus = 2,
        TemplateStatus = 3,
    }

export enum PlanOfActionStatusTemplate {
        Active = 2,
        Deleted = 5,
        Inactive = 6,
    }

export enum FlightSchoolStatusAllItems {
        Active = 1,
        Inactive = 2,
    }

export enum FlightSchoolReferenceStatusAllItems {
        Active = 1,
        Inactive = 2,
    }

export enum FlightSchoolApplicantStatusAllItems {
        AwaitingCheckride = 1,
        CheckrideScheduled = 2,
        CheckrideComplete = 3,
        Inactive = 4,
        AwaitingRebook = 6,
        Deleted = 7,
    }

export enum FlightSchoolExaminerStatusAllItems {
        Active = 1,
        Inactive = 2,
        Invited = 3,
    }

export enum CheckRideRequestSubStatusSchoolWF {
        PendingApproval = 1,
        Cancelled = 3,
        NewDateProposedByExaminer = 4,
        Accepted = 5,
        RequiresAdditionalInfo = 6,
        AllDetailsComplete = 7,
        Rejected = 8,
        PendingOutcome = 9,
        Completed = 10,
        Deleted = 11,
        Draft = 12,
        PendingPayment = 14,
        AdditionalInformationNeeded = 15,
        AcceptedPendingPayment = 16,
        PendingReschedule = 17,
        PendingApprovalPayment = 18,
    }

export enum SubscriptionStatusAllItems {
        Active = 1,
        Inactive = 2,
        Future = 3,
    }

export enum SubscriptionTierStatusAllItems {
        Active = 1,
        Inactive = 2,
    }

export enum PaymentCardStatusAllItems {
        Active = 1,
        Deleted = 2,
    }

export enum FlightSchoolInstructorStatusAllItems {
        Active = 1,
        Inactive = 2,
        Deleted = 3,
    }

export enum CheckRideRequestSubStatusSchoolManualWF {
        PendingApproval = 1,
        Cancelled = 3,
        NewDateProposedByExaminer = 4,
        Accepted = 5,
        RequiresAdditionalInfo = 6,
        AllDetailsComplete = 7,
        Rejected = 8,
        PendingOutcome = 9,
        Completed = 10,
        Deleted = 11,
        Draft = 12,
        PendingPayment = 14,
        AdditionalInformationNeeded = 15,
        AcceptedPendingPayment = 16,
        PendingReschedule = 17,
        PendingApprovalPayment = 18,
    }

export enum CheckRideRequestSubStatusAllItems {
        PendingApproval = 1,
        Cancelled = 3,
        NewDateProposedByExaminer = 4,
        Accepted = 5,
        RequiresAdditionalInfo = 6,
        AllDetailsComplete = 7,
        Rejected = 8,
        PendingOutcome = 9,
        Completed = 10,
        Deleted = 11,
        Draft = 12,
        PendingPayment = 14,
        AdditionalInformationNeeded = 15,
        AcceptedPendingPayment = 16,
        PendingReschedule = 17,
        PendingApprovalPayment = 18,
    }

export enum FlightSchoolExaminerStatusActiveInactive {
        Active = 1,
        Inactive = 2,
    }

export enum UserInviteRequestStatusAllItems {
        Pending = 1,
        Complete = 2,
        Deleted = 3,
    }

export enum FlightSchoolSetupRequestStatusAllItems {
        Submitted = 1,
        Rejected = 2,
        Complete = 3,
    }

export enum ScheduleBlockStatusAllItems {
        Active = 1,
        Inactive = 2,
        Deleted = 3,
    }

export enum ScheduleBlockItemStatusAllItems {
        Active = 1,
        Inactive = 2,
        Deleted = 3,
    }

export enum CheckRideAISummaryStatusAllItems {
        New = 1,
        Processing = 2,
        Success = 3,
        Failed = 4,
        Deleted = 5,
    }

export enum QuestionBankStatusAllItems {
        Active = 1,
        Inactive = 2,
        Deleted = 3,
    }

export enum ReferenceStatusAllItems {
        Active = 1,
        Inactive = 2,
        Deleted = 3,
    }

export enum ReferenceStatusActiveInactive {
        Active = 1,
        Inactive = 2,
    }

export enum FlightSchoolInstrcutorStatusActiveInactive {
        Active = 1,
        Inactive = 2,
    }

export enum CalendarSyncRequestStatusAllItems {
        Pending = 1,
        InProgress = 2,
        Succeeded = 3,
        Failed = 4,
        DeadLetter = 5,
        Superseded = 6,
    }

export enum TrainingRecordStatusAllItems {
        Incomplete = 1,
        Complete = 2,
        Expired = 3,
    }

// Excluding lookup MediaGroup All Items because it contains 203 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum CheckRideGroupAllItems {
        Private = 1,
        Instrument = 2,
        Commercial = 3,
        CFI = 4,
        AirlineTransportPilot = 8,
        SportPilot = 9,
        AddOn = 10,
        Administrative = 11,
        SpecialMedicalFlightTest = 1001,
        Mechanic = 1002,
    }

export enum CheckRideTypeByGroup {
    }

export enum FlightSchoolExaminerBySchoolWithGrouping {
    }

export enum ReportDashboardGroupAllItems {
        SchoolReports = 1,
        ExaminerReports = 2,
        ExaminerHomeKpis = 3,
        OdaSchoolReports = 4,
        SchoolHomeKpis = 5,
    }

export enum CheckRideTypeAllItems {
        AirplaneSingleEngineLand = 1,
        AirplaneSingleEngineSea = 2,
        AirplaneMultiEngineLand = 3,
        AirplaneMultiEngineSea = 4,
        LighterThanAirBalloon = 5,
        PoweredChuteLand = 6,
        GliderLand = 7,
        // Duplicate property Name found
        AirplaneSingleEngineLand_8 = 8,
        // Duplicate property Name found
        AirplaneSingleEngineSea_9 = 9,
        // Duplicate property Name found
        AirplaneMultiEngineLand_10 = 10,
        // Duplicate property Name found
        AirplaneMultiEngineSea_11 = 11,
        RotorcraftHelicopter = 12,
        RotorcraftGyroplane = 13,
        // Duplicate property Name found
        AirplaneSingleEngineLand_14 = 14,
        // Duplicate property Name found
        RotorcraftHelicopter_15 = 15,
        // Duplicate property Name found
        RotorcraftGyroplane_16 = 16,
        // Duplicate property Name found
        GliderLand_17 = 17,
        // Duplicate property Name found
        PoweredChuteLand_18 = 18,
        // Duplicate property Name found
        LighterThanAirBalloon_19 = 19,
        // Duplicate property Name found
        AirplaneSingleEngineLand_20 = 20,
        // Duplicate property Name found
        AirplaneMultiEngineLand_21 = 21,
        // Duplicate property Name found
        RotorcraftHelicopter_22 = 22,
        // Duplicate property Name found
        AirplaneSingleEngineLand_25 = 25,
        // Duplicate property Name found
        AirplaneMultiEngineLand_27 = 27,
        RotorcraftHelicopterSingleEngine = 28,
        AirplaneInstrumentInstructorAddOn = 29,
        AirplaneMultiEngineInstructorAddOn = 30,
        // Duplicate property Name found
        AirplaneSingleEngineSea_31 = 31,
        // Duplicate property Name found
        AirplaneSingleEngineLand_32 = 32,
        // Duplicate property Name found
        AirplaneSingleEngineSea_33 = 33,
        // Duplicate property Name found
        AirplaneMultiEngineLand_34 = 34,
        // Duplicate property Name found
        AirplaneMultiEngineSea_35 = 35,
        // Duplicate property Name found
        RotorcraftHelicopterSingleEngine_36 = 36,
        RotorcraftHelicopterMultiEngine = 37,
        // Duplicate property Name found
        RotorcraftHelicopterMultiEngine_38 = 38,
        PoweredChuteSea = 39,
        // Duplicate property Name found
        PoweredChuteSea_40 = 40,
        SportSingleEngineLand = 41,
        SportSingleEngineSea = 42,
        InstrumentSingleEngine = 43,
        CommercialSingleEngineLand = 44,
        SeaplaneSingleEngine = 45,
        SeaplaneMultiEngine = 46,
        Glider = 47,
        // Duplicate property Name found
        LighterThanAirBalloon_48 = 48,
        RotorcraftSingleEngine = 49,
        RotorcraftMultiEngine = 50,
        CommercialMultiEngine = 51,
        TurbopropSingleEngine = 52,
        TurbopropMultiEngine = 53,
        TurbojetSingleEngine = 54,
        TurbojetMultiEngine = 55,
        ReciprocatingSingleEngine = 56,
        ReciprocatingMultiEngine = 57,
        ForeignPilotExaminerFPE = 58,
        MilitaryCompetencyExaminerMCE = 59,
        GroundInstructorExaminerGIE = 60,
        FlightInstructorRenewalExaminerFIRE = 61,
        RemotePilotExaminerRPE = 62,
        AirmanCert141ACR141 = 63,
        AirmanCertFlightInstructorRefresherCourseACRFIRC = 64,
        InstrumentMultiEngine = 1001,
        InstrumentHelicopterSingleEngine = 1002,
        PrivateMultiEngineLand = 1003,
        CommercialLighterThanAirBalloon = 1004,
        // Duplicate property Name found
        AirplaneSingleEngineSea_1005 = 1005,
        // Duplicate property Name found
        AirplaneMultiEngineSea_1006 = 1006,
        PrivateSingleEngineLand = 1007,
        SICTypeRatingSIC = 1008,
        AirplaneCE500TypeRating = 1009,
        AirplaneCE525TypeRating = 1010,
        AirplaneBE300TypeRating = 1011,
        SOERemovalSOE = 1012,
        ATPRestrictionRemovalRATP = 1013,
        HearingImpairment = 1014,
        TotalHearingLoss = 1015,
        PhysicalDeformity = 1016,
        VisualDefect = 1017,
        SpeechDefect = 1018,
        ColorVisionDefect = 1019,
        HearingImpairmentRemoval = 1020,
        AirframeA = 1021,
        PowerplantP = 1022,
        AirframePowerplantAP = 1023,
        AirplaneBE737TypeRating = 1024,
    }

// Excluding lookup CheckRideScenarioTypeMap All Items because it contains 237 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum PaymentTypeAllItems {
        PilExOSFee = 1,
        CheckridePayment = 2,
        CheckrideRefund = 3,
        ExaminerFee = 4,
    }

export enum CheckRideTestTypeAllItems {
        InitialTest = 1,
        Retest = 2,
        Continuance = 3,
        RetestFlightOnly = 4,
        ContinuanceFlightOnly = 5,
        Admin = 6,
        Recurrent = 1001,
        StageCheck1 = 1002,
        StageCheck2 = 1003,
        StageCheck3 = 1004,
        Stage1FlightOnly = 1005,
        Stage2FlightOnly = 1006,
        Stage3FlightOnly = 1007,
        EndOfCourse = 1008,
        Stage1Retest = 1009,
        Stage2Retest = 1010,
        Stage3Retest = 1011,
        Stage1RetestFlightOnly = 1012,
        Stage2RetestFlightOnly = 1013,
        Stage3RetestFlightOnly = 1014,
        EndOfCourseRetest = 1015,
        EndOfCourseFlightOnly = 1016,
    }

export enum UserTypeAllItems {
        PilotExaminer = 1,
        FlightSchool = 2,
        StudentApplicant = 3,
        PilexosAdmin = 4,
        FlightInstructor = 5,
        CheckInstructor = 6,
    }

export enum CalendarReferenceTypeAllItems {
        GoogleCalendar = 1,
    }

export enum CheckRideTypeWithGrade {
        CFIAirplaneSingleEngineLand = 1,
        CFIAirplaneSingleEngineSea = 2,
        CFIAirplaneMultiEngineLand = 3,
        CFIAirplaneMultiEngineSea = 4,
        CFILighterThanAirBalloon = 5,
        CFIPoweredChuteLand = 6,
        CFIGliderLand = 7,
        PrivateAirplaneSingleEngineLand = 8,
        PrivateAirplaneSingleEngineSea = 9,
        PrivateAirplaneMultiEngineLand = 10,
        PrivateAirplaneMultiEngineSea = 11,
        CFIRotorcraftHelicopter = 12,
        CFIRotorcraftGyroplane = 13,
        InstrumentAirplaneSingleEngineLand = 14,
        PrivateRotorcraftHelicopter = 15,
        PrivateRotorcraftGyroplane = 16,
        PrivateGliderLand = 17,
        SportPilotPoweredChuteLand = 18,
        PrivateLighterThanAirBalloon = 19,
        SportPilotAirplaneSingleEngineLand = 20,
        InstrumentAirplaneMultiEngineLand = 21,
        InstrumentRotorcraftHelicopter = 22,
        CommercialAirplaneSingleEngineLand = 25,
        CommercialAirplaneMultiEngineLand = 27,
        CommercialRotorcraftHelicopterSingleEngine = 28,
        CFIAirplaneInstrumentInstructorAddOn = 29,
        CFIAirplaneMultiEngineInstructorAddOn = 30,
        SportPilotAirplaneSingleEngineSea = 31,
        AirlineTransportPilotAirplaneSingleEngineLand = 32,
        AirlineTransportPilotAirplaneSingleEngineSea = 33,
        AirlineTransportPilotAirplaneMultiEngineLand = 34,
        AirlineTransportPilotAirplaneMultiEngineSea = 35,
        AirlineTransportPilotRotorcraftHelicopterSingleEngine = 36,
        AirlineTransportPilotRotorcraftHelicopterMultiEngine = 37,
        CommercialRotorcraftHelicopterMultiEngine = 38,
        CFIPoweredChuteSea = 39,
        SportPilotPoweredChuteSea = 40,
        CFISportSingleEngineLand = 41,
        CFISportSingleEngineSea = 42,
        AddOnInstrumentSingleEngine = 43,
        AddOnCommercialSingleEngineLand = 44,
        AddOnSeaplaneSingleEngine = 45,
        AddOnSeaplaneMultiEngine = 46,
        AddOnGlider = 47,
        AddOnLighterThanAirBalloon = 48,
        AddOnRotorcraftSingleEngine = 49,
        AddOnRotorcraftMultiEngine = 50,
        AddOnCommercialMultiEngine = 51,
        AddOnTurbopropSingleEngine = 52,
        AddOnTurbopropMultiEngine = 53,
        AddOnTurbojetSingleEngine = 54,
        AddOnTurbojetMultiEngine = 55,
        AddOnReciprocatingSingleEngine = 56,
        AddOnReciprocatingMultiEngine = 57,
        AdministrativeForeignPilotExaminerFPE = 58,
        AdministrativeMilitaryCompetencyExaminerMCE = 59,
        AdministrativeGroundInstructorExaminerGIE = 60,
        AdministrativeFlightInstructorRenewalExaminerFIRE = 61,
        AdministrativeRemotePilotExaminerRPE = 62,
        AdministrativeAirmanCert141ACR141 = 63,
        AdministrativeAirmanCertFlightInstructorRefresherCourseACRFIRC = 64,
        AddOnInstrumentMultiEngine = 1001,
        AddOnInstrumentHelicopterSingleEngine = 1002,
        AddOnPrivateMultiEngineLand = 1003,
        AddOnCommercialLighterThanAirBalloon = 1004,
        CommercialAirplaneSingleEngineSea = 1005,
        CommercialAirplaneMultiEngineSea = 1006,
        AddOnPrivateSingleEngineLand = 1007,
        AdministrativeSICTypeRatingSIC = 1008,
        AirlineTransportPilotAirplaneCE500TypeRating = 1009,
        AirlineTransportPilotAirplaneCE525TypeRating = 1010,
        AirlineTransportPilotAirplaneBE300TypeRating = 1011,
        AdministrativeSOERemovalSOE = 1012,
        AdministrativeATPRestrictionRemovalRATP = 1013,
        SpecialMedicalFlightTestHearingImpairment = 1014,
        SpecialMedicalFlightTestTotalHearingLoss = 1015,
        SpecialMedicalFlightTestPhysicalDeformity = 1016,
        SpecialMedicalFlightTestVisualDefect = 1017,
        SpecialMedicalFlightTestSpeechDefect = 1018,
        SpecialMedicalFlightTestColorVisionDefect = 1019,
        SpecialMedicalFlightTestHearingImpairmentRemoval = 1020,
        MechanicAirframeA = 1021,
        MechanicPowerplantP = 1022,
        MechanicAirframePowerplantAP = 1023,
        AirlineTransportPilotAirplaneBE737TypeRating = 1024,
    }

export enum PaymentReferenceCardTypeAllItems {
        Visa = 1,
        Matsercard = 2,
        AmericanExpress = 3,
        Discover = 4,
        Unknown = 5,
    }

export enum CheckRideApplicantTypeAllItems {
        StudentAccount = 1,
        ManualEntry = 2,
        FlightSchoolStudent = 3,
    }

export enum CheckRideRequestCancelTypeAllItems {
        ApplicantNoShow = 1,
        ApplicantNotReady = 2,
        Mechanical = 3,
        Weather = 4,
        Other = 5,
        ApplicantSick = 6,
        ExaminerSick = 7,
        ExaminerCancelled = 8,
    }

export enum PilotCertificateTypeAllItems {
        Student = 1,
        Private = 2,
        Commercial = 3,
        ATP = 4,
        CFI = 5,
        CFII = 6,
        Instrument = 7,
    }

export enum AcsCodeTypeAllItems {
        Knowledge = 1,
        RiskManagement = 2,
        Skills = 3,
    }

export enum PlanOfActionSectionTypeAllItems {
        Manual = 1,
        AreaOfOperation = 2,
        Task = 3,
    }

export enum PilotExaminerLocationTypeAllItems {
        Home = 1,
        Travel = 2,
    }

export enum AcsTestCheckRideTypeAllItems {
        AcsTestCheckRideTypeId1 = 1,
        AcsTestCheckRideTypeId2 = 2,
        AcsTestCheckRideTypeId3 = 3,
        AcsTestCheckRideTypeId4 = 4,
        AcsTestCheckRideTypeId5 = 5,
        AcsTestCheckRideTypeId7 = 7,
        AcsTestCheckRideTypeId9 = 9,
        AcsTestCheckRideTypeId10 = 10,
        AcsTestCheckRideTypeId11 = 11,
        AcsTestCheckRideTypeId12 = 12,
        AcsTestCheckRideTypeId13 = 13,
        AcsTestCheckRideTypeId14 = 14,
        AcsTestCheckRideTypeId15 = 15,
        AcsTestCheckRideTypeId16 = 16,
        AcsTestCheckRideTypeId17 = 17,
        AcsTestCheckRideTypeId18 = 18,
        AcsTestCheckRideTypeId19 = 19,
        AcsTestCheckRideTypeId20 = 20,
        AcsTestCheckRideTypeId21 = 21,
        AcsTestCheckRideTypeId22 = 22,
        AcsTestCheckRideTypeId23 = 23,
        AcsTestCheckRideTypeId24 = 24,
        AcsTestCheckRideTypeId25 = 25,
        AcsTestCheckRideTypeId26 = 26,
        AcsTestCheckRideTypeId27 = 27,
        AcsTestCheckRideTypeId28 = 28,
        AcsTestCheckRideTypeId29 = 29,
        AcsTestCheckRideTypeId30 = 30,
        AcsTestCheckRideTypeId31 = 31,
        AcsTestCheckRideTypeId32 = 32,
        AcsTestCheckRideTypeId33 = 33,
        AcsTestCheckRideTypeId34 = 34,
        AcsTestCheckRideTypeId35 = 35,
        AcsTestCheckRideTypeId36 = 36,
        AcsTestCheckRideTypeId37 = 37,
    }

export enum CheckRideExaminerTypeAllItems {
        Examiner = 1,
        FlightSchoolExaminer = 2,
    }

export enum CheckRideOwnershipTypeAllItems {
        Examiner = 1,
        FlightSchool = 2,
    }

export enum PilotExaminerTypeAllItems {
        PilExOSExaminer = 1,
        BasicExaminer = 2,
    }

export enum ElectronicFlightBagTypeAllItems {
        ForeFlight = 1,
        GarminPilot = 2,
        FlyQ = 3,
        Num8Flight = 4,
        IFlightPlanner = 5,
        None = 6,
        Other = 7,
    }

export enum AvionicTypeAllItems {
        SteamGauge = 1,
        G1000 = 2,
        G5 = 3,
        GI275 = 4,
        Garmin430 = 5,
        Garmin530 = 6,
        GTN650 = 7,
        GTN750 = 8,
        Avidyne = 9,
        Dynon = 10,
        AdvancedAvionics = 11,
        Autopilot = 12,
        Other = 13,
    }

export enum CheckRideAvionicTypeAllItems {
        CheckRideAvionicTypeId1 = 1,
        CheckRideAvionicTypeId2 = 2,
        CheckRideAvionicTypeId3 = 3,
        CheckRideAvionicTypeId4 = 4,
        CheckRideAvionicTypeId5 = 5,
        CheckRideAvionicTypeId6 = 6,
        CheckRideAvionicTypeId7 = 7,
        CheckRideAvionicTypeId8 = 8,
        CheckRideAvionicTypeId9 = 9,
        CheckRideAvionicTypeId10 = 10,
        CheckRideAvionicTypeId11 = 11,
        CheckRideAvionicTypeId12 = 12,
        CheckRideAvionicTypeId13 = 13,
        CheckRideAvionicTypeId14 = 14,
        CheckRideAvionicTypeId15 = 15,
        CheckRideAvionicTypeId16 = 16,
        CheckRideAvionicTypeId17 = 17,
        CheckRideAvionicTypeId18 = 18,
        CheckRideAvionicTypeId19 = 19,
        CheckRideAvionicTypeId20 = 20,
        CheckRideAvionicTypeId21 = 21,
        CheckRideAvionicTypeId22 = 22,
        CheckRideAvionicTypeId23 = 23,
        CheckRideAvionicTypeId24 = 24,
        CheckRideAvionicTypeId25 = 25,
        CheckRideAvionicTypeId26 = 26,
        CheckRideAvionicTypeId27 = 27,
        CheckRideAvionicTypeId28 = 28,
        CheckRideAvionicTypeId29 = 29,
        CheckRideAvionicTypeId30 = 30,
        CheckRideAvionicTypeId31 = 31,
        CheckRideAvionicTypeId32 = 32,
        CheckRideAvionicTypeId33 = 33,
    }

export enum FlightSchoolExaminerTypeAllItems {
        PilExOSExaminer = 1,
        BasicExaminer = 2,
        NonPilExOSExaminer = 3,
        CheckInstructor = 4,
    }

export enum UserInviteRequestTypeAllItems {
        FlightSchoolAdmin = 1,
        FlightSchoolUser = 2,
        FlightInstructor = 3,
        CheckInstructorUnitMember = 4,
        CheckInstructorUnitMemberAdmin = 5,
    }

export enum ScheduleBlockItemTypeAllItems {
        IndividualDay = 1,
        DateRange = 2,
    }

// Excluding lookup ScheduleBlockCheckRideType All Items because it contains 154 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum FlightSchoolInstructorTypeAllItems {
        FlightInstructor = 1,
        CheckInstructor = 2,
    }

export enum UserInviteRequestTypeLimited {
        FlightSchoolAdmin = 1,
        FlightSchoolUser = 2,
    }

export enum ApplicantAcsWrittenResultTypeAllItems {
        Written = 1,
        Exam = 2,
    }

export enum CheckRideInstructorTypeAllItems {
        ManualInstructor = 1,
        FlightSchoolInstructor = 2,
    }

export enum FlightSchoolTypeAllItems {
        Standard = 1,
        ODA = 2,
    }

export enum CalendarSyncRequestSourceTypeAllItems {
        Checkride = 1,
        ScheduleBlock = 2,
    }

export enum CalendarSyncRequestSourceSubTypeAllItems {
        CheckrideScheduledEvent = 1,
        CheckrideProposedEvent = 2,
        ScheduleBlockExpansion = 3,
    }

export enum CalendarSyncRequestActionTypeAllItems {
        Upsert = 1,
        Delete = 2,
        Reconcile = 3,
    }

export enum CalendarSyncRequestErrorTypeAllItems {
        Transient = 1,
        RateLimited = 2,
        Unauthorized = 3,
        Configuration = 4,
        Validation = 5,
        NotFound = 6,
        Unknown = 7,
    }

export enum CalendarOwnerTypeAllItems {
        PilotExaminer = 1,
        FlightSchoolOrganization = 2,
    }

export enum TrainingTypeAllItems {
        UnitMemberQualifications12Months = 1,
        DPETraining24Months = 2,
        UnitMemberAudit12Months = 3,
        FAAODAAdminTraining24Months = 4,
    }

export enum ReportFilterPresetOwnershipTypeAllItems {
        System = 1,
        FlightSchool = 2,
        User = 3,
    }

export enum UnitMemberAircraftExperienceTypeAllItems {
        PoweredLiftLargeHelicopter = 1,
        TurbinePoweredLargeAircraft = 2,
    }

export enum UnitMemberQualificationResponseTypeAllItems {
        YesNo = 1,
        Number = 2,
        SingleChoice = 3,
    }

export enum UnitMemberQualificationTypeAllItems {
        CFI24MONTHRANGE = 1,
        DPEQUAL01 = 2,
        DPEQUAL02 = 3,
        DPEQUAL03 = 4,
        DPEQUAL04 = 5,
        DPEQUAL05 = 6,
        DPEQUAL06 = 7,
        DPEQUAL07 = 8,
        DPEQUAL08 = 9,
        DPEQUAL09 = 10,
        DPEQUAL10 = 11,
        DPEQUAL11 = 12,
        DPEQUAL12 = 13,
        DPEQUAL13 = 14,
        PIC12MONTHRANGE = 15,
    }

export enum CheckRideOutcomeAllItems {
        CertificateIssued = 1,
        Disapproved = 2,
        Discontinued = 3,
        Satisfactory = 4,
        Unsatisfactory = 5,
        Incomplete = 6,
    }

export enum CheckrideOutcomeStandard {
        CertificateIssued = 1,
        Disapproved = 2,
        Discontinued = 3,
    }

export enum CheckrideOutcomeStage {
        Satisfactory = 4,
        Unsatisfactory = 5,
        Incomplete = 6,
    }

export enum CheckRideRequestPaymentPartyAllItems {
        PilotExaminer = 1,
        Applicant = 2,
        FlightSchool = 3,
    }

export enum CheckRideRequestPaymentPartyForSchools {
        Applicant = 2,
        FlightSchool = 3,
    }

export enum SubscriptionPartyAllItems {
        FlightSchool = 1,
        Examiner = 2,
    }

export enum CheckRideRequestPaymentPartyForExaminers {
        PilotExaminer = 1,
        Applicant = 2,
    }

export enum AviationTrainingProgramAllItems {
        Part61 = 1,
        Part141 = 2,
    }

export enum FlightSchoolTrainingProgramAllItems {
        FlightSchoolTrainingProgramId2 = 2,
        FlightSchoolTrainingProgramId3 = 3,
        FlightSchoolTrainingProgramId4 = 4,
        FlightSchoolTrainingProgramId5 = 5,
        FlightSchoolTrainingProgramId6 = 6,
        FlightSchoolTrainingProgramId7 = 7,
        FlightSchoolTrainingProgramId8 = 8,
        FlightSchoolTrainingProgramId9 = 9,
        FlightSchoolTrainingProgramId16 = 16,
        FlightSchoolTrainingProgramId17 = 17,
    }

export enum AcsTestPortionAllItems {
        PreTestBrief = 1,
        Ground = 2,
        Flight = 3,
        PostFlightBrief = 4,
        PreFlightBrief = 5,
    }

export enum CheckRideWorkflowAllItems {
        ExaminerWorkflow = 1,
        ExaminerManualWorkflow = 2,
        SchoolWorkflow = 3,
        SchoolWorkflowManualNoPilexosExaminer = 4,
    }

export enum SubscriptionFeatureAllItems {
        BasicReports = 1,
        PlanOfAction = 2,
        AdvancedReports = 3,
        APIIntegrations = 4,
        SchoolPublicProfile = 5,
        AIPostExamSummary = 6,
    }

export enum SubscriptionTierFeatureAllItems {
        SubscriptionTierFeatureId3 = 3,
        SubscriptionTierFeatureId4 = 4,
        SubscriptionTierFeatureId5 = 5,
        SubscriptionTierFeatureId6 = 6,
        SubscriptionTierFeatureId7 = 7,
        SubscriptionTierFeatureId8 = 8,
        SubscriptionTierFeatureId9 = 9,
        SubscriptionTierFeatureId10 = 10,
        SubscriptionTierFeatureId11 = 11,
        SubscriptionTierFeatureId12 = 12,
    }

export enum FlightSchoolOrganizationFeatureAllItems {
        FlightSchoolOrganizationFeatureId2 = 2,
        FlightSchoolOrganizationFeatureId3 = 3,
        FlightSchoolOrganizationFeatureId4 = 4,
        FlightSchoolOrganizationFeatureId5 = 5,
        FlightSchoolOrganizationFeatureId8 = 8,
        FlightSchoolOrganizationFeatureId11 = 11,
        FlightSchoolOrganizationFeatureId12 = 12,
        FlightSchoolOrganizationFeatureId13 = 13,
        FlightSchoolOrganizationFeatureId16 = 16,
        FlightSchoolOrganizationFeatureId17 = 17,
        FlightSchoolOrganizationFeatureId18 = 18,
        FlightSchoolOrganizationFeatureId19 = 19,
        FlightSchoolOrganizationFeatureId20 = 20,
        FlightSchoolOrganizationFeatureId21 = 21,
        FlightSchoolOrganizationFeatureId22 = 22,
        FlightSchoolOrganizationFeatureId23 = 23,
        FlightSchoolOrganizationFeatureId24 = 24,
        FlightSchoolOrganizationFeatureId25 = 25,
        FlightSchoolOrganizationFeatureId26 = 26,
    }

export enum SchoolFeatureAllItems {
        PlanOfAction = 1,
        SchoolBookingFeeFreeTrial = 2,
        AviatorProIntegraiton = 4,
    }

export enum ScheduleBlockSchoolBookingOptionAllItems {
        None = 1,
        ReadOnlyCanView = 2,
        ReadOnlyAllowSchoolBlocks = 3,
        FullAccess = 4,
    }

export enum UnitMemberQualificationOptionAllItems {
        Num201250TotalPICHours = 1,
        Num2501000TotalPICHours = 2,
        GreaterThan1000TotalPICHours = 3,
        Num51100TotalHoursAsACFI = 4,
        Num100250TotalHoursAsACFI = 5,
        Num250500TotalHoursAsACFI = 6,
        Num5001000TotalHoursAsACFI = 7,
        Over1000TotalHoursAsACFI = 8,
    }

export enum QuestionOutcomeAllItems {
        Sat = 1,
        Discuss = 2,
        UnSat = 3,
    }




